export const cleanData = [
  {
    App: "Photo Editor & Candy Camera & Grid & ScrapBook",
    Category: "ART_AND_DESIGN",
    Rating: 4.1,
    Reviews: 159,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "January 7, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Coloring book moana",
    Category: "ART_AND_DESIGN",
    Rating: 3.9,
    Reviews: 967,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design;Pretend Play",
    "Last Updated": "January 15, 2018",
    "Current Ver": "2.0.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "U Launcher Lite – FREE Live Cool Themes, Hide Apps",
    Category: "ART_AND_DESIGN",
    Rating: 4.7,
    Reviews: 87510,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.2.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Sketch - Draw & Paint",
    Category: "ART_AND_DESIGN",
    Rating: 4.5,
    Reviews: 215644,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Art & Design",
    "Last Updated": "June 8, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Pixel Draw - Number Art Coloring Book",
    Category: "ART_AND_DESIGN",
    Rating: 4.3,
    Reviews: 967,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design;Creativity",
    "Last Updated": "June 20, 2018",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Paper flowers instructions",
    Category: "ART_AND_DESIGN",
    Rating: 4.4,
    Reviews: 167,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "March 26, 2017",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Smoke Effect Photo Maker - Smoke Editor",
    Category: "ART_AND_DESIGN",
    Rating: 3.8,
    Reviews: 178,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "April 26, 2018",
    "Current Ver": 1.1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Infinite Painter",
    Category: "ART_AND_DESIGN",
    Rating: 4.1,
    Reviews: 36815,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "June 14, 2018",
    "Current Ver": "6.1.61.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Garden Coloring Book",
    Category: "ART_AND_DESIGN",
    Rating: 4.4,
    Reviews: 13791,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "September 20, 2017",
    "Current Ver": "2.9.2",
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Kids Paint Free - Drawing Fun",
    Category: "ART_AND_DESIGN",
    Rating: 4.7,
    Reviews: 121,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design;Creativity",
    "Last Updated": "July 3, 2018",
    "Current Ver": 2.8,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Text on Photo - Fonteee",
    Category: "ART_AND_DESIGN",
    Rating: 4.4,
    Reviews: 13880,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "October 27, 2017",
    "Current Ver": "1.0.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Name Art Photo Editor - Focus n Filters",
    Category: "ART_AND_DESIGN",
    Rating: 4.4,
    Reviews: 8788,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.0.15",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Tattoo Name On My Photo Editor",
    Category: "ART_AND_DESIGN",
    Rating: 4.2,
    Reviews: 44829,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Art & Design",
    "Last Updated": "April 2, 2018",
    "Current Ver": 3.8,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Mandala Coloring Book",
    Category: "ART_AND_DESIGN",
    Rating: 4.6,
    Reviews: 4326,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "June 26, 2018",
    "Current Ver": "1.0.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "3D Color Pixel by Number - Sandbox Art Coloring",
    Category: "ART_AND_DESIGN",
    Rating: 4.4,
    Reviews: 1518,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.2.3",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Learn To Draw Kawaii Characters",
    Category: "ART_AND_DESIGN",
    Rating: 3.2,
    Reviews: 55,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "June 6, 2018",
    "Current Ver": "NaN",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Photo Designer - Write your name with shapes",
    Category: "ART_AND_DESIGN",
    Rating: 4.7,
    Reviews: 3632,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "July 31, 2018",
    "Current Ver": 3.1,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "350 Diy Room Decor Ideas",
    Category: "ART_AND_DESIGN",
    Rating: 4.5,
    Reviews: 27,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "November 7, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "FlipaClip - Cartoon animation",
    Category: "ART_AND_DESIGN",
    Rating: 4.3,
    Reviews: 194216,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.2.5",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "ibis Paint X",
    Category: "ART_AND_DESIGN",
    Rating: 4.6,
    Reviews: 224399,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "July 30, 2018",
    "Current Ver": "5.5.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Logo Maker - Small Business",
    Category: "ART_AND_DESIGN",
    Rating: 4,
    Reviews: 450,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "April 20, 2018",
    "Current Ver": 4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Boys Photo Editor - Six Pack & Men's Suit",
    Category: "ART_AND_DESIGN",
    Rating: 4.1,
    Reviews: 654,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "March 20, 2018",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Superheroes Wallpapers | 4K Backgrounds",
    Category: "ART_AND_DESIGN",
    Rating: 4.7,
    Reviews: 7699,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Art & Design",
    "Last Updated": "July 12, 2018",
    "Current Ver": "2.2.6.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Mcqueen Coloring pages",
    Category: "ART_AND_DESIGN",
    Rating: "NaN",
    Reviews: 61,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design;Action & Adventure",
    "Last Updated": "March 7, 2018",
    "Current Ver": "1.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "HD Mickey Minnie Wallpapers",
    Category: "ART_AND_DESIGN",
    Rating: 4.7,
    Reviews: 118,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "July 7, 2018",
    "Current Ver": "1.1.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Harley Quinn wallpapers HD",
    Category: "ART_AND_DESIGN",
    Rating: 4.8,
    Reviews: 192,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "April 25, 2018",
    "Current Ver": 1.5,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "Colorfit - Drawing & Coloring",
    Category: "ART_AND_DESIGN",
    Rating: 4.7,
    Reviews: 20260,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design;Creativity",
    "Last Updated": "October 11, 2017",
    "Current Ver": "1.0.8",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Animated Photo Editor",
    Category: "ART_AND_DESIGN",
    Rating: 4.1,
    Reviews: 203,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "March 21, 2018",
    "Current Ver": 1.03,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Pencil Sketch Drawing",
    Category: "ART_AND_DESIGN",
    Rating: 3.9,
    Reviews: 136,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "July 12, 2018",
    "Current Ver": 6,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Easy Realistic Drawing Tutorial",
    Category: "ART_AND_DESIGN",
    Rating: 4.1,
    Reviews: 223,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "August 22, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Pink Silver Bow Keyboard Theme",
    Category: "ART_AND_DESIGN",
    Rating: 4.2,
    Reviews: 1120,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "July 12, 2018",
    "Current Ver": "6.7.12.2018",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Art Drawing Ideas",
    Category: "ART_AND_DESIGN",
    Rating: 4.1,
    Reviews: 227,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "May 31, 2018",
    "Current Ver": 1.2,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Anime Manga Coloring Book",
    Category: "ART_AND_DESIGN",
    Rating: 4.5,
    Reviews: 5035,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "July 19, 2018",
    "Current Ver": 2.2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Easy Origami Ideas",
    Category: "ART_AND_DESIGN",
    Rating: 4.2,
    Reviews: 1015,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "January 6, 2018",
    "Current Ver": "1.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "I Creative Idea",
    Category: "ART_AND_DESIGN",
    Rating: 4.7,
    Reviews: 353,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Art & Design",
    "Last Updated": "April 27, 2018",
    "Current Ver": 1.6,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "How to draw Ladybug and Cat Noir",
    Category: "ART_AND_DESIGN",
    Rating: 3.8,
    Reviews: 564,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "July 11, 2018",
    "Current Ver": 2.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "UNICORN - Color By Number & Pixel Art Coloring",
    Category: "ART_AND_DESIGN",
    Rating: 4.7,
    Reviews: 8145,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design;Creativity",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.0.9",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Floor Plan Creator",
    Category: "ART_AND_DESIGN",
    Rating: 4.1,
    Reviews: 36639,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "July 14, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "PIP Camera - PIP Collage Maker",
    Category: "ART_AND_DESIGN",
    Rating: 4.7,
    Reviews: 158,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "November 29, 2017",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "How To Color Disney Princess - Coloring Pages",
    Category: "ART_AND_DESIGN",
    Rating: 4,
    Reviews: 591,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "March 31, 2018",
    "Current Ver": 1,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Drawing Clothes Fashion Ideas",
    Category: "ART_AND_DESIGN",
    Rating: 4.2,
    Reviews: 117,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Sad Poetry Photo Frames 2018",
    Category: "ART_AND_DESIGN",
    Rating: 4.5,
    Reviews: 176,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "April 2, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Textgram - write on photos",
    Category: "ART_AND_DESIGN",
    Rating: 4.4,
    Reviews: 295221,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Paint Splash!",
    Category: "ART_AND_DESIGN",
    Rating: 3.8,
    Reviews: 2206,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design;Creativity",
    "Last Updated": "April 15, 2018",
    "Current Ver": 1.46,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Popsicle Sticks and Similar DIY Craft Ideas",
    Category: "ART_AND_DESIGN",
    Rating: 4.2,
    Reviews: 26,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "January 3, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Canva: Poster, banner, card maker & graphic design",
    Category: "ART_AND_DESIGN",
    Rating: 4.7,
    Reviews: 174531,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.6.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Install images with music to make video without Net - 2018",
    Category: "ART_AND_DESIGN",
    Rating: 4.6,
    Reviews: 1070,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "November 14, 2017",
    "Current Ver": 1.6,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Little Teddy Bear Colouring Book Game",
    Category: "ART_AND_DESIGN",
    Rating: 4.2,
    Reviews: 85,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "December 17, 2017",
    "Current Ver": "2.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "How To Draw Food",
    Category: "ART_AND_DESIGN",
    Rating: 4.3,
    Reviews: 845,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "May 28, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Monster Truck Stunt 3D 2019",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.2,
    Reviews: 367,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "May 10, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Real Tractor Farming",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4,
    Reviews: 1598,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 26, 2018",
    "Current Ver": 11,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ultimate F1 Racing Championship",
    Category: "AUTO_AND_VEHICLES",
    Rating: 3.8,
    Reviews: 284,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 26, 2018",
    "Current Ver": 3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Used Cars and Trucks for Sale",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.6,
    Reviews: 17057,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "American Muscle Car Race",
    Category: "AUTO_AND_VEHICLES",
    Rating: 3.9,
    Reviews: 129,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 26, 2018",
    "Current Ver": 3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Offroad Oil Tanker Driver Transport Truck 2019",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.3,
    Reviews: 542,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 31, 2018",
    "Current Ver": 4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Tickets SDA 2018 and Exam from the State Traffic Safety Inspectorate with Drom.ru",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.9,
    Reviews: 10479,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.7.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Gas Prices (Germany only)",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.4,
    Reviews: 805,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 29, 2018",
    "Current Ver": "2.5.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Extreme Rally Championship",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.2,
    Reviews: 129,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 26, 2018",
    "Current Ver": 3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Restart Navigator",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4,
    Reviews: 1403,
    Size: "201k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "August 26, 2014",
    "Current Ver": "1.0.1",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "REG - Check the regnumber, find information about Swedish vehicles",
    Category: "AUTO_AND_VEHICLES",
    Rating: 3.9,
    Reviews: 3971,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 30, 2018",
    "Current Ver": 2.493,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CityBus Lviv",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.6,
    Reviews: 534,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 8, 2018",
    "Current Ver": "1.9.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CDL Practice Test 2018 Edition",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.9,
    Reviews: 7774,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 3, 2018",
    "Current Ver": 1.7,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ezETC (ETC balance inquiry, meter trial, real-time traffic)",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.3,
    Reviews: 38846,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 28, 2018",
    "Current Ver": "2.20 Build 02",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Free VIN Report for Used Cars",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.6,
    Reviews: 2431,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "June 12, 2018",
    "Current Ver": 1.37,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DMV Permit Practice Test 2018 Edition",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.9,
    Reviews: 6090,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 3, 2018",
    "Current Ver": 1.7,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Check Vehicle Tax",
    Category: "AUTO_AND_VEHICLES",
    Rating: 3.9,
    Reviews: 295,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 30, 2018",
    "Current Ver": "0.2.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Used Cars Mexico",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4,
    Reviews: 190,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "October 14, 2016",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Ulysse Speedometer",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.3,
    Reviews: 40211,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "REPUVE",
    Category: "AUTO_AND_VEHICLES",
    Rating: 3.9,
    Reviews: 356,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "May 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Used cars for sale - Trovit",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.2,
    Reviews: 52530,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 16, 2018",
    "Current Ver": "4.47.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Fines of the State Traffic Safety Inspectorate are official: inspection, payment of fines",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.8,
    Reviews: 116986,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.9.7",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "SK Enca Direct Malls - Used Cars Search",
    Category: "AUTO_AND_VEHICLES",
    Rating: 3.6,
    Reviews: 1379,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.2.21",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Android Auto - Maps, Media, Messaging & Voice",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.2,
    Reviews: 271920,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "PDD-UA",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.8,
    Reviews: 736,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 29, 2018",
    "Current Ver": 2.9,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Tickets SDA 2019 + Exam RF",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.8,
    Reviews: 7021,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 27, 2018",
    "Current Ver": 1.79,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Super Cars Wallpapers And Backgrounds",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.6,
    Reviews: 197,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "June 14, 2018",
    "Current Ver": 1.3,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Police Lights, Sirens & Follow Me",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.5,
    Reviews: 737,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "June 8, 2018",
    "Current Ver": "2.3.5.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Police Detector (Speed Camera Radar)",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.3,
    Reviews: 3574,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 4, 2018",
    "Current Ver": 1.6,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Best Car Wallpapers",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.5,
    Reviews: 994,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "March 27, 2018",
    "Current Ver": 1.6,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Tickets + PDA 2018 Exam",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.9,
    Reviews: 197136,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 15, 2018",
    "Current Ver": 8.31,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Pick Your Part Garage",
    Category: "AUTO_AND_VEHICLES",
    Rating: 3.9,
    Reviews: 142,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.1.5.0",
    numInstall: 50000,
    numAndroid: 6,
  },
  {
    App: "PakWheels: Buy & Sell Cars",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.4,
    Reviews: 15168,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 27, 2018",
    "Current Ver": "10.0.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Supervision service",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4,
    Reviews: 2155,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.10.3",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Speed Camera Detector - Traffic & Speed Alert",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.3,
    Reviews: 138,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 23, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Used car search Goo net whole car Go to net",
    Category: "AUTO_AND_VEHICLES",
    Rating: 3.7,
    Reviews: 5414,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 23, 2018",
    "Current Ver": "3.20.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CarMax – Cars for Sale: Search Used Car Inventory",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.4,
    Reviews: 21777,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "BEST CAR SOUNDS",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.3,
    Reviews: 348,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 29, 2018",
    "Current Ver": "1.0.3",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "RST - Sale of cars on the PCT",
    Category: "AUTO_AND_VEHICLES",
    Rating: 3.2,
    Reviews: 250,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "April 27, 2018",
    "Current Ver": 1.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AutoScout24 Switzerland – Find your new car",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.6,
    Reviews: 13372,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Zona Azul Digital Fácil SP CET - OFFICIAL São Paulo",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.6,
    Reviews: 7880,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "May 10, 2018",
    "Current Ver": "4.6.5",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "SMS Park",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.5,
    Reviews: 3617,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "May 16, 2018",
    "Current Ver": "2.8.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "SKencar",
    Category: "AUTO_AND_VEHICLES",
    Rating: 3.7,
    Reviews: 4806,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.0.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fuelio: Gas log & costs",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.6,
    Reviews: 65786,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "auto fines",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.6,
    Reviews: 31433,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "August 2, 2018",
    "Current Ver": 1.4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Used car is the first car - used car purchase, used car quotation, dealer information to",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.6,
    Reviews: 5097,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.5.18",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "All of the parking lot - National Park application (parking lot search / parking sharing / discount payment)",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4,
    Reviews: 1754,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "June 2, 2018",
    "Current Ver": "2.3.4",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Inquiry Fines and Debits of Vehicles",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.4,
    Reviews: 2680,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "March 20, 2018",
    "Current Ver": 1.03,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Gas Station",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4,
    Reviews: 1288,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "April 21, 2018",
    "Current Ver": 2.17,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Hush - Beauty for Everyone",
    Category: "BEAUTY",
    Rating: 4.7,
    Reviews: 18900,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "August 2, 2018",
    "Current Ver": "6.10.1",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "ipsy: Makeup, Beauty, and Tips",
    Category: "BEAUTY",
    Rating: 4.9,
    Reviews: 49790,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "November 9, 2017",
    "Current Ver": "2.3.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Natural recipes for your beauty",
    Category: "BEAUTY",
    Rating: 4.7,
    Reviews: 1150,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "May 15, 2018",
    "Current Ver": 4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BestCam Selfie-selfie, beauty camera, photo editor",
    Category: "BEAUTY",
    Rating: 3.9,
    Reviews: 1739,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.0.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Mirror - Zoom & Exposure -",
    Category: "BEAUTY",
    Rating: 3.9,
    Reviews: 32090,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "October 24, 2016",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Beauty Selfie Camera",
    Category: "BEAUTY",
    Rating: 4.2,
    Reviews: 2225,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "February 28, 2018",
    "Current Ver": 1.6,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Hairstyles step by step",
    Category: "BEAUTY",
    Rating: 4.6,
    Reviews: 4369,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "July 25, 2018",
    "Current Ver": 1.9,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Filters for Selfie",
    Category: "BEAUTY",
    Rating: 4.3,
    Reviews: 8572,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "May 10, 2018",
    "Current Ver": "1.1.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Tie - Always be happy",
    Category: "BEAUTY",
    Rating: 4.7,
    Reviews: 964,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "June 21, 2018",
    "Current Ver": 4,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Ulta Beauty",
    Category: "BEAUTY",
    Rating: 4.7,
    Reviews: 42050,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "June 5, 2018",
    "Current Ver": 5.4,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Prom MakeUp Tutorial",
    Category: "BEAUTY",
    Rating: 4.8,
    Reviews: 104,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "June 26, 2018",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Selfie Camera",
    Category: "BEAUTY",
    Rating: 4.2,
    Reviews: 17934,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "September 12, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Sweet Selfie Beauty Camera",
    Category: "BEAUTY",
    Rating: 4.3,
    Reviews: 601,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "June 2, 2018",
    "Current Ver": "2.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Colors of white in Urdu",
    Category: "BEAUTY",
    Rating: 4.5,
    Reviews: 36,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "July 26, 2018",
    "Current Ver": 6,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Selfie Camera Photo Editor & Filter & Sticker",
    Category: "BEAUTY",
    Rating: 4.1,
    Reviews: 187,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Beauty",
    "Last Updated": "July 24, 2018",
    "Current Ver": "3.0.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Wrinkles and rejuvenation",
    Category: "BEAUTY",
    Rating: "NaN",
    Reviews: 182,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Beauty",
    "Last Updated": "September 20, 2017",
    "Current Ver": 8,
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Eyes Makeup Beauty Tips",
    Category: "BEAUTY",
    Rating: 4.2,
    Reviews: 30,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "April 9, 2018",
    "Current Ver": "3.3.9",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Photo Editor 2018",
    Category: "BEAUTY",
    Rating: 4.5,
    Reviews: 134,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "March 1, 2018",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Step By Step Eyes Makeup Tutorial",
    Category: "BEAUTY",
    Rating: 4.4,
    Reviews: 74,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "April 5, 2018",
    "Current Ver": "2.3.09",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Beauty Camera - Selfie Camera",
    Category: "BEAUTY",
    Rating: 4,
    Reviews: 113715,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "August 3, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Girls Hairstyles",
    Category: "BEAUTY",
    Rating: 4.1,
    Reviews: 3595,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "May 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Mirror Camera (Mirror + Selfie Camera)",
    Category: "BEAUTY",
    Rating: 4.1,
    Reviews: 9315,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "November 21, 2017",
    "Current Ver": "1.4.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Beauty Tips - Beauty Tips in Sinhala",
    Category: "BEAUTY",
    Rating: 4.4,
    Reviews: 75,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "October 18, 2017",
    "Current Ver": "1.0.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Haircut Tutorials/Haircut Videos",
    Category: "BEAUTY",
    Rating: 4.6,
    Reviews: 38,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "May 29, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Sephora: Skin Care, Beauty Makeup & Fragrance Shop",
    Category: "BEAUTY",
    Rating: 4.5,
    Reviews: 26834,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "July 24, 2018",
    "Current Ver": 18.5,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Manicure - nail design",
    Category: "BEAUTY",
    Rating: "NaN",
    Reviews: 119,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "July 23, 2018",
    "Current Ver": 1.3,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Sticker Camera - Selfie Filters, Beauty Camera",
    Category: "BEAUTY",
    Rating: 3.9,
    Reviews: 2277,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.1.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Filters for B Live",
    Category: "BEAUTY",
    Rating: 4.4,
    Reviews: 2280,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "May 14, 2018",
    "Current Ver": "1.1.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Skin Care and Natural Beauty",
    Category: "BEAUTY",
    Rating: "NaN",
    Reviews: 654,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Beauty",
    "Last Updated": "July 17, 2018",
    "Current Ver": 1.15,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Facial Wrinkle Reduction",
    Category: "BEAUTY",
    Rating: 4.6,
    Reviews: 184,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "July 2, 2018",
    "Current Ver": 1.5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Makeup Videos",
    Category: "BEAUTY",
    Rating: 3.8,
    Reviews: 9,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "June 7, 2018",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Secrets of beauty, youth and health",
    Category: "BEAUTY",
    Rating: "NaN",
    Reviews: 77,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Beauty",
    "Last Updated": "August 8, 2017",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Recipes and tips for losing weight",
    Category: "BEAUTY",
    Rating: "NaN",
    Reviews: 35,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Beauty",
    "Last Updated": "December 11, 2017",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "Discover Color",
    Category: "BEAUTY",
    Rating: 4,
    Reviews: 364,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "May 24, 2018",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Eyeliner step by step 2018",
    Category: "BEAUTY",
    Rating: 4.3,
    Reviews: 18,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "June 1, 2018",
    "Current Ver": "1.2.13",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Dresses Ideas & Fashions +3000",
    Category: "BEAUTY",
    Rating: 4.5,
    Reviews: 473,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Beauty",
    "Last Updated": "March 1, 2017",
    "Current Ver": "1.0.2.0",
    numInstall: 100000,
    numAndroid: 1,
  },
  {
    App: "Lady adviser (beauty, health)",
    Category: "BEAUTY",
    Rating: "NaN",
    Reviews: 30,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Beauty",
    "Last Updated": "January 24, 2018",
    "Current Ver": 3,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "Step By Step Hairstyles For Women",
    Category: "BEAUTY",
    Rating: 4.1,
    Reviews: 66,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "April 5, 2018",
    "Current Ver": "3.1.89",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Rainbow Camera",
    Category: "BEAUTY",
    Rating: 3.7,
    Reviews: 3871,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "July 30, 2018",
    "Current Ver": "2.2.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Methods of teeth whitening",
    Category: "BEAUTY",
    Rating: 4.7,
    Reviews: 257,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "August 7, 2017",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Girls hairstyles 2018",
    Category: "BEAUTY",
    Rating: 4.2,
    Reviews: 62,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "May 28, 2018",
    "Current Ver": "1.9.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Wattpad 📖 Free Books",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 2914724,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "E-Book Read - Read Book for free",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 1857,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.3.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Download free book with green book",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 4478,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Books & Reference",
    "Last Updated": "July 31, 2017",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Wikipedia",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 577550,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Amazon Kindle",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.2,
    Reviews: 814080,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Cool Reader",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 246315,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 17, 2015",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 1,
  },
  {
    App: "Dictionary - Merriam-Webster",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 454060,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "NOOK: Read eBooks & Magazines",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 155446,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "April 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Free Panda Radio Music",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 418,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "March 27, 2018",
    "Current Ver": 2.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Book store",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 22486,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "June 6, 2018",
    "Current Ver": "3.2.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "FBReader: Favorite Book Reader",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 203130,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "English Grammar Complete Handbook",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 1435,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "January 21, 2018",
    "Current Ver": 1,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Free Books - Spirit Fanfiction and Stories",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.8,
    Reviews: 116507,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.0.075",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Google Play Books",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.9,
    Reviews: 1433233,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "AlReader -any text book reader",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 90468,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 27, 2018",
    "Current Ver": 1.91180527,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Offline English Dictionary",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.2,
    Reviews: 860,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 17, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Oxford Dictionary of English : Free",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.1,
    Reviews: 363934,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 11, 2018",
    "Current Ver": "9.1.363",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Offline: English to Tagalog Dictionary",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 967,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.1.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Spanish English Translator",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.2,
    Reviews: 87873,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "May 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "FamilySearch Tree",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.3,
    Reviews: 17506,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.3.18",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Cloud of Books",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.3,
    Reviews: 1862,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "April 27, 2018",
    "Current Ver": "2.2.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Recipes of Prophetic Medicine for free",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 2084,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 17, 2018",
    "Current Ver": 15,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "ReadEra – free ebook reader",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.8,
    Reviews: 47303,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 2, 2018",
    "Current Ver": "18.05.31+530",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "NOOK App for NOOK Devices",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 19080,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "April 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Anonymous caller detection",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 161,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 13, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Ebook Reader",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.1,
    Reviews: 85842,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 25, 2018",
    "Current Ver": "5.0.6",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Litnet - E-books",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 7831,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "July 4, 2018",
    "Current Ver": "1.2.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Read books online",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.1,
    Reviews: 91615,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Books & Reference",
    "Last Updated": "June 29, 2018",
    "Current Ver": 3.12,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "English to Urdu Dictionary",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 4620,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "November 23, 2017",
    "Current Ver": 2,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "eBoox: book reader fb2 epub zip",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 21336,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 20, 2018",
    "Current Ver": 1.28,
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "English Persian Dictionary",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 26875,
    Size: "73M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 1, 2018",
    "Current Ver": "6.0.8",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Flybook",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.9,
    Reviews: 1778,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Books & Reference",
    "Last Updated": "October 16, 2014",
    "Current Ver": "1.0.3",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "All Maths Formulas",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 2709,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 11, 2018",
    "Current Ver": 1.9,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ancestry",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.3,
    Reviews: 64513,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "HTC Help",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.2,
    Reviews: 8342,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 28, 2017",
    "Current Ver": "9.00.950462",
    numInstall: 10000000,
    numAndroid: 7,
  },
  {
    App: "English translation from Bengali",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 527,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "March 31, 2018",
    "Current Ver": 14,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Pdf Book Download - Read Pdf Book",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 1322,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 28, 2018",
    "Current Ver": 6,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Free Book Reader",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.4,
    Reviews: 1680,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 20, 2016",
    "Current Ver": 3.05,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "eBoox new: Reader for fb2 epub zip books",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.9,
    Reviews: 2739,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 17, 2018",
    "Current Ver": 2,
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "Only 30 days in English, the guideline is guaranteed",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 1065,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 16, 2018",
    "Current Ver": 1.5,
    numInstall: 500000,
    numAndroid: 3,
  },
  {
    App: "Moon+ Reader",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 233757,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "SH-02J Owner's Manual (Android 8.0)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 2,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 15, 2018",
    "Current Ver": 3,
    numInstall: 50000,
    numAndroid: 6,
  },
  {
    App: "English-Myanmar Dictionary",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 8788,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 28, 2018",
    "Current Ver": "2.5.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Golden Dictionary (EN-AR)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 51269,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 19, 2018",
    "Current Ver": "7.0.4.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "All Language Translator Free",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 30105,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 29, 2018",
    "Current Ver": 1.15,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Azpen eReader",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.5,
    Reviews: 156,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "February 15, 2018",
    "Current Ver": "3.1.7.9",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "URBANO V 02 instruction manual",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 114,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 7, 2015",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "English Dictionary - Offline",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 341157,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Books & Reference",
    "Last Updated": "March 20, 2018",
    "Current Ver": "3.9.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Visual Voicemail by MetroPCS",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 16129,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Indeed Job Search",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 674730,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 21, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Uber Driver",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 1254730,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "ADP Mobile Solutions",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 85185,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 17, 2018",
    "Current Ver": "3.4.2",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Snag - Jobs Hiring Now",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 32584,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Docs To Go™ Free Office Suite",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 217730,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Google My Business",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 70991,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 24, 2018",
    "Current Ver": "2.19.0.204537701",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "OfficeSuite : Free Office + PDF Editor",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 1002861,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "9.7.14188",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "USPS MOBILE®",
    Category: "BUSINESS",
    Rating: 3.9,
    Reviews: 16589,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 14, 2018",
    "Current Ver": "4.9.10",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Job Search by ZipRecruiter",
    Category: "BUSINESS",
    Rating: 4.8,
    Reviews: 148945,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 19, 2018",
    "Current Ver": "5.2.8",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Curriculum vitae App CV Builder Free Resume Maker",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 4458,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 8, 2018",
    "Current Ver": 3.3,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Google Primer",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 62272,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 26, 2018",
    "Current Ver": "3.550.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Alba Heaven - Alvarez Job Portal Services",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 8941,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.6.30",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "SuperLivePro",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 46353,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 13, 2016",
    "Current Ver": 2.8,
    numInstall: 1000000,
    numAndroid: 1,
  },
  {
    App: "Facebook Pages Manager",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 1279184,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "OfficeSuite Pro + PDF (Trial)",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 88073,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 9, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "My Space - Employment Center",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 67000,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 17, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Box",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 159872,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Polaris Office for LG",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 30847,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 8, 2018",
    "Current Ver": "7.3.21",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Call Blocker",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 188841,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 21, 2018",
    "Current Ver": "1.1.13",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Jobs in Alabama - Jobs in Alba",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 11622,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Square Point of Sale - POS",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 95912,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Plugin:AOT v5.0",
    Category: "BUSINESS",
    Rating: 3.1,
    Reviews: 4034,
    Size: "23k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "September 11, 2015",
    "Current Ver": "3.0.1.11 (Build 311)",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Kariyer.net",
    Category: "BUSINESS",
    Rating: 3.9,
    Reviews: 45964,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 18, 2018",
    "Current Ver": "5.1.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SEEK Job Search",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 14955,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Become a Job - Find a job or advertise",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 6903,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 10, 2018",
    "Current Ver": "2.3.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ZOOM Cloud Meetings",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 31614,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 20, 2018",
    "Current Ver": "4.1.28165.0716",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Easy Installer - Apps On SD",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 23055,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 8, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Facebook Ads Manager",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 19023,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 1, 2018",
    "Current Ver": "99.0.0.35.75",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "IndiaMART: Search Products, Buy, Sell & Trade",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 207372,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "12.2.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "ViettelPost express delivery",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 1225,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.0.6.8",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "MyASUS - Service Center",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 380837,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 4, 2018",
    "Current Ver": "3.4.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Job Korea - Career Jobs",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 10600,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.5.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "104 Looking for a job - looking for a job, looking for a job, looking for a part-time job, health checkup, resume, treatment room",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 74359,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.12.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Myanmar 2D/3D",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 822,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 8, 2018",
    "Current Ver": 1.5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Quick PDF Scanner + OCR FREE",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 80805,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "sABN",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 2287,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 26, 2018",
    "Current Ver": 4.9,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "ATI Cargoes and Transportation",
    Category: "BUSINESS",
    Rating: 4.7,
    Reviews: 4162,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 24, 2018",
    "Current Ver": "0.9.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Secure Folder",
    Category: "BUSINESS",
    Rating: 3.8,
    Reviews: 14760,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 31, 2018",
    "Current Ver": "1.1.07.6",
    numInstall: 50000000,
    numAndroid: 7,
  },
  {
    App: "UPS Mobile",
    Category: "BUSINESS",
    Rating: 3.9,
    Reviews: 23243,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Y! Mobile menu",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 9,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 9, 2018",
    "Current Ver": "1.0.5",
    numInstall: 100000,
    numAndroid: 6,
  },
  {
    App: "SignEasy | Sign and Fill PDF and other Documents",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 8978,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Quick PDF Scanner + OCR FREE",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 80805,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Genius Scan - PDF Scanner",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 42492,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Tiny Scanner - PDF Scanner App",
    Category: "BUSINESS",
    Rating: 4.7,
    Reviews: 286897,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 30, 2017",
    "Current Ver": "1.2.6",
    numInstall: 10000000,
    numAndroid: 3,
  },
  {
    App: "Fast Scanner : Free PDF Scan",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 103755,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 11, 2018",
    "Current Ver": "3.9.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Mobile Doc Scanner (MDScan) Lite",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 46505,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.4.49",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "TurboScan: scan documents and receipts in PDF",
    Category: "BUSINESS",
    Rating: 4.7,
    Reviews: 11442,
    Size: "6.8M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 25, 2018",
    "Current Ver": "1.5.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Tiny Scanner Pro: PDF Doc Scan",
    Category: "BUSINESS",
    Rating: 4.8,
    Reviews: 10295,
    Size: "39M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 11, 2017",
    "Current Ver": "3.4.6",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Box",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 159872,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Zenefits",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 296,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 15, 2018",
    "Current Ver": "3.2.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Google Ads",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 29313,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.12.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Google My Business",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 70991,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 24, 2018",
    "Current Ver": "2.19.0.204537701",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Slack",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 51507,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "FreshBooks Classic",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 1802,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 18, 2018",
    "Current Ver": "1.7.14",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Insightly CRM",
    Category: "BUSINESS",
    Rating: 3.8,
    Reviews: 1383,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 12, 2018",
    "Current Ver": "3.24.1",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "QuickBooks Accounting: Invoicing & Expenses",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 23175,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 13, 2018",
    "Current Ver": 18.7,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "HipChat - Chat Built for Teams",
    Category: "BUSINESS",
    Rating: 3.8,
    Reviews: 5868,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 3, 2018",
    "Current Ver": "3.19.005",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Xero Accounting Software",
    Category: "BUSINESS",
    Rating: 3.5,
    Reviews: 2111,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "MailChimp - Email, Marketing Automation",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 5448,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 25, 2018",
    "Current Ver": "4.9.1",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Crew - Free Messaging and Scheduling",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 4159,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 20, 2018",
    "Current Ver": "6.1.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Asana: organize team projects",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 20815,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 26, 2018",
    "Current Ver": "6.4.4",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Google Analytics",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 78662,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 13, 2018",
    "Current Ver": "3.7.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AdWords Express",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 7149,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.6.158",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Accounting App - Zoho Books",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 3079,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.20.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Invoice & Time Tracking - Zoho",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 5800,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.20.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "join.me - Simple Meetings",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 6989,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 16, 2018",
    "Current Ver": "4.3.0.508",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Invoice 2go — Professional Invoices and Estimates",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 16422,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 1, 2018",
    "Current Ver": "10.46.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Cisco Webex Meetings",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 108741,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 20, 2018",
    "Current Ver": "11.1.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ZOOM Cloud Meetings",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 31614,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 20, 2018",
    "Current Ver": "4.1.28165.0716",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ScreenMeet. Easy Phone Meeting",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 624,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 22, 2018",
    "Current Ver": "1.2.287",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Cisco Webex Teams",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 1661,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.0.4651",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Microsoft Remote Desktop",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 97702,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Start Meeting",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 308,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 29, 2018",
    "Current Ver": "3.1.4.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "join.me - Simple Meetings",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 6989,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 16, 2018",
    "Current Ver": "4.3.0.508",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ClickMeeting Webinars",
    Category: "BUSINESS",
    Rating: 3.8,
    Reviews: 5211,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 30, 2018",
    "Current Ver": "3.3.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BlueJeans for Android",
    Category: "BUSINESS",
    Rating: 3.9,
    Reviews: 1058,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 29, 2018",
    "Current Ver": "2.22.397",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Skype for Business for Android",
    Category: "BUSINESS",
    Rating: 3.9,
    Reviews: 78172,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Box",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 159872,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Zenefits",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 296,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 15, 2018",
    "Current Ver": "3.2.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Google Ads",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 29313,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.12.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Google My Business",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 70991,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 24, 2018",
    "Current Ver": "2.19.0.204537701",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Slack",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 51507,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "FreshBooks Classic",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 1802,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 18, 2018",
    "Current Ver": "1.7.14",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Insightly CRM",
    Category: "BUSINESS",
    Rating: 3.8,
    Reviews: 1383,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 12, 2018",
    "Current Ver": "3.24.1",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "QuickBooks Accounting: Invoicing & Expenses",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 23175,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 13, 2018",
    "Current Ver": 18.7,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "HipChat - Chat Built for Teams",
    Category: "BUSINESS",
    Rating: 3.8,
    Reviews: 5868,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 3, 2018",
    "Current Ver": "3.19.005",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Xero Accounting Software",
    Category: "BUSINESS",
    Rating: 3.5,
    Reviews: 2111,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "MailChimp - Email, Marketing Automation",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 5448,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 25, 2018",
    "Current Ver": "4.9.1",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Crew - Free Messaging and Scheduling",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 4159,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 20, 2018",
    "Current Ver": "6.1.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Asana: organize team projects",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 20815,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 26, 2018",
    "Current Ver": "6.4.4",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Google Analytics",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 78662,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 13, 2018",
    "Current Ver": "3.7.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AdWords Express",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 7149,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.6.158",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Accounting App - Zoho Books",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 3079,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.20.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Invoice & Time Tracking - Zoho",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 5800,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.20.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "join.me - Simple Meetings",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 6989,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 16, 2018",
    "Current Ver": "4.3.0.508",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Invoice 2go — Professional Invoices and Estimates",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 16422,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 1, 2018",
    "Current Ver": "10.46.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SignEasy | Sign and Fill PDF and other Documents",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 8978,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Quick PDF Scanner + OCR FREE",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 80804,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Genius Scan - PDF Scanner",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 42492,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Tiny Scanner - PDF Scanner App",
    Category: "BUSINESS",
    Rating: 4.7,
    Reviews: 286897,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 30, 2017",
    "Current Ver": "1.2.6",
    numInstall: 10000000,
    numAndroid: 3,
  },
  {
    App: "Fast Scanner : Free PDF Scan",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 103755,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 11, 2018",
    "Current Ver": "3.9.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Mobile Doc Scanner (MDScan) Lite",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 46505,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.4.49",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "TurboScan: scan documents and receipts in PDF",
    Category: "BUSINESS",
    Rating: 4.7,
    Reviews: 11442,
    Size: "6.8M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 25, 2018",
    "Current Ver": "1.5.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Tiny Scanner Pro: PDF Doc Scan",
    Category: "BUSINESS",
    Rating: 4.8,
    Reviews: 10295,
    Size: "39M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 11, 2017",
    "Current Ver": "3.4.6",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Docs To Go™ Free Office Suite",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 217730,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "OfficeSuite : Free Office + PDF Editor",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 1002859,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "9.7.14188",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Slack",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 51510,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Verify - Receipts & Expenses",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 413,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 25, 2018",
    "Current Ver": "2.0.19",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "QuickBooks Accounting: Invoicing & Expenses",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 23175,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 13, 2018",
    "Current Ver": 18.7,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "LINE WEBTOON - Free Comics",
    Category: "COMICS",
    Rating: 4.5,
    Reviews: 1013635,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Manga Master - Best manga & comic reader",
    Category: "COMICS",
    Rating: 4.6,
    Reviews: 24005,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Adults only 18+",
    Genres: "Comics",
    "Last Updated": "July 4, 2018",
    "Current Ver": "1.1.7.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "GANMA! - All original stories free of charge for all original comics",
    Category: "COMICS",
    Rating: 4.7,
    Reviews: 57106,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.11.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Röhrich Werner Soundboard",
    Category: "COMICS",
    Rating: 4.7,
    Reviews: 2249,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "November 16, 2017",
    "Current Ver": 1.08,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Unicorn Pokez - Color By Number",
    Category: "COMICS",
    Rating: 4.8,
    Reviews: 516,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics;Creativity",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.0.6",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "MangaToon - Comics updated Daily",
    Category: "COMICS",
    Rating: 3.9,
    Reviews: 834,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Comics",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.0.8",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Manga Net – Best Online Manga Reader",
    Category: "COMICS",
    Rating: 4.1,
    Reviews: 1010,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Comics",
    "Last Updated": "July 7, 2018",
    "Current Ver": 1.5,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Manga Rock - Best Manga Reader",
    Category: "COMICS",
    Rating: 4.4,
    Reviews: 238970,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "July 9, 2018",
    "Current Ver": "3.4.3_world",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Manga - read Thai translation",
    Category: "COMICS",
    Rating: 4.6,
    Reviews: 302,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "July 3, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "The Vietnam Story - Fun Stories",
    Category: "COMICS",
    Rating: 4.5,
    Reviews: 438,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "December 27, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Dragon Ball Wallpaper - Ringtones",
    Category: "COMICS",
    Rating: 4.7,
    Reviews: 73,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "July 23, 2018",
    "Current Ver": 1.9,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Funny Jokes Photos",
    Category: "COMICS",
    Rating: 4.4,
    Reviews: 39,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Comics",
    "Last Updated": "July 3, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Truyện Vui Tý Quậy",
    Category: "COMICS",
    Rating: 4.5,
    Reviews: 144,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "July 19, 2018",
    "Current Ver": 3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Comic Es - Shojo manga / love comics free of charge ♪ ♪",
    Category: "COMICS",
    Rating: 3.9,
    Reviews: 2181,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "March 5, 2018",
    "Current Ver": "1.2.12",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "comico Popular Original Cartoon Updated Everyday Comico",
    Category: "COMICS",
    Rating: 3.2,
    Reviews: 93965,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "July 3, 2018",
    "Current Ver": "6.3.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Daily Manga - Comic & Webtoon",
    Category: "COMICS",
    Rating: 3.2,
    Reviews: 1446,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Comics",
    "Last Updated": "May 18, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "漫咖 Comics - Manga,Novel and Stories",
    Category: "COMICS",
    Rating: 4.1,
    Reviews: 12088,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Comics",
    "Last Updated": "July 6, 2018",
    "Current Ver": "2.3.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Emmanuella Funny Videos 2018",
    Category: "COMICS",
    Rating: 4.5,
    Reviews: 314,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "May 23, 2018",
    "Current Ver": "3.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DC Comics",
    Category: "COMICS",
    Rating: 4.2,
    Reviews: 25671,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "June 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Manga Zero - Japanese cartoon and comic reader",
    Category: "COMICS",
    Rating: 4.2,
    Reviews: 15194,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "July 19, 2018",
    "Current Ver": "4.7.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Marvel Unlimited",
    Category: "COMICS",
    Rating: 3.7,
    Reviews: 22551,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "July 24, 2018",
    "Current Ver": "3.16.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Tapas – Comics, Novels, and Stories",
    Category: "COMICS",
    Rating: 4.5,
    Reviews: 29839,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.1.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Children's cartoons (Mithu-Mina-Raju)",
    Category: "COMICS",
    Rating: 4.6,
    Reviews: 279,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "December 18, 2017",
    "Current Ver": 1.6,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Narrator's Voice",
    Category: "COMICS",
    Rating: 4.5,
    Reviews: 564387,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "【Ranobbe complete free】 Novelba - Free app that you can read and write novels",
    Category: "COMICS",
    Rating: "NaN",
    Reviews: 1330,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "July 3, 2018",
    "Current Ver": "6.1.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Faustop Sounds",
    Category: "COMICS",
    Rating: 4.7,
    Reviews: 1677,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "May 26, 2018",
    "Current Ver": "1.7.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Manga Mania - Best online manga reader",
    Category: "COMICS",
    Rating: 4.4,
    Reviews: 757,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "May 24, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "- Free Comics - Comic Apps",
    Category: "COMICS",
    Rating: 3.5,
    Reviews: 115,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Comics",
    "Last Updated": "July 13, 2018",
    "Current Ver": "5.0.12",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Manga AZ - Manga Comic Reader",
    Category: "COMICS",
    Rating: 3.3,
    Reviews: 125,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.0.4",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Buff Thun - Daily Free Webtoon / Comics / Web Fiction / Mini Game",
    Category: "COMICS",
    Rating: 4.5,
    Reviews: 9952,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Comics",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.3.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "pixiv comic - everyone's manga app",
    Category: "COMICS",
    Rating: 4.4,
    Reviews: 18814,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Comics",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Funny Jokes and Stories 2018",
    Category: "COMICS",
    Rating: 4.2,
    Reviews: 21,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "March 31, 2018",
    "Current Ver": 1.3,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Hojiboy Tojiboyev Life Hacks",
    Category: "COMICS",
    Rating: 5,
    Reviews: 15,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "June 26, 2018",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Perfect Viewer",
    Category: "COMICS",
    Rating: 4.4,
    Reviews: 51981,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.2.0.2",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Best Wallpapers Backgrounds(100,000+ 4K HD)",
    Category: "COMICS",
    Rating: 4.7,
    Reviews: 3596,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "June 16, 2018",
    "Current Ver": 1.01,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "think Comics",
    Category: "COMICS",
    Rating: 4.4,
    Reviews: 1006,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.3.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Memes Button",
    Category: "COMICS",
    Rating: 4.4,
    Reviews: 5968,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "May 28, 2018",
    "Current Ver": 1.4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Laftel - Watching and Announcing Snooping, Streaming",
    Category: "COMICS",
    Rating: 4.6,
    Reviews: 4895,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.4.25",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Messenger – Text and Video Chat for Free",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 56642847,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "WhatsApp Messenger",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 69119316,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Messenger for SMS",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 125257,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.8.9",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Google Chrome: Fast & Secure",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 9642995,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Messenger Lite: Free Calls & Messages",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 1429035,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 25, 2018",
    "Current Ver": "37.0.0.7.163",
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "Gmail",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 4604324,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Hangouts",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 3419249,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 21, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Viber Messenger",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 11334799,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "My Tele2",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 158679,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.4.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Firefox Browser fast & private",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 3075028,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Yahoo Mail – Stay Organized",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 4187998,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 18, 2018",
    "Current Ver": "5.29.3",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "imo beta free calls and text",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 659395,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 7, 2018",
    "Current Ver": "9.8.000000010492",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "imo free video calls and chat",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 4785892,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 8, 2018",
    "Current Ver": "9.8.000000010501",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Contacts",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 66602,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 26, 2018",
    "Current Ver": "2.8.4.201036949",
    numInstall: 50000000,
    numAndroid: 5,
  },
  {
    App: "Call Free – Free Call",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 30209,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 28, 2018",
    "Current Ver": "1.3.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Web Browser & Explorer",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 36901,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 4, 2018",
    "Current Ver": "11.8.6",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Opera Mini - fast web browser",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 5149854,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Browser 4G",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 192948,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 19, 2018",
    "Current Ver": "24.6.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "MegaFon Dashboard",
    Category: "COMMUNICATION",
    Rating: 3.7,
    Reviews: 99559,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "ZenUI Dialer & Contacts",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 437674,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Cricket Visual Voicemail",
    Category: "COMMUNICATION",
    Rating: 3.9,
    Reviews: 13698,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 2, 2018",
    "Current Ver": "3.2.0.100171",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Opera Browser: Fast and Secure",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 2473509,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 31, 2018",
    "Current Ver": "47.1.2249.129326",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "TracFone My Account",
    Category: "COMMUNICATION",
    Rating: 3.6,
    Reviews: 20769,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 11, 2018",
    "Current Ver": "R6.0.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Firefox Focus: The privacy browser",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 36880,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 6, 2018",
    "Current Ver": 5.2,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Google Voice",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 171031,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Chrome Dev",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 63543,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 2, 2018",
    "Current Ver": "69.0.3497.24",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Xperia Link™",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 45487,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "October 27, 2016",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "TouchPal Keyboard - Fun Emoji & Android Keyboard",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 615381,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Communication",
    "Last Updated": "August 2, 2018",
    "Current Ver": "6.7.9.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Who",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 2451083,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Skype Lite - Free Video Call & Chat",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 33053,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.60.0.31354-release",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "WeChat",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 5387333,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "UC Browser Mini -Tiny Fast Private & Secure",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 3648120,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "July 18, 2018",
    "Current Ver": "11.4.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "WhatsApp Business",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 136662,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 30, 2018",
    "Current Ver": "2.18.116",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "My magenta",
    Category: "COMMUNICATION",
    Rating: 3.9,
    Reviews: 42370,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 25, 2018",
    "Current Ver": "7.5.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Android Messages",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 781810,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Telegram",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 3128250,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Communication",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Google Duo - High Quality Video Calls",
    Category: "COMMUNICATION",
    Rating: 4.6,
    Reviews: 2083237,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 31, 2018",
    "Current Ver": "37.1.206017801.DR37_RC14",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Puffin Web Browser",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 541389,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 9, 2018",
    "Current Ver": "7.5.3.20547",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Seznam.cz",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 46702,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Antillean Gold Telegram (original version)",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 2939,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 16, 2018",
    "Current Ver": 2.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AT&T Visual Voicemail",
    Category: "COMMUNICATION",
    Rating: 3.7,
    Reviews: 13761,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "GMX Mail",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 258556,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Omlet Chat",
    Category: "COMMUNICATION",
    Rating: 3.9,
    Reviews: 40751,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "November 4, 2016",
    "Current Ver": "2.2.7600",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "UC Browser - Fast Download Private & Secure",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 17712922,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "August 2, 2018",
    "Current Ver": "12.8.5.1121",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "My Vodacom SA",
    Category: "COMMUNICATION",
    Rating: 3.7,
    Reviews: 25021,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 26, 2018",
    "Current Ver": "9.9.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Microsoft Edge",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 27187,
    Size: "66M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 28, 2018",
    "Current Ver": "42.0.0.2059",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "WhatsApp Messenger",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 69119316,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Messenger – Text and Video Chat for Free",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 56646578,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "imo free video calls and chat",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 4785988,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 8, 2018",
    "Current Ver": "9.8.000000010501",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Hangouts Dialer - Call Phones",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 122498,
    Size: "79k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "September 2, 2015",
    "Current Ver": "0.1.100944346",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Viber Messenger",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 11334973,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Hangouts",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 3419433,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 21, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Talkatone: Free Texts, Calls & Phone Number",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 132014,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 18, 2018",
    "Current Ver": 6.1,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Calls & Text by Mo+",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 83239,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 19, 2018",
    "Current Ver": "3.0.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "free video calls and chat",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 594728,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 19, 2018",
    "Current Ver": "7.3(800241)",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "WeChat",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 5387446,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Skype - free IM & video calls",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 10484169,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Telegram",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 3128509,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Communication",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Who",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 2451093,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Google Voice",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 171031,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "GO SMS Pro - Messenger, Free Themes, Emoji",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 2876500,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2018",
    "Current Ver": 7.73,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Android Messages",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 781810,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Messaging+ SMS, MMS Free",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 28238,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 2, 2018",
    "Current Ver": 4.98,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "chomp SMS",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 335646,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 26, 2018",
    "Current Ver": 7.21,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Glide - Video Chat Messenger",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 350154,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Text SMS",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 349384,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 24, 2018",
    "Current Ver": 3.47,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Google Allo",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 346982,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Talkray - Free Calls & Texts",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 244863,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "LINE: Free Calls & Messages",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 10790289,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "GroupMe",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 330761,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "mysms SMS Text Messaging Sync",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 37320,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 30, 2018",
    "Current Ver": "6.5.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BBM - Free Calls & Messages",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 12842860,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "KakaoTalk: Free Calls & Text",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 2546527,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Firefox Focus: The privacy browser",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 36893,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 6, 2018",
    "Current Ver": 5.2,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "2ndLine - Second Phone Number",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 15880,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "5.65.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Google Allo",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 346980,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Google Chrome: Fast & Secure",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 9643041,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Firefox Browser fast & private",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 3075118,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "CM Browser - Ad Blocker , Fast Download , Privacy",
    Category: "COMMUNICATION",
    Rating: 4.6,
    Reviews: 2264916,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 31, 2018",
    "Current Ver": "5.22.18.0006",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Puffin Web Browser",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 541389,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 9, 2018",
    "Current Ver": "7.5.3.20547",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Opera Browser: Fast and Secure",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 2473693,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 31, 2018",
    "Current Ver": "47.1.2249.129326",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Ninesky Browser",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 42925,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 27, 2017",
    "Current Ver": 6.1,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Opera Mini - fast web browser",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 5150471,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Dolphin Browser - Fast, Private & Adblock🐬",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 2511130,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "UC Browser Mini -Tiny Fast Private & Secure",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 3648480,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "July 18, 2018",
    "Current Ver": "11.4.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "UC Browser - Fast Download Private & Secure",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 17714850,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "August 2, 2018",
    "Current Ver": "12.8.5.1121",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Ghostery Privacy Browser",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 13100,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "March 20, 2018",
    "Current Ver": "1.4.1.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "InBrowser - Incognito Browsing",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 27156,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Web Browser for Android",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 55098,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 20, 2018",
    "Current Ver": 2.2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "DU Browser—Browse fast & fun",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 1133501,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 1, 2016",
    "Current Ver": "6.4.0.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Lightning Web Browser",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 12578,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 10, 2017",
    "Current Ver": "4.5.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Web Browser",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 10965,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "February 2, 2015",
    "Current Ver": 2,
    numInstall: 500000,
    numAndroid: 3,
  },
  {
    App: "Puffin Browser Pro",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 18247,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 5, 2018",
    "Current Ver": "7.5.3.20547",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Contacts+",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 190613,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 31, 2018",
    "Current Ver": "5.85.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ExDialer - Dialer & Contacts",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 125232,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "March 5, 2017",
    "Current Ver": 196,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Calls & Text by Mo+",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 83239,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 19, 2018",
    "Current Ver": "3.0.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Viber Messenger",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 11334973,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "PHONE for Google Voice & GTalk",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 72065,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 18, 2018",
    "Current Ver": "3.0.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Safest Call Blocker",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 27540,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 5, 2018",
    "Current Ver": "1.26.001",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Full Screen Caller ID",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 104990,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 15, 2018",
    "Current Ver": "3.5.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Hiya - Caller ID & Block",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 177703,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Communication",
    "Last Updated": "July 25, 2018",
    "Current Ver": "8.1.2-6310",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Call Blocker",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 17529,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 26, 2018",
    "Current Ver": 5.86,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Mr. Number-Block calls & spam",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 177263,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Communication",
    "Last Updated": "July 13, 2018",
    "Current Ver": "5.1.2-6310",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Should I Answer?",
    Category: "COMMUNICATION",
    Rating: 4.8,
    Reviews: 237468,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2018.1.715",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "RocketDial Dialer & Contacts",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 32254,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "December 4, 2017",
    "Current Ver": "3.9.7",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "CallApp: Caller ID, Blocker & Phone Call Recorder",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 483565,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 29, 2018",
    "Current Ver": 1.286,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Whoscall - Caller ID & Block",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 552441,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2018",
    "Current Ver": "6.19.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "CIA - Caller ID & Call Blocker",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 60308,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Calls Blacklist - Call Blocker",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 457283,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Call Control - Call Blocker",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 93825,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 5, 2018",
    "Current Ver": "2.17.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "True Contact - Real Caller ID",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 32283,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Video Caller Id",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 15287,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 24, 2018",
    "Current Ver": "2.2.245",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Sync.ME – Caller ID & Block",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 205739,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 26, 2018",
    "Current Ver": "4.5.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Burner - Free Phone Number",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 14873,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Truecaller: Caller ID, SMS spam blocking & Dialer",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 7820209,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Caller ID +",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 9498,
    Size: "118k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 7, 2016",
    "Current Ver": "5.28.0",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Gmail",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 4604483,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Yahoo Mail – Stay Organized",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 4188142,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 18, 2018",
    "Current Ver": "5.29.3",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "K-9 Mail",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 88427,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 6, 2018",
    "Current Ver": 5.403,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "myMail – Email for Hotmail, Gmail and Outlook Mail",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 305218,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Email TypeApp - Mail App",
    Category: "COMMUNICATION",
    Rating: 4.6,
    Reviews: 183374,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.9.4.74",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "All Email Providers",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 20901,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 3, 2018",
    "Current Ver": "5.0.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Newton Mail - Email App for Gmail, Outlook, IMAP",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 122595,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 19, 2018",
    "Current Ver": "9.8.376",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "GO Notifier",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 124346,
    Size: "695k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 6, 2014",
    "Current Ver": 2.8,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Mail.Ru - Email App",
    Category: "COMMUNICATION",
    Rating: 4.6,
    Reviews: 837842,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Mail1Click - Secure Mail",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 255,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 11, 2017",
    "Current Ver": 2.3,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Daum Mail - Next Mail",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 41420,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 21, 2018",
    "Current Ver": "3.2.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "mail.com mail",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 44706,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "SolMail - All-in-One email app",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 23707,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 9, 2017",
    "Current Ver": "2.3.17",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Hangouts",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 3419513,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 21, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "imo free video calls and chat",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 4785988,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 8, 2018",
    "Current Ver": "9.8.000000010501",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "free video calls and chat",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 594728,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 19, 2018",
    "Current Ver": "7.3(800241)",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Viber Messenger",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 11335255,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Skype - free IM & video calls",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 10484169,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "WeChat",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 5387446,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Vonage Mobile® Call Video Text",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 29208,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "September 28, 2016",
    "Current Ver": "2.9.8",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "JusTalk - Free Video Calls and Fun Video Chat",
    Category: "COMMUNICATION",
    Rating: 4.6,
    Reviews: 191032,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 4, 2018",
    "Current Ver": "7.2.29",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Glide - Video Chat Messenger",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 350154,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Talkray - Free Calls & Texts",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 244863,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "LINE: Free Calls & Messages",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 10790289,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "KakaoTalk: Free Calls & Text",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 2546527,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Moco+ - Chat, Meet People",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 1545,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 19, 2018",
    "Current Ver": "2.6.139",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Calculator",
    Category: "DATING",
    Rating: 2.6,
    Reviews: 57,
    Size: "6.2M",
    Type: "Paid",
    Price: "$6.99",
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "October 25, 2017",
    "Current Ver": "1.1.6",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Truth or Dare Pro",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "20M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Teen",
    Genres: "Dating",
    "Last Updated": "September 1, 2017",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Private Dating, Hide App- Blue for PrivacyHider",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "18k",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "July 25, 2017",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ad Blocker for SayHi",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 4,
    Size: "1.2M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Teen",
    Genres: "Dating",
    "Last Updated": "August 2, 2018",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AMBW Dating App: Asian Men Black Women Interracial",
    Category: "DATING",
    Rating: 3.5,
    Reviews: 2,
    Size: "17M",
    Type: "Paid",
    Price: "$7.99",
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "January 21, 2017",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Zoosk Dating App: Meet Singles",
    Category: "DATING",
    Rating: 4,
    Reviews: 516801,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "OkCupid Dating",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 285726,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 30, 2018",
    "Current Ver": "11.10.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Match™ Dating - Meet Singles",
    Category: "DATING",
    Rating: 3.7,
    Reviews: 76646,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Hily: Dating, Chat, Match, Meet & Hook up",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 2556,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.5.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Hinge: Dating & Relationships",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 7779,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 3, 2018",
    "Current Ver": "6.1.3",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Casual Dating & Adult Singles - Joyride",
    Category: "DATING",
    Rating: 4.5,
    Reviews: 61637,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.17.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "BBW Dating & Plus Size Chat",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 12632,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 27, 2018",
    "Current Ver": "3.5.0.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Moco - Chat, Meet People",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 313724,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 4, 2018",
    "Current Ver": "2.6.141",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "CMB Free Dating App",
    Category: "DATING",
    Rating: 4,
    Reviews: 48845,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.19.0.2320",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hot or Not - Find someone right now",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 305708,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "eharmony - Online Dating App",
    Category: "DATING",
    Rating: 3.1,
    Reviews: 31320,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 30, 2018",
    "Current Ver": "6.6.5",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Free Dating App & Flirt Chat - Match with Singles",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 172460,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 4, 2018",
    "Current Ver": 1.639,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Chispa, the Dating App for Latino, Latina Singles",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 4195,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.6.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Clover Dating App",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 11633,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 24, 2018",
    "Current Ver": "2.5.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Black People Meet Singles Date",
    Category: "DATING",
    Rating: 3.9,
    Reviews: 10212,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.9.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Mingle2 - Free Online Dating & Singles Chat Rooms",
    Category: "DATING",
    Rating: 4.3,
    Reviews: 37053,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.4B",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Free Dating App & Flirt Chat - Cheers",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 667,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.308.us",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "stranger chat - anonymous chat",
    Category: "DATING",
    Rating: 3.5,
    Reviews: 13202,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 7, 2018",
    "Current Ver": "2.4.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Blendr - Chat, Flirt & Meet",
    Category: "DATING",
    Rating: 4,
    Reviews: 28671,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Free Dating Hook Up Messenger",
    Category: "DATING",
    Rating: 3.3,
    Reviews: 1157,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "January 27, 2017",
    "Current Ver": "5.0.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Find Real Love — YouLove Premium Dating",
    Category: "DATING",
    Rating: 4.5,
    Reviews: 212626,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.17.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Once - Quality Matches Every day",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 222888,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 17, 2018",
    "Current Ver": 2.45,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BLK - Swipe. Match. Chat.",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 2067,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.6.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Cougar Dating Life : Date Older Women Sugar Mummy",
    Category: "DATING",
    Rating: 3.9,
    Reviews: 1643,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 3, 2018",
    "Current Ver": "4.5.5",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Howlr",
    Category: "DATING",
    Rating: 3.9,
    Reviews: 105,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 19, 2018",
    "Current Ver": "1.0.4",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Stranger Chat & Date",
    Category: "DATING",
    Rating: 3.6,
    Reviews: 3414,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.2.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Free Dating & Flirt Chat - Choice of Love",
    Category: "DATING",
    Rating: 4,
    Reviews: 42194,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "RandoChat - Chat roulette",
    Category: "DATING",
    Rating: 3.6,
    Reviews: 11806,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 26, 2018",
    "Current Ver": "4.0.18",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BeWild Free Dating & Chat App",
    Category: "DATING",
    Rating: 3.4,
    Reviews: 1999,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "February 3, 2017",
    "Current Ver": "1.6.5",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "FastMeet: Chat, Dating, Love",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 22544,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.31.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Free Dating App - YoCutie - Flirt, Chat & Meet",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 97684,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 10, 2018",
    "Current Ver": 1.23,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "OurTime Dating for Singles 50+",
    Category: "DATING",
    Rating: 3.4,
    Reviews: 2519,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.9.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "FarmersOnly Dating",
    Category: "DATING",
    Rating: 3,
    Reviews: 1146,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "February 25, 2016",
    "Current Ver": 2.2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dating for 50 plus Mature Singles – FINALLY",
    Category: "DATING",
    Rating: 4.6,
    Reviews: 13046,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.17.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Sudy – Meet Elite & Rich Single",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 17268,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 25, 2018",
    "Current Ver": "4.1.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Christian Dating For Free App",
    Category: "DATING",
    Rating: 3.9,
    Reviews: 8722,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 20, 2018",
    "Current Ver": 15.8,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Just She - Top Lesbian Dating",
    Category: "DATING",
    Rating: 1.9,
    Reviews: 953,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 18, 2018",
    "Current Ver": "6.3.7",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Single Parent Meet #1 Dating",
    Category: "DATING",
    Rating: 3.5,
    Reviews: 2593,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.9.7",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "EliteSingles – Dating for Single Professionals",
    Category: "DATING",
    Rating: 2.5,
    Reviews: 5377,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.8.5",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Millionaire Match: Rich Singles Dating App",
    Category: "DATING",
    Rating: 3.9,
    Reviews: 852,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 30, 2018",
    "Current Ver": "6.4.6",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "InterracialCupid - Interracial Dating App",
    Category: "DATING",
    Rating: 3.4,
    Reviews: 212,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 13, 2018",
    "Current Ver": "2.3.0.1781",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "Sugar Mommas Dating And Single Search",
    Category: "DATING",
    Rating: 3.5,
    Reviews: 1972,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "May 12, 2018",
    "Current Ver": 4.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hide App, Private Dating, Safe Chat - PrivacyHider",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 35206,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "May 21, 2018",
    "Current Ver": "2.9.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "muzmatch: Muslim & Arab Singles, Marriage & Dating",
    Category: "DATING",
    Rating: 3.8,
    Reviews: 5164,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 24, 2018",
    "Current Ver": "3.8.75a",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "NoBuffDating - Free Dating App",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 1939,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "January 8, 2017",
    "Current Ver": "1.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Sugar Daddy Dating App",
    Category: "DATING",
    Rating: 2.5,
    Reviews: 277,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "December 4, 2017",
    "Current Ver": "3.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Adult Dirty Emojis",
    Category: "DATING",
    Rating: 2.8,
    Reviews: 80,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Dating",
    "Last Updated": "November 6, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Free Dating App - Meet Local Singles - Flirt Chat",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 825,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "December 28, 2017",
    "Current Ver": "1.0.5",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Meet4U - Chat, Love, Singles!",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 40035,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.31.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SnpCupid Dating",
    Category: "DATING",
    Rating: 3.5,
    Reviews: 1093,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "January 28, 2017",
    "Current Ver": "1.6.6",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Chat Rooms, Avatars, Date - Galaxy",
    Category: "DATING",
    Rating: 4.3,
    Reviews: 135418,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Adult Dating - AdultFinder",
    Category: "DATING",
    Rating: 3.3,
    Reviews: 1601,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "February 1, 2017",
    "Current Ver": 1.5,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Gay Sugar Daddy Dating & Hookup – Sudy Gay",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 2212,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 20, 2018",
    "Current Ver": "2.0.5",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Meet24 - Love, Chat, Singles",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 57081,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.31.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BBWCupid - BBW Dating App",
    Category: "DATING",
    Rating: 3.5,
    Reviews: 241,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 1, 2018",
    "Current Ver": "2.2.0.1748",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "ChatVideo Meet new people",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 63986,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "May 31, 2018",
    "Current Ver": "3.0.15",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "TryDate - Free Online Dating App, Chat Meet Adults",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 7888,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "April 29, 2018",
    "Current Ver": "2.4.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Black White Interracial Dating - Interracial Match",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 535,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "March 29, 2018",
    "Current Ver": "2.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "USA Singles Meet, Match and Date Free - Date",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 5084,
    Size: "9.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1.55,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "FlirtChat - ♥Free Dating/Flirting App♥",
    Category: "DATING",
    Rating: 4.3,
    Reviews: 2430,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 26, 2018",
    "Current Ver": "12.0.4",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "OkCupid Dating",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 285726,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 30, 2018",
    "Current Ver": "11.10.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "CMB Free Dating App",
    Category: "DATING",
    Rating: 4,
    Reviews: 48845,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.19.0.2320",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hily: Dating, Chat, Match, Meet & Hook up",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 2556,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.5.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Hinge: Dating & Relationships",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 7779,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 3, 2018",
    "Current Ver": "6.1.3",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "The League",
    Category: "DATING",
    Rating: 3,
    Reviews: 837,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 16, 2018",
    "Current Ver": "1.15.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BBW Dating & Plus Size Chat",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 12632,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 27, 2018",
    "Current Ver": "3.5.0.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Casual Dating & Adult Singles - Joyride",
    Category: "DATING",
    Rating: 4.5,
    Reviews: 61637,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.17.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "EliteSingles – Dating for Single Professionals",
    Category: "DATING",
    Rating: 2.5,
    Reviews: 5377,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.8.5",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Clover Dating App",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 11633,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 24, 2018",
    "Current Ver": "2.5.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Moco - Chat, Meet People",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 313724,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 4, 2018",
    "Current Ver": "2.6.141",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Herpes Dating: 1,000K+ Singles",
    Category: "DATING",
    Rating: 4,
    Reviews: 738,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 1, 2018",
    "Current Ver": "6.4.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Hot or Not - Find someone right now",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 305708,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Just She - Top Lesbian Dating",
    Category: "DATING",
    Rating: 1.9,
    Reviews: 953,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 18, 2018",
    "Current Ver": "6.3.7",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Heart mill",
    Category: "DATING",
    Rating: 3.3,
    Reviews: 4631,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 4, 2018",
    "Current Ver": "5.2.14",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Once - Quality Matches Every day",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 222888,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 17, 2018",
    "Current Ver": 2.45,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Sudy – Meet Elite & Rich Single",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 17268,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 25, 2018",
    "Current Ver": "4.1.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "muzmatch: Muslim & Arab Singles, Marriage & Dating",
    Category: "DATING",
    Rating: 3.8,
    Reviews: 5164,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 24, 2018",
    "Current Ver": "3.8.75a",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "95Live -SG#1 Live Streaming App",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 4953,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Dating",
    "Last Updated": "August 1, 2018",
    "Current Ver": "8.7.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Chispa, the Dating App for Latino, Latina Singles",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 4195,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.6.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Blendr - Chat, Flirt & Meet",
    Category: "DATING",
    Rating: 4,
    Reviews: 28671,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Find Real Love — YouLove Premium Dating",
    Category: "DATING",
    Rating: 4.5,
    Reviews: 212626,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.17.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Mutual - LDS Dating",
    Category: "DATING",
    Rating: 3.7,
    Reviews: 1439,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.1.46",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Cougar Dating Life : Date Older Women Sugar Mummy",
    Category: "DATING",
    Rating: 3.9,
    Reviews: 1645,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 3, 2018",
    "Current Ver": "4.5.5",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "stranger chat - anonymous chat",
    Category: "DATING",
    Rating: 3.5,
    Reviews: 13204,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 7, 2018",
    "Current Ver": "2.4.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Millionaire Match: Rich Singles Dating App",
    Category: "DATING",
    Rating: 3.9,
    Reviews: 853,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 30, 2018",
    "Current Ver": "6.4.6",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "2RedBeans",
    Category: "DATING",
    Rating: 4,
    Reviews: 337,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.8.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Dating for 50 plus Mature Singles – FINALLY",
    Category: "DATING",
    Rating: 4.6,
    Reviews: 13049,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.17.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "SweetRing - Meet, Match, Date",
    Category: "DATING",
    Rating: 4,
    Reviews: 51698,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 26, 2018",
    "Current Ver": "3.0.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BiggerCity: Chat for gay bears, chubs & chasers",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 923,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.4.1.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Moco+ - Chat, Meet People",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 1546,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 19, 2018",
    "Current Ver": "2.6.139",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "SilverSingles: The 50+ Dating App",
    Category: "DATING",
    Rating: 3.3,
    Reviews: 149,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.8.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Herpes Positive Singles Dating",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 198,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "May 18, 2018",
    "Current Ver": "5.5.7",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Chat Rooms, Avatars, Date - Galaxy",
    Category: "DATING",
    Rating: 4.3,
    Reviews: 135420,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "FastMeet: Chat, Dating, Love",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 22545,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.31.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Christian Dating For Free App",
    Category: "DATING",
    Rating: 3.9,
    Reviews: 8723,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 20, 2018",
    "Current Ver": 15.8,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Glam - Premium Dating App",
    Category: "DATING",
    Rating: 4.3,
    Reviews: 23170,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.5.4.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "iDates - Chats, Flirts, Dating, Love & Relations",
    Category: "DATING",
    Rating: 3.4,
    Reviews: 13890,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 19, 2018",
    "Current Ver": "4.9.2 (Oasis)",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Meet24 - Love, Chat, Singles",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 57083,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.31.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Black White Interracial Dating - Interracial Match",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 537,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "March 29, 2018",
    "Current Ver": "2.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "JustDating",
    Category: "DATING",
    Rating: 4,
    Reviews: 13440,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.10.5",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Interracial Match Dating App",
    Category: "DATING",
    Rating: 3.6,
    Reviews: 143,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.2.7",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Russian Dating & Chat for Russian speaking RusDate",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 1059,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1.17,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Sky People (SPI): A secure blind date through authentication by Seoul National University",
    Category: "DATING",
    Rating: 3.5,
    Reviews: 894,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 17, 2018",
    "Current Ver": "3.1.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Sweet mi - unlimited hunnam hunting blind date",
    Category: "DATING",
    Rating: 4,
    Reviews: 6191,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 12, 2018",
    "Current Ver": "0.0.73",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Gay Sugar Daddy Dating & Hookup – Sudy Gay",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 2212,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 20, 2018",
    "Current Ver": "2.0.5",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Mingle - Online Dating App to Chat & Meet People",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 15081,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 26, 2018",
    "Current Ver": "4.7.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Adult Dirty Emojis",
    Category: "DATING",
    Rating: 2.8,
    Reviews: 80,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Dating",
    "Last Updated": "November 6, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BBW Dating & Curvy Singles Chat- LargeFriends",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 218,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 23, 2018",
    "Current Ver": "5.2.9",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Hide App, Private Dating, Safe Chat - PrivacyHider",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 35205,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "May 21, 2018",
    "Current Ver": "2.9.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hitwe - meet people and chat",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 243950,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "May 10, 2018",
    "Current Ver": "4.3.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "A hundred",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 236,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "March 29, 2018",
    "Current Ver": "3.9.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "JustSayHi- Dating App. Chat & Meet Singles Nearby",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 5152,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 26, 2018",
    "Current Ver": "3.6.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "FERZU - Furries Social Network",
    Category: "DATING",
    Rating: 3.9,
    Reviews: 1576,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "February 16, 2018",
    "Current Ver": "4.4.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "WannaMeet – Dating & Chat App",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 6701,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 29, 2018",
    "Current Ver": "5.16.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Meet4U - Chat, Love, Singles!",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 40039,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.31.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Luxy Pro- Elite Dating Single",
    Category: "DATING",
    Rating: 3.9,
    Reviews: 742,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "April 7, 2018",
    "Current Ver": "5.3.3.13289",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Dating Network",
    Category: "DATING",
    Rating: 4,
    Reviews: 187,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1.17,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Chatting - Free chat, random chat, boyfriend, girlfriend",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 2506,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 15, 2017",
    "Current Ver": "3.0.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "iPair-Meet, Chat, Dating",
    Category: "DATING",
    Rating: 4.5,
    Reviews: 182986,
    Size: "77M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.0.8",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Meet, chat & date. Free dating app - Chocolate app",
    Category: "DATING",
    Rating: 3.9,
    Reviews: 8661,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "April 3, 2018",
    "Current Ver": "0.1.11",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Transenger – Ts Dating and Chat for Free",
    Category: "DATING",
    Rating: 3.6,
    Reviews: 8,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 29, 2018",
    "Current Ver": "1.4.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "O-Star",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 59,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.0.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Free Cam Girls - Live Webcam",
    Category: "DATING",
    Rating: 3.5,
    Reviews: 35,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 16, 2018",
    "Current Ver": 2.4,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Cardi B Live Stream Video Chat - Prank",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 28,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "July 16, 2018",
    "Current Ver": 2.5,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Live Girls Talk - Free Video Chat",
    Category: "DATING",
    Rating: 4.8,
    Reviews: 125,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 8, 2018",
    "Current Ver": 8.2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Live Talk - Free Text and Video Chat",
    Category: "DATING",
    Rating: 4.6,
    Reviews: 185,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 16, 2018",
    "Current Ver": 8.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Chat Kids - Chat Room For Kids",
    Category: "DATING",
    Rating: 4.7,
    Reviews: 6,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 24, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Girls Live Chat - Free Text & Video Chat",
    Category: "DATING",
    Rating: 4.8,
    Reviews: 110,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 9, 2018",
    "Current Ver": 8.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Random Video Chat",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 3,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 15, 2018",
    "Current Ver": 4.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "MouseMingle",
    Category: "DATING",
    Rating: 2.7,
    Reviews: 3,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "American Girls Mobile Numbers",
    Category: "DATING",
    Rating: 5,
    Reviews: 5,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 17, 2018",
    "Current Ver": 3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Random Video Chat App With Strangers",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 3,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 17, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FREE VIDEO CHAT - LIVE VIDEO AND TEXT CHAT",
    Category: "DATING",
    Rating: 4.8,
    Reviews: 84,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 6, 2018",
    "Current Ver": 8.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Awake Dating",
    Category: "DATING",
    Rating: 5,
    Reviews: 2,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 24, 2018",
    "Current Ver": "2.2.9",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Live Chat - Free Video Chat Rooms",
    Category: "DATING",
    Rating: 4.8,
    Reviews: 20,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 15, 2018",
    "Current Ver": 8.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Meet With Strangers: Video Chat & Dating",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 2,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 16, 2018",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "FREE LIVE TALK",
    Category: "DATING",
    Rating: 4.9,
    Reviews: 776,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 14, 2018",
    "Current Ver": 8.2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Random Chat App with Strangers",
    Category: "DATING",
    Rating: 3,
    Reviews: 2,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 17, 2018",
    "Current Ver": 2.5,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ost. Zombies Cast - New Music and Lyrics",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 1,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Dating",
    "Last Updated": "July 20, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Dating White Girls",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 20, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Live Chat - Free Video Talk",
    Category: "DATING",
    Rating: 4.7,
    Reviews: 14,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1.3,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Geeks Dating",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 10, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Live chat - free video chat",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 1,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 23, 2018",
    "Current Ver": 3.52,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "House party - live chat",
    Category: "DATING",
    Rating: 1,
    Reviews: 1,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 31, 2018",
    "Current Ver": 3.52,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Fishing Brain & Boating Maps Marine",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 3,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "July 23, 2018",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CAM5678 Video Chat",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 13, 2018",
    "Current Ver": "5.5.8",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Video chat live advices",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "July 10, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "chat live chat",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 24,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Pet Lovers Dating",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 9, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Friend Find: free chat + flirt dating app",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 23,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 31, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Latin Dating",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 9, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Spine- The dating app",
    Category: "DATING",
    Rating: 5,
    Reviews: 5,
    Size: "9.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Dating",
    "Last Updated": "July 14, 2018",
    "Current Ver": 4,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Online Chat Girls Meet",
    Category: "DATING",
    Rating: 4.7,
    Reviews: 18,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 25, 2018",
    "Current Ver": 8.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Wifi Mingle",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "10.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "July 27, 2018",
    "Current Ver": 1.3,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Girls Live Talk - Free Text and Video Chat",
    Category: "DATING",
    Rating: 5,
    Reviews: 6,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 1, 2018",
    "Current Ver": 8.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Soy Luna - Top Music And Lyrics",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 1,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Dating",
    "Last Updated": "July 24, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "When Will You Get Married",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 2,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "July 14, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "HOW TO ASK A GIRL OUT",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "July 16, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Online Girls Chat Group",
    Category: "DATING",
    Rating: 5,
    Reviews: 5,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 2, 2018",
    "Current Ver": 8.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "The DJ - Match with People",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 2, 2018",
    "Current Ver": 1.2,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Toronto Dating",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 12, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "i miss you quotes and photos",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "July 22, 2018",
    "Current Ver": "1.0.7",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "JoJo Siwa Top Hits Music",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Dating",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "UK Girls Mobile Numbers",
    Category: "DATING",
    Rating: 3,
    Reviews: 1,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 19, 2018",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "chat saudi arabia",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 11,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 14, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Chat Click - Dating Search",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 4,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 11, 2018",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 3,
  },
  {
    App: "Iraq love chat",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 14,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Dating",
    "Last Updated": "August 3, 2018",
    "Current Ver": 8.2,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Healthy Relationships Guide",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "July 31, 2018",
    "Current Ver": 2,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "following",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 1,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.0.3",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Gods by Night",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 104,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 22, 2018",
    "Current Ver": "3.5.4.2.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "PlusOne",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.1.1",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Love Calendar - Couple Sharing Calendar & CoupleDay",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 14,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "July 30, 2018",
    "Current Ver": 1.6,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Speeding Joyride & Car Meet App",
    Category: "DATING",
    Rating: 5,
    Reviews: 3,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 20, 2018",
    "Current Ver": "1.2.9",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "LOBSTR - go on a lunch date",
    Category: "DATING",
    Rating: 3.7,
    Reviews: 101,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 24, 2018",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Titanic App - Feminist Dating Application",
    Category: "DATING",
    Rating: 4.5,
    Reviews: 120,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.5-beta",
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "French Chat Room",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 24,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 11, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Soul Mate",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 19, 2018",
    "Current Ver": "4.5.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Diamond Engagement Rings",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "July 12, 2018",
    "Current Ver": 6.1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Dating Tips For Men",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 0,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "July 9, 2018",
    "Current Ver": 3,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Halalguur",
    Category: "DATING",
    Rating: 4.3,
    Reviews: 6,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 26, 2018",
    "Current Ver": 3.7,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "95Live -SG#1 Live Streaming App",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 4954,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Dating",
    "Last Updated": "August 1, 2018",
    "Current Ver": "8.7.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Just She - Top Lesbian Dating",
    Category: "DATING",
    Rating: 1.9,
    Reviews: 954,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 18, 2018",
    "Current Ver": "6.3.7",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Hily: Dating, Chat, Match, Meet & Hook up",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 2560,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.5.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "O-Star",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 59,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.0.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Random Video Chat",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 3,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 15, 2018",
    "Current Ver": 4.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Black People Meet Singles Date",
    Category: "DATING",
    Rating: 3.9,
    Reviews: 10212,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.9.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Howlr",
    Category: "DATING",
    Rating: 3.9,
    Reviews: 105,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 19, 2018",
    "Current Ver": "1.0.4",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Find Lover",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 21,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.0.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Free Dating & Flirt Chat - Choice of Love",
    Category: "DATING",
    Rating: 4,
    Reviews: 42197,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Cardi B Live Stream Video Chat - Prank",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 28,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "July 16, 2018",
    "Current Ver": 2.5,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Chat Kids - Chat Room For Kids",
    Category: "DATING",
    Rating: 4.7,
    Reviews: 6,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 24, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "muzmatch: Muslim & Arab Singles, Marriage & Dating",
    Category: "DATING",
    Rating: 3.8,
    Reviews: 5168,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 24, 2018",
    "Current Ver": "3.8.75a",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BBW Dating & Plus Size Chat",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 12633,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 27, 2018",
    "Current Ver": "3.5.0.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "2Date Dating App, Love and matching",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 41605,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 26, 2018",
    "Current Ver": 4.813,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Transenger – Ts Dating and Chat for Free",
    Category: "DATING",
    Rating: 3.6,
    Reviews: 8,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 29, 2018",
    "Current Ver": "1.4.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BBW Dating & Curvy Singles Chat- LargeFriends",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 218,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 23, 2018",
    "Current Ver": "5.2.9",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "MouseMingle",
    Category: "DATING",
    Rating: 2.7,
    Reviews: 3,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FlirtChat - ♥Free Dating/Flirting App♥",
    Category: "DATING",
    Rating: 4.3,
    Reviews: 2433,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 26, 2018",
    "Current Ver": "12.0.4",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Live Talk - Free Text and Video Chat",
    Category: "DATING",
    Rating: 4.6,
    Reviews: 185,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 16, 2018",
    "Current Ver": 8.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Adult Dirty Emojis",
    Category: "DATING",
    Rating: 2.8,
    Reviews: 80,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Dating",
    "Last Updated": "November 6, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Free Cam Girls - Live Webcam",
    Category: "DATING",
    Rating: 3.5,
    Reviews: 35,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 16, 2018",
    "Current Ver": 2.4,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Random Video Chat App With Strangers",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 3,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 17, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Teenage Chat & Dating",
    Category: "DATING",
    Rating: 3.4,
    Reviews: 5,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 9, 2018",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Live Girls Talk - Free Video Chat",
    Category: "DATING",
    Rating: 4.8,
    Reviews: 125,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 8, 2018",
    "Current Ver": 8.2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Girls Online Talk - Free Text and Video Chat",
    Category: "DATING",
    Rating: 4.7,
    Reviews: 791,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "May 15, 2018",
    "Current Ver": 8.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Girls Live Chat - Free Text & Video Chat",
    Category: "DATING",
    Rating: 4.8,
    Reviews: 110,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 9, 2018",
    "Current Ver": 8.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Online Girls Chat",
    Category: "DATING",
    Rating: 4.8,
    Reviews: 5323,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "April 21, 2018",
    "Current Ver": 8.2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "LIVE VIDEO TALK",
    Category: "DATING",
    Rating: 4.7,
    Reviews: 478,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "June 28, 2018",
    "Current Ver": 8.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Free Dating App - Meet Local Singles - Flirt Chat",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 825,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "December 28, 2017",
    "Current Ver": "1.0.5",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "SkyLove – Dating and chat",
    Category: "DATING",
    Rating: 3.5,
    Reviews: 69,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.0.82",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Free Live Talk-Video Call",
    Category: "DATING",
    Rating: 4.7,
    Reviews: 158,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 5, 2018",
    "Current Ver": 8.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FindLoving",
    Category: "DATING",
    Rating: 3.8,
    Reviews: 24,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.0.5",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Sugar Daddies Dating App",
    Category: "DATING",
    Rating: 2.9,
    Reviews: 53,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 10, 2018",
    "Current Ver": 4.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "iPair-Meet, Chat, Dating",
    Category: "DATING",
    Rating: 4.5,
    Reviews: 182986,
    Size: "77M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.0.8",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Free Dating Hook Up Messenger",
    Category: "DATING",
    Rating: 3.3,
    Reviews: 1157,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "January 27, 2017",
    "Current Ver": "5.0.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Free Dating App - YoCutie - Flirt, Chat & Meet",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 97699,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 10, 2018",
    "Current Ver": 1.23,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Chat Mexico: meet people, flirt and friendship",
    Category: "DATING",
    Rating: "NaN",
    Reviews: 8,
    Size: "9.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 2, 2018",
    "Current Ver": 3.7,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Duolingo: Learn Languages Free",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 6289924,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "TED",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 181893,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "3.2.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "English Communication - Learn English for Chinese (Learn English for Chinese)",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 2544,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 29, 2017",
    "Current Ver": 3.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Khan Academy",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 85375,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "5.0.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Learn English with Wlingua",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 314299,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 2, 2018",
    "Current Ver": "1.94.9",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Ai La Trieu Phu - ALTP Free",
    Category: "EDUCATION",
    Rating: "NaN",
    Reviews: 776,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 23, 2018",
    "Current Ver": 1.5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Princess Coloring Book",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 9770,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Creativity",
    "Last Updated": "February 25, 2018",
    "Current Ver": "1.2.8",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Learn Spanish - Español",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 32346,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 18, 2017",
    "Current Ver": "1.3.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "English Grammar Test",
    Category: "EDUCATION",
    Rating: 4.8,
    Reviews: 4075,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 22, 2018",
    "Current Ver": "2.1.8",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Speed Reading",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 10611,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 27, 2018",
    "Current Ver": "2.3.7",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "English for beginners",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 9321,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 18, 2018",
    "Current Ver": "2.9.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Flame - درب عقلك يوميا",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 56065,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 26, 2018",
    "Current Ver": 3.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Mermaids",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 14286,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Creativity",
    "Last Updated": "April 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Learn Japanese, Korean, Chinese Offline & Free",
    Category: "EDUCATION",
    Rating: 4.9,
    Reviews: 133136,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.16.11.10",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Kids Mode",
    Category: "EDUCATION",
    Rating: 3.8,
    Reviews: 2469,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "PBS KIDS Video",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 36212,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Music & Video",
    "Last Updated": "July 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Dinosaurs Coloring Pages",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 390,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "February 3, 2018",
    "Current Ver": "1.1.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Cars Coloring Pages",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 1090,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Creativity",
    "Last Updated": "February 3, 2018",
    "Current Ver": "1.2.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Babbel – Learn Languages",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 266948,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 30, 2018",
    "Current Ver": "20.7.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Math Tricks",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 342918,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 29, 2018",
    "Current Ver": 2.24,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Monster Truck Driver & Racing",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 748,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Action & Adventure",
    "Last Updated": "January 19, 2017",
    "Current Ver": "1.0.9",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Learn English Words Free",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 172640,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 2, 2018",
    "Current Ver": "2.6.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Japanese / English one-shop search dictionary - Free Japanese - English - Japanese dictionary application",
    Category: "EDUCATION",
    Rating: 3.9,
    Reviews: 61,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Education",
    "Last Updated": "May 28, 2018",
    "Current Ver": "1.4.2",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "English speaking texts",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 1619,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 20, 2018",
    "Current Ver": 1.2,
    numInstall: 1000000,
    numAndroid: 1,
  },
  {
    App: "Thai Handwriting",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 3168,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 26, 2017",
    "Current Ver": 3.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "THAI DICT 2018",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 29855,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Education",
    "Last Updated": "July 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Kanji test · Han search Kanji training (free version)",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 6736,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Education",
    "Last Updated": "October 17, 2017",
    "Current Ver": "2.51.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Game for KIDS: KIDS match'em",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 7005,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 23, 2016",
    "Current Ver": 1.17,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Flippy Campus - Buy & sell on campus at a discount",
    Category: "EDUCATION",
    Rating: 4,
    Reviews: 889,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 9, 2018",
    "Current Ver": "2.2.4",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Free intellectual training game application |",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 5741,
    Size: "84M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "July 25, 2018",
    "Current Ver": "3.7.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ABC Preschool Free",
    Category: "EDUCATION",
    Rating: 3.8,
    Reviews: 27572,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "October 25, 2017",
    "Current Ver": 3,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "PINKFONG Baby Shark",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 10852,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 28, 2017",
    "Current Ver": 10,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "English words application mikan",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 9888,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Learn English for beginners",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 1929,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 28, 2017",
    "Current Ver": 1.1,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Listen and learn English in seven days",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 1516,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 28, 2018",
    "Current Ver": 3.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Lumosity: #1 Brain Games & Cognitive Training App",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 215301,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Learn English from Persian: Persian to English",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 423,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 3, 2018",
    "Current Ver": 6,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "English with Lingualeo",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 254519,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.8.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Learn languages, grammar & vocabulary with Memrise",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 1107903,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Khan Academy",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 85375,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "5.0.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "TED",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 181893,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "3.2.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Quizlet: Learn Languages & Vocab with Flashcards",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 211856,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Udemy - Online Courses",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 99020,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.0.4",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Coursera: Online courses",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 90481,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "edX - Online Courses by Harvard, MIT & more",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 32381,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Education",
    "Last Updated": "July 15, 2018",
    "Current Ver": "2.15.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Elevate - Brain Training Games",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 248912,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "NeuroNation - Focus and Brain Training",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 248555,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Brain Games",
    "Last Updated": "May 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Lumosity: #1 Brain Games & Cognitive Training App",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 215301,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Peak – Brain Games & Training",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 272145,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Brain Games",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.14.15",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Memorado - Brain Games",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 56897,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Brain Games",
    "Last Updated": "January 16, 2017",
    "Current Ver": "1.10.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Lynda - Online Training Videos",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 8599,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 11, 2018",
    "Current Ver": "4.9.10",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Brilliant",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 41185,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "CppDroid - C/C++ IDE",
    Category: "EDUCATION",
    Rating: 4.1,
    Reviews: 29980,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 17, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Quiz&Learn Python",
    Category: "EDUCATION",
    Rating: 4,
    Reviews: 304,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 4, 2016",
    "Current Ver": "1.3.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "C++ Tutorials",
    Category: "EDUCATION",
    Rating: 4.1,
    Reviews: 358,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 21, 2014",
    "Current Ver": 1.1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "C++ Programming",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 11904,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 22, 2015",
    "Current Ver": 2,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "C Programming",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 22251,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 28, 2015",
    "Current Ver": 3,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Udacity - Lifelong Learning",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 22384,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.7.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Udemy - Online Courses",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 99020,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.0.4",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Learn C++",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 73404,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 25, 2017",
    "Current Ver": "4.5.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Learn programming",
    Category: "EDUCATION",
    Rating: 4.1,
    Reviews: 12733,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Learn JavaScript",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 25183,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 25, 2017",
    "Current Ver": "5.7.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Learn Java",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 52743,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 25, 2017",
    "Current Ver": "3.5.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Learn HTML",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 61749,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 25, 2017",
    "Current Ver": "5.5.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Programming Hub, Learn to code",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 55704,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 4, 2018",
    "Current Ver": "4.2.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Learn SQL",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 19277,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 25, 2017",
    "Current Ver": "3.4.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ready4 SAT (Prep4 SAT)",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 13612,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 10, 2018",
    "Current Ver": "7.2.3633",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Socratic - Math Answers & Homework Help",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 37862,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 7, 2018",
    "Current Ver": "1.8.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ready4 GMAT (Prep4 GMAT)",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 18372,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 21, 2018",
    "Current Ver": "7.2.3634",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Pocket GMAT Math",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 656,
    Size: "556k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 11, 2014",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "GMAT Question Bank",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 240,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 29, 2015",
    "Current Ver": "1.2.0",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "GRE Tutor",
    Category: "EDUCATION",
    Rating: 4,
    Reviews: 275,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 2, 2013",
    "Current Ver": 2.9,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "GRE Flashcards",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 13791,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "play2prep: ACT, SAT prep",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 3692,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 23, 2015",
    "Current Ver": "4.1.3",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "SAT Test",
    Category: "EDUCATION",
    Rating: 4.1,
    Reviews: 2363,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 17, 2016",
    "Current Ver": 2.48,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "GMAT Math Flashcards",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 1769,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Pocket SAT Math",
    Category: "EDUCATION",
    Rating: 4,
    Reviews: 430,
    Size: "526k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 11, 2014",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "TOEFL Prep & Practice from Magoosh",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 756,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 18, 2018",
    "Current Ver": "3.2.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "GRE Prep & Practice by Magoosh",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 3963,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "GRE® Flashcards by Kaplan",
    Category: "EDUCATION",
    Rating: 4,
    Reviews: 316,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 15, 2017",
    "Current Ver": 1.4,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "SAT Vocabulary",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 642,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Magoosh GMAT Prep & Practice",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 1058,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "SAT Flashcards: Prep & Vocabulary",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 2277,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 7, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Khan Academy",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 85375,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "5.0.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "TED",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 181893,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "3.2.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Duolingo: Learn Languages Free",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 6290507,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Quizlet: Learn Languages & Vocab with Flashcards",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 211856,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Coursera: Online courses",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 90481,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Udemy - Online Courses",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 99020,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.0.4",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Udacity - Lifelong Learning",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 22384,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.7.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "edX - Online Courses by Harvard, MIT & more",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 32380,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Education",
    "Last Updated": "July 15, 2018",
    "Current Ver": "2.15.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Rosetta Stone: Learn to Speak & Read New Languages",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 172505,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "June 27, 2018",
    "Current Ver": "5.2.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Google Classroom",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 69493,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Lynda - Online Training Videos",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 8599,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 11, 2018",
    "Current Ver": "4.9.10",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Learn languages, grammar & vocabulary with Memrise",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 1107884,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Brilliant",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 41185,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "LinkedIn Learning: Online Courses to Learn Skills",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 7973,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "0.29.74",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Babbel – Learn Languages",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 266935,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 30, 2018",
    "Current Ver": "20.7.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Learn English with Phrases",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 5695,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 28, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Free english course",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 142632,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 12, 2018",
    "Current Ver": 2.8,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Duolingo: Learn Languages Free",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 6290507,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Learn 50 languages",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 55256,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 19, 2018",
    "Current Ver": "10.9.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Rosetta Stone: Learn to Speak & Read New Languages",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 172508,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "June 27, 2018",
    "Current Ver": "5.2.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Babbel – Learn Spanish",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 54798,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 30, 2018",
    "Current Ver": "20.7.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Mango Languages: Lovable Language Courses",
    Category: "EDUCATION",
    Rating: 4,
    Reviews: 4815,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 17, 2018",
    "Current Ver": "4.2.3",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Learn English with Aco",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 75112,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 11, 2017",
    "Current Ver": 2.09,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Learn to Speak English",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 33646,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 15, 2018",
    "Current Ver": "2.3.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Learn languages, grammar & vocabulary with Memrise",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 1107903,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Learn English with Wlingua",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 314300,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 2, 2018",
    "Current Ver": "1.94.9",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "busuu: Learn Languages - Spanish, English & More",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 206527,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "13.9.0.161",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "My Class Schedule: Timetable",
    Category: "EDUCATION",
    Rating: 4.1,
    Reviews: 9348,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 1, 2016",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Study Checker",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 3816,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 4, 2016",
    "Current Ver": "3.6.0.115_FN",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "My Study Life - School Planner",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 47847,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 13, 2017",
    "Current Ver": "6.1.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "HomeWork",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 16195,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 20, 2016",
    "Current Ver": "8.5.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Next Gen Science Standards",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 206,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 20, 2016",
    "Current Ver": "1.12.1",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "myHomework Student Planner",
    Category: "EDUCATION",
    Rating: 4,
    Reviews: 28392,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Teacher's Gradebook - Additio",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 3241,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.8.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Common Core",
    Category: "EDUCATION",
    Rating: 4,
    Reviews: 835,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 20, 2016",
    "Current Ver": "2.3.1",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Homework Planner",
    Category: "EDUCATION",
    Rating: 4,
    Reviews: 2525,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 11, 2015",
    "Current Ver": "15.9.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "TeachersPayTeachers",
    Category: "EDUCATION",
    Rating: 3.8,
    Reviews: 828,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 1, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Quizlet: Learn Languages & Vocab with Flashcards",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 211856,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Edmodo",
    Category: "EDUCATION",
    Rating: 4.1,
    Reviews: 200058,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 20, 2018",
    "Current Ver": "9.12.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Socrative Teacher",
    Category: "EDUCATION",
    Rating: 3.9,
    Reviews: 1239,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 29, 2016",
    "Current Ver": "4.4.1",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Training schedule - AllUniver",
    Category: "EDUCATION",
    Rating: 4.1,
    Reviews: 702,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 16, 2017",
    "Current Ver": 5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Remind: School Communication",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 108613,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Google Classroom",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 69498,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "ClassDojo",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 148550,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.21.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Duolingo: Learn Languages Free",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 6290507,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Lerni. Learn languages.",
    Category: "EDUCATION",
    Rating: 4,
    Reviews: 3847,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 25, 2017",
    "Current Ver": "3.1.3",
    numInstall: 500000,
    numAndroid: 3,
  },
  {
    App: "Learn 50 languages",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 55256,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 19, 2018",
    "Current Ver": "10.9.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "HelloTalk — Chat, Speak & Learn Foreign Languages",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 84309,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 25, 2018",
    "Current Ver": "2.6.6",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Mango Languages: Lovable Language Courses",
    Category: "EDUCATION",
    Rating: 4,
    Reviews: 4815,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 17, 2018",
    "Current Ver": "4.2.3",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Rosetta Stone: Learn to Speak & Read New Languages",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 172508,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "June 27, 2018",
    "Current Ver": "5.2.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Learn languages, grammar & vocabulary with Memrise",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 1107948,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Babbel – Learn Languages",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 266948,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 30, 2018",
    "Current Ver": "20.7.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Innovative: Learn 34 Languages",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 14206,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1.16,
    numInstall: 500000,
    numAndroid: 3,
  },
  {
    App: "busuu: Learn Languages - Spanish, English & More",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 206532,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "13.9.0.161",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "My Class Schedule: Timetable",
    Category: "EDUCATION",
    Rating: 4.1,
    Reviews: 9348,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 1, 2016",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Chegg Study - Homework Help",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 14700,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 30, 2018",
    "Current Ver": "5.7.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Canvas Student",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 42828,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Timetable",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 40209,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Socratic - Math Answers & Homework Help",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 37862,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 7, 2018",
    "Current Ver": "1.8.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "EasyBib: Citation Generator",
    Category: "EDUCATION",
    Rating: 3.5,
    Reviews: 1405,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 29, 2018",
    "Current Ver": "2.4.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Google Classroom",
    Category: "EDUCATION",
    Rating: 4.2,
    Reviews: 69498,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "ClassDojo",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 148549,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.21.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "HelloTalk — Chat, Speak & Learn Foreign Languages",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 84311,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 25, 2018",
    "Current Ver": "2.6.6",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Quizlet: Learn Languages & Vocab with Flashcards",
    Category: "EDUCATION",
    Rating: 4.6,
    Reviews: 211856,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "busuu: Learn Languages - Spanish, English & More",
    Category: "EDUCATION",
    Rating: 4.3,
    Reviews: 206532,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "13.9.0.161",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Rosetta Stone: Learn to Speak & Read New Languages",
    Category: "EDUCATION",
    Rating: 4.5,
    Reviews: 172508,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "June 27, 2018",
    "Current Ver": "5.2.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "SoloLearn: Learn to Code for Free",
    Category: "EDUCATION",
    Rating: 4.8,
    Reviews: 256079,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Education",
    "Last Updated": "July 12, 2018",
    "Current Ver": "2.2.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Kids Learn Languages by Mondly",
    Category: "EDUCATION",
    Rating: 4.4,
    Reviews: 2078,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "December 24, 2017",
    "Current Ver": "1.0.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Blinkist - Nonfiction Books",
    Category: "EDUCATION",
    Rating: 4.1,
    Reviews: 16103,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 31, 2018",
    "Current Ver": "5.7.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Sago Mini Hat Maker",
    Category: "EDUCATION",
    Rating: 4.9,
    Reviews: 11,
    Size: "63M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "July 24, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Fuzzy Numbers: Pre-K Number Foundation",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 21,
    Size: "44M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "July 21, 2017",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Toca Life: City",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 31085,
    Size: "24M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "July 6, 2018",
    "Current Ver": "1.5-play",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Toca Life: Hospital",
    Category: "EDUCATION",
    Rating: 4.7,
    Reviews: 3528,
    Size: "24M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "June 12, 2018",
    "Current Ver": "1.1.1-play",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Netflix",
    Category: "ENTERTAINMENT",
    Rating: 4.4,
    Reviews: 5456208,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Complete Spanish Movies",
    Category: "ENTERTAINMENT",
    Rating: 4,
    Reviews: 11656,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 20, 2018",
    "Current Ver": 1.02,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Pluto TV - It’s Free TV",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 28948,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Tubi TV - Free Movies & TV",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 296771,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 15, 2018",
    "Current Ver": "2.13.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "YouTube Kids",
    Category: "ENTERTAINMENT",
    Rating: 4.5,
    Reviews: 470089,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.43.3",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Mobile TV",
    Category: "ENTERTAINMENT",
    Rating: 3.5,
    Reviews: 10939,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 28, 2016",
    "Current Ver": "2.05.0010",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "TV+",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 98509,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Digital TV",
    Category: "ENTERTAINMENT",
    Rating: 3.1,
    Reviews: 5241,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 6,
  },
  {
    App: "Motorola Spotlight Player™",
    Category: "ENTERTAINMENT",
    Rating: 4.6,
    Reviews: 22508,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 16, 2015",
    "Current Ver": "v1.8b22p13",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Vigo Lite",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 10291,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 4, 2018",
    "Current Ver": "3.7.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Google Play Games",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 7165362,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Hotstar",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 4885646,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Peers.TV: broadcast TV channels First, Match TV, TNT ...",
    Category: "ENTERTAINMENT",
    Rating: 4.1,
    Reviews: 141980,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "The green alien dance",
    Category: "ENTERTAINMENT",
    Rating: 3.8,
    Reviews: 6979,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 5, 2018",
    "Current Ver": 1.03,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Spectrum TV",
    Category: "ENTERTAINMENT",
    Rating: 3.4,
    Reviews: 46618,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "H TV",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 103078,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 5, 2018",
    "Current Ver": "4.6.2",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "StarTimes - Live International Champions Cup",
    Category: "ENTERTAINMENT",
    Rating: 4.4,
    Reviews: 17682,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 3, 2018",
    "Current Ver": 5.2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Cinematic Cinematic",
    Category: "ENTERTAINMENT",
    Rating: 4.4,
    Reviews: 37000,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "June 21, 2018",
    "Current Ver": "4.0.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "MEGOGO - Cinema and TV",
    Category: "ENTERTAINMENT",
    Rating: 4,
    Reviews: 175528,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Talking Angela",
    Category: "ENTERTAINMENT",
    Rating: 3.7,
    Reviews: 1828284,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 12, 2018",
    "Current Ver": "2.8.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "DStv Now",
    Category: "ENTERTAINMENT",
    Rating: 3.9,
    Reviews: 34923,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "ivi - movies and TV shows in HD",
    Category: "ENTERTAINMENT",
    Rating: 4.5,
    Reviews: 684116,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Radio Javan",
    Category: "ENTERTAINMENT",
    Rating: 4.4,
    Reviews: 46916,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 18, 2018",
    "Current Ver": 7.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Viki: Asian TV Dramas & Movies",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 407698,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Talking Ginger 2",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 702975,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 5, 2018",
    "Current Ver": "2.6.6.11",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Girly Lock Screen Wallpaper with Quotes",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 32458,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 19, 2018",
    "Current Ver": 2.2,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "No.Draw - Colors by Number 2018",
    Category: "ENTERTAINMENT",
    Rating: 4.5,
    Reviews: 235496,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Brain Games",
    "Last Updated": "July 29, 2018",
    "Current Ver": "1.2.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "🔥 Football Wallpapers 4K | Full HD Backgrounds 😍",
    Category: "ENTERTAINMENT",
    Rating: 4.7,
    Reviews: 11661,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 14, 2018",
    "Current Ver": "1.1.3.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Movies by Flixster, with Rotten Tomatoes",
    Category: "ENTERTAINMENT",
    Rating: 4.5,
    Reviews: 653008,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 20, 2018",
    "Current Ver": "9.1.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Low Poly – Puzzle art game",
    Category: "ENTERTAINMENT",
    Rating: 4.5,
    Reviews: 23063,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Brain Games",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.0.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BBC Media Player",
    Category: "ENTERTAINMENT",
    Rating: 3.4,
    Reviews: 87384,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "September 14, 2016",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Amazon Prime Video",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 411683,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.0.231.18141",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Adult Glitter Color by Number Book - Sandbox Pages",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 8918,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Creativity",
    "Last Updated": "July 21, 2018",
    "Current Ver": 1.7,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "IMDb Movies & TV",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 501498,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Twitch: Livestream Multiplayer Games & Esports",
    Category: "ENTERTAINMENT",
    Rating: 4.6,
    Reviews: 2133296,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Ziggo GO",
    Category: "ENTERTAINMENT",
    Rating: 4.1,
    Reviews: 29690,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.3.34 Prod",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "YouTube Gaming",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 130549,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 27, 2018",
    "Current Ver": "2.08.78.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "PlayStation App",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 613059,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 26, 2018",
    "Current Ver": "18.07.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Talking Ben the Dog",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 1633682,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 3, 2018",
    "Current Ver": "3.5.2.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Red Bull TV: Live Sports, Music & Entertainment",
    Category: "ENTERTAINMENT",
    Rating: 4.4,
    Reviews: 42050,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Trailer Addict Movie Trailers",
    Category: "ENTERTAINMENT",
    Rating: 3.9,
    Reviews: 2646,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "February 14, 2018",
    "Current Ver": "2.2.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Cinemark Theatres",
    Category: "ENTERTAINMENT",
    Rating: 4.1,
    Reviews: 21867,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 12, 2018",
    "Current Ver": "2.19.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Regal Cinemas",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 32732,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Movies by Flixster, with Rotten Tomatoes",
    Category: "ENTERTAINMENT",
    Rating: 4.5,
    Reviews: 653008,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 20, 2018",
    "Current Ver": "9.1.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Fandango Movies - Times + Tickets",
    Category: "ENTERTAINMENT",
    Rating: 4.6,
    Reviews: 243747,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Marcus Theatres",
    Category: "ENTERTAINMENT",
    Rating: 3.6,
    Reviews: 2639,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 7, 2018",
    "Current Ver": "2.9.43",
    numInstall: 100000,
    numAndroid: 6,
  },
  {
    App: "Harkins Theatres",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 1511,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 11, 2018",
    "Current Ver": "2.1.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AMC Theatres",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 44550,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 18, 2018",
    "Current Ver": "6.18.3",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "IMDb Movies & TV",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 501497,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Netflix",
    Category: "ENTERTAINMENT",
    Rating: 4.4,
    Reviews: 5456208,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Food Network",
    Category: "ENTERTAINMENT",
    Rating: 4.1,
    Reviews: 7813,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Cooking Channel",
    Category: "ENTERTAINMENT",
    Rating: 4.1,
    Reviews: 1033,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Animal Planet GO",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 2442,
    Size: "9.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 24, 2018",
    "Current Ver": "2.9.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "VRV: Anime, game videos & more",
    Category: "ENTERTAINMENT",
    Rating: 3.9,
    Reviews: 15254,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "DramaFever: Stream Asian Drama Shows & Movies",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 155234,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 1, 2018",
    "Current Ver": "01.01.66",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Crunchyroll - Everything Anime",
    Category: "ENTERTAINMENT",
    Rating: 3.7,
    Reviews: 310066,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "March 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Investigation Discovery GO",
    Category: "ENTERTAINMENT",
    Rating: 4.5,
    Reviews: 12216,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 24, 2018",
    "Current Ver": "2.9.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Crackle - Free TV & Movies",
    Category: "ENTERTAINMENT",
    Rating: 3.7,
    Reviews: 388089,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "April 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "CBS - Full Episodes & Live TV",
    Category: "ENTERTAINMENT",
    Rating: 3.8,
    Reviews: 92058,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 20, 2018",
    "Current Ver": "4.8.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "STARZ",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 88185,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "June 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Acorn TV: World-class TV from Britain and Beyond",
    Category: "ENTERTAINMENT",
    Rating: 3,
    Reviews: 493,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 15, 2018",
    "Current Ver": "2.0.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "HISTORY: Watch TV Show Full Episodes & Specials",
    Category: "ENTERTAINMENT",
    Rating: 4.1,
    Reviews: 33387,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 16, 2018",
    "Current Ver": "3.1.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Nick",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 123279,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "January 24, 2018",
    "Current Ver": "2.0.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "VH1",
    Category: "ENTERTAINMENT",
    Rating: 4.1,
    Reviews: 27424,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 8, 2018",
    "Current Ver": "11.45.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "FOX NOW - On Demand & Live TV",
    Category: "ENTERTAINMENT",
    Rating: 3.9,
    Reviews: 60841,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "A&E - Watch Full Episodes of TV Shows",
    Category: "ENTERTAINMENT",
    Rating: 4,
    Reviews: 29706,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 16, 2018",
    "Current Ver": "3.1.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "The CW",
    Category: "ENTERTAINMENT",
    Rating: 4.4,
    Reviews: 288150,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 23, 2018",
    "Current Ver": 2.17,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "BET NOW - Watch Shows",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 14807,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 8, 2018",
    "Current Ver": "11.45.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hulu: Stream TV, Movies & more",
    Category: "ENTERTAINMENT",
    Rating: 4,
    Reviews: 319692,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "HBO NOW: Stream TV & Movies",
    Category: "ENTERTAINMENT",
    Rating: 3.9,
    Reviews: 61201,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Univision NOW - Live TV and On Demand",
    Category: "ENTERTAINMENT",
    Rating: 4,
    Reviews: 22998,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 27, 2018",
    "Current Ver": 8.0626,
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "SHOWTIME",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 12398,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Lifetime - Watch Full Episodes & Original Movies",
    Category: "ENTERTAINMENT",
    Rating: 4,
    Reviews: 35928,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 16, 2018",
    "Current Ver": "3.1.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SeriesGuide – Show & Movie Manager",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 64448,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "July 21, 2018",
    "Current Ver": 43,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Comedy Central",
    Category: "ENTERTAINMENT",
    Rating: 3.9,
    Reviews: 22378,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 8, 2018",
    "Current Ver": "11.45.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "IMDb Movies & TV",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 501498,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Netflix",
    Category: "ENTERTAINMENT",
    Rating: 4.4,
    Reviews: 5456599,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Tubi TV - Free Movies & TV",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 296829,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 15, 2018",
    "Current Ver": "2.13.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Crunchyroll - Everything Anime",
    Category: "ENTERTAINMENT",
    Rating: 3.7,
    Reviews: 310095,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "March 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "STARZ",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 88185,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "June 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Crackle - Free TV & Movies",
    Category: "ENTERTAINMENT",
    Rating: 3.7,
    Reviews: 388089,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "April 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "CBS - Full Episodes & Live TV",
    Category: "ENTERTAINMENT",
    Rating: 3.8,
    Reviews: 92058,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 20, 2018",
    "Current Ver": "4.8.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Nick",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 123279,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "January 24, 2018",
    "Current Ver": "2.0.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Hulu: Stream TV, Movies & more",
    Category: "ENTERTAINMENT",
    Rating: 4,
    Reviews: 319691,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "FOX NOW - On Demand & Live TV",
    Category: "ENTERTAINMENT",
    Rating: 3.9,
    Reviews: 60841,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "The CW",
    Category: "ENTERTAINMENT",
    Rating: 4.4,
    Reviews: 288150,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 23, 2018",
    "Current Ver": 2.17,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "CW Seed",
    Category: "ENTERTAINMENT",
    Rating: 4.5,
    Reviews: 16372,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 18, 2018",
    "Current Ver": 1.16,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "The NBC App - Watch Live TV and Full Episodes",
    Category: "ENTERTAINMENT",
    Rating: 4.1,
    Reviews: 58028,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 5, 2018",
    "Current Ver": "4.18.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "HISTORY: Watch TV Show Full Episodes & Specials",
    Category: "ENTERTAINMENT",
    Rating: 4.1,
    Reviews: 33387,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 16, 2018",
    "Current Ver": "3.1.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "HBO NOW: Stream TV & Movies",
    Category: "ENTERTAINMENT",
    Rating: 3.9,
    Reviews: 61201,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "WWE",
    Category: "ENTERTAINMENT",
    Rating: 4.5,
    Reviews: 736864,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "January 19, 2018",
    "Current Ver": "3.17.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "A&E - Watch Full Episodes of TV Shows",
    Category: "ENTERTAINMENT",
    Rating: 4,
    Reviews: 29706,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 16, 2018",
    "Current Ver": "3.1.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "VH1",
    Category: "ENTERTAINMENT",
    Rating: 4.1,
    Reviews: 27424,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 8, 2018",
    "Current Ver": "11.45.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Universal Kids",
    Category: "ENTERTAINMENT",
    Rating: 3.6,
    Reviews: 1968,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "May 24, 2018",
    "Current Ver": "3.3.1.41",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "MTV",
    Category: "ENTERTAINMENT",
    Rating: 3.8,
    Reviews: 35279,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 8, 2018",
    "Current Ver": "11.45.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Lifetime - Watch Full Episodes & Original Movies",
    Category: "ENTERTAINMENT",
    Rating: 4,
    Reviews: 35931,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 16, 2018",
    "Current Ver": "3.1.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BET NOW - Watch Shows",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 14807,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 8, 2018",
    "Current Ver": "11.45.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "LEGO® TV",
    Category: "ENTERTAINMENT",
    Rating: 3.7,
    Reviews: 17247,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "August 4, 2018",
    "Current Ver": "4.0.2",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "HBO GO: Stream with TV Package",
    Category: "ENTERTAINMENT",
    Rating: 3.8,
    Reviews: 87723,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 19, 2018",
    "Current Ver": "16.0.0.437",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Showtime Anytime",
    Category: "ENTERTAINMENT",
    Rating: 3.7,
    Reviews: 18523,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "PlayKids - Educational cartoons and games for kids",
    Category: "ENTERTAINMENT",
    Rating: 4.1,
    Reviews: 182103,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "FOX",
    Category: "ENTERTAINMENT",
    Rating: 3.7,
    Reviews: 197774,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "June 25, 2018",
    "Current Ver": "6.6.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Telemundo Now",
    Category: "ENTERTAINMENT",
    Rating: 3.9,
    Reviews: 8674,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "May 25, 2018",
    "Current Ver": "3.3.1.42",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Netflix",
    Category: "ENTERTAINMENT",
    Rating: 4.4,
    Reviews: 5456708,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Tubi TV - Free Movies & TV",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 296771,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 15, 2018",
    "Current Ver": "2.13.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Vudu Movies & TV",
    Category: "ENTERTAINMENT",
    Rating: 3.9,
    Reviews: 58082,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Crackle - Free TV & Movies",
    Category: "ENTERTAINMENT",
    Rating: 3.7,
    Reviews: 388089,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "April 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Crunchyroll - Everything Anime",
    Category: "ENTERTAINMENT",
    Rating: 3.7,
    Reviews: 310066,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "March 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Nick",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 123279,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "January 24, 2018",
    "Current Ver": "2.0.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "STARZ",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 88185,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "June 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Hulu: Stream TV, Movies & more",
    Category: "ENTERTAINMENT",
    Rating: 4,
    Reviews: 319691,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Food Network",
    Category: "ENTERTAINMENT",
    Rating: 4.1,
    Reviews: 7813,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "FOX NOW - On Demand & Live TV",
    Category: "ENTERTAINMENT",
    Rating: 3.9,
    Reviews: 60841,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Movies by Flixster, with Rotten Tomatoes",
    Category: "ENTERTAINMENT",
    Rating: 4.5,
    Reviews: 653008,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 20, 2018",
    "Current Ver": "9.1.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Yidio: TV Show & Movie Guide",
    Category: "ENTERTAINMENT",
    Rating: 3.9,
    Reviews: 27424,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "HISTORY: Watch TV Show Full Episodes & Specials",
    Category: "ENTERTAINMENT",
    Rating: 4.1,
    Reviews: 33387,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 16, 2018",
    "Current Ver": "3.1.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Viki: Asian TV Dramas & Movies",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 407719,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "The CW",
    Category: "ENTERTAINMENT",
    Rating: 4.4,
    Reviews: 288150,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 23, 2018",
    "Current Ver": 2.17,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Redbox",
    Category: "ENTERTAINMENT",
    Rating: 4.1,
    Reviews: 115033,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 2, 2018",
    "Current Ver": "7.5.0",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Univision NOW - Live TV and On Demand",
    Category: "ENTERTAINMENT",
    Rating: 4,
    Reviews: 22997,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 27, 2018",
    "Current Ver": 8.0626,
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "HBO NOW: Stream TV & Movies",
    Category: "ENTERTAINMENT",
    Rating: 3.9,
    Reviews: 61201,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Tribeca Shortlist - Handpicked Movies",
    Category: "ENTERTAINMENT",
    Rating: 3.9,
    Reviews: 801,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "March 21, 2018",
    "Current Ver": "4.003.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "A&E - Watch Full Episodes of TV Shows",
    Category: "ENTERTAINMENT",
    Rating: 4,
    Reviews: 29706,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 16, 2018",
    "Current Ver": "3.1.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "VH1",
    Category: "ENTERTAINMENT",
    Rating: 4.1,
    Reviews: 27424,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 8, 2018",
    "Current Ver": "11.45.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SHOWTIME",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 12398,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "MTV",
    Category: "ENTERTAINMENT",
    Rating: 3.8,
    Reviews: 35279,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 8, 2018",
    "Current Ver": "11.45.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Lifetime - Watch Full Episodes & Original Movies",
    Category: "ENTERTAINMENT",
    Rating: 4,
    Reviews: 35931,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 16, 2018",
    "Current Ver": "3.1.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Comedy Central",
    Category: "ENTERTAINMENT",
    Rating: 3.9,
    Reviews: 22378,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 8, 2018",
    "Current Ver": "11.45.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BET NOW - Watch Shows",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 14807,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 8, 2018",
    "Current Ver": "11.45.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "FOX",
    Category: "ENTERTAINMENT",
    Rating: 3.7,
    Reviews: 197774,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "June 25, 2018",
    "Current Ver": "6.6.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Telemundo Now",
    Category: "ENTERTAINMENT",
    Rating: 3.9,
    Reviews: 8674,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "May 25, 2018",
    "Current Ver": "3.3.1.42",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Nick Jr. - Shows & Games",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 8968,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "January 23, 2018",
    "Current Ver": "1.0.20",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Sticker Market: Emoji keyboard",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 303,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "December 14, 2017",
    "Current Ver": "1.2.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Viki: Asian TV Dramas & Movies",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 407719,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Kidjo TV Kids Have Fun & Learn",
    Category: "ENTERTAINMENT",
    Rating: 4.6,
    Reviews: 732,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Laugh Out Loud by Kevin Hart",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 1856,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.6.1",
    numInstall: 100000,
    numAndroid: 6,
  },
  {
    App: "ColorFul - Adult Coloring Book",
    Category: "ENTERTAINMENT",
    Rating: 4.6,
    Reviews: 50725,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.0.64",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Nick",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 123279,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "January 24, 2018",
    "Current Ver": "2.0.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Fandango Movies - Times + Tickets",
    Category: "ENTERTAINMENT",
    Rating: 4.6,
    Reviews: 243747,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Hamilton — The Official App",
    Category: "ENTERTAINMENT",
    Rating: 4.5,
    Reviews: 1575,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 13, 2018",
    "Current Ver": "2.3.2",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "My Talking Pet",
    Category: "ENTERTAINMENT",
    Rating: 4.6,
    Reviews: 6238,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Funny Pics",
    Category: "ENTERTAINMENT",
    Rating: 3.9,
    Reviews: 9941,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 7, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Funny Quotes Free",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 23666,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "May 4, 2018",
    "Current Ver": 8.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "LOL Pics (Funny Pictures)",
    Category: "ENTERTAINMENT",
    Rating: 4.4,
    Reviews: 67554,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "September 15, 2015",
    "Current Ver": 4,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Meme Creator",
    Category: "ENTERTAINMENT",
    Rating: 4.2,
    Reviews: 38769,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "September 22, 2015",
    "Current Ver": "7.2.3",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Imgur: Find funny GIFs, memes & watch viral videos",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 160164,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.2.0.8447",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Meme Generator",
    Category: "ENTERTAINMENT",
    Rating: 4.6,
    Reviews: 3771,
    Size: "53M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "August 3, 2018",
    "Current Ver": 4.426,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "SketchBook - draw and paint",
    Category: "ENTERTAINMENT",
    Rating: 4.3,
    Reviews: 256664,
    Size: "77M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 4, 2018",
    "Current Ver": "4.1.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Colorfy: Coloring Book for Adults - Free",
    Category: "ENTERTAINMENT",
    Rating: 4.5,
    Reviews: 787177,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "All Events in City",
    Category: "EVENTS",
    Rating: 4,
    Reviews: 3782,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "June 12, 2018",
    "Current Ver": 8.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Ticketmaster Event Tickets",
    Category: "EVENTS",
    Rating: 4,
    Reviews: 40113,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Reminder",
    Category: "EVENTS",
    Rating: 4.5,
    Reviews: 7074,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "June 25, 2018",
    "Current Ver": 1.57,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Birdays - Birthday reminder",
    Category: "EVENTS",
    Rating: 4.5,
    Reviews: 2153,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "December 14, 2017",
    "Current Ver": "1.5.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "StubHub - Tickets to Sports, Concerts & Events",
    Category: "EVENTS",
    Rating: 4,
    Reviews: 26089,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.2.1",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Fever",
    Category: "EVENTS",
    Rating: 4,
    Reviews: 20611,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Events",
    "Last Updated": "July 18, 2018",
    "Current Ver": "4.3.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "DroidAdmin for Android - Advice",
    Category: "EVENTS",
    Rating: 4.2,
    Reviews: 811,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "May 29, 2018",
    "Current Ver": 3.8,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "SeatGeek – Tickets to Sports, Concerts, Broadway",
    Category: "EVENTS",
    Rating: 4.4,
    Reviews: 15558,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2018.07.31229",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "my4D",
    Category: "EVENTS",
    Rating: 4.6,
    Reviews: 573,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "July 12, 2018",
    "Current Ver": 1.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "VAN NIAN 2018 - Vietnamese Calendar",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 37,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "November 27, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Vivid Seats – Event Tickets",
    Category: "EVENTS",
    Rating: 4.6,
    Reviews: 8232,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Name days",
    Category: "EVENTS",
    Rating: 4.1,
    Reviews: 3089,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "July 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "LBB - Find New & Unique Things To Do Around You",
    Category: "EVENTS",
    Rating: 4.6,
    Reviews: 3874,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "July 27, 2018",
    "Current Ver": "4.0.19",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Happy Birthday Songs Offline",
    Category: "EVENTS",
    Rating: 4.4,
    Reviews: 464,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "December 4, 2017",
    "Current Ver": 1.3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Series Valley of the Wolves full of part",
    Category: "EVENTS",
    Rating: 4.6,
    Reviews: 731,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "December 24, 2017",
    "Current Ver": 2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Mummatikabalkuragi",
    Category: "EVENTS",
    Rating: 4.9,
    Reviews: 69,
    Size: "334k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Events",
    "Last Updated": "July 22, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Gametime - Tickets to Sports, Concerts, Theater",
    Category: "EVENTS",
    Rating: 4.5,
    Reviews: 8800,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "July 17, 2018",
    "Current Ver": "11.1.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "PTI Flex Maker, Photo Frame Editor & Songs 2018",
    Category: "EVENTS",
    Rating: 4.6,
    Reviews: 99,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "July 6, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Wipe out",
    Category: "EVENTS",
    Rating: 4.7,
    Reviews: 30,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Events",
    "Last Updated": "May 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500,
    numAndroid: null,
  },
  {
    App: "Birthdays & Other Events",
    Category: "EVENTS",
    Rating: 4.3,
    Reviews: 456,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "June 21, 2018",
    "Current Ver": 1.75,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Sarajevo Film Festival - Official",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 6,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Events",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Summer Madness",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 4,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1.107,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Events High - Meet Your City!",
    Category: "EVENTS",
    Rating: 4.2,
    Reviews: 3200,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Events",
    "Last Updated": "June 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "vide-greniers.org",
    Category: "EVENTS",
    Rating: 4.3,
    Reviews: 5839,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "November 8, 2016",
    "Current Ver": "16.11.8",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "SUMMER SONIC app",
    Category: "EVENTS",
    Rating: 5,
    Reviews: 4,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "July 24, 2018",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Quake & Volcanoes: 3D Globe of Volcanic Eruptions",
    Category: "EVENTS",
    Rating: 4.4,
    Reviews: 663,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "October 14, 2017",
    "Current Ver": "1.1.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Prosperity",
    Category: "EVENTS",
    Rating: 5,
    Reviews: 16,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "July 9, 2018",
    "Current Ver": 1.14,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Picktrainer: India's largest photo contest app",
    Category: "EVENTS",
    Rating: 4.5,
    Reviews: 1065,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "May 31, 2018",
    "Current Ver": "1.3.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AAS-IN-ASIA 2018",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 3,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "July 4, 2018",
    "Current Ver": "1.1.9",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Moot Peru 2018",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 13,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "June 28, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "FM News",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 46,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "July 4, 2018",
    "Current Ver": 1.4,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Goldstar: Live Event Tickets",
    Category: "EVENTS",
    Rating: 4.5,
    Reviews: 1953,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Events",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Emmabodafestivalen",
    Category: "EVENTS",
    Rating: 4.8,
    Reviews: 12,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Events",
    "Last Updated": "June 28, 2018",
    "Current Ver": 42,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "KudaGo - things to do in NY",
    Category: "EVENTS",
    Rating: 4.4,
    Reviews: 4298,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "April 27, 2017",
    "Current Ver": "2.2.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Mindvalley U Tallinn 2018",
    Category: "EVENTS",
    Rating: 5,
    Reviews: 1,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.0.5",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Rockmaraton Info",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 49,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "July 8, 2018",
    "Current Ver": 18.4,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Freitas Auctioneer Official",
    Category: "EVENTS",
    Rating: 3.7,
    Reviews: 100,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "December 15, 2017",
    "Current Ver": "1.0.11",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "mobLee Events",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 11,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "May 30, 2018",
    "Current Ver": "3.05.30.16",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Xceed - Clubs, DJs, Festivals & Tickets",
    Category: "EVENTS",
    Rating: 4.1,
    Reviews: 399,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Cannonau 3.11.11",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "AMM Events & CPD",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 5,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.0.5",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Arab Halls - For Wedding & Events",
    Category: "EVENTS",
    Rating: 4.8,
    Reviews: 28,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "May 20, 2018",
    "Current Ver": "8.0bld14",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "MeAuDote - An act of love that saves a life",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 250,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "June 22, 2018",
    "Current Ver": "1.0.11",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "TCF National Conference",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 1,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "July 11, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Endurance Lifestyle",
    Category: "EVENTS",
    Rating: 4.6,
    Reviews: 7,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Events",
    "Last Updated": "July 10, 2017",
    "Current Ver": 2.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "K PLUS",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 124424,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 26, 2018",
    "Current Ver": "4.6.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ING Banking",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 39041,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Citibanamex Movil",
    Category: "FINANCE",
    Rating: 3.6,
    Reviews: 52306,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 27, 2018",
    "Current Ver": "20.1.0",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "The postal bank",
    Category: "FINANCE",
    Rating: 3.7,
    Reviews: 36718,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "KTB Netbank",
    Category: "FINANCE",
    Rating: 3.8,
    Reviews: 42644,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 28, 2018",
    "Current Ver": 8.18,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Mobile Bancomer",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 278082,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 30, 2018",
    "Current Ver": 10.78,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Nedbank Money",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 6076,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 28, 2018",
    "Current Ver": "4.1.1-0-prod",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "SCB EASY",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 112656,
    Size: "93M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 19, 2018",
    "Current Ver": "3.9.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "CASHIER",
    Category: "FINANCE",
    Rating: 3.3,
    Reviews: 335738,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Rabo Banking",
    Category: "FINANCE",
    Rating: 3.4,
    Reviews: 31906,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 19, 2018",
    "Current Ver": "5.16.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Capitec Remote Banking",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 20672,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 8, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Itau bank",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 957973,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 30, 2018",
    "Current Ver": "6.5.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Nubank",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 130582,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "The Societe Generale App",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 31218,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "IKO",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 167168,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 4, 2018",
    "Current Ver": "3.115.27",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Cash App",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 34428,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.31.1",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Standard Bank / Stanbic Bank",
    Category: "FINANCE",
    Rating: 3.6,
    Reviews: 15247,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 13, 2018",
    "Current Ver": "3.0.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Bualuang mBanking",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 48445,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 16, 2018",
    "Current Ver": "2.6.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Intesa Sanpaolo Mobile",
    Category: "FINANCE",
    Rating: 3.6,
    Reviews: 35518,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "UBA Mobile Banking",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 12185,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 8, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "BBVA Spain",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 36746,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "MyMo by GSB",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 21996,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.17.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "VTB-Online",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 138371,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Ecobank Mobile Banking",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 12073,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 25, 2018",
    "Current Ver": 3.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Banorte Movil",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 111632,
    Size: "65M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 9, 2018",
    "Current Ver": "5.10.1.40699",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Wells Fargo Mobile",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 250706,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "6.8.0.109",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Credit Karma",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 706301,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "BZWBK24 mobile",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 64959,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 18, 2018",
    "Current Ver": "5.0.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "PayPal",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 659741,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 18, 2018",
    "Current Ver": "6.28.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Capital One® Mobile",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 510392,
    Size: "79M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.38.1",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Zenith Bank Mobile App",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 7215,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.7.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "GCash - Buy Load, Pay Bills, Send Money",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 25508,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Post Bank",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 60449,
    Size: "100M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.9.12",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "İşCep",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 381788,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.22.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "People's Bank",
    Category: "FINANCE",
    Rating: 3.6,
    Reviews: 10697,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 18, 2018",
    "Current Ver": "3.22.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Google Pay",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 347838,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.70.206190089",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Transfer",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 31804,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 27, 2018",
    "Current Ver": "3.1.6.12",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "T-Mobile in",
    Category: "FINANCE",
    Rating: 3.5,
    Reviews: 3856,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.2.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "TrueMoney Wallet",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 199684,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Alfa-Bank (Alfa-Bank)",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 44545,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Bank of Brazil",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 1336246,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 3, 2018",
    "Current Ver": "6.39.1.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "WiseBanyan - Invest For Free",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 257,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.2.12",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Robinhood - Investing, No Fees",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 57493,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Wells Fargo Daily Change",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 283,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 26, 2018",
    "Current Ver": "2.5.0.26",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Even - organize your money, get paid early",
    Category: "FINANCE",
    Rating: 4.8,
    Reviews: 12304,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 2, 2018",
    "Current Ver": "6.0.16",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Digit Save Money Automatically",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 8188,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.29.01",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Stash: Invest. Learn. Save.",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 11919,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.13.2.11",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Acorns - Invest Spare Change",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 45957,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Google Pay",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 347838,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.70.206190089",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Money Lover: Expense Tracker, Budget Planner",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 126431,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Expense IQ Money Manager",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 21570,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 19, 2018",
    "Current Ver": "2.0.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Money Manager Expense & Budget",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 134564,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Wells Fargo Daily Change",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 283,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 26, 2018",
    "Current Ver": "2.5.0.26",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Prism Pay Bills, Track Money, Personal Finance",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 16961,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 4, 2018",
    "Current Ver": "2.12.100",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Monefy - Money Manager",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 111254,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.8.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Simple - Better Banking",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 7731,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.53.2",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Chime - Mobile Banking",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 5928,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 22, 2018",
    "Current Ver": "5.1.1",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Bluebird by American Express",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 15703,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Walmart MoneyCard",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 6148,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 1, 2018",
    "Current Ver": "1.14.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Moven - Smart Finances",
    Category: "FINANCE",
    Rating: 3.8,
    Reviews: 861,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 29, 2018",
    "Current Ver": "3.3.9",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Qapital - Save Small. Live Large",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 8662,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.5.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Experian - Free Credit Report",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 23130,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 12, 2018",
    "Current Ver": "2.1.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Branch",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 69973,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.17.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "WalletHub - Free Credit Score, Report & Monitoring",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 1311,
    Size: "9.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 19, 2018",
    "Current Ver": "1.4.11",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "CreditWise from Capital One",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 26587,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.18.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "NerdWallet: Personal Finance, Credit Score & Cash",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 2417,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.5.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Credit Karma",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 706302,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "my face",
    Category: "FINANCE",
    Rating: 3.8,
    Reviews: 1054,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 10, 2018",
    "Current Ver": "2.3.0",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Credit Sesame",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 25166,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 25, 2018",
    "Current Ver": "3.1.16",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Mint: Budget, Bills, Finance",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 129304,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Fresh EBT - Food Stamp Balance",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 19870,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 24, 2018",
    "Current Ver": "2.9.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hurdlr: Track Mileage, Expenses, and Log Receipts",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 3596,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 20, 2018",
    "Current Ver": 16.6,
    numInstall: 100000,
    numAndroid: 6,
  },
  {
    App: "Mobills: Budget Planner",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 161440,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.2.18.07.30",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Everlance: Free Mileage Log",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 7514,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.9.9.9.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "MileIQ - Free Mileage Tracker for Business",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 46106,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.28.0.5402",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "QuickBooks Self-Employed:Mileage Tracker and Taxes",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 15141,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 24, 2018",
    "Current Ver": 4.63,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "FREE Stock Market Trading Tips",
    Category: "FINANCE",
    Rating: 3.9,
    Reviews: 714,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 7, 2017",
    "Current Ver": "2.10.3",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "MetaTrader 5",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 42410,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "MetaTrader 4",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 260547,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Stock Quote",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 4344,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 30, 2018",
    "Current Ver": "3.6.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Seeking Alpha",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 22808,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Stock Trainer: Virtual Trading (Stock Markets)",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 42809,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 27, 2018",
    "Current Ver": "3.04 - Beta",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Stocks: Realtime Quotes Charts",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 16808,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Stocks, Forex, Bitcoin, Ethereum: Portfolio & News",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 157505,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "CNBC: Breaking Business News & Live Market Data",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 24647,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "US Stock Market",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 1922,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 1, 2018",
    "Current Ver": 1.28,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Bloomberg Professional",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 3334,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "E*TRADE Mobile",
    Category: "FINANCE",
    Rating: 3.9,
    Reviews: 10658,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 2, 2018",
    "Current Ver": "6.8.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Robinhood - Investing, No Fees",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 57493,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "MSN Money- Stock Quotes & News",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 78361,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.2.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fox Business",
    Category: "FINANCE",
    Rating: 3.7,
    Reviews: 2594,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "NSE Mobile Trading",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 13868,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 3, 2017",
    "Current Ver": "1.1.16",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Yahoo Finance",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 135952,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "JStock - Stock Market, Portfolio & News",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 11066,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.1.39",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Digit Save Money Automatically",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 8188,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.29.01",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Acorns - Invest Spare Change",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 45962,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Webull - Stock Quotes & Free Stock Trading",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 34861,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Trading 212 - Forex, Stocks, CFDs",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 37580,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.5.2.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Moneycontrol – Stocks, Sensex, Mutual Funds, IPO",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 281485,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Current debit card and app made for teens",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 685,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.0.22",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Money Lover: Expense Tracker, Budget Planner",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 126447,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Mint: Budget, Bills, Finance",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 129304,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Betterment",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 3780,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 3, 2018",
    "Current Ver": "6.0.6",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Citizens Bank Mobile Banking",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 15192,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 23, 2018",
    "Current Ver": "4.2.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "GoBank",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 5950,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 1, 2018",
    "Current Ver": 2.131,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "NetSpend Prepaid",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 15993,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 9, 2018",
    "Current Ver": "4.10.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BBVA Compass Banking",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 5905,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 27, 2018",
    "Current Ver": "6.0.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Simple - Better Banking",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 7731,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.53.2",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "PayPal",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 659760,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 18, 2018",
    "Current Ver": "6.28.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "BankMobile Vibe App",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 14627,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 9, 2018",
    "Current Ver": 5.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Netspend Skylight ONE",
    Category: "FINANCE",
    Rating: 3.9,
    Reviews: 1098,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 9, 2018",
    "Current Ver": "4.10.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ACE Elite",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 2898,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 9, 2018",
    "Current Ver": "4.10.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "U.S. Bank",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 70782,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 25, 2018",
    "Current Ver": "2.34.29",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Huntington Mobile",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 11264,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 26, 2018",
    "Current Ver": "5.2.203",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "USAA Mobile",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 100997,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 27, 2018",
    "Current Ver": "8.44.2",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Google Pay",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 347874,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.70.206190089",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Associated Credit Union Mobile",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 3290,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 30, 2018",
    "Current Ver": "5.9.1.0",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "Bank of America Mobile Banking",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 341090,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "7.8.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "USE Credit Union Mobile",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 964,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 12, 2018",
    "Current Ver": "5.9.1.0",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Discover Mobile",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 87951,
    Size: "68M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 23, 2018",
    "Current Ver": "9.7.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Wells Fargo Mobile",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 250719,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "6.8.0.109",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Capital One® Mobile",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 510401,
    Size: "79M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.38.1",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Amex Mobile",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 24729,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 3, 2018",
    "Current Ver": "6.7.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Citi Mobile®",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 78306,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "9.9.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Navy Federal Credit Union",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 43313,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 9, 2018",
    "Current Ver": "5.16.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Chase Mobile",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 1374549,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 23, 2018",
    "Current Ver": 3.52,
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "HDFC Bank MobileBanking",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 208463,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Barclays US for Android",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 6998,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 1, 2018",
    "Current Ver": "6.29.37589",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "McDonald's",
    Category: "FOOD_AND_DRINK",
    Rating: 3.6,
    Reviews: 145323,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 31, 2018",
    "Current Ver": "5.15.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Easy and Fast Recipes",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 95,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "January 6, 2018",
    "Current Ver": "3.0.1",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Cookpad - FREE recipe search makes fun cooking · musical making!",
    Category: "FOOD_AND_DRINK",
    Rating: 4.1,
    Reviews: 64784,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 2, 2018",
    "Current Ver": "18.6.0.10",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "DELISH KITCHEN - FREE recipe movies make food fun and easy!",
    Category: "FOOD_AND_DRINK",
    Rating: 4.6,
    Reviews: 32997,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 4, 2018",
    "Current Ver": "2.2.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Sumine side dish - dish recipe side dish",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 82,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "June 23, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Easy Recipes",
    Category: "FOOD_AND_DRINK",
    Rating: 4.7,
    Reviews: 2707,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "May 15, 2018",
    "Current Ver": 2.12,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Delicious Recipes",
    Category: "FOOD_AND_DRINK",
    Rating: 4.7,
    Reviews: 129737,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Food & Drink",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Tastely",
    Category: "FOOD_AND_DRINK",
    Rating: 4.7,
    Reviews: 611136,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 13, 2018",
    "Current Ver": "3.2.0d",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Pastry & Cooking (Without Net)",
    Category: "FOOD_AND_DRINK",
    Rating: 4.7,
    Reviews: 6118,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Frigo Magic: Easy recipe idea and anti-waste",
    Category: "FOOD_AND_DRINK",
    Rating: 4.1,
    Reviews: 2473,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 28, 2018",
    "Current Ver": "3.1.5",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "McDonald's - McDonald's Japan",
    Category: "FOOD_AND_DRINK",
    Rating: 3.4,
    Reviews: 109784,
    Size: "64M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.0.30",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Debonairs Pizza",
    Category: "FOOD_AND_DRINK",
    Rating: 3.8,
    Reviews: 3320,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.9.117",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Popeyes® App",
    Category: "FOOD_AND_DRINK",
    Rating: 3.7,
    Reviews: 61,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.0.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Dunkin' Donuts",
    Category: "FOOD_AND_DRINK",
    Rating: 4.2,
    Reviews: 68103,
    Size: "66M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "June 20, 2018",
    "Current Ver": "5.0.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Pyaterochka",
    Category: "FOOD_AND_DRINK",
    Rating: 3.1,
    Reviews: 8412,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Refreshing app Free application that can use deal coupons",
    Category: "FOOD_AND_DRINK",
    Rating: 3.5,
    Reviews: 10741,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 23, 2018",
    "Current Ver": "5.2.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Simple Recipes",
    Category: "FOOD_AND_DRINK",
    Rating: 4.7,
    Reviews: 3803,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "February 22, 2018",
    "Current Ver": 1.6,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Grubhub: Food Delivery",
    Category: "FOOD_AND_DRINK",
    Rating: 4.5,
    Reviews: 155944,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 2, 2018",
    "Current Ver": 7.12,
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Panera Bread",
    Category: "FOOD_AND_DRINK",
    Rating: 4.2,
    Reviews: 10159,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 17, 2018",
    "Current Ver": "4.3.3",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Chick-fil-A",
    Category: "FOOD_AND_DRINK",
    Rating: 4.3,
    Reviews: 28008,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 3, 2018",
    "Current Ver": "6.0.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "hellofood - Food Delivery",
    Category: "FOOD_AND_DRINK",
    Rating: 4,
    Reviews: 43614,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "October 12, 2016",
    "Current Ver": "2.14.36",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Starbucks",
    Category: "FOOD_AND_DRINK",
    Rating: 4.5,
    Reviews: 455377,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.11.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Easy and quick desserts",
    Category: "FOOD_AND_DRINK",
    Rating: 4.6,
    Reviews: 1398,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Food & Drink",
    "Last Updated": "June 14, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Domino's Pizza USA",
    Category: "FOOD_AND_DRINK",
    Rating: 4.7,
    Reviews: 1032935,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Chef - Recipes & Cooking",
    Category: "FOOD_AND_DRINK",
    Rating: 4.1,
    Reviews: 32405,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 3, 2018",
    "Current Ver": "3.3.21",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Delivery Club-food delivery: pizza, sushi, burger, salad",
    Category: "FOOD_AND_DRINK",
    Rating: 4.3,
    Reviews: 151080,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "HungerStation",
    Category: "FOOD_AND_DRINK",
    Rating: 3.8,
    Reviews: 22513,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "May 21, 2018",
    "Current Ver": "5.3.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Delivery yogi.",
    Category: "FOOD_AND_DRINK",
    Rating: 4.4,
    Reviews: 90042,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Delivery trough - delivery trough delivery trough",
    Category: "FOOD_AND_DRINK",
    Rating: 4.3,
    Reviews: 58316,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Dr. Oetker recipe ideas",
    Category: "FOOD_AND_DRINK",
    Rating: 4.2,
    Reviews: 8509,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 12, 2018",
    "Current Ver": "3.5.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SONIC Drive-In",
    Category: "FOOD_AND_DRINK",
    Rating: 4.3,
    Reviews: 19314,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.3.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SUBWAY®",
    Category: "FOOD_AND_DRINK",
    Rating: 3.8,
    Reviews: 21314,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 24, 2018",
    "Current Ver": "7.9.0.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "GialloZafferano: Recipes",
    Category: "FOOD_AND_DRINK",
    Rating: 4.3,
    Reviews: 30224,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "May 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Dairy Queen",
    Category: "FOOD_AND_DRINK",
    Rating: 3.7,
    Reviews: 731,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 25, 2018",
    "Current Ver": "2.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "9th stage",
    Category: "FOOD_AND_DRINK",
    Rating: 4.5,
    Reviews: 454,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "March 28, 2018",
    "Current Ver": "2.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "OpenRice",
    Category: "FOOD_AND_DRINK",
    Rating: 3.6,
    Reviews: 14952,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "June 8, 2018",
    "Current Ver": "5.8.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SarashpazPapion (Cooking with Chef Bowls)",
    Category: "FOOD_AND_DRINK",
    Rating: 4.8,
    Reviews: 1250,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 28, 2018",
    "Current Ver": "3.2.7",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Little Caesars",
    Category: "FOOD_AND_DRINK",
    Rating: 3.3,
    Reviews: 1726,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 19, 2018",
    "Current Ver": 4.26,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Recipes Pastries and homemade pies More than 500 recipes for pastries",
    Category: "FOOD_AND_DRINK",
    Rating: 4.7,
    Reviews: 14065,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "June 12, 2018",
    "Current Ver": "1.2.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Om Waleed Sweets",
    Category: "FOOD_AND_DRINK",
    Rating: 4.6,
    Reviews: 556,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Food & Drink",
    "Last Updated": "January 25, 2018",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: 'Eat Fast Prepare "Without Internet"',
    Category: "FOOD_AND_DRINK",
    Rating: 4.6,
    Reviews: 4925,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "June 10, 2018",
    "Current Ver": "3.6.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Wendy’s – Food and Offers",
    Category: "FOOD_AND_DRINK",
    Rating: 3.4,
    Reviews: 6507,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "April 12, 2018",
    "Current Ver": "5.7.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "My Recipes Cookbook : RecetteTek",
    Category: "FOOD_AND_DRINK",
    Rating: 4.6,
    Reviews: 11707,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "June 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Healthy Recipes Free",
    Category: "FOOD_AND_DRINK",
    Rating: 4,
    Reviews: 1077,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "October 18, 2017",
    "Current Ver": "3.2.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Cookbook Recipes",
    Category: "FOOD_AND_DRINK",
    Rating: 4.1,
    Reviews: 46539,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Food & Drink",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "ChefTap Recipes & Grocery List",
    Category: "FOOD_AND_DRINK",
    Rating: 4.5,
    Reviews: 9066,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "April 25, 2018",
    "Current Ver": "4.0.0.427",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Recipe Keeper",
    Category: "FOOD_AND_DRINK",
    Rating: 4.4,
    Reviews: 1962,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "June 27, 2018",
    "Current Ver": "3.17.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "My CookBook (Recipe Manager)",
    Category: "FOOD_AND_DRINK",
    Rating: 4.5,
    Reviews: 22071,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "June 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "50 Healthy Slow Cooker Recipes",
    Category: "FOOD_AND_DRINK",
    Rating: 4,
    Reviews: 196,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Food & Drink",
    "Last Updated": "February 17, 2017",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Easy Healthy Recipes",
    Category: "FOOD_AND_DRINK",
    Rating: 4.1,
    Reviews: 278,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 20, 2018",
    "Current Ver": "24.5.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Allrecipes Dinner Spinner",
    Category: "FOOD_AND_DRINK",
    Rating: 4.5,
    Reviews: 61881,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "April 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "My CookBook Pro (Ad Free)",
    Category: "FOOD_AND_DRINK",
    Rating: 4.6,
    Reviews: 2129,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$3.49",
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "June 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "Paprika Recipe Manager",
    Category: "FOOD_AND_DRINK",
    Rating: 4.1,
    Reviews: 1268,
    Size: "2.3M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "June 3, 2018",
    "Current Ver": "1.4.4",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Yummly Recipes & Shopping List",
    Category: "FOOD_AND_DRINK",
    Rating: 4.5,
    Reviews: 91359,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 5, 2018",
    "Current Ver": "2.0.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Kitchen Stories - Recipes & Cooking",
    Category: "FOOD_AND_DRINK",
    Rating: 4.6,
    Reviews: 22015,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Cookpad",
    Category: "FOOD_AND_DRINK",
    Rating: 4.5,
    Reviews: 131569,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.76.2.0-android",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "BigOven Recipes, Meal Planner, Grocery List & More",
    Category: "FOOD_AND_DRINK",
    Rating: 4.3,
    Reviews: 31986,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Food & Drink",
    "Last Updated": "November 23, 2017",
    "Current Ver": "5.7.23",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Postmates Food Delivery: Order Eats & Alcohol",
    Category: "FOOD_AND_DRINK",
    Rating: 3.6,
    Reviews: 22875,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 27, 2018",
    "Current Ver": "4.2.6",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Instacart: Grocery Delivery",
    Category: "FOOD_AND_DRINK",
    Rating: 4.4,
    Reviews: 17071,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "OpenTable: Restaurants Near Me",
    Category: "FOOD_AND_DRINK",
    Rating: 4.6,
    Reviews: 90242,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 31, 2018",
    "Current Ver": "9.15.0.2020",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Foursquare City Guide",
    Category: "FOOD_AND_DRINK",
    Rating: 4.1,
    Reviews: 483960,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Food & Drink",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Zomato - Restaurant Finder and Food Delivery App",
    Category: "FOOD_AND_DRINK",
    Rating: 4.3,
    Reviews: 511228,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Munchery: Chef Crafted Fresh Food Delivered",
    Category: "FOOD_AND_DRINK",
    Rating: 3.9,
    Reviews: 464,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "May 22, 2018",
    "Current Ver": "2.6.15",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Grubhub: Food Delivery",
    Category: "FOOD_AND_DRINK",
    Rating: 4.5,
    Reviews: 155944,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 2, 2018",
    "Current Ver": 7.12,
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "delivery.com: Order Food, Alcohol & Laundry",
    Category: "FOOD_AND_DRINK",
    Rating: 4.1,
    Reviews: 1920,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Postmates Food Delivery: Order Eats & Alcohol",
    Category: "FOOD_AND_DRINK",
    Rating: 3.6,
    Reviews: 22875,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 27, 2018",
    "Current Ver": "4.2.6",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Domino's Pizza USA",
    Category: "FOOD_AND_DRINK",
    Rating: 4.7,
    Reviews: 1032935,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Eat24 Food Delivery & Takeout",
    Category: "FOOD_AND_DRINK",
    Rating: 4.3,
    Reviews: 40116,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "BeyondMenu Food Delivery",
    Category: "FOOD_AND_DRINK",
    Rating: 4.7,
    Reviews: 51517,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "EatStreet Food Delivery App",
    Category: "FOOD_AND_DRINK",
    Rating: 4.6,
    Reviews: 7690,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 3, 2018",
    "Current Ver": "3.1.14",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Pizza Hut",
    Category: "FOOD_AND_DRINK",
    Rating: 4.4,
    Reviews: 321134,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "June 12, 2018",
    "Current Ver": "4.7.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Caviar - Food Delivery",
    Category: "FOOD_AND_DRINK",
    Rating: 4.2,
    Reviews: 3755,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.4.11",
    numInstall: 100000,
    numAndroid: 6,
  },
  {
    App: "DoorDash - Food Delivery",
    Category: "FOOD_AND_DRINK",
    Rating: 4.5,
    Reviews: 104504,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Chick-fil-A",
    Category: "FOOD_AND_DRINK",
    Rating: 4.3,
    Reviews: 28009,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 3, 2018",
    "Current Ver": "6.0.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Uber Eats: Local Food Delivery",
    Category: "FOOD_AND_DRINK",
    Rating: 4.2,
    Reviews: 333208,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.161.10002",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Seamless Food Delivery/Takeout",
    Category: "FOOD_AND_DRINK",
    Rating: 4.5,
    Reviews: 35218,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 2, 2018",
    "Current Ver": 7.12,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Talabat: Food Delivery",
    Category: "FOOD_AND_DRINK",
    Rating: 4.5,
    Reviews: 116403,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "TheFork - Restaurants booking and special offers",
    Category: "FOOD_AND_DRINK",
    Rating: 4.3,
    Reviews: 37517,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 20, 2018",
    "Current Ver": "11.11.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "foodpanda - Local Food Delivery",
    Category: "FOOD_AND_DRINK",
    Rating: 4,
    Reviews: 292969,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 30, 2018",
    "Current Ver": "4.11.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Zomato - Restaurant Finder and Food Delivery App",
    Category: "FOOD_AND_DRINK",
    Rating: 4.3,
    Reviews: 511420,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Home Workout - No Equipment",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 428156,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Step Counter - Calorie Counter",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4,
    Reviews: 1577,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 12, 2017",
    "Current Ver": "1.0.7",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Lose Belly Fat in 30 Days - Flat Stomach",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.9,
    Reviews: 38098,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 21, 2018",
    "Current Ver": "1.0.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Pedometer - Step Counter Free & Calorie Burner",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 31139,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.0.11",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Six Pack in 30 Days - Abs Workout",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.9,
    Reviews: 272337,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 21, 2018",
    "Current Ver": "1.0.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Lose Weight in 30 Days",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 220125,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.0.14",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Pedometer",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 400592,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 4, 2018",
    "Current Ver": 5.23,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "LG Health",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.3,
    Reviews: 20098,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "May 14, 2018",
    "Current Ver": "5.31.75",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Step Counter - Pedometer Free & Calorie Counter",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.7,
    Reviews: 117925,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.0.26",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Pedometer, Step Counter & Weight Loss Tracker App",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 548021,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 2, 2018",
    "Current Ver": "p5.7.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Sportractive GPS Running Cycling Distance Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 48276,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 4, 2018",
    "Current Ver": "3.0.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "30 Day Fitness Challenge - Workout at Home",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 471036,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Home Workout for Men - Bodybuilding",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 12705,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 10, 2018",
    "Current Ver": "1.0.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fat Burning Workout - Home Weight lose",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 706,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.0.5",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Buttocks and Abdomen",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 465,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 7, 2018",
    "Current Ver": 1.08,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Walking for Weight Loss - Walk Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 644,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.0.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Running & Jogging",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 6238,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.1.22",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Walk with Map My Walk",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 144040,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 27, 2018",
    "Current Ver": "18.7.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Sleep Sounds",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 51227,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 13, 2018",
    "Current Ver": "4.0.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fitbit",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.9,
    Reviews: 357417,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Lose Belly Fat-Home Abs Fitness Workout",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 199,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.0.7",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Runtastic Running App & Mile Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 827597,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Cycling - Bike Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 9116,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.1.22",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Abs Training-Burn belly fat",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.7,
    Reviews: 2071,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.0.12",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Calorie Counter - EasyFit free",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.7,
    Reviews: 50294,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "3.0.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Nike+ Run Club",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 708674,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 12, 2018",
    "Current Ver": "2.17.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Aunjai i lert u",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.2,
    Reviews: 1140,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "January 10, 2017",
    "Current Ver": 1.5,
    numInstall: 500000,
    numAndroid: 3,
  },
  {
    App: "Garmin Connect™",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.9,
    Reviews: 232153,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "BetterMe: Weight Loss Workouts",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.2,
    Reviews: 14709,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.8.2",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Bike Computer - GPS Cycling Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 12029,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 4, 2018",
    "Current Ver": 2.6,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Calorie Counter - MyFitnessPal",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 1873516,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Six Packs for Man–Body Building with No Equipment",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 2880,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.0.8",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Weight Watchers Mobile",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.2,
    Reviews: 270267,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 31, 2018",
    "Current Ver": "6.15.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Endomondo - Running & Walking",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 559186,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Running Distance Tracker +",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.7,
    Reviews: 77777,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 29, 2018",
    "Current Ver": 3.401,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "The TK-App - everything under control",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 8642,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 2, 2018",
    "Current Ver": 1.2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Runkeeper - GPS Track Run Walk",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 501144,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Walking: Pedometer diet",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.7,
    Reviews: 1861,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 18, 2018",
    "Current Ver": 1.5,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Recipes for hair and face tried",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 1203,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "October 16, 2016",
    "Current Ver": 1.2,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Abs Workout - 30 Days Fitness App for Six Pack Abs",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 299,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.3.8",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "8fit Workouts & Meal Planner",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 115721,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 11, 2018",
    "Current Ver": "3.5.0",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Keep Trainer - Workout Trainer & Fitness Coach",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.7,
    Reviews: 14810,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Run with Map My Run",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 183662,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 27, 2018",
    "Current Ver": "18.7.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Weight Loss Running by Verv",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 27393,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Health & Fitness",
    "Last Updated": "July 16, 2018",
    "Current Ver": "6.5.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Couch to 10K Running Trainer",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 10445,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 2, 2018",
    "Current Ver": 112,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "PumpUp — Fitness Community",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4,
    Reviews: 49479,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "July 10, 2018",
    "Current Ver": "5.13.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Home workouts - fat burning, abs, legs, arms,chest",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.3,
    Reviews: 4848,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 18, 2018",
    "Current Ver": 2.6,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Running Weight Loss Walking Jogging Hiking FITAPP",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 20812,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Strava Training: Track Running, Cycling & Swimming",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 328469,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Workout Trainer: fitness coach",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.2,
    Reviews: 100406,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Fabulous: Motivate Me! Meditate, Relax, Sleep",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 205299,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 16, 2018",
    "Current Ver": 3.48,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "StrongLifts 5x5 Workout Gym Log & Personal Trainer",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.9,
    Reviews: 66791,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Run with Map My Run",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 183669,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 27, 2018",
    "Current Ver": "18.7.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "7 Minute Workout",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 399009,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 8, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Workout Tracker & Gym Trainer - Fitness Log Book",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 5420,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 5, 2018",
    "Current Ver": "2.48.3",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Freeletics: Personal Trainer & Fitness Workouts",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 130104,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 3, 2018",
    "Current Ver": 5.3,
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Nike Training Club - Workouts & Fitness Plans",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 251534,
    Size: "93M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 18, 2018",
    "Current Ver": "5.14.0",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Fitbit Coach",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 28951,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 16, 2018",
    "Current Ver": 4.4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "JEFIT Workout Tracker, Weight Lifting, Gym Log App",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 60096,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "April 7, 2018",
    "Current Ver": 10,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Map My Ride GPS Cycling Riding",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 106547,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 27, 2018",
    "Current Ver": "18.7.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Daily Workouts - Exercise Fitness Routine Trainer",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 134195,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 14, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Google Fit - Fitness Tracking",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.9,
    Reviews: 249855,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Weight Loss Running by Verv",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 27396,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Health & Fitness",
    "Last Updated": "July 16, 2018",
    "Current Ver": "6.5.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Nike+ Run Club",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 708710,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 12, 2018",
    "Current Ver": "2.17.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Sworkit: Workouts & Fitness Plans",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 109756,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 1, 2018",
    "Current Ver": "8.2.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Map My Fitness Workout Trainer",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 38343,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 27, 2018",
    "Current Ver": "18.7.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Sports Tracker Running Cycling",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 190247,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Runtastic Running App & Mile Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 827651,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "8fit Workouts & Meal Planner",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 115721,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 11, 2018",
    "Current Ver": "3.5.0",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Seven - 7 Minute Workout Training Challenge",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 75571,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 3, 2018",
    "Current Ver": "7.2.5",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Daily Yoga - Yoga Fitness Plans",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 70769,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 24, 2018",
    "Current Ver": "6.2.73",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Pocket Yoga",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 2107,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "December 22, 2015",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Relax Meditation: Sleep with Sleep Sounds",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 26540,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "February 9, 2017",
    "Current Ver": "2.5.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Free Meditation - Take a Break",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.2,
    Reviews: 1608,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 28, 2016",
    "Current Ver": 6.7,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Meditate OM",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 19074,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "January 17, 2018",
    "Current Ver": 16,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Yoga - Track Yoga",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 7976,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": 7,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "My Chakra Meditation",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 7586,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "April 10, 2018",
    "Current Ver": "1.0.6",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Relax with Andrew Johnson Lite",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.3,
    Reviews: 2885,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 19, 2012",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Meditation Music - Relax, Yoga",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 48226,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "March 5, 2018",
    "Current Ver": "3.1.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Meditation Studio",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 1026,
    Size: "29M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "May 15, 2018",
    "Current Ver": "1.0.6",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Down Dog: Great Yoga Anywhere",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.9,
    Reviews: 28945,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "May 17, 2018",
    "Current Ver": "2.6.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "21-Day Meditation Experience",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 11506,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "My Chakra Meditation 2",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.3,
    Reviews: 1288,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "April 10, 2018",
    "Current Ver": "2.0.4",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Simply Yoga - Fitness Trainer for Workouts & Poses",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.1,
    Reviews: 6826,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 14, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Calm - Meditate, Sleep, Relax",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 111450,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Relax Melodies P: Sleep Sounds",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 19543,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "January 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Relax Melodies: Sleep Sounds",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 233243,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Simple Habit Meditation",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.7,
    Reviews: 11689,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.29.15",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Headspace: Meditation & Mindfulness",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 77563,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 23, 2018",
    "Current Ver": "3.6.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Yoga Studio: Mind & Body",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.3,
    Reviews: 5499,
    Size: "94M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.0.16",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Daily Yoga - Yoga Fitness Plans",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 70769,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 24, 2018",
    "Current Ver": "6.2.73",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Pocket Yoga",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 2107,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "December 22, 2015",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Pregnancy & Baby Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 48286,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "My Cycles Period and Ovulation",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.3,
    Reviews: 26652,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "May 4, 2018",
    "Current Ver": "2.3.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "I’m Expecting - Pregnancy App",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 71269,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "March 30, 2018",
    "Current Ver": "2.3.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "The Bump Pregnancy Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 20301,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "May 16, 2018",
    "Current Ver": 3.22,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "My Days - Ovulation Calendar & Period Tracker ™",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 93691,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Best Ovulation Tracker Fertility Calendar App Glow",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 56145,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 1, 2018",
    "Current Ver": "7.3.4-play",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Eve Period Tracker - Love, Sex & Relationships App",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 20326,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "August 4, 2018",
    "Current Ver": "2.9.18",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fertility Friend Ovulation App",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 12955,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "June 27, 2018",
    "Current Ver": 10.24,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Pregnancy Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.1,
    Reviews: 2681,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "February 10, 2018",
    "Current Ver": 37,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Period Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 325738,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Spot On Period, Birth Control, & Cycle Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 4102,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Health & Fitness",
    "Last Updated": "July 19, 2018",
    "Current Ver": "2.6.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "OvuView: Ovulation and Fertility",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 40296,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 15, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Period Tracker - Period Calendar Ovulation Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 4559407,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Period Tracker Clue: Period and Ovulation Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 570242,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.0.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Calorie Counter - MyFitnessPal",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 1873523,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "WomanLog Calendar",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 121838,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "May 23, 2018",
    "Current Ver": "5.5.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Geocaching®",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.1,
    Reviews: 62616,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Map My Hike GPS Hiking",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 12858,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 27, 2018",
    "Current Ver": "18.7.1",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "ViewRanger - Hike, Ride or Walk",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.2,
    Reviews: 34356,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Runtastic Mountain Bike GPS Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 50679,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 1, 2018",
    "Current Ver": "3.6.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AllTrails: Hiking, Running & Mountain Bike Trails",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.3,
    Reviews: 16943,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 30, 2018",
    "Current Ver": "8.8.14",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Water Drink Reminder",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 524299,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Zombies, Run! 5k Training (Free)",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4,
    Reviews: 267,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Tracks",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 623,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Health & Fitness",
    "Last Updated": "July 17, 2017",
    "Current Ver": "1.2.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Weight Loss Running by Verv",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 27396,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Health & Fitness",
    "Last Updated": "July 16, 2018",
    "Current Ver": "6.5.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Nike+ Run Club",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 708710,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 12, 2018",
    "Current Ver": "2.17.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Seven - 7 Minute Workout Training Challenge",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 75571,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 3, 2018",
    "Current Ver": "7.2.5",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "YAZIO Calorie Counter, Nutrition Diary & Diet Plan",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 117176,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Technutri - calorie counter, diet and carb tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 70416,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 27, 2018",
    "Current Ver": "3.19.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Couch to 5K by RunDouble",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.7,
    Reviews: 15674,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.5.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fooducate Healthy Weight Loss & Calorie Counter",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 14402,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Weight Watchers Mobile",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.2,
    Reviews: 270294,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 31, 2018",
    "Current Ver": "6.15.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Walk with Map My Walk",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 144050,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 27, 2018",
    "Current Ver": "18.7.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Workout Trainer: fitness coach",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.2,
    Reviews: 100406,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "My Diet Coach - Weight Loss Motivation & Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 141163,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Run with Map My Run",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 183669,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 27, 2018",
    "Current Ver": "18.7.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Nike Training Club - Workouts & Fitness Plans",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 251534,
    Size: "93M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 18, 2018",
    "Current Ver": "5.14.0",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Fitbit Coach",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 28951,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 16, 2018",
    "Current Ver": 4.4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Calorie Counter - MyFitnessPal",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 1873520,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Endomondo - Running & Walking",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 559262,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Runkeeper - GPS Track Run Walk",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 501144,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Nike+ Run Club",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 708753,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 12, 2018",
    "Current Ver": "2.17.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Lose It! - Calorie Counter",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 69395,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Runtastic Running App & Mile Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 827653,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Calorie Counter - MyNetDiary",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 27439,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 16, 2018",
    "Current Ver": "6.5.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "10 Best Foods for You",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4,
    Reviews: 2490,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Health & Fitness",
    "Last Updated": "February 17, 2017",
    "Current Ver": 1.9,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "MyPlate Calorie Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 24094,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "3.3.0(1)",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "My Diet Diary Calorie Counter",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.1,
    Reviews: 18539,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.11.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Calorie Counter - Macros",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4,
    Reviews: 3061,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 27, 2016",
    "Current Ver": "2.3.4",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Calorie Counter by FatSecret",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 229210,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Weight Loss Tracker - RecStyle",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 20547,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "November 29, 2017",
    "Current Ver": "3.2.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Lark - 24/7 Health Coach",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.1,
    Reviews: 3405,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 25, 2018",
    "Current Ver": "4.5.1.123",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "MealLogger-Photo Food Journal",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.5,
    Reviews: 217,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "August 23, 2017",
    "Current Ver": "4.6.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Health and Nutrition Guide",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.3,
    Reviews: 7895,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 15, 2018",
    "Current Ver": 3.3,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Calorie Counter & Diet Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 32606,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "March 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Food Calorie Calculator",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.2,
    Reviews: 1324,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "January 29, 2018",
    "Current Ver": "10.2.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Calorie Counter - MyFitnessPal",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 1873520,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Lose It! - Calorie Counter",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 69395,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Calorie Counter - MyNetDiary",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 27439,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 16, 2018",
    "Current Ver": "6.5.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "10 Best Foods for You",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4,
    Reviews: 2490,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Health & Fitness",
    "Last Updated": "February 17, 2017",
    "Current Ver": 1.9,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Monitor Your Weight",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 126017,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 5, 2018",
    "Current Ver": "4.9.8.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "MyPlate Calorie Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 24094,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "3.3.0(1)",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Weight Loss Tracker - RecStyle",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 20547,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "November 29, 2017",
    "Current Ver": "3.2.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Calorie Counter by FatSecret",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 229214,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Eat Fit - Diet and Health Free",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.1,
    Reviews: 2469,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 23, 2014",
    "Current Ver": "1.0.9",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Calorie Counter - Macros",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4,
    Reviews: 3061,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 27, 2016",
    "Current Ver": "2.3.4",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "My Diet Diary Calorie Counter",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.1,
    Reviews: 18539,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.11.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Lark - 24/7 Health Coach",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.1,
    Reviews: 3405,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 25, 2018",
    "Current Ver": "4.5.1.123",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Weight Watchers Mobile",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.2,
    Reviews: 270294,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 31, 2018",
    "Current Ver": "6.15.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Calorie Counter & Diet Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 32606,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "March 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "MealLogger-Photo Food Journal",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.5,
    Reviews: 217,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "August 23, 2017",
    "Current Ver": "4.6.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Health and Nutrition Guide",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.3,
    Reviews: 7895,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 15, 2018",
    "Current Ver": 3.3,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Food Calorie Calculator",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.2,
    Reviews: 1324,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "January 29, 2018",
    "Current Ver": "10.2.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Calorie Counter - MyFitnessPal",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 1873523,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Lose It! - Calorie Counter",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 69395,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Self Healing",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 14394,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 16, 2017",
    "Current Ver": "Public.Heal",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Relax Meditation: Sleep with Sleep Sounds",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 26540,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "February 9, 2017",
    "Current Ver": "2.5.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Happify",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.7,
    Reviews: 1812,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.31.0-15160.950adac99",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Binaural Beats Therapy",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.3,
    Reviews: 13724,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 17, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Pacifica - Stress & Anxiety",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 10253,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "6.3.1",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Relaxing Sounds",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 4642,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "March 11, 2017",
    "Current Ver": 1.92,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "White Sound Pro",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.7,
    Reviews: 16570,
    Size: "73M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 29, 2018",
    "Current Ver": "4.8.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Meditation Music - Relax, Yoga",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 48226,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "March 5, 2018",
    "Current Ver": "3.1.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Insight Timer - Free Meditation App",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 20161,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Self-help Anxiety Management",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4,
    Reviews: 2894,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Health & Fitness",
    "Last Updated": "February 22, 2017",
    "Current Ver": "1.2.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Brain Waves - Binaural Beats",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 5038,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 15, 2018",
    "Current Ver": 5.2,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "21-Day Meditation Experience",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 11506,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Prana Breath: Calm & Meditate",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 31665,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 19, 2018",
    "Current Ver": "8.2.0_8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fabulous: Motivate Me! Meditate, Relax, Sleep",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 205299,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 16, 2018",
    "Current Ver": 3.48,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "7 Cups: Anxiety & Stress Chat",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.2,
    Reviews: 13799,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Calm - Meditate, Sleep, Relax",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 111455,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Runtastic Sleep Better: Sleep Cycle & Smart Alarm",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.1,
    Reviews: 111462,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "White Noise Lite",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 57634,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 25, 2018",
    "Current Ver": 7.4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Relax Melodies: Sleep Sounds",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 233243,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Stop, Breathe & Think: Meditation & Mindfulness",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.3,
    Reviews: 8576,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Simple Habit Meditation",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.7,
    Reviews: 11689,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.29.15",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Headspace: Meditation & Mindfulness",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 77563,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 23, 2018",
    "Current Ver": "3.6.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Daily Yoga - Yoga Fitness Plans",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 70769,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 24, 2018",
    "Current Ver": "6.2.73",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Zillow: Find Houses for Sale & Apartments for Rent",
    Category: "HOUSE_AND_HOME",
    Rating: 4.5,
    Reviews: 417907,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 1, 2018",
    "Current Ver": "9.8.1.7425",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Viva Decora - Decoration, Photos, Architecture, House",
    Category: "HOUSE_AND_HOME",
    Rating: 4.8,
    Reviews: 3167,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.0.0",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Apartments & Rentals - Zillow",
    Category: "HOUSE_AND_HOME",
    Rating: 4.2,
    Reviews: 27386,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "June 21, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Realtor.com Real Estate: Homes for Sale and Rent",
    Category: "HOUSE_AND_HOME",
    Rating: 4.5,
    Reviews: 162243,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 26, 2018",
    "Current Ver": 8.18,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Real Estate sale & rent Trovit",
    Category: "HOUSE_AND_HOME",
    Rating: 4.1,
    Reviews: 65913,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 16, 2018",
    "Current Ver": "4.47.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "591 housing transactions - renting houses, middle-class houses, new cases, real-time registration, villas through the sky, apartment suites, MRT, buying a house selling prices, housing mortgages",
    Category: "HOUSE_AND_HOME",
    Rating: 4.1,
    Reviews: 24977,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 1, 2018",
    "Current Ver": "3.5.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Homes.com 🏠 For Sale, Rent",
    Category: "HOUSE_AND_HOME",
    Rating: 4,
    Reviews: 6000,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 28, 2018",
    "Current Ver": "9.6.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CYANOGEN. Rent, buy an apartment, a room, a cottage 3+",
    Category: "HOUSE_AND_HOME",
    Rating: 4.3,
    Reviews: 37711,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.51.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Trulia Real Estate & Rentals",
    Category: "HOUSE_AND_HOME",
    Rating: 4.5,
    Reviews: 175293,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Latest 2018 Home Designs",
    Category: "HOUSE_AND_HOME",
    Rating: "NaN",
    Reviews: 174,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Houzz Interior Design Ideas",
    Category: "HOUSE_AND_HOME",
    Rating: 4.6,
    Reviews: 353799,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Good room network fast rent",
    Category: "HOUSE_AND_HOME",
    Rating: 3.7,
    Reviews: 2758,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "June 25, 2018",
    "Current Ver": "4.2.3",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Yongqing fast search",
    Category: "HOUSE_AND_HOME",
    Rating: 3.7,
    Reviews: 1437,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "LIFULL HOME'S",
    Category: "HOUSE_AND_HOME",
    Rating: 4.2,
    Reviews: 7573,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 25, 2018",
    "Current Ver": "8.2.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Apartment List: Housing, Apt, and Property Rentals",
    Category: "HOUSE_AND_HOME",
    Rating: 4.5,
    Reviews: 8481,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.1.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Gold Butterfly Keyboard Theme",
    Category: "HOUSE_AND_HOME",
    Rating: 4.3,
    Reviews: 10054,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 12, 2018",
    "Current Ver": "6.7.12.2018",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Apartment, Home Rental Search: Realtor.com Rentals",
    Category: "HOUSE_AND_HOME",
    Rating: 3.9,
    Reviews: 10117,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "June 29, 2018",
    "Current Ver": 3.6,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Living Smart Home",
    Category: "HOUSE_AND_HOME",
    Rating: 4.6,
    Reviews: 39189,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "591 Housing Trading - Hong Kong",
    Category: "HOUSE_AND_HOME",
    Rating: 4.3,
    Reviews: 3522,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.10.8",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Trulia Rent Apartments & Homes",
    Category: "HOUSE_AND_HOME",
    Rating: 4.4,
    Reviews: 71419,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Redfin Real Estate",
    Category: "HOUSE_AND_HOME",
    Rating: 4.6,
    Reviews: 36857,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 25, 2018",
    "Current Ver": 220,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Domofond Real Estate. Buy, rent an apartment.",
    Category: "HOUSE_AND_HOME",
    Rating: 4.5,
    Reviews: 39123,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "realestate.com.au - Buy, Rent & Sell Property",
    Category: "HOUSE_AND_HOME",
    Rating: 3.8,
    Reviews: 14653,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Yes319 real price login query",
    Category: "HOUSE_AND_HOME",
    Rating: "NaN",
    Reviews: 12,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 12, 2018",
    "Current Ver": 1.04,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DaBang - Rental Homes in Korea",
    Category: "HOUSE_AND_HOME",
    Rating: 4.4,
    Reviews: 23013,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 17, 2018",
    "Current Ver": "3.2.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "DIY On A Budget",
    Category: "HOUSE_AND_HOME",
    Rating: 4.7,
    Reviews: 114,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "House & Home",
    "Last Updated": "February 18, 2018",
    "Current Ver": 2.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Free Foreclosure Real Estate Search by USHUD.com",
    Category: "HOUSE_AND_HOME",
    Rating: 3.4,
    Reviews: 287,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "May 29, 2018",
    "Current Ver": "2.4.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Mortgage by Zillow: Calculator & Rates",
    Category: "HOUSE_AND_HOME",
    Rating: 4.3,
    Reviews: 4435,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "March 2, 2016",
    "Current Ver": "2.6.0.287",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Home Security Camera WardenCam - reuse old phones",
    Category: "HOUSE_AND_HOME",
    Rating: 4.3,
    Reviews: 43800,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Room planner: Interior & Floorplan Design for IKEA",
    Category: "HOUSE_AND_HOME",
    Rating: 4,
    Reviews: 4281,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 5, 2018",
    "Current Ver": 858,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Rent.com Apartment Homes",
    Category: "HOUSE_AND_HOME",
    Rating: 4,
    Reviews: 7508,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 9, 2018",
    "Current Ver": "7.9.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Good house to buy a house",
    Category: "HOUSE_AND_HOME",
    Rating: 3.8,
    Reviews: 491,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 25, 2018",
    "Current Ver": "2.6.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "LH Housing Promotion Notice",
    Category: "HOUSE_AND_HOME",
    Rating: "NaN",
    Reviews: 160,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "September 19, 2017",
    "Current Ver": "1.2.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Apartments.com Rental Search",
    Category: "HOUSE_AND_HOME",
    Rating: 4.3,
    Reviews: 22584,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 16, 2018",
    "Current Ver": "4.7.13",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hemnet",
    Category: "HOUSE_AND_HOME",
    Rating: 3.6,
    Reviews: 4087,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 16, 2018",
    "Current Ver": "4.3.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "At home - rental · real estate · room finding application such as apartment · apartment",
    Category: "HOUSE_AND_HOME",
    Rating: 3.8,
    Reviews: 2496,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Alfred Home Security Camera",
    Category: "HOUSE_AND_HOME",
    Rating: 4.5,
    Reviews: 103305,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "House app: beautiful everyday ~",
    Category: "HOUSE_AND_HOME",
    Rating: 4.6,
    Reviews: 2669,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "House & Home",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.0.6.9",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Home tips and advice",
    Category: "HOUSE_AND_HOME",
    Rating: "NaN",
    Reviews: 10,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "December 28, 2017",
    "Current Ver": 2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "N1.RU - Real estate: apartments, new buildings, lodging",
    Category: "HOUSE_AND_HOME",
    Rating: 4.5,
    Reviews: 7619,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.22.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Ruler",
    Category: "HOUSE_AND_HOME",
    Rating: 4.7,
    Reviews: 126,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 21, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Home Decor Showpiece Art making: Medium Difficulty",
    Category: "HOUSE_AND_HOME",
    Rating: 4.3,
    Reviews: 273,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "May 30, 2018",
    "Current Ver": 1.2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "乐屋网: Buying a house, selling a house, renting a house",
    Category: "HOUSE_AND_HOME",
    Rating: 3.7,
    Reviews: 2248,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 3, 2018",
    "Current Ver": "v3.1.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Real estate court auction information site - Hyundai court auction",
    Category: "HOUSE_AND_HOME",
    Rating: "NaN",
    Reviews: 10,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 2, 2018",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "iProperty Malaysia",
    Category: "HOUSE_AND_HOME",
    Rating: 4.2,
    Reviews: 809,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.6.1.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ColorSnap® Visualizer",
    Category: "HOUSE_AND_HOME",
    Rating: 3.4,
    Reviews: 3280,
    Size: "77M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "June 29, 2018",
    "Current Ver": "5.0.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Apartment Decorating Ideas",
    Category: "HOUSE_AND_HOME",
    Rating: 3.9,
    Reviews: 1478,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "March 13, 2015",
    "Current Ver": 1.2,
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Bedroom Decorating Ideas",
    Category: "HOUSE_AND_HOME",
    Rating: 4,
    Reviews: 2382,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "April 7, 2015",
    "Current Ver": 1.7,
    numInstall: 500000,
    numAndroid: 3,
  },
  {
    App: "Room Painting Ideas",
    Category: "HOUSE_AND_HOME",
    Rating: 4,
    Reviews: 4450,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "March 17, 2015",
    "Current Ver": 1.7,
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Kitchen Island Ideas",
    Category: "HOUSE_AND_HOME",
    Rating: 4,
    Reviews: 515,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "May 30, 2015",
    "Current Ver": 1.5,
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "Houzz Interior Design Ideas",
    Category: "HOUSE_AND_HOME",
    Rating: 4.6,
    Reviews: 353800,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Living Room Decorating Ideas",
    Category: "HOUSE_AND_HOME",
    Rating: 4,
    Reviews: 4465,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "March 6, 2015",
    "Current Ver": 1.7,
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Bathroom Decorating Ideas",
    Category: "HOUSE_AND_HOME",
    Rating: 4.1,
    Reviews: 2427,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "March 12, 2015",
    "Current Ver": 1.4,
    numInstall: 500000,
    numAndroid: 3,
  },
  {
    App: "Wall Decorating Ideas",
    Category: "HOUSE_AND_HOME",
    Rating: 3.9,
    Reviews: 6631,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "March 11, 2015",
    "Current Ver": 1.5,
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Zumper - Apartment Rental Finder",
    Category: "HOUSE_AND_HOME",
    Rating: 4.4,
    Reviews: 11200,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 16, 2018",
    "Current Ver": "4.5.15",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "RadPad: Apartment Finder App",
    Category: "HOUSE_AND_HOME",
    Rating: 4.4,
    Reviews: 6896,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 30, 2017",
    "Current Ver": "1.7.3",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Mortgage by Zillow: Calculator & Rates",
    Category: "HOUSE_AND_HOME",
    Rating: 4.3,
    Reviews: 4435,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "March 2, 2016",
    "Current Ver": "2.6.0.287",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Redfin Real Estate",
    Category: "HOUSE_AND_HOME",
    Rating: 4.6,
    Reviews: 36857,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 25, 2018",
    "Current Ver": 220,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Apartment List: Housing, Apt, and Property Rentals",
    Category: "HOUSE_AND_HOME",
    Rating: 4.5,
    Reviews: 8481,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.1.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Realtor.com Real Estate: Homes for Sale and Rent",
    Category: "HOUSE_AND_HOME",
    Rating: 4.5,
    Reviews: 162243,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 26, 2018",
    "Current Ver": 8.18,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Trulia Real Estate & Rentals",
    Category: "HOUSE_AND_HOME",
    Rating: 4.5,
    Reviews: 175293,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Zillow: Find Houses for Sale & Apartments for Rent",
    Category: "HOUSE_AND_HOME",
    Rating: 4.5,
    Reviews: 417907,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 1, 2018",
    "Current Ver": "9.8.1.7425",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Homesnap Real Estate & Rentals",
    Category: "HOUSE_AND_HOME",
    Rating: 4.3,
    Reviews: 3834,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 31, 2018",
    "Current Ver": "5.20.38",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Apartments & Rentals - Zillow",
    Category: "HOUSE_AND_HOME",
    Rating: 4.2,
    Reviews: 27387,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "June 21, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Trulia Rent Apartments & Homes",
    Category: "HOUSE_AND_HOME",
    Rating: 4.4,
    Reviews: 71421,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Apartments.com Rental Search",
    Category: "HOUSE_AND_HOME",
    Rating: 4.3,
    Reviews: 22584,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 16, 2018",
    "Current Ver": "4.7.13",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Houzz Interior Design Ideas",
    Category: "HOUSE_AND_HOME",
    Rating: 4.6,
    Reviews: 353813,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Trulia Mortgage Calculators",
    Category: "HOUSE_AND_HOME",
    Rating: 4.1,
    Reviews: 81,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "February 16, 2018",
    "Current Ver": "2.1.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Public Digital Library",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 3.9,
    Reviews: 2087,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Quotes",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.4,
    Reviews: 58,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "July 6, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Best New Ringtones 2018 Free 🔥 For Android™",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.6,
    Reviews: 3014,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "June 27, 2018",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Lamp detector",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 5,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "April 23, 2018",
    "Current Ver": "4.4.2",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "SUDOKU",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.1,
    Reviews: 923,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "October 15, 2015",
    "Current Ver": 3.1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "General culture",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 26,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 20, 2018",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Luffs",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 487,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "January 16, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Aviary Effects: Classic",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 3.8,
    Reviews: 67007,
    Size: "232k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "March 6, 2013",
    "Current Ver": "1.2.0",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Chakra Cleansing",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.6,
    Reviews: 539,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "August 2, 2018",
    "Current Ver": 7,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Aviary Stickers: Free Pack",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 3.5,
    Reviews: 126862,
    Size: "624k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "January 17, 2012",
    "Current Ver": 1,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Call Recorder",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.7,
    Reviews: 48,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.7.2.10",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Pink Water Sakura Keyboard Theme",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.3,
    Reviews: 1465,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "July 9, 2018",
    "Current Ver": "6.7.5",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "auto Call Recorder 2018",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.5,
    Reviews: 929,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 16, 2018",
    "Current Ver": "1.02.2018.11",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "converter video to mp3",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.4,
    Reviews: 783,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "June 10, 2017",
    "Current Ver": 1.6,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "eBiblio",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 3.4,
    Reviews: 2907,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "June 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "chicken song",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.3,
    Reviews: 434,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "June 6, 2018",
    "Current Ver": "6.0.0",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Words (188 Category)",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 54,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "July 4, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Binaural Beats Meditation",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.3,
    Reviews: 411,
    Size: "95M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "June 8, 2018",
    "Current Ver": 5,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Essential Resources",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.6,
    Reviews: 237,
    Size: "8.5k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "September 27, 2017",
    "Current Ver": 1.02,
    numInstall: 50000,
    numAndroid: 7,
  },
  {
    App: "MOMOLAND BBoom BBoom",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.6,
    Reviews: 2580,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "March 8, 2018",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Cold Spirits",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 363,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "January 2, 2017",
    "Current Ver": 1.2,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Cardboard",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.2,
    Reviews: 130272,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "March 14, 2016",
    "Current Ver": 1.8,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "How to sew & make the easiest pattern",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 110,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "November 5, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "I will return his eggs",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 91,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "November 16, 2017",
    "Current Ver": 6,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Bird Sounds & Bird Ringtones for Free 2018",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.6,
    Reviews: 130,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 23, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Benefits of olive oil with garlic",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 25,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "June 23, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Sad hair without net",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 20,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "March 26, 2018",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Top Popular Ringtones 2018 Free 🔥",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.4,
    Reviews: 7396,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "July 6, 2018",
    "Current Ver": 5.28,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Wifi Connect Library",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 3.9,
    Reviews: 58055,
    Size: "41k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "November 7, 2016",
    "Current Ver": "2.0.3",
    numInstall: 5000000,
    numAndroid: 1,
  },
  {
    App: "Super Funny Ringtones 2018 🔔",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.5,
    Reviews: 1703,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "March 1, 2018",
    "Current Ver": 3.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Apk Installer",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 3.8,
    Reviews: 7750,
    Size: "292k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "June 29, 2011",
    "Current Ver": 1,
    numInstall: 1000000,
    numAndroid: 1,
  },
  {
    App: "SAMSUNG RETAILMODE 2018",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.3,
    Reviews: 6,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "August 3, 2018",
    "Current Ver": "8.0.20180212",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "OpenCV Manager",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 3.7,
    Reviews: 12657,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "September 21, 2015",
    "Current Ver": 3,
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Eternal life",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 5,
    Reviews: 26,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "May 24, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 1,
  },
  {
    App: "V380s",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 3.2,
    Reviews: 1919,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "July 11, 2018",
    "Current Ver": "5.9.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Cool Popular Ringtones 2018 🔥",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.5,
    Reviews: 60170,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "July 13, 2018",
    "Current Ver": 2.4,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Blackpink as if it's your last",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.7,
    Reviews: 831,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 20, 2018",
    "Current Ver": 8,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Wifi Test",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4,
    Reviews: 8671,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "July 3, 2018",
    "Current Ver": 3.6,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Patience Words",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 31,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "December 14, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Market Update Helper",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.1,
    Reviews: 20145,
    Size: "11k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 12, 2013",
    numInstall: 1000000,
    numAndroid: 1,
  },
  {
    App: "Ayyush wih wih new without Net",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 3.8,
    Reviews: 912,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "January 9, 2018",
    "Current Ver": "2.0.0",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Girls Nancy Ajram Without Net",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.7,
    Reviews: 2639,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "December 11, 2017",
    "Current Ver": 6,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "R M Lock Screen",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.5,
    Reviews: 399,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "May 22, 2018",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Mama Lala 's song",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 102,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "July 1, 2018",
    "Current Ver": "6.0.0",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Barcode Scanner",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.2,
    Reviews: 3945,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "January 9, 2018",
    "Current Ver": "4.2.2",
    numInstall: 500000,
    numAndroid: 3,
  },
  {
    App: "Young Speeches",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 2221,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "January 8, 2017",
    "Current Ver": 1.1,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "New Ringtones 2018",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.1,
    Reviews: 3781,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "April 15, 2018",
    "Current Ver": 1.8,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "EyeCloud",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 3.1,
    Reviews: 1267,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.1.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dollhouse Decorating Games",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 18968,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "April 26, 2018",
    "Current Ver": 5.1,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "metroZONE",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 47497,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 8, 2018",
    "Current Ver": "5.3.0.54.7",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Easy Hair Style Design",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 601,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 20, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Talking Babsy Baby: Baby Games",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 140995,
    Size: "100M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle;Pretend Play",
    "Last Updated": "July 16, 2018",
    "Current Ver": 9,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Black Wallpaper, AMOLED, Dark Background: Darkify",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 51357,
    Size: "80M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 31, 2018",
    "Current Ver": 8,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Girly Wallpapers Backgrounds",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 13565,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 5, 2018",
    "Current Ver": 2.5,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Chart - Myanmar Keyboard",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 39364,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 17, 2018",
    "Current Ver": 10.19,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Easy Makeup Tutorials",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 7287,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "November 3, 2016",
    "Current Ver": 1,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Horoscopes – Daily Zodiac Horoscope and Astrology",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 161143,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Lifestyle",
    "Last Updated": "June 25, 2018",
    "Current Ver": "5.2.4(881)",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Entel",
    Category: "LIFESTYLE",
    Rating: 3.2,
    Reviews: 16168,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.2.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ZenUI Safeguard",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 100,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 9, 2018",
    "Current Ver": "1.0.0.21_180410",
    numInstall: 1000000,
    numAndroid: 7,
  },
  {
    App: "Live 4D Results ! (MY & SG)",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 116079,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 20, 2018",
    "Current Ver": 5.8,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Diary with lock",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 815893,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 30, 2018",
    "Current Ver": 4.9,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "FOSSIL Q: DESIGN YOUR DIAL",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 985,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 31, 2018",
    "Current Ver": 3.7,
    numInstall: 500000,
    numAndroid: 7,
  },
  {
    App: "Telstra",
    Category: "LIFESTYLE",
    Rating: 3,
    Reviews: 4260,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 8, 2017",
    "Current Ver": 6.1,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Family Locator - GPS Tracker",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 726074,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 2, 2018",
    "Current Ver": "16.7.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Van Nien 2018 - Lich Van su & Lich Am",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 3829,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 1, 2018",
    "Current Ver": "3.9.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Safeway",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 33572,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 2, 2018",
    "Current Ver": "6.2.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "HTC Speak",
    Category: "LIFESTYLE",
    Rating: 3.5,
    Reviews: 6145,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 30, 2016",
    "Current Ver": "8.00.775375",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Kawaii Easy Drawing : How to draw Step by Step",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 34327,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 17, 2018",
    "Current Ver": "2.5.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Tattoodo - Find your next tattoo",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 7457,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.4.12-r244",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "H&M",
    Category: "LIFESTYLE",
    Rating: 3.7,
    Reviews: 41941,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 30, 2018",
    "Current Ver": "9.6.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Samsung+",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 82145,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 5, 2018",
    "Current Ver": "10.19.0.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Anime Avatar Creator: Make Your Own Avatar",
    Category: "LIFESTYLE",
    Rating: 4.2,
    Reviews: 10944,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 15, 2018",
    "Current Ver": 2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Beautiful Design Birthday Cake",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 665,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 4, 2018",
    "Current Ver": 2,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Pronunciation and know the name of the caller from his number",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 2167,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 7, 2018",
    "Current Ver": 1,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Super Slime Simulator - Satisfying Slime App",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 53652,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 5, 2018",
    "Current Ver": 2.15,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Caf - My Account",
    Category: "LIFESTYLE",
    Rating: 3.9,
    Reviews: 18961,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 24, 2015",
    "Current Ver": "1.1.1",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "H Pack",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 9412,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 17, 2016",
    "Current Ver": "1.5.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Family convenience store FamilyMart",
    Category: "LIFESTYLE",
    Rating: 3.3,
    Reviews: 9663,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 16, 2018",
    "Current Ver": "Version:6.97",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "သိင်္ Astrology - Min Thein Kha BayDin",
    Category: "LIFESTYLE",
    Rating: 4.7,
    Reviews: 2225,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 26, 2018",
    "Current Ver": "4.2.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "w UN map",
    Category: "LIFESTYLE",
    Rating: 4.2,
    Reviews: 23164,
    Size: "10.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Lifestyle",
    "Last Updated": "July 24, 2018",
    "Current Ver": 2.6,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Official Matsumoto Kiyoshi application",
    Category: "LIFESTYLE",
    Rating: 3.2,
    Reviews: 3031,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.5.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Galaxy Gift",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 95557,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 23, 2018",
    "Current Ver": "7.0.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "PASS by KT (formerly KT certified)",
    Category: "LIFESTYLE",
    Rating: 3.5,
    Reviews: 7869,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 1, 2018",
    "Current Ver": "02.00.06",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Safety stepping stone",
    Category: "LIFESTYLE",
    Rating: 3.7,
    Reviews: 4212,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 25, 2018",
    "Current Ver": "3.4.5",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Rate Guide Bill Letter",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 17368,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 27, 2018",
    "Current Ver": "5.1.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "US Mission - buy gourmet movie KTV",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 6554,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "June 20, 2018",
    "Current Ver": "9.4.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "OK cashbag [point of pleasure]",
    Category: "LIFESTYLE",
    Rating: 3.7,
    Reviews: 33264,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 15, 2018",
    "Current Ver": "6.2.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "JOANN - Crafts & Coupons",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 34782,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 22, 2018",
    "Current Ver": "5.2.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "MK eCatalog",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 6676,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "February 21, 2018",
    "Current Ver": 3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Vaniday - Beauty Booking App",
    Category: "LIFESTYLE",
    Rating: 3.6,
    Reviews: 1067,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 20, 2018",
    "Current Ver": "3.8.15",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Fashion in Vogue",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 1797,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 27, 2016",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Mirror",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 367505,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "StyleSeat",
    Category: "LIFESTYLE",
    Rating: 4.7,
    Reviews: 20304,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 31, 2018",
    "Current Ver": 4.35,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Wedding Countdown Widget",
    Category: "LIFESTYLE",
    Rating: 3.9,
    Reviews: 7376,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 11, 2018",
    "Current Ver": "5.2.2018010801-1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "My Day - Countdown Calendar 🗓️",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 49147,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 7, 2018",
    "Current Ver": "2.9.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "justWink Greeting Cards",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 69177,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "August 2, 2017",
    "Current Ver": "2.7.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Wedding LookBook by The Knot",
    Category: "LIFESTYLE",
    Rating: 4.2,
    Reviews: 3448,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 9, 2018",
    "Current Ver": "3.9.5",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Vaniday - Beauty Booking App",
    Category: "LIFESTYLE",
    Rating: 3.6,
    Reviews: 1067,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 20, 2018",
    "Current Ver": "3.8.15",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Big Days - Events Countdown",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 39724,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Wedding Planner by WeddingWire - Venues, Checklist",
    Category: "LIFESTYLE",
    Rating: 4.2,
    Reviews: 3788,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 24, 2018",
    "Current Ver": "8.5.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Been Together (Ad) - D-day",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 95736,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "WedMeGood - Wedding Planner",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 1658,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.0.9",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "StyleSeat",
    Category: "LIFESTYLE",
    Rating: 4.7,
    Reviews: 20304,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 31, 2018",
    "Current Ver": 4.35,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "DIY Garden Ideas",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 3309,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 5, 2018",
    "Current Ver": 10,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Brit + Co",
    Category: "LIFESTYLE",
    Rating: 3.9,
    Reviews: 987,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 29, 2017",
    "Current Ver": "2.0.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Creative Ideas - DIY & Craft",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 5208,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "November 23, 2017",
    "Current Ver": 1.37,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Homestyler Interior Design & Decorating Ideas",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 78298,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.1.2.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "JOANN - Crafts & Coupons",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 34802,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 22, 2018",
    "Current Ver": "5.2.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Wheretoget: Shop in style",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 6808,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "June 5, 2017",
    "Current Ver": "3.2.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "My Dressing - Fashion closet",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 12452,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 26, 2017",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Chictopia",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 360,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "April 30, 2014",
    "Current Ver": "1.6.2",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Scarf Fashion Designer",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 16637,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 18, 2017",
    "Current Ver": 1.8,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Fashion in Vogue",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 1797,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 27, 2016",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Zara",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 95904,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 30, 2018",
    "Current Ver": "4.1.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Wheretoget: Shop in style",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 6808,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "June 5, 2017",
    "Current Ver": "3.2.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "My Dressing - Fashion closet",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 12452,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 26, 2017",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Chictopia",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 360,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "April 30, 2014",
    "Current Ver": "1.6.2",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Scarf Fashion Designer",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 16637,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 18, 2017",
    "Current Ver": 1.8,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Fashion in Vogue",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 1797,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 27, 2016",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Zara",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 95905,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 30, 2018",
    "Current Ver": "4.1.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Real Estate by Movoto",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 3114,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "February 20, 2018",
    "Current Ver": 6.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Etta Homes",
    Category: "LIFESTYLE",
    Rating: 4.2,
    Reviews: 220,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 26, 2018",
    "Current Ver": "9.1.0",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "Houlihan Lawrence",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 33,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "October 12, 2017",
    "Current Ver": "3.9.5",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Home Scouting® MLS Mobile",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 1533,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 27, 2016",
    "Current Ver": "2.2.6",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Housing-Real Estate & Property",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 28301,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 13, 2018",
    "Current Ver": "12.1.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ZipRealty Real Estate & Homes",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 3937,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 27, 2018",
    "Current Ver": "8.3.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Sotheby's International Realty",
    Category: "LIFESTYLE",
    Rating: 4.2,
    Reviews: 894,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "April 9, 2018",
    "Current Ver": "5.600.42",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Zoopla Property Search UK - Home to buy & rent",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 21195,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Neighborhoods & Apartments",
    Category: "LIFESTYLE",
    Rating: 3.9,
    Reviews: 2042,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 28, 2015",
    "Current Ver": "3.1.6",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Keller Williams Real Estate",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 13213,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 28, 2018",
    "Current Ver": "5.800.04",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Relax Rain ~ Rain Sounds",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 118034,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Relax Ocean ~ Nature Sounds",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 9464,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 18, 2017",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Bed Time Fan - White Noise Sleep Sounds",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 10097,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "April 26, 2018",
    "Current Ver": 1.2,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Nature Sounds",
    Category: "LIFESTYLE",
    Rating: 4.8,
    Reviews: 28588,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 1, 2018",
    "Current Ver": "3.1.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SleepyTime: Bedtime Calculator",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 19621,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "February 27, 2016",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "White Noise Baby",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 10544,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 18, 2018",
    "Current Ver": 5.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "White Noise ~ Sleeping Sounds",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 4427,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 23, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Journey - Diary, Journal",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 50338,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "7 Day Food Journal Challenge",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 3346,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "March 8, 2017",
    "Current Ver": "3.6.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ROBLOX",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 4447388,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Adventure;Action & Adventure",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.347.225742",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Subway Surfers",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 27722264,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.90.0",
    numInstall: 1000000000,
    numAndroid: 4,
  },
  {
    App: "Candy Crush Saga",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 22426677,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.129.0.2",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Solitaire",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 254258,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.137.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Bubble Shooter",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 148897,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.20.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Hello Kitty Nail Salon",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 369203,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "April 17, 2018",
    "Current Ver": 1.5,
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "slither.io",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 5234162,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "November 14, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "Clash Royale",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 23133508,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "June 27, 2018",
    "Current Ver": "2.3.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Temple Run 2",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 8118609,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.49.1",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Pou",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 10485308,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.4.77",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Helix Jump",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 1497361,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "April 9, 2018",
    "Current Ver": "1.0.6",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Block Puzzle",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 59800,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "March 6, 2018",
    "Current Ver": 2.9,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Angry Birds Rio",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 2610526,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 3, 2018",
    "Current Ver": "2.6.9",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Plants vs. Zombies FREE",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 4066989,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 6, 2018",
    "Current Ver": "2.2.00",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Sonic Dash",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 3778921,
    Size: "75M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 26, 2018",
    "Current Ver": "3.8.5.Go",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Candy Crush Soda Saga",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 6198563,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 10, 2018",
    "Current Ver": "1.118.4",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Hunter King",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 10306,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.0.8",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Clash of Clans",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 44891723,
    Size: "98M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 15, 2018",
    "Current Ver": "10.322.16",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Kick the Buddy",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1000417,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Block Puzzle Classic Legend !",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 17039,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 13, 2018",
    "Current Ver": 2.9,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "PAC-MAN",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 685981,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 15, 2018",
    "Current Ver": "6.6.3",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Super Jim Jump - pixel 3d",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 10393,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 11, 2018",
    "Current Ver": "2.2.3181",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "8 Ball Pool",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 14198297,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.0.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Magic Tiles 3",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 592068,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music",
    "Last Updated": "August 3, 2018",
    "Current Ver": "5.13.007",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Bubble Witch 3 Saga",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 1732263,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 17, 2018",
    "Current Ver": "4.8.4",
    numInstall: 50000000,
    numAndroid: 3,
  },
  {
    App: "Word Search",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 295241,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.1.3",
    numInstall: 10000000,
    numAndroid: 3,
  },
  {
    App: "Granny",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1135631,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "May 29, 2018",
    "Current Ver": "1.4.0.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Angry Birds Classic",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 5566669,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 24, 2018",
    "Current Ver": "7.9.3",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Flow Free",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1295557,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 11, 2018",
    "Current Ver": 4,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Race the Traffic Moto",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 270687,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Racing",
    "Last Updated": "July 20, 2018",
    "Current Ver": "1.0.16",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Fishdom",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 2157930,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 19, 2018",
    "Current Ver": "2.21.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Galaxy Attack: Alien Shooter",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 506275,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "August 1, 2018",
    "Current Ver": 5.66,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Tsunami",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 4920817,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "June 15, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Bubble Shooter 2",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 23005,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 25, 2018",
    "Current Ver": 3.5,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Barbie™ Fashion Closet",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 68057,
    Size: "85M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Creativity",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.3.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Candy Crush Jelly Saga",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1300490,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.1.10",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Hill Climb Racing",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 8923587,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "July 2, 2018",
    "Current Ver": "1.37.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Gardenscapes",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 4128732,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 13, 2018",
    "Current Ver": "2.6.2",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Marble - Temple Quest",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 42053,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "June 21, 2018",
    "Current Ver": 4.9,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Shooting King",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 257724,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.4.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Catchers",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 990491,
    Size: "75M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.0.27",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Minion Rush: Despicable Me Official Game",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 10216538,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "July 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Farm Heroes Saga",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 7614130,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 26, 2018",
    "Current Ver": "5.1.8",
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "Geometry Dash World",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 760628,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "December 22, 2017",
    "Current Ver": 1.03,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "My Talking Angela",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 9881829,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 3, 2018",
    "Current Ver": "3.7.2.51",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Cut the Rope FULL FREE",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 2123381,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 5, 2018",
    "Current Ver": "3.7.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Sniper 3D Gun Shooter: Free Shooting Games - FPS",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 7671249,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Subway Surfers",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 27723193,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.90.0",
    numInstall: 1000000000,
    numAndroid: 4,
  },
  {
    App: "ROBLOX",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 4447346,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Adventure;Action & Adventure",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.347.225742",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Pou",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 10485334,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.4.77",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "8 Ball Pool",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 14198602,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.0.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Clash of Clans",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 44891723,
    Size: "98M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 15, 2018",
    "Current Ver": "10.322.16",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Candy Crush Saga",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 22428456,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.129.0.2",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Plants vs. Zombies FREE",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 4066980,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 6, 2018",
    "Current Ver": "2.2.00",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Cooking Fever",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 3197865,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 12, 2018",
    "Current Ver": "2.8.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Toon Blast",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 1351068,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 30, 2018",
    "Current Ver": 3196,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Score! Hero",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 5418675,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 13, 2018",
    "Current Ver": 1.751,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "My Talking Angela",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 9881908,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 3, 2018",
    "Current Ver": "3.7.2.51",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Bubble Shooter",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 148895,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.20.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Toy Blast",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 1889250,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 23, 2018",
    "Current Ver": 5423,
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Miraculous Ladybug & Cat Noir - The Official Game",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 183846,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.0.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Wordscapes",
    Category: "GAME",
    Rating: 4.8,
    Reviews: 230710,
    Size: "87M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.0.47",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Word Search",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 295305,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.1.3",
    numInstall: 10000000,
    numAndroid: 3,
  },
  {
    App: "Candy Crush Soda Saga",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 6198880,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 10, 2018",
    "Current Ver": "1.118.4",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Fishdom",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 2157930,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 19, 2018",
    "Current Ver": "2.21.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Garena Free Fire",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 5465624,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.21.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Block Puzzle",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 59854,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "March 6, 2018",
    "Current Ver": 2.9,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Bowmasters",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 1534466,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.12.5",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Clash Royale",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 23134775,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "June 27, 2018",
    "Current Ver": "2.3.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "My Talking Tom",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 14891223,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 19, 2018",
    "Current Ver": "4.8.0.132",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Sniper 3D Gun Shooter: Free Shooting Games - FPS",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 7672495,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Granny",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1137271,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "May 29, 2018",
    "Current Ver": "1.4.0.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Galaxy Attack: Alien Shooter",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 506275,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "August 1, 2018",
    "Current Ver": 5.66,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Angry Birds Rio",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 2610622,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 3, 2018",
    "Current Ver": "2.6.9",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Catchers",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 990586,
    Size: "75M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.0.27",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Hunter King",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 10354,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.0.8",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Temple Run 2",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 8118937,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.49.1",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Tsunami",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 4921122,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "June 15, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Jungle Marble Blast",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 18985,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.5.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Rider",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 655067,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "July 17, 2017",
    "Current Ver": "1.2.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Farm Heroes Saga",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 7614271,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 26, 2018",
    "Current Ver": "5.1.8",
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "Super Jim Jump - pixel 3d",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 10434,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 11, 2018",
    "Current Ver": "2.2.3181",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "slither.io",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 5234825,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "November 14, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "Roll the Ball® - slide puzzle",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1385093,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.7.40",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Talking Tom Gold Run",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 2698348,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.8.2.59",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Pixel Art: Color by Number Game",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 1125017,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 17, 2018",
    "Current Ver": "3.9.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Dream League Soccer 2018",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 9882639,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 16, 2018",
    "Current Ver": 5.064,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Angry Birds Classic",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 5566805,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 24, 2018",
    "Current Ver": "7.9.3",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Fruits Bomb",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 74673,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 6, 2018",
    "Current Ver": "3.3.3179",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Traffic Racer",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 5387639,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "February 27, 2018",
    "Current Ver": 2.5,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Hill Climb Racing 2",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 2750410,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.17.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Flow Free",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1295606,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 11, 2018",
    "Current Ver": 4,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Knife Hit",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 461137,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.7.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Block Craft 3D: Building Simulator Games For Free",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 946926,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "March 5, 2018",
    "Current Ver": "2.10.2",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Farm Fruit Pop: Party Time",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 9305,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.9.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ROBLOX",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 4448791,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Adventure;Action & Adventure",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.347.225742",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Helix Jump",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 1498648,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "April 9, 2018",
    "Current Ver": "1.0.6",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Subway Surfers",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 27724094,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.90.0",
    numInstall: 1000000000,
    numAndroid: 4,
  },
  {
    App: "Candy Crush Saga",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 22428456,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.129.0.2",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Toon Blast",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 1351089,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 30, 2018",
    "Current Ver": 3196,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Love Balls",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 360630,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.2.7",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Granny",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1137267,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "May 29, 2018",
    "Current Ver": "1.4.0.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "8 Ball Pool",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 14200344,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.0.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Sniper 3D Gun Shooter: Free Shooting Games - FPS",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 7672495,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "slither.io",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 5234810,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "November 14, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "Hungry Shark Evolution",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 6074334,
    Size: "100M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.0.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Temple Run 2",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 8118937,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.49.1",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Kick the Buddy",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1000417,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Magic Tiles 3",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 592282,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music",
    "Last Updated": "August 3, 2018",
    "Current Ver": "5.13.007",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Bowmasters",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 1535084,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.12.5",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Piano Tiles 2™",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 8118880,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.1.0.226",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Pokémon GO",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 10424925,
    Size: "85M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "July 23, 2018",
    "Current Ver": "0.111.3",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Wordscapes",
    Category: "GAME",
    Rating: 4.8,
    Reviews: 230727,
    Size: "87M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.0.47",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Paint Hit",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 37023,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 6, 2018",
    "Current Ver": 5.2,
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Snake VS Block",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 422244,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "April 23, 2018",
    "Current Ver": 1.24,
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Rolly Vortex",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 98123,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.7.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Woody Puzzle",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 21262,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.0.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Stack Jump",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 118253,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "May 3, 2018",
    "Current Ver": "1.4.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Color by Number – New Coloring Book",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 141529,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Board",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.0.6",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "The Cube",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 70226,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.2.9",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Extreme Car Driving Simulator",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 2251012,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "May 3, 2018",
    "Current Ver": "4.17.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Bricks n Balls",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 30253,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "August 5, 2018",
    "Current Ver": "1.0.1.049",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "The Fish Master!",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 15763,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 17, 2018",
    "Current Ver": 1.6,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Color Road",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 84911,
    Size: "71M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 19, 2018",
    "Current Ver": "2.5.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Draw In",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 46416,
    Size: "73M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.0.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Block Craft 3D: Building Simulator Games For Free",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 946926,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "March 5, 2018",
    "Current Ver": "2.10.2",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "PLANK!",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 7196,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.0.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Looper!",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 48256,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 20, 2018",
    "Current Ver": "1.2.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Trivia Crack",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 6427773,
    Size: "95M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.79.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Will it Crush?",
    Category: "GAME",
    Rating: 3.1,
    Reviews: 25825,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.3.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Tomb of the Mask",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 55380,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.2.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Baseball Boy!",
    Category: "GAME",
    Rating: 3.4,
    Reviews: 148177,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.7.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "PUBG MOBILE",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 3715656,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 24, 2018",
    "Current Ver": "0.7.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Episode - Choose Your Story",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1841061,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Hello Stars",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 101686,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.8.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Run Sausage Run!",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 275447,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Tank Stars",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 174755,
    Size: "98M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.1.1",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Castle Clash: Heroes of the Empire US",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 4578476,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.4.51",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Hole.io",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 145353,
    Size: "85M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.3.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Helix Jump",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 1499373,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "April 9, 2018",
    "Current Ver": "1.0.6",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Mini Golf King - Multiplayer Game",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 531458,
    Size: "100M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 20, 2018",
    "Current Ver": "3.04.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "PUBG MOBILE",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 3714270,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 24, 2018",
    "Current Ver": "0.7.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Flip the Gun - Simulator Game",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 195558,
    Size: "86M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1.2,
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Mad Skills BMX 2",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 29940,
    Size: "80M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.1.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Wordscapes",
    Category: "GAME",
    Rating: 4.8,
    Reviews: 230727,
    Size: "87M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.0.47",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "MMX Hill Dash 2 – Offroad Truck, Car & Bike Racing",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 41975,
    Size: "79M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "July 19, 2018",
    "Current Ver": "3.00.11034",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Word Link",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 216675,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.2.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Last Day on Earth: Survival",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 2311785,
    Size: "87M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.9.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "MARVEL Strike Force",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 165888,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.4.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Partymasters - Fun Idle Game",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 541144,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.2.5",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Harry Potter: Hogwarts Mystery",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 1107310,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.8.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Offroad Outlaws",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 29168,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "May 29, 2018",
    "Current Ver": "2.0.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Grim Soul: Dark Fantasy Survival",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 189773,
    Size: "95M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.1.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "DRAGON BALL LEGENDS",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 337752,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.11.0",
    numInstall: 5000000,
    numAndroid: 6,
  },
  {
    App: "Disney Heroes: Battle Mode",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 102107,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.2.2",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Homescapes",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 3093358,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 13, 2018",
    "Current Ver": "1.8.0.900",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "New YAHTZEE® With Buddies Dice Game",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 42079,
    Size: "93M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "July 5, 2018",
    "Current Ver": "5.6.5",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Word Crossy - A crossword game",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 240416,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.2.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "MLB TAP SPORTS BASEBALL 2018",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 32506,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 27, 2018",
    "Current Ver": "1.2.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hero Hunters",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 70747,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 31, 2018",
    "Current Ver": 1.7,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Cooking Madness - A Chef's Restaurant Games",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 358817,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.2.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Ice Crush 2018 - A new Puzzle Matching Adventure",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 15403,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.8.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "TerraGenesis - Space Colony",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 38957,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.9.31",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Merge Dragons!",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 214777,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 30, 2018",
    "Current Ver": "3.6.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "SHADOWGUN LEGENDS",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 100609,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 16, 2018",
    "Current Ver": "0.5.4",
    numInstall: 1000000,
    numAndroid: 6,
  },
  {
    App: "RULES OF SURVIVAL",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 1343866,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.180271.184729",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Mafia City",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 168717,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Strategy",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.3.205",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Cash, Inc. Money Clicker Game & Business Adventure",
    Category: "GAME",
    Rating: 4.8,
    Reviews: 549720,
    Size: "85M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 19, 2018",
    "Current Ver": "2.1.1.4.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Dino War: Rise of Beasts",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 18996,
    Size: "81M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.5.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Tokyo Ghoul: Dark War",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 25094,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 6, 2018",
    "Current Ver": "1.2.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Last Shelter: Survival",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 93033,
    Size: "98M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.250.078",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Guns of Glory",
    Category: "GAME",
    Rating: 4,
    Reviews: 120592,
    Size: "77M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.0.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Lineage 2: Revolution",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 187972,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.05.20",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Final Fantasy XV: A New Empire",
    Category: "GAME",
    Rating: 4,
    Reviews: 484981,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "June 15, 2018",
    "Current Ver": "3.30.4.83",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Girls' Frontline",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 2055,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "May 18, 2018",
    "Current Ver": "2.0081_206",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Chapters: Interactive Stories",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 73539,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Role Playing",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.3.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Honkai Impact 3rd",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 59017,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 3, 2018",
    "Current Ver": "2.2.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Master of Eternity(MOE)",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 5829,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.8.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "The Game of Life",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 18621,
    Size: "63M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "July 4, 2018",
    "Current Ver": "2.1.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Clue",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 19922,
    Size: "35M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone 10+",
    Genres: "Board",
    "Last Updated": "July 30, 2018",
    "Current Ver": "2.2.5",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "The Room: Old Sins",
    Category: "GAME",
    Rating: 4.9,
    Reviews: 21119,
    Size: "48M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 18, 2018",
    "Current Ver": "1.0.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "The Escapists",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 7412,
    Size: "84M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "April 26, 2018",
    "Current Ver": "1.1.0",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Farming Simulator 18",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 18125,
    Size: "15M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Simulation;Education",
    "Last Updated": "July 9, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "RollerCoaster Tycoon® Classic",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 10795,
    Size: "69M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "December 21, 2017",
    "Current Ver": "1.2.1.1712080",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Call of Duty:Black Ops Zombies",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 13004,
    Size: "46M",
    Type: "Paid",
    Price: "$6.99",
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "December 20, 2016",
    "Current Ver": "1.0.11",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Star Wars ™: DIRTY",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 38207,
    Size: "15M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "October 19, 2015",
    "Current Ver": "1.0.6",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Monument Valley 2",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 9394,
    Size: "33M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "November 30, 2017",
    "Current Ver": "1.2.9",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DRAGON BALL LEGENDS",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 337913,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.11.0",
    numInstall: 5000000,
    numAndroid: 6,
  },
  {
    App: "ROBLOX",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 4449882,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Adventure;Action & Adventure",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.347.225742",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Candy Crush Saga",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 22429716,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.129.0.2",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Angry Birds 2",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 3883589,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.21.1",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "8 Ball Pool",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 14200550,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.0.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Fallout Shelter",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 2719142,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "June 11, 2018",
    "Current Ver": "1.13.12",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Harry Potter: Hogwarts Mystery",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 1107197,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.8.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "PUBG MOBILE",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 3716278,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 24, 2018",
    "Current Ver": "0.7.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "The Sims™ FreePlay",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 931595,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "July 16, 2018",
    "Current Ver": "5.39.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "MARVEL Strike Force",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 165928,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.4.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Best Fiends - Free Puzzle Game",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 1480189,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.8.1",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "MARVEL Contest of Champions",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 2468063,
    Size: "92M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 30, 2018",
    "Current Ver": "19.1.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Jurassic World™ Alive",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 309176,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Simulation",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.3.15",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Choices: Stories You Play",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 807338,
    Size: "93M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "July 30, 2018",
    "Current Ver": "2.3.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Solitaire TriPeaks",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 446434,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.6.2.46103",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Merge Dragons!",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 214819,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 30, 2018",
    "Current Ver": "3.6.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "The Walking Dead: Road to Survival",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 522466,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Role Playing",
    "Last Updated": "June 19, 2018",
    "Current Ver": "12.0.4.62276",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Hustle Castle: Fantasy Kingdom",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 584126,
    Size: "64M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.5.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Might & Magic: Elemental Guardians",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 32551,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Role Playing",
    "Last Updated": "July 12, 2018",
    "Current Ver": 1.93,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Game of Thrones: Conquest™",
    Category: "GAME",
    Rating: 4,
    Reviews: 90218,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.8.225278",
    numInstall: 1000000,
    numAndroid: 6,
  },
  {
    App: "Love Nikki-Dress UP Queen",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 212524,
    Size: "93M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "July 24, 2018",
    "Current Ver": "3.0.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Summoners War",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 2045554,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 30, 2018",
    "Current Ver": "4.0.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "FINAL FANTASY BRAVE EXVIUS",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 745684,
    Size: "83M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 17, 2018",
    "Current Ver": "3.0.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Idle Heroes",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 416540,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "May 30, 2018",
    "Current Ver": "1.14.0",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Fate/Grand Order (English)",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 16601,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.18.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Honkai Impact 3rd",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 59017,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 3, 2018",
    "Current Ver": "2.2.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Lords Mobile: Battle of the Empires - Strategy RPG",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 3057481,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1.76,
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "War and Order",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 224514,
    Size: "81M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.1.8",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Dungeon Hunter Champions: Epic Online Action RPG",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 26247,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.1.40",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Candy Crush Saga",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 22430188,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.129.0.2",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "ROBLOX",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 4449910,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Adventure;Action & Adventure",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.347.225742",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "8 Ball Pool",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 14201891,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.0.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Subway Surfers",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 27725352,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.90.0",
    numInstall: 1000000000,
    numAndroid: 4,
  },
  {
    App: "Candy Crush Soda Saga",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 6199095,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 10, 2018",
    "Current Ver": "1.118.4",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Hunter King",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 10493,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.0.8",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Bubble Shooter",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 148945,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.20.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Toon Blast",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 1351771,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 30, 2018",
    "Current Ver": 3196,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Toy Blast",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 1889582,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 23, 2018",
    "Current Ver": 5423,
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Clash Royale",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 23136735,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "June 27, 2018",
    "Current Ver": "2.3.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Clash of Clans",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 44893888,
    Size: "98M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 15, 2018",
    "Current Ver": "10.322.16",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Farm Heroes Saga",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 7614415,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 26, 2018",
    "Current Ver": "5.1.8",
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "Plants vs. Zombies FREE",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 4067651,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 6, 2018",
    "Current Ver": "2.2.00",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Word Search",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 295576,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.1.3",
    numInstall: 10000000,
    numAndroid: 3,
  },
  {
    App: "Block Puzzle",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 59907,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "March 6, 2018",
    "Current Ver": 2.9,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Super Jim Jump - pixel 3d",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 10460,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 11, 2018",
    "Current Ver": "2.2.3181",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Pou",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 10486018,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.4.77",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Temple Run 2",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 8119151,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.49.1",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Flow Free",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1295625,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 11, 2018",
    "Current Ver": 4,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Homescapes",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 3093932,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 13, 2018",
    "Current Ver": "1.8.0.900",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Wordscapes",
    Category: "GAME",
    Rating: 4.8,
    Reviews: 230849,
    Size: "87M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.0.47",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "My Talking Angela",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 9883367,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 3, 2018",
    "Current Ver": "3.7.2.51",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "slither.io",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 5235294,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "November 14, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "Cooking Fever",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 3198176,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 12, 2018",
    "Current Ver": "2.8.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Yes day",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 10055521,
    Size: "94M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "June 28, 2018",
    "Current Ver": "1_39_93",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Gardenscapes",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 4129665,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 13, 2018",
    "Current Ver": "2.6.2",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Fishdom",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 2158580,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 19, 2018",
    "Current Ver": "2.21.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Galaxy Attack: Alien Shooter",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 506593,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "August 1, 2018",
    "Current Ver": 5.66,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Score! Hero",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 5419676,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 13, 2018",
    "Current Ver": 1.751,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Catchers",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 990723,
    Size: "75M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.0.27",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Magic Tiles 3",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 592504,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music",
    "Last Updated": "August 3, 2018",
    "Current Ver": "5.13.007",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Jewels Star: OZ adventure",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 21892,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "December 29, 2017",
    "Current Ver": 1.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Granny",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1138239,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "May 29, 2018",
    "Current Ver": "1.4.0.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Dream League Soccer 2018",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 9883806,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 16, 2018",
    "Current Ver": 5.064,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Sweet Fruit Candy",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 197540,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 16, 2018",
    "Current Ver": 79,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Fruits Bomb",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 74695,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 6, 2018",
    "Current Ver": "3.3.3179",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Angry Birds Classic",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 5566889,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 24, 2018",
    "Current Ver": "7.9.3",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Talking Tom Gold Run",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 2698882,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.8.2.59",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Bowmasters",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 1535973,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.12.5",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "My Talking Tom",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 14892469,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 19, 2018",
    "Current Ver": "4.8.0.132",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Hill Climb Racing",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 8923818,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "July 2, 2018",
    "Current Ver": "1.37.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Sniper 3D Gun Shooter: Free Shooting Games - FPS",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 7674252,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Pixel Art: Color by Number Game",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 1125438,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 17, 2018",
    "Current Ver": "3.9.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Shoot Bubble - Fruit Splash",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 29445,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 11, 2018",
    "Current Ver": 14,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Rider",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 655145,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "July 17, 2017",
    "Current Ver": "1.2.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Tsunami",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 4921451,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "June 15, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Garena Free Fire",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 5476569,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.21.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Doodle Jump",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1083571,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Subway Surfers",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 27725352,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.90.0",
    numInstall: 1000000000,
    numAndroid: 4,
  },
  {
    App: "Helix Jump",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 1500999,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "April 9, 2018",
    "Current Ver": "1.0.6",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Crossy Road",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 4230886,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "August 1, 2018",
    "Current Ver": "3.1.0",
    numInstall: 100000000,
    numAndroid: 5,
  },
  {
    App: "Temple Run 2",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 8119154,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.49.1",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "slither.io",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 5235294,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "November 14, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "Bowmasters",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 1535973,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.12.5",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Talking Tom Gold Run",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 2698889,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.8.2.59",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Catchers",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 990663,
    Size: "75M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.0.27",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Sniper 3D Gun Shooter: Free Shooting Games - FPS",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 7674252,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Swamp Attack",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 2119218,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "June 29, 2018",
    "Current Ver": "3.0.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Earn to Die 2",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 1327265,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Racing",
    "Last Updated": "April 12, 2017",
    "Current Ver": 1.3,
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "Miraculous Ladybug & Cat Noir - The Official Game",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 184210,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.0.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Kick the Buddy",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1003269,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Hungry Shark World",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1242855,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 18, 2018",
    "Current Ver": "3.0.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Dude Perfect 2",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 401425,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "April 12, 2017",
    "Current Ver": "1.6.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Shadow Fight 2",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 10979062,
    Size: "88M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "July 2, 2018",
    "Current Ver": "1.9.38",
    numInstall: 100000000,
    numAndroid: 3,
  },
  {
    App: "Alto's Adventure",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 515657,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "June 5, 2018",
    "Current Ver": "1.7.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DEER HUNTER 2018",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 955656,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 26, 2018",
    "Current Ver": "5.1.2",
    numInstall: 10000000,
    numAndroid: 3,
  },
  {
    App: "DRAGON BALL LEGENDS",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 337913,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.11.0",
    numInstall: 5000000,
    numAndroid: 6,
  },
  {
    App: "DEAD TARGET: FPS Zombie Apocalypse Survival Games",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1468591,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Cover Fire: offline shooting games for free",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 725897,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.8.20",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Anger of stick 5 : zombie",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 549039,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.1.5",
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "CATS: Crash Arena Turbo Stars",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 1559650,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 9, 2018",
    "Current Ver": "2.11.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Soul Knight",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 292164,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.8.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Major Mayhem",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 520962,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 28, 2017",
    "Current Ver": 108,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DINO HUNTER: DEADLY SHORES",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 1381820,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "March 14, 2017",
    "Current Ver": "3.1.1",
    numInstall: 10000000,
    numAndroid: 3,
  },
  {
    App: "Strawberry Shortcake BerryRush",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 525517,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action;Action & Adventure",
    "Last Updated": "October 15, 2017",
    "Current Ver": "1.2.3",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Extreme Match",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 696,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.1.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Power Rangers Dino Charge",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 194969,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "January 29, 2018",
    "Current Ver": "1.4.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Hunter: Post Apocalypse Survival Games",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 327599,
    Size: "66M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 28, 2017",
    "Current Ver": "2.4.2",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Agar.io",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 3816799,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.2.8",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Hunter King",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 10538,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.0.8",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Garena Free Fire",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 5476569,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.21.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Battlelands Royale",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 105620,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "July 16, 2018",
    "Current Ver": "0.5.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Once Upon a Tower",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 37139,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "January 24, 2018",
    "Current Ver": 8,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "TEKKEN™",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 147791,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1.3,
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "diep.io",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 347883,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "March 16, 2018",
    "Current Ver": "1.2.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Arrow.io",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 343263,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "August 6, 2018",
    "Current Ver": "1.2.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "BEYBLADE BURST app",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 216849,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action;Action & Adventure",
    "Last Updated": "July 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Dragon Hills",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 354373,
    Size: "66M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "October 12, 2017",
    "Current Ver": "1.2.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Bus Rush: Subway Edition",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 753043,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.15.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "DC Super Hero Girls™",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 43055,
    Size: "95M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action;Action & Adventure",
    "Last Updated": "June 29, 2018",
    "Current Ver": "2.8.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Tiny Archers",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 80678,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "May 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Metal Soldiers 2",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 153381,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 18, 2018",
    "Current Ver": "1.11.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Runner 3d like",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 559,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.0.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "War Robots",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 3073251,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "July 25, 2018",
    "Current Ver": "4.1.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Dinosaur Simulator: Dino World",
    Category: "GAME",
    Rating: 4,
    Reviews: 26649,
    Size: "66M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 5, 2018",
    "Current Ver": 1.2,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "GUNSHIP BATTLE: Helicopter 3D",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 2151039,
    Size: "75M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.6.61",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Quiz: Logo game",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 306764,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "August 3, 2018",
    "Current Ver": 6.2,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Candy Crush Saga",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 22430188,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.129.0.2",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Plants vs. Zombies FREE",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 4067651,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 6, 2018",
    "Current Ver": "2.2.00",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Block Puzzle",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 59907,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "March 6, 2018",
    "Current Ver": 2.9,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Helix Jump",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 1500622,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "April 9, 2018",
    "Current Ver": "1.0.6",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "8 Ball Pool",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 14201604,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.0.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Jewels Legend - Match 3 Puzzle",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 280098,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.11.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Bubble Shooter",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 148990,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.20.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Solitaire",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 154264,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "June 8, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Bubble Shooter Genies",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 26985,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "June 4, 2018",
    "Current Ver": "1.9.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Blossom Blast Saga",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1125438,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 5, 2018",
    "Current Ver": "57.0.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Traffic Racer",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 5387781,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "February 27, 2018",
    "Current Ver": 2.5,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Hill Climb Racing",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 8923847,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "July 2, 2018",
    "Current Ver": "1.37.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Earn to Die 2",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 1327269,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Racing",
    "Last Updated": "April 12, 2017",
    "Current Ver": 1.3,
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "Bubble Shooter 2",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 23043,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 25, 2018",
    "Current Ver": 3.5,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Candy Bomb",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 42145,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Brain Games",
    "Last Updated": "July 4, 2018",
    "Current Ver": "2.9.3181",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Flow Free",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1295625,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 11, 2018",
    "Current Ver": 4,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Catchers",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 990796,
    Size: "75M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.0.27",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Gems or jewels ?",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 171448,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Puzzle",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.0.109",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Angry Birds Rio",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 2610680,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 3, 2018",
    "Current Ver": "2.6.9",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Candy Crush Jelly Saga",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1300619,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.1.10",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Cut the Rope FULL FREE",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 2123793,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 5, 2018",
    "Current Ver": "3.7.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Jewels Star: OZ adventure",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 21892,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "December 29, 2017",
    "Current Ver": 1.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hungry Shark Evolution",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 6074627,
    Size: "100M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.0.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Power Pop Bubbles",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 104303,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "August 2, 2018",
    "Current Ver": 3.15,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Angry Birds Classic",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 5566908,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 24, 2018",
    "Current Ver": "7.9.3",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Best Fiends - Free Puzzle Game",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 1480182,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.8.1",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Hill Climb Racing 2",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 2750645,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.17.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Jewels classic Prince",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 47644,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "June 15, 2018",
    "Current Ver": "2.4.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Fruit Block - Puzzle Legend",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 125647,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 23, 2018",
    "Current Ver": 60,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Bubble Shooter Space",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 4355,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 17, 2017",
    "Current Ver": 1.6,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Swamp Attack",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 2119235,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "June 29, 2018",
    "Current Ver": "3.0.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "1LINE – One Line with One Touch",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 214878,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.0.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Stick War: Legacy",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 811040,
    Size: "77M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "May 10, 2018",
    "Current Ver": "1.7.04",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Bowmasters",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 1536349,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.12.5",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Magic Tiles 3",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 592504,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music",
    "Last Updated": "August 3, 2018",
    "Current Ver": "5.13.007",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Block Puzzle Classic Legend !",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 17044,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 13, 2018",
    "Current Ver": 2.9,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Marble Woka Woka 2018 - Bubble Shooter Match 3",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 155186,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.3.35",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Pixel Art: Color by Number Game",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 1125566,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 17, 2018",
    "Current Ver": "3.9.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Score! Hero",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 5419676,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 13, 2018",
    "Current Ver": 1.751,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Super Jabber Jump 3",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 34494,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "July 11, 2018",
    "Current Ver": "2.5.3182",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Rush",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 260651,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "February 14, 2018",
    "Current Ver": 1.1,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Jetpack Joyride",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 4638163,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.10.12",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Tsunami",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 4921409,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "June 15, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "DEAD TARGET: FPS Zombie Apocalypse Survival Games",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1468638,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Word Search",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 344585,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "July 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Farm Heroes Saga",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 7614407,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 26, 2018",
    "Current Ver": "5.1.8",
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "Racing in Car 2",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 234110,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "November 22, 2016",
    "Current Ver": 1,
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "Dog Run - Pet Dog Simulator",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 48615,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation;Action & Adventure",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.4.12",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "YouTube Kids",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 470694,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.43.3",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Candy Bomb",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 42145,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Brain Games",
    "Last Updated": "July 4, 2018",
    "Current Ver": "2.9.3181",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ROBLOX",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 4449910,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Adventure;Action & Adventure",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.347.225742",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Jewels Crush- Match 3 Puzzle",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 14774,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Brain Games",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.9.3901",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Coloring & Learn",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 12753,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Creativity",
    "Last Updated": "July 17, 2018",
    "Current Ver": 1.49,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Mahjong",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 33983,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.24.3181",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Super ABC! Learning games for kids! Preschool apps",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 20267,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "July 16, 2018",
    "Current Ver": "1.1.6.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Toy Pop Cubes",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 5761,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Brain Games",
    "Last Updated": "July 4, 2018",
    "Current Ver": "1.8.3181",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Educational Games 4 Kids",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 11618,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "April 3, 2018",
    "Current Ver": 2.4,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Candy Pop Story",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 12948,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Brain Games",
    "Last Updated": "May 24, 2018",
    "Current Ver": "2.0.3165",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Solitaire",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 685,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card;Brain Games",
    "Last Updated": "July 16, 2018",
    "Current Ver": "1.7.101",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Princess Coloring Book",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 9779,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Creativity",
    "Last Updated": "February 25, 2018",
    "Current Ver": "1.2.8",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Hello Kitty Nail Salon",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 369378,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "April 17, 2018",
    "Current Ver": 1.5,
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Candy Smash",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 11436,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Brain Games",
    "Last Updated": "April 17, 2018",
    "Current Ver": "2.2.3169",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Happy Fruits Bomb - Cube Blast",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 2150,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Brain Games",
    "Last Updated": "February 1, 2018",
    "Current Ver": "1.0.3122",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Dog Run - Pet Dog Simulator",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 48615,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation;Action & Adventure",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.4.12",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Princess Adventures Puzzles",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 382,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Creativity",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.1.0",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Kids Educational Game 3 Free",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 24936,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "May 16, 2018",
    "Current Ver": 3.1,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Puzzle Kids - Animals Shapes and Jigsaw Puzzles",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 1109,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Brain Games",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.0.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Coloring book moana",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 974,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design;Pretend Play",
    "Last Updated": "January 15, 2018",
    "Current Ver": "2.0.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Baby Panda Care",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 108795,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "June 15, 2018",
    "Current Ver": "8.25.10.00",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Kids Educational :All in One",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 1455,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "February 1, 2018",
    "Current Ver": 2.7,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Number Counting games for toddler preschool kids",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1024,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "May 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Toca Kitchen 2",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 1014822,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "June 29, 2017",
    "Current Ver": "1.2.3-play",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "PJ Masks: Moonlight Heroes",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 86961,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "June 5, 2018",
    "Current Ver": "2.0.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Learn To Draw Glow Flower",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 7320,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Education",
    "Last Updated": "July 7, 2017",
    "Current Ver": "1.0.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "No. Color - Color by Number, Number Coloring",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 269194,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Brain Games",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Bubble Shooter",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 59843,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "January 9, 2018",
    "Current Ver": "2.3.3122",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Draw.ly - Color by Number Pixel Art Coloring",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 18616,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Education",
    "Last Updated": "August 5, 2018",
    "Current Ver": "1.0.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Baby puzzles",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 11950,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "July 12, 2018",
    "Current Ver": 6.1,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Garden Fruit Legend",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 4289,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Brain Games",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.5.3183",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Barbie™ Fashion Closet",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 68286,
    Size: "85M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Creativity",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.3.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Candy Day",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 11716,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Brain Games",
    "Last Updated": "August 3, 2018",
    "Current Ver": "8.4.3180",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Learn To Draw Glow Princess",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 3323,
    Size: "9.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "July 14, 2017",
    "Current Ver": "1.0.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ABC Kids - Tracing & Phonics",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 36606,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "June 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Barbie Magical Fashion",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 328619,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Creativity",
    "Last Updated": "October 6, 2017",
    "Current Ver": 2.2,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Minion Rush: Despicable Me Official Game",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 10216997,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "July 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Piano Kids - Music & Songs",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 46741,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music;Music & Video",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1.73,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Farming Simulator 14",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 530854,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation;Action & Adventure",
    "Last Updated": "July 17, 2017",
    "Current Ver": "1.4.4",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Educational Games for Kids",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 7050,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "May 27, 2018",
    "Current Ver": 2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "No.Draw - Colors by Number 2018",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 235906,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Brain Games",
    "Last Updated": "July 29, 2018",
    "Current Ver": "1.2.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Fruit Boom",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 17753,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Brain Games",
    "Last Updated": "May 25, 2018",
    "Current Ver": "2.2.3172",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Duolingo: Learn Languages Free",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 6294400,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Hot Wheels: Race Off",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 520609,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "June 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Baby Tiger Care - My Cute Virtual Pet Friend",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 432,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Educational;Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.0.89",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Strawberry Shortcake Ice Cream Island",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 32029,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "November 6, 2017",
    "Current Ver": 1.2,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Rhythm Patrol",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 4207,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music;Music & Video",
    "Last Updated": "July 23, 2018",
    "Current Ver": 2.180723,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Kiddopia - Preschool Learning Games",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 64,
    Size: "81M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.1.2",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Toca Mystery House",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 96,
    Size: "79M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Educational;Creativity",
    "Last Updated": "June 14, 2018",
    "Current Ver": "1.0.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DisneyNOW – TV Shows & Games",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 82471,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Papumba Academy - Fun Learning For Kids",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 496,
    Size: "94M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "July 11, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Super ABC! Learning games for kids! Preschool apps",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 20267,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "July 16, 2018",
    "Current Ver": "1.1.6.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Drawing for Kids Learning Games for Toddlers age 3",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 29436,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "March 21, 2018",
    "Current Ver": "2.0.5.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Baby Panda’s Juice Shop",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 19230,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Brain Games",
    "Last Updated": "July 12, 2018",
    "Current Ver": "8.25.10.01",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Dr. Panda Restaurant 3",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 11126,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "March 23, 2018",
    "Current Ver": "1.6.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "LEGO® Friends: Heartlake Rush",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 23671,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade;Pretend Play",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.2.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Baby ABC in box! Kids alphabet games for toddlers!",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 9652,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "July 16, 2018",
    "Current Ver": "2.0.7.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Henry Danger Crime Warp",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 9626,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action;Action & Adventure",
    "Last Updated": "February 7, 2018",
    "Current Ver": 1.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Thomas & Friends: Race On!",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 29319,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "May 18, 2018",
    "Current Ver": 2.4,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Super School: Educational Kids Games & Rhymes",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 1791,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "June 2, 2018",
    "Current Ver": "5.3.11",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Fruit Cube Blast",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 9199,
    Size: "80M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.2.7",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Toddler Kids Puzzles PUZZINGO",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 14014,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "July 6, 2018",
    "Current Ver": 7.32,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Happy Street",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 110877,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "March 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Intellijoy Early Learning Academy",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 160,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "June 18, 2018",
    "Current Ver": "3.4.0",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Dr. Panda Town: Vacation",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 10366,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.2.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Leo and Tig",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 47644,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure;Action & Adventure",
    "Last Updated": "May 31, 2018",
    "Current Ver": 10.18053,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "School of Dragons",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 530792,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing;Action & Adventure",
    "Last Updated": "May 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Fuzzy Seasons: Animal Forest",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 12137,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Simulation;Pretend Play",
    "Last Updated": "August 6, 2018",
    "Current Ver": 149,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Montessori Preschool",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 237,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.7.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Kids Corner: Interactive Tales and Games for kids",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 6404,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Brain Games",
    "Last Updated": "July 16, 2018",
    "Current Ver": "1.8.3",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Cutie Cubies",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 6356,
    Size: "83M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Creativity",
    "Last Updated": "July 4, 2018",
    "Current Ver": 1.180702,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "My Little Princess : Stores",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 169,
    Size: "60M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "May 25, 2018",
    "Current Ver": 1.08,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Sago Mini Big City",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 8,
    Size: "44M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "July 9, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Pinkalicious Party",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 2,
    Size: "82M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Educational;Creativity",
    "Last Updated": "June 25, 2018",
    "Current Ver": "1.5.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "ROBLOX",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 4450855,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Adventure;Action & Adventure",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.347.225742",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "PJ Masks: Moonlight Heroes",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 86961,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "June 5, 2018",
    "Current Ver": "2.0.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Minion Rush: Despicable Me Official Game",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 10216997,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "July 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Dog Run - Pet Dog Simulator",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 48701,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation;Action & Adventure",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.4.12",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Moana Island Life",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 15246,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation;Action & Adventure",
    "Last Updated": "July 12, 2017",
    "Current Ver": "3.2.473.202",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hot Wheels: Race Off",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 520654,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "June 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Basketball FRVR - Shoot the Hoop and Slam Dunk!",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 4076,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports;Action & Adventure",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.3.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Farming Simulator 14",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 530904,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation;Action & Adventure",
    "Last Updated": "July 17, 2017",
    "Current Ver": "1.4.4",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "My Oasis - Calming and Relaxing Idle Clicker Game",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 106750,
    Size: "94M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation;Action & Adventure",
    "Last Updated": "June 29, 2018",
    "Current Ver": 1.221,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "My Little Pony Rainbow Runners",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 33785,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "December 20, 2017",
    "Current Ver": 1.3,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Extreme Racing 2 - Real driving RC cars game!",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 4207,
    Size: "93M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "August 31, 2017",
    "Current Ver": "1.1.9",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Cars: Lightning League",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 58795,
    Size: "77M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "May 21, 2018",
    "Current Ver": 1.6,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Little Panda Run",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 3235,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Action & Adventure",
    "Last Updated": "June 20, 2018",
    "Current Ver": "8.25.10.00",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Snoopy's Town Tale - City Building Simulator",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 47031,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation;Action & Adventure",
    "Last Updated": "July 30, 2018",
    "Current Ver": "3.2.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Car Racing game for Kids - Beepzz Dogs 🐕",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 131,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "June 13, 2018",
    "Current Ver": "1.1.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Pony Friends 🦄 - Beepzz racing game for kids",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 114,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "June 13, 2018",
    "Current Ver": "1.4.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "LEGO® Juniors Create & Cruise",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 673203,
    Size: "73M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Action & Adventure",
    "Last Updated": "January 19, 2018",
    "Current Ver": "6.7.5222",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Xtreme Racing 2018 - Jeep & 4x4 off road simulator",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 2178,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "August 23, 2017",
    "Current Ver": "1.0.8",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Thomas & Friends: Go Go Thomas",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 175625,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "November 22, 2017",
    "Current Ver": 1.4,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Ninja Dash - Ronin Jump RPG",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 8508,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade;Action & Adventure",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.1.23",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Paw Patrol by ShuffleCards",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 3484,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Action & Adventure",
    "Last Updated": "March 7, 2017",
    "Current Ver": "1.0.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Plants vs. Zombies™ Heroes",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 379415,
    Size: "68M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "June 26, 2018",
    "Current Ver": "1.28.01",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Transformers Rescue Bots: Disaster Dash",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 19245,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "March 28, 2018",
    "Current Ver": 1.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Mcqueen Coloring pages",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 65,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design;Action & Adventure",
    "Last Updated": "March 7, 2018",
    "Current Ver": "1.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "PAC-MAN Pop",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 24877,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Action & Adventure",
    "Last Updated": "June 20, 2018",
    "Current Ver": "2.1.6579",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Monster Truck Driver & Racing",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 765,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Action & Adventure",
    "Last Updated": "January 19, 2017",
    "Current Ver": "1.0.9",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "L.O.L. Surprise Ball Pop",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 10088,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "March 8, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Strawberry Shortcake BerryRush",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 525552,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action;Action & Adventure",
    "Last Updated": "October 15, 2017",
    "Current Ver": "1.2.3",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Little Fire Station",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 3762,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Action & Adventure",
    "Last Updated": "July 2, 2018",
    "Current Ver": 1.47,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ice Cream Jump",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 141363,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "January 21, 2018",
    "Current Ver": "1.20.2",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Disney Magic Kingdoms: Build Your Own Magical Park",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 472584,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation;Action & Adventure",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.2.0h",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Turbo FAST",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1329192,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "October 4, 2017",
    "Current Ver": "2.1.20",
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "My Little Pony: Harmony Quest",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 148295,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "March 5, 2018",
    "Current Ver": 1.6,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Transformers Rescue Bots: Hero Adventures",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 41273,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure;Action & Adventure",
    "Last Updated": "July 5, 2018",
    "Current Ver": 1.5,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Robots Vs Zombies: Transform To Race And Fight",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 278,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "July 11, 2018",
    "Current Ver": 3.49,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Equestria Girls",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 392596,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing;Action & Adventure",
    "Last Updated": "July 22, 2016",
    "Current Ver": 37893,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DC Super Hero Girls™",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 43060,
    Size: "95M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action;Action & Adventure",
    "Last Updated": "June 29, 2018",
    "Current Ver": "2.8.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Disney Crossy Road",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 514088,
    Size: "83M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade;Action & Adventure",
    "Last Updated": "May 30, 2018",
    "Current Ver": "3.200.18289",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Touch Racing 2 - Mini RC Race",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 41867,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "May 18, 2017",
    "Current Ver": "1.4.2.1",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Toca Kitchen 2",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 1014846,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "June 29, 2017",
    "Current Ver": "1.2.3-play",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Doctor Pets",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 23060,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1.19,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Supermarket – Game for Kids",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 112080,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1.24,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Supermarket Manager: Cashier Simulator Kids Games",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 15489,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "October 11, 2017",
    "Current Ver": "2.4.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Kids Animals Jigsaw Puzzles 😄",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 51895,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Brain Games",
    "Last Updated": "June 16, 2018",
    "Current Ver": 18.1,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DC Super Hero Girls™",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 43060,
    Size: "95M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action;Action & Adventure",
    "Last Updated": "June 29, 2018",
    "Current Ver": "2.8.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Strawberry Shortcake BerryRush",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 525552,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action;Action & Adventure",
    "Last Updated": "October 15, 2017",
    "Current Ver": "1.2.3",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Inside Out Thought Bubbles",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 623398,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "August 31, 2017",
    "Current Ver": "1.22.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Disney Magic Kingdoms: Build Your Own Magical Park",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 472584,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation;Action & Adventure",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.2.0h",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Monster High™",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 66661,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "February 2, 2018",
    "Current Ver": 5.2,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Cute Pet Puppies",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 10447,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation;Action & Adventure",
    "Last Updated": "February 18, 2016",
    "Current Ver": "1.0.4",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Frozen Free Fall",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1574197,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Action & Adventure",
    "Last Updated": "July 27, 2018",
    "Current Ver": "6.7.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Monster High™ Minis Mania",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 19170,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy;Action & Adventure",
    "Last Updated": "March 15, 2017",
    "Current Ver": "1.4.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Shopkins World!",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 169609,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade;Action & Adventure",
    "Last Updated": "June 13, 2018",
    "Current Ver": "3.6.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Monica Toy TV",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 6188,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "April 3, 2018",
    "Current Ver": "1.6.4",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Toy Guitar with songs for kids",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1369,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music & Audio;Music & Video",
    "Last Updated": "March 5, 2016",
    "Current Ver": "1.0.3",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Endless Numbers",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 2952,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "June 19, 2018",
    "Current Ver": "1.2.0",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Toddler Learning Games - Little Kids Games",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 731,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "July 28, 2018",
    "Current Ver": "3.7.2.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Sworkit Kids - Fitness Meets Fun",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 9856,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness;Education",
    "Last Updated": "February 2, 2016",
    "Current Ver": "1.1.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Earth to Luna! Watch and Play",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 10753,
    Size: "84M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.5.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Nancy Drew Codes and Clues",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 154,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "January 13, 2017",
    "Current Ver": "2.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Masha and the Bear Child Games",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 288523,
    Size: "92M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure;Education",
    "Last Updated": "May 8, 2018",
    "Current Ver": "2.7.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "codeSpark Academy & The Foos",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 4522,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "June 21, 2018",
    "Current Ver": "2.19.01",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Toca Builders",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 3328,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Education;Creativity",
    "Last Updated": "July 13, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Toca Life: City",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 31100,
    Size: "24M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "July 6, 2018",
    "Current Ver": "1.5-play",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "LEGO® Friends",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 854,
    Size: "6.9M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "December 1, 2015",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "My Little Work – Garage",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 560,
    Size: "44M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Casual;Education",
    "Last Updated": "June 17, 2015",
    "Current Ver": "2.0.1",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Alizay, pirate girl",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 197,
    Size: "11M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "March 23, 2017",
    "Current Ver": "4.0.2",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Word Search Games in english",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 63186,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "July 12, 2018",
    "Current Ver": 7.5,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Chess Free",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 23772,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board;Brain Games",
    "Last Updated": "August 2, 2017",
    "Current Ver": "1.15.3028.0",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Tic Tac Toe",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 6007,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board;Action & Adventure",
    "Last Updated": "July 3, 2017",
    "Current Ver": "1.6.3028.0",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Dominos Game ✔️",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 2903,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board;Brain Games",
    "Last Updated": "July 5, 2018",
    "Current Ver": 5.2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Checkers ✔️",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 3617,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board;Brain Games",
    "Last Updated": "July 24, 2018",
    "Current Ver": "4.0.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Crazy Colors: Bubbles Matching",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 3063,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board;Brain Games",
    "Last Updated": "May 24, 2018",
    "Current Ver": "2.9.7",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Chess for Kids - Play & Learn",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 3234,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "May 15, 2018",
    "Current Ver": "2.2.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Block Puzzle : Night in Egypt",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 276,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "September 12, 2017",
    "Current Ver": "1.2.16",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Mosaic puzzles",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 1595,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "July 4, 2018",
    "Current Ver": 2.8,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Chess School for Beginners",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 879,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board;Brain Games",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "RISK: Global Domination",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 68559,
    Size: "75M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board;Action & Adventure",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.19.56.434",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Pino chess",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 61,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Brain Games",
    "Last Updated": "January 26, 2017",
    "Current Ver": "0.1.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Chess PRO Free",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 1123,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board;Brain Games",
    "Last Updated": "September 8, 2016",
    "Current Ver": 4.2,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Children Educational Game Full",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 30,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$7.49",
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "May 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "All-in-One Mahjong 3 FREE",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 566,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board;Brain Games",
    "Last Updated": "June 13, 2018",
    "Current Ver": 20180609,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Hactar Go",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 97,
    Size: "3.5M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Board;Brain Games",
    "Last Updated": "March 30, 2018",
    "Current Ver": "2.4.15",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "All-in-One Mahjong 3",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 38,
    Size: "16M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Board;Brain Games",
    "Last Updated": "June 14, 2018",
    "Current Ver": 20180609,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "World Racers family board game",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 4,
    Size: "42M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Board;Pretend Play",
    "Last Updated": "September 3, 2015",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "SweetLand — Family Board Game",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 38,
    Size: "47M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "November 14, 2014",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Steam: Rails to Riches",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 214,
    Size: "67M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Board;Brain Games",
    "Last Updated": "December 13, 2017",
    "Current Ver": "3.3.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Whoowasit? - Best kids game!",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 248,
    Size: "26M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Board;Action & Adventure",
    "Last Updated": "July 24, 2018",
    "Current Ver": 1.6,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Lanterns: The Harvest Festival",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 185,
    Size: "72M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Board;Brain Games",
    "Last Updated": "May 1, 2018",
    "Current Ver": "1.16.5",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Tsuro - The Game of the Path",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 2195,
    Size: "37M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Board;Brain Games",
    "Last Updated": "August 2, 2016",
    "Current Ver": "1.3.3",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "THE aMAZEing Labyrinth",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 1615,
    Size: "1.2M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Board;Brain Games",
    "Last Updated": "February 9, 2016",
    "Current Ver": "1.0.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Chess and Mate",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 359,
    Size: "17M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Board;Brain Games",
    "Last Updated": "August 12, 2015",
    "Current Ver": "2.0.5",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Kids Balloon Pop Game Free 🎈",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 38021,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Music & Video",
    "Last Updated": "July 6, 2018",
    "Current Ver": 18.2,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Sounds for Toddlers FREE",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 6190,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "August 24, 2015",
    "Current Ver": "1.7.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Elmo Calls by Sesame Street",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 6903,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "January 31, 2018",
    "Current Ver": "2.0.7",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Sago Mini Friends",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 13155,
    Size: "83M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "June 16, 2016",
    "Current Ver": 1.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Papumba Academy - Fun Learning For Kids",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 496,
    Size: "94M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "July 11, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Tee and Mo Bath Time Free",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 418,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "November 7, 2016",
    "Current Ver": "1.0.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Bita and the Animals - Pelos Ares",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 1160,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Music & Video",
    "Last Updated": "May 22, 2013",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "TO-FU Oh!SUSHI",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 59917,
    Size: "92M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "July 31, 2018",
    "Current Ver": 2.3,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "DreamWorks Friends",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 1042,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing;Pretend Play",
    "Last Updated": "August 4, 2017",
    "Current Ver": 2.5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Avokiddo Emotions",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 73,
    Size: "12M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "May 21, 2018",
    "Current Ver": "1.7.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Nighty Night Circus",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 382,
    Size: "15M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Education;Action & Adventure",
    "Last Updated": "March 7, 2017",
    "Current Ver": 2.6,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Sago Mini Babies",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 253,
    Size: "83M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "October 28, 2016",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Dr. Panda & Toto's Treehouse",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 3396,
    Size: "9.5M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "December 9, 2014",
    "Current Ver": 1.8,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Kids Balloon Pop Game Free 🎈",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 38021,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Music & Video",
    "Last Updated": "July 6, 2018",
    "Current Ver": 18.2,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Sounds for Toddlers FREE",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 6190,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "August 24, 2015",
    "Current Ver": "1.7.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Elmo Calls by Sesame Street",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 6903,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "January 31, 2018",
    "Current Ver": "2.0.7",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Sago Mini Friends",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 13155,
    Size: "83M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "June 16, 2016",
    "Current Ver": 1.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Papumba Academy - Fun Learning For Kids",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 496,
    Size: "94M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "July 11, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Tee and Mo Bath Time Free",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 418,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "November 7, 2016",
    "Current Ver": "1.0.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Bita and the Animals - Pelos Ares",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 1160,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Music & Video",
    "Last Updated": "May 22, 2013",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "TO-FU Oh!SUSHI",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 59917,
    Size: "92M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "July 31, 2018",
    "Current Ver": 2.3,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "DreamWorks Friends",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 1042,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing;Pretend Play",
    "Last Updated": "August 4, 2017",
    "Current Ver": 2.5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Avokiddo Emotions",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 73,
    Size: "12M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "May 21, 2018",
    "Current Ver": "1.7.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Nighty Night Circus",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 382,
    Size: "15M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Education;Action & Adventure",
    "Last Updated": "March 7, 2017",
    "Current Ver": 2.6,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Sago Mini Babies",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 253,
    Size: "83M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "October 28, 2016",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Dr. Panda & Toto's Treehouse",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 3396,
    Size: "9.5M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "December 9, 2014",
    "Current Ver": 1.8,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "ROBLOX",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 4450890,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Adventure;Action & Adventure",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.347.225742",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "PlayKids - Educational cartoons and games for kids",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 182173,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "YouTube Kids",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 470713,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.43.3",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Fun Kid Racing - Motocross",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 59729,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "June 27, 2018",
    "Current Ver": 3.46,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Barbie Life™",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 133117,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "July 12, 2018",
    "Current Ver": 2.6,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Baby Panda Care",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 108795,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "June 15, 2018",
    "Current Ver": "8.25.10.00",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Palace Pets in Whisker Haven",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 47213,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Pretend Play",
    "Last Updated": "December 9, 2017",
    "Current Ver": 1.8,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Sweet Baby Girl - Dream House and Play Time",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 95537,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "July 13, 2018",
    "Current Ver": "2.2.54",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Monster High™",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 66660,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "February 2, 2018",
    "Current Ver": 5.2,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Hello Kitty Lunchbox",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 51838,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Creativity",
    "Last Updated": "November 21, 2017",
    "Current Ver": 1.6,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Duolingo: Learn Languages Free",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 6294397,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Sweet Baby Girl Newborn Baby",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 36028,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "July 2, 2018",
    "Current Ver": "1.3.51",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "COOKING MAMA Let's Cook!",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 528745,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.38.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Shopkins World!",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 169609,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade;Action & Adventure",
    "Last Updated": "June 13, 2018",
    "Current Ver": "3.6.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DisneyNOW – TV Shows & Games",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 82471,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Ever After High™ Charmed Style",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 44062,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "December 30, 2016",
    "Current Ver": 1.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Equestria Girls",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 392596,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing;Action & Adventure",
    "Last Updated": "July 22, 2016",
    "Current Ver": 37893,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Fun Kid Racing",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 79667,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "August 3, 2018",
    "Current Ver": 3.52,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Learn to Read with Tommy Turtle",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 20763,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "March 6, 2018",
    "Current Ver": "3.6.17",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Frozen Free Fall",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1574204,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Action & Adventure",
    "Last Updated": "July 27, 2018",
    "Current Ver": "6.7.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Nick",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 123322,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "January 24, 2018",
    "Current Ver": "2.0.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Thomas & Friends: Race On!",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 29319,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "May 18, 2018",
    "Current Ver": 2.4,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Mad Libs",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 8126,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Brain Games",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.1.1",
    numInstall: 1000000,
    numAndroid: 6,
  },
  {
    App: "Inside Out Thought Bubbles",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 623398,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "August 31, 2017",
    "Current Ver": "1.22.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ABCmouse.com",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 50887,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "July 3, 2018",
    "Current Ver": "7.2.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "My Little Pony Celebration",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 63160,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation;Pretend Play",
    "Last Updated": "July 22, 2016",
    "Current Ver": "1.0.0",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Sago Mini Friends",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 13155,
    Size: "83M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "June 16, 2016",
    "Current Ver": 1.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Thomas & Friends: Delivery",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 28737,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "February 5, 2016",
    "Current Ver": 1,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "School of Dragons",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 530792,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing;Action & Adventure",
    "Last Updated": "May 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Nasty Goats",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 45579,
    Size: "64M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade;Action & Adventure",
    "Last Updated": "April 14, 2016",
    "Current Ver": "1.1.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Starfall Free & Member",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 19720,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "November 7, 2017",
    "Current Ver": "1.35.23",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Animal Jam - Play Wild!",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 361970,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "August 2, 2018",
    "Current Ver": "28.0.14",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Video Editor",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 159619,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors;Creativity",
    "Last Updated": "July 17, 2018",
    "Current Ver": "6.14.091",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Real Racing 3",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 354384,
    Size: "71M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "July 2, 2018",
    "Current Ver": "6.4.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Peak – Brain Games & Training",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 272321,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Brain Games",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.14.15",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Minecraft",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 2376564,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$6.99",
    "Content Rating": "Everyone 10+",
    Genres: "Arcade;Action & Adventure",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.5.2.1",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Card Wars - Adventure Time",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 129603,
    Size: "23M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone 10+",
    Genres: "Card;Action & Adventure",
    "Last Updated": "February 11, 2016",
    "Current Ver": "1.11.0",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Monash Uni Low FODMAP Diet",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 1135,
    Size: "12M",
    Type: "Paid",
    Price: "$9.00",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 16, 2018",
    "Current Ver": "2.0.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "iBP Blood Pressure",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 578,
    Size: "704k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "November 30, 2014",
    "Current Ver": "7.0.1",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Pedi STAT",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 129,
    Size: "2.9M",
    Type: "Paid",
    Price: "$5.49",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 6, 2018",
    "Current Ver": "3.0.1.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "ASCCP Mobile",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 63,
    Size: "25M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 3, 2016",
    "Current Ver": "2.1.1",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Journal Club: Medicine",
    Category: "MEDICAL",
    Rating: 4.8,
    Reviews: 216,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$6.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 17, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "Paramedic Protocol Provider",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 171,
    Size: "20M",
    Type: "Paid",
    Price: "$10.00",
    "Content Rating": "Everyone 10+",
    Genres: "Medical",
    "Last Updated": "September 21, 2017",
    "Current Ver": "1.8.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "MommyMeds",
    Category: "MEDICAL",
    Rating: 3.2,
    Reviews: 45,
    Size: "21M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "November 15, 2017",
    "Current Ver": "2.0.1",
    numInstall: 5000,
    numAndroid: 6,
  },
  {
    App: "Medical ID - In Case of Emergency (ICE)",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 717,
    Size: "5.4M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 31, 2018",
    "Current Ver": "6.5.0",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "Human Anatomy Atlas 2018: Complete 3D Human Body",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 2921,
    Size: "25M",
    Type: "Paid",
    Price: "$24.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 25, 2018",
    "Current Ver": "2018.5.47",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Essential Anatomy 3",
    Category: "MEDICAL",
    Rating: 4.1,
    Reviews: 1533,
    Size: "42M",
    Type: "Paid",
    Price: "$11.99",
    "Content Rating": "Mature 17+",
    Genres: "Medical",
    "Last Updated": "August 7, 2014",
    "Current Ver": "1.1.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Vargo Anesthesia Mega App",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 92,
    Size: "32M",
    Type: "Paid",
    Price: "$79.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 18, 2018",
    "Current Ver": 19,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EMT Review Plus",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 199,
    Size: "1.8M",
    Type: "Paid",
    Price: "$11.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 27, 2018",
    "Current Ver": "3.0.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Muscle Trigger Point Anatomy",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 1361,
    Size: "33M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 17, 2018",
    "Current Ver": "2.4.4",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "2017 EMRA Antibiotic Guide",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 12,
    Size: "3.8M",
    Type: "Paid",
    Price: "$16.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 27, 2017",
    "Current Ver": "1.0.5",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "ASRA Coags",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 15,
    Size: "5.8M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 1, 2018",
    "Current Ver": 2.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "IBM Micromedex Drug Info",
    Category: "MEDICAL",
    Rating: 3.8,
    Reviews: 206,
    Size: "9.5M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 25, 2018",
    "Current Ver": "1.17.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Diabetes & Diet Tracker",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 395,
    Size: "19M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 16, 2018",
    "Current Ver": "6.5.1",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "VeinSeek",
    Category: "MEDICAL",
    Rating: 2.5,
    Reviews: 79,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "December 6, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "Block Buddy",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 15,
    Size: "5.0M",
    Type: "Paid",
    Price: "$14.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 1, 2018",
    "Current Ver": "7.6.14",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Super Hearing Secret Voices Recorder PRO",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 3,
    Size: "23M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 20, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EMT Study - NREMT Test Prep",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 35,
    Size: "862k",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "December 3, 2014",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Calcium Pro",
    Category: "MEDICAL",
    Rating: 3.4,
    Reviews: 77,
    Size: "9.9M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 18, 2017",
    "Current Ver": "1.6.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Arrhythmias and Dysrhythmias",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 3,
    Size: "24M",
    Type: "Paid",
    Price: "$1.00",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 24, 2016",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "EMT PASS",
    Category: "MEDICAL",
    Rating: 3.4,
    Reviews: 51,
    Size: "2.4M",
    Type: "Paid",
    Price: "$29.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 22, 2014",
    "Current Ver": "2.0.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Pocket Lab Values",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 214,
    Size: "899k",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "November 22, 2012",
    "Current Ver": 2.5,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Medical terms (OFFLINE)",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 104,
    Size: "38M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Teen",
    Genres: "Medical",
    "Last Updated": "May 24, 2018",
    "Current Ver": "3.2.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Cardiac diagnosis (heart rate, arrhythmia)",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 8,
    Size: "6.5M",
    Type: "Paid",
    Price: "$12.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 25, 2018",
    "Current Ver": 7,
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "ERres- Emergency Medicine",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 45,
    Size: "14M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 18, 2015",
    "Current Ver": 6,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FHR 5-Tier 2.0",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 2,
    Size: "1.2M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "December 16, 2015",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "AnatomyMapp",
    Category: "MEDICAL",
    Rating: 4.1,
    Reviews: 80,
    Size: "48M",
    Type: "Paid",
    Price: "$14.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "November 5, 2013",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "OptoDrum",
    Category: "MEDICAL",
    Rating: 3.9,
    Reviews: 10,
    Size: "378k",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 26, 2015",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Migraine, Headache Diary HeadApp Pro",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 156,
    Size: "22M",
    Type: "Paid",
    Price: "$3.49",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 14, 2018",
    "Current Ver": "1.10.0.user.pro.release",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Blood Pressure Companion",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 178,
    Size: "4.8M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 22, 2018",
    "Current Ver": "4.1.5 (Steglitz)",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Visual Anatomy 2",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 576,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 5, 2017",
    "Current Ver": "Varies with device",
    numInstall: 5000,
    numAndroid: null,
  },
  {
    App: "Muscle Premium - Human Anatomy, Kinesiology, Bones",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 168,
    Size: "25M",
    Type: "Paid",
    Price: "$24.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 11, 2017",
    "Current Ver": "7.1.17",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CCHT PREP",
    Category: "MEDICAL",
    Rating: 3.6,
    Reviews: 25,
    Size: "266k",
    Type: "Paid",
    Price: "$10.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "December 8, 2016",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Paramedic Meds",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 163,
    Size: "375k",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 3, 2015",
    "Current Ver": "3.4.3",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "Advanced Comprehension Therapy",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 3,
    Size: "62M",
    Type: "Paid",
    Price: "$24.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 5, 2017",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "OmniMedix Medical Calculator",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 25,
    Size: "1.2M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 11, 2016",
    "Current Ver": "3.1.6",
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Breathing Zone",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 319,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000,
    numAndroid: null,
  },
  {
    App: "Lab Values + Medical Reference",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 133,
    Size: "2.8M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 2, 2014",
    "Current Ver": 3,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Recognise Foot",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 9,
    Size: "95M",
    Type: "Paid",
    Price: "$7.49",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "September 14, 2017",
    "Current Ver": "1.0.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Anti Mosquito simulation",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 74,
    Size: "2.6M",
    Type: "Paid",
    Price: "$1.50",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "September 6, 2014",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Pain Tracker & Diary",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 3,
    Size: "4.6M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 2, 2018",
    "Current Ver": 1.5,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Menstrual Calendar Premium",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 4207,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 26, 2013",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Whist - Tinnitus Relief",
    Category: "MEDICAL",
    Rating: 4.1,
    Reviews: 12,
    Size: "5.1M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 2, 2017",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Critical Care Paramedic Review",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 17,
    Size: "1.8M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Everyone 10+",
    Genres: "Medical",
    "Last Updated": "May 14, 2018",
    "Current Ver": "2.0.5",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "With Helper Pro Pill Reminder",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 358,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 25, 2017",
    "Current Ver": "Varies with device",
    numInstall: 5000,
    numAndroid: null,
  },
  {
    App: "Manage My Pain Pro",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 726,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000,
    numAndroid: null,
  },
  {
    App: "End Anxiety Pro - Stress, Panic Attack Help",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 33,
    Size: "53M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 8, 2018",
    "Current Ver": 2.29,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Acupuncture Assistant",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 492,
    Size: "39M",
    Type: "Paid",
    Price: "$7.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 13, 2018",
    "Current Ver": "4.4.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Number Therapy",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.3M",
    Type: "Paid",
    Price: "$14.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 3, 2017",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "InfantRisk Center HCP",
    Category: "MEDICAL",
    Rating: 2.6,
    Reviews: 41,
    Size: "14M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 6, 2015",
    "Current Ver": "1.3.4",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "EMT Tutor NREMT-B Study Guide",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 625,
    Size: "8.4M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 8, 2017",
    "Current Ver": 2.1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Hospitalist Handbook",
    Category: "MEDICAL",
    Rating: 4.8,
    Reviews: 12,
    Size: "18M",
    Type: "Paid",
    Price: "$19.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 5, 2017",
    "Current Ver": "6.0.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "PTA Content Master",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 64,
    Size: "41M",
    Type: "Paid",
    Price: "$29.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "December 22, 2015",
    "Current Ver": 2.1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Navi Radiography Pro",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 11,
    Size: "100M",
    Type: "Paid",
    Price: "$15.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 14, 2018",
    "Current Ver": "1.2.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Nursing Care Plan NANDA Tables",
    Category: "MEDICAL",
    Rating: 3,
    Reviews: 4,
    Size: "3.4M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 9, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "A Manual of Acupuncture",
    Category: "MEDICAL",
    Rating: 3.5,
    Reviews: 214,
    Size: "68M",
    Type: "Paid",
    Price: "$33.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 2, 2017",
    "Current Ver": "2.1.35",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "palmPEDi: Pediatric Tape",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 66,
    Size: "2.6M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "December 2, 2013",
    "Current Ver": 4.1,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "GoodRx Drug Prices and Coupons",
    Category: "MEDICAL",
    Rating: 4.8,
    Reviews: 59158,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 26, 2018",
    "Current Ver": "5.4.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "MyChart",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 19473,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "FollowMyHealth®",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 73118,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 10, 2018",
    "Current Ver": 3.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CareZone",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 27524,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Ovia Pregnancy Tracker & Baby Countdown Calendar",
    Category: "MEDICAL",
    Rating: 4.8,
    Reviews: 102858,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.2.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Teladoc Member",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 2094,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 26, 2018",
    "Current Ver": 3.19,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "myAir™ for Air10™ by ResMed",
    Category: "MEDICAL",
    Rating: 3.7,
    Reviews: 236,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.1.0.0.1487",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "Blood Pressure",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 33033,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 24, 2018",
    "Current Ver": "3.27.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Pregnancy Week By Week",
    Category: "MEDICAL",
    Rating: 4.8,
    Reviews: 78825,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.2.16",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Doctor On Demand",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 18674,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 27, 2018",
    "Current Ver": "3.25.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BioLife Plasma Services",
    Category: "MEDICAL",
    Rating: 3.5,
    Reviews: 250,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 9, 2018",
    "Current Ver": "1.2.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "OneTouch Reveal",
    Category: "MEDICAL",
    Rating: 3.9,
    Reviews: 6266,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 22, 2018",
    "Current Ver": 3.5,
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "To",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 22,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "Ovia Fertility Tracker & Ovulation Calculator",
    Category: "MEDICAL",
    Rating: 4.8,
    Reviews: 53743,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Anthem Anywhere",
    Category: "MEDICAL",
    Rating: 2.7,
    Reviews: 2657,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 27, 2018",
    "Current Ver": "8.0.226",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Blood Donor",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 4476,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.6.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "My Calendar - Period Tracker",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 156410,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 3, 2018",
    "Current Ver": "5.9.6",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Youper - AI Therapy",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 2006,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 3, 2018",
    "Current Ver": "6.02.000",
    numInstall: 50000,
    numAndroid: 6,
  },
  {
    App: "Zocdoc: Find Doctors & Book Appointments",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 6099,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.18.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "1800 Contacts - Lens Store",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 23160,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 27, 2018",
    "Current Ver": "7.4.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Blood Pressure Log - MyDiary",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 8348,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 13, 2018",
    "Current Ver": "1.4.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "PulsePoint Respond",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 7837,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 31, 2018",
    "Current Ver": 2.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Ovia Parenting & Baby Development Tracker",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 6185,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.2.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "MyQuest for Patients",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 3803,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 13, 2018",
    "Current Ver": 2.17,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "OptumRx",
    Category: "MEDICAL",
    Rating: 3.4,
    Reviews: 1838,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 2, 2018",
    "Current Ver": "2.11.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CVS Caremark",
    Category: "MEDICAL",
    Rating: 3.5,
    Reviews: 3707,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 28, 2018",
    "Current Ver": 4.36,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "fred's Pharmacy",
    Category: "MEDICAL",
    Rating: 3,
    Reviews: 315,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 10, 2017",
    "Current Ver": "1.0.02",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Ada - Your Health Guide",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 87418,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 16, 2018",
    "Current Ver": "2.25.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "mySugr: the blood sugar tracker made just for you",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 21189,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 6, 2018",
    "Current Ver": "3.52.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "ClearCareGo Caregiver",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 1746,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 25, 2018",
    "Current Ver": "2.1.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Pregnancy Calculator and Tracker app",
    Category: "MEDICAL",
    Rating: 4.8,
    Reviews: 69126,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 1, 2018",
    "Current Ver": "2.6.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "All Mental disorders",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 453,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 7, 2017",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DreamMapper",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 10710,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 3, 2018",
    "Current Ver": 2.15,
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "ScriptSave WellRx Rx Discounts",
    Category: "MEDICAL",
    Rating: 3.8,
    Reviews: 700,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 21, 2018",
    "Current Ver": "3.3.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Delta Dental",
    Category: "MEDICAL",
    Rating: 3,
    Reviews: 914,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 17, 2018",
    "Current Ver": "4.6.0",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Drugs.com Medication Guide",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 15875,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "MoodSpace",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 503,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 10, 2018",
    "Current Ver": "3.2.4",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "Pill Identifier and Drug list",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 488,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 1, 2018",
    "Current Ver": 3.8,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "HealtheLife",
    Category: "MEDICAL",
    Rating: 3.6,
    Reviews: 190,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 2, 2018",
    "Current Ver": "2.4.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "SonicCloud: Hearing App",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 15,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.16.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Migraine Buddy - The Migraine and Headache tracker",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 26862,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 25, 2018",
    "Current Ver": "25.3.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Period Tracker",
    Category: "MEDICAL",
    Rating: 4.9,
    Reviews: 100082,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 9, 2018",
    "Current Ver": "1.2.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "LabCorp | Patient",
    Category: "MEDICAL",
    Rating: 3.6,
    Reviews: 27,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 19, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Anatomy Learning - 3D Atlas",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 72167,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 18, 2018",
    "Current Ver": 2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Super Hearing Super Ear Amplifier",
    Category: "MEDICAL",
    Rating: 4.1,
    Reviews: 21,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 11, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Moodpath - Depression & Anxiety Test",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 6035,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.2.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Teach Me Anatomy",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 9945,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 5, 2018",
    "Current Ver": 5.11,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Baritastic - Bariatric Tracker",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 4318,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.3.185",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Brilliant Distinctions®",
    Category: "MEDICAL",
    Rating: 2.8,
    Reviews: 78,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 27, 2018",
    "Current Ver": "2.2.12",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Mayo Clinic",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 2218,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "98point6",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 47,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.7.1 (946)",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Epocrates Plus",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 23889,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "MDLIVE: Talk to a Doctor 24/7",
    Category: "MEDICAL",
    Rating: 3.4,
    Reviews: 650,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 23, 2018",
    "Current Ver": "4.23.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Free Blood Pressure",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 7,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 13, 2016",
    "Current Ver": "3.0.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Super Ear",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 3498,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 1, 2018",
    "Current Ver": "1.7.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "VitusVet: Pet Health Care App",
    Category: "MEDICAL",
    Rating: 4.8,
    Reviews: 3052,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.8.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Banfield Pet Health Tracker",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 1747,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 17, 2016",
    "Current Ver": "1.2.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dexcom G6",
    Category: "MEDICAL",
    Rating: 3,
    Reviews: 45,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 16, 2018",
    "Current Ver": "1.2.3.2",
    numInstall: 5000,
    numAndroid: 6,
  },
  {
    App: "Nurse Grid",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 1686,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 30, 2018",
    "Current Ver": 2.9,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Castlight Mobile",
    Category: "MEDICAL",
    Rating: 3.7,
    Reviews: 529,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 30, 2018",
    "Current Ver": "4.4.7",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Sanford Guide:Antimicrobial Rx",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 1388,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 3, 2018",
    "Current Ver": "2.1.11",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Davis's Drug Guide for Nurses",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 572,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 13, 2018",
    "Current Ver": "4.3.2.315",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Vargo Anesthesia Mega App",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 92,
    Size: "32M",
    Type: "Paid",
    Price: "$79.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 18, 2018",
    "Current Ver": 19,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Monash Uni Low FODMAP Diet",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 1135,
    Size: "12M",
    Type: "Paid",
    Price: "$9.00",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 16, 2018",
    "Current Ver": "2.0.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "mySugr: the blood sugar tracker made just for you",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 21189,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 6, 2018",
    "Current Ver": "3.52.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "live Point",
    Category: "MEDICAL",
    Rating: 3.6,
    Reviews: 54,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Medical",
    "Last Updated": "July 3, 2018",
    "Current Ver": "2.6.5",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Tarascon Pharmacopoeia",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 275,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Medical",
    "Last Updated": "March 16, 2018",
    "Current Ver": "3.16.4.1669",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Official NBSTSA CST Exam Prep",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 2159,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 17, 2018",
    "Current Ver": "4.5.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EMT-B Pocket Prep",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 2951,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 11, 2018",
    "Current Ver": "4.5.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Human Anatomy Atlas 2018: Complete 3D Human Body",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 2921,
    Size: "25M",
    Type: "Paid",
    Price: "$24.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 25, 2018",
    "Current Ver": "2018.5.47",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "5-Minute Clinical Consult",
    Category: "MEDICAL",
    Rating: 4.1,
    Reviews: 84,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "December 11, 2017",
    "Current Ver": "2.7.36",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Diabetes:M",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 15545,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 1, 2018",
    "Current Ver": "6.1.3",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Pzizz - Sleep, Nap, Focus",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 5521,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 1, 2018",
    "Current Ver": "4.9.6",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "HESI A2 Pocket Prep",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 2108,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 2, 2018",
    "Current Ver": "4.5.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Johns Hopkins Guides ABX...",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 73,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "December 8, 2017",
    "Current Ver": "2.7.36",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "ASCCP Mobile",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 63,
    Size: "25M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 3, 2016",
    "Current Ver": "2.1.1",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "FP Notebook",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 408,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 24, 2018",
    "Current Ver": "2.1.0.372",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Paramedic Protocol Provider",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 171,
    Size: "20M",
    Type: "Paid",
    Price: "$10.00",
    "Content Rating": "Everyone 10+",
    Genres: "Medical",
    "Last Updated": "September 21, 2017",
    "Current Ver": "1.8.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "5 Minute Clinical Consult 2019 - #1 for 25 years",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 33,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 2, 2018",
    "Current Ver": "2.6.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Open Sesame - Touch Free Control",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 197,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.5.7",
    numInstall: 10000,
    numAndroid: 7,
  },
  {
    App: "Davis's Drug Guide",
    Category: "MEDICAL",
    Rating: 3.9,
    Reviews: 272,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "December 11, 2017",
    "Current Ver": "2.7.36",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Deep Sleep and Relax Hypnosis",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 4852,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 22, 2013",
    "Current Ver": 1.3,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "2017 EMRA Antibiotic Guide",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 12,
    Size: "3.8M",
    Type: "Paid",
    Price: "$16.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 27, 2017",
    "Current Ver": "1.0.5",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Essential Anatomy 3",
    Category: "MEDICAL",
    Rating: 4.1,
    Reviews: 1533,
    Size: "42M",
    Type: "Paid",
    Price: "$11.99",
    "Content Rating": "Mature 17+",
    Genres: "Medical",
    "Last Updated": "August 7, 2014",
    "Current Ver": "1.1.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EMT PASS",
    Category: "MEDICAL",
    Rating: 3.4,
    Reviews: 51,
    Size: "2.4M",
    Type: "Paid",
    Price: "$29.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 22, 2014",
    "Current Ver": "2.0.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Christella VoiceUp",
    Category: "MEDICAL",
    Rating: 4.1,
    Reviews: 38,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 12, 2018",
    "Current Ver": "2.1.4",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Block Buddy",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 15,
    Size: "5.0M",
    Type: "Paid",
    Price: "$14.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 1, 2018",
    "Current Ver": "7.6.14",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Language Therapy: Aphasia",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 10,
    Size: "28M",
    Type: "Paid",
    Price: "$74.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 25, 2018",
    "Current Ver": "3.1.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Complete Anatomy for Android",
    Category: "MEDICAL",
    Rating: 4.1,
    Reviews: 90,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 7,
  },
  {
    App: "GlassesOff",
    Category: "MEDICAL",
    Rating: 3.5,
    Reviews: 1288,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 10, 2018",
    "Current Ver": "1.0.0.10",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Free Hypnosis",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 4303,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "September 6, 2016",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "e-Anatomy",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 1545,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 30, 2018",
    "Current Ver": "4.8.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "EMT Review Plus",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 199,
    Size: "1.8M",
    Type: "Paid",
    Price: "$11.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 27, 2018",
    "Current Ver": "3.0.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Registered Dietitian Pocket Prep",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 283,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 12, 2018",
    "Current Ver": "4.5.3",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Paramedic Pocket Prep",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 460,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 12, 2018",
    "Current Ver": "4.5.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Journal Club: Medicine",
    Category: "MEDICAL",
    Rating: 4.8,
    Reviews: 216,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$6.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 17, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "Pedi STAT",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 129,
    Size: "2.9M",
    Type: "Paid",
    Price: "$5.49",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 6, 2018",
    "Current Ver": "3.0.1.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AnatomyMapp",
    Category: "MEDICAL",
    Rating: 4.1,
    Reviews: 80,
    Size: "48M",
    Type: "Paid",
    Price: "$14.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "November 5, 2013",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "Diabetes & Diet Tracker",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 395,
    Size: "19M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 16, 2018",
    "Current Ver": "6.5.1",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "A Manual of Acupuncture",
    Category: "MEDICAL",
    Rating: 3.5,
    Reviews: 214,
    Size: "68M",
    Type: "Paid",
    Price: "$33.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 2, 2017",
    "Current Ver": "2.1.35",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "5 Minute Veterinary Consult: Canine & Feline",
    Category: "MEDICAL",
    Rating: 2.3,
    Reviews: 17,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 29, 2018",
    "Current Ver": 2.6,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Wide address pocket prep",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 513,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 11, 2018",
    "Current Ver": "4.5.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Nursing Central",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 168,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 29, 2018",
    "Current Ver": "2.7.38",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "PTA Content Master",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 64,
    Size: "41M",
    Type: "Paid",
    Price: "$29.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "December 22, 2015",
    "Current Ver": 2.1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Muscle Premium - Human Anatomy, Kinesiology, Bones",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 168,
    Size: "25M",
    Type: "Paid",
    Price: "$24.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 11, 2017",
    "Current Ver": "7.1.17",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Tinnitus Alleviator",
    Category: "MEDICAL",
    Rating: 3.1,
    Reviews: 82,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "December 23, 2017",
    "Current Ver": "1.6.17",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Cardiac diagnosis (heart rate, arrhythmia)",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 8,
    Size: "6.5M",
    Type: "Paid",
    Price: "$12.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 25, 2018",
    "Current Ver": 7,
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "PMHNP-BC Pocket Prep",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 112,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 12, 2018",
    "Current Ver": "4.5.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Dialysis of Drugs",
    Category: "MEDICAL",
    Rating: 2.9,
    Reviews: 92,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 15, 2018",
    "Current Ver": "3.1-2018 – (13)",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "abeoCoder",
    Category: "MEDICAL",
    Rating: 3.1,
    Reviews: 83,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 30, 2018",
    "Current Ver": 6.6,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Saunders Comprehensive Review NCLEX-PN Examination",
    Category: "MEDICAL",
    Rating: 3.7,
    Reviews: 3,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 16, 2018",
    "Current Ver": "2.7.6",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "LTC AS Legal",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 6,
    Size: "1.3M",
    Type: "Paid",
    Price: "$39.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 4, 2018",
    "Current Ver": "3.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Lippincott Nursing Advisor",
    Category: "MEDICAL",
    Rating: 3.8,
    Reviews: 343,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 1, 2018",
    "Current Ver": "3.3.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Medical ID - In Case of Emergency (ICE)",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 717,
    Size: "5.4M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 31, 2018",
    "Current Ver": "6.5.0",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "Official NBSTSA CSFA Exam Prep",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 137,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 17, 2018",
    "Current Ver": "4.5.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "IBM Micromedex Drug Info",
    Category: "MEDICAL",
    Rating: 3.8,
    Reviews: 206,
    Size: "9.5M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 25, 2018",
    "Current Ver": "1.17.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Advanced Comprehension Therapy",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 3,
    Size: "62M",
    Type: "Paid",
    Price: "$24.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 5, 2017",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Hospitalist Handbook",
    Category: "MEDICAL",
    Rating: 4.8,
    Reviews: 12,
    Size: "18M",
    Type: "Paid",
    Price: "$19.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 5, 2017",
    "Current Ver": "6.0.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Dosecast - Medication Reminder",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 4107,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 17, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Visualmed",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.1M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 1, 2018",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "ABG Master",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 2,
    Size: "1.8M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 4, 2018",
    "Current Ver": 1.1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "OrthoFlow",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "66M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 15, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Be the Expert in Phlebotomy - Professional Nursing",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.0M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 24, 2018",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "JH Blood Pressure Monitor",
    Category: "MEDICAL",
    Rating: 3.7,
    Reviews: 9,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 21, 2018",
    "Current Ver": 1.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Sway Medical",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 3,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 25, 2018",
    "Current Ver": "3.0.0",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "Exposure Ed",
    Category: "MEDICAL",
    Rating: 3,
    Reviews: 2,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.2.9",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Nucleus Smart",
    Category: "MEDICAL",
    Rating: 3.7,
    Reviews: 20,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 27, 2018",
    "Current Ver": "1.830.0.564-(e405bb2)",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Penn State Health OnDemand",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 24, 2018",
    "Current Ver": "10.4.1.018_06",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Breastfeeding Tracker Baby Log",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 6,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 20, 2018",
    "Current Ver": "1.3.5",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "Lego Ninjago Wallpaper",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 2,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 2, 2018",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "RT 516 VET",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 13, 2018",
    "Current Ver": "300000.1.11",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EXOGEN Connects (US)",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.0.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Full Code - Emergency Medicine Simulation",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "65M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 23, 2018",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "Maricopa AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 16, 2018",
    "Current Ver": "300000.1.11",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Dare EMS Protocols",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Medical",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.8.3",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Pediatric Emergency Guide",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 9, 2018",
    "Current Ver": "3.1.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Weill Cornell Medicine",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 16, 2018",
    "Current Ver": "1.0.10",
    numInstall: 50,
    numAndroid: 5,
  },
  {
    App: "Doctors Care",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 24, 2018",
    "Current Ver": "2.0.0 (35717)",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "PCOS Guide - Fight PCOS naturally",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 4, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "EVA - Menstrual calendar and fertility",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 25,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 2, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Hello Face",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 31, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Cochrane Library",
    Category: "MEDICAL",
    Rating: 3.7,
    Reviews: 3,
    Size: "10.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.5.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Labs on Demand",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 1,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1.2,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Diabetes Testing",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Medical",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "GGDE: Prevent & Beat Depression Symptoms",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 2,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 24, 2018",
    "Current Ver": "2.01.12",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Dermatology Atlas (Colored & Illustrative)",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 3,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 19, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Jaylex",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.2.3-DEBUG",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Tablet Reminder",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 4,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Clinical Pharmacology",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 1, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Galaxies of Hope",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 2,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 27, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Smartshading AI",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 21, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "KBA-EZ Health Guide",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 4,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.0.72",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "FoothillsVet",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 2,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 11, 2018",
    "Current Ver": "300000.1.11",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Eversense",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 3,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 18, 2018",
    "Current Ver": "2.0.101",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "PrimeDelivery",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 3,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 13, 2018",
    "Current Ver": 0.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "You're an Anime",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 2,
    Size: "83M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 12, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 5,
  },
  {
    App: "Anatomy & Physiology Vocabulary Exam Review App",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 1,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 2, 2018",
    "Current Ver": 2,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Drug Calculator",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 27, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "HACH Cares",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 25, 2018",
    "Current Ver": "300000.1.11",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "WAH 247",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 20, 2018",
    "Current Ver": "300000.1.11",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "CT Scan Cross Sectional Anatomy",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 10,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 19, 2018",
    "Current Ver": "5.0.16",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "VetCode",
    Category: "MEDICAL",
    Rating: 4.9,
    Reviews: 28,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 7, 2018",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "ear super hearing",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.0 Super Ear Hearing",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Traditional Chinese Medicine Fangfang Liangfang Daquan - Practical and ancient Chinese medicine and old prescriptions for the treatment of various incurable diseases",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 21, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "COPD GOLD 2017",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 5,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 13, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Summit Medical Video Visits",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.1.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "ExtendedCare Virtual Care Room",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 30, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 5,
  },
  {
    App: "Lord Fairfax EMS Council",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 17, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "MyWoundDoctor - Provider",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.2.1",
    numInstall: 1,
    numAndroid: 5,
  },
  {
    App: "NCLEX Multi-topic Nursing Exam Review-Quiz & notes",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 1,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 24, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Warfarin Dose Calculator",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 15, 2018",
    "Current Ver": "3.0.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Renesas PMA",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.2.9",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Pediatric Nursing",
    Category: "MEDICAL",
    Rating: 4.9,
    Reviews: 14,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 13, 2018",
    "Current Ver": "PN.1.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Interpret Chest X-Ray With 100 Cases",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 5,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Basics of Orthopaedics",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 1,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 27, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "4 Paws PH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 25, 2018",
    "Current Ver": "300000.1.11",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "high cholesterol levels",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 23, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Thyroid Nodules",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 14, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Training course: Learn Nursing",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 8, 2018",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Familyfirst Messenger",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 1,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 12, 2018",
    "Current Ver": "0.1.2",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "14thStreetVet",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 16, 2018",
    "Current Ver": "300000.1.11",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Clinic Doctor EHr",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 2,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.0.51.0.3",
    numInstall: 5,
    numAndroid: 8,
  },
  {
    App: "OMD Protocols",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 27, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: null,
  },
  {
    App: "Teladoc Member",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 2094,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 26, 2018",
    "Current Ver": 3.19,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Anthem BC Anywhere",
    Category: "MEDICAL",
    Rating: 2.6,
    Reviews: 496,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 27, 2018",
    "Current Ver": "8.0.226",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Ada - Your Health Guide",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 87418,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 16, 2018",
    "Current Ver": "2.25.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ovia Fertility Tracker & Ovulation Calculator",
    Category: "MEDICAL",
    Rating: 4.8,
    Reviews: 53747,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "My Cancer Coach",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 44,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 12, 2018",
    "Current Ver": "3.4.0.10",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "IHSS Help",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 10,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 5, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "mobileRx Pharmacy",
    Category: "MEDICAL",
    Rating: 2.5,
    Reviews: 124,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 13, 2017",
    "Current Ver": "3.0.2",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "Youper - AI Therapy",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 2014,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 3, 2018",
    "Current Ver": "6.02.000",
    numInstall: 50000,
    numAndroid: 6,
  },
  {
    App: "MoodSpace",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 503,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 10, 2018",
    "Current Ver": "3.2.4",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "Super Hearing Super Ear Amplifier",
    Category: "MEDICAL",
    Rating: 4.1,
    Reviews: 21,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 11, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BURST Professionals",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 11,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 17, 2018",
    "Current Ver": "1.0.7",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "LactMed",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 573,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 1, 2017",
    "Current Ver": 3.1,
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Penn State Health OnDemand",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 24, 2018",
    "Current Ver": "10.4.1.018_06",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "ScriptSave WellRx Rx Discounts",
    Category: "MEDICAL",
    Rating: 3.8,
    Reviews: 700,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 21, 2018",
    "Current Ver": "3.3.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Blue CareOnDemand",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 163,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 29, 2018",
    "Current Ver": "10.4.1.015_05",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "HHS",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 30, 2017",
    "Current Ver": "Initial",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Free Blood Pressure",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 7,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 13, 2016",
    "Current Ver": "3.0.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Every disease has a drug without internet",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 44,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 24, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "PulsePoint AED",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 330,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 31, 2018",
    "Current Ver": 1.12,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "All Mental disorders",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 453,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 7, 2017",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Deaf Interpreter",
    Category: "MEDICAL",
    Rating: 3.8,
    Reviews: 24,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "September 26, 2017",
    "Current Ver": 5.51,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Nurse Grid",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 1686,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 30, 2018",
    "Current Ver": 2.9,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "High Blood Pressure Symptoms",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 531,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 18, 2015",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "MedStar eVisit",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 20,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 10, 2018",
    "Current Ver": "10.4.1.000_00",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Blood Pressure(BP) Diary",
    Category: "MEDICAL",
    Rating: 3.7,
    Reviews: 3596,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 18, 2018",
    "Current Ver": "4.0.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "REDCap Mobile App",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 56,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.0.8",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "JH Blood Pressure Monitor",
    Category: "MEDICAL",
    Rating: 3.7,
    Reviews: 9,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 21, 2018",
    "Current Ver": 1.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Blood Pressure",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 10,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 14, 2015",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "VITAS Hospice Referral App for Healthcare Pros",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 27,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.5.0 b665",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "AAFP",
    Category: "MEDICAL",
    Rating: 3.8,
    Reviews: 63,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 22, 2018",
    "Current Ver": "2.3.1",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "RT 516 VET",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 13, 2018",
    "Current Ver": "300000.1.11",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Anthem Anywhere",
    Category: "MEDICAL",
    Rating: 2.7,
    Reviews: 2657,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 27, 2018",
    "Current Ver": "8.0.226",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Sway Medical",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 3,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 25, 2018",
    "Current Ver": "3.0.0",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "Airway Ex - Intubate. Anesthetize. Train.",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 123,
    Size: "86M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 1, 2018",
    "Current Ver": "0.6.88",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "myvi by",
    Category: "MEDICAL",
    Rating: 3.8,
    Reviews: 122,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "fred's Pharmacy",
    Category: "MEDICAL",
    Rating: 3,
    Reviews: 315,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 10, 2017",
    "Current Ver": "1.0.02",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "420 BZ Budeze Delivery",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 2,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Medical",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Fever Meter",
    Category: "MEDICAL",
    Rating: 3.6,
    Reviews: 26,
    Size: "975k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 10, 2015",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Super Ear Super Hearing",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 122,
    Size: "980k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 13, 2018",
    "Current Ver": 1.4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Blood Pressure Monitor",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 17,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "February 25, 2017",
    "Current Ver": "1.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BELONG Beating Cancer Together",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 623,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Medical",
    "Last Updated": "July 29, 2018",
    "Current Ver": "4.0.5",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "BP Journal - Blood Pressure Diary",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 6,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.0.32",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "TelaDoc",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 6,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 31, 2018",
    "Current Ver": "1.3.0",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Breastfeeding Tracker Baby Log",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 6,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 20, 2018",
    "Current Ver": "1.3.5",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "Blood Pressure - Stay Healthy",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 7,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 16, 2018",
    "Current Ver": 43,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "ConnectLine",
    Category: "MEDICAL",
    Rating: 3.1,
    Reviews: 253,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "September 12, 2016",
    "Current Ver": "1.3.4",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Club",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 3786,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 16, 2018",
    "Current Ver": "4.4.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Zen Leaf",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 1,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Medical",
    "Last Updated": "March 8, 2018",
    "Current Ver": "2.3.5",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Homeopathic Medicine Finder",
    Category: "MEDICAL",
    Rating: 3.6,
    Reviews: 10,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "November 20, 2017",
    "Current Ver": "0.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Patient Portal",
    Category: "MEDICAL",
    Rating: 2.8,
    Reviews: 66,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 25, 2016",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Nemours CareConnect",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 65,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 5, 2018",
    "Current Ver": "10.4.1.000_00",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Banfield Pet Health Tracker",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 1747,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 17, 2016",
    "Current Ver": "1.2.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "tökr",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 17,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.9.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Low Blood Pressure Symptoms",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 28,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 20, 2015",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "PatientPORTAL by InteliChart",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.0.1",
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "Hypertension High blood pressure",
    Category: "MEDICAL",
    Rating: 3.8,
    Reviews: 292,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 16, 2018",
    "Current Ver": 43,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Fever Care",
    Category: "MEDICAL",
    Rating: 3.5,
    Reviews: 19,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 12, 2018",
    "Current Ver": "1.4.15-free",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "1800 Contacts - Lens Store",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 23160,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 27, 2018",
    "Current Ver": "7.4.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Facebook",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 78158306,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Instagram",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 66577313,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Facebook Lite",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 8606259,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Messages, Text and Video Chat for Messenger",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 49173,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "June 4, 2018",
    "Current Ver": 1.24,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Tumblr",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 2955326,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "All Social Networks",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 22492,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "May 21, 2018",
    "Current Ver": "2.4.12",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Snapchat",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 17014787,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Social network all in one 2018",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 1403,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "January 30, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Pinterest",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 4305441,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "TextNow - free text + calls",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 441189,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Google+",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 4831125,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "The Messenger App",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 4919,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "0.1.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Messenger Pro",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 13762,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "May 9, 2018",
    "Current Ver": "1.0.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Free Messages, Video, Chat,Text for Messenger Plus",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 6086,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "June 14, 2018",
    "Current Ver": "1.0.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Telegram X",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 70616,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "The Video Messenger App",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 1200,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "0.1.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Jodel - The Hyperlocal App",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 76480,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 6, 2018",
    "Current Ver": "4.95.4",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Who Viewed My Facebook Profile - Stalkers Visitors",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 271445,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "June 24, 2018",
    "Current Ver": "4.1.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Hide Something - Photo, Video",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 225103,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "June 13, 2018",
    "Current Ver": "5.1.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Love Sticker",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 33177,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "June 12, 2018",
    "Current Ver": "2.1.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Web Browser & Fast Explorer",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 54768,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "May 16, 2018",
    "Current Ver": "3.6.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "LiveMe - Video chat, new friends, and make money",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 457197,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "VidStatus app - Status Videos & Status Downloader",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 25562,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.6.10",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Love Images",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 16404,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "June 24, 2018",
    "Current Ver": 1.6,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Web Browser ( Fast & Secure Web Explorer)",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 2508,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "November 20, 2017",
    "Current Ver": "2.0.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "SPARK - Live random video chat & meet new people",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 79658,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 6, 2018",
    "Current Ver": "2.1.3.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Golden telegram",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 374,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 30, 2018",
    "Current Ver": "T4.6.5-tl2.0.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Amino: Communities and Chats",
    Category: "SOCIAL",
    Rating: 4.8,
    Reviews: 1259075,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 20, 2018",
    "Current Ver": "1.8.19179",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Facebook Local",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 4751,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "June 30, 2018",
    "Current Ver": 13,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Meet – Talk to Strangers Using Random Video Chat",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 60562,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 6, 2018",
    "Current Ver": "1.3.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "MobilePatrol Public Safety App",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 22695,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Social",
    "Last Updated": "June 21, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "💘 WhatsLov: Smileys of love, stickers and GIF",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 22098,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 24, 2018",
    "Current Ver": "4.2.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Phone Tracker : Family Locator",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 231325,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": 4.81,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "HTC Social Plugin - Facebook",
    Category: "SOCIAL",
    Rating: 3.6,
    Reviews: 13223,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "June 8, 2016",
    "Current Ver": "8.00.752746",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Periscope - Live Video",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 479908,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 9, 2018",
    "Current Ver": "1.23.3.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Quora",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 313633,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Kate Mobile for VK",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 540930,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 23, 2018",
    "Current Ver": "50.2 lite",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Family GPS tracker KidControl + GPS by SMS Locator",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 57146,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "LinkedIn",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 1225339,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.1.202",
    numInstall: 100000000,
    numAndroid: 5,
  },
  {
    App: "Moment",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 19583,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.2.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Text Me: Text Free, Call Free, Second Phone Number",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 344921,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "June 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Meetup",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 79129,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.10.26",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Text Free: WiFi Calling App",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 83488,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "TextNow - free text + calls",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 441189,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Badoo - Free Chat & Dating App",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 3781770,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Text free - Free Text + Call",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 315441,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "textPlus: Free Text & Calls",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 382120,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 26, 2018",
    "Current Ver": "7.3.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Free phone calls, free texting SMS on free number",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 412725,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.8.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Tango - Live Video Broadcast",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 3806669,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "MeetMe: Chat & Meet New People",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 1259849,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Tagged - Meet, Chat & Dating",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 486824,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "June 21, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "ooVoo Video Calls, Messaging & Stories",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 1157004,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "October 16, 2017",
    "Current Ver": "4.2.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "SayHi Chat, Meet New People",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 423105,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 9, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Whisper",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 205803,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Tapatalk - 100,000+ Forums",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 285816,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "June 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Tumblr",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 2955325,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Blogger",
    Category: "SOCIAL",
    Rating: 3.7,
    Reviews: 138026,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "February 29, 2016",
    "Current Ver": "2.1.3",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Bloglovin'",
    Category: "SOCIAL",
    Rating: 3.9,
    Reviews: 8936,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "May 18, 2017",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Blogaway for Android (Blogger)",
    Category: "SOCIAL",
    Rating: 3.7,
    Reviews: 4253,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "May 31, 2018",
    "Current Ver": "7.0.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Snapchat",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 17014705,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Instagram",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 66577446,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "TwitCasting Live",
    Category: "SOCIAL",
    Rating: 3.6,
    Reviews: 14835,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Stream - Live Video Community",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 6388,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "December 5, 2017",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "YouNow: Live Stream Video Chat",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 309872,
    Size: "85M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "14.0.13",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Periscope - Live Video",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 479909,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 9, 2018",
    "Current Ver": "1.23.3.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Mirrativ: Live Stream Any App",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 17955,
    Size: "89M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "7.23.4",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Snapchat",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 17015352,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Instagram",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 66577313,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Pinterest",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 4305441,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Nextdoor - Local neighborhood news & classifieds",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 51502,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 25, 2018",
    "Current Ver": 2.69,
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "SKOUT - Meet, Chat, Go Live",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 1064049,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Banjo",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 58341,
    Size: "9.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 25, 2015",
    "Current Ver": "4.6.2.0",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "We Heart It",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 637309,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "MeetMe: Chat & Meet New People",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 1259894,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "ooVoo Video Calls, Messaging & Stories",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 1157003,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "October 16, 2017",
    "Current Ver": "4.2.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Timehop",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 161610,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 5, 2018",
    "Current Ver": "4.5.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Frontback - Social Photos",
    Category: "SOCIAL",
    Rating: 3.8,
    Reviews: 19446,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "December 1, 2017",
    "Current Ver": "3.4.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "LinkedIn",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 1225367,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.1.202",
    numInstall: 100000000,
    numAndroid: 5,
  },
  {
    App: "Path",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 1520959,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "May 9, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Tango - Live Video Broadcast",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 3806669,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "SayHi Chat, Meet New People",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 423138,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 9, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Tapatalk - 100,000+ Forums",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 285820,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "June 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Couple - Relationship App",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 33249,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "March 5, 2015",
    "Current Ver": "1.8.0",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Badoo - Free Chat & Dating App",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 3781770,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Nextdoor - Local neighborhood news & classifieds",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 51504,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 25, 2018",
    "Current Ver": 2.69,
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "POF Free Dating App",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 1175794,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "MeetMe: Chat & Meet New People",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 1259894,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "LOVOO",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 852455,
    Size: "68M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": 27,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Jaumo Dating, Flirt & Live Video",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 900064,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.17.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Patook - make platonic friends",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 3677,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "June 21, 2018",
    "Current Ver": "10.6.3",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Meetup",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 79129,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.10.26",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Text Free: WiFi Calling App",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 83488,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Zello PTT Walkie Talkie",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 695613,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "textPlus: Free Text & Calls",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 382121,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 26, 2018",
    "Current Ver": "7.3.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "magicApp Calling & Messaging",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 207712,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "June 9, 2018",
    "Current Ver": "4.18.962.5",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Dating App, Flirt & Chat : W-Match",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 175722,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "uCiC- Videos and Photos on demand",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 2052,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "September 27, 2017",
    "Current Ver": 2.16,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Meetup",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 79130,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.10.26",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "POF Free Dating App",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 1175815,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "MeetMe: Chat & Meet New People",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 1259894,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Tagged - Meet, Chat & Dating",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 486830,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "June 21, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "LOVOO",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 852455,
    Size: "68M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": 27,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "SKOUT - Meet, Chat, Go Live",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 1064076,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Badoo - Free Chat & Dating App",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 3781770,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Jaumo Dating, Flirt & Live Video",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 900064,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.17.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Mico- Stranger Chat Random video Chat, Live, Meet",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 624557,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 27, 2018",
    "Current Ver": "5.4.7.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "SayHi Chat, Meet New People",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 423138,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 9, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Waplog - Free Chat, Dating App, Meet Singles",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 522018,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Couple - Relationship App",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 33249,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "March 5, 2015",
    "Current Ver": "1.8.0",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Meetup",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 79130,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.10.26",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Amazon for Tablets",
    Category: "SHOPPING",
    Rating: 4,
    Reviews: 141613,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 31, 2018",
    "Current Ver": "16.14.0.850",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Wish - Shopping Made Fun",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 6210998,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.20.5",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "OfferUp - Buy. Sell. Offer Up",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 591312,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Shopee - No. 1 Online Shopping",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 94294,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.25.17",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Shopee: No.1 Online Shopping",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 608753,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.25.17",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Kroger",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 38961,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 2, 2018",
    "Current Ver": "14.2.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "AliExpress - Smarter Shopping, Better Living",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 5916606,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Walmart",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 441473,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "eBay: Buy & Sell this Summer - Discover Deals Now!",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 2788923,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "letgo: Buy & Sell Used Stuff, Cars & Real Estate",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 973270,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 6, 2018",
    "Current Ver": "2.4.9",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Amazon Shopping",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 909226,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 31, 2018",
    "Current Ver": "16.14.0.100",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Lazada - Online Shopping & Deals",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 1573054,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "OLX - Buy and Sell",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 857923,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 31, 2018",
    "Current Ver": "11.7.3.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "The wall",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 35563,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 23, 2018",
    "Current Ver": "10.2.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Flipp - Weekly Shopping",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 85858,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Shrimp skin shopping: spend less, buy better",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 106798,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.25.17",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Lotte Home Shopping LOTTE Homeshopping",
    Category: "SHOPPING",
    Rating: 3.6,
    Reviews: 8820,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 25, 2018",
    "Current Ver": "3.0.5",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Horn, free country requirements",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 37186,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 30, 2018",
    "Current Ver": "3.4.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Jiji.ng",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 25714,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 24, 2018",
    "Current Ver": "3.8.2.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "GS SHOP",
    Category: "SHOPPING",
    Rating: 3.8,
    Reviews: 44255,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "6.0.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "The birth",
    Category: "SHOPPING",
    Rating: 4.7,
    Reviews: 1084945,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "CJmall",
    Category: "SHOPPING",
    Rating: 3.6,
    Reviews: 18252,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 6, 2018",
    "Current Ver": "6.3.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Home & Shopping - Only in apps. 10% off + 10% off",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 42750,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 4, 2018",
    "Current Ver": "2.8.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "EHS Dongsen Shopping",
    Category: "SHOPPING",
    Rating: 3.6,
    Reviews: 3656,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.16.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "bigbasket - online grocery",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 216741,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 6, 2018",
    "Current Ver": "4.6.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Bukalapak - Buy and Sell Online",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 662287,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.26.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Life market",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 30834,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 17, 2018",
    "Current Ver": "3.2.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Jabong Online Shopping App",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 367290,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 20, 2018",
    "Current Ver": "4.9.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Family Dollar",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 2588,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.4.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Jumia online shopping",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 162655,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 10, 2018",
    "Current Ver": "4.7.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Mercado Libre: Find your favorite brands",
    Category: "SHOPPING",
    Rating: 4.7,
    Reviews: 3860225,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Carousell: Snap-Sell, Chat-Buy",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 125783,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Blibli.com Online Shopping",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 171584,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 26, 2018",
    "Current Ver": "4.9.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Club Factory Everything, Unbeaten Price",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 244141,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 6, 2018",
    "Current Ver": "4.4.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Real Estate, Car, Shopping and Others",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 568273,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "ZALORA Fashion Shopping",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 142512,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.2.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Magazine Luiza Online Shopping",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 109124,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.11.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ROMWE - Women's Fashion",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 135043,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 30, 2018",
    "Current Ver": "4.0.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Buscapé - Offers and discounts",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 108592,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 24, 2018",
    "Current Ver": "4.7.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Myntra Online Shopping App",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 1315242,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 21, 2018",
    "Current Ver": "3.27.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "11st",
    Category: "SHOPPING",
    Rating: 3.8,
    Reviews: 48732,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 31, 2018",
    "Current Ver": "7.8.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Coupang",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 308234,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.3.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Wemep - Special price representative (special / shopping / shopping app / coupon / shipping)",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 178497,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.33.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Target - now with Cartwheel",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 68406,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.25.0+1906001476",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Flipkart Online Shopping App",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 6012719,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Sam's Club: Wholesale Shopping & Instant Savings",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 45362,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Chilindo",
    Category: "SHOPPING",
    Rating: 3.8,
    Reviews: 18364,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 4, 2018",
    "Current Ver": 29.14,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Rossmann PL",
    Category: "SHOPPING",
    Rating: 4,
    Reviews: 15867,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Jingdong - pick good things, go to Jingdong",
    Category: "SHOPPING",
    Rating: 3.3,
    Reviews: 9189,
    Size: "98M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 1, 2018",
    "Current Ver": "7.0.14",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CheckPoints 🏆 Rewards App",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 23187,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 21, 2018",
    "Current Ver": 4.89,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Extreme Coupon Finder",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 11798,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "May 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "SnipSnap Coupon App",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 9975,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "January 22, 2018",
    "Current Ver": 1.4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Checkout 51: Grocery coupons",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 52896,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Coupon Sherpa",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 7793,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "February 6, 2018",
    "Current Ver": "3.0.3",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Gyft - Mobile Gift Card Wallet",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 9701,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 25, 2018",
    "Current Ver": "2.4.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "SavingStar - Grocery Coupons",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 31519,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 12, 2018",
    "Current Ver": "4.9.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "The Coupons App",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 181990,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "April 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Shopkick: Free Gift Cards, Shop Rewards & Deals",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 213735,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 24, 2018",
    "Current Ver": "5.3.73",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Wish - Shopping Made Fun",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 6211039,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.20.5",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Key Ring: Cards Coupon & Sales",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 42871,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 27, 2018",
    "Current Ver": "8.9.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ibotta: Cash Back Savings, Rewards & Coupons App",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 315908,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.21.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "RetailMeNot - Coupons, Deals & Discount Shopping",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 210208,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Groupon - Shop Deals, Discounts & Coupons",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 1370749,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Kohl's: Scan, Shop, Pay & Save",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 79261,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": 7.36,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Stocard - Rewards Cards Wallet",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 284725,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 31, 2018",
    "Current Ver": "7.2.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Nike",
    Category: "SHOPPING",
    Rating: 4.7,
    Reviews: 67071,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.24.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Poshmark - Buy & Sell Fashion",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 46153,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 4, 2018",
    "Current Ver": "2.124.01",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Mercari: The Selling App",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 101883,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "6.9.2",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Blidz - Hunt Free Deals On Trending Items!",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 1659,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 29, 2018",
    "Current Ver": "2.4.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "SnipSnap Coupon App",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 9975,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "January 22, 2018",
    "Current Ver": 1.4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Extreme Coupon Finder",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 11798,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "May 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Checkout 51: Grocery coupons",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 52896,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "The Coupons App",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 181990,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "April 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Shopular: Coupons, Weekly Ads & Shopping Deals",
    Category: "SHOPPING",
    Rating: 4.7,
    Reviews: 57920,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "May 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "LivingSocial - Local Deals",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 28523,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "18.10.157066",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Coupons.com – Grocery Coupons & Cash Back Savings",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 24953,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 21, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Ebates: Cash Back, Coupons, Rewards & Savings",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 37253,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.31.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "RetailMeNot - Coupons, Deals & Discount Shopping",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 210208,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Groupon - Shop Deals, Discounts & Coupons",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 1370749,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "FidMe Loyalty Cards & Deals at Grocery Supermarket",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 33758,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Stocard - Rewards Cards Wallet",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 284721,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 31, 2018",
    "Current Ver": "7.2.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Ratings by Consumer Reports",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 3420,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "February 27, 2018",
    "Current Ver": "2.3.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "HauteLook",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 7193,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 13, 2018",
    "Current Ver": "5.0.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Extreme Coupon Finder",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 11798,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "May 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "eBay: Buy & Sell this Summer - Discover Deals Now!",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 2788923,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Checkout 51: Grocery coupons",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 52896,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Nordstrom",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 2278,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 15, 2018",
    "Current Ver": "3.28.1.3.1359",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Modcloth – Unique Indie Women's Fashion & Style",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 5121,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 13, 2018",
    "Current Ver": "9.0.30",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Fancy",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 39735,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 25, 2018",
    "Current Ver": "3.13.09",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Gyft - Mobile Gift Card Wallet",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 9701,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 25, 2018",
    "Current Ver": "2.4.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Twice: Buy, Sell Clothing",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 1558,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 29, 2015",
    "Current Ver": "1.2.12",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Shopkick: Free Gift Cards, Shop Rewards & Deals",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 213735,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 24, 2018",
    "Current Ver": "5.3.73",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Slice: Package Tracker",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 16966,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 12, 2018",
    "Current Ver": "6.10.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "The Coupons App",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 181990,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "April 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Shopular: Coupons, Weekly Ads & Shopping Deals",
    Category: "SHOPPING",
    Rating: 4.7,
    Reviews: 57920,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "May 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Wish - Shopping Made Fun",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 6211039,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.20.5",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Carousell: Snap-Sell, Chat-Buy",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 125783,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "LightInTheBox Online Shopping",
    Category: "SHOPPING",
    Rating: 4,
    Reviews: 41986,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 6, 2018",
    "Current Ver": "3.69.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Walmart",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 441473,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Best Buy",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 186116,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "11.6.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "JackThreads: Men's Shopping",
    Category: "SHOPPING",
    Rating: 4,
    Reviews: 13085,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "November 8, 2017",
    "Current Ver": 5.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ibotta: Cash Back Savings, Rewards & Coupons App",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 315908,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.21.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "AliExpress - Smarter Shopping, Better Living",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 5916569,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "LivingSocial - Local Deals",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 28523,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "18.10.157066",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "zulily - Shop Daily Deals in Fashion and Home",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 28560,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "MiniInTheBox Online Shopping",
    Category: "SHOPPING",
    Rating: 3.9,
    Reviews: 34171,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Zappos – Shoe shopping made simple",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 44588,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 12, 2018",
    "Current Ver": "9.0.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Urban Outfitters",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 4158,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 2, 2018",
    "Current Ver": 2.8,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Tophatter - 90 Second Auctions",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 105773,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Amazon Shopping",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 909204,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 31, 2018",
    "Current Ver": "16.14.0.100",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Shopfully - Weekly Ads & Deals",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 279428,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "6.4.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Slickdeals: Coupons & Shopping",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 33583,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 30, 2018",
    "Current Ver": 3.9,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Wanelo Shopping",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 94205,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 13, 2018",
    "Current Ver": "5.6.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "RetailMeNot - Coupons, Deals & Discount Shopping",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 210208,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Etsy: Handmade & Vintage Goods",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 95520,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "5.3.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Poshmark - Buy & Sell Fashion",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 46153,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 4, 2018",
    "Current Ver": "2.124.01",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Target - now with Cartwheel",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 68406,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.25.0+1906001476",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "ASOS",
    Category: "SHOPPING",
    Rating: 4.7,
    Reviews: 181798,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 30, 2018",
    "Current Ver": "4.4.9",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Overstock – Home Decor, Furniture Shopping",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 25719,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "ZALORA Fashion Shopping",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 142512,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.2.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "eBay: Buy & Sell this Summer - Discover Deals Now!",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 2788923,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Fancy",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 39735,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 25, 2018",
    "Current Ver": "3.13.09",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Modcloth – Unique Indie Women's Fashion & Style",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 5121,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 13, 2018",
    "Current Ver": "9.0.30",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Gyft - Mobile Gift Card Wallet",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 9701,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 25, 2018",
    "Current Ver": "2.4.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "JackThreads: Men's Shopping",
    Category: "SHOPPING",
    Rating: 4,
    Reviews: 13085,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "November 8, 2017",
    "Current Ver": 5.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "LivingSocial - Local Deals",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 28523,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "18.10.157066",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Zappos – Shoe shopping made simple",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 44588,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 12, 2018",
    "Current Ver": "9.0.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Wanelo Shopping",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 94205,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 13, 2018",
    "Current Ver": "5.6.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Etsy: Handmade & Vintage Goods",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 95520,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "5.3.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Groupon - Shop Deals, Discounts & Coupons",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 1370749,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "eBay: Buy & Sell this Summer - Discover Deals Now!",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 2788923,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Find&Save - Local Shopping",
    Category: "SHOPPING",
    Rating: 4,
    Reviews: 4602,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "December 22, 2017",
    "Current Ver": "3.0.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Receipt Hog - Receipts to Cash",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 72596,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.2.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ShopSavvy Barcode & QR Scanner",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 110425,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 18, 2018",
    "Current Ver": "13.6.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Savory - Deals,Freebies,Sales",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 2375,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "November 2, 2016",
    "Current Ver": 3.1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "JackThreads: Men's Shopping",
    Category: "SHOPPING",
    Rating: 4,
    Reviews: 13085,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "November 8, 2017",
    "Current Ver": 5.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AliExpress - Smarter Shopping, Better Living",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 5917485,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Newegg Mobile",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 35497,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 11, 2018",
    "Current Ver": "4.16.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "REI – Shop Outdoor Gear",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 3878,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "May 8, 2018",
    "Current Ver": "5.6.8",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Slickdeals: Coupons & Shopping",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 33583,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 30, 2018",
    "Current Ver": 3.9,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Target - now with Cartwheel",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 68406,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 6, 2018",
    "Current Ver": "6.25.0+1906001476",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "The Home Depot",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 44071,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 19, 2018",
    "Current Ver": 5.1,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Wish - Shopping Made Fun",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 6212081,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.20.5",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Fancy",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 39735,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 25, 2018",
    "Current Ver": "3.13.09",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Boxed Wholesale",
    Category: "SHOPPING",
    Rating: 3.8,
    Reviews: 6380,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "La La-Shop Designer Brands Street",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 5123,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 28, 2018",
    "Current Ver": "4.4.4",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "ASOS",
    Category: "SHOPPING",
    Rating: 4.7,
    Reviews: 181823,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 30, 2018",
    "Current Ver": "4.4.9",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "TouchNote: Cards & Gifts",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 19232,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 6, 2018",
    "Current Ver": "7.4.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Shutterfly: Free Prints, Photo Books, Cards, Gifts",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 98716,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.13.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "FreePrints – Free Photos Delivered",
    Category: "PHOTOGRAPHY",
    Rating: 4.8,
    Reviews: 109500,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.18.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Groovebook Photo Books & Gifts",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 21159,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "January 31, 2018",
    "Current Ver": "2.1.9",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Moony Lab - Print Photos, Books & Magnets ™",
    Category: "PHOTOGRAPHY",
    Rating: 4.7,
    Reviews: 1320,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 27, 2018",
    "Current Ver": "2.1.9",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "LALALAB prints your photos, photobooks and magnets",
    Category: "PHOTOGRAPHY",
    Rating: 4.7,
    Reviews: 50424,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 2, 2018",
    "Current Ver": 584,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Snapfish",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 32398,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 1, 2018",
    "Current Ver": "9.6.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Google Photos",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 10858556,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Motorola Camera",
    Category: "PHOTOGRAPHY",
    Rating: 3.6,
    Reviews: 219745,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "January 25, 2016",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "HD Camera - Best Cam with filters & panorama",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 38953,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.2.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Face Filter, Selfie Editor - Sweet Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.7,
    Reviews: 142634,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 6, 2018",
    "Current Ver": "1.5.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "LightX Photo Editor & Photo Effects",
    Category: "PHOTOGRAPHY",
    Rating: 4.7,
    Reviews: 259450,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.0.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Sweet Snap - live filter, Selfie photo edit",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 123029,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Adobe Photoshop Express:Photo Editor Collage Maker",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 914804,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 22, 2018",
    "Current Ver": "5.0.508",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "HD Camera - Quick Snap Photo & Video",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 21841,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.6.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "B612 - Beauty & Filter Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 5282578,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 30, 2018",
    "Current Ver": "7.6.5",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Waterfall Photo Frames",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 10349,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 29, 2017",
    "Current Ver": "1.6.0",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Photo frame",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 859,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.5.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Huji Cam",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 40289,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 11, 2018",
    "Current Ver": 2.2,
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Unicorn Photo",
    Category: "PHOTOGRAPHY",
    Rating: 3.7,
    Reviews: 3362,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "HD Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 49680,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.8.5",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Makeup Editor -Beauty Photo Editor & Selfie Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 3378,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Photography",
    "Last Updated": "July 25, 2018",
    "Current Ver": 1.7,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Makeup Photo Editor: Makeup Camera & Makeup Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 10525,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 27, 2018",
    "Current Ver": "8.9.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Moto Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 3.3,
    Reviews: 3492,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 14, 2018",
    "Current Ver": "1.5.3.8",
    numInstall: 5000000,
    numAndroid: 7,
  },
  {
    App: "InstaBeauty -Makeup Selfie Cam",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 654419,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Garden Photo Frames - Garden Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 1864,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 3, 2018",
    "Current Ver": 22,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Photo Frame",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 74476,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 19, 2018",
    "Current Ver": 1.6,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Camera360 Lite - Selfie Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 221858,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Selfie Camera - Photo Editor & Filter & Sticker",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 401820,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "April 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Sweet Snap Lite - live filter, Selfie photo editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 3116,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.15.180",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Selfie Camera: Beauty Camera, Photo Editor,Collage",
    Category: "PHOTOGRAPHY",
    Rating: 4.7,
    Reviews: 31985,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 6, 2018",
    "Current Ver": "1.7.14",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Night Photo Frame",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 4400,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 28, 2018",
    "Current Ver": "2.0.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "YouCam Makeup - Magic Selfie Makeovers",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 3337956,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Selfie Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 11677,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.0.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BeautyPlus - Easy Photo Editor & Selfie Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 3158047,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 31, 2018",
    "Current Ver": "6.9.031",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "ASUS Gallery",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 125259,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "My Photo Keyboard",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 56114,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 9, 2018",
    "Current Ver": 2.6,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Kids Photo Frames",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 15700,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 7, 2018",
    "Current Ver": 2.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Pencil Photo Sketch-Sketching Drawing Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 16523,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.2.31",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Pretty Makeup, Beauty Photo Editor & Snappy Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 26361,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 25, 2018",
    "Current Ver": 5.3,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Photo Collage - Layout Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 285788,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "December 4, 2017",
    "Current Ver": "1.8.0.170824_9",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "DSLR Camera Hd Ultra Professional",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 4410,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 27, 2018",
    "Current Ver": 4.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Snap Cat Face Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 5855,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 12, 2018",
    "Current Ver": 1.6,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Silent Camera [High Quality]",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 47090,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Sweet Camera - Selfie Filters, Beauty Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.7,
    Reviews: 233039,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 28, 2018",
    "Current Ver": "1.5.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Photo Frames",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 28578,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 28, 2018",
    "Current Ver": 6.21,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Sweet Selfie - selfie camera, beauty cam, photo edit",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 1159058,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.73.672",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Candy selfie - photo editor, live filter camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 53421,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 6, 2018",
    "Current Ver": "2.74.685",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "YouCam Perfect - Selfie Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 1579287,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Open Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 116880,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "April 23, 2018",
    "Current Ver": "1.43.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Beauty Makeup – Photo Makeover",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 21730,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 23, 2018",
    "Current Ver": "1.6.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Blur Image Background Editor (Blur Photo Editor)",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 62421,
    Size: "9.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 28, 2018",
    "Current Ver": 2.4,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Google Photos",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 10858538,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Muzy - Share photos & collages",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 70189,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Photography",
    "Last Updated": "August 11, 2015",
    "Current Ver": "4.0.10",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "QuickPic - Photo Gallery with Google Drive Support",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 847159,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 10, 2017",
    "Current Ver": "4.7.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Flickr",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 251951,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Photography",
    "Last Updated": "July 11, 2018",
    "Current Ver": "4.7.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Shutterfly: Free Prints, Photo Books, Cards, Gifts",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 98716,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.13.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "InstaBeauty -Makeup Selfie Cam",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 654418,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "B612 - Beauty & Filter Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 5282558,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 30, 2018",
    "Current Ver": "7.6.5",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Camera for Android",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 240475,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 22, 2017",
    "Current Ver": 3.8,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Photo Editor Selfie Camera Filter & Mirror Image",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 527247,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 1, 2018",
    "Current Ver": "1.6.1",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "BeautyPlus - Easy Photo Editor & Selfie Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 3157936,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 31, 2018",
    "Current Ver": "6.9.031",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Photo Mixer",
    Category: "PHOTOGRAPHY",
    Rating: 3.9,
    Reviews: 55427,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 25, 2016",
    "Current Ver": 5.1,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Photo Editor-",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 68070,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Cymera Camera- Photo Editor, Filter,Collage,Layout",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 2418135,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Wondershare PowerCam",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 329160,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 29, 2018",
    "Current Ver": "3.1.8.180529",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "YouCam Perfect - Selfie Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 1579287,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "love",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 42677,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 15, 2018",
    "Current Ver": 1.28,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "LINE Camera - Photo editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 1517369,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "InstaSize Photo Filters & Collage Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 811693,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.0.26",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "KVAD Camera +: Selfie, Photo Filter, Grids",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 23440,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.8.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Candy Camera - selfie, beauty camera, photo editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 3368649,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 16, 2018",
    "Current Ver": 4.47,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 42079,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "September 24, 2015",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Camera51 - a smarter camera",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 29707,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 10, 2015",
    "Current Ver": "1.1.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "InstaCam - Camera for Selfie",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 15098,
    Size: "10.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 3, 2017",
    "Current Ver": 1.43,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Phogy, 3D Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 35724,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 11, 2015",
    "Current Ver": 1.4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Sweet Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 71898,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "October 10, 2017",
    "Current Ver": "6.1.7.100920",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Camera360: Selfie Photo Editor with Funny Sticker",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 4865093,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 6, 2018",
    "Current Ver": "9.3.1",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "RetroSelfie - Selfie Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 106080,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 27, 2018",
    "Current Ver": "6.1.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Mega Photo",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 44941,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "October 19, 2016",
    "Current Ver": "1.6.2",
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Blur Image Background",
    Category: "PHOTOGRAPHY",
    Rating: 3.9,
    Reviews: 129272,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 30, 2018",
    "Current Ver": 1.32,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "MIX by Camera360",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 111066,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.8.7",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Facetune - For Free",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 49553,
    Size: "48M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.3.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Google Photos",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 10859051,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Muzy - Share photos & collages",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 70189,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Photography",
    "Last Updated": "August 11, 2015",
    "Current Ver": "4.0.10",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "QuickPic - Photo Gallery with Google Drive Support",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 847159,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 10, 2017",
    "Current Ver": "4.7.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Flickr",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 251951,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Photography",
    "Last Updated": "July 11, 2018",
    "Current Ver": "4.7.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Shutterfly: Free Prints, Photo Books, Cards, Gifts",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 98716,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.13.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "SuperPhoto - Effects & Filters",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 43296,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "September 20, 2017",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Camera FV-5 Lite",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 130081,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 10, 2017",
    "Current Ver": "3.31.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "HD Camera Ultra",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 462152,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "October 17, 2015",
    "Current Ver": "2.3.1",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Cameringo Lite. Filters Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 140917,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 11, 2018",
    "Current Ver": "2.2.93",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Camera ZOOM FX - FREE",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 88860,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "April 6, 2017",
    "Current Ver": "6.2.9",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "HD Camera Pro for Android",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 49211,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "January 19, 2017",
    "Current Ver": "1.5.5",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "HD Camera for Android",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 351254,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 29, 2018",
    "Current Ver": "4.6.0.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "GoPro (formerly Capture)",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 157506,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 24, 2018",
    "Current Ver": "4.5.2",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Photo Editor Pro",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 1871416,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "December 21, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Open Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 116880,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "April 23, 2018",
    "Current Ver": "1.43.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Camera for Android",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 240475,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 22, 2017",
    "Current Ver": 3.8,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Beauty Makeup Snappy Collage Photo Editor - Lidow",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 420973,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Samsung SMART CAMERA App",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 34753,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.4.0_180703",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Square InPic - Photo Editor & Collage Maker",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 635846,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 23, 2018",
    "Current Ver": "4.2.14",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "High-Speed Camera (GIF,Burst)",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 78140,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 11, 2018",
    "Current Ver": "5.5.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Cymera Camera- Photo Editor, Filter,Collage,Layout",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 2418135,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Camera MX - Free Photo & Video Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 244371,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Lapse It • Time Lapse • Pro",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 12865,
    Size: "6.9M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 6, 2014",
    "Current Ver": 4.7,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "EyeEm - Camera & Photo Filter",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 215343,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 14, 2018",
    "Current Ver": "6.4.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Retrica",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 6120977,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 28, 2018",
    "Current Ver": "6.1.0",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Candy Camera - selfie, beauty camera, photo editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 3368646,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 16, 2018",
    "Current Ver": 4.47,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "VSCO",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 753115,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 3, 2018",
    "Current Ver": 71,
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Camera360: Selfie Photo Editor with Funny Sticker",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 4865107,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 6, 2018",
    "Current Ver": "9.3.1",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Facetune - For Free",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 49553,
    Size: "48M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.3.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Camera FV-5",
    Category: "PHOTOGRAPHY",
    Rating: 3.8,
    Reviews: 16320,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$3.95",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 10, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "PhotoWonder: Pro Beauty Photo Editor Collage Maker",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 852649,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Photography",
    "Last Updated": "June 26, 2018",
    "Current Ver": "4.1.0.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Photo Effects Pro",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 1494491,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 21, 2017",
    "Current Ver": "3.3.8",
    numInstall: 50000000,
    numAndroid: 3,
  },
  {
    App: "Photo Editor Selfie Camera Filter & Mirror Image",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 527248,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 1, 2018",
    "Current Ver": "1.6.1",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "No Crop & Square for Instagram",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 819774,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 26, 2018",
    "Current Ver": "4.2.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Picture Grid Builder",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 33439,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 18, 2016",
    "Current Ver": 3.2,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "HD Camera for Android",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 351255,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 29, 2018",
    "Current Ver": "4.6.0.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Photo Studio",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 477831,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 28, 2018",
    "Current Ver": "2.0.17.9",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Photo Editor Pro",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 1871421,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "December 21, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "YouCam Makeup - Magic Selfie Makeovers",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 3337952,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "FilterGrid - Cam&Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 126337,
    Size: "9.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 15, 2017",
    "Current Ver": "2.0.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Photo Editor-",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 68071,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Camera for Android",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 240475,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 22, 2017",
    "Current Ver": 3.8,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Mirror Photo:Editor Collage (HD)",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 373606,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Pic Stitch - #1 Collage Maker",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 15426,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 24, 2018",
    "Current Ver": "3.8.3",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "PhotoDirector Photo Editor App",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 714340,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Pic Collage - Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 1451000,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Photo Editor by Aviary",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 1490732,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 19, 2018",
    "Current Ver": "4.8.4",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Video Editor Music,Cut,No Crop",
    Category: "PHOTOGRAPHY",
    Rating: 4.7,
    Reviews: 2163282,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Pixlr – Free Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 1163232,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 20, 2018",
    "Current Ver": "3.4.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 114680,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 15, 2018",
    "Current Ver": 1.38,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Photo Collage Maker",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 751766,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Cymera Camera- Photo Editor, Filter,Collage,Layout",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 2418158,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Adobe Photoshop Express:Photo Editor Collage Maker",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 914917,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 22, 2018",
    "Current Ver": "5.0.508",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "BeautyPlus - Easy Photo Editor & Selfie Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 3158151,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 31, 2018",
    "Current Ver": "6.9.031",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "PicsArt Photo Studio: Collage Maker & Pic Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 7594559,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Photography",
    "Last Updated": "August 6, 2018",
    "Current Ver": "9.40.3",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Photo Collage Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 1028637,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "December 21, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Color Touch Effects",
    Category: "PHOTOGRAPHY",
    Rating: 3.8,
    Reviews: 167652,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "April 23, 2018",
    "Current Ver": 4.5,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "InstaSize Photo Filters & Collage Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 811714,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.0.26",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Z Camera - Photo Editor, Beauty Selfie, Collage",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 1075277,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Photography",
    "Last Updated": "August 3, 2018",
    "Current Ver": 4.21,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "PhotoGrid: Video & Pic Collage Maker, Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 7529865,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 6, 2018",
    "Current Ver": 6.71,
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Candy Camera - selfie, beauty camera, photo editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 3368705,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 16, 2018",
    "Current Ver": 4.47,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "YouCam Perfect - Selfie Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 1579343,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Pixgram- video photo slideshow",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 93726,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 8, 2018",
    "Current Ver": "2.0.18",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Fotor Photo Editor - Photo Collage & Photo Effects",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 597068,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 9, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Snapseed",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 823109,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 29, 2018",
    "Current Ver": "2.19.0.201907232",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Camera360: Selfie Photo Editor with Funny Sticker",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 4865132,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 6, 2018",
    "Current Ver": "9.3.1",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Facetune - For Free",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 49553,
    Size: "48M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.3.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Font Studio- Photo Texts Image",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 197295,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 23, 2017",
    "Current Ver": "4.0.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Add Text To Photo",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 21578,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "September 8, 2017",
    "Current Ver": "1.1.3",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Phonto - Text on Photos",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 307453,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "October 26, 2017",
    "Current Ver": "1.7.16",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Collage&Add Stickers papelook",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 32896,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 14, 2018",
    "Current Ver": "3.3.5",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Shutterfly: Free Prints, Photo Books, Cards, Gifts",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 98717,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.13.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Photo Collage - InstaMag",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 542561,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "January 2, 2018",
    "Current Ver": "4.7.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "BeautyPlus - Easy Photo Editor & Selfie Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 3158151,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 31, 2018",
    "Current Ver": "6.9.031",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Meitu – Beauty Cam, Easy Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 462702,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 1, 2018",
    "Current Ver": "8.1.0.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ESPN",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 521138,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Free Sports TV",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 1802,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 21, 2018",
    "Current Ver": 1.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "LiveScore: Live Sport Updates",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 283662,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 15, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "MLB At Bat",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 82882,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "NFL",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 459795,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "theScore: Live Sports Scores, News, Stats & Videos",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 133825,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.17.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Onefootball - Soccer Scores",
    Category: "SPORTS",
    Rating: 4.7,
    Reviews: 911995,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": "10.8.1.330",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Cristiano Ronaldo Wallpaper",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 1733,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 17, 2018",
    "Current Ver": 2.1,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "FIFA - Tournaments, Soccer News & Live Scores",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 342909,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.3.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Futbol24",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 31908,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "September 27, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "kicker football news",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 56270,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 3, 2018",
    "Current Ver": "5.4.2",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Football Live Scores",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 107724,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": 1004,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Pro 2018 - Series A and B",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 101455,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.24.2.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "BeSoccer - Soccer Live Score",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 152780,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Sport.pl LIVE",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 21733,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Sports",
    "Last Updated": "June 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "FotMob - Live Soccer Scores",
    Category: "SPORTS",
    Rating: 4.7,
    Reviews: 410384,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Yahoo Fantasy Sports - #1 Rated Fantasy App",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 277902,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Sports",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "CBS Sports App - Scores, News, Stats & Watch Live",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 91031,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "The Team - Live Sport: football, tennis, rugby ..",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 112725,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "MARCA - Sports Leader Diary",
    Category: "SPORTS",
    Rating: 3.9,
    Reviews: 76346,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.3.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Sahadan Live Scores",
    Category: "SPORTS",
    Rating: 3.9,
    Reviews: 63938,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "BBC Sport",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 18678,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "April 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Foot Mercato: transfers, results, news, live",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 39878,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 28, 2018",
    "Current Ver": "3.6.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "All Football - Latest News & Videos",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 152867,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.0.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Premier League - Official App",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 63580,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 20, 2018",
    "Current Ver": "1.1.5",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Eurosport",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 121003,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "beIN SPORTS TR",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 135763,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.5.13",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ESPN Fantasy Sports",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 176448,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "November 21, 2017",
    "Current Ver": "5.3.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "All Football GO- Live Score, Games",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 1981,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 21, 2018",
    "Current Ver": "2.9.9go",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Top Mercato: football news",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 16016,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "January 7, 2016",
    "Current Ver": "2.7.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "GollerCepte Live Score",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 9992,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 23, 2018",
    "Current Ver": 6.5,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Championat",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 36490,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Bleacher Report: sports news, scores, & highlights",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 122282,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Hovercraft Racer",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 218,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 19, 2018",
    "Current Ver": 5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "World Cup 2018",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 4011,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Sports",
    "Last Updated": "July 1, 2018",
    "Current Ver": "1.0.16",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "GollerCepte 1903",
    Category: "SPORTS",
    Rating: 4.7,
    Reviews: 25172,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 23, 2018",
    "Current Ver": 5.5,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "League18",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 14123,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.0.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Speed Boat Racing",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 2487,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 3, 2018",
    "Current Ver": 12,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "La Liga - Spanish Soccer League Official",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 180938,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 24, 2018",
    "Current Ver": "6.4.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Lionel Messi Wallpapers",
    Category: "SPORTS",
    Rating: 4.7,
    Reviews: 950,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 17, 2018",
    "Current Ver": 2.6,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Goal Live Scores",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 232423,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 11, 2018",
    "Current Ver": "4.2.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "The 5th Stand",
    Category: "SPORTS",
    Rating: 4.8,
    Reviews: 1664,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.2.677",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "NUsport",
    Category: "SPORTS",
    Rating: 3.3,
    Reviews: 1391,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "U + professional baseball",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 2486,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 30, 2018",
    "Current Ver": "06.11.00",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Mackolik Live Results",
    Category: "SPORTS",
    Rating: 3.9,
    Reviews: 188834,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Mercato foot by Maxifoot",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 697,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 16, 2017",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "MLB Ballpark",
    Category: "SPORTS",
    Rating: 3.9,
    Reviews: 5510,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 16, 2018",
    "Current Ver": "7.3.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "MUTV - Manchester United TV",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 4549,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.4.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "CBS Sports App - Scores, News, Stats & Watch Live",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 91031,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Hole19: Golf GPS App, Rangefinder & Scorecard",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 6106,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Yahoo Fantasy Sports - #1 Rated Fantasy App",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 277900,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Sports",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "ESPN",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 521138,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "NFL",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 459795,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Bleacher Report: sports news, scores, & highlights",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 122282,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "ESPN Fantasy Sports",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 176448,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "November 21, 2017",
    "Current Ver": "5.3.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "theScore: Live Sports Scores, News, Stats & Videos",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 133825,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.17.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "CBS Sports App - Scores, News, Stats & Watch Live",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 91031,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "WatchESPN",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 288809,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "September 27, 2017",
    "Current Ver": "2.5.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "CBS Sports Fantasy",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 43611,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 27, 2018",
    "Current Ver": "3.17.0+3",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "ESPN",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 521138,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "MLB At Bat",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 82882,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "CBS Sports App - Scores, News, Stats & Watch Live",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 91031,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "NBC Sports",
    Category: "SPORTS",
    Rating: 3.1,
    Reviews: 78442,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 22, 2018",
    "Current Ver": "5.12.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "WatchESPN",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 288809,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "September 27, 2017",
    "Current Ver": "2.5.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "NBC Sports Gold",
    Category: "SPORTS",
    Rating: 2.9,
    Reviews: 3017,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 2, 2018",
    "Current Ver": 3.7,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "UFC",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 30840,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Sports",
    "Last Updated": "May 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Telemundo Deportes - Live",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 36255,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.10.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SwingAid - Level up Golf",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 752,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 10, 2018",
    "Current Ver": "2.6.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Golf Channel",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 19230,
    Size: "88M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 30, 2018",
    "Current Ver": "4.5.19.56",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "The Rules of Golf",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 926,
    Size: "9.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "January 17, 2018",
    "Current Ver": 5.9,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "GolfNow: Tee Time Deals at Golf Courses, Golf GPS",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 26102,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Golf GPS by SwingxSwing",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 37167,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Zepp Golf Swing Analyzer",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 2020,
    Size: "84M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 24, 2018",
    "Current Ver": "4.4.0",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Live Golf Scores - US & European Golf",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 798,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": 3.5,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Golfshot: Golf GPS + Tee Times",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 7543,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.31.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "PGA TOUR LIVE",
    Category: "SPORTS",
    Rating: 3.4,
    Reviews: 1845,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 7, 2017",
    "Current Ver": "1.3.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Golf GPS Rangefinder: Golf Pad",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 13098,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Mobitee GPS Golf Free",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 1904,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 11, 2018",
    "Current Ver": "2.0.22",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Hole19: Golf GPS App, Rangefinder & Scorecard",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 6106,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "GolfLogix GPS + Putt Breaks",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 11085,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 21, 2018",
    "Current Ver": "8.9.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Golfshot Plus: Golf GPS",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 3387,
    Size: "25M",
    Type: "Paid",
    Price: "$29.99",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 11, 2018",
    "Current Ver": "4.18.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "PGA TOUR",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 11151,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 27, 2018",
    "Current Ver": 2018.6,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "FanDuel: Daily Fantasy Sports",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 29673,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Sports",
    "Last Updated": "August 6, 2018",
    "Current Ver": "2.46.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Yahoo Fantasy Sports - #1 Rated Fantasy App",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 277904,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Sports",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "DraftKings - Daily Fantasy Sports",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 50017,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Adults only 18+",
    Genres: "Sports",
    "Last Updated": "July 24, 2018",
    "Current Ver": "3.21.324",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fantasy Football Manager (FPL)",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 63650,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 3, 2018",
    "Current Ver": "7.0.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ESPN Fantasy Sports",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 176450,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "November 21, 2017",
    "Current Ver": "5.3.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Fantasy Football",
    Category: "SPORTS",
    Rating: 3.5,
    Reviews: 50179,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.5.7.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "CBS Sports Fantasy",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 43611,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 27, 2018",
    "Current Ver": "3.17.0+3",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "ESPN",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 521140,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "US Open Tennis Championships 2018",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 9971,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 5, 2018",
    "Current Ver": 7.1,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Bleacher Report: sports news, scores, & highlights",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 122283,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Live Tennis Rankings / LTR",
    Category: "SPORTS",
    Rating: 4.8,
    Reviews: 1660,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 5, 2018",
    "Current Ver": 3.9,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Tennis Livescore Widget",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 361,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "October 13, 2016",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Tennis Temple - Live Scores",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 5305,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "The Championships, Wimbledon 2018",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 24082,
    Size: "95M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 4, 2018",
    "Current Ver": 6.5,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "theScore: Live Sports Scores, News, Stats & Videos",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 133833,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.17.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "CBS Sports App - Scores, News, Stats & Watch Live",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 91033,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Tennis 24 - tennis live scores",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 990,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 18, 2018",
    "Current Ver": "2.28.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Yahoo Sports - scores, stats, news, & highlights",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 32386,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": "7.8.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Tennis News and Scores",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 101,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 15, 2018",
    "Current Ver": 5.4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "ESPN",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 521140,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Bleacher Report: sports news, scores, & highlights",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 122283,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "MLB At Bat",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 82883,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "theScore: Live Sports Scores, News, Stats & Videos",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 133833,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.17.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "CBS Sports App - Scores, News, Stats & Watch Live",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 91033,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "MSN Sports - Scores & Schedule",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 35394,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.2.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Yahoo Sports - scores, stats, news, & highlights",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 32386,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": "7.8.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "WatchESPN",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 288809,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "September 27, 2017",
    "Current Ver": "2.5.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "FOX Sports: Live Streaming, Scores & News",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 28895,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Sports",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.4.15",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "FotMob - Live Soccer Scores",
    Category: "SPORTS",
    Rating: 4.7,
    Reviews: 410395,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Sports Alerts - NFL edition",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 11549,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Yahoo Fantasy Sports - #1 Rated Fantasy App",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 277904,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Sports",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "ESPN",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 521140,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "NCAA March Madness Live",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 34123,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 30, 2018",
    "Current Ver": "7.1.0",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "NFL",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 459797,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "SportsManias Fantasy Team News",
    Category: "SPORTS",
    Rating: 3.5,
    Reviews: 4057,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 10, 2018",
    "Current Ver": "3.2.12",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Thuuz Sports",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 5517,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "April 3, 2018",
    "Current Ver": "6.9.12",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "NCAA Sports",
    Category: "SPORTS",
    Rating: 3.9,
    Reviews: 4272,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "April 23, 2018",
    "Current Ver": "3.0.13",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "850 Sports News Digest",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 539,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 23, 2016",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "US Open Tennis Championships 2018",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 9971,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 5, 2018",
    "Current Ver": 7.1,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Bleacher Report: sports news, scores, & highlights",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 122283,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "MLB At Bat",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 82883,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "FIFA - Tournaments, Soccer News & Live Scores",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 342912,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.3.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "365Scores - Live Scores",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 666521,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 29, 2018",
    "Current Ver": "5.5.9",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Cricbuzz - Live Cricket Scores & News",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 838765,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "theScore: Live Sports Scores, News, Stats & Videos",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 133833,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.17.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Fantasy Football & NFL News",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 2943,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 15, 2018",
    "Current Ver": "6.1.3",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "NBA",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 108318,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 9, 2018",
    "Current Ver": "2017.7.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Golfshot: Golf GPS + Tee Times",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 7543,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.31.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "BBC Sport",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 18679,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "April 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "CBS Sports App - Scores, News, Stats & Watch Live",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 91033,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Yahoo Sports - scores, stats, news, & highlights",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 32386,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": "7.8.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "NHL",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 68935,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 27, 2018",
    "Current Ver": "9.4.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "NASCAR MOBILE",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 80900,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 25, 2018",
    "Current Ver": "7.1.7.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "WatchESPN",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 288809,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "September 27, 2017",
    "Current Ver": "2.5.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "MLB Ballpark",
    Category: "SPORTS",
    Rating: 3.9,
    Reviews: 5511,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 16, 2018",
    "Current Ver": "7.3.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Univision Deportes: Liga MX, MLS, Fútbol Live",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 75545,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "FOX Sports: Live Streaming, Scores & News",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 28895,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Sports",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.4.15",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Fantasy Football",
    Category: "SPORTS",
    Rating: 3.5,
    Reviews: 50179,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.5.7.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "PGA TOUR",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 11151,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 27, 2018",
    "Current Ver": 2018.6,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "UFC",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 30840,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Sports",
    "Last Updated": "May 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Real Basketball",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 1605267,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "December 5, 2016",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Expedia Hotels, Flights & Car Rental Travel Deals",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 136626,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": "18.30.0",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "trivago: Hotels & Travel",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 219848,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Hopper - Watch & Book Flights",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 52029,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "TripIt: Travel Organizer",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 49190,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 15, 2018",
    "Current Ver": "7.5.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Trip by Skyscanner - City & Travel Guide",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 5150,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "CityMaps2Go Plan Trips Travel Guide Offline Maps",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 64713,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 9, 2018",
    "Current Ver": "10.9.8 (Play)",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "KAYAK Flights, Hotels & Cars",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 216388,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Skyscanner",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 481545,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": 5.48,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "World Travel Guide by Triposo",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 6012,
    Size: "81M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "March 5, 2018",
    "Current Ver": "4.6.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Hotels.com: Book Hotel Rooms & Find Vacation Deals",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 260121,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Booking.com Travel Deals",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.7,
    Reviews: 1830388,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Hostelworld: Hostels & Cheap Hotels Travel App",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 17878,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 16, 2018",
    "Current Ver": "6.7.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Google Trips - Travel Planner",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 26871,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.10.0.205086730",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "TripAdvisor Hotels Flights Restaurants Attractions",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 1162837,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Airbnb",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 359403,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Maps - Navigate & Explore",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 9235155,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "trivago: Hotels & Travel",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 219848,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "GPS Map Free",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4,
    Reviews: 33782,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 11, 2018",
    "Current Ver": 4.6,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Offline Maps & Navigation",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.7,
    Reviews: 192641,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 7, 2018",
    "Current Ver": "17.4.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Google Earth",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 2338655,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 18, 2018",
    "Current Ver": "9.2.17.13",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "GasBuddy: Find Cheap Gas",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.6,
    Reviews: 751551,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Travel & Local",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.2.0 21127",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Southwest Airlines",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.9,
    Reviews: 24781,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 11, 2018",
    "Current Ver": "5.6.1",
    numInstall: 5000000,
    numAndroid: 6,
  },
  {
    App: "AT&T Navigator: Maps, Traffic",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.6,
    Reviews: 32862,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "December 6, 2016",
    "Current Ver": "5.10.6.2.8466393",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "VZ Navigator",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4,
    Reviews: 16101,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "January 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "KakaoMap - Map / Navigation",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 76779,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Google Street View",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 2129689,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "AirAsia",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.9,
    Reviews: 98585,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 16, 2018",
    "Current Ver": "5.0.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Expedia Hotels, Flights & Car Rental Travel Deals",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 136633,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": "18.30.0",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Goibibo - Flight Hotel Bus Car IRCTC Booking App",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 459851,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 1, 2018",
    "Current Ver": "3.9.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Allegiant",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.1,
    Reviews: 5572,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 12, 2018",
    "Current Ver": "5.16.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Amtrak",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.7,
    Reviews: 16815,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 15, 2018",
    "Current Ver": "3.1.3",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "JAL (Domestic and international flights)",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.4,
    Reviews: 2277,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 7, 2018",
    "Current Ver": "4.4.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Flight & Hotel Booking App - ixigo",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 45562,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 30, 2018",
    "Current Ver": "4.0.9.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "VZ Navigator for Tablets",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.6,
    Reviews: 285,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "January 22, 2018",
    "Current Ver": "10.7.8.111",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "TripAdvisor Hotels Flights Restaurants Attractions",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 1162838,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "HSL - Tickets, route planner and information",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.3,
    Reviews: 256,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.1.2",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Wisepilot for XPERIA™",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.7,
    Reviews: 21443,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "January 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "VZ Navigator for Galaxy S4",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3,
    Reviews: 2750,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "January 22, 2018",
    "Current Ver": "10.7.8.111",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "MAIN",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.6,
    Reviews: 7081,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": "4.1.21",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Yoriza Pension - travel, lodging, pension, camping, caravan, pool villas accommodation discount",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.8,
    Reviews: 17882,
    Size: "86M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.4.5",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Foursquare Swarm: Check In",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.9,
    Reviews: 421800,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Travel & Local",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "PagesJaunes - local search",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.8,
    Reviews: 43935,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 1, 2018",
    "Current Ver": "8.13.3",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Flightradar24 Flight Tracker",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 171889,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 18, 2018",
    "Current Ver": "7.8.0",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Yatra - Flights, Hotels, Bus, Trains & Cabs",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 251037,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 5, 2018",
    "Current Ver": "13.0.16",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "SNCF",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.4,
    Reviews: 15750,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Fly Delta",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.7,
    Reviews: 27560,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.13.2",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Skyscanner",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 481546,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": 5.48,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Despegar.com Hotels and Flights",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 150932,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 30, 2018",
    "Current Ver": "9.1.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Navigation Plus",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 928,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "January 9, 2018",
    "Current Ver": "11.0.269 (m)",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "2GIS: directory & navigator",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 768833,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Poynt",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4,
    Reviews: 26665,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "March 29, 2018",
    "Current Ver": "2.5.26",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Gaode Map",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.9,
    Reviews: 13275,
    Size: "71M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 3, 2018",
    "Current Ver": "8.60.0.2586",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Priceline Hotel Deals, Rental Cars & Flights",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 48930,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 26, 2018",
    "Current Ver": "4.38.176",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "TravelPirates",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.8,
    Reviews: 43054,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Booking.com Travel Deals",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.7,
    Reviews: 1830387,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Free Radar Detector",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 15680,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 6, 2018",
    "Current Ver": "6.2.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "American Airlines",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.7,
    Reviews: 16980,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Where to travel - ticket. hotel. train ticket. car ticket. travel. tickets",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 5112,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 27, 2018",
    "Current Ver": "8.8.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "United Airlines",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.5,
    Reviews: 30447,
    Size: "80M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.1.56",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "NTES",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 165299,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 30, 2018",
    "Current Ver": 8,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Where is my Train : Indian Railway & PNR Status",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.7,
    Reviews: 620534,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 30, 2018",
    "Current Ver": "5.7.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "MakeMyTrip-Flight Hotel Bus Cab IRCTC Rail Booking",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 599872,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 4, 2018",
    "Current Ver": "7.3.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Restaurant Finder",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 12564,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Zagat",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.1,
    Reviews: 2528,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 14, 2016",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Gormey: Find Best Restaurants",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 34,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 29, 2017",
    "Current Ver": 2.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Find Dining Restaurant Finder",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 427,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "March 21, 2016",
    "Current Ver": "1.2.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Urbanspoon Restaurant Reviews",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 35560,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 5, 2016",
    "Current Ver": "4.0.21",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Yelp: Food, Shopping, Services Nearby",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 397422,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Travel & Local",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "TripAdvisor Hotels Flights Restaurants Attractions",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 1162837,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Qatar Airways",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 11182,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 30, 2018",
    "Current Ver": 11.26,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hipmunk Hotels & Flights",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 16734,
    Size: "10.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "8.8.2",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Priceline Hotel Deals, Rental Cars & Flights",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 48930,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 26, 2018",
    "Current Ver": "4.38.176",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "United Airlines",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.5,
    Reviews: 30447,
    Size: "80M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.1.56",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Expedia Hotels, Flights & Car Rental Travel Deals",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 136626,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": "18.30.0",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Skiplagged — Exclusive Flights & Hotels",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.6,
    Reviews: 10035,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "CWT To Go",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 20313,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 5, 2018",
    "Current Ver": "17.7.8",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "British Airways",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 25740,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 24, 2018",
    "Current Ver": 4.2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Southwest Airlines",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.9,
    Reviews: 24781,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 11, 2018",
    "Current Ver": "5.6.1",
    numInstall: 5000000,
    numAndroid: 6,
  },
  {
    App: "Cheap Flights & Hotels momondo",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 42546,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "April 25, 2018",
    "Current Ver": "7.6.5",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "CheapTickets – Hotels, Flights & Travel Deals",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 6925,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "JetBlue",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 24281,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 25, 2018",
    "Current Ver": "4.4.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hopper - Watch & Book Flights",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 52028,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Flights",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 18039,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 26, 2018",
    "Current Ver": "3.6.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fly Delta",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.7,
    Reviews: 27560,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.13.2",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "The Emirates App",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 22748,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": "4.7.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "KAYAK Flights, Hotels & Cars",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 216388,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "American Airlines",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.7,
    Reviews: 16980,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Cheapflights – Flight Search",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 47780,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "KLM - Royal Dutch Airlines",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.7,
    Reviews: 7705,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": "9.7.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Orbitz - Hotels, Flights & Package Deals",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 33256,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Skyscanner",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 481546,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": 5.48,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Lufthansa",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.6,
    Reviews: 14544,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 27, 2018",
    "Current Ver": "7.2.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "easyJet: Travel App",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 134895,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 1, 2018",
    "Current Ver": "2.32.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "IndiGo",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4,
    Reviews: 48082,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 25, 2018",
    "Current Ver": "4.1.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "LateRooms: Find Hotel Deals",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 2419,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 29, 2018",
    "Current Ver": "1.24.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Choice Hotels",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 17915,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Couchsurfing Travel App",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 61776,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Travel & Local",
    "Last Updated": "July 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Hotwire Hotel & Car Rental App",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 10323,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Priceline Hotel Deals, Rental Cars & Flights",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 48930,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 26, 2018",
    "Current Ver": "4.38.176",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "HOTEL DEALS",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 1609,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "April 26, 2018",
    "Current Ver": "53.89.55",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "trivago: Hotels & Travel",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 219848,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Expedia Hotels, Flights & Car Rental Travel Deals",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 136626,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": "18.30.0",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "HomeAway Vacation Rentals",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 30403,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "KAYAK Flights, Hotels & Cars",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 216388,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Orbitz - Hotels, Flights & Package Deals",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 33256,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Skyscanner",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 481546,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": 5.48,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "IHG®: Hotel Deals & Rewards",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 18622,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.15.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SPG: Starwood Hotels & Resorts",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 8258,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 3, 2018",
    "Current Ver": "v5.4.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hotels.com: Book Hotel Rooms & Find Vacation Deals",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 260133,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Booking.com Travel Deals",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.7,
    Reviews: 1830388,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "HotelTonight: Book amazing deals at great hotels",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 57573,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Hostelworld: Hostels & Cheap Hotels Travel App",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 17878,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 16, 2018",
    "Current Ver": "6.7.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "TripAdvisor Hotels Flights Restaurants Attractions",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 1162837,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Airbnb",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 359560,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Hotels Combined - Cheap deals",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 17202,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "November 13, 2017",
    "Current Ver": "4.9.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Agoda – Hotel Booking Deals",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.6,
    Reviews: 263525,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Turo - Better Than Car Rental",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 14114,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 4, 2018",
    "Current Ver": "18.21.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Ascape VR: 360° Virtual Travel",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 890,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local;Action & Adventure",
    "Last Updated": "August 9, 2017",
    "Current Ver": "4.0.38",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Cheap hotel deals and discounts — Hotellook",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 7153,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Skyscanner",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 481546,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": 5.48,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "HotelTonight: Book amazing deals at great hotels",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 57573,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Maps - Navigate & Explore",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 9235373,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "GPS Status & Toolbox",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 149723,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 13, 2018",
    "Current Ver": "8.1.171",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Airport + Flight Tracker Radar",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 6762,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 14, 2015",
    "Current Ver": 8,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Scout GPS Navigation & Meet Up",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 120373,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.19.35.999",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Street Panorama View",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 40225,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 18, 2018",
    "Current Ver": "4.0.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Geo Tracker - GPS tracker",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 42849,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 10, 2016",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "DreamTrips",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.7,
    Reviews: 9971,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": "1.28.1",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Navmii GPS USA (Navfree)",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4,
    Reviews: 5960,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Sygic Truck GPS Navigation",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 18294,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 2, 2018",
    "Current Ver": "13.8.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Google Street View",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 2129707,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Moto File Manager",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 38655,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 1, 2018",
    "Current Ver": "v3.7.93",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Google",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 8033493,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Google Translate",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 5745093,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Moto Display",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 18239,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Motorola Alert",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 24199,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 21, 2014",
    "Current Ver": "1.02.53",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Motorola Assist",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 37333,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 17, 2016",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Cache Cleaner-DU Speed Booster (booster & cleaner)",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 12759663,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 25, 2018",
    "Current Ver": "3.1.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Moto Suggestions ™",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 308,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 8, 2018",
    "Current Ver": "0.2.32",
    numInstall: 1000000,
    numAndroid: 8,
  },
  {
    App: "Moto Voice",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 33216,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Calculator",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 40770,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 21, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Device Help",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 28860,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Account Manager",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 76604,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 27, 2016",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "myMetro",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 26189,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 27, 2018",
    "Current Ver": "MyMetro_HTML_2.0_430029",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "File Manager",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 739329,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 17, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "My Telcel",
    Category: "TOOLS",
    Rating: 3.1,
    Reviews: 45838,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 25, 2018",
    "Current Ver": "7.6.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Calculator - free calculator, multi calculator app",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 25592,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": "v8.0.1.8.0629.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ASUS Sound Recorder",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 34126,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "iWnn IME for Nexus",
    Category: "TOOLS",
    Rating: 3.2,
    Reviews: 2394,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 13, 2014",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Samsung Max - Data Savings & Privacy Protection",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 330468,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Android TV Remote Service",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 17, 2018",
    "Current Ver": "2.1.02.4477839",
    numInstall: 1000000,
    numAndroid: 7,
  },
  {
    App: "ZenUI Help",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 136874,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Calculator - free calculator ,multi calculator app",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 1236,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 6, 2018",
    "Current Ver": "8.1.6",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "SHAREit - Transfer & Share",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 7790693,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": "4.5.28_ww",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "ZenUI Keyboard – Emoji, Theme",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 537554,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Files Go by Google: Free up space on your phone",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 315585,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.0.204375696",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "SD card backup",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 142,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 27, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Nokia mobile support",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 12215,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.7.4",
    numInstall: 5000000,
    numAndroid: 7,
  },
  {
    App: "File Manager -- Take Command of Your Files Easily",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 127223,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 3, 2018",
    "Current Ver": "v7.0.7.1.0625.1_06_0629",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Samsung Calculator",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 9602,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 5, 2018",
    "Current Ver": "6.0.61.5",
    numInstall: 100000000,
    numAndroid: 7,
  },
  {
    App: "Clear",
    Category: "TOOLS",
    Rating: 3.1,
    Reviews: 24151,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 6, 2018",
    "Current Ver": "11.7.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Phone",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 45483,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "HTC Lock Screen",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 28250,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 21, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Gboard - the Google Keyboard",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 1859115,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Google Korean Input",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 74819,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: 7,
  },
  {
    App: "AT&T Smart Wi-Fi",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 18513,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 26, 2018",
    "Current Ver": 3.2,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Google app for Android TV",
    Category: "TOOLS",
    Rating: 3,
    Reviews: 66,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Sound Recorder: Recorder & Voice Changer Free",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 14552,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": "v7.0.9.1.0526.1_06_0704",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Remote Link (PC Remote)",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 87055,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 3, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "HTC Sense Input",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 17030,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 12, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Share Music & Transfer Files - Xender",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 1280423,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "App vault",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 25094,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "TouchPal Keyboard for vivo",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 357,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 30, 2018",
    "Current Ver": "6.2.6.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Google Assistant Go",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 315,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.8.203182757.armeabi-v7a.release",
    numInstall: 500000,
    numAndroid: 8,
  },
  {
    App: "My love",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 163997,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 5, 2018",
    "Current Ver": 5.36,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DuraSpeed",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 5431,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 13, 2017",
    "Current Ver": "1.5.0",
    numInstall: 10000000,
    numAndroid: 6,
  },
  {
    App: "HTC Sense Input-LV",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 59,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 22, 2014",
    "Current Ver": "9.7.753080",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "HTC Sense Input-CA",
    Category: "TOOLS",
    Rating: 3.1,
    Reviews: 124,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 22, 2014",
    "Current Ver": "9.7.753080",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "HTC Sense Input-AR",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 1420,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 22, 2014",
    "Current Ver": "9.7.753080",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Digital Alarm Clock",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 118439,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 19, 2018",
    "Current Ver": 10.4,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Alarm Clock Free",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 59973,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 16, 2018",
    "Current Ver": "1.2.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Puzzle Alarm Clock ⏰",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 32111,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.1.0.1126",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Alarm Clock",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 114788,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "I Can't Wake Up! Alarm Clock",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 70404,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 25, 2018",
    "Current Ver": "3.4.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "High-Powered Flashlight",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 429580,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Brightest Flashlight - LED Light",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 876866,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.4.9",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "LED Flashlight",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 207706,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 10, 2017",
    "Current Ver": 2.4,
    numInstall: 10000000,
    numAndroid: 3,
  },
  {
    App: "Tiny Flashlight + LED",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 4254879,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 8, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Flashlight & LED Torch",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 111507,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 29, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Color Flashlight",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 472904,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 14, 2017",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Flashlight",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 115409,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "CM Flashlight (Compass, SOS)",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 166367,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.4.0",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Flashlight HD LED",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 618918,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Flashlight - Torch LED Light",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 192661,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 7, 2018",
    "Current Ver": "2.4.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Super Flashlight + LED",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 54207,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 11, 2017",
    "Current Ver": 3.2,
    numInstall: 5000000,
    numAndroid: 3,
  },
  {
    App: "Brightest LED Flashlight",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 60571,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Brightest Flashlight Free ®",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 1335799,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 27, 2017",
    "Current Ver": "2.5.2",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Fraction Calculator Plus Free",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 148506,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 15, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Calculator Plus Free",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 679912,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "CALCU™ Stylish Calculator Free",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 152692,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 7, 2018",
    "Current Ver": "3.5.6",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Mobi Calculator free & AD free!",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 77311,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 9, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Calculator with Percent (Free)",
    Category: "TOOLS",
    Rating: 4.8,
    Reviews: 48211,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 18, 2017",
    "Current Ver": 32.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Graphing Calculator",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 12388,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 1, 2016",
    "Current Ver": 1.17,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Unit Converter",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 85387,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 3, 2018",
    "Current Ver": "2.1.54",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Calculator ++",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 33509,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 12, 2018",
    "Current Ver": "2.2.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "MyScript Calculator",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 342336,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools;Education",
    "Last Updated": "August 10, 2015",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "ConvertPad - Unit Converter",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 90831,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 18, 2017",
    "Current Ver": "3.1.00",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Unit Converter Pro",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 12718,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Classic Calculator",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 85659,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 25, 2018",
    "Current Ver": 1.51,
    numInstall: 5000000,
    numAndroid: 3,
  },
  {
    App: "Scientific Calculator Free",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 16395,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "weight conversion calculator",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 807,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 18, 2018",
    "Current Ver": 20180517,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Age Calculator",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 24265,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 25, 2017",
    "Current Ver": "4.0.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "EzCalculator",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 1657,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 17, 2017",
    "Current Ver": "2.1.0",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "SuperVPN Free VPN Client",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 576454,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 5, 2018",
    "Current Ver": "2.0.9",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Hideman VPN",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 88675,
    Size: "9.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 24, 2018",
    "Current Ver": "6.0.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Fast Secure VPN",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 56848,
    Size: "9.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 18, 2018",
    "Current Ver": "1.6.11",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Free & Premium VPN - FinchVPN",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 19096,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 5, 2018",
    "Current Ver": "2.0.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hotspot Shield Free VPN Proxy & Wi-Fi Security",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 1116393,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 6, 2018",
    "Current Ver": "6.1.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "OpenVPN Connect – Fast & Safe SSL VPN Client",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 154578,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 25, 2018",
    "Current Ver": "3.0.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "VPN - Fast, Secure & Unlimited WiFi with VyprVPN",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 40676,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 5, 2018",
    "Current Ver": "2.27.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "FREEDOME VPN Unlimited anonymous Wifi Security",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 39833,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 9, 2018",
    "Current Ver": "2.5.1.7592",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SurfEasy Secure Android VPN",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 273283,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 11, 2018",
    "Current Ver": "4.1.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "TunnelBear VPN",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 139480,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 19, 2018",
    "Current Ver": "v150",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "VPN Free - Betternet Hotspot VPN & Private Browser",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 801054,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.3.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Gboard - the Google Keyboard",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 1859109,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Smart Keyboard Trial",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 65597,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 28, 2017",
    "Current Ver": "4.20.1",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Emoji keyboard - Cute Emoticons, GIF, Stickers",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 1107320,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 7, 2018",
    "Current Ver": "3.4.500",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "GO Keyboard - Cute Emojis, Themes and GIFs",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 4594198,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Google Handwriting Input",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 94427,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Wifi Analyzer",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 335115,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 7, 2018",
    "Current Ver": "3.11.2",
    numInstall: 10000000,
    numAndroid: 6,
  },
  {
    App: "Network Signal Info",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 33926,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.78.06",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Speedtest by Ookla",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 1028794,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "osmino Wi-Fi: free WiFi",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 134203,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 6, 2018",
    "Current Ver": "6.06.14",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "WiFi Overview 360",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 15693,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.32.07",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Speedcheck",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 48979,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 4, 2018",
    "Current Ver": "5.0.0.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Internet Speed Meter Lite",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 410303,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 5, 2016",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Wifi Inspector",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 63712,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 12, 2016",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "WiFi Automatic",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 10595,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "NETGEAR WiFi Analytics",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 9496,
    Size: "696k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 25, 2014",
    "Current Ver": "1.0.19",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Keypad Lock Screen",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 428581,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 17, 2018",
    "Current Ver": 1.33,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "photo keypad lockscreen",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 225544,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 17, 2018",
    "Current Ver": "3.1.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "CM Locker - Security Lockscreen",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 3090727,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Solo Locker (DIY Locker)",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 474439,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 26, 2018",
    "Current Ver": "6.1.7.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Lock Screen",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 41137,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 15, 2017",
    "Current Ver": "1.7.3",
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "ZERO Lock Screen",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 75336,
    Size: "544k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 5, 2016",
    "Current Ver": 1.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AppLock - Fingerprint",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 745245,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 13, 2018",
    "Current Ver": "7.2.0",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Applock",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 4934130,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Smart AppLock (App Protect)",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 137562,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Screen Off and Lock",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 172990,
    Size: "525k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 2, 2017",
    "Current Ver": "1.17.4",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Screen Lock",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 68309,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 23, 2017",
    "Current Ver": "v3.9f",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Nova Launcher",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 1121805,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 14, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Funny Ringtones",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 7146,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Personalization",
    "Last Updated": "February 2, 2018",
    "Current Ver": 1.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ZEDGE™ Ringtones & Wallpapers",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 6466641,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "XOS - Launcher,Theme,Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 49657,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 6, 2018",
    "Current Ver": "3.6.21_pre",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "3D Live Neon Weed Launcher",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 1724,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Personalization",
    "Last Updated": "June 26, 2018",
    "Current Ver": "5.34.10",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Evie Launcher",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 139258,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Golden Launcher",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 32794,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.284.1.83",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Launcher",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 102923,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 10, 2018",
    "Current Ver": "2.1.2",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "CM Launcher 3D - Theme, Wallpapers, Efficient",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 6702776,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "August 3, 2018",
    "Current Ver": "5.41.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "4K Wallpapers and Ultra HD Backgrounds",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 7583,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Personalization",
    "Last Updated": "July 4, 2018",
    "Current Ver": "2.6.2.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "OnePlus Launcher",
    Category: "PERSONALIZATION",
    Rating: 4,
    Reviews: 24215,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Birds Sounds Ringtones & Wallpapers",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 5073,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Personalization",
    "Last Updated": "September 25, 2017",
    "Current Ver": 1.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Funny Alarm Clock Ringtones",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 15633,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 9, 2017",
    "Current Ver": 1.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ZenUI Launcher",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 1141545,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Color Call - Caller Screen, LED Flash",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 29485,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 20, 2018",
    "Current Ver": "1.0.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "New Launcher 2018",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 142393,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.284.1.126",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Diamond Zipper Lock Screen",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 71688,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 11, 2018",
    "Current Ver": 3.5,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Emoji Keyboard - Cute Emoji,GIF, Sticker, Emoticon",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 114851,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.1.9",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "3D Blue Glass Water Keyboard Theme",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 62209,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 1, 2018",
    "Current Ver": "6.7.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Backgrounds (HD Wallpapers)",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 202474,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "August 9, 2017",
    "Current Ver": "2.6.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Smart Launcher 5",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 512102,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "New 2018 Keyboard",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 298321,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 5, 2018",
    "Current Ver": "2.5.5.9",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "APUS Launcher - Theme, Wallpaper, Hide Apps",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 5783441,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 6, 2018",
    "Current Ver": "3.9.7",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "ZenUI Themes – Stylish Themes",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 47393,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.8.0.24_180511",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Keyboard - wallpapers , photos",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 55525,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "February 26, 2018",
    "Current Ver": "1.2.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Lovely Cute Pink Kitty Cat Keyboard Theme",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 2267,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 9, 2018",
    "Current Ver": "6.7.5",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Apex Launcher",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 266401,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Microsoft Launcher",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 649568,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.12.0.44682",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Goku Wallpaper Art",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 6342,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 13, 2018",
    "Current Ver": 1.8,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Door Lock Screen",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 5413,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 28, 2018",
    "Current Ver": "3.3.a",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Yandex Browser with Protect",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 1237135,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Cute wallpapers & kawaii backgrounds images",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 4724,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 30, 2018",
    "Current Ver": 1.2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ASUS Cover for ZenFone 2",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 43960,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 1, 2017",
    "Current Ver": "2.0.0.39_171124",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Hola Launcher- Theme,Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 3277209,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 9, 2018",
    "Current Ver": "3.2.5",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "OnePlus Icon Pack - Square",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 229,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 23, 2018",
    "Current Ver": "1.9.1.180419172630.4a15962",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Live 3D Neon Blue Love Heart Keyboard Theme",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 6626,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.7.25.2018",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Pink Diamond Princess Keyboard Theme",
    Category: "PERSONALIZATION",
    Rating: 3.7,
    Reviews: 10796,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 6, 2018",
    "Current Ver": "6.7.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Wallpapers HD, 4K Backgrounds",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 273994,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.3.27",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Photo Lock App - Hide Pictures & Videos",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 29203,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 10, 2017",
    "Current Ver": 40,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Romantic Love Photo Frames",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 18918,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 19, 2018",
    "Current Ver": 1.14,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Colorful Glitter Neon Butterfly Keyboard Theme",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 2056,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.7.24.2018",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "OnePlus Icon Pack",
    Category: "PERSONALIZATION",
    Rating: 4.8,
    Reviews: 440,
    Size: "920k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 23, 2018",
    "Current Ver": "1.9.2.180419172639.dbf3246",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Water Garden Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 66453,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 10, 2018",
    "Current Ver": 1.57,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Water Droplets Keyboard Theme",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 398,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 29, 2018",
    "Current Ver": "6.6.28",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "FUN Keyboard – Emoji Keyboard, Sticker,Theme & GIF",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 12089,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.2.5",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Freeme Launcher—Stylish Theme",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 2828,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 22, 2017",
    "Current Ver": "2.11.5",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ZEDGE™ Ringtones & Wallpapers",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 6466641,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Ringtones & Wallpapers for Me",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 89342,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 30, 2018",
    "Current Ver": 1.13,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Ringtone Maker",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 495905,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Retro Clock Widget",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 86743,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "November 1, 2016",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Zooper Widget",
    Category: "PERSONALIZATION",
    Rating: 4,
    Reviews: 30498,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 11, 2015",
    "Current Ver": 2.6,
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Beautiful Widgets Pro",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 97890,
    Size: "14M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 24, 2016",
    "Current Ver": "5.7.8",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Beautiful Widgets Free",
    Category: "PERSONALIZATION",
    Rating: 3.9,
    Reviews: 25037,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "October 20, 2016",
    "Current Ver": "5.7.6",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "HD Widgets",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 58617,
    Size: "26M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 7, 2016",
    "Current Ver": "4.3.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "DashClock Widget",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 62301,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 11, 2016",
    "Current Ver": "1.7.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fancy Widgets",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 37237,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 4, 2014",
    "Current Ver": "3.5.6",
    numInstall: 5000000,
    numAndroid: 1,
  },
  {
    App: "Kairo XP (for HD Widgets)",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 1591,
    Size: "779k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 7, 2015",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "icon wallpaper dressup💞CocoPPa",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 595120,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "The real aquarium - HD",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 100130,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Best Wallpapers QHD",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 294701,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "March 17, 2018",
    "Current Ver": 2.85,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Dog Licks Screen Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 63624,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "November 20, 2017",
    "Current Ver": 11,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Waterfall Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 112977,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 22, 2018",
    "Current Ver": 3.6,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Galaxy Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 58052,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "September 14, 2017",
    "Current Ver": "1.1.8",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Northern Lights FREE (Aurora)",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 12180,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 24, 2016",
    "Current Ver": 1.3,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Flowers Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 118459,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "October 27, 2017",
    "Current Ver": 4,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Petals 3D live wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 112479,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 25, 2018",
    "Current Ver": "3.0.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Galactic Core Free Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 69417,
    Size: "853k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 1, 2014",
    "Current Ver": 2.41,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "LINE Launcher",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 733838,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 29, 2018",
    "Current Ver": "2.4.25",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Asteroids 3D live wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 157495,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 24, 2018",
    "Current Ver": "4.0.0.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Sun Rise Free Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 86481,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 31, 2018",
    "Current Ver": "4.8.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Wallpapers HD",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 484981,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "November 28, 2016",
    "Current Ver": "1.7.1",
    numInstall: 10000000,
    numAndroid: 3,
  },
  {
    App: "Tiger Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 77724,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "May 31, 2018",
    "Current Ver": "2.7.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "ZEDGE™ Ringtones & Wallpapers",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 6466641,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Backgrounds HD (Wallpapers)",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 2390185,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Pink Roses Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 33074,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 4, 2018",
    "Current Ver": 4.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Butterfly Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 35771,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 4, 2018",
    "Current Ver": 4.1,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Koi Free Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 290241,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 24, 2014",
    "Current Ver": 1.9,
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 69488,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 8, 2018",
    "Current Ver": 6.07,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Wolves Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 10401,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "October 27, 2017",
    "Current Ver": 7.5,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Horses Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 28806,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 22, 2018",
    "Current Ver": 18,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Tropical Beach Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4,
    Reviews: 11343,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 22, 2018",
    "Current Ver": 18,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Glowing Flowers Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 66730,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 21, 2018",
    "Current Ver": 18,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Dolphins Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 25807,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "October 29, 2017",
    "Current Ver": 15,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Nova Launcher",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 1121805,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 14, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Apex Launcher",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 266402,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Smart Launcher 5",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 512106,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Buzz Launcher-Smart&Free Theme",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 251616,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "November 13, 2017",
    "Current Ver": "1.9.7.07",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Yandex.Shell (Launcher+Dialer)",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 87300,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 17, 2015",
    "Current Ver": 2.32,
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "ADW Launcher 2",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 181399,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 8, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "BIG Launcher",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 881,
    Size: "5.9M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 20, 2018",
    "Current Ver": "2.5.9",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Smart Launcher Pro 3",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 40704,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$4.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "iKeyboard - emoji, emoticons",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 624924,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.8.2.2195",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Simple Neon Blue Future Tech Keyboard Theme",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 51145,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 28, 2018",
    "Current Ver": 1,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ai.type Free Emoji Keyboard",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 647844,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "GO Keyboard - Emoticon keyboard, Free Theme, GIF",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 2591941,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "TouchPal Purple Butterfly Theme",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 7435,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 28, 2018",
    "Current Ver": 1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "2018Emoji Keyboard 😂 Emoticons Lite -sticker&gif",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 115773,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Lavender Emoji Keyboard Theme",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 12008,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 27, 2016",
    "Current Ver": 5,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Microsoft Word",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 2084126,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 11, 2018",
    "Current Ver": "16.0.10325.20043",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "All-In-One Toolbox: Cleaner, Booster, App Manager",
    Category: "PRODUCTIVITY",
    Rating: 4.7,
    Reviews: 536926,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Adobe Acrobat Reader",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 3016297,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 17, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "AVG Cleaner – Speed, Battery & Memory Booster",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 1188154,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 14, 2018",
    "Current Ver": "4.6.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Google Drive",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 2731171,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "QR Scanner & Barcode Scanner 2018",
    Category: "PRODUCTIVITY",
    Rating: 3.8,
    Reviews: 8226,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 20, 2018",
    "Current Ver": "1.8.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Chrome Beta",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 228794,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "68.0.3440.91",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Microsoft Outlook",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 3252896,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.2.194",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Google PDF Viewer",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 226456,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 9, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Microsoft Excel",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 1079491,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 14, 2018",
    "Current Ver": "16.0.10325.20059",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "My Claro Peru",
    Category: "PRODUCTIVITY",
    Rating: 3.2,
    Reviews: 11200,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 23, 2018",
    "Current Ver": "3.1.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Power Booster - Junk Cleaner & CPU Cooler & Boost",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 9653,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "1.2.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Google Assistant",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 58675,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 9, 2018",
    "Current Ver": "0.1.187945513",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Microsoft OneDrive",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 1038306,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Calculator - unit converter",
    Category: "PRODUCTIVITY",
    Rating: 4.7,
    Reviews: 287250,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 9, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Microsoft OneNote",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 480643,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 22, 2018",
    "Current Ver": "16.0.10325.20024",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Metro name iD",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 27800,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 10, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Google Keep",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 691474,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Archos File Manager",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 2131,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 22, 2016",
    "Current Ver": "4.1.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "ES File Explorer File Manager",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 5383985,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.1.8.2.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "ASUS SuperNote",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 26559,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 14, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "HTC File Manager",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 13500,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 11, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "MyMTN",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 8550,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 25, 2018",
    "Current Ver": "2.1.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Dropbox",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 1861310,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "ASUS Quick Memo",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 23089,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 11, 2018",
    "Current Ver": "1.10.0.33_180403",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "HTC Calendar",
    Category: "PRODUCTIVITY",
    Rating: 3.9,
    Reviews: 6949,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 27, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Google Calendar",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 858208,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Google Docs",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 815981,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "ASUS Calling Screen",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 102451,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 15, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "lifebox",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 56403,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 27, 2018",
    "Current Ver": "4.0.5",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Yandex.Disk",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 115072,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Content Transfer",
    Category: "PRODUCTIVITY",
    Rating: 4.7,
    Reviews: 19302,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 28, 2018",
    "Current Ver": "3.5.12",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Evernote – Organizer, Planner for Notes & Memos",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 1488396,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "HTC Mail",
    Category: "PRODUCTIVITY",
    Rating: 3.1,
    Reviews: 6572,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Advanced Task Killer",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 577059,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 7, 2016",
    "Current Ver": "2.2.1B216",
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "MyVodafone (India) - Online Recharge & Pay Bills",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 1092367,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 4, 2018",
    "Current Ver": "8.0.1.0",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Microsoft PowerPoint",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 618798,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 11, 2018",
    "Current Ver": "16.0.10325.20043",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Microsoft Translator",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 209696,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 18, 2018",
    "Current Ver": "3.2.258b ae1da5165",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "My Airtel-Online Recharge, Pay Bill, Wallet, UPI",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 1498393,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.3.2.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Samsung Notes",
    Category: "PRODUCTIVITY",
    Rating: 3.9,
    Reviews: 15368,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Do It Later: Tasks & To-Dos",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 123412,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Verizon Cloud",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 185632,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "myAT&T",
    Category: "PRODUCTIVITY",
    Rating: 3.7,
    Reviews: 80847,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 5,
  },
  {
    App: "SwiftKey Keyboard",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 2764964,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Hacker's Keyboard",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 41418,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 11, 2016",
    "Current Ver": "v1.39.3",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "MEGA",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 549973,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Security & Privacy",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 212,
    Size: "10.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 26, 2018",
    "Current Ver": "5.0.44",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "7 Weeks - Habit & Goal Tracker",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 6011,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 19, 2015",
    "Current Ver": "3.2.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Loop - Habit Tracker",
    Category: "PRODUCTIVITY",
    Rating: 4.7,
    Reviews: 17955,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 23, 2018",
    "Current Ver": "1.7.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "TickTick: To Do List with Reminder, Day Planner",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 25370,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Keeper: Free Password Manager & Secure Vault",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 74146,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 16, 2018",
    "Current Ver": "12.1.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Pushbullet - SMS on PC",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 176873,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 30, 2017",
    "Current Ver": "17.7.20",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Wunderlist: To-Do List & Tasks",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 404617,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Planner Pro-Personal Organizer",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 10270,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 23, 2018",
    "Current Ver": "4.4.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Todoist: To-do lists for task management & errands",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 155999,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 5, 2018",
    "Current Ver": "12.8.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Cozi Family Organizer",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 56713,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 5, 2018",
    "Current Ver": "9.3.5776",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "IFTTT",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 117255,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Google Keep",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 691474,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Any.do: To-do list, Calendar, Reminders & Planner",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 298843,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Trello",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 72513,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 18, 2018",
    "Current Ver": "5.0.1.11068-production",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Evernote – Organizer, Planner for Notes & Memos",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 1488396,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Easy Voice Recorder",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 205191,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 20, 2018",
    "Current Ver": "2.4.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Dashlane Free Password Manager",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 73695,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "CM FILE MANAGER HD",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 144879,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 24, 2016",
    "Current Ver": "3.5.0",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "ES File Explorer File Manager",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 5383971,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.1.8.2.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Solid Explorer Classic",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 49794,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 17, 2017",
    "Current Ver": "1.7.3",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "File Browser by Astro (File Manager)",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 609182,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 2, 2018",
    "Current Ver": "6.4.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "File Explorer",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 979,
    Size: "720k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "September 30, 2013",
    "Current Ver": "2.1.3",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "The Maner",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 53015,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 12, 2017",
    "Current Ver": "2.2.2",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "AndroZip™ FREE File Manager",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 277794,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 7, 2016",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Solid Explorer File Manager",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 67523,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 19, 2018",
    "Current Ver": "2.5.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Smart File Manager",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 17415,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 5, 2018",
    "Current Ver": "3.5.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Microsoft Word",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 2084125,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 11, 2018",
    "Current Ver": "16.0.10325.20043",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Google Drive",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 2731211,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Adobe Acrobat Reader",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 3016305,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 17, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Google PDF Viewer",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 226456,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 9, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Google Sheets",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 496399,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Microsoft Excel",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 1079616,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 14, 2018",
    "Current Ver": "16.0.10325.20059",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Google Docs",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 815974,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Polaris Office - Word, Docs, Sheets, Slide, PDF",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 549900,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 18, 2018",
    "Current Ver": "7.3.30",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Microsoft PowerPoint",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 618796,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 11, 2018",
    "Current Ver": "16.0.10325.20043",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "WPS Office - Word, Docs, PDF, Note, Slide & Sheet",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 1508137,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 30, 2018",
    "Current Ver": "11.1.3",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Microsoft OneNote",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 480640,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 22, 2018",
    "Current Ver": "16.0.10325.20024",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Google Calendar",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 858227,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Google Slides",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 244567,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "ColorNote Notepad Notes",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 2401017,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Note Everything",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 57033,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 18, 2016",
    "Current Ver": "4.2.11",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Simple Notepad",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 12321,
    Size: "713k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 25, 2016",
    "Current Ver": "2.0.1",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Keep My Notes - Notepad & Memo",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 122424,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 16, 2018",
    "Current Ver": "1.35.2",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Sticky Note + : Sync Notes",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 21507,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 31, 2017",
    "Current Ver": 13.4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Notepad",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 80581,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 16, 2016",
    "Current Ver": 2.4,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Squid - Take Notes & Markup PDFs",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 37204,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 21, 2018",
    "Current Ver": "3.4.4.4-GP",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ultimate Notepad",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 10643,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Notepad & To do list",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 226295,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 6, 2018",
    "Current Ver": "4.3.19",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "JotterPad - Writer, Screenplay, Novel",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 57904,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 1, 2018",
    "Current Ver": "12.8.2-pi",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Google Keep",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 691474,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Wunderlist: To-Do List & Tasks",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 404610,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Evernote – Organizer, Planner for Notes & Memos",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 1488397,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Any.do: To-do list, Calendar, Reminders & Planner",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 298854,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Todoist: To-do lists for task management & errands",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 155999,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 5, 2018",
    "Current Ver": "12.8.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Microsoft OneNote",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 480638,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 22, 2018",
    "Current Ver": "16.0.10325.20024",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Planning Center Services",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 5157,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Calendar+ Schedule Planner App",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 8985,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 16, 2017",
    "Current Ver": "1.07.59",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Today Calendar 2017",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 16349,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 25, 2016",
    "Current Ver": "4.0.7.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "To-Do Calendar Planner",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 30291,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "New Calendar",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 25985,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 20, 2018",
    "Current Ver": "1.0.167",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Planner Pro-Personal Organizer",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 10270,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 23, 2018",
    "Current Ver": "4.4.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Calendar Widget Month + Agenda",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 60840,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 31, 2018",
    "Current Ver": "1.26.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "DigiCal Calendar Agenda",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 133573,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Time Recording - Timesheet App",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 23393,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Jorte Calendar & Organizer",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 198051,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Business Calendar 2",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 102594,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.30.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Google Calendar",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 858230,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "aCalendar - Android Phone",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 80119,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "aCalendar+ Calendar & Tasks",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 26919,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Google Drive",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 2731211,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "G Cloud Backup",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 267189,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Microsoft OneDrive",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 1038303,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Unclouded - Cloud Manager",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 6850,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 8, 2016",
    "Current Ver": "2.3.3-play",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dropbox",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 1861309,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Amazon Drive",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 18669,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 8, 2018",
    "Current Ver": "1.9.1.147.0-google",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SugarSync",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 16420,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 16, 2018",
    "Current Ver": "4.4.0.4",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "pCloud: Free Cloud Storage",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 16149,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "MediaFire",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 71432,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 1, 2017",
    "Current Ver": "4.2.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Cloud Print",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 282460,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Baby Names",
    Category: "PARENTING",
    Rating: 4.5,
    Reviews: 86,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1.7,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "My baby Piano",
    Category: "PARENTING",
    Rating: 3.9,
    Reviews: 17941,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting;Music & Video",
    "Last Updated": "May 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Zoo For Preschool Kids 3-9 Years",
    Category: "PARENTING",
    Rating: "NaN",
    Reviews: 76,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting;Education",
    "Last Updated": "April 24, 2018",
    "Current Ver": "1.0.7",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "My baby Game (Balloon POP!)",
    Category: "PARENTING",
    Rating: 3.8,
    Reviews: 3614,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting;Brain Games",
    "Last Updated": "May 28, 2018",
    "Current Ver": "2.15.2714",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Arabic Alphabets",
    Category: "PARENTING",
    Rating: "NaN",
    Reviews: 34,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "January 9, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Learn the letters and words",
    Category: "PARENTING",
    Rating: "NaN",
    Reviews: 31,
    Size: "85M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting;Education",
    "Last Updated": "June 15, 2018",
    "Current Ver": 3.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Development of the child up to a year",
    Category: "PARENTING",
    Rating: 4.6,
    Reviews: 1413,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Parenting",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.9.9",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Favorite children's songs",
    Category: "PARENTING",
    Rating: 4.7,
    Reviews: 39,
    Size: "95M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "July 6, 2018",
    "Current Ver": "1.2.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Ali Baba's Farm Tutorial Kids Games",
    Category: "PARENTING",
    Rating: "NaN",
    Reviews: 36,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "May 27, 2018",
    "Current Ver": 4.7,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Baby Panda Learns Shapes",
    Category: "PARENTING",
    Rating: 4,
    Reviews: 3789,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting;Education",
    "Last Updated": "June 21, 2018",
    "Current Ver": "8.25.10.00",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Learning English for children",
    Category: "PARENTING",
    Rating: "NaN",
    Reviews: 67,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting;Education",
    "Last Updated": "April 18, 2018",
    "Current Ver": 1.9,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Mozart Baby Sleep",
    Category: "PARENTING",
    Rating: 4.7,
    Reviews: 107,
    Size: "98M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Parenting",
    "Last Updated": "July 9, 2018",
    "Current Ver": "1.4.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Kids Videos",
    Category: "PARENTING",
    Rating: 4.1,
    Reviews: 559,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "May 20, 2018",
    "Current Ver": "1.3.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "My baby firework",
    Category: "PARENTING",
    Rating: 3.7,
    Reviews: 4976,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting;Education",
    "Last Updated": "May 28, 2018",
    "Current Ver": "2.04.2714",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "We learn children's verses in kindergarten",
    Category: "PARENTING",
    Rating: "NaN",
    Reviews: 3248,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting;Education",
    "Last Updated": "December 20, 2017",
    "Current Ver": 2.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Baby Food - Homemade Recipes",
    Category: "PARENTING",
    Rating: 4.1,
    Reviews: 44,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "August 7, 2018",
    "Current Ver": 8.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "My baby Phone",
    Category: "PARENTING",
    Rating: 3.7,
    Reviews: 9293,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "May 28, 2018",
    "Current Ver": "2.03.2714",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Baby Sleep: White noise lullabies for newborns",
    Category: "PARENTING",
    Rating: 4.6,
    Reviews: 62386,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "June 12, 2018",
    "Current Ver": 2.7,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Arabic Chat - Chat",
    Category: "PARENTING",
    Rating: 4.4,
    Reviews: 162,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "May 1, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BookBaby - Baby Development",
    Category: "PARENTING",
    Rating: 4.6,
    Reviews: 1002,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "August 18, 2016",
    "Current Ver": 3,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Kids Craft Ideas",
    Category: "PARENTING",
    Rating: 4.1,
    Reviews: 99,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "March 29, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Child Growth Tracking",
    Category: "PARENTING",
    Rating: 4.4,
    Reviews: 498,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.5.3.1807",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Family Album Mitene: Private Photo & Video Sharing",
    Category: "PARENTING",
    Rating: 4.7,
    Reviews: 34336,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Family GPS Tracker and Chat + Baby Monitor Online",
    Category: "PARENTING",
    Rating: 4.4,
    Reviews: 9073,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Educational Children's Songs",
    Category: "PARENTING",
    Rating: "NaN",
    Reviews: 163,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "August 5, 2018",
    "Current Ver": 1.2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "How do I take care of my child?",
    Category: "PARENTING",
    Rating: 4.8,
    Reviews: 190,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "June 24, 2018",
    "Current Ver": 1.5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Baby Name Together",
    Category: "PARENTING",
    Rating: 4,
    Reviews: 464,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "August 6, 2018",
    "Current Ver": "2.3.1",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "White Noise for Baby",
    Category: "PARENTING",
    Rating: 4.9,
    Reviews: 717,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "December 30, 2017",
    "Current Ver": "1.6.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Favorite Soviet cartoons",
    Category: "PARENTING",
    Rating: "NaN",
    Reviews: 63,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.0.6",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "The first year of a baby's life",
    Category: "PARENTING",
    Rating: 4.8,
    Reviews: 7505,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "January 7, 2017",
    "Current Ver": "1.1.27.477-free",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Safe365 – Cell Phone GPS Locator For Your Family",
    Category: "PARENTING",
    Rating: 4.4,
    Reviews: 11501,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "July 30, 2018",
    "Current Ver": "3.7.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Listen to the story~The Story of the Fairy Tales",
    Category: "PARENTING",
    Rating: 4.7,
    Reviews: 69,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "July 10, 2018",
    "Current Ver": "1.0.6",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Amazon FreeTime – Kids’ Videos, Books, & TV shows",
    Category: "PARENTING",
    Rating: 4.2,
    Reviews: 2715,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting;Music & Video",
    "Last Updated": "July 24, 2018",
    "Current Ver": "FreeTimeApp-aosp_v3.14_Build-1.0.204367.0.13014",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Kids Fang - Infant Videos, Children's Songs, Fairy Tales, Lullaby Collections",
    Category: "PARENTING",
    Rating: 4.6,
    Reviews: 349,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "March 21, 2018",
    "Current Ver": 1.7,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "PPS Online",
    Category: "PARENTING",
    Rating: 4.6,
    Reviews: 37,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "July 9, 2018",
    "Current Ver": 3.19,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Johny Johny Yes Papa Nursery Rhyme - offline Video",
    Category: "PARENTING",
    Rating: 4.5,
    Reviews: 806,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "August 4, 2018",
    "Current Ver": 4.2,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Latest Emmanuella Comedy Video",
    Category: "PARENTING",
    Rating: 4.6,
    Reviews: 60,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "April 1, 2018",
    "Current Ver": "Natalia Studio Development",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Baby Care & Tracker",
    Category: "PARENTING",
    Rating: 4.1,
    Reviews: 319,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "July 12, 2018",
    "Current Ver": 5.3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Urban Limo Taxi Simulator",
    Category: "PARENTING",
    Rating: 3.8,
    Reviews: 824,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "August 2, 2018",
    "Current Ver": 8.9,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Rainbow - Journal & Activities",
    Category: "PARENTING",
    Rating: 4.8,
    Reviews: 6668,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "March 28, 2018",
    "Current Ver": "2.5.9",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Classical music for baby",
    Category: "PARENTING",
    Rating: 4.8,
    Reviews: 1940,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting;Music & Video",
    "Last Updated": "July 18, 2018",
    "Current Ver": 1.04,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "How do I care about my child?",
    Category: "PARENTING",
    Rating: "NaN",
    Reviews: 34,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "July 3, 2018",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "My Child from eDziecko.pl",
    Category: "PARENTING",
    Rating: 4.5,
    Reviews: 1025,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "June 29, 2018",
    "Current Ver": "1.3.9",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Baby Panda Musical Genius",
    Category: "PARENTING",
    Rating: 4,
    Reviews: 3346,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting;Music & Video",
    "Last Updated": "June 15, 2018",
    "Current Ver": "8.25.10.00",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Baby Monitor",
    Category: "PARENTING",
    Rating: 4.4,
    Reviews: 5343,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "March 30, 2018",
    "Current Ver": "2.1.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Daniel Tiger for Parents",
    Category: "PARENTING",
    Rating: 4.7,
    Reviews: 247,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting;Music & Video",
    "Last Updated": "March 19, 2018",
    "Current Ver": "1.3.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Voice Tables - no internet",
    Category: "PARENTING",
    Rating: "NaN",
    Reviews: 970,
    Size: "71M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "May 28, 2018",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Vegetable Fun",
    Category: "PARENTING",
    Rating: 3.9,
    Reviews: 3182,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting;Education",
    "Last Updated": "June 15, 2018",
    "Current Ver": "8.25.10.00",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "It's open.",
    Category: "PARENTING",
    Rating: 4.4,
    Reviews: 1528,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "July 24, 2018",
    "Current Ver": "8.1.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Children's Stories 2018 - The Lion Come Lion",
    Category: "PARENTING",
    Rating: 4.4,
    Reviews: 39,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting;Music & Video",
    "Last Updated": "October 31, 2017",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Feed Baby - Baby Tracker",
    Category: "PARENTING",
    Rating: 4.5,
    Reviews: 76795,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.0.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "The Weather Channel: Rain Forecast & Storm Alerts",
    Category: "WEATHER",
    Rating: 4.4,
    Reviews: 1558437,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Weather forecast",
    Category: "WEATHER",
    Rating: 4.8,
    Reviews: 159455,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "May 8, 2018",
    "Current Ver": "1.11.93",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AccuWeather: Daily Forecast & Live Weather Reports",
    Category: "WEATHER",
    Rating: 4.4,
    Reviews: 2053404,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Live Weather Pro",
    Category: "WEATHER",
    Rating: 4.8,
    Reviews: 892,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 17, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Weather by WeatherBug: Forecast, Radar & Alerts",
    Category: "WEATHER",
    Rating: 4.5,
    Reviews: 981995,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "June 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "weather - weather forecast",
    Category: "WEATHER",
    Rating: 4.7,
    Reviews: 11118,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "April 26, 2018",
    "Current Ver": 30,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "MyRadar NOAA Weather Radar",
    Category: "WEATHER",
    Rating: 4.5,
    Reviews: 178934,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "SMHI Weather",
    Category: "WEATHER",
    Rating: 3.5,
    Reviews: 11297,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "June 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Free live weather on screen",
    Category: "WEATHER",
    Rating: 4.4,
    Reviews: 15370,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 2, 2018",
    "Current Ver": "12.2.6.3660",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Weather Radar Widget",
    Category: "WEATHER",
    Rating: 4.3,
    Reviews: 18194,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "June 28, 2017",
    "Current Ver": "1.7.7",
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Weather –Simple weather forecast",
    Category: "WEATHER",
    Rating: 4.4,
    Reviews: 40606,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 5, 2018",
    "Current Ver": "v7.0.02.3.0516.1_06_0713",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Weather Crave",
    Category: "WEATHER",
    Rating: 4.2,
    Reviews: 133338,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "June 26, 2018",
    "Current Ver": "6.1.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Klara weather",
    Category: "WEATHER",
    Rating: 4.6,
    Reviews: 36900,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 28, 2018",
    "Current Ver": "1.3.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Yahoo Weather",
    Category: "WEATHER",
    Rating: 4.4,
    Reviews: 1312037,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Real time Weather Forecast",
    Category: "WEATHER",
    Rating: 4.4,
    Reviews: 4184,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "March 26, 2018",
    "Current Ver": "7.1.12.12",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "METEO FRANCE",
    Category: "WEATHER",
    Rating: 3.9,
    Reviews: 100994,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 13, 2018",
    "Current Ver": "5.9.7",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "APE Weather ( Live Forecast)",
    Category: "WEATHER",
    Rating: 4.3,
    Reviews: 20008,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 3, 2018",
    "Current Ver": "7.1.34.28",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Live Weather & Daily Local Weather Forecast",
    Category: "WEATHER",
    Rating: 4.5,
    Reviews: 13426,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 17, 2018",
    "Current Ver": "9.9.1.1910",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Weather",
    Category: "WEATHER",
    Rating: 4.2,
    Reviews: 18773,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.3.A.2.9",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Rainfall radar - weather",
    Category: "WEATHER",
    Rating: 3.7,
    Reviews: 26941,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Yahoo! Weather for SH Forecast for understanding the approach of rain clouds Free",
    Category: "WEATHER",
    Rating: 4.2,
    Reviews: 7457,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "The Weather Network",
    Category: "WEATHER",
    Rating: 3.9,
    Reviews: 135337,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Klart.se - Sweden's best weather",
    Category: "WEATHER",
    Rating: 3.6,
    Reviews: 7623,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 11, 2018",
    "Current Ver": "3.18.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "GO Weather - Widget, Theme, Wallpaper, Efficient",
    Category: "WEATHER",
    Rating: 4.5,
    Reviews: 1422858,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Info BMKG",
    Category: "WEATHER",
    Rating: 4.3,
    Reviews: 21404,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "June 15, 2017",
    "Current Ver": 2.2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Weather From DMI/YR",
    Category: "WEATHER",
    Rating: 4.3,
    Reviews: 2143,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "wetter.com - Weather and Radar",
    Category: "WEATHER",
    Rating: 4.2,
    Reviews: 189313,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Storm Radar: Tornado Tracker & Hurricane Alerts",
    Category: "WEATHER",
    Rating: 4.6,
    Reviews: 89868,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "June 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Yandex.Weather",
    Category: "WEATHER",
    Rating: 4.5,
    Reviews: 309617,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Local Weather Forecast & Visual Widget",
    Category: "WEATHER",
    Rating: 4.5,
    Reviews: 3478,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.9.10",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Wetter by t-online.de",
    Category: "WEATHER",
    Rating: 4.2,
    Reviews: 24349,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "May 14, 2018",
    "Current Ver": "1.8.4.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "HTC Weather",
    Category: "WEATHER",
    Rating: 3.9,
    Reviews: 22154,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 10, 2017",
    "Current Ver": "8.50.935520",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Weather Live Pro",
    Category: "WEATHER",
    Rating: 4.8,
    Reviews: 17493,
    Size: "11M",
    Type: "Paid",
    Price: "$4.49",
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "April 20, 2018",
    "Current Ver": 1.3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AEMET's time",
    Category: "WEATHER",
    Rating: 3.8,
    Reviews: 15966,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 17, 2017",
    "Current Ver": 2,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "New 2018 Weather App & Widget",
    Category: "WEATHER",
    Rating: 4.5,
    Reviews: 2332,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Weather",
    "Last Updated": "August 3, 2018",
    "Current Ver": "12.2.7.3671",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Météociel",
    Category: "WEATHER",
    Rating: 4.5,
    Reviews: 29344,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 25, 2018",
    "Current Ver": "4.1.11 - Hegoa",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Weather by eltiempo.es",
    Category: "WEATHER",
    Rating: 4.2,
    Reviews: 67772,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Climatempo Lite - 15 day weather forecast",
    Category: "WEATHER",
    Rating: 4,
    Reviews: 634,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "June 15, 2018",
    "Current Ver": "1.0.34",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ForecaWeather",
    Category: "WEATHER",
    Rating: 4.2,
    Reviews: 18425,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 29, 2017",
    "Current Ver": "3.1.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "YouTube",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 25655305,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "All Video Downloader 2018",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 7557,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.0.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Video Downloader",
    Category: "VIDEO_PLAYERS",
    Rating: 4.2,
    Reviews: 59089,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.0.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "HD Video Player",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 1551,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 25, 2018",
    "Current Ver": 1.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Iqiyi (for tablet)",
    Category: "VIDEO_PLAYERS",
    Rating: 3.6,
    Reviews: 12764,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "July 11, 2018",
    "Current Ver": 7.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Motorola FM Radio",
    Category: "VIDEO_PLAYERS",
    Rating: 3.9,
    Reviews: 54807,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "May 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Video Player All Format",
    Category: "VIDEO_PLAYERS",
    Rating: 4.8,
    Reviews: 259003,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Motorola Gallery",
    Category: "VIDEO_PLAYERS",
    Rating: 3.9,
    Reviews: 121916,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "January 25, 2016",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Free TV series",
    Category: "VIDEO_PLAYERS",
    Rating: 3.7,
    Reviews: 400,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "May 28, 2018",
    "Current Ver": "v1.0.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Video Player All Format for Android",
    Category: "VIDEO_PLAYERS",
    Rating: 4.6,
    Reviews: 3930,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.1.7",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "VLC for Android",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 1032076,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "Code",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 239242,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "November 19, 2017",
    "Current Ver": 17.6,
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Vote for",
    Category: "VIDEO_PLAYERS",
    Rating: 4.2,
    Reviews: 193381,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1.78,
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "XX HD Video downloader-Free Video Downloader",
    Category: "VIDEO_PLAYERS",
    Rating: 4.1,
    Reviews: 7624,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "April 20, 2018",
    "Current Ver": 1.9,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "OBJECTIVE",
    Category: "VIDEO_PLAYERS",
    Rating: 3.8,
    Reviews: 19738,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "August 7, 2018",
    "Current Ver": "9.7.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Music - Mp3 Player",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 259605,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.6.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "HD Movie Video Player",
    Category: "VIDEO_PLAYERS",
    Rating: 4.5,
    Reviews: 18699,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "March 27, 2018",
    "Current Ver": 1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "YouCut - Video Editor & Video Maker, No Watermark",
    Category: "VIDEO_PLAYERS",
    Rating: 4.6,
    Reviews: 98819,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 6, 2018",
    "Current Ver": "1.251.54",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Video Editor,Crop Video,Movie Video,Music,Effects",
    Category: "VIDEO_PLAYERS",
    Rating: 4.7,
    Reviews: 53006,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.5.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "YouTube Studio",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 436921,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "June 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "video player for android",
    Category: "VIDEO_PLAYERS",
    Rating: 4.5,
    Reviews: 351168,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "October 18, 2016",
    "Current Ver": "2.0.0",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Vigo Video",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 1615596,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Google Play Movies & TV",
    Category: "VIDEO_PLAYERS",
    Rating: 3.7,
    Reviews: 906384,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "HTC Service － DLNA",
    Category: "VIDEO_PLAYERS",
    Rating: 3.9,
    Reviews: 3484,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "December 3, 2015",
    "Current Ver": "7.10.621414",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "VPlayer",
    Category: "VIDEO_PLAYERS",
    Rating: 3.6,
    Reviews: 5639,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "April 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "MiniMovie - Free Video and Slideshow Editor",
    Category: "VIDEO_PLAYERS",
    Rating: 4.5,
    Reviews: 504823,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "December 13, 2017",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Samsung Video Library",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 25922,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "May 9, 2018",
    "Current Ver": "1.4.08.2",
    numInstall: 50000000,
    numAndroid: 7,
  },
  {
    App: "OnePlus Gallery",
    Category: "VIDEO_PLAYERS",
    Rating: 3.8,
    Reviews: 5555,
    Size: "64M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 12, 2018",
    "Current Ver": "2.6.71",
    numInstall: 1000000,
    numAndroid: 7,
  },
  {
    App: "LIKE – Magic Video Maker & Community",
    Category: "VIDEO_PLAYERS",
    Rating: 4.6,
    Reviews: 921868,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "August 4, 2018",
    "Current Ver": "2.4.11",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "HTC Service—Video Player",
    Category: "VIDEO_PLAYERS",
    Rating: 4.2,
    Reviews: 6449,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "February 13, 2015",
    "Current Ver": "6.5.852058",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Play Tube",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 15874,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 5, 2018",
    "Current Ver": 1.2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Droid Zap by Motorola",
    Category: "VIDEO_PLAYERS",
    Rating: 3.8,
    Reviews: 2093,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "February 3, 2015",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "video player",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 26421,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "May 30, 2018",
    "Current Ver": "3.4.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "G Guide Program Guide (SOFTBANK EMOBILE WILLCOM version)",
    Category: "VIDEO_PLAYERS",
    Rating: 3.1,
    Reviews: 2689,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Video.Guru - Video Maker",
    Category: "VIDEO_PLAYERS",
    Rating: 4.6,
    Reviews: 36969,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 6, 2018",
    "Current Ver": "1.137.22",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "HTC Gallery",
    Category: "VIDEO_PLAYERS",
    Rating: 4.1,
    Reviews: 45744,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "June 3, 2016",
    "Current Ver": "9.51.755029",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "PowerDirector Video Editor App: 4K, Slow Mo & More",
    Category: "VIDEO_PLAYERS",
    Rating: 4.5,
    Reviews: 714665,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 24, 2018",
    "Current Ver": "4.13.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Cartoon Network App",
    Category: "VIDEO_PLAYERS",
    Rating: 4,
    Reviews: 119202,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Video Players & Editors;Music & Video",
    "Last Updated": "June 21, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "MX Player",
    Category: "VIDEO_PLAYERS",
    Rating: 4.5,
    Reviews: 6474426,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Video Status",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 6685,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.1.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Video Wallpaper Show",
    Category: "VIDEO_PLAYERS",
    Rating: "NaN",
    Reviews: 0,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 26, 2018",
    "Current Ver": 3.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "SVT Play",
    Category: "VIDEO_PLAYERS",
    Rating: 3.7,
    Reviews: 11549,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "July 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "BluTV",
    Category: "VIDEO_PLAYERS",
    Rating: 3.9,
    Reviews: 28835,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Tencent Video - Supporting the whole network",
    Category: "VIDEO_PLAYERS",
    Rating: 3.5,
    Reviews: 13205,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "July 31, 2018",
    "Current Ver": "6.2.2.17136",
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Casper Ssinema",
    Category: "VIDEO_PLAYERS",
    Rating: 3.3,
    Reviews: 1261,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "October 30, 2014",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "amazer - Global Kpop Video Community",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 1215,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Video Players & Editors",
    "Last Updated": "July 20, 2018",
    "Current Ver": "1.5.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "MX Player",
    Category: "VIDEO_PLAYERS",
    Rating: 4.5,
    Reviews: 6474672,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Video Editor",
    Category: "VIDEO_PLAYERS",
    Rating: 4.1,
    Reviews: 159622,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors;Creativity",
    "Last Updated": "July 17, 2018",
    "Current Ver": "6.14.091",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Omlet Arcade - Stream, Meet, Play",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 169965,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.32.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "VUE: video editor & camcorder",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 38630,
    Size: "89M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 5, 2018",
    "Current Ver": "2.1.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fox News – Breaking News, Live Video & News Alerts",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 249919,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "NEW - Read Newspaper, News 24h",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.4,
    Reviews: 158196,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "BaBe + - Indonesian News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 42624,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 1, 2018",
    "Current Ver": "6.6.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "daily News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 26411,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "March 26, 2018",
    "Current Ver": "2.3.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BBC News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 296781,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Free TV Shows App:News, TV Series, Episode, Movies",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.6,
    Reviews: 29706,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "August 2, 2018",
    "Current Ver": 2.71,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "News24",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 30693,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Le Monde, the continuous news",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.2,
    Reviews: 83558,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Wireless news",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.5,
    Reviews: 6066,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "April 16, 2018",
    "Current Ver": "2.1.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CNN Breaking US & World News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 293080,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 6, 2018",
    "Current Ver": 5.17,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Gnoche entertainment news · sports news is also free",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.8,
    Reviews: 54256,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "BaBe - Read News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 355921,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "August 1, 2018",
    "Current Ver": "9.1.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Nigeria News NAIJ.com",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 37882,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "June 1, 2018",
    "Current Ver": "8.2.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "detikcom - Latest & Most Complete News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 190888,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "July 13, 2018",
    "Current Ver": "5.2.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Dailyhunt (Newshunt) - Latest News, Viral Videos",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 948198,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "BaBe Lite - Read Quota Saving News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 9548,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "August 1, 2018",
    "Current Ver": "6.6.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ARY NEWS URDU",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.4,
    Reviews: 1071,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 25, 2018",
    "Current Ver": "5.8.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Bengali Newspaper - The first L.",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 11908,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 1, 2018",
    "Current Ver": 8.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Read- Latest News, Information, Gossip and Politics",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 185058,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "August 1, 2018",
    "Current Ver": "3.1.6.9",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Reddit: Social News, Trending Memes & Funny Videos",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.6,
    Reviews: 697212,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "News & Magazines",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "BBC Persian | BBC Farsi News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 978,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 12, 2018",
    "Current Ver": "1.8.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Google News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.9,
    Reviews: 877635,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.2.0",
    numInstall: 1000000000,
    numAndroid: 4,
  },
  {
    App: "Opera News - Trending news and videos",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 51684,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.2.2254.129147",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Topbuzz: Breaking News, Videos & Funny GIFs",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.7,
    Reviews: 175110,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "News & Magazines",
    "Last Updated": "August 6, 2018",
    "Current Ver": "6.7.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Twitter",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 11667403,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "News & Magazines",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Pulse Nabd - World News, Urgent",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 357944,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 12, 2018",
    "Current Ver": 9.1,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Asahi Shimbun Digital",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.1,
    Reviews: 735,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.3.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Breaking News, Local news, Attacks and Alerts Free",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.7,
    Reviews: 2543,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 19, 2018",
    "Current Ver": "8.0.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "WE",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.8,
    Reviews: 18818,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "June 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Sky News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 30287,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.11.0.611033",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Microsoft News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.2,
    Reviews: 31504,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 30, 2018",
    "Current Ver": "18.201.01",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Onet - news, weather, sport",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 13950,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "News & Magazines",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Vietnam Today - Read online newspapers, the hottest news 24h",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.2,
    Reviews: 21147,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "August 6, 2018",
    "Current Ver": "2.2.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Apple Daily Apple News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.4,
    Reviews: 41490,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "July 24, 2018",
    "Current Ver": "4.6.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "The Report, Fox, Breitbart - Conservative News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.6,
    Reviews: 2090,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "August 5, 2018",
    "Current Ver": "1.9.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "РИА Новости",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 44274,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "August 6, 2018",
    "Current Ver": "4.0.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Tencent News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 7006,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 31, 2018",
    "Current Ver": "5.6.40",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ARY NEWS",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.4,
    Reviews: 2959,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "August 4, 2018",
    "Current Ver": "7.5.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Kurio - Read the Latest News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.2,
    Reviews: 40167,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 30, 2018",
    "Current Ver": "3.12.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Daily Mail Online",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 56807,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Flipboard: News For Our Time",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.4,
    Reviews: 1284017,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Loop - Caribbean Local News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 4332,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "March 16, 2018",
    "Current Ver": "3.0.42",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AD - News, Sports, Region & Entertainment",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.7,
    Reviews: 10382,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Podcast Addict",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.6,
    Reviews: 413999,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.53.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Podcast Republic - Podcast Player & Radio Player",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 66978,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Podcast App: Free & Offline Podcasts by Player FM",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.6,
    Reviews: 66384,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "July 25, 2018",
    "Current Ver": "4.1.0.72",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Spreaker Podcast Radio",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 17703,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "June 7, 2018",
    "Current Ver": "4.10.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "BeyondPod Podcast Manager",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.9,
    Reviews: 32121,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "April 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Dezeen Magazine RSS Reader",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 350,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 22, 2018",
    "Current Ver": "3.000.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "issuu - Read Magazines, Catalogs, Newspapers.",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.4,
    Reviews: 74425,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 18, 2018",
    "Current Ver": "5.14.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Google News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.9,
    Reviews: 877635,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.2.0",
    numInstall: 1000000000,
    numAndroid: 4,
  },
  {
    App: "BuzzFeed: News, Tasty, Quizzes",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 131028,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "July 30, 2018",
    "Current Ver": 5.38,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Flipboard: News For Our Time",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.4,
    Reviews: 1284017,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Fast News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.4,
    Reviews: 84957,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "January 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "LA Times: Your California News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.6,
    Reviews: 3311,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "April 24, 2018",
    "Current Ver": "4.0.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "The Washington Post Classic",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 23158,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 17, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Chicago Tribune",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.6,
    Reviews: 1380,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "USA TODAY",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 49259,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "World Newspapers",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.4,
    Reviews: 185884,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "News & Magazines",
    "Last Updated": "September 17, 2017",
    "Current Ver": "3.1.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "The Wall Street Journal: Business & Market News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 40975,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.4.2.19",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Financial Times",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.2,
    Reviews: 27104,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.42.1.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "The Guardian",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.7,
    Reviews: 247992,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.5.1725",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "NYTimes - Latest News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.9,
    Reviews: 63647,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 1, 2018",
    "Current Ver": "6.19.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Digg",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.9,
    Reviews: 6105,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "March 11, 2016",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "News360: Personalized News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.4,
    Reviews: 30722,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "BBC News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 296781,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "RT News (Russia Today)",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.6,
    Reviews: 56524,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "August 6, 2018",
    "Current Ver": "3.5.13",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "NPR News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 24790,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Reuters News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 13169,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "June 6, 2018",
    "Current Ver": "3.4.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Bloomberg: Market & Financial News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.2,
    Reviews: 61692,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 25, 2018",
    "Current Ver": "5.9.1.1347176.a3ca6ab274",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Fox News – Breaking News, Live Video & News Alerts",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 249919,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Haystack TV: Local & World News - Free",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 3684,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "ABC News - US & World News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 18976,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "June 6, 2018",
    "Current Ver": "3.19.11",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "NBC News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 63020,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "February 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Sync for reddit",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.6,
    Reviews: 62740,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "News & Magazines",
    "Last Updated": "June 16, 2018",
    "Current Ver": 16.3,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "USA TODAY",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 49259,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "AP Mobile - Breaking News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 76677,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "May 25, 2017",
    "Current Ver": "4.4.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CNN Breaking US & World News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 293080,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 6, 2018",
    "Current Ver": 5.17,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "HuffPost - News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.2,
    Reviews: 78154,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 3, 2018",
    "Current Ver": "19.2.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "News Republic",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 479594,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "July 28, 2018",
    "Current Ver": "9.2.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Newsroom: News Worth Sharing",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.2,
    Reviews: 201737,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Twitter",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 11667403,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "News & Magazines",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "SmartNews: Breaking News Headlines",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.2,
    Reviews: 233305,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "August 3, 2018",
    "Current Ver": "5.1.10",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Updates for Samsung - Android Update Versions",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 80368,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 17, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "AC - Tips & News for Android™",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.2,
    Reviews: 23292,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "May 24, 2018",
    "Current Ver": "3.1.12",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BBC News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 296781,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "NPR News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 24790,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Fox News – Breaking News, Live Video & News Alerts",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 249919,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "CBS News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 23641,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "June 29, 2018",
    "Current Ver": "3.9.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Haystack TV: Local & World News - Free",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 3684,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "NPR One",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.9,
    Reviews: 13217,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.8.7.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "ABC News - US & World News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 18976,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "June 6, 2018",
    "Current Ver": "3.19.11",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "USA TODAY",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 49259,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "NBC News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 63020,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "February 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "The Wall Street Journal: Business & Market News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 40975,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.4.2.19",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "JailBase - Arrests + Mugshots",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 17240,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CNN Breaking US & World News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 293080,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 6, 2018",
    "Current Ver": 5.17,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Pocket",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 256680,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 24, 2018",
    "Current Ver": "6.7.15.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "AOL - News, Mail & Video",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 62465,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "NYTimes - Latest News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.9,
    Reviews: 63647,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 1, 2018",
    "Current Ver": "6.19.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Newsroom: News Worth Sharing",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.2,
    Reviews: 201737,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Google News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.9,
    Reviews: 877643,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.2.0",
    numInstall: 1000000000,
    numAndroid: 4,
  },
  {
    App: "BaconReader for Reddit",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 103074,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "News & Magazines",
    "Last Updated": "July 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "BuzzFeed: News, Tasty, Quizzes",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 131028,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "July 30, 2018",
    "Current Ver": 5.38,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Flipboard: News For Our Time",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.4,
    Reviews: 1284018,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Waze - GPS, Maps, Traffic Alerts & Live Navigation",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.6,
    Reviews: 7232629,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "T map (te map, T map, navigation)",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 15681,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "MapQuest: Directions, Maps, GPS & Navigation",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.1,
    Reviews: 53481,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "May 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Yahoo! transit guide free timetable, operation information, transfer search",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.4,
    Reviews: 104800,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 26, 2018",
    "Current Ver": "7.0.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "乗換NAVITIME　Timetable & Route Search in Japan Tokyo",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.4,
    Reviews: 50459,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Transit: Real-Time Transit App",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 43269,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 18, 2018",
    "Current Ver": "4.4.7",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Mapy.cz - Cycling & Hiking offline maps",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.5,
    Reviews: 56443,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "June 26, 2018",
    "Current Ver": "6.2.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Uber",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 4928420,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "GPS Navigation & Offline Maps Sygic",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.4,
    Reviews: 1421884,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 26, 2018",
    "Current Ver": "17.4.11",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Map and Router Badge",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.4,
    Reviews: 3652,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 25, 2018",
    "Current Ver": "4.8.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Yandex.Transport",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4,
    Reviews: 126282,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 30, 2018",
    "Current Ver": 5.7,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Air Traffic",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.3,
    Reviews: 14110,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 24, 2018",
    "Current Ver": 4.3,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Speed Cameras Radar",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.4,
    Reviews: 18710,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.2.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Atlan3D Navigation: Korea navigator",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 22063,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Compass",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.3,
    Reviews: 286454,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 9, 2016",
    "Current Ver": "2.1.2",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Mappy - Plan, route comparison, GPS",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.1,
    Reviews: 15922,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Gps Route Finder",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.4,
    Reviews: 652,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "May 26, 2018",
    "Current Ver": 116,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "My Location: GPS Maps, Share & Save Places",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.3,
    Reviews: 29768,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: 'Yanosik: "antyradar", traffic jams, navigation, camera',
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.4,
    Reviews: 102248,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "NAVITIME - Map & Transfer Navi",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 41225,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Sygic Car Navigation",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.7,
    Reviews: 162049,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 7, 2018",
    "Current Ver": "18.0.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Czech Public Transport IDOS",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.3,
    Reviews: 26014,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "November 6, 2017",
    "Current Ver": "2.4.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Karta GPS - Offline Navigation",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.5,
    Reviews: 53562,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "May 4, 2018",
    "Current Ver": "2.10.06",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Circle ratio",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.7,
    Reviews: 10562,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 3, 2018",
    "Current Ver": "04.08.00",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Soviet Military Maps Free",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.3,
    Reviews: 21589,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.1.0 free",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Truck Car Navi by Navitime Large size car, traffic jam, traffic closure, live camera, typhoon / precipitation map",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 3682,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Sentin Information Map",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.1,
    Reviews: 2909,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "June 26, 2018",
    "Current Ver": 1.39,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Snapp",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.5,
    Reviews: 37937,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 1, 2018",
    "Current Ver": "3.6.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "GPS Speedometer and Odometer",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.8,
    Reviews: 15865,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 3, 2018",
    "Current Ver": 10,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "GPS Traffic Speedcam Route Planner by ViaMichelin",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.3,
    Reviews: 63920,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 28, 2018",
    "Current Ver": "7.16.8",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Trucker Path – Truck Stops & Weigh Stations",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.7,
    Reviews: 38375,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 26, 2018",
    "Current Ver": "3.0.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Map Coordinates",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.3,
    Reviews: 16657,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 17, 2018",
    "Current Ver": "4.7.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Grab Driver",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 301413,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.44.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "SBB Mobile",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.7,
    Reviews: 20605,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "GPS Speedometer, Distance Meter",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.6,
    Reviews: 16094,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.7.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Blitzer.de",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.5,
    Reviews: 65590,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 9, 2018",
    "Current Ver": "3.1.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "GPS Speedometer - Trip Meter - Altimeter",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.3,
    Reviews: 32225,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.0.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Radarbot Free: Speed Camera Detector & Speedometer",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.5,
    Reviews: 44348,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 6, 2018",
    "Current Ver": "6.2.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "FindShip",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 23279,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "April 26, 2018",
    "Current Ver": "5.2.10",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ÖBB Scotty",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 12572,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "February 19, 2018",
    "Current Ver": "5.4 (30)",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Subway Terminator: Smarter Subway",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.3,
    Reviews: 70556,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 17, 2018",
    "Current Ver": 4.76,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Alopec - Online Shipping System",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.3,
    Reviews: 1240,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "November 2, 2017",
    "Current Ver": "2.4.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Yandex.Trains",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.4,
    Reviews: 56471,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "NAVITIME Bus Transit JAPAN",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.7,
    Reviews: 6939,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "hum app",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.4,
    Reviews: 10218,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 31, 2018",
    "Current Ver": "5.072.1830.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Moovit: Bus Time & Train Time Live Info",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.4,
    Reviews: 617477,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Dynavix - Navigation, Maps, Traffic data & Cameras",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 1688,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 3, 2018",
    "Current Ver": "6.1.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "National Rail Enquiries",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.5,
    Reviews: 18857,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "May 24, 2018",
    "Current Ver": "9.3.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ixigo Cabs-Compare & Book Taxi",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 11838,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "April 9, 2018",
    "Current Ver": "1.7.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Maps & GPS Navigation — OsmAnd",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 60838,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Snapchat",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 17000166,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Flashlight",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 162335,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 6, 2018",
    "Current Ver": "8.10.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "aa",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 886418,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "June 30, 2018",
    "Current Ver": "1.7.3",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "A Call From Santa Claus!",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 3720,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 4, 2016",
    "Current Ver": "4.2.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Rope Hero Return of a Legend",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 9951,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Arcade",
    "Last Updated": "August 26, 2016",
    "Current Ver": 1,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "A Word A Day",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 2398,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 5, 2017",
    "Current Ver": 5.8,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Draw a Stickman: EPIC 2 Free",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 213340,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "June 14, 2018",
    "Current Ver": "1.2.1.49",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Akinator",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1805398,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 11, 2018",
    "Current Ver": "6.5.2",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Dog Sim Online: Raise a Family",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 94989,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "April 22, 2018",
    "Current Ver": 8.6,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Pou",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 10483141,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.4.77",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Agar.io",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 3815614,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.2.8",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Color by Number - Draw Sandbox Pixel Art",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 10247,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.3.13",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "A+ Mobile",
    Category: "FINANCE",
    Rating: 3.9,
    Reviews: 730,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 26, 2018",
    "Current Ver": "5.4.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Angry Birds Classic",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 5565856,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 24, 2018",
    "Current Ver": "7.9.3",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Build a Bridge!",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 263454,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.1.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "UNO ™ & Friends",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 1728557,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "September 20, 2017",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Find a Way: Addictive Puzzle",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 39480,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "June 16, 2017",
    "Current Ver": "4.1.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "CompTIA A+ Pocket Prep",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1311,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 11, 2018",
    "Current Ver": "4.5.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "My Talking Tom",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 14885236,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 19, 2018",
    "Current Ver": "4.8.0.132",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Netflix",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 5453997,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Comptia A+ 220-901 & 220-902",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 174,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 19, 2018",
    "Current Ver": "2.0.7",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Create A Superhero HD",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 8642,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "December 30, 2017",
    "Current Ver": "4.0.4",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Azar",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 1092337,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Communication",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "4 in a Row",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 4257,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "May 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Bubble Shooter",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 43576,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "September 13, 2017",
    "Current Ver": 4.4,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Adobe Acrobat Reader",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 3014548,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 17, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Subway Surfers",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 27711703,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.90.0",
    numInstall: 1000000000,
    numAndroid: 4,
  },
  {
    App: "Super Mario Run",
    Category: "GAME",
    Rating: 3.7,
    Reviews: 1221896,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 12, 2018",
    "Current Ver": "3.0.11",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "STARDOM: THE A-LIST",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 152658,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "September 12, 2014",
    "Current Ver": "2.1.8",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "LokLok: Draw on a Lock Screen",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 14766,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "September 20, 2017",
    "Current Ver": "0.81 beta",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "The Tribez: Build a Village",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 1852384,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 13, 2018",
    "Current Ver": "9.3.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Photo Warp",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 353342,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 24, 2017",
    "Current Ver": "2.0.7",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "LEGO® Juniors Create & Cruise",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 672089,
    Size: "73M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Action & Adventure",
    "Last Updated": "January 19, 2018",
    "Current Ver": "6.7.5222",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "CompTIA Exam Training",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 3053,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 3, 2018",
    "Current Ver": 1.7,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "WhatsApp Messenger",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 69109672,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Magisto Video Editor & Maker",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 960726,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Glow Hockey",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 1703479,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 22, 2018",
    "Current Ver": "1.3.8",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Google Translate",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 5741684,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Pokémon GO",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 10421284,
    Size: "85M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "July 23, 2018",
    "Current Ver": "0.111.3",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Instagram",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 66509917,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "My Talking Angela",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 9876369,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 3, 2018",
    "Current Ver": "3.7.2.51",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "YouTube Kids",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 469851,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.43.3",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Asphalt 8: Airborne",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 8389714,
    Size: "92M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Racing",
    "Last Updated": "July 4, 2018",
    "Current Ver": "3.7.1a",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "PAC-MAN",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 685450,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 15, 2018",
    "Current Ver": "6.6.3",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Basketball Stars",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 867920,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 14, 2018",
    "Current Ver": "1.16.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Colorfy: Coloring Book for Adults - Free",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 787107,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Lep's World 2 🍀🍀",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 798522,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "June 7, 2018",
    "Current Ver": "1.9.8.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Wolfify - Be a Werewolf",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 6760,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 11, 2015",
    "Current Ver": "1.4.6",
    numInstall: 500000,
    numAndroid: 3,
  },
  {
    App: "Law of Creation: A Playable Manga",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 13118,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "June 25, 2018",
    "Current Ver": "1.0.19",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Real City Car Driver",
    Category: "GAME",
    Rating: 3.7,
    Reviews: 413609,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Racing",
    "Last Updated": "August 1, 2018",
    "Current Ver": 2.8,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Toca Kitchen 2",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 1013465,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "June 29, 2017",
    "Current Ver": "1.2.3-play",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Rolling Sky",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1117212,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Amazon Shopping",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 908525,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 31, 2018",
    "Current Ver": "16.14.0.100",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Gymnastics Superstar - Spin your way to gold!",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 305765,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.1.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Fake Call - Fake Caller ID",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 154668,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "SuperCity: Build a Story",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 98324,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 28, 2018",
    "Current Ver": "1.19.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Chick-fil-A",
    Category: "FOOD_AND_DRINK",
    Rating: 4.3,
    Reviews: 27931,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 3, 2018",
    "Current Ver": "6.0.1",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "4 in a row",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 47698,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "April 12, 2016",
    "Current Ver": "1.0.21",
    numInstall: 5000000,
    numAndroid: 1,
  },
  {
    App: "YouTube",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 25623548,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Four In A Line Free",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 133195,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "June 11, 2018",
    "Current Ver": 1.58,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Flow Free",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1295293,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 11, 2018",
    "Current Ver": 4,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Like A Boss",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 17069,
    Size: "94M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.0.17.2",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "AutoCAD - DWG Viewer & Editor",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 145088,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 23, 2018",
    "Current Ver": "4.5.19",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Hungry Hearts Diner: A Tale of Star-Crossed Souls",
    Category: "FAMILY",
    Rating: 4.9,
    Reviews: 46253,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Simulation",
    "Last Updated": "February 7, 2018",
    "Current Ver": "1.0.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Microsoft Word",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 2078744,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 11, 2018",
    "Current Ver": "16.0.10325.20043",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Dragon Sim Online: Be A Dragon",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 111741,
    Size: "66M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "February 27, 2018",
    "Current Ver": 5.4,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Alto's Adventure",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 515240,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "June 5, 2018",
    "Current Ver": "1.7.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Fortune City - A Finance App",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 49275,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 17, 2018",
    "Current Ver": "2.0.3.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Draw A Stickman",
    Category: "GAME",
    Rating: 3.4,
    Reviews: 29265,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "May 19, 2017",
    "Current Ver": "1.1.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Be A Legend: Soccer",
    Category: "SPORTS",
    Rating: 3.8,
    Reviews: 85763,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 24, 2015",
    "Current Ver": "2.8.0.17",
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Zombie Tsunami",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 4918776,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "June 15, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Bible",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 2440695,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Cat Sim Online: Play with Cats",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 137198,
    Size: "81M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Simulation",
    "Last Updated": "April 22, 2018",
    "Current Ver": 3.7,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Facebook",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 78128208,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Four In A Line",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 22191,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "May 4, 2015",
    "Current Ver": 1.1,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Tik Tok - including musical.ly",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 5637451,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "8.0.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "B612 - Beauty & Filter Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 5276983,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 30, 2018",
    "Current Ver": "7.6.5",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Disney Magic Timer by Oral-B",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 31061,
    Size: "83M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness;Action & Adventure",
    "Last Updated": "June 16, 2018",
    "Current Ver": "4.0.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "B-Messenger Video Chat",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 12495,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 19, 2017",
    "Current Ver": "7.1.1",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Bestie - Camera360 Selfie",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 512996,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.0.3.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "B",
    Category: "FINANCE",
    Rating: 3.7,
    Reviews: 800,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 21, 2018",
    "Current Ver": "2.16.5426",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "BIGO LIVE - Live Stream",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 2349421,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 27, 2018",
    "Current Ver": "4.1.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Block Craft 3D: Building Simulator Games For Free",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 944661,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "March 5, 2018",
    "Current Ver": "2.10.2",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "8 Ball Pool",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 14184910,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.0.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "B-BLE(BLE4.0 Scan)",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 159,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 20, 2018",
    "Current Ver": 5.5,
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Cardi B Piano Game",
    Category: "GAME",
    Rating: 3.1,
    Reviews: 50,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music",
    "Last Updated": "November 15, 2017",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "VPN Free - Betternet Hotspot VPN & Private Browser",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 799206,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.3.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ADS-B Driver",
    Category: "TOOLS",
    Rating: 5,
    Reviews: 2,
    Size: "6.3M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 15, 2018",
    "Current Ver": 1.19,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "MORTAL KOMBAT X",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 3039889,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "June 27, 2018",
    "Current Ver": "1.18.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "B-17 Flying Fortress WWII LWP",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 7,
    Size: "14M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 22, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "► MultiCraft ― Free Miner! 👍",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1305050,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Adventure",
    "Last Updated": "July 29, 2018",
    "Current Ver": "1.1.11.11",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "B.GOOD",
    Category: "FOOD_AND_DRINK",
    Rating: 2.9,
    Reviews: 155,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "April 4, 2018",
    "Current Ver": "4.94.19",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "B-Dubs®",
    Category: "LIFESTYLE",
    Rating: 3.1,
    Reviews: 3042,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Oral-B App",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.3,
    Reviews: 14210,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 19, 2018",
    "Current Ver": "6.0.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Smart Launcher theme b. gold",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 291,
    Size: "35M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "October 22, 2016",
    "Current Ver": 2.2,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "EMT Tutor NREMT-B Study Guide",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 625,
    Size: "8.4M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 8, 2017",
    "Current Ver": 2.1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Next Launcher 3D Theme Hit-B",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 83,
    Size: "8.6M",
    Type: "Paid",
    Price: "$1.70",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 16, 2015",
    "Current Ver": 1.05,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Pixel Gun 3D: Survival shooter & Battle Royale",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 4487182,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 4, 2018",
    "Current Ver": "15.1.2",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "B-52 Spirits of Glory Deluxe",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 12,
    Size: "29M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "September 2, 2017",
    "Current Ver": "1.5.9",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Servers Ultimate Pack B",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 668,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 31, 2016",
    "Current Ver": "2.1.8",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "EMT-B Pocket Prep",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 2948,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 11, 2018",
    "Current Ver": "4.5.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "UC Browser - Fast Download Private & Secure",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 17712922,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "August 2, 2018",
    "Current Ver": "12.8.5.1121",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Air Transat CinePlus B",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 2.2,
    Reviews: 83,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.0.17.3905",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Hungry Shark Evolution",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 6071542,
    Size: "100M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.0.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Perfect Piano",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 828489,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Hay Day",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 10053186,
    Size: "94M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "June 28, 2018",
    "Current Ver": "1_39_93",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Diary with lock",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 815280,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 30, 2018",
    "Current Ver": 4.9,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "B-Grade Renegade",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 24,
    Size: "64M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "October 17, 2017",
    "Current Ver": "0.8.17",
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "CARDI B WALLPAPERS",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 8,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 21, 2018",
    "Current Ver": 3.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Plan B",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.3,
    Reviews: 19,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 12, 2017",
    "Current Ver": 1.2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Block! Hexa Puzzle™",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 472247,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.5.10",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "B Tiff Viewer",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 283,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 12, 2018",
    "Current Ver": "1.1.7.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Cardi B Wallpaper",
    Category: "ART_AND_DESIGN",
    Rating: 4.8,
    Reviews: 253,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "November 1, 2017",
    "Current Ver": "1.0.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "A & B Taxi",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.1,
    Reviews: 41,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 4, 2018",
    "Current Ver": "0.19.13-SPECTRUM",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Cardi B HD Wallpapers Lock Screen",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 2,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Personalization",
    "Last Updated": "June 10, 2018",
    "Current Ver": 1.3,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CURSUM B",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 30,
    Size: "26M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "June 20, 2017",
    "Current Ver": "1.0.0",
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Clash of Clans",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 44881447,
    Size: "98M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 15, 2018",
    "Current Ver": "10.322.16",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Clash Royale",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 23125280,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "June 27, 2018",
    "Current Ver": "2.3.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "C Programming",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 22248,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 28, 2015",
    "Current Ver": 3,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "CppDroid - C/C++ IDE",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 29978,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 17, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Learn C [NEW]",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 349,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 16, 2018",
    "Current Ver": "2.1.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Mobile C [ C/C++ Compiler ]",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 4624,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 7, 2018",
    "Current Ver": "2.5.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Critical Ops",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 1397944,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 31, 2018",
    "Current Ver": "0.9.10.f96",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "C4droid - C/C++ compiler & IDE",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 2890,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 26, 2017",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Candy Crush Saga",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 22419455,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.129.0.2",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "CL Mobile - Classifieds for Craigslist",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 27275,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 30, 2018",
    "Current Ver": 27500000,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Google Chrome: Fast & Secure",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 9642112,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "C Locker Pro",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 1531,
    Size: "7.7M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 5, 2017",
    "Current Ver": "8.3.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "C Programs and Reference",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.2,
    Reviews: 873,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 31, 2014",
    "Current Ver": 2.2,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Learn C++",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 73404,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 25, 2017",
    "Current Ver": "4.5.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "C Launcher: Themes, Wallpapers, DIY, Smart, Clean",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 901110,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Personalization",
    "Last Updated": "July 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "C Programming Zone",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 1218,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 13, 2017",
    "Current Ver": 3,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "C Offline Tutorial",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 88,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "December 8, 2017",
    "Current Ver": "1.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Neon Glow C - Icon Pack",
    Category: "PERSONALIZATION",
    Rating: 4.8,
    Reviews: 557,
    Size: "74M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 27, 2018",
    "Current Ver": "4.5.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "All C Programs",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 2387,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 9, 2018",
    "Current Ver": "2.5.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Clean Master- Space Cleaner & Antivirus",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 42916526,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "C by GE",
    Category: "LIFESTYLE",
    Rating: 1.7,
    Reviews: 686,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 11, 2018",
    "Current Ver": "4.1.07",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CPlus for Craigslist - Officially Licensed",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 8096,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Lifestyle",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.6.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Alt-C",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 499,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 27, 2017",
    "Current Ver": 1.37,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "C-SPAN Radio",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 608,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 17, 2018",
    "Current Ver": "4.3.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Bridge-C - Get More Storage",
    Category: "TOOLS",
    Rating: 2,
    Reviews: 24,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 29, 2017",
    "Current Ver": 1.7,
    numInstall: 1000,
    numAndroid: 6,
  },
  {
    App: "Community by C Space",
    Category: "LIFESTYLE",
    Rating: 4.7,
    Reviews: 707,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 17, 2018",
    "Current Ver": "2.2.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "My C Spire",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 376,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.15.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "learn c in hindi",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 109,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 24, 2017",
    "Current Ver": 4.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Learn C Programming (Examples) (OFFLINE)",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 43,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 16, 2017",
    "Current Ver": "1.0.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "C Programming - Learn Code, Theory & Discuss",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 2751,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 15, 2018",
    "Current Ver": "3.2.8",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Expert C Programming - Learn C Coding Easily",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 77,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 5, 2018",
    "Current Ver": "1.1.9",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "Hill Climb Racing",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 8921451,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "July 2, 2018",
    "Current Ver": "1.37.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "codeEazy - C/C++/JAVA",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 130,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 4, 2016",
    "Current Ver": "1.0.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Batmobile™ R/C Controller",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 452,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 2, 2018",
    "Current Ver": "1.0.8",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "C Pattern Programs Free",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 4115,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 8, 2018",
    "Current Ver": "7.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "C Programs Handbook",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4,
    Reviews: 459,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "November 16, 2017",
    "Current Ver": "2.2.3.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "C Functions",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 55,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 26, 2015",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Learn C# - .Net - C Sharp Programming Tutorial App",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 1320,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 3, 2018",
    "Current Ver": "4.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Learn Basic C - For Beginners",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 27,
    Size: "772k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 20, 2016",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "C Prowess",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 306,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 3, 2017",
    "Current Ver": 1.2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "101 C Programming Problems",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 498,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 15, 2017",
    "Current Ver": 2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Let us C - Example Programs",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 36,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 30, 2017",
    "Current Ver": 1.2,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "C Examples",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1002,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 31, 2016",
    "Current Ver": 3.9,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "C BOOK-C PROGRAMS",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 138,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 22, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "100+ C Programs",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 20,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 3, 2017",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "ZEDGE™ Ringtones & Wallpapers",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 6459626,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Dubsmash",
    Category: "VIDEO_PLAYERS",
    Rating: 4.2,
    Reviews: 1971777,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "May 11, 2018",
    "Current Ver": "2.35.8",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Discord - Chat for Gamers",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 305347,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "July 27, 2018",
    "Current Ver": "7.1.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Hitman Sniper",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 408292,
    Size: "29M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.7.110758",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "FRONTLINE COMMANDO: D-DAY",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1736105,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "May 16, 2014",
    "Current Ver": "3.0.4",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Minion Rush: Despicable Me Official Game",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 10214862,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "July 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Fruit Ninja®",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 5091448,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 12, 2018",
    "Current Ver": "2.6.7.487220",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "DU Recorder – Screen Recorder, Video Editor, Live",
    Category: "VIDEO_PLAYERS",
    Rating: 4.8,
    Reviews: 2588730,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.7.1.3",
    numInstall: 50000000,
    numAndroid: 5,
  },
  {
    App: "Google Duo - High Quality Video Calls",
    Category: "COMMUNICATION",
    Rating: 4.6,
    Reviews: 2083237,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 31, 2018",
    "Current Ver": "37.1.206017801.DR37_RC14",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Crossy Road",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 4229977,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "August 1, 2018",
    "Current Ver": "3.1.0",
    numInstall: 100000000,
    numAndroid: 5,
  },
  {
    App: "Temple Run 2",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 8116142,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.49.1",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "Beach Buggy Blitz",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 640974,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "June 5, 2018",
    "Current Ver": 1.5,
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Vector",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 3058687,
    Size: "89M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "July 18, 2016",
    "Current Ver": "1.2.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Dr. Driving",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 4972230,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "March 2, 2018",
    "Current Ver": 1.52,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "D Day World War II Commando Survival Shooting",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 951,
    Size: "64M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "May 25, 2018",
    "Current Ver": 1.2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Geometry Dash Meltdown",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 1591129,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "December 22, 2017",
    "Current Ver": 1.01,
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Koi Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 14026,
    Size: "12M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 24, 2014",
    "Current Ver": 1.9,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Dropbox",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 1860844,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "KineMaster – Pro Video Editor",
    Category: "VIDEO_PLAYERS",
    Rating: 4.5,
    Reviews: 1013867,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.5.0.10701.GP",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Block City Wars + skins export",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 762706,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "March 30, 2018",
    "Current Ver": "6.7.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Sniper 3D Gun Shooter: Free Shooting Games - FPS",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 7657490,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Bike Race Free - Top Motorcycle Racing Games",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 2586261,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "July 31, 2018",
    "Current Ver": "7.7.9",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Dance School Stories - Dance Dreams Come True",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 91171,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.0.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "3D Bowling",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 1076243,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "January 18, 2018",
    "Current Ver": 3.1,
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "Plants vs. Zombies FREE",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 4064868,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 6, 2018",
    "Current Ver": "2.2.00",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Dream League Soccer 2018",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 9873470,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 16, 2018",
    "Current Ver": 5.064,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Mind Games Pro",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 15301,
    Size: "18M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "July 18, 2018",
    "Current Ver": "3.0.5",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Z Ringtones PREMIUM 2018",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 10158,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 1, 2018",
    "Current Ver": 1.5,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Smash Hit",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 4147718,
    Size: "79M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "November 26, 2015",
    "Current Ver": "1.4.0",
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "Bad Piggies",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1168959,
    Size: "66M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "May 3, 2017",
    "Current Ver": "2.3.3",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Temple Run",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 4000433,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.9.1",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Broken Screen Prank",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 23682,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "June 14, 2018",
    "Current Ver": 6.2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Screen Lock - with Fingerprint Simulator",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 338449,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 19, 2018",
    "Current Ver": 8.6,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Tuner - gStrings Free",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 214265,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Car Parking Game 3D - Real City Driving Challenge",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 187892,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "May 10, 2018",
    "Current Ver": "1.2.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "E!",
    Category: "FAMILY",
    Rating: 3.1,
    Reviews: 740,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "May 24, 2018",
    "Current Ver": "3.3.1.41",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "E! News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 15443,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "June 19, 2018",
    "Current Ver": "4.2.133",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "eBay: Buy & Sell this Summer - Discover Deals Now!",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 2788460,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "ESPN",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 521081,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Chuck E.'s Skate Universe",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 94910,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action;Action & Adventure",
    "Last Updated": "January 10, 2017",
    "Current Ver": 1.12,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Eventbrite - Discover popular events & nearby fun",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 63773,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 30, 2018",
    "Current Ver": "5.7.2",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "ES File Explorer File Manager",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 5378795,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.1.8.2.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Eternium",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 1506783,
    Size: "89M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.2.115",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Firefox Browser fast & private",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 3075096,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "E*TRADE Mobile",
    Category: "FINANCE",
    Rating: 3.9,
    Reviews: 10657,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 2, 2018",
    "Current Ver": "6.8.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "WWE",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 736824,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "January 19, 2018",
    "Current Ver": "3.17.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "E-cigarette for free",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 1354,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "October 23, 2017",
    "Current Ver": 1,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Moto LED for Moto X & E [Root]",
    Category: "LIFESTYLE",
    Rating: 3.4,
    Reviews: 4082,
    Size: "318k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "October 16, 2014",
    "Current Ver": 1,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Mobile Security & Antivirus",
    Category: "PRODUCTIVITY",
    Rating: 4.7,
    Reviews: 564759,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Lookout Security & Antivirus",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 951413,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": "10.23.2-964159b",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "World History Quick e-Book",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 1657,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "July 17, 2018",
    "Current Ver": 1.35,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Greeting Cards & Wishes",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 17350,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 18, 2018",
    "Current Ver": 1.078,
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Amazon Kindle",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.2,
    Reviews: 814151,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Evernote – Organizer, Planner for Notes & Memos",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 1488289,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Maps & GPS Navigation OsmAnd+",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 15209,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$8.99",
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Microsoft Edge",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 27156,
    Size: "66M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 28, 2018",
    "Current Ver": "42.0.0.2059",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Microsoft Outlook",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 3249518,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.2.194",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Pinterest",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 4300936,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "ClassDojo",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 148536,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.21.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "The Coupons App",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 181983,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "April 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "theScore esports",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 16257,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "February 3, 2017",
    "Current Ver": 2.8,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "EX File Explorer File Manager",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 4660,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 6, 2016",
    "Current Ver": 1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Aab e Hayat Full Novel",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.3,
    Reviews: 1476,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "February 21, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "EBookDroid - PDF & DJVU Reader",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 75951,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 8, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Ebook Reader",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.1,
    Reviews: 85842,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 25, 2018",
    "Current Ver": "5.0.6",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Gmail",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 4604324,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "E-NUM",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 10374,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "October 24, 2016",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Maps - Navigate & Explore",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 9231613,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "AliExpress - Smarter Shopping, Better Living",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 5911055,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Aldiko Book Reader",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.2,
    Reviews: 210534,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 13, 2018",
    "Current Ver": "3.0.58",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Flipkart Online Shopping App",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 6003590,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Wish - Shopping Made Fun",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 6200739,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.20.5",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Synd e-Passbook",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 9400,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 12, 2016",
    "Current Ver": 1.09,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Messenger – Text and Video Chat for Free",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 56642847,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Facebook Lite",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 8595964,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Messenger Lite: Free Calls & Messages",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 1429038,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 25, 2018",
    "Current Ver": "37.0.0.7.163",
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "Video Downloader for Facebook",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 894435,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Tools",
    "Last Updated": "July 1, 2018",
    "Current Ver": "2.2.8",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "F-Stop Gallery Pro",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 1302,
    Size: "58k",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 5, 2015",
    "Current Ver": 3.2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Offroad Pickup Truck F",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 4551,
    Size: "79M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "December 26, 2017",
    "Current Ver": 1,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "F-Stop Gallery",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 12726,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 21, 2018",
    "Current Ver": "4.9.18",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Talking Tom Cat 2",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 3213548,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Entertainment",
    "Last Updated": "July 25, 2018",
    "Current Ver": "5.3.5.16",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "FlashLight F.Light",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 3943,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 23, 2018",
    "Current Ver": "1.4.2",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "F-Secure SENSE",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 57,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 4, 2018",
    "Current Ver": "1.0.988",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "Super Car F. Mod for MCPE",
    Category: "GAME",
    Rating: 3.6,
    Reviews: 214,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "July 19, 2018",
    "Current Ver": "3.0.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Twitter",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 11657972,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "News & Magazines",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "F-Secure KEY Password manager",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 2588,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 27, 2018",
    "Current Ver": "4.7.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Inputting Plus: Ctrl + Z/F/C/V",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 1117,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 18, 2017",
    "Current Ver": "1.0.6",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "CTRL-F - Search the real world",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 607,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 24, 2016",
    "Current Ver": 1.1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "F-Secure SAFE",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 9433,
    Size: "9.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": "17.4.0014017",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "MHD F-Series",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.9,
    Reviews: 73,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "June 5, 2018",
    "Current Ver": "version 0.994",
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "F-Secure AV Test",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 1250,
    Size: "241k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 6, 2018",
    "Current Ver": "1.0.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "LINE: Free Calls & Messages",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 10790092,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "imo beta free calls and text",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 659395,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 7, 2018",
    "Current Ver": "9.8.000000010492",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "F-Secure Mobile Security",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 13096,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": "17.4.0014017",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "f'east",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 38,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "April 17, 2018",
    "Current Ver": "2.6.3",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Dumb Ways to Die 2: The Games",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1671658,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "July 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Speech Therapy: F",
    Category: "FAMILY",
    Rating: 1,
    Reviews: 1,
    Size: "16M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 7, 2016",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "HumorCast - Authentic Weather",
    Category: "WEATHER",
    Rating: 4.4,
    Reviews: 6495,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Weather",
    "Last Updated": "July 12, 2018",
    "Current Ver": "4.4.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "F & M Mobile Banking",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 43,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 20, 2018",
    "Current Ver": "4.5.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "F",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 6,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 15, 2018",
    "Current Ver": "1.0.2",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "RPG End of Aspiration F",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 20368,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "December 15, 2016",
    "Current Ver": "3.0.0fr",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "F-Sim Space Shuttle",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 5427,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "January 28, 2014",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Weather Live",
    Category: "WEATHER",
    Rating: 4.5,
    Reviews: 76593,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "November 21, 2017",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Norwegian For Kids & Babies F",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "14M",
    Type: "Paid",
    Price: "$39.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 24, 2015",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "R+F PULSE",
    Category: "BUSINESS",
    Rating: 3.4,
    Reviews: 58,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 21, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "F-Secure Freedome for Business",
    Category: "BUSINESS",
    Rating: 3.8,
    Reviews: 183,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 16, 2018",
    "Current Ver": "2.5.1.7594.psb",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "F-1 watchface by Delta",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 23, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10,
    numAndroid: null,
  },
  {
    App: "f.lux (preview, root-only)",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.7,
    Reviews: 5559,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "March 15, 2016",
    "Current Ver": 22,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "F Length Sim (no Ads)",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.7M",
    Type: "Paid",
    Price: "$2.00",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "April 29, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Arto: f.infrared photo",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 41,
    Size: "11M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 19, 2016",
    "Current Ver": 3.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Geometry Dash World",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 759838,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "December 22, 2017",
    "Current Ver": 1.03,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Convert degree Celsius to Fahrenheit or °F to °C",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 51,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 21, 2018",
    "Current Ver": "1.5.8",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "F-Gas Solutions",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 127,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 7, 2016",
    "Current Ver": "2.1.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Google+",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 4828372,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "PUBG MOBILE",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 3697174,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 24, 2018",
    "Current Ver": "0.7.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Gangstar Vegas - mafia game",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 4830407,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "May 25, 2018",
    "Current Ver": "3.7.1a",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Gboard - the Google Keyboard",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 1855262,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "Granny",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1128805,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "May 29, 2018",
    "Current Ver": "1.4.0.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Offroad Car G",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 64884,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 12, 2016",
    "Current Ver": 1,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Google",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 8021623,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Google Now Launcher",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 857215,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 7, 2017",
    "Current Ver": "1.4.large",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Rolling G Sky",
    Category: "GAME",
    Rating: 3.6,
    Reviews: 2065,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "January 25, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Hangouts",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 3419464,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 21, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "G-Switch 2",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 12683,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "February 5, 2018",
    "Current Ver": 1.1,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "G-Switch 3",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 3656,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "March 15, 2018",
    "Current Ver": "1.1.3",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "G Cloud Apps Backup Key * root",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 1034,
    Size: "196k",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 8, 2013",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Share G - Images Sharing - Wallpapers App",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 120,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "October 5, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Next Launcher 3D Theme Hit-G",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 59,
    Size: "8.1M",
    Type: "Paid",
    Price: "$1.70",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 16, 2015",
    "Current Ver": 1.05,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Wrestling Revolution 3D",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 989344,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Sports",
    "Last Updated": "July 23, 2018",
    "Current Ver": 1.64,
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "G Cloud Backup",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 267042,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "G-Playlists",
    Category: "TOOLS",
    Rating: 1.8,
    Reviews: 53,
    Size: "3.4M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 19, 2018",
    "Current Ver": 1.91,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "G-Switch",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 4116,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "September 1, 2015",
    "Current Ver": "1.3.4",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Offroad G-Class 2018",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 7715,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 29, 2018",
    "Current Ver": 1.7,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "G-SHOCK+",
    Category: "LIFESTYLE",
    Rating: 3,
    Reviews: 4710,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "November 1, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Ramfer - CNC Lathe G-code Tool",
    Category: "PRODUCTIVITY",
    Rating: 3.4,
    Reviews: 5,
    Size: "11M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "September 26, 2016",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "G-Force Driving Assistant",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 10,
    Size: "6.1M",
    Type: "Paid",
    Price: "$3.88",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "April 10, 2013",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "My G:",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.7,
    Reviews: 96,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "November 14, 2017",
    "Current Ver": "1.4.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "G-SHOCK Connected",
    Category: "LIFESTYLE",
    Rating: 3,
    Reviews: 543,
    Size: "94M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 2, 2018",
    "Current Ver": "1.4.1(0629A)",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "Go",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 89,
    Size: "11M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "October 21, 2017",
    "Current Ver": "1.6.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Google Drive",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 2728941,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "G-Homa",
    Category: "LIFESTYLE",
    Rating: 3.1,
    Reviews: 777,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 4, 2018",
    "Current Ver": "3.0.20",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "G-NetTrack Pro",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 255,
    Size: "1.6M",
    Type: "Paid",
    Price: "$14.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 25, 2018",
    "Current Ver": 14.6,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "G Theme 2 for LG V30, LG G6",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 25,
    Size: "15M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 13, 2017",
    "Current Ver": "1.0.2",
    numInstall: 500,
    numAndroid: 7,
  },
  {
    App: "Speedometer with G-FORCE meter",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 415,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 1, 2017",
    "Current Ver": 7,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "A41 WatchFace for Android Wear Smart Watch",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 231,
    Size: "5.7M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 24, 2017",
    "Current Ver": "7.0.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Radial-G : Infinity",
    Category: "GAME",
    Rating: 3.6,
    Reviews: 517,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "December 7, 2015",
    "Current Ver": 1.4,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "G-NetReport Pro",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.6M",
    Type: "Paid",
    Price: "$25.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 14, 2018",
    "Current Ver": 5,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Dialer theme G Black Gold",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 33,
    Size: "857k",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 1, 2016",
    "Current Ver": 2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "G-REMOTE",
    Category: "HOUSE_AND_HOME",
    Rating: 4.5,
    Reviews: 30,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 1, 2018",
    "Current Ver": 2.4,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Car G-Force Meter",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 184,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 29, 2017",
    "Current Ver": 2.23,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "G-NetWiFi Pro",
    Category: "TOOLS",
    Rating: 3.3,
    Reviews: 6,
    Size: "1.5M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 18, 2018",
    "Current Ver": 3.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Helix Jump",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 1485806,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "April 9, 2018",
    "Current Ver": "1.0.6",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "HSPA+ Tweaker (3G booster)",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 99290,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 5, 2017",
    "Current Ver": "3.1 Release b2",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Offroad Car H",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1960,
    Size: "87M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "October 6, 2017",
    "Current Ver": 1.4,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "H&M",
    Category: "LIFESTYLE",
    Rating: 3.7,
    Reviews: 41917,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 30, 2018",
    "Current Ver": "9.6.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Guns - Shot Sounds",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 29544,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 25, 2018",
    "Current Ver": 3.15,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "HPlus",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.9,
    Reviews: 1786,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 12, 2018",
    "Current Ver": "3.5.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Geometry Dash Lite",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 6181640,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "December 22, 2017",
    "Current Ver": 2.2,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "DNS Changer - BEST (Gprs/Edge/3G/H/H+/4G)",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 123,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 30, 2017",
    "Current Ver": 1.2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "H*nest Meditation",
    Category: "LIFESTYLE",
    Rating: 4.9,
    Reviews: 145,
    Size: "48M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Mature 17+",
    Genres: "Lifestyle",
    "Last Updated": "April 7, 2016",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Car Driving Simulator Drift",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 19816,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "November 3, 2017",
    "Current Ver": "1.8.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Deaf - Hearing chat device H",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 9,
    Size: "51k",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "February 8, 2017",
    "Current Ver": 3.6,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "صور حرف H",
    Category: "ART_AND_DESIGN",
    Rating: 4.4,
    Reviews: 13,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "March 27, 2018",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "H Band 2.0",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.9,
    Reviews: 4031,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 15, 2018",
    "Current Ver": "3.0.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "H!LooK - Dating",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 46,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 29, 2018",
    "Current Ver": "2.1.6",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "H-Connect",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4,
    Reviews: 50,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 3, 2018",
    "Current Ver": 2.14,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "most expensive app (H)",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 6,
    Size: "1.5M",
    Type: "Paid",
    Price: "$399.99",
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 16, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 7,
  },
  {
    App: "AntennaPict β",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 15439,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "November 7, 2016",
    "Current Ver": "2.0.0",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Elkhart County 4-H Fair",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 38,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 6, 2018",
    "Current Ver": "5055.524.5",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "H TV",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 103064,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 5, 2018",
    "Current Ver": "4.6.2",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "H letter images",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 17,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "June 28, 2018",
    "Current Ver": 16.7,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "H Band",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4,
    Reviews: 214,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 13, 2018",
    "Current Ver": "3.0.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "The World Ends With You",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 4108,
    Size: "13M",
    Type: "Paid",
    Price: "$17.99",
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "December 14, 2015",
    "Current Ver": "1.0.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "MJX H",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 126,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 22, 2017",
    "Current Ver": "1.0-build20170819",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "tinyCam Monitor FREE",
    Category: "HOUSE_AND_HOME",
    Rating: 4,
    Reviews: 65914,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "June 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "H-Kakashi - theme Xperia™",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 621,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 1, 2017",
    "Current Ver": "a.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "RC City Police Heavy Traffic Racer",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 3250,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "July 19, 2018",
    "Current Ver": 1.2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: 'Alphabet "H" Passcode Lock Screen',
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 2,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 21, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ohio State Fair 4-H",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 4,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 7, 2018",
    "Current Ver": "3.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Larry H Miller Automotive",
    Category: "PRODUCTIVITY",
    Rating: 3.1,
    Reviews: 67,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 18, 2018",
    "Current Ver": "3.5.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Talking Ben the Dog",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1633565,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 3, 2018",
    "Current Ver": "3.5.2.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Add-On: Alcatel (h)",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 107,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 19, 2015",
    "Current Ver": "10.0.3148",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "My Android Device S/W & H/W",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 681,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 20, 2015",
    "Current Ver": 1.1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "ADMIRALTY H-Note",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 176,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 25, 2016",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Force LTE Only",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 10426,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 4, 2018",
    "Current Ver": 1.4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ulysse Speedometer Pro",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.6,
    Reviews: 4140,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "May 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Talking Ginger",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1752017,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 5, 2018",
    "Current Ver": "2.5.6.11",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "D+H Reaction Wall",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 24, 2016",
    "Current Ver": "Varies with device",
    numInstall: 1,
    numAndroid: null,
  },
  {
    App: "Motorbike Driving Simulator 3D",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 178723,
    Size: "65M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "December 25, 2016",
    "Current Ver": 4.1,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Helix",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 2454,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "September 10, 2017",
    "Current Ver": 1.2,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Mobile Number Tracker",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 19758,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 14, 2018",
    "Current Ver": 2.7,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "imo free video calls and chat",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 4785892,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 8, 2018",
    "Current Ver": "9.8.000000010501",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "I am Nose Doctor -Save my Nose",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 3133,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "January 4, 2016",
    "Current Ver": "1.1.1",
    numInstall: 500000,
    numAndroid: 3,
  },
  {
    App: "free video calls and chat",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 594720,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 19, 2018",
    "Current Ver": "7.3(800241)",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "What was I in my Past Life",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 7453,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 19, 2017",
    "Current Ver": 2.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "How Old am I?",
    Category: "FAMILY",
    Rating: 2.8,
    Reviews: 4635,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 1, 2018",
    "Current Ver": 1.7,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "slither.io",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 5231553,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "November 14, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "I Screen Dialer",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 8137,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 25, 2018",
    "Current Ver": 1.11,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Where's My Water? Free",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 1372013,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "November 21, 2017",
    "Current Ver": "1.10.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "How Do I Look",
    Category: "PHOTOGRAPHY",
    Rating: 2.7,
    Reviews: 3032,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "December 8, 2017",
    "Current Ver": 1.3,
    numInstall: 500000,
    numAndroid: 3,
  },
  {
    App: "Solitaire!",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 403911,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "June 24, 2018",
    "Current Ver": "2.277.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "POF Free Dating App",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 1175188,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "iGun Pro -The Original Gun App",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 249308,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "September 7, 2017",
    "Current Ver": 5.26,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Skype - free IM & video calls",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 10484169,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Sonic Dash",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 3777822,
    Size: "75M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 26, 2018",
    "Current Ver": "3.8.5.Go",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "I'm Ping Pong King :)",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 29864,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 26, 2018",
    "Current Ver": 2.5,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "LINE I Love Coffee",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 250257,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "November 16, 2016",
    "Current Ver": "1.1.5",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Text Free: WiFi Calling App",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 83474,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Talkatone: Free Texts, Calls & Phone Number",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 132015,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 18, 2018",
    "Current Ver": 6.1,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Instachat 😜",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 80987,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 30, 2018",
    "Current Ver": "2.2.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Textgram - write on photos",
    Category: "ART_AND_DESIGN",
    Rating: 4.4,
    Reviews: 295237,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Fame Boom for Real Followers, Likes",
    Category: "SOCIAL",
    Rating: 4.7,
    Reviews: 896118,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "October 9, 2017",
    "Current Ver": "1.3.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "NinJump",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 421000,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "June 13, 2018",
    "Current Ver": "3.1.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Catchers",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 989158,
    Size: "75M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.0.27",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "FollowMeter for Instagram",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 90082,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "May 22, 2018",
    "Current Ver": 2.44,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "I LOVE PASTA",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 83875,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "September 8, 2017",
    "Current Ver": "1.6.1",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Talking Tom Cat",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1838090,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Casual",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Fidget Spinner",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 307398,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "November 30, 2017",
    "Current Ver": "1.12.5.1",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Jetpack Joyride",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 4637439,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.10.12",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "J Touch",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 2176,
    Size: "953k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.5.1-GP",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "J-Novel Club",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 162,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "October 22, 2017",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Anger of stick 5 : zombie",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 547644,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.1.5",
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "J - Style Pro",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.3,
    Reviews: 74,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "January 20, 2016",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Cook Baked Lasagna",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 56259,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "March 14, 2018",
    "Current Ver": 4,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Tom's Love Letters",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 705805,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 30, 2018",
    "Current Ver": "2.3.1.8",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "The J-Notes: Jazz News",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 7,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "February 28, 2018",
    "Current Ver": "5.2.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Cut the Rope FULL FREE",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 2122705,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 5, 2018",
    "Current Ver": "3.7.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Mali J",
    Category: "SOCIAL",
    Rating: 3.2,
    Reviews: 185,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "October 20, 2017",
    "Current Ver": "1.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "J-UFO",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 339,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 12, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Cut the Rope GOLD",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 61264,
    Size: "43M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "June 19, 2018",
    "Current Ver": "3.7.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Turbo FAST",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1329008,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "October 4, 2017",
    "Current Ver": "2.1.20",
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "The Voice, sing and connect",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 405824,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 4, 2018",
    "Current Ver": "7.1.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "J. Cole Rapper Wallpaper HD",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 8,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 11, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Keyboard for Sony Xperia J",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 797,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 29, 2018",
    "Current Ver": "1.279.13.98",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "J Alvarej Moji",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 2,
    Size: "13M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 3, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 3,
  },
  {
    App: "Harris J Lyrics",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 36,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 12, 2018",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Smart TV Remote",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 81747,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 26, 2018",
    "Current Ver": "3.8.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "J.ME Fly",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 28,
    Size: "98M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 31, 2018",
    "Current Ver": "0.4.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "J Balvin Piano Tiles",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 6,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music",
    "Last Updated": "May 15, 2018",
    "Current Ver": 2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Guess the song of J Balvin",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 28,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "December 24, 2017",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "J-Stars Victory VS Guide",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 609,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "May 14, 2014",
    "Current Ver": 1.7,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "2048 BTS J Hope KPop Puzzle Game",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 17,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "September 26, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "J. Polep Plus Mobile",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 26, 2018",
    "Current Ver": "1.1.4",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "J. Cole Albums (2007-2017)",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 7,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "April 11, 2018",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "J Dark Ice Substratum Theme",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 164,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 19, 2018",
    "Current Ver": 4.3,
    numInstall: 10000,
    numAndroid: 6,
  },
  {
    App: "BTS J-Hope Wallpaper KPOP Fans HD",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 98,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 19, 2018",
    "Current Ver": "1.1.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BTS j-hope LINE Launcher theme",
    Category: "PERSONALIZATION",
    Rating: 4.9,
    Reviews: 934,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "October 17, 2014",
    "Current Ver": 4.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BTS J-Hope Wallpaper HD for KPOP Fans",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 4,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.1.4",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Kik",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 2451136,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "K Health",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.1,
    Reviews: 290,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "July 22, 2018",
    "Current Ver": "1.7.2992",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "CIRCLE K",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 9140,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 31, 2018",
    "Current Ver": "5.9.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "K-@ Mail Pro - Email App",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 1603,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 23, 2016",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "K-@ Mail - Email App",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 1760,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 23, 2016",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Keepsafe Photo Vault: Hide Private Photos & Videos",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 1656808,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 31, 2018",
    "Current Ver": "9.14.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "KIM KARDASHIAN: HOLLYWOOD",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1017408,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "July 16, 2018",
    "Current Ver": "9.2.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Sight Words Pre-K to Grade-3",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 1185,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "June 17, 2018",
    "Current Ver": "1.5.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "K PLUS",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 124324,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 26, 2018",
    "Current Ver": "4.6.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "[Substratum] K-Manager for K-Klock",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 14,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 31, 2018",
    "Current Ver": 31,
    numInstall: 1000,
    numAndroid: 7,
  },
  {
    App: "KDRAMA Amino for K-Drama Fans",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 4046,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 13, 2018",
    "Current Ver": "1.8.19106",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "K keyboard - Myanmar",
    Category: "TOOLS",
    Rating: 4.8,
    Reviews: 1955,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 17, 2018",
    "Current Ver": "1.0.8",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Zapzapmath: K-6 Math Games",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1065,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "May 13, 2018",
    "Current Ver": "4.1.10",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "KPOP Amino for K-Pop Entertainment",
    Category: "SOCIAL",
    Rating: 4.8,
    Reviews: 19047,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 13, 2018",
    "Current Ver": "1.8.19106",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "K.MOJI",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 16,
    Size: "8.9M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 9, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "K-Chiing VPN (Free)",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 43,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Tools",
    "Last Updated": "July 24, 2018",
    "Current Ver": "2.1.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Preschool All-In-One",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 9019,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Education",
    "Last Updated": "March 28, 2018",
    "Current Ver": 6.6,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "OST)",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 4444,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 6, 2018",
    "Current Ver": "3.0.12",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Kpop Music Quiz (K-pop Game)",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 6418,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 8, 2017",
    "Current Ver": 1.3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Radio K - KUOM",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 39,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 9, 2018",
    "Current Ver": "3.0.57",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Math Games for Pre-K - Grade 4",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 28,
    Size: "23M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "January 13, 2014",
    "Current Ver": 1.02,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "PowerDirector Video Editor App: 4K, Slow Mo & More",
    Category: "VIDEO_PLAYERS",
    Rating: 4.5,
    Reviews: 712737,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 24, 2018",
    "Current Ver": "4.13.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Fuzzy Numbers: Pre-K Number Foundation",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 21,
    Size: "44M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "July 21, 2017",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "KakaoTalk: Free Calls & Text",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 2546549,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Speech Therapy: K",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 7, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "K-Otic Universe",
    Category: "FAMILY",
    Rating: 4.9,
    Reviews: 55,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "August 3, 2018",
    "Current Ver": 108,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Magic Tiles - TWICE Edition (K-Pop)",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 2351,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music",
    "Last Updated": "July 25, 2018",
    "Current Ver": 1009001,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CASE K-12 Math English Science",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 60,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 1, 2016",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Mermaid Princess Pre K Games",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 19,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "June 29, 2018",
    "Current Ver": 3.01,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "K-App Mitarbeiter Galeria Kaufhof",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 10, 2018",
    "Current Ver": "3.27.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Niche: College, K-12, and Neighborhood Search",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 42,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 6, 2018",
    "Current Ver": "1.0.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "K-Spapp, the K-Space app",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 39,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 9, 2017",
    "Current Ver": 1.53,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Math Quiz Free: Grades K,1,2,3",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 159,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "February 3, 2015",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "K-9 Material (unofficial)",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 64,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "March 27, 2017",
    "Current Ver": 5.206,
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "Discovery K!ds Play! Español",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 11263,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "May 3, 2018",
    "Current Ver": "2.1.0.2173",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Magic Tiles - Blackpink Edition (K-Pop)",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 4304,
    Size: "71M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music",
    "Last Updated": "June 20, 2018",
    "Current Ver": 1900001,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Wallpapers Bus Scania Irizar K",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 35,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "April 21, 2016",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Anna.K Tarot",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 17,
    Size: "23M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "January 16, 2017",
    "Current Ver": "1.4.4",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "K-pop Music",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 369,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 11, 2017",
    "Current Ver": "2.0.0",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Daily K-Talk",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 264,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 31, 2018",
    "Current Ver": "v8[1.0.10]",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Korean Dungeon: K-Word 1000",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 703,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Word",
    "Last Updated": "November 17, 2017",
    "Current Ver": "1.0.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "LiveMe - Video chat, new friends, and make money",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 456866,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Talking Tom Gold Run",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 2694969,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.8.2.59",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "letgo: Buy & Sell Used Stuff, Cars & Real Estate",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 972256,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.4.8",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Lep's World 🍀",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 696019,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "May 26, 2018",
    "Current Ver": "3.0.6",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "L.POINT - 엘포인트 [ 포인트, 멤버십, 적립, 사용, 모바일 카드, 쿠폰, 롯데]",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 45224,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 1, 2018",
    "Current Ver": "6.5.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Love Balls",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 357049,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.2.7",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "SpongeBob Diner Dash",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 576210,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "August 22, 2013",
    "Current Ver": "3.25.3",
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "Last Day on Earth: Survival",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 2308916,
    Size: "87M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.9.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Messenger L SMS, MMS",
    Category: "PERSONALIZATION",
    Rating: 4,
    Reviews: 6263,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 12, 2018",
    "Current Ver": 7.46,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Tom Loves Angela",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 1111915,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 30, 2018",
    "Current Ver": "2.2.1.3",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "EXO-L",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 67410,
    Size: "865k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 2, 2017",
    "Current Ver": "1.0.9",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Lie Detector",
    Category: "FAMILY",
    Rating: 3.1,
    Reviews: 306,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "April 4, 2017",
    "Current Ver": "1.2.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EXO-L Amino for EXO Fans",
    Category: "SOCIAL",
    Rating: 4.9,
    Reviews: 5677,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 13, 2018",
    "Current Ver": "1.8.19106",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Calculator L",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 2965,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 10, 2015",
    "Current Ver": "1.1.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "My Teacher - Classroom Play",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 155276,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing;Pretend Play",
    "Last Updated": "June 18, 2018",
    "Current Ver": "1.1.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Emoji Android L Keyboard",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 11535,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 7, 2017",
    "Current Ver": 1.42,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Lollipop Keyboard L Pro",
    Category: "PERSONALIZATION",
    Rating: 3.6,
    Reviews: 5525,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 6, 2016",
    "Current Ver": 1.6,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "French to English Speaking - Apprendre l' Anglais",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 4251,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 27, 2018",
    "Current Ver": 23,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ant Smasher by Best Cool & Fun Games",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 1185148,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "August 1, 2018",
    "Current Ver": 9.55,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Cheating Tom 3 - Genius School",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 90415,
    Size: "84M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.0.20",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Clock L",
    Category: "PERSONALIZATION",
    Rating: 3.9,
    Reviews: 2852,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "September 7, 2015",
    "Current Ver": 1.3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dialer theme Droid L",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 1734,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Personalization",
    "Last Updated": "April 2, 2016",
    "Current Ver": 4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "SPEED L",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 85,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 26, 2018",
    "Current Ver": 1.24,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Lie Detector Test Prank",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 222308,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.0.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Xbox",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 556659,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 20, 2018",
    "Current Ver": "1805.0618.1637",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Je Parle ANGLAIS - Apprendre l’anglais Audio cours",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 499,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 13, 2018",
    "Current Ver": 2.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Mobizen Screen Recorder - Record, Capture, Edit",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 1827212,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.6.0.28",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Minecraft",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 2375336,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$6.99",
    "Content Rating": "Everyone 10+",
    Genres: "Arcade;Action & Adventure",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.5.2.1",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Mobizen Screen Recorder for SAMSUNG",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 953894,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "April 26, 2018",
    "Current Ver": "3.5.1.8",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "MapleStory M",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 31538,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.2703.273",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "M-Files",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 236,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 26, 2018",
    "Current Ver": "3.1.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "M Launcher -Marshmallow 6.0",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 37234,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 22, 2018",
    "Current Ver": "1.4.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Mobizen Screen Recorder for LG - Record, Capture",
    Category: "VIDEO_PLAYERS",
    Rating: 4.5,
    Reviews: 58820,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "April 26, 2018",
    "Current Ver": "3.5.1.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "MakeupPlus - Your Own Virtual Makeup Artist",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 758780,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.0.55",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "M3-X5-X6-M-İ3-İ8 RACİNG 2018",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 596,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "February 12, 2017",
    "Current Ver": "1,01",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "MEGA",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 549214,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "360-M Flight",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 84,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 14, 2017",
    "Current Ver": 2.18,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "M-acceleration 3D Car Racing",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 1202,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "June 28, 2018",
    "Current Ver": 1.6,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "m>notes notepad",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 184,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 4, 2015",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "M+",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.9,
    Reviews: 198,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 29, 2018",
    "Current Ver": "3.2.2",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Super Hero M Craft Run",
    Category: "GAME",
    Rating: 3.7,
    Reviews: 303,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 12, 2017",
    "Current Ver": 1.6,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "M-Sight Pro",
    Category: "VIDEO_PLAYERS",
    Rating: 3.3,
    Reviews: 30,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 25, 2018",
    "Current Ver": "3.1.0.1-r4",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "💎 I'm rich",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 718,
    Size: "26M",
    Type: "Paid",
    Price: "$399.99",
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 11, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Don't Hug Me I'm So Scared",
    Category: "GAME",
    Rating: 3.5,
    Reviews: 901,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "June 8, 2018",
    "Current Ver": "1.8.5",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "GTS-M",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 38,
    Size: "251k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 26, 2017",
    "Current Ver": 1.4,
    numInstall: 5000,
    numAndroid: 1,
  },
  {
    App: "MX Player",
    Category: "VIDEO_PLAYERS",
    Rating: 4.5,
    Reviews: 6469179,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "M star Dialer",
    Category: "COMMUNICATION",
    Rating: 3.5,
    Reviews: 400,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "March 20, 2017",
    "Current Ver": "3.8.8",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "I'm Rich - Trump Edition",
    Category: "LIFESTYLE",
    Rating: 3.6,
    Reviews: 275,
    Size: "7.3M",
    Type: "Paid",
    Price: "$400.00",
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 3, 2018",
    "Current Ver": "1.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "I’m Expecting - Pregnancy App",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 71266,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "March 30, 2018",
    "Current Ver": "2.3.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Free WiFi Connect",
    Category: "COMMUNICATION",
    Rating: 3.9,
    Reviews: 167229,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "March 31, 2018",
    "Current Ver": 8.1,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "M Notifier for M Launcher",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 2803,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 15, 2017",
    "Current Ver": "1.0.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "M Theme - Dark Green Icon Pack",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 202,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "November 16, 2016",
    "Current Ver": "1.2.3",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "m-Faisaa",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 142,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 13, 2018",
    "Current Ver": 5.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "m:go BiH",
    Category: "COMMUNICATION",
    Rating: 3.2,
    Reviews: 559,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 25, 2018",
    "Current Ver": 3.4,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "Diabetes:M",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 15537,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 1, 2018",
    "Current Ver": "6.1.3",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Libre Scan (Diabetes:M addon)",
    Category: "MEDICAL",
    Rating: 2.4,
    Reviews: 102,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 9, 2017",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "m.ride - your motorcycle app",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.5,
    Reviews: 189,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.1.6",
    numInstall: 10000,
    numAndroid: 6,
  },
  {
    App: "Rope'n'Fly 4",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 234606,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "January 29, 2018",
    "Current Ver": 3.1,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "N Launcher: Nougat Theme",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 128,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 13, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Dino in City-Dinosaur N Police",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 10035,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "May 23, 2018",
    "Current Ver": 2.07,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "N Launcher Pro - Nougat 7.0",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 2538,
    Size: "6.4M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 23, 2018",
    "Current Ver": "1.5.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Cops N Robbers - FPS Mini Game",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 156862,
    Size: "64M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "July 31, 2018",
    "Current Ver": "7.0.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Cops N Robbers 2",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 63680,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Adventure",
    "Last Updated": "June 2, 2018",
    "Current Ver": "2.2.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hands 'n Guns Simulator",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 19727,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "July 3, 2018",
    "Current Ver": 32,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hide N Seek : Mini Game",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 4719,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 8, 2018",
    "Current Ver": "5.1.3",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "N Launcher - Nougat 7.0",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 32597,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.5.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Cook'n Recipe App",
    Category: "LIFESTYLE",
    Rating: 3.4,
    Reviews: 552,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.0.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Rope'n'Fly 3 - Dusk Till Dawn",
    Category: "GAME",
    Rating: 4,
    Reviews: 166033,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "January 31, 2018",
    "Current Ver": 3.6,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Tap N Pay",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 253,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 31, 2018",
    "Current Ver": "0.1.22",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "N-Com Wizard",
    Category: "COMMUNICATION",
    Rating: 3.3,
    Reviews: 960,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "September 21, 2017",
    "Current Ver": "2.1.2",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Drag'n'Boom",
    Category: "GAME",
    Rating: 4.8,
    Reviews: 133180,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "January 12, 2018",
    "Current Ver": "1.1.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Traps n' Gemstones",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 413,
    Size: "9.1M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "May 17, 2017",
    "Current Ver": 1.04,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Shop 'n Save",
    Category: "SHOPPING",
    Rating: 3.4,
    Reviews: 620,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "March 13, 2018",
    "Current Ver": "2.2.8",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dual N-Back - Brain game",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 817,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "May 25, 2018",
    "Current Ver": "2.4.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "N Files - File Manager & Explorer",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 369,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 18, 2018",
    "Current Ver": "2.9.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Guns'n'Glory Zombies Premium",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 313,
    Size: "34M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 15, 2016",
    "Current Ver": "1.1.5",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Cops N Robbers",
    Category: "GAME",
    Rating: 4,
    Reviews: 37789,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.5.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Guns'n'Glory Premium",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 3570,
    Size: "21M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "September 22, 2017",
    "Current Ver": "1.8.1",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Madagascar Surf n' Slides Free",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 48929,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "September 8, 2017",
    "Current Ver": "1.5.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Guns'n'Glory",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 89947,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "February 9, 2018",
    "Current Ver": "1.8.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Ghosts'n Goblins MOBILE",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 466,
    Size: "28M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "March 28, 2017",
    "Current Ver": "1.00.02",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Mopar Drag N Brag",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 30630,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "May 25, 2015",
    "Current Ver": "1.2.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Read Unlimitedly! Kids'n Books",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 7462,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Music & Video",
    "Last Updated": "February 16, 2018",
    "Current Ver": 3.42,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Dark Infusion Substratum Theme for Android N & O",
    Category: "PERSONALIZATION",
    Rating: 4.8,
    Reviews: 133,
    Size: "59M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 3, 2018",
    "Current Ver": 15.6,
    numInstall: 1000,
    numAndroid: 7,
  },
  {
    App: "Fantastic Chefs: Match 'n Cook",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 8600,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.0.7",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Guns'n'Glory Heroes Premium",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 923,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "November 9, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "Eat'n Park",
    Category: "LIFESTYLE",
    Rating: 3.5,
    Reviews: 292,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 18, 2017",
    "Current Ver": "3.1.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Draw N Guess Multiplayer",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 29505,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "April 4, 2018",
    "Current Ver": "3.0.11",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Car Parking Crane N Drifting",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 106,
    Size: "71M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "February 26, 2018",
    "Current Ver": 1.8,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Lock 'n' Roll Pro - Ad Free",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 169,
    Size: "13M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "July 1, 2015",
    "Current Ver": "4.0.5",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Rock N' Cash Casino Slots -Free Vegas Slot Games",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 6187,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.15.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Age of Conquest: N. America",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 659,
    Size: "3.3M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.0.28",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "Sketch 'n' go",
    Category: "VIDEO_PLAYERS",
    Rating: 3.8,
    Reviews: 3965,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "March 26, 2018",
    "Current Ver": "2.2.9",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Guns'n'Glory WW2 Premium",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 4656,
    Size: "20M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "December 8, 2017",
    "Current Ver": "1.4.11",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Rock n Roll Music Quiz Game",
    Category: "GAME",
    Rating: 3.7,
    Reviews: 80,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "June 6, 2018",
    "Current Ver": 5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Cook 'n Learn Smart Kitchen",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 205,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "March 6, 2017",
    "Current Ver": "1.0.4",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Jump'N'Shoot Attack",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 155,
    Size: "32M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 26, 2018",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ghouls'n Ghosts MOBILE",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 168,
    Size: "49M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "May 18, 2017",
    "Current Ver": "1.00.00",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "N-Back",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 413,
    Size: "930k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "February 15, 2016",
    "Current Ver": 1.6,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Oddworld: New 'n' Tasty",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 1475,
    Size: "34M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "January 2, 2018",
    "Current Ver": "1.0.4",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Knights N Squires",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 148826,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "June 19, 2018",
    "Current Ver": "1.4.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Opera Mini - fast web browser",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 5150801,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Opera Browser: Fast and Secure",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 2473795,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 31, 2018",
    "Current Ver": "47.1.2249.129326",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Planet O - Icon Pack",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 354,
    Size: "24M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 13, 2018",
    "Current Ver": "1.6.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "The Noise-O-Meter",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 1699,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "October 18, 2017",
    "Current Ver": "1.0.1.24",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "O Launcher 8.0 for Android™ O Oreo Launcher",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 11393,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 27, 2018",
    "Current Ver": 3.9,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Opera Mini browser beta",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 401530,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Stand O’Food® (Full)",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 925,
    Size: "40M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "December 26, 2014",
    "Current Ver": 1.5,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "WiFi-o-Matic",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 736,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "February 1, 2018",
    "Current Ver": "1.80.03",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Detect-O-Gromit (D.O.G 2)",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 45,
    Size: "47M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 16, 2018",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "O Shopping",
    Category: "SHOPPING",
    Rating: 3.9,
    Reviews: 671,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.1.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Obbligo o Verità? PRO",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 4,
    Size: "2.9M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Teen",
    Genres: "Board",
    "Last Updated": "April 26, 2018",
    "Current Ver": "1,01",
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "AC Remote for O General - NOW FREE",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 274,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": "6.1.7",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "O'Route Orienteering",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 6,
    Size: "1.3M",
    Type: "Paid",
    Price: "$3.02",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "December 27, 2017",
    "Current Ver": "2.0.5",
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "Drink-O-Tron The Drinking Game",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 140,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Card",
    "Last Updated": "May 31, 2017",
    "Current Ver": 1.64,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Multiling O Keyboard + emoji",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 30443,
    Size: "540k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 3, 2018",
    "Current Ver": "0.54.2.4",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Google I/O 2018",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.3,
    Reviews: 22401,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 7, 2018",
    "Current Ver": "6.1.2",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Prime Key for Nougat Launcher& O Launcher &KitKat",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 324,
    Size: "313k",
    Type: "Paid",
    Price: "$6.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 20, 2017",
    "Current Ver": 5.1,
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "OO Launcher for Android O 8.0 Oreo™ Launcher",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 14832,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 3, 2018",
    "Current Ver": 4.6,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Band O'Clock",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 1140,
    Size: "746k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 3, 2011",
    "Current Ver": 0.11,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "O Launcher",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 2059,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.1.4",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "O-Star",
    Category: "DATING",
    Rating: 4.4,
    Reviews: 59,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.0.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Verdad o Reto",
    Category: "SOCIAL",
    Rating: 3.8,
    Reviews: 826,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "May 10, 2018",
    "Current Ver": 2,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Pixlr-o-matic",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 180697,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "April 25, 2017",
    "Current Ver": "2.2.5",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "O-Level Past Papers & Solution (up to 2017)",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 589,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 11, 2018",
    "Current Ver": "8.3.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "O Multiple - App Cloner, Duals APP, tarallel",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 145,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 15, 2018",
    "Current Ver": "1.0.7",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "The Maze Runner",
    Category: "GAME",
    Rating: 4,
    Reviews: 428268,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "September 14, 2015",
    "Current Ver": "1.8.1",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Psiphon Pro - The Internet Freedom VPN",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 298041,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "PicsArt Photo Studio: Collage Maker & Pic Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 7590099,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Photography",
    "Last Updated": "July 31, 2018",
    "Current Ver": "9.40.3",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "P Icon Pack for Pixel",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 38,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 6, 2018",
    "Current Ver": "1.0.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Android P | Xperia™ Theme 4800+ icons",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 29,
    Size: "39M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 16, 2018",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 6,
  },
  {
    App: "Android P Home KLWP",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.1M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 14, 2018",
    "Current Ver": "v2018.Apr.12.16",
    numInstall: 5,
    numAndroid: 5,
  },
  {
    App: "P-Home for KLWP",
    Category: "PERSONALIZATION",
    Rating: 5,
    Reviews: 4,
    Size: "12M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 15, 2018",
    "Current Ver": "v2018.May.15.14",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "[substratum] Vacuum: P",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 230,
    Size: "11M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 20, 2018",
    "Current Ver": 4.4,
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "Super P Launcher for Android P 9.0 launcher, theme",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 2026,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1.9,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "pixiv",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 86956,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "5.0.109",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "[Sub/EMUI] P Pro - EMUI 8.1/8.0/5.X Theme",
    Category: "PERSONALIZATION",
    Rating: 4,
    Reviews: 13,
    Size: "19M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 20, 2018",
    "Current Ver": "H7SubTV0.1_TV0.4",
    numInstall: 100,
    numAndroid: 7,
  },
  {
    App: "Pacify Exceed (Android P) - Theme for Xperia™",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 5,
    Size: "1.9M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 2, 2018",
    "Current Ver": "1.2.A.Exceed.Paid",
    numInstall: 10,
    numAndroid: 6,
  },
  {
    App: "Theme Android P Design for LG V30",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 35,
    Size: "5.2M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 26, 2018",
    "Current Ver": 1.33,
    numInstall: 500,
    numAndroid: 7,
  },
  {
    App: "Pistachio Launcher for Android P 9.0",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.3M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.0.2",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Theme Android P for LG G7 & V35",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 5,
    Size: "4.5M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 7, 2018",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 8,
  },
  {
    App: "Volume Slider Like Android P Volume Control",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 1129,
    Size: "1.7M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 30, 2018",
    "Current Ver": 1.28,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Pacify (Android P theme) - Theme for Xperia™",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "1.8M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 15, 2018",
    "Current Ver": "1.0.B+.Exceed.Paid",
    numInstall: 10,
    numAndroid: 5,
  },
  {
    App: "P Launcher for Android™ 9.0",
    Category: "PERSONALIZATION",
    Rating: 3.9,
    Reviews: 35,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 1, 2018",
    "Current Ver": "0.9.3",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "PixelLab - Text on pictures",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 108002,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Popsicle Launcher for Android P 9.0 launcher",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.5M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 11, 2018",
    "Current Ver": 1.1,
    numInstall: 0,
    numAndroid: 4,
  },
  {
    App: "Theme Android P Black design for LG V30",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 8,
    Size: "6.2M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 6, 2018",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 7,
  },
  {
    App: "P Launcher Theme For Android™ 9.0",
    Category: "PERSONALIZATION",
    Rating: 3.9,
    Reviews: 213,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 18, 2018",
    "Current Ver": 1.4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Theme Android P Black for LG G7 & V35",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 5,
    Size: "4.3M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 31, 2018",
    "Current Ver": 1.3,
    numInstall: 100,
    numAndroid: 7,
  },
  {
    App: "P Theme for Android™ P 9.0 Style Launcher",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 216,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 13, 2018",
    "Current Ver": 1.4,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Android P 9.0",
    Category: "PERSONALIZATION",
    Rating: 3,
    Reviews: 12,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 30, 2018",
    "Current Ver": 2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Pureness Pacify (Android P) - Theme for Xperia™",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.6M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.2.A.Exceed.Paid",
    numInstall: 1,
    numAndroid: 6,
  },
  {
    App: "Android P Wallpapers",
    Category: "PERSONALIZATION",
    Rating: 3.6,
    Reviews: 53,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "February 12, 2018",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "P XPERIA Theme™ | Design For SONY 🎨",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 147,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 28, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Parallel Space - Multiple accounts & Two face",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 3062845,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.0.8552",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Theme for New Android P",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 13,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 23, 2018",
    "Current Ver": "1.1.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "P9 Launcher - Android™ 9.0 P Launcher Style",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 1162,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 6, 2018",
    "Current Ver": 2.5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Android P Style Icon Pack",
    Category: "PERSONALIZATION",
    Rating: 5,
    Reviews: 1,
    Size: "60M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 16, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Android P Stock Wallpapers",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 16,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.3.0",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "G-Pix [Android P] Dark EMUI 8/5 THEME",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 169,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 25, 2018",
    "Current Ver": 7,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "G-Pix [Android P] EMUI 8/5 THEME",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 720,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 13, 2018",
    "Current Ver": 12,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Android-P Mono Grey EMUI 8/5 Theme",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 61,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 4, 2018",
    "Current Ver": 4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "P XPERIA Theme™ | PURPLE - Design For SONY 🎨",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 3,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 5, 2018",
    "Current Ver": "1.0.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Materialistic P Wallpapers",
    Category: "PERSONALIZATION",
    Rating: 4.8,
    Reviews: 24,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 3, 2018",
    "Current Ver": 2.244,
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Android P Rotation",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 502,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 15, 2018",
    "Current Ver": 1.5,
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "P XPERIA Theme™ | INDIGO - Design For SONY 🎨",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 12,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 5, 2018",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Android P Launcher 9.0 launcher",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 164,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 23, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Pixel Oreo/P Dark White AMOLED UI - Icon Pack",
    Category: "PERSONALIZATION",
    Rating: 4.8,
    Reviews: 18,
    Size: "16M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 21, 2018",
    "Current Ver": 5.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "pretty Easy privacy p≡p",
    Category: "COMMUNICATION",
    Rating: 3.7,
    Reviews: 21,
    Size: "20M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.0.100rc1.withoutKeysync",
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "P Icon Pack",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "21M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 16, 2018",
    "Current Ver": "1.0.6",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Pi Dark [substratum]",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 189,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 27, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "Q Alerts: QAnon Drop Notifications, Research +++",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.7,
    Reviews: 143,
    Size: "26M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Mature 17+",
    Genres: "News & Magazines",
    "Last Updated": "July 26, 2018",
    "Current Ver": "4.1.10",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "The Q - Live Trivia Game Network",
    Category: "GAME",
    Rating: 2.7,
    Reviews: 1486,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.4.8",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Fossil Q",
    Category: "LIFESTYLE",
    Rating: 2.9,
    Reviews: 6627,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.5.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Q",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 69126,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 19, 2018",
    "Current Ver": "2.9.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: 'Official QR Code® Reader "Q"',
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 3031,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Q Cat Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 4383,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "March 16, 2015",
    "Current Ver": 2.7,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Q MINDshare Mobile",
    Category: "BUSINESS",
    Rating: 3.4,
    Reviews: 24,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "Fossil Q Legacy",
    Category: "LIFESTYLE",
    Rating: 2.6,
    Reviews: 680,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 19, 2017",
    "Current Ver": "1.0.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Offroad Car Q",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 24668,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 4, 2016",
    "Current Ver": "1.0.2",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Q*bert: Rebooted",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 13788,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "April 1, 2017",
    "Current Ver": 1.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Quora",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 313403,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Gun Shoot War Q",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 26893,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "March 1, 2017",
    "Current Ver": "1.0.5",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "FaceQ",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 591411,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "May 16, 2017",
    "Current Ver": "3.4.1",
    numInstall: 10000000,
    numAndroid: 3,
  },
  {
    App: "Q Actions - Digital Assistant",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500,
    numAndroid: null,
  },
  {
    App: "Q Link Wireless Zone",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 2194,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 8, 2018",
    "Current Ver": "2.0.4",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Q Avatar (Avatar Maker)",
    Category: "COMICS",
    Rating: 4.4,
    Reviews: 2012,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "March 4, 2017",
    "Current Ver": "1.3.5",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Q downloader : download your social media videos",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 41,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 21, 2018",
    "Current Ver": "1.1.2.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Q Avatar Pro",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 4,
    Size: "3.6M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "March 4, 2017",
    "Current Ver": "1.3.5",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Q-See Plus",
    Category: "VIDEO_PLAYERS",
    Rating: 2.2,
    Reviews: 32,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 9, 2018",
    "Current Ver": "3.1.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Q Wunder",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 156,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "June 30, 2018",
    "Current Ver": "2.0.13",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Q-See QC View",
    Category: "TOOLS",
    Rating: 3.1,
    Reviews: 657,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 19, 2018",
    "Current Ver": "3.49.0202",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Leica Q",
    Category: "PHOTOGRAPHY",
    Rating: 3.1,
    Reviews: 133,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 8, 2018",
    "Current Ver": "1.0.2.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Q Remote Control",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 4264,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 12, 2014",
    "Current Ver": "2.6.1",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Q-Ticketing",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.8,
    Reviews: 114,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "December 18, 2017",
    "Current Ver": "1.8.3111",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DJMAX TECHNIKA Q - Music Game",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 21107,
    Size: "95M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.2.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "myQ",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 3642,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 23, 2018",
    "Current Ver": "3.2.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "QR Code Reader",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 495971,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 16, 2016",
    "Current Ver": 2.3,
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "ICQ — Video Calls & Chat Messenger",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 697939,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 18, 2018",
    "Current Ver": "7.3(823181)",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Q Operator",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 60,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "November 8, 2016",
    "Current Ver": "1.10.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Q Call",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 20,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 16, 2018",
    "Current Ver": 2.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Q-slope",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 2,
    Size: "3.9M",
    Type: "Paid",
    Price: "$1.76",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 3, 2017",
    "Current Ver": 5,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Q-Tech Companion App",
    Category: "FOOD_AND_DRINK",
    Rating: 1.8,
    Reviews: 17,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "March 8, 2017",
    "Current Ver": "1.6.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Q Mobile Banking",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 460,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 26, 2018",
    "Current Ver": "5.9.1.0",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Q Quiz SK",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 159,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 8, 2015",
    "Current Ver": 2.3,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Big Q Car Service",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.4,
    Reviews: 75,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "May 15, 2017",
    "Current Ver": 3.002,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Q-See QT View",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 7357,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 12, 2018",
    "Current Ver": "4.4.1",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "ROBLOX",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 4443407,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Adventure;Action & Adventure",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.347.225742",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "DataCamp - Learn R, Python & SQL",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 944,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "3.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "R Language Reference Guide",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.9,
    Reviews: 54,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "December 24, 2017",
    "Current Ver": 1.11,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Run R Script - Online Statistical Data Analysis",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 8,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 4, 2018",
    "Current Ver": "1.1 Build 226",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "R Programming Language",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 39,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 21, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "R Programming",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 21, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "R. Physics Puzzle Game",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 5369,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 19, 2018",
    "Current Ver": "1.0.16",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "R Instructor",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 135,
    Size: "4.9M",
    Type: "Paid",
    Price: "$4.84",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 21, 2014",
    "Current Ver": 2.03,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "GT-R R35 Drift Simulator",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 1852,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "October 31, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Offroad Pickup Truck R",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 6367,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 14, 2017",
    "Current Ver": 1.4,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Learn R Programming Full",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 11,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "January 30, 2018",
    "Current Ver": 1.5,
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "R Programming Tutorial",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 5,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 14, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "R Programing Offline Tutorial",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 5,
    Reviews: 4,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "March 15, 2018",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Learn R Language Easy Way",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 17,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 24, 2017",
    "Current Ver": 1.22,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: ".R",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 259,
    Size: "203k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 16, 2014",
    "Current Ver": "1.1.06",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "R-TYPE II",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 5682,
    Size: "37M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "March 2, 2017",
    "Current Ver": "1.1.5",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Guide for R Programming",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.0.0",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "R Programming Solution",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 169,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 20, 2016",
    "Current Ver": "1.0.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Learn R - Programming Concepts",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 6,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 25, 2017",
    "Current Ver": "1.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Learn R Programming",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "April 28, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Car Parking Nissan GT-R R35 Simulator",
    Category: "FAMILY",
    Rating: 3.2,
    Reviews: 513,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "December 5, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "R Quick Reference Big Data",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 6,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 29, 2017",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Learn R Programming Free EBook",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 23, 2018",
    "Current Ver": "1.0.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "RMEduS - 음성인식을 활용한 R 프로그래밍 실습 시스템",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 4,
    Size: "64M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.0.1",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "R Programming Language (Paperset 2) MCQ Quiz",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 19, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "R-net for Android",
    Category: "PRODUCTIVITY",
    Rating: 3.3,
    Reviews: 48,
    Size: "58k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 7, 2013",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "R File Manager",
    Category: "TOOLS",
    Rating: 4.8,
    Reviews: 17,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 5, 2018",
    "Current Ver": "v2",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "R-TYPE",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 7687,
    Size: "23M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "February 27, 2017",
    "Current Ver": "2.3.1",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "R Studio",
    Category: "SHOPPING",
    Rating: 3.7,
    Reviews: 23,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 8, 2016",
    "Current Ver": "2.1.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Day R Premium",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 51068,
    Size: "57M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "June 21, 2018",
    "Current Ver": 1.574,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Join R, Community Engagement",
    Category: "SOCIAL",
    Rating: 4.7,
    Reviews: 144,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "January 31, 2017",
    "Current Ver": "1.0.12",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "R Bank",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 90,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 30, 2018",
    "Current Ver": "5.9.1.0",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "Elemental Knights R Platinum",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 2925,
    Size: "93M",
    Type: "Paid",
    Price: "$4.77",
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "August 1, 2018",
    "Current Ver": "6.2.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Wonder5 Masters R",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 1655,
    Size: "83M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.1.52",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Neon-R (Red)",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 25,
    Size: "41M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 12, 2015",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Mat|r viewer",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 5,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.0.5",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "R. Lee Ermey's Official Sound",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1696,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "September 19, 2012",
    "Current Ver": 1.4,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Tutorials for R Programming Offline",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 4, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "R Programming Language (Paperset 1) MCQ Quiz",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 19, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "SHAREit - Transfer & Share",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 7775146,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": "4.5.28_ww",
    numInstall: 500000000,
    numAndroid: 4,
  },
  {
    App: "S Launcher for Galaxy TouchWiz",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 11244,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 12, 2018",
    "Current Ver": "1.1.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "360 Security - Free Antivirus, Booster, Cleaner",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 16771865,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "S Player - Lightest and Most Powerful Video Player",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 14224,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 12, 2017",
    "Current Ver": "1.0.98_ww",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Offroad Pickup Truck S",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 5178,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "October 10, 2017",
    "Current Ver": 1.7,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "S Launcher Pro for Galaxy",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 47,
    Size: "26k",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "February 12, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Type S LED",
    Category: "LIFESTYLE",
    Rating: 3.5,
    Reviews: 628,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 14, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "S Note",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 12435,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "September 26, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 6,
  },
  {
    App: "S Photo Editor - Collage Maker , Photo Collage",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 972574,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 3, 2018",
    "Current Ver": 2.31,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Stupid Zombies",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 464900,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "June 27, 2018",
    "Current Ver": "2.0.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "S’more - Earn Cash Rewards",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 15097,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.6.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "PitchBlack S - Samsung Substratum Theme “For Oreo”",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 90,
    Size: "37M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 4, 2018",
    "Current Ver": 12.6,
    numInstall: 1000,
    numAndroid: 7,
  },
  {
    App: "Samsung Smart Switch Mobile",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 146913,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 18, 2018",
    "Current Ver": "3.5.02.15",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "S S9 Launcher - Galaxy S8/S9 Launcher, theme, cool",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 22503,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 6, 2018",
    "Current Ver": 4.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Five Nights at Freddy's 2 Demo",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1503544,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "November 15, 2014",
    "Current Ver": 1.07,
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "Crime Wars S. Andreas",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 5785,
    Size: "93M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Racing",
    "Last Updated": "April 12, 2017",
    "Current Ver": 1.2,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "S Pen Keeper",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 560,
    Size: "314k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 8, 2018",
    "Current Ver": "2.1.0.032",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "SH Script Runner",
    Category: "PRODUCTIVITY",
    Rating: 3.9,
    Reviews: 334,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 2, 2018",
    "Current Ver": 1.07,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "City Taxi Driver sim 2016: Cab simulator Game-s",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 16111,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 12, 2018",
    "Current Ver": 1.11,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Shopping List S PRO",
    Category: "SHOPPING",
    Rating: 4.8,
    Reviews: 14,
    Size: "2.7M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "May 16, 2018",
    "Current Ver": 2.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Tumblr",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 2953886,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Tinder",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 2789775,
    Size: "68M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Lifestyle",
    "Last Updated": "August 2, 2018",
    "Current Ver": "9.5.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Topbuzz: Breaking News, Videos & Funny GIFs",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.7,
    Reviews: 174827,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "News & Magazines",
    "Last Updated": "August 4, 2018",
    "Current Ver": "6.7.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Twitch: Livestream Multiplayer Games & Esports",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 2133047,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "T-Mobile",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 482630,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Dino T-Rex",
    Category: "GAME",
    Rating: 4,
    Reviews: 69115,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "June 13, 2018",
    "Current Ver": 1.36,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Telegram",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 3128611,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Communication",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "myAT&T",
    Category: "PRODUCTIVITY",
    Rating: 3.7,
    Reviews: 80816,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 5,
  },
  {
    App: "AT&T U-verse",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 38606,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 13, 2018",
    "Current Ver": "5.9.0.0031",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AT&T Messages for Tablet",
    Category: "COMMUNICATION",
    Rating: 3.3,
    Reviews: 3044,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 3, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "T Uploader",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 75,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 24, 2017",
    "Current Ver": "0.1.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "T-Mobile DIGITS",
    Category: "COMMUNICATION",
    Rating: 3,
    Reviews: 1820,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "February 15, 2018",
    "Current Ver": "1.1.50",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AT&T Digital Life",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 10067,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 7, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "DIRECTV Remote App",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 480,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 31, 2017",
    "Current Ver": 2.4,
    numInstall: 1000000,
    numAndroid: 6,
  },
  {
    App: "AT&T Smart Limits℠",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 2300,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 7, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "T-Mobile Tuesdays",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 53144,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 13, 2018",
    "Current Ver": "4.8.0",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Truecaller: Caller ID, SMS spam blocking & Dialer",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 7820775,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "AT&T Mobile Transfer",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 22775,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.8.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "T-Mobile Content Transfer",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 370,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 25, 2018",
    "Current Ver": "2.1.5",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "T-Mobile Visual Voicemail",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 41502,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "I Can't Wake Up!",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 963,
    Size: "3.7M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 25, 2018",
    "Current Ver": "3.4.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AT&T FamilyMap®",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 21592,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 24, 2017",
    "Current Ver": "10.1.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "T-Mobile® FamilyMode™",
    Category: "PARENTING",
    Rating: 3.1,
    Reviews: 103,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "June 29, 2018",
    "Current Ver": "1.0.2-alpha4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Portable Wi-Fi hotspot",
    Category: "COMMUNICATION",
    Rating: 3.9,
    Reviews: 138129,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 6, 2018",
    "Current Ver": "1.5.2.4-23",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Showtime Anytime",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 18522,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "AT&T Call Protect",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 6454,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 3, 2018",
    "Current Ver": "1.5.13-3598",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Don't Starve: Pocket Edition",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 17988,
    Size: "7.9M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "July 25, 2018",
    "Current Ver": 1.06,
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Please, Don't Touch Anything",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 1771,
    Size: "46M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Teen",
    Genres: "Puzzle",
    "Last Updated": "April 20, 2016",
    "Current Ver": "1.1.0",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "AT&T DriveMode",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.3,
    Reviews: 8465,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "May 3, 2018",
    "Current Ver": "1.0.4.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "The T Factor",
    Category: "EVENTS",
    Rating: 4.8,
    Reviews: 48,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "September 26, 2017",
    "Current Ver": 8.8,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Please Don't Touch Anything 3D",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 146,
    Size: "20M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Teen",
    Genres: "Puzzle",
    "Last Updated": "December 7, 2016",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Don't Panic with Andrew J.",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 124,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 25, 2015",
    "Current Ver": "Varies with device",
    numInstall: 5000,
    numAndroid: null,
  },
  {
    App: "Don't touch my phone",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 21943,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 19, 2016",
    "Current Ver": 30,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Don't Starve: Shipwrecked",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 1468,
    Size: "4.9M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "July 10, 2018",
    "Current Ver": 0.16,
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Ludo - Don't get angry",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 131,
    Size: "23M",
    Type: "Paid",
    Price: "$1.61",
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "February 24, 2016",
    "Current Ver": "1.6.3",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Jurassic Life: T Rex Simulator",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1088,
    Size: "35M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone 10+",
    Genres: "Simulation",
    "Last Updated": "August 19, 2014",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "T-Mobile SyncUP DRIVE",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4,
    Reviews: 1981,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.15.1.4",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "T-shirt design - Snaptee",
    Category: "LIFESTYLE",
    Rating: 4.2,
    Reviews: 29756,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.1.6.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "MBTA GPS - Track the T",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.8,
    Reviews: 82,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "February 23, 2018",
    "Current Ver": "5.1.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "T. Rowe Price Personal® App",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 1057,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 6, 2018",
    "Current Ver": 1.7,
    numInstall: 50000,
    numAndroid: 6,
  },
  {
    App: "Můj T-Mobile Business",
    Category: "PRODUCTIVITY",
    Rating: 3.7,
    Reviews: 10490,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 24, 2018",
    "Current Ver": "3.1.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "U by BB&T",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 16600,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 19, 2018",
    "Current Ver": "1.7.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "U LIVE – Video Chat & Stream",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 67611,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "April 23, 2018",
    "Current Ver": "263.16.29",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "U - Webinars, Meetings & Messenger",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 6601,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 2, 2018",
    "Current Ver": "4.7.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Hollywood U: Rising Stars",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 233588,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "April 21, 2017",
    "Current Ver": "3.8.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "U-Dictionary: Best English Learning Dictionary",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 166886,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Education",
    "Last Updated": "July 29, 2018",
    "Current Ver": "3.6.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Ustream",
    Category: "VIDEO_PLAYERS",
    Rating: 4,
    Reviews: 93638,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Video Players & Editors",
    "Last Updated": "July 11, 2018",
    "Current Ver": "3.2.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "UC Browser Mini -Tiny Fast Private & Secure",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 3648765,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "July 18, 2018",
    "Current Ver": "11.4.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Uber",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 4921866,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "ENCHANT U",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 83977,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "November 8, 2012",
    "Current Ver": "1.2.2",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "/u/app",
    Category: "COMMUNICATION",
    Rating: 4.7,
    Reviews: 573,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Communication",
    "Last Updated": "July 3, 2018",
    "Current Ver": "4.2.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Kicker U",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 124,
    Size: "37M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 13, 2018",
    "Current Ver": 3.04,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "U-Haul",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.2,
    Reviews: 852,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.2.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Vienna U-Bahn",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.9,
    Reviews: 139,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.21.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Kicker U Lite",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 438,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 27, 2013",
    "Current Ver": "2.0.0",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "U-Scan",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 784,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 29, 2016",
    "Current Ver": "1.2.6 (94)",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Octo U: Your driving companion",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3,
    Reviews: 331,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "March 13, 2018",
    "Current Ver": "1.1.47",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "I Love U Theme&Emoji Keyboard",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 655,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 8, 2018",
    "Current Ver": 4.3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Channel U",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 34,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 21, 2018",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Parallel U - App Cloner, Duals APP, tarallel",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 3315,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 15, 2018",
    "Current Ver": "1.0.24",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "U Pull It Auto Dismantler",
    Category: "BUSINESS",
    Rating: 3.1,
    Reviews: 71,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 14, 2013",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "Wii U Simulator",
    Category: "FAMILY",
    Rating: 3.4,
    Reviews: 1178,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Simulation",
    "Last Updated": "April 8, 2018",
    "Current Ver": "1.0.1",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "U Camera : Phone 6s OS 9 style",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 2158,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 28, 2017",
    "Current Ver": "1.0.3",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "U get - Wireless Speed Test",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 26,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 4, 2018",
    "Current Ver": "1.3.5",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "U Guard",
    Category: "TOOLS",
    Rating: 3,
    Reviews: 245,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 31, 2016",
    "Current Ver": "1.1.6.6",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "DRC Sim - Wii U Gamepad",
    Category: "FAMILY",
    Rating: 2.4,
    Reviews: 210,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "June 25, 2017",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "See U - Random video chat, video chat",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 568,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "April 13, 2018",
    "Current Ver": "1.4.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "[verify-U] VideoIdent",
    Category: "COMMUNICATION",
    Rating: 2.9,
    Reviews: 83,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 26, 2018",
    "Current Ver": "2.4.0",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "What U See",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 712,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "March 5, 2018",
    "Current Ver": "2.3.9",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "U Assist - Screen Mirroring & Sharing App",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 198,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 26, 2017",
    "Current Ver": "2.0.16",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "U+Box",
    Category: "PRODUCTIVITY",
    Rating: 3.8,
    Reviews: 24517,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 23, 2018",
    "Current Ver": "4.2.17",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Wi u Emulator",
    Category: "FAMILY",
    Rating: 2.4,
    Reviews: 468,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 3, 2018",
    "Current Ver": "0.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Waiting For U Launcher Theme",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 5599,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 23, 2016",
    "Current Ver": "2.0.40",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "U of I Community Credit Union",
    Category: "FINANCE",
    Rating: 3.7,
    Reviews: 52,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 4, 2018",
    "Current Ver": "4.16.10",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "U-Report",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 241,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "April 10, 2018",
    "Current Ver": "2.8.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Meet U - Get Friends for Snapchat, Kik & Instagram",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 4435,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.0.3386",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "U-Craft Mobile",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 11404,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "September 11, 2017",
    "Current Ver": "1.0.14",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Alarmy (Sleep If U Can) - Pro",
    Category: "LIFESTYLE",
    Rating: 4.8,
    Reviews: 10249,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "U-Disco",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 906,
    Size: "196k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 5, 2014",
    "Current Ver": "1.7.3",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "SAY-U",
    Category: "FAMILY",
    Rating: 3.2,
    Reviews: 1011,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Be U Salons Hair-Beauty Deals In Delhi & Bangalore",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 889,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.1.4.38",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "U-48 Submarine Commander Free",
    Category: "GAME",
    Rating: 3.5,
    Reviews: 4575,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "October 7, 2017",
    "Current Ver": 1.24,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Berlin Subway – BVG U-Bahn & S-Bahn map and routes",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.4,
    Reviews: 509,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.0.7",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Remote For ATT U-verse TV - NOW FREE",
    Category: "TOOLS",
    Rating: 2.5,
    Reviews: 20,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.1.5",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Pocket U ASW",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 93,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 25, 2018",
    "Current Ver": "3.0.6",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "V LIVE - Star Live App",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 397147,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Identity V",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 109263,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 10, 2018",
    "Current Ver": "1.0.144431",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "VMate",
    Category: "VIDEO_PLAYERS",
    Rating: 4.2,
    Reviews: 192677,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1.78,
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "V Made",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.3,
    Reviews: 241,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "February 13, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Grand Theft Auto V: The Manual",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 182103,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 31, 2018",
    "Current Ver": "5.0.12",
    numInstall: 5000000,
    numAndroid: 3,
  },
  {
    App: "Viber Messenger",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 11335481,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "V for Voodoo",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 16876,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Trivia",
    "Last Updated": "June 28, 2018",
    "Current Ver": "3.0.1",
    numInstall: 1000000,
    numAndroid: 6,
  },
  {
    App: "Sin City Crime Simulator V - Gangster",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 2113,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "April 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "The Gang Sniper V. Pocket Edition.",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 6121,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "June 20, 2018",
    "Current Ver": 2.1,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Vimeo",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 85578,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "VLC for Android",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 1031045,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "All Video Downloader",
    Category: "VIDEO_PLAYERS",
    Rating: 3.8,
    Reviews: 165723,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 4, 2018",
    "Current Ver": "7.5.9",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Vault-Hide SMS,Pics & Videos,App Lock,Cloud backup",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 984451,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "VidPlay",
    Category: "VIDEO_PLAYERS",
    Rating: 4.2,
    Reviews: 3546,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "May 27, 2018",
    "Current Ver": "2.0.19",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "HD Video Downloader : 2018 Best video mate",
    Category: "VIDEO_PLAYERS",
    Rating: 3.7,
    Reviews: 430643,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "May 31, 2018",
    "Current Ver": "2.5.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Vigo Video",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 1615418,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "V-CUBE Seminar Mobile",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 542,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 17, 2018",
    "Current Ver": "1.23.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "VivaVideo - Video Editor & Photo Movie",
    Category: "VIDEO_PLAYERS",
    Rating: 4.6,
    Reviews: 9879473,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "August 4, 2018",
    "Current Ver": "7.2.1",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Mod GTA V for MCPE",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 4288,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 23, 2018",
    "Current Ver": "1.2.3.4.5",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Vi Trainer",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.6,
    Reviews: 124,
    Size: "100M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.0.0.11",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "San Andreas: Gang Crime V",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 2399,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "January 28, 2018",
    "Current Ver": "1.0.1",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "The Grand Bike V",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 3478,
    Size: "95M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "February 24, 2018",
    "Current Ver": 4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "V.360° Camera",
    Category: "PHOTOGRAPHY",
    Rating: 3.3,
    Reviews: 582,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "September 11, 2015",
    "Current Ver": "1.1.6",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "FINAL FANTASY V",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 15924,
    Size: "4.2M",
    Type: "Paid",
    Price: "$7.99",
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "March 15, 2017",
    "Current Ver": "1.2.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BTS V LINE Launcher theme",
    Category: "PERSONALIZATION",
    Rating: 4.8,
    Reviews: 3283,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "October 17, 2014",
    "Current Ver": 4.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "VideoShow-Video Editor, Video Maker, Beauty Camera",
    Category: "VIDEO_PLAYERS",
    Rating: 4.6,
    Reviews: 4016834,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "FORD V SERIES CALC - NO LIMIT",
    Category: "AUTO_AND_VEHICLES",
    Rating: "NaN",
    Reviews: 2,
    Size: "17M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "June 25, 2018",
    "Current Ver": "3.0.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "VMate Lite - Funny Short Videos Social Network",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 903,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1.76,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Mirk V Launcher Theme",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 292,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 15, 2017",
    "Current Ver": "v1.0.50",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Mike V: Skateboard Party PRO",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 2506,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "January 23, 2017",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "The grand theft V Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 3.8,
    Reviews: 87,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Personalization",
    "Last Updated": "June 5, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "V Bucks ProTips New",
    Category: "SOCIAL",
    Rating: 4.7,
    Reviews: 594,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 19, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Cheats for GTA V",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 450,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 29, 2018",
    "Current Ver": 6,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "V for Vampire - Free",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 2772,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Puzzle",
    "Last Updated": "September 20, 2014",
    "Current Ver": "1.0.1",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Get Free V-bucks_fortnite Hints",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 1997,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 21, 2018",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "V BTS Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 127,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 4, 2018",
    "Current Ver": 8,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "v-view",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 309,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 22, 2017",
    "Current Ver": "1.1.0.0402",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Mental Hospital V",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 2460,
    Size: "25M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "November 19, 2016",
    "Current Ver": 1.04,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Grand Stickman Cover V",
    Category: "GAME",
    Rating: 4,
    Reviews: 1744,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "May 19, 2018",
    "Current Ver": "1.0.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Cheat Codes for GTA V",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 589,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "September 3, 2017",
    "Current Ver": "1.8.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DRAGON QUEST V",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 1667,
    Size: "17M",
    Type: "Paid",
    Price: "$14.99",
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.0.3",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "WeChat",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 5387631,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Easy V-Bux free",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 856,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 17, 2018",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "BTS V Kim Taehyung Wallpapers Kpop HD New",
    Category: "PERSONALIZATION",
    Rating: 4.8,
    Reviews: 51,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 10, 2018",
    "Current Ver": "1.1.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Wattpad 📖 Free Books",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 2915189,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "W Pro - Weather Forecast & Animated Weather Maps",
    Category: "WEATHER",
    Rating: 3.8,
    Reviews: 11,
    Size: "2.9M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "April 23, 2018",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Waze - GPS, Maps, Traffic Alerts & Live Navigation",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.6,
    Reviews: 7231017,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Dating App, Flirt & Chat : W-Match",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 175523,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "W - Weather Forecast & Animated Radar Maps",
    Category: "WEATHER",
    Rating: 4.2,
    Reviews: 29,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "April 23, 2018",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "WPS Office - Word, Docs, PDF, Note, Slide & Sheet",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 1507205,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 30, 2018",
    "Current Ver": "11.1.3",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "W-History Standalone",
    Category: "SOCIAL",
    Rating: 3.2,
    Reviews: 38,
    Size: "1.5M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "March 9, 2018",
    "Current Ver": 1.935,
    numInstall: 1000,
    numAndroid: 7,
  },
  {
    App: "Words With Friends Classic",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1704112,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "July 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Fantasy Squad W",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 2142,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "April 16, 2018",
    "Current Ver": "1.5.4",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "LINE WEBTOON - Free Comics",
    Category: "COMICS",
    Rating: 4.5,
    Reviews: 1013944,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Weather & Clock Widget for Android",
    Category: "WEATHER",
    Rating: 4.4,
    Reviews: 2371543,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "June 4, 2018",
    "Current Ver": "5.9.4.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "W Box VMS",
    Category: "VIDEO_PLAYERS",
    Rating: 1.9,
    Reviews: 105,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "January 9, 2017",
    "Current Ver": "4.0.4",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "WhatsApp Business",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 137144,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 30, 2018",
    "Current Ver": "2.18.116",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "W Box VMS HD",
    Category: "VIDEO_PLAYERS",
    Rating: 2.5,
    Reviews: 24,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "January 4, 2017",
    "Current Ver": "4.0.3",
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "Ace Screen Recorder w facecam",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 2447,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 26, 2017",
    "Current Ver": 1.19,
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "WIFI WPS WPA TESTER",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 352097,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 12, 2018",
    "Current Ver": "3.8.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Flashlight Free w/ compass",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 75,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 15, 2017",
    "Current Ver": 2.5,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "App Lock: Locker w/ fingerprint, Parental Control",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 37607,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "IRS W-9 form",
    Category: "BUSINESS",
    Rating: 4.8,
    Reviews: 492,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.7.11",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Open in WhatsApp (click to chat)",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 12121,
    Size: "79k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 1, 2018",
    "Current Ver": 1.12,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "B & W Filter for Photo Editor Pro",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 65,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 2, 2018",
    "Current Ver": "1.0.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "WowBox",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 101957,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "April 23, 2018",
    "Current Ver": "2.11.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Zaatar w Zeit",
    Category: "FOOD_AND_DRINK",
    Rating: 4.4,
    Reviews: 205,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 1, 2018",
    "Current Ver": "2.2.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "WPSApp",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 95080,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.6.22",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "WhatsCall Free Global Phone Call App & Cheap Calls",
    Category: "COMMUNICATION",
    Rating: 4.6,
    Reviews: 1130966,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.9.1.013",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Dictionary - WordWeb",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 124970,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "May 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Profile w/o crop for Telegram",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 348,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "April 11, 2014",
    "Current Ver": "3.1.50",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "We Heart It",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 637254,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "weather HD",
    Category: "PERSONALIZATION",
    Rating: 4,
    Reviews: 1546,
    Size: "4.5M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "February 26, 2014",
    "Current Ver": 3.1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "TripAdvisor Hotels Flights Restaurants Attractions",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 1162331,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Draw Something Classic",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 1092106,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "July 28, 2018",
    "Current Ver": "2.400.022",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "X-VPN - Free Unlimited VPN Proxy",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 40617,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": 65,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Telegram X",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 70449,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Share Music & Transfer Files - Xender",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 1279109,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "X Launcher: With OS11 Style Theme & Control Center",
    Category: "ART_AND_DESIGN",
    Rating: 4.7,
    Reviews: 5754,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "July 30, 2018",
    "Current Ver": "2.1.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Phone X Launcher, OS 11 iLauncher & Control Center",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 54063,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 1, 2018",
    "Current Ver": "2.7.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Lock Screen Phone X Style OS 11",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 1166,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 26, 2018",
    "Current Ver": 8.8,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Nose Doctor X: Booger Mania",
    Category: "FAMILY",
    Rating: 3.2,
    Reviews: 37584,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "August 31, 2016",
    "Current Ver": "1.0.8",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Control Center iOS 11 - Phone X Control Panel",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 1925,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 15, 2017",
    "Current Ver": 3.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "X Browser",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 142,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "December 31, 2017",
    "Current Ver": "1.1.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "X Launcher Pro: PhoneX Theme, OS11 Control Center",
    Category: "ART_AND_DESIGN",
    Rating: 4.7,
    Reviews: 801,
    Size: "3.5M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "July 30, 2018",
    "Current Ver": "2.1.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "X-plore File Manager",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 168487,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 26, 2018",
    "Current Ver": "4.01.00",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Flashlight X",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 20418,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 8, 2018",
    "Current Ver": 4.54,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "iSwipe Phone X",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 58366,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 7, 2017",
    "Current Ver": 1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "X Launcher Pro - IOS Style Theme & Control Center",
    Category: "ART_AND_DESIGN",
    Rating: 4.8,
    Reviews: 1216,
    Size: "8.6M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "June 26, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "X Home Bar - Free",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 4210,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 18, 2018",
    "Current Ver": "1.5.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "[ROOT] X Privacy Installer",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 12147,
    Size: "118k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 25, 2015",
    "Current Ver": 1.18,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Extreme X Ray Robot Stunts",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 10806,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "May 9, 2017",
    "Current Ver": "1.5.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Xray Scanner Prank",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 355837,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 7, 2016",
    "Current Ver": 14,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "X Launcher Prime: With OS Style Theme & No Ads",
    Category: "ART_AND_DESIGN",
    Rating: 4.7,
    Reviews: 149,
    Size: "3.5M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.2.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "The X-Files: Deep State - Hidden Object Adventure",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 22018,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "July 18, 2018",
    "Current Ver": "2.6.1",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Theme for Iphone X Plus",
    Category: "PERSONALIZATION",
    Rating: 4,
    Reviews: 126,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "October 19, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Casino X - Free Online Slots",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 30515,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "May 22, 2018",
    "Current Ver": 2.92,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "X-WOLF",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 4878,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Adventure",
    "Last Updated": "February 2, 2018",
    "Current Ver": "1.2.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Light X - Icon Pack",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 252,
    Size: "24M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 13, 2018",
    "Current Ver": "1.6.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "X-Plane 10 Flight Simulator",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 63197,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Anime X Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 32613,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 31, 2018",
    "Current Ver": 3.11,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "NEW Theme for Phone X",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 8642,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.1.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "X-Plane to GPS",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 161,
    Size: "1.2M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 4, 2018",
    "Current Ver": 1.62,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Control Center iOS 11 - Phone X notifications",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 514,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 12, 2018",
    "Current Ver": 1.8,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "iLocker X - iOS11 Lockscreen with HD Wallpapers",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 1714,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 19, 2018",
    "Current Ver": "1.4.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "iLauncher OS 12 Pro - Phone X",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 3,
    Size: "9.6M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 24, 2018",
    "Current Ver": "1.0.1",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Hero Fighter X",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 24210,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "November 13, 2015",
    "Current Ver": 1.091,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Slendrina X",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 12736,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "December 18, 2017",
    "Current Ver": 1.02,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "X Back - Icon Pack",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 56,
    Size: "26M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 29, 2018",
    "Current Ver": "1.6.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Guide (for X-MEN)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 586,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 8, 2017",
    "Current Ver": "1.1.1",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Decibel X PRO - Sound Meter dBA, Noise Detector",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 60,
    Size: "6.9M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 11, 2018",
    "Current Ver": "4.4.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Flight Simulator X 2016 Free",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 44636,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "January 23, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Robocar X Ray",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 3432,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "January 23, 2017",
    "Current Ver": 1,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Space X: Sky Wars of Air Force",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 10748,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "August 4, 2018",
    "Current Ver": 4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "OS-X EMUI 4/5/8 THEME",
    Category: "PERSONALIZATION",
    Rating: 3.9,
    Reviews: 916,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "February 5, 2018",
    "Current Ver": 5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Flexiroam X",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4,
    Reviews: 875,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.5.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "X-ray scanner simulator",
    Category: "FAMILY",
    Rating: 2.7,
    Reviews: 1616,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "January 8, 2017",
    "Current Ver": 7,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "X Construction",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 18612,
    Size: "8.5M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 28, 2015",
    "Current Ver": 1.57,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "X Home Bar - Home Bar Gesture Pro",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 88,
    Size: "2.0M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 2, 2018",
    "Current Ver": 1.5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "PLAYBULB X",
    Category: "LIFESTYLE",
    Rating: 2.9,
    Reviews: 2160,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 25, 2018",
    "Current Ver": "1.6.5",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "X-Wing Squadron Builder",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 5898,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 1, 2017",
    "Current Ver": "3.3.8.03082017",
    numInstall: 100000,
    numAndroid: 1,
  },
  {
    App: "YouTube TV - Watch & Record Live TV",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 38517,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.29.2",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Yandex Browser with Protect",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 1235841,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "JW Caleb y Sofia",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 5227,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 20, 2015",
    "Current Ver": 1,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Boomerang Make and Race",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 281448,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "June 1, 2018",
    "Current Ver": "1.5.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "YouTube Studio",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 436170,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "June 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Talking Tom & Ben News",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 1131937,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 30, 2018",
    "Current Ver": "2.4.0.7",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Vegas Crime Simulator",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 721646,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "August 2, 2018",
    "Current Ver": 2.7,
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "PewDiePie's Tuber Simulator",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 1499466,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.25.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Yahoo Mail – Stay Organized",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 4188345,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 18, 2018",
    "Current Ver": "5.29.3",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Real Gangster Crime",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 285814,
    Size: "84M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 26, 2018",
    "Current Ver": 3.5,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Antivirus & Mobile Security",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 351267,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 9, 2018",
    "Current Ver": "3.1.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Flashlight Ultimate",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 16936,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 25, 2018",
    "Current Ver": 2.94,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "PBS KIDS Video",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 36214,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Music & Video",
    "Last Updated": "July 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "YouTube Gaming",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 130549,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 27, 2018",
    "Current Ver": "2.08.78.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Gangster Town",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 74842,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "December 22, 2016",
    "Current Ver": 1.7,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Rope Hero 3",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 45871,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "May 8, 2017",
    "Current Ver": 1.6,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Avast Mobile Security 2018 - Antivirus & App Lock",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 5180480,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 1, 2018",
    "Current Ver": "6.11.4",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "GO Keyboard - Emoticon keyboard, Free Theme, GIF",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 2591610,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "NQ Mobile Security & Antivirus",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 427185,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Productivity",
    "Last Updated": "June 8, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "yHomework - Math Solver",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 50771,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 12, 2016",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "GO Launcher - 3D parallax Themes & HD Wallpapers",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 7464996,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Z Origins - (Z The Game)",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 4421,
    Size: "37M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "November 5, 2014",
    "Current Ver": 1.77,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "ZArchiver",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 337242,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Zapya - File Transfer, Sharing",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 387958,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Tools",
    "Last Updated": "July 16, 2018",
    "Current Ver": "5.6.2 (US)",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Experiment Z - Zombie",
    Category: "GAME",
    Rating: 4,
    Reviews: 229329,
    Size: "88M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "December 4, 2017",
    "Current Ver": 2.14,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "War Z 2",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 97071,
    Size: "87M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "April 3, 2018",
    "Current Ver": "0.1.219",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Last Empire - War Z: Strategy",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 853495,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.0.208",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Z Day: Hearts of Heroes",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 5894,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.0.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Z Champions",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 96028,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "May 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Zello PTT Walkie Talkie",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 695576,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "CPU-Z",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 295430,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 17, 2018",
    "Current Ver": 1.26,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "WithstandZ - Zombie Survival!",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 121612,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "December 28, 2017",
    "Current Ver": "1.0.6.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Z Camera - Photo Editor, Beauty Selfie, Collage",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 1075016,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Photography",
    "Last Updated": "August 3, 2018",
    "Current Ver": 4.21,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Empire Z: Endless War",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 367951,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "July 16, 2018",
    "Current Ver": "2.2.8",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Zombie War Z : Hero Survival Rules",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 1987,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "December 13, 2017",
    "Current Ver": 1.8,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DRAGON BALL Z DOKKAN BATTLE",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 650114,
    Size: "80M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 3, 2018",
    "Current Ver": "3.11.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Moto Z Market",
    Category: "TOOLS",
    Rating: 2.2,
    Reviews: 605,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 18, 2017",
    "Current Ver": "02.02.0045",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Cube Z (Pixel Zombies)",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 41444,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 31, 2016",
    "Current Ver": "1.0.11",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Z War-Zombie Modern Combat",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 62301,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "August 1, 2018",
    "Current Ver": 1.6,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Z App",
    Category: "LIFESTYLE",
    Rating: 2.8,
    Reviews: 405,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 22, 2018",
    "Current Ver": "4.2.45",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "GALAK-Z: Variant Mobile",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 145,
    Size: "79M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.7.6",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Z City",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 3976,
    Size: "98M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "January 29, 2018",
    "Current Ver": "1.1.6",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Space Z 🌏 🚀Icon Pack Theme",
    Category: "PERSONALIZATION",
    Rating: 4.8,
    Reviews: 201,
    Size: "68M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.2.7",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Reload: The Z-Team",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1655,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "February 28, 2018",
    "Current Ver": "1.6.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Rage Z: Multiplayer Zombie FPS Online Shooter",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 11258,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "December 8, 2016",
    "Current Ver": 1.25,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Pixel Z Gunner 3D - Battle Survival Fps",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 11408,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 6, 2018",
    "Current Ver": 4.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Saiyan Z: Super SSJ Ultimate Combat",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 306,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "April 18, 2018",
    "Current Ver": "2.0.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Mini DAYZ: Zombie Survival",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 94661,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 8, 2018",
    "Current Ver": "1.4.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Z-Empire: Dead Strike",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 99,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "June 8, 2018",
    "Current Ver": "1.8.7",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Free Z Glass GO Keyboard Theme",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 71829,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 30, 2017",
    "Current Ver": 4.16,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Avengers:(Dreamsky)Stickman War Z",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 13604,
    Size: "96M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 26, 2018",
    "Current Ver": "2.4.4",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Z Camera",
    Category: "PHOTOGRAPHY",
    Rating: 3.8,
    Reviews: 142,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "April 8, 2016",
    "Current Ver": 1.8,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "ZArchiver Donate",
    Category: "TOOLS",
    Rating: 4.8,
    Reviews: 1721,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.50",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "Cardio Z",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 24,
    Size: "10M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 13, 2017",
    "Current Ver": "1.0.2.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "GO SMS Pro Z Glass Theme EX",
    Category: "PERSONALIZATION",
    Rating: 3.8,
    Reviews: 24198,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 10, 2014",
    "Current Ver": 1,
    numInstall: 1000000,
    numAndroid: 1,
  },
  {
    App: "Route Z",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 24697,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 10, 2015",
    "Current Ver": 1.5,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Z PIVOT",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.7M",
    Type: "Paid",
    Price: "$19.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 11, 2018",
    "Current Ver": 1.3,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Dragon X Adventure: Warrior Z",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 8537,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "November 3, 2015",
    "Current Ver": "1.1.4",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Ultimate Fighter Z",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 180,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 16, 2018",
    "Current Ver": 2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Theme eXp - Black Z Light",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 29540,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 15, 2016",
    "Current Ver": 2,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Toy Battle Z",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 133,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.0.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Wave Z Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 63699,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "September 21, 2015",
    "Current Ver": "1.1.6",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Six Pack in 30 Days - Abs Workout",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.9,
    Reviews: 272172,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 21, 2018",
    "Current Ver": "1.0.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "30 Day Ab Challenge",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 1886,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 21, 2016",
    "Current Ver": "3.2.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Angry Birds Blast",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 253115,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.6.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ab",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 10,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "October 27, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ultimate Ab & Core Workouts",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.7,
    Reviews: 55571,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "February 21, 2018",
    "Current Ver": 1.23,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Angry Birds Evolution",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 384602,
    Size: "88M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.21.1",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Angry Birds Match",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 227401,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.5.0",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Angry Birds POP Bubble Shooter",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 596628,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.39.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Abs Workout - Burn Belly Fat with No Equipment",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 69279,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.1.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "6 Pack Promise - Ultimate Abs",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 18921,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Angry Birds 2",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 3881752,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.21.1",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "AB Repeat Player",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 1628,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "March 6, 2018",
    "Current Ver": "4.1.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Abs, Core & Back Workout Challenge",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 3908,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "1.5.8",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AB Mobile App",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.4,
    Reviews: 2105,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 21, 2017",
    "Current Ver": "2.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Daily Ab Workout",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 2901,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 14, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Angry Birds Rio",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 2610328,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 3, 2018",
    "Current Ver": "2.6.9",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Angry Birds Epic RPG",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 2634605,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "July 18, 2018",
    "Current Ver": "3.0.27430.4799",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "A-B repeater",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 32,
    Size: "239k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "May 18, 2018",
    "Current Ver": 1.8,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "Daily Ab Workout - Core & Abs Fitness Exercises",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 44939,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 14, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Abs workout 7 minutes",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 37224,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Angry Birds Friends",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 829753,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "June 19, 2018",
    "Current Ver": "4.9.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "30 Day Ab Challenge FREE",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.3,
    Reviews: 48253,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "December 13, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "AB Blast Match 3",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 111,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "June 19, 2018",
    "Current Ver": 1.13,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AB Click2Shop",
    Category: "SHOPPING",
    Rating: 3.8,
    Reviews: 454,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 26, 2018",
    "Current Ver": "1.1.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Math games for kids : times tables - AB Math",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 2371,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "3.9.3",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "AB Crush Match 3",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 96,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "February 23, 2017",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "ABS Workout - Belly workout, 30 days AB",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 5103,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 13, 2018",
    "Current Ver": "2.0.5",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AB Match",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 9,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 19, 2018",
    "Current Ver": "1.0.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Math games for kids : times tables training",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 630,
    Size: "8.3M",
    Type: "Paid",
    Price: "$1.59",
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "3.9.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "7 minute abs workout - Daily Ab Workout",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 527,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "March 30, 2018",
    "Current Ver": 2.01,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AB Anywhere Mobile Banking",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 3,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 3, 2018",
    "Current Ver": "4.17.82",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "5 Minute Ab Workouts",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 2067,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "May 18, 2018",
    "Current Ver": "2.0.4",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Angry Birds Go!",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 3846378,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "May 30, 2018",
    "Current Ver": "2.8.2",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "AB Screen Recorder",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 533,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 2, 2017",
    "Current Ver": 2.8,
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Six Pack Abs Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 5967,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 2, 2017",
    "Current Ver": 2,
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Best Blood Type AB: Food Diet & Personality",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 3,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 11, 2018",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Angry Birds Star Wars",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1218055,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.5.12",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "30 Day AB Challenge - Lumowell",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 793,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "September 15, 2016",
    "Current Ver": "1.0.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Ab Workouts",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.1,
    Reviews: 27501,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "January 5, 2018",
    "Current Ver": "5.1.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ab Workouts - Ab Generator",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.7,
    Reviews: 21,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "December 31, 2016",
    "Current Ver": "2.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Chatime AB Rewards",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 9,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 22, 2018",
    "Current Ver": "2.7.0621",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Abs workout - 21 Day Fitness Challenge",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 18604,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "May 2, 2018",
    "Current Ver": "1.0.0.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ladies' Ab Workout FREE",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4,
    Reviews: 12906,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "October 8, 2012",
    "Current Ver": 1.01,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "30-Day Ab Challenge Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.5,
    Reviews: 224,
    Size: "371k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2014",
    "Current Ver": "1.2.6",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Universal AC Remote Control",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 40934,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 28, 2018",
    "Current Ver": "acremotecontrol18",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AC Freedom",
    Category: "BUSINESS",
    Rating: 3.5,
    Reviews: 537,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Smart Air Conditioner",
    Category: "TOOLS",
    Rating: 3.3,
    Reviews: 4786,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.2.84",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Assassin's Creed Identity",
    Category: "GAME",
    Rating: 3.7,
    Reviews: 42529,
    Size: "92M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "November 23, 2016",
    "Current Ver": "2.8.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "AC Remote Control",
    Category: "TOOLS",
    Rating: 3.3,
    Reviews: 472,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 17, 2017",
    "Current Ver": 1.3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Air conditioner remote control",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 29854,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 19, 2017",
    "Current Ver": 5,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Smart-AC Universal Remote Free",
    Category: "FAMILY",
    Rating: 1.8,
    Reviews: 3270,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 18, 2015",
    "Current Ver": 1,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "AC REMOTE UNIVERSAL-PRO",
    Category: "FAMILY",
    Rating: 1.6,
    Reviews: 402,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 11, 2015",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Kenmore Smart AC",
    Category: "LIFESTYLE",
    Rating: 1.9,
    Reviews: 71,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 8, 2017",
    "Current Ver": "1.0.11",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "AC WIFI",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 41,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 3, 2018",
    "Current Ver": "1.0.3",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "A/C Air Conditioner Remote",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 7816,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2016",
    "Current Ver": "1.1.1",
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Smart Air Conditioner(CAC)",
    Category: "TOOLS",
    Rating: 3.2,
    Reviews: 409,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.0.18",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Carrier Air Conditioner",
    Category: "TOOLS",
    Rating: 2.5,
    Reviews: 362,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 15, 2018",
    "Current Ver": "v67_slk3.0_20180115_01",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AC Troubleshooter",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 147,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 8, 2015",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "TOSHIBA Smart AC",
    Category: "TOOLS",
    Rating: 2.6,
    Reviews: 60,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 4, 2018",
    "Current Ver": "2.1.20180804_01",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Trane Interactive Smart AC",
    Category: "TOOLS",
    Rating: 2.8,
    Reviews: 48,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 21, 2016",
    "Current Ver": "0.0.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AC remote control mobile",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 3043,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 2, 2017",
    "Current Ver": "1.3 acremotecontrol",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AC Air condition Troubleshoot,Repair,Maintenance",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.2,
    Reviews: 27,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "February 7, 2018",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "AC Remote for Haier - NOW FREE",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 336,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": "6.1.7",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Air Conditioner Maintenance",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 11,
    Size: "220k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 27, 2015",
    "Current Ver": "airConditionerMaintenance_13112015",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "AC Remote for Daikin - NOW FREE",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 383,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": "6.1.7",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "A/C Universal Remote Control",
    Category: "TOOLS",
    Rating: 3.1,
    Reviews: 3263,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 16, 2017",
    "Current Ver": 1.17,
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "AC Remote for LG - NOW FREE",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 1041,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": "6.1.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Plug-in app (System AC)",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 126,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 8, 2017",
    "Current Ver": "v1.1072.35.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "LG AC Smart Diagnosis",
    Category: "LIFESTYLE",
    Rating: 3.4,
    Reviews: 377,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 21, 2017",
    "Current Ver": "1.1.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AC Remote for Midea - NOW FREE",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 448,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": "6.1.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Ac remote control",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 822,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 27, 2017",
    "Current Ver": 1.1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "A/C REFRIGERANT CAPACITY",
    Category: "BUSINESS",
    Rating: 1.7,
    Reviews: 84,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 28, 2014",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Remote Control For All AC - Universal Remote",
    Category: "PRODUCTIVITY",
    Rating: 2.4,
    Reviews: 166,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 28, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "All Type Ac Repair & Services",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 45,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 26, 2017",
    "Current Ver": 0.8,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AC - Tips & News for Android™",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.2,
    Reviews: 23291,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "May 24, 2018",
    "Current Ver": "3.1.12",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AC Remote Control Simulator",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 353,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 4, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Mi Remote controller - for TV, STB, AC and more",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 114340,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.7.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "AcDisplay",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 66473,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 30, 2015",
    "Current Ver": "3.8.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AC Mobile Control",
    Category: "HOUSE_AND_HOME",
    Rating: 3.4,
    Reviews: 1450,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "November 5, 2013",
    "Current Ver": 2.4,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "AC Remote For LG",
    Category: "TOOLS",
    Rating: 3,
    Reviews: 1298,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 20, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Universal AC Remote Control Simulator",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 119,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 22, 2017",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Hi-Smart AC",
    Category: "TOOLS",
    Rating: 2.2,
    Reviews: 32,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 3, 2018",
    "Current Ver": "1.1.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AC Remote for Sharp - NOW FREE",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 332,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": "6.1.7",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "AC Remote for Samsung - NOW FREE",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 566,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": "6.1.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Pocket AC",
    Category: "PHOTOGRAPHY",
    Rating: 4.8,
    Reviews: 130,
    Size: "4.4M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 27, 2018",
    "Current Ver": "3.1.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AC Remote for Carrier - NOW FREE",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 163,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": "6.1.7",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AC & TV, DVD, Set Top Box - Remote control IR",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 3632,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 13, 2017",
    "Current Ver": "11;11.26",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ac remote control",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 9514,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 11, 2018",
    "Current Ver": "acremotecontrol-v7",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Free Adblocker Browser - Adblock & Popup Blocker",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 152470,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Ad Detect Plugin - Handy Tool",
    Category: "PRODUCTIVITY",
    Rating: 3.8,
    Reviews: 5107,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 28, 2015",
    "Current Ver": "1.6.3",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "AppBrain Ad Detector",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 9221,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 12, 2018",
    "Current Ver": "2.2.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AD - Nieuws, Sport, Regio & Entertainment",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.7,
    Reviews: 10369,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Flud (Ad free)",
    Category: "VIDEO_PLAYERS",
    Rating: 4.8,
    Reviews: 5639,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "September 7, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "AdClear Ad blocker for Samsung",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 1586,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 7, 2017",
    "Current Ver": "1.0.5",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Adblock Browser for Android",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 121113,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.4.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "CM Browser - Ad Blocker , Fast Download , Privacy",
    Category: "COMMUNICATION",
    Rating: 4.6,
    Reviews: 2265084,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 31, 2018",
    "Current Ver": "5.22.18.0006",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Adguard Content Blocker",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 14491,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 26, 2018",
    "Current Ver": "2.1.2",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "tTorrent - ad free",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 2976,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "June 15, 2018",
    "Current Ver": "1.5.14",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "cronometer (ad free)",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.9,
    Reviews: 1075,
    Size: "8.3M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 13, 2018",
    "Current Ver": "2.1.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Ad Detector",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 208,
    Size: "730k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 28, 2014",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Adblock Plus for Samsung Internet - Browse safe.",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 8769,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 5, 2018",
    "Current Ver": "1.1.4",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "MyRadar NOAA Weather Radar Ad Free",
    Category: "WEATHER",
    Rating: 4.5,
    Reviews: 3005,
    Size: "26M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 4, 2018",
    "Current Ver": "7.1.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Safe Notes - Secure Ad-free notepad",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 3362,
    Size: "756k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 21, 2017",
    "Current Ver": 1.7,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Adblock Fast",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 9914,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 17, 2017",
    "Current Ver": "1.4.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "FVD Ad-Free",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 1774,
    Size: "4.1M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 5, 2017",
    "Current Ver": "4.4.3",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "2000 AD Comics and Judge Dredd",
    Category: "COMICS",
    Rating: 3.7,
    Reviews: 705,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.3.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Anti Adware",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 18751,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 19, 2018",
    "Current Ver": 3.6,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ad Blocker Turbo - Adblocker Browser",
    Category: "COMMUNICATION",
    Rating: 3.9,
    Reviews: 107,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 29, 2018",
    "Current Ver": "1.0.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Weather & Radar Pro - Ad-Free",
    Category: "WEATHER",
    Rating: 4.5,
    Reviews: 25243,
    Size: "26M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.34.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ONScripter Plus (Ad Free)",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 100,
    Size: "17M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "April 7, 2016",
    "Current Ver": "1.2.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Vpn Hosts (ad blocker & no root & support ipv6 )",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 319,
    Size: "1.1M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 3, 2018",
    "Current Ver": "2.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Google AdSense",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 52677,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 13, 2017",
    "Current Ver": 3.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ad-free Triangle Solver",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 118,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 20, 2015",
    "Current Ver": "6.3.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Ez Screen Recorder (no ad)",
    Category: "VIDEO_PLAYERS",
    Rating: 4.7,
    Reviews: 8696,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "June 3, 2018",
    "Current Ver": "2.1.4",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Best Applock - Locker & No Ads",
    Category: "PRODUCTIVITY",
    Rating: 4.7,
    Reviews: 10672,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 23, 2018",
    "Current Ver": "2.1.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Local Services ads by Google",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 7,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 17, 2018",
    "Current Ver": "3.3.270",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ad Block REMOVER - NEED ROOT",
    Category: "TOOLS",
    Rating: 3.3,
    Reviews: 999,
    Size: "91k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 17, 2013",
    "Current Ver": 3.2,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "WhatsFake Pro (Ad free)",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 204,
    Size: "9.4M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "September 25, 2017",
    "Current Ver": 1.4,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Photo Compress 2.0 - Ad Free",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 6267,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 7, 2016",
    "Current Ver": 2.1,
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Ad Removal: thereisonlywe",
    Category: "PRODUCTIVITY",
    Rating: 3.4,
    Reviews: 16,
    Size: "293k",
    Type: "Paid",
    Price: "$6.49",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 3, 2014",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Brave Browser: Fast AdBlocker",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 40241,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 30, 2018",
    "Current Ver": "1.0.52",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Solitaire: Decked Out Ad Free",
    Category: "GAME",
    Rating: 4.9,
    Reviews: 37302,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "May 8, 2017",
    "Current Ver": "1.3.3",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "WeatherClear - Ad-free Weather, Minute forecast",
    Category: "WEATHER",
    Rating: 4.5,
    Reviews: 3252,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "June 25, 2017",
    "Current Ver": "1.2.6",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Ad Remove Plugin for App2SD",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 66,
    Size: "17k",
    Type: "Paid",
    Price: "$1.29",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "September 25, 2013",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Digital Clock : Simple, Tiny, Ad-free Desk Clock.",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 317,
    Size: "74k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 21, 2016",
    "Current Ver": 3,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Google Ads",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 29331,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.12.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "RAM Cleanup Ad-Free Option",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 457,
    Size: "1.1M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 26, 2016",
    "Current Ver": 3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Emo Ads Blocker Browser",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 1555,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 17, 2015",
    "Current Ver": 1.4,
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Bing Ads",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 1828,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.13.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "My baby firework (Remove ad)",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 30,
    Size: "14k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 25, 2013",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "Apps Ads Detector",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 315,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 19, 2018",
    "Current Ver": 25,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "TIMBER AD FILTER - Very useful ad block app",
    Category: "PRODUCTIVITY",
    Rating: 3.8,
    Reviews: 1343,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 12, 2018",
    "Current Ver": "1.0.26",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Alchemy Classic Ad Free",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 20178,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "May 26, 2014",
    "Current Ver": "1.7.3",
    numInstall: 100000,
    numAndroid: 1,
  },
  {
    App: "Mobi Calculator free & AD free!",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 77302,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 9, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Easy Hotspot Ad Free",
    Category: "TOOLS",
    Rating: 5,
    Reviews: 2,
    Size: "3.3M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1.05,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Flipp - Weekly Shopping",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 85782,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "AE + Aerie: Jeans, Dresses, Swimsuits & Bralettes",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 20476,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 17, 2018",
    "Current Ver": "5.6.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "A&E - Watch Full Episodes of TV Shows",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 29708,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 16, 2018",
    "Current Ver": "3.1.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Adobe Premiere Clip",
    Category: "VIDEO_PLAYERS",
    Rating: 3.9,
    Reviews: 39495,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "June 26, 2018",
    "Current Ver": "1.1.4.1296",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Shortcuts for After Effects",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 464,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 9, 2014",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "AE Sudoku",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 2171,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 29, 2015",
    "Current Ver": "1.1.0",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "ESS Mobile for AE",
    Category: "PRODUCTIVITY",
    Rating: 1.9,
    Reviews: 63,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "September 27, 2016",
    "Current Ver": "2.0.1027",
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "AE Jewels 2: Island Adventures",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 652,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "February 24, 2016",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "AE Bubble:Offline Bubble Games",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 6973,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "October 20, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "AE Basketball",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 8100,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "November 20, 2013",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "AE Bingo: Offline Bingo Games",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 61746,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "September 30, 2016",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "AE Jewels",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 960,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "August 20, 2015",
    "Current Ver": "1.0.5",
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "AE Spider Solitaire",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 17263,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "June 7, 2017",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "AE Coin Mania : Arcade Fun",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 30002,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "February 8, 2018",
    "Current Ver": "2.3.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AE Roundy POP",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 5262,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "March 23, 2016",
    "Current Ver": "1.1.2",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Mupen64+AE FREE (N64 Emulator)",
    Category: "GAME",
    Rating: 4,
    Reviews: 41759,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "January 19, 2014",
    "Current Ver": "2.4.4",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Mupen64Plus AE (N64 Emulator)",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 4569,
    Size: "12M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "January 19, 2014",
    "Current Ver": "2.4.4",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "AE Lucky Fishing",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 18277,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "March 14, 2016",
    "Current Ver": "2.0.2",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "AE Video Poker",
    Category: "GAME",
    Rating: 4,
    Reviews: 721,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "December 31, 2015",
    "Current Ver": "1.3.2",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "AE Solitaire",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1776,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "January 4, 2018",
    "Current Ver": "2.3.4",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "AE Archer",
    Category: "SPORTS",
    Rating: 3.9,
    Reviews: 8638,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "September 2, 2015",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "AE Blackjack",
    Category: "GAME",
    Rating: 4,
    Reviews: 1417,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "November 27, 2015",
    "Current Ver": "1.3.1",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "AE Gun Ball: arcade ball games",
    Category: "GAME",
    Rating: 3.7,
    Reviews: 8581,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "December 13, 2013",
    "Current Ver": "1.0.2",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "AE Order",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 19,
    Size: "317k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 12, 2013",
    "Current Ver": "2.0.131112",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "TV.AE",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 109,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "September 21, 2017",
    "Current Ver": "1.0.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AE 3D MOTOR :Racing Games Free",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 74902,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "August 26, 2016",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "AE Garage",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.4,
    Reviews: 64,
    Size: "66M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "June 27, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AE Bulletins",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 14,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 18, 2018",
    "Current Ver": "2.2.5",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AE GTO Racing",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 6988,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Racing",
    "Last Updated": "September 24, 2015",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "AE 3D Moto 3",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 2588,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Racing",
    "Last Updated": "December 31, 2014",
    "Current Ver": "1.7.1",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "AE FreeCell",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 358,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "November 6, 2014",
    "Current Ver": "1.1.5",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "AE City Jump",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 804,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.0.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AE Angry Chef",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 533,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "January 24, 2014",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Ae Allah na Dai (Rasa)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 263,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "January 1, 2015",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Dashboard AE",
    Category: "AUTO_AND_VEHICLES",
    Rating: "NaN",
    Reviews: 0,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "May 16, 2018",
    "Current Ver": 1255162018,
    numInstall: 10,
    numAndroid: 6,
  },
  {
    App: "FilmoraGo - Free Video Editor",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 238459,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "June 6, 2018",
    "Current Ver": "3.1.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Event Manager - AllEvents.in",
    Category: "EVENTS",
    Rating: 4.7,
    Reviews: 120,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "July 25, 2018",
    "Current Ver": 2.5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Nasihat - Chalo ae Pyaara",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 557,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 9, 2015",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "AE Master Moto",
    Category: "GAME",
    Rating: 4,
    Reviews: 17876,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "December 10, 2015",
    "Current Ver": "1.8.6",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Brica BPRO5 AE",
    Category: "PHOTOGRAPHY",
    Rating: 3.9,
    Reviews: 4726,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 17, 2015",
    "Current Ver": "v1.0",
    numInstall: 500000,
    numAndroid: 3,
  },
  {
    App: "AE Manager",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 15, 2015",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AE Air Hockey",
    Category: "SPORTS",
    Rating: 3.8,
    Reviews: 926,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2013",
    "Current Ver": "1.0.0",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Connect.ae - Local Search UAE",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.9,
    Reviews: 194,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "April 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "AE Fishing Hunter",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 14,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "March 15, 2016",
    "Current Ver": "0.0.3",
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "ActionDirector Video Editor - Edit Videos Fast",
    Category: "VIDEO_PLAYERS",
    Rating: 4.5,
    Reviews: 74531,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "June 15, 2018",
    "Current Ver": "2.12.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Ivanti AE Agent",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 10, 2018",
    "Current Ver": "11.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AE Checkout Plugin",
    Category: "SHOPPING",
    Rating: 3.8,
    Reviews: 208,
    Size: "78k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "February 11, 2015",
    "Current Ver": "1.3.1",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "NewTek NDI",
    Category: "PHOTOGRAPHY",
    Rating: 3.5,
    Reviews: 77,
    Size: "1.2M",
    Type: "Paid",
    Price: "$19.99",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "October 26, 2016",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AfterFocus",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 165224,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 8, 2016",
    "Current Ver": "2.1.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "AF Link",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.7,
    Reviews: 210,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 31, 2018",
    "Current Ver": "v4.29.0.9",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AF Hydro",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2,
    Reviews: 136,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "May 12, 2018",
    "Current Ver": "1.0.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Gunship III Vietnam People AF",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 726,
    Size: "19M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "December 9, 2016",
    "Current Ver": "3.8.4",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "AF Comics Reader - Free",
    Category: "COMICS",
    Rating: 2.8,
    Reviews: 5,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "November 10, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Camera FV-5 Lite",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 130063,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 10, 2017",
    "Current Ver": "3.31.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Flim Af Somali Hindi Fanproj",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 12,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 22, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Cardiac diagnosis (heart rate, arrhythmia)",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 4559,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 27, 2018",
    "Current Ver": 117,
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "DSLR camera - Auto Focus and Blur Professional",
    Category: "PHOTOGRAPHY",
    Rating: 3.4,
    Reviews: 30,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "April 18, 2018",
    "Current Ver": "5.1.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AF-STROKE (FREE)",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 93,
    Size: "924k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Medical",
    "Last Updated": "January 25, 2013",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Hesab.af - Send money in Afghanistan",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 51,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 15, 2018",
    "Current Ver": "1.4.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AppFinder by AppTap",
    Category: "TOOLS",
    Rating: 2,
    Reviews: 2221,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 3, 2017",
    "Current Ver": "1.8.2.7",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "iFunny :)",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 503757,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Toppen af Danmark",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 8,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 28, 2018",
    "Current Ver": "8.3.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "AF-STROKE",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 5,
    Size: "902k",
    Type: "Paid",
    Price: "$5.00",
    "Content Rating": "Teen",
    Genres: "Medical",
    "Last Updated": "December 19, 2013",
    "Current Ver": 1.3,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "i-share AF/KLM (AFKL ishare)",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 2,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 21, 2018",
    "Current Ver": "1.16.5",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Bazar.af",
    Category: "SHOPPING",
    Rating: 4.7,
    Reviews: 13,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 7, 2017",
    "Current Ver": "cli-6.5.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "DSLR Blur Camera Auto Focus",
    Category: "TOOLS",
    Rating: 3.3,
    Reviews: 75,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 7, 2018",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Ariana News AF",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 20,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 10, 2017",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "AF Legendary 2017",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Business",
    "Last Updated": "September 30, 2017",
    "Current Ver": "v2.7.11.6",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "AR effect",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 79792,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "ASUS PixelMaster Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 626366,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 29, 2016",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "AzadBazar.af",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 3,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "March 9, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "easyFocus",
    Category: "PHOTOGRAPHY",
    Rating: 3.7,
    Reviews: 3396,
    Size: "266k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 28, 2012",
    "Current Ver": "1.2.0",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "AF Nutrition - Integratori",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 6,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 2, 2018",
    "Current Ver": 1.3,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Open Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 116769,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "April 23, 2018",
    "Current Ver": "1.43.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Blur Image - DSLR focus effect",
    Category: "PHOTOGRAPHY",
    Rating: 3.9,
    Reviews: 38055,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 16, 2017",
    "Current Ver": 1.17,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Tafsiir Quraan MP3 Af Soomaali Quraanka Kariimka",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 7,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 9, 2018",
    "Current Ver": 1.4,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Camera Pro",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 7479,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "April 16, 2018",
    "Current Ver": 5.4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Rоhi.af",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.8,
    Reviews: 46,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 1, 2017",
    "Current Ver": "1.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "HD Camera - silent shutter",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 26530,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.3.5",
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "AF Our Time to Shine",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 17, 2017",
    "Current Ver": "v2.7.10.6",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "A Better Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 76484,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 8, 2018",
    "Current Ver": 3.52,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Auto Dslr Photo Effect : Auto Focus Effect",
    Category: "PHOTOGRAPHY",
    Rating: 3.8,
    Reviews: 6,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 20, 2018",
    "Current Ver": 1.6,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "9GAG: Funny Gifs, Pics, Memes & Videos for IGTV",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 1450632,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "AF Johannesburg",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 2, 2017",
    "Current Ver": "1.0.3",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "PhotoScan by Google Photos",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 61990,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 9, 2018",
    "Current Ver": "1.5.1.182070924",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Gun Strike Shoot",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 94761,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "February 21, 2017",
    "Current Ver": "1.1.4",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "All Football - Latest News & Videos",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 152653,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.0.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "50000 Free eBooks & Free AudioBooks",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.1,
    Reviews: 52312,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "May 19, 2018",
    "Current Ver": "5.3.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "AppLock",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 4931562,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "King of Avalon: Dragon Warfare",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 306652,
    Size: "64M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.6.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "What's Up",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 23453,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "October 26, 2017",
    "Current Ver": 2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Afterlight",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 50893,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 20, 2014",
    "Current Ver": "1.0.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Blurfoto : Auto blur photo background & DSLR focus",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 2215,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 27, 2018",
    "Current Ver": 1.12,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Blur",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 9013,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 18, 2018",
    "Current Ver": "4.0.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AG Contacts, Premium edition",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 88,
    Size: "3.7M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 18, 2018",
    "Current Ver": "8.05.18.14250",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Ag PhD Field Guide",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.1,
    Reviews: 114,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 25, 2015",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "AG Drive 3D",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 164,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "March 20, 2015",
    "Current Ver": "1.0.1",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Apps for SportsBєtting.ag - Bitcoin Welcome here!",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "10.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "December 11, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AG Contacts, Lite edition",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 185,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 18, 2018",
    "Current Ver": "8.05.18.14250",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Ag Weather Tools",
    Category: "WEATHER",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "January 9, 2018",
    "Current Ver": "1.0.1",
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "Trimble Ag Mobile",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 85,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.7.8",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Ag Tools",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 2,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 27, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ag PhD Deficiencies",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.9,
    Reviews: 20,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 21, 2016",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AG Screen Recorder",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 7,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 3, 2018",
    "Current Ver": 3,
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "SOLEM AG",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 19, 2017",
    "Current Ver": "1.0.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AG Subway Simulator Mobile",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 623,
    Size: "47M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 2, 2018",
    "Current Ver": "1.3.0.6",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "AG Subway Simulator Lite",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 6738,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 8, 2018",
    "Current Ver": "1.2.6",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Elim AG",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 7,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 31, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EZ Ag Mobile",
    Category: "FINANCE",
    Rating: 3.4,
    Reviews: 19,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 12, 2017",
    "Current Ver": "9.0.00",
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "AG Subway Simulator Pro",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "BRL AG",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 19, 2017",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Oklahoma Ag Co-op Council",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.2.3",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "AG Fast Service Automotive",
    Category: "AUTO_AND_VEHICLES",
    Rating: "NaN",
    Reviews: 5,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "June 12, 2018",
    "Current Ver": "1.0.8",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ag PhD Soils",
    Category: "PRODUCTIVITY",
    Rating: 2.3,
    Reviews: 3,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 16, 2018",
    "Current Ver": "1.24.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "All States Ag Parts",
    Category: "SHOPPING",
    Rating: 4.7,
    Reviews: 68,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "January 25, 2018",
    "Current Ver": "5.26.0",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "VR AG Racing for Cardboard",
    Category: "GAME",
    Rating: 3.4,
    Reviews: 13,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "September 29, 2016",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Safe Ag Systems™",
    Category: "BUSINESS",
    Rating: 4.7,
    Reviews: 3,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 22, 2018",
    "Current Ver": "2.0.3",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ag PhD Planting Population Calculator",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 9, 2017",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ag Trucking Mobile App",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 17, 2017",
    "Current Ver": 8,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Lakeside AG Moultrie",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 3,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 23, 2017",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Ag Guardian",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 28, 2015",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Wind & Weather Meter for Ag",
    Category: "WEATHER",
    Rating: "NaN",
    Reviews: 3,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "March 14, 2016",
    "Current Ver": "v1.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ag Across America",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "May 15, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Border Ag & Energy",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 30, 2018",
    "Current Ver": 2.1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Ag-Pro Companies",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 6, 2018",
    "Current Ver": "2.3.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "My Ag Report",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 18, 2018",
    "Current Ver": 1.2,
    numInstall: 50,
    numAndroid: 5,
  },
  {
    App: "Alabama Ag Credit Ag Banking",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 9, 2018",
    "Current Ver": "5.3.4",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AG EMS Tour",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 5, 2017",
    "Current Ver": 1.35,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Mix Tank – Tank Mixing Ag App",
    Category: "PRODUCTIVITY",
    Rating: 3.6,
    Reviews: 64,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 16, 2017",
    "Current Ver": 4.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Eternal Light AG",
    Category: "SOCIAL",
    Rating: 5,
    Reviews: 30,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "May 19, 2018",
    "Current Ver": 1.04,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AG test",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 3,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 18, 2017",
    "Current Ver": "1.0.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "West Central Ag",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 3,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 16, 2017",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Platincoin Wallet - PLC Group AG",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.3,
    Reviews: 375,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "June 1, 2018",
    "Current Ver": "2.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Tri-Ag (WV) FCU",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 3, 2018",
    "Current Ver": "3.1.10",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ag PhD Soybean Diseases",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 8, 2017",
    "Current Ver": "1.0.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "United Ag Cooperative",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 27, 2018",
    "Current Ver": "30.0.0",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Ag Valley Cooperative",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 6,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 26, 2017",
    "Current Ver": 2.3,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Michael's AG Sound Board",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.7M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 12, 2017",
    "Current Ver": 1.1,
    numInstall: 1,
    numAndroid: 1,
  },
  {
    App: "Ag-Power",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 13, 2018",
    "Current Ver": "2.4.3",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Fertilizer Removal By Crop",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.1,
    Reviews: 295,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 20, 2017",
    "Current Ver": "2.0.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "AG Track",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 12,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 23, 2018",
    "Current Ver": 3.3,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Denis Brogniart - AH !",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 2931,
    Size: "818k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 4, 2017",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Freeland AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "December 18, 2017",
    "Current Ver": "300000.0.95",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "MD PAWS AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "February 23, 2018",
    "Current Ver": "300000.0.98",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AH Connect (Adventist Health)",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.4,
    Reviews: 5,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "January 23, 2018",
    "Current Ver": "3.5.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Woodland AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "February 2, 2018",
    "Current Ver": "300000.0.97",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Mukwonago AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 29, 2017",
    "Current Ver": "300000.0.85",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Angelcare AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 6, 2017",
    "Current Ver": "300000.0.91",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "WoW AH Tracker",
    Category: "TOOLS",
    Rating: 2.9,
    Reviews: 33,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "AH Kollection for KLWP",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 644,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 30, 2017",
    "Current Ver": "Version 1.20",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Chenoweth AH",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 1,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 3, 2017",
    "Current Ver": "300000.0.78",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Sayers AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 17, 2018",
    "Current Ver": "300000.0.97",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Claus Paws AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "December 8, 2017",
    "Current Ver": "300000.0.94",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Denis Brogniart - AH 2 !",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 4,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "October 28, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Ah! Cutie",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 536,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "June 27, 2017",
    "Current Ver": "2.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AH Alarm Panel",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 7,
    Size: "81k",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 12, 2011",
    "Current Ver": "1.2.0",
    numInstall: 100,
    numAndroid: 1,
  },
  {
    App: "Arrowhead AH App",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 3,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 21, 2017",
    "Current Ver": "300000.0.80",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ah! Monster",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 1998,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "June 21, 2017",
    "Current Ver": "4.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Maricopa AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 16, 2018",
    "Current Ver": "300000.1.11",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Kimbrough AH",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 5,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "September 21, 2017",
    "Current Ver": "300000.0.90",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "The Ah Yeah! Button",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 30,
    Size: "318k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "October 1, 2013",
    "Current Ver": 1.2,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Bee'ah Employee App",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 4,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "December 24, 2017",
    "Current Ver": "2.26.5.0",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "Clarksburg AH",
    Category: "MEDICAL",
    Rating: 1,
    Reviews: 1,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 1, 2017",
    "Current Ver": "300000.0.81",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "WAH AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 3, 2017",
    "Current Ver": "300000.0.80",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Prestige AH",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 2,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 11, 2017",
    "Current Ver": "300000.0.81",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "San Dimas AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "February 18, 2018",
    "Current Ver": "300000.0.97",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ah Bailar",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 10,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 14, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "Ebenezer AH",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 4,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 5, 2017",
    "Current Ver": "300000.0.79",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Boston AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "November 30, 2017",
    "Current Ver": "300000.0.93",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "AH-1 Viper Cobra Ops - helicopter flight simulator",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 1088,
    Size: "86M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "February 16, 2018",
    "Current Ver": "1.0.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Ah !",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 27, 2017",
    "Current Ver": "1.1.2",
    numInstall: 50,
    numAndroid: 5,
  },
  {
    App: "Kay AH GA",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "February 15, 2018",
    "Current Ver": "300000.0.97",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Bayview Hill AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 6, 2018",
    "Current Ver": "300000.1.08",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Hilltop AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 10, 2018",
    "Current Ver": "300000.0.96",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ah Ha Block",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 9, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AH Lake Villa",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 3,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 22, 2017",
    "Current Ver": "300000.0.78",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ferguson AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 17, 2017",
    "Current Ver": "300000.0.86",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "be'ah",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 5,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "March 28, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "Ah! Bird",
    Category: "SPORTS",
    Rating: 3.5,
    Reviews: 1689,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 29, 2017",
    "Current Ver": "1.5.062",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Downers Grove AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 10, 2018",
    "Current Ver": "300000.0.96",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AH! Soundboard",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 11,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "September 21, 2017",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Sherbourne AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "February 27, 2018",
    "Current Ver": "300000.0.98",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Cathy AH",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 16, 2018",
    "Current Ver": "1.0.4",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Monticello AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 26, 2017",
    "Current Ver": "300000.0.84",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Brandon Lakes AH",
    Category: "MEDICAL",
    Rating: 2.6,
    Reviews: 5,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 5, 2017",
    "Current Ver": "300000.0.79",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Forest Crossing AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 12, 2018",
    "Current Ver": "300000.1.01",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Ah! Coins",
    Category: "GAME",
    Rating: 3.4,
    Reviews: 256,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "December 8, 2016",
    "Current Ver": "1.0.0",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Mitchell AH",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 23, 2018",
    "Current Ver": "300000.1.08",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "AH of Rocky Hill",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "November 24, 2017",
    "Current Ver": "300000.0.93",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Replika",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 45458,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.5.49",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ai illustrator viewer",
    Category: "ART_AND_DESIGN",
    Rating: 3.4,
    Reviews: 486,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "July 26, 2018",
    "Current Ver": 5.7,
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Real AI",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 949,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 22, 2018",
    "Current Ver": 4.9,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "The Artificial Intelligence Project (A.I. Chat)",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 76,
    Size: "39M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "March 29, 2018",
    "Current Ver": 1.2,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Virtual Assistant DataBot: Artificial Intelligence",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 80927,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 31, 2018",
    "Current Ver": "7.2.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ALPHA - Artificial Intelligence",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 51,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 3, 2018",
    "Current Ver": "1.3.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Artificial Intelligence",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 339,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 5, 2018",
    "Current Ver": 6.2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Orbita AI — Exciting mobile puzzles & riddles",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 116973,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "March 29, 2018",
    "Current Ver": "1.1.9.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SMS AI Bot",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 89,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 1, 2018",
    "Current Ver": "3.0.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "ChatBot AI Talking Girl",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 3597,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Entertainment",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.0.16",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Ai File Viewer",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 66,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "Youper - AI Therapy",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 1976,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 3, 2018",
    "Current Ver": "6.02.000",
    numInstall: 50000,
    numAndroid: 6,
  },
  {
    App: "ParaTek Ai Speech generator",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 448,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 23, 2017",
    "Current Ver": 1.9,
    numInstall: 50000,
    numAndroid: 1,
  },
  {
    App: "Extreme- Personal Voice Assistant",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 25627,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 5, 2018",
    "Current Ver": 132,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "AI Face Beauty Analysis - IntelliFace (Free)",
    Category: "BEAUTY",
    Rating: 3.1,
    Reviews: 40,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "April 11, 2018",
    "Current Ver": 20,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Robin - AI Voice Assistant",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 55313,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 5, 2018",
    "Current Ver": 4.435,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Learn Artificial Intelligence",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 27,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 14, 2018",
    "Current Ver": "1.1.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AI Benchmark",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 97,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 29, 2018",
    "Current Ver": "2.0.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "AI Today : Artificial Intelligence News & AI 101",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 5,
    Reviews: 43,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 22, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Tomo A.i. Pet Chat Bot",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 40,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 15, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Puck AI Personal Assistant Robot",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 22,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 2, 2017",
    "Current Ver": 1.5,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Builder (by Engineer.ai)",
    Category: "PRODUCTIVITY",
    Rating: 3.6,
    Reviews: 8,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 4, 2017",
    "Current Ver": "1.2-Release",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Chat With Artificial Intelligence",
    Category: "FAMILY",
    Rating: 3.2,
    Reviews: 32,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 10, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Friday: Smart Personal Assistant",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 2087,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 24, 2018",
    "Current Ver": 20,
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Picai - Smart AI Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 529,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.2.3",
    numInstall: 100000,
    numAndroid: 6,
  },
  {
    App: "Virtual Eye AI",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 26,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 27, 2018",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Lyra Virtual Assistant",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 41624,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.2.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "2048(AI)",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 20,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "June 3, 2015",
    "Current Ver": 0.33,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "ai robot keyboard",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 1891,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 24, 2018",
    "Current Ver": 10001008,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AI with Python Tutorial",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 8,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 5, 2018",
    "Current Ver": "1.0.4",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "ai.Bot Box",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 1, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "Adobe Illustrator Draw",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 65766,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "April 2, 2018",
    "Current Ver": "3.4.23",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "FaceApp",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 346681,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 10, 2018",
    "Current Ver": "2.0.949",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Message AI - Write Better Messages (Free)",
    Category: "SOCIAL",
    Rating: 3.7,
    Reviews: 3,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 4, 2018",
    "Current Ver": "1.3.1-lite",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "ChatBolo - AI Chatbot Online",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 1407,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "September 25, 2015",
    "Current Ver": 2.1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Artificial intelligence",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 5, 2018",
    "Current Ver": 2.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "MiAI (Artificial Intelligence) Assistant",
    Category: "PRODUCTIVITY",
    Rating: 3.7,
    Reviews: 3,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 1, 2018",
    "Current Ver": 11.04,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AI Draw | Art Filter for Selfie",
    Category: "PHOTOGRAPHY",
    Rating: 3,
    Reviews: 20,
    Size: "4.3M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 18, 2018",
    "Current Ver": "1.4.7",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Turbo AI™ - Personal assistant",
    Category: "PRODUCTIVITY",
    Rating: 2.6,
    Reviews: 91,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 16, 2018",
    "Current Ver": "0.0.52",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Message AI - Write Better Messages",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "7.9M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Mature 17+",
    Genres: "Tools",
    "Last Updated": "July 4, 2018",
    "Current Ver": "1.3.1",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "AI Image Recognizer (beta)",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "September 13, 2017",
    "Current Ver": "closed",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "AI Sight",
    Category: "PRODUCTIVITY",
    Rating: 3.5,
    Reviews: 43,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 18, 2018",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Jarvis artificial intelligent",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 253,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 28, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Age of AI: War Strategy",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 71,
    Size: "5.7M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "March 14, 2018",
    "Current Ver": 1.8,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "DREAM-e: Dream Analysis A.I.",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 89,
    Size: "939k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "February 18, 2013",
    "Current Ver": 2.3,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Animal Jam - Play Wild!",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 361734,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "August 2, 2018",
    "Current Ver": "28.0.14",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "AJ Jump: Animal Jam Kangaroos!",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 2975,
    Size: "42M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "March 7, 2016",
    "Current Ver": 1.6,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "AJ Academy: Amazing Animals",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 1564,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.1.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Dash Tag - Fun Endless Runner!",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 6750,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "June 13, 2018",
    "Current Ver": "2.0.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Jamaa Amino for Animal Jam",
    Category: "SOCIAL",
    Rating: 4.7,
    Reviews: 3873,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 13, 2018",
    "Current Ver": "1.8.19106",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Tunnel Town",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 74744,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.5.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AJ+ Beta",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 4, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "AJ Cam",
    Category: "PHOTOGRAPHY",
    Rating: 5,
    Reviews: 44,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "January 23, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AJ Reminders",
    Category: "MAPS_AND_NAVIGATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "January 27, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "tournaments and more.aj.2",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "September 25, 2017",
    "Current Ver": 4.3,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Club Penguin Island",
    Category: "FAMILY",
    Rating: 2.8,
    Reviews: 107441,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "July 10, 2018",
    "Current Ver": "1.10.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Aj. Vallbona",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 0,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 25, 2018",
    "Current Ver": 4,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "AJ Official",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 31,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 3, 2017",
    "Current Ver": 0.1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "AJ Bell Youinvest",
    Category: "FINANCE",
    Rating: 2.8,
    Reviews: 135,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 4, 2018",
    "Current Ver": "2.13.0.65",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Hey AJ! It's Saturday!",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 5,
    Reviews: 12,
    Size: "50M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 13, 2016",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Selfie With Champion AJ Style",
    Category: "PHOTOGRAPHY",
    Rating: 5,
    Reviews: 2,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "January 8, 2018",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 3,
  },
  {
    App: "Baby Game Animal Jam Free",
    Category: "GAME",
    Rating: 2.8,
    Reviews: 9,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "March 24, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "AJ Concept Group App",
    Category: "HOUSE_AND_HOME",
    Rating: "NaN",
    Reviews: 0,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 25, 2017",
    "Current Ver": 3,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Blackjack aj Poker",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 8,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "October 19, 2016",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Bonza Poly Art - Tenkyu Animal Jam for Kids",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 22,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.0.9",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "A.J. Styles HD Wallpapers 2018",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 1,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AJ Player",
    Category: "VIDEO_PLAYERS",
    Rating: 4.8,
    Reviews: 18,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "April 22, 2018",
    "Current Ver": "1.6.3.1",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "AJ RETAILS",
    Category: "SHOPPING",
    Rating: 5,
    Reviews: 9,
    Size: "169k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 1, 2018",
    "Current Ver": 18060104,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "Hey AJ! It's Bedtime!",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 1,
    Size: "63M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 4, 2018",
    "Current Ver": "1.0.59",
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "AJ AUTO",
    Category: "AUTO_AND_VEHICLES",
    Rating: "NaN",
    Reviews: 0,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "February 27, 2017",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "AJ Percent Off Calculator",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 134,
    Size: "45k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 4, 2013",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "AJ Nails Supply",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 1,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 15, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Aj.Petra",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 5,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "September 29, 2017",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AJ Men's Grooming",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 2,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 28, 2017",
    "Current Ver": 5,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Watch Face Swiss AJ-6",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 21,
    Size: "3.6M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "September 20, 2017",
    "Current Ver": 1.35,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AJ Rafael Music Lyrics",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Entertainment",
    "Last Updated": "January 3, 2018",
    "Current Ver": 2,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "AJ Styles HD Wallpapers",
    Category: "ART_AND_DESIGN",
    Rating: 4.8,
    Reviews: 48,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.1.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "AJ and Alyssa",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "475k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 1, 2017",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "A.J. Green Wallpapers 4 Fans",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 26, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "AJ Gray Icon Pack",
    Category: "PERSONALIZATION",
    Rating: 4.8,
    Reviews: 5,
    Size: "35M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 22, 2018",
    "Current Ver": 1.1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "AJ Styles Wallpaper 2018 - AJ Styles HD Wallpaper",
    Category: "ART_AND_DESIGN",
    Rating: 4,
    Reviews: 18,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "March 22, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "A-J Media Vault",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "January 4, 2017",
    "Current Ver": "5.62.1",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "AJ Gray Dark Icon Pack",
    Category: "PERSONALIZATION",
    Rating: 5,
    Reviews: 2,
    Size: "35M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 29, 2018",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Little Pets Animal Guardians",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 18893,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "June 9, 2018",
    "Current Ver": "1.4.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AJ-COMICS",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 0,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 13, 2018",
    "Current Ver": "0.1.0",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "AJ Blue Icon Pack",
    Category: "PERSONALIZATION",
    Rating: 5,
    Reviews: 4,
    Size: "31M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 27, 2018",
    "Current Ver": 1.1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "AJ Tracey Music and Lyrics",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 7, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "AJ Turquoise Dark Icon Pack",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "32M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 1, 2018",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "AJ렌터카 법인 카셰어링",
    Category: "MAPS_AND_NAVIGATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.0.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "My Wild Pet: Online Animal Sim",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 26916,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "March 17, 2017",
    "Current Ver": 2.7,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "AJ Rafael Music Lessons",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 1,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 29, 2017",
    "Current Ver": "1.2.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "AJ Orange Icon Pack",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "30M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 2, 2018",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "AJ Wallpapers",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 6, 2018",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Aj Di Awaaz",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 9,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "September 7, 2016",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "How it works: AK-74N",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 1031,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 9, 2018",
    "Current Ver": "2.1.9f0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AK-47: Simulator and Shooting",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 345,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Simulation",
    "Last Updated": "November 11, 2016",
    "Current Ver": "1.3.0",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "AK-47 Simulation and Info",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 5, 2018",
    "Current Ver": "2.0.0",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "AK-47 Sounds",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 656,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Entertainment",
    "Last Updated": "September 14, 2016",
    "Current Ver": 2,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "AK 47 Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 585,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 20, 2018",
    "Current Ver": 1.3,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Puppy Shooting an AK-47: Platformer Zombie Game",
    Category: "GAME",
    Rating: 4.8,
    Reviews: 21,
    Size: "89M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "March 30, 2018",
    "Current Ver": "0.46.91",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AK Interactive",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 734,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 12, 2018",
    "Current Ver": 2.5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AK-47 sounds",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 7,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 18, 2018",
    "Current Ver": 568,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Wallpapers AK 47 Guns",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 37,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "February 26, 2017",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "AK 47 Assault Rifle Wallpapers",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "February 22, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AK-47 Assault Rifle",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 165,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "April 26, 2015",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Crisis Action: 2018 NO.1 FPS",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 807226,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 11, 2018",
    "Current Ver": "3.0.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "AK 47 Guns Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 322,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 29, 2017",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "AK-47 3D",
    Category: "GAME",
    Rating: 3.7,
    Reviews: 91,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "December 25, 2016",
    "Current Ver": 3.2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Book of AK-47",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 6,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 1, 2016",
    "Current Ver": "1.0.2",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Weapon stripping 3D",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 23971,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 4, 2018",
    "Current Ver": 39.231,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AK-47 Assult Rifle: Gun Shooting Simulator Game",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 1,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "May 17, 2018",
    "Current Ver": 2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Ak-47 Wallpapers 2018",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 7,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 14, 2018",
    "Current Ver": "newversion",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Wallpapers New AK 47 Assault Rifle Guns Arms",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "March 10, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Weapon AK-74 Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 3.3,
    Reviews: 25,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 28, 2017",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Shoot M-16 vs AK-47 : realistic weapon simulator",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 2,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 18, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Counter Terrorist Attack",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 145931,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "May 31, 2018",
    "Current Ver": "5.3.2",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "RULES OF SURVIVAL",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 1343106,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.180271.184729",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "AK47 Assault Rifle",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 54,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 2, 2015",
    "Current Ver": "1.0.0.1",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Wallpapers AK 74M",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "April 13, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Weapons simulator AK-47",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 21,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "May 15, 2017",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Wallpapers AK 12",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "April 12, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "AK 47 Lock Screen",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 5,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Personalization",
    "Last Updated": "February 11, 2018",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Gun AK 47",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 18, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "AK Blackjack",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 4,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "July 30, 2018",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Jigsaw Puzzles AK 74M",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Personalization",
    "Last Updated": "May 7, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "AK-47 guns Sounds",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 28, 2018",
    "Current Ver": 666,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AK Phone",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 9,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 29, 2017",
    "Current Ver": "3.8.8",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "AK Booster",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 71,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 2, 2018",
    "Current Ver": "2.0.1.966",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "GUN ZOMBIE",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 243121,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "October 17, 2014",
    "Current Ver": 5.3,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Ak Parti Yardım Toplama",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.7M",
    Type: "Paid",
    Price: "$13.99",
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 28, 2017",
    "Current Ver": "3.4.4.3.3",
    numInstall: 0,
    numAndroid: 4,
  },
  {
    App: "AK Lodi Films",
    Category: "VIDEO_PLAYERS",
    Rating: 4.9,
    Reviews: 23,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 11, 2015",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Gun Mod: Guns in Minecraft PE",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 33812,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 30, 2018",
    "Current Ver": 2.5,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Kymco AK 550",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.3,
    Reviews: 47,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "November 11, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "AK Math Coach",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 283,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 19, 2015",
    "Current Ver": 1.3,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Shoot Strike War Fire",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 82827,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "July 13, 2018",
    "Current Ver": "1.1.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "AL.com",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.4,
    Reviews: 803,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 23, 2018",
    "Current Ver": "3.7.10-0d44b899",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "University of Alabama",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 302,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 30, 2017",
    "Current Ver": 3.3,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Alabama Gameday Live",
    Category: "SPORTS",
    Rating: 4.7,
    Reviews: 19,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 18, 2018",
    "Current Ver": "2.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AL.com: Alabama Football News",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 459,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 23, 2018",
    "Current Ver": "3.7.10-0d44b899",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Alabama Road Trips",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 71,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "October 27, 2017",
    "Current Ver": "1.8.7",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Alabama DMV Permit Test - AL",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 218,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 15, 2018",
    "Current Ver": "6.0.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Al-Quran (Free)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 218451,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 20, 2018",
    "Current Ver": "3.2.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Official AL Fishing & Hunting",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 1291,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "October 18, 2017",
    "Current Ver": "5.29.77 Domain 427",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Al Quran (Tafsir & by Word)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.8,
    Reviews: 57400,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.6.5",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Al-Moazin Lite (Prayer Times)",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 284670,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Al Quran Indonesia",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.8,
    Reviews: 445756,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 15, 2018",
    "Current Ver": "2.6.22",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Al'Quran Bahasa Indonesia",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 361780,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 30, 2018",
    "Current Ver": 4.1,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Al Quran Al karim",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 41608,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "November 5, 2017",
    "Current Ver": "1.1.7",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Al jazeera TV",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 9952,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 5, 2016",
    "Current Ver": "1.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Al Jazeera English",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 24456,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Al-Muhaffiz",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 2319,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "April 22, 2018",
    "Current Ver": 10.1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Al Quran Audio (Full 30 Juz)",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 7878,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 29, 2017",
    "Current Ver": 4,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Quran for All (Al-Huda Int.)",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 6696,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 7, 2018",
    "Current Ver": "3.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AL Voice Recorder",
    Category: "PRODUCTIVITY",
    Rating: 3.6,
    Reviews: 4832,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 22, 2016",
    "Current Ver": "2.1.7.3",
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Ayat - Al Quran",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 173394,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 13, 2018",
    "Current Ver": "2.9.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Quran Juz-30 - Mahad al Zahra",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 2654,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 2, 2016",
    "Current Ver": "1.10.0",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Al Quran : EAlim - Translations & MP3 Offline",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 96419,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Al Mayadeen",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.7,
    Reviews: 13620,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "April 16, 2018",
    "Current Ver": 2.137,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Al-Quran Al-Muallim",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 199,
    Size: "266k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 11, 2013",
    "Current Ver": "1.0beta",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "We're Working Out - Al Kavadlo",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.3,
    Reviews: 979,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "December 24, 2017",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Al-Quran 30 Juz free copies",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 12322,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "December 17, 2016",
    "Current Ver": 3,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Koran Read &MP3 30 Juz Offline",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.8,
    Reviews: 29551,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "April 6, 2018",
    "Current Ver": "1.0.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Al Quran MP3 - Quran Reading®",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 47463,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 24, 2018",
    "Current Ver": 4.4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Al'Quran Bahasa Indonesia PRO",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 1340,
    Size: "11M",
    Type: "Paid",
    Price: "$4.49",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 16, 2018",
    "Current Ver": "4.0.5",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Hafizi Quran 15 lines per page",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 55011,
    Size: "68M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "November 2, 2017",
    "Current Ver": "1.1.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Al-Quran Ahmad Saud Offline",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 7116,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 9, 2016",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "12 Step Meditations & Sober Prayers AA NA AL-ANON",
    Category: "LIFESTYLE",
    Rating: 4.7,
    Reviews: 759,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Lifestyle",
    "Last Updated": "January 22, 2018",
    "Current Ver": "1.4.5",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Quran for Android",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 497826,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Al Quran Free - القرآن (Islam)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 1777,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "February 15, 2015",
    "Current Ver": 1.1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Taha Al Junaid Quran Mp3",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 518,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 25, 2017",
    "Current Ver": 1.1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Surah Al-Waqiah",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 1201,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 24, 2015",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Muslim Pro - Prayer Times, Azan, Quran & Qibla",
    Category: "LIFESTYLE",
    Rating: 4.7,
    Reviews: 1133393,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Hisnul Al Muslim - Hisn Invocations & Adhkaar",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 3234,
    Size: "85M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "December 26, 2017",
    "Current Ver": "1.7.22",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "I am rich",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 3547,
    Size: "1.8M",
    Type: "Paid",
    Price: "$399.99",
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 12, 2018",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "I AM RICH",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 1455,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "October 11, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Amazon for Tablets",
    Category: "SHOPPING",
    Rating: 4,
    Reviews: 141584,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 31, 2018",
    "Current Ver": "16.14.0.850",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "I am Rich Plus",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 856,
    Size: "8.7M",
    Type: "Paid",
    Price: "$399.99",
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 19, 2018",
    "Current Ver": 3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "I am rich VIP",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 411,
    Size: "2.6M",
    Type: "Paid",
    Price: "$299.99",
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 21, 2018",
    "Current Ver": "1.1.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "I Am Rich Premium",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 1867,
    Size: "4.7M",
    Type: "Paid",
    Price: "$399.99",
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "November 12, 2017",
    "Current Ver": 1.6,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "I am extremely Rich",
    Category: "LIFESTYLE",
    Rating: 2.9,
    Reviews: 41,
    Size: "2.9M",
    Type: "Paid",
    Price: "$379.99",
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 1, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "I am Rich!",
    Category: "FINANCE",
    Rating: 3.8,
    Reviews: 93,
    Size: "22M",
    Type: "Paid",
    Price: "$399.99",
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "December 11, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "I am rich(premium)",
    Category: "FINANCE",
    Rating: 3.5,
    Reviews: 472,
    Size: "965k",
    Type: "Paid",
    Price: "$399.99",
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 1, 2017",
    "Current Ver": 3.4,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "I am Rich Person",
    Category: "LIFESTYLE",
    Rating: 4.2,
    Reviews: 134,
    Size: "1.8M",
    Type: "Paid",
    Price: "$37.99",
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 18, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "I am Rich Premium Plus",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 459,
    Size: "2.0M",
    Type: "Paid",
    Price: "$18.99",
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 17, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "I Am Rich Pro",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 201,
    Size: "2.7M",
    Type: "Paid",
    Price: "$399.99",
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 30, 2017",
    "Current Ver": 1.54,
    numInstall: 5000,
    numAndroid: 1,
  },
  {
    App: "I Am Innocent",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 208501,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.8.307",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "I am rich (Most expensive app)",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 129,
    Size: "2.7M",
    Type: "Paid",
    Price: "$399.99",
    "Content Rating": "Teen",
    Genres: "Finance",
    "Last Updated": "December 6, 2017",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "i am rich",
    Category: "BUSINESS",
    Rating: 3.9,
    Reviews: 213,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 9, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "I Am Rich",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 217,
    Size: "4.9M",
    Type: "Paid",
    Price: "$389.99",
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 22, 2018",
    "Current Ver": 1.5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "I am Bread",
    Category: "GAME",
    Rating: 4,
    Reviews: 630,
    Size: "20M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "October 26, 2016",
    "Current Ver": "1.6.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Where Am I At?",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.8,
    Reviews: 39,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "October 8, 2016",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "I am Rich",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 180,
    Size: "3.8M",
    Type: "Paid",
    Price: "$399.99",
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 22, 2018",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Where Am I? GPS Loc",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.6,
    Reviews: 68,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "November 14, 2017",
    "Current Ver": 5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "I am Millionaire - Richest guy in the town",
    Category: "LIFESTYLE",
    Rating: 3.6,
    Reviews: 126,
    Size: "1.4M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 22, 2018",
    "Current Ver": 8,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Coast To Coast AM Insider",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.9,
    Reviews: 4581,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "January 4, 2018",
    "Current Ver": "5.0.108",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "I AM RICH PRO PLUS",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 36,
    Size: "41M",
    Type: "Paid",
    Price: "$399.99",
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 25, 2018",
    "Current Ver": "1.0.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Where Am I?",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 1313,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 28, 2014",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "I Am Wizard",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1493,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "April 1, 2018",
    "Current Ver": "1.0.9",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "What Am I? - Brain Teasers",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 4537,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "April 5, 2017",
    "Current Ver": 2.2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Who am I? (Biblical)",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 5849,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "September 13, 2017",
    "Current Ver": "1.2.2_comAds",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "DWWW 774 Ultimate AM Radio",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.7,
    Reviews: 327,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 26, 2018",
    "Current Ver": "4.0.9",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Anno: Build an Empire",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 33944,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "March 10, 2016",
    "Current Ver": "2.0.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Vikings: an Archer's Journey",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 10256,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "December 11, 2017",
    "Current Ver": "2.1.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Final Fantasy XV: A New Empire",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 484858,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "June 15, 2018",
    "Current Ver": "3.30.4.83",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Trell: An app for Explorers | Best Wanderlust App",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 8004,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.4.8",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Virtual Families 2",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 636228,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "The Sims™ FreePlay",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 931503,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "July 16, 2018",
    "Current Ver": "5.39.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "My Emma :)",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 245839,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "April 3, 2017",
    "Current Ver": "2.7.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "League of Gamers - Be an E-Sports Legend!",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 68072,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.1.7",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Draw a Stickman: EPIC Free",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 210317,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Adventure",
    "Last Updated": "April 10, 2015",
    "Current Ver": "1.4.3.104",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "My Horse",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 1333338,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 23, 2018",
    "Current Ver": "1.34.1",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "My Boo - Your Virtual Pet Game",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 899748,
    Size: "80M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "August 3, 2018",
    "Current Ver": 2.11,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Create apps fast with beautiful design and no code",
    Category: "BUSINESS",
    Rating: 3.7,
    Reviews: 23729,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 14, 2018",
    "Current Ver": 7.2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "THE KING OF FIGHTERS-A 2012(F)",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 406511,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "October 21, 2016",
    "Current Ver": "1.0.5",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Text free - Free Text + Call",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 315390,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Diary with lock password",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 179139,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "November 1, 2017",
    "Current Ver": "3.5.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Fast like a Fox",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 104389,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "April 17, 2018",
    "Current Ver": "1.4.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Google Photos",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 10847682,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Scoompa Video - Slideshow Maker and Video Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 559931,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Girls Craft: Exploration",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 130689,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Simulation",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1.32,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "The PCH App",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 234971,
    Size: "81M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 25, 2018",
    "Current Ver": "2.8.7.78579",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Legend - Animate Text in Video",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 228737,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 12, 2016",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Resume Builder Free, 5 Minute CV Maker & Templates",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 72202,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 25, 2018",
    "Current Ver": 6,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AO Surgery Reference",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 2570,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 10, 2017",
    "Current Ver": "1.2.6",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ao",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 14145,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "June 8, 2016",
    "Current Ver": "1.0.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AO/OTA Fracture Classification",
    Category: "MEDICAL",
    Rating: 4.9,
    Reviews: 25,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 17, 2018",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "AO Player",
    Category: "EVENTS",
    Rating: 4,
    Reviews: 9,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "December 20, 2017",
    "Current Ver": "1.1.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ao Oni2",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 21223,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "April 20, 2018",
    "Current Ver": "1.6.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "A. O. Smith",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 32,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 21, 2018",
    "Current Ver": "3.0.22",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AO-EVENT",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 28, 2018",
    "Current Ver": "6.2.6",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Arena of Valor: 5v5 Arena Game",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 438911,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 28, 2018",
    "Current Ver": "1.23.1.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "PlacarTv Futebol Ao Vivo",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 2063,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 3, 2018",
    "Current Ver": "1.0.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Virtual lover",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 45771,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "June 8, 2018",
    "Current Ver": 1.39,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "The Hunt for the Lost Treasure",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 7148,
    Size: "8.1M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Adventure;Brain Games",
    "Last Updated": "September 13, 2017",
    "Current Ver": 1.8,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Attack the Light",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 19209,
    Size: "21M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Role Playing;Action & Adventure",
    "Last Updated": "February 23, 2016",
    "Current Ver": "1.1.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Princess Closet : Otome games free dating sim",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 29495,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.11.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Gravidez ao Vivo",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 61,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 11, 2014",
    "Current Ver": 1.5,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "365Scores - Live Scores",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 666246,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 29, 2018",
    "Current Ver": "5.5.9",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "PES 2018 PRO EVOLUTION SOCCER",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 1721943,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 27, 2018",
    "Current Ver": "2.3.2",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Mobile Legends: Bang Bang",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 8219586,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.2.97.3042",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Heroes of Order & Chaos",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 690148,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "October 27, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Kill Shot Bravo: Sniper FPS",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 579519,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "July 18, 2018",
    "Current Ver": 5.1,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Tennis Champion 3D - Online Sports Game",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 170973,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 6, 2018",
    "Current Ver": 2.1,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Carnivores: Dinosaur Hunter",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 62636,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 2, 2018",
    "Current Ver": "1.8.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "High School Simulator 2017",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 123136,
    Size: "80M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Simulation",
    "Last Updated": "June 25, 2018",
    "Current Ver": 1,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Hopeless Land: Fight for Survival",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 250197,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 12, 2018",
    "Current Ver": 1,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "SofaScore Live Score",
    Category: "SPORTS",
    Rating: 4.8,
    Reviews: 221722,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Virtual Cigarette Smoking (prank)",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 29838,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "June 28, 2018",
    "Current Ver": 2.2,
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Scanning body and undressing people",
    Category: "FAMILY",
    Rating: 3.4,
    Reviews: 1012,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "February 24, 2018",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Ultimate Tennis",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 183004,
    Size: "100M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 19, 2018",
    "Current Ver": "2.29.3118",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Legion of Heroes",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 143087,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.9.22",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Soccer Star 2018 Top Leagues · MLS Soccer Games",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 652940,
    Size: "90M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Sports",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.3.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Heroes Arena",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 336386,
    Size: "88M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "July 24, 2018",
    "Current Ver": "2.0.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "virtual lover 3D",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 5195,
    Size: "64M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "April 18, 2018",
    "Current Ver": 1.3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Range Master: Sniper Academy",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 91935,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "April 26, 2018",
    "Current Ver": "2.1.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DINO HUNTER: DEADLY SHORES",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 1381624,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "March 14, 2017",
    "Current Ver": "3.1.1",
    numInstall: 10000000,
    numAndroid: 3,
  },
  {
    App: "FC Barcelona Official App",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 92522,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 26, 2018",
    "Current Ver": "4.0.14",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Can Your Pet? : Returns - Teen",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 45370,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.59.8",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "GUYZ - Gay Chat & Gay Dating",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 41269,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "May 10, 2017",
    "Current Ver": "1.3.6.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Bubbu – My Virtual Pet",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 394842,
    Size: "75M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "August 4, 2018",
    "Current Ver": 1.5,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "3D Tennis",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 1008012,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "December 5, 2017",
    "Current Ver": "1.7.7",
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "Start the Hunt for the Lost Treasure",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 302,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "September 13, 2017",
    "Current Ver": 1.4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Treasure Hunt Hidden Objects Adventure Game",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1231,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "May 24, 2018",
    "Current Ver": 2.2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Scanning under clothes (prank)",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 1443,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "January 18, 2018",
    "Current Ver": 3,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "WGT Golf Game by Topgolf",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 148083,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.42.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "3D Holograms Joke",
    Category: "FAMILY",
    Rating: 2.9,
    Reviews: 31596,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "December 23, 2016",
    "Current Ver": 1.5,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Weaphones™ Gun Sim Free Vol 1",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 598975,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "January 17, 2018",
    "Current Ver": "2.4.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Hidden Objects Treasure Hunt Adventure Games",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 275,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 9, 2018",
    "Current Ver": "1.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Live Camera Viewer ★ World Webcam & IP Cam Streams",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4,
    Reviews: 64164,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "April 7, 2018",
    "Current Ver": 1.9,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Body scanner (prank)",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 16063,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "June 2, 2016",
    "Current Ver": 3,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "AP Mobile - Breaking News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 76616,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "May 25, 2017",
    "Current Ver": "4.4.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AP ENPS Mobile",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 22,
    Size: "545k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 8, 2016",
    "Current Ver": "8.0.0130",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "AP® Guide",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 3,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 31, 2017",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "WiFi Access Point (hotspot)",
    Category: "COMMUNICATION",
    Rating: 3.9,
    Reviews: 684,
    Size: "61k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 14, 2015",
    "Current Ver": "1.1.2",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "AP Mobile",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 117,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 21, 2017",
    "Current Ver": 1.03,
    numInstall: 10000,
    numAndroid: 6,
  },
  {
    App: "AP Manager",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 177,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 4, 2015",
    "Current Ver": "1.0.8",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "AP App for Android™",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.6,
    Reviews: 188,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 12, 2016",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Access Point Finder",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 22,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 6, 2016",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "AP English Language: Practice Tests and Flashcards",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 19,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.6.7.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "AP Mobile 104",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "December 13, 2017",
    "Current Ver": "1.2.2.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AP Planner",
    Category: "FAMILY",
    Rating: 2.9,
    Reviews: 45,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 3, 2015",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Access Point Browser",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 25,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 22, 2017",
    "Current Ver": 3.11,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AP Installer",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 23,
    Size: "283k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 20, 2018",
    "Current Ver": 13,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "Access Point Proximity",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 5,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 28, 2018",
    "Current Ver": "2.1.1",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Study AP World History",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 513,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 18, 2016",
    "Current Ver": "1.1.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "UniFi",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 11018,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.7.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Ap Video Downloader for fb New 2018",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 676,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.0.188",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AP Government Review",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 3,
    Size: "1.5M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 14, 2017",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "ap,wifi testing,iperf,ping,android,Bluetooth,tcp",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 3,
    Size: "5.3M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 27, 2018",
    "Current Ver": "1.0.15",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "HotSpot Tethering Free/WiFi AP",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 478,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 12, 2016",
    "Current Ver": 2.003,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "AP Chemistry Prep: Practice Tests and Flashcards",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 55,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.6.7.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AP Flashcards",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 88,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 30, 2015",
    "Current Ver": "1.3.14",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "AP World History: Practice Tests and Flashcards",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 21,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.6.7.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Access Point Names",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 138,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 12, 2014",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "AP Biology Prep: Practice Tests, Flashcards",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 87,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.6.7.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AP Biology Study Guide + Quiz",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 105,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 22, 2016",
    "Current Ver": "1.5.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Reuters News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 13166,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "June 6, 2018",
    "Current Ver": "3.4.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "500 AP World History Questions",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 7,
    Size: "1.2M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 1, 2013",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 1,
  },
  {
    App: "AP Themes for Kustom/KLWP",
    Category: "PERSONALIZATION",
    Rating: 3.6,
    Reviews: 5,
    Size: "45M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "September 1, 2017",
    "Current Ver": "1.8.2",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "AP Physics 1 Prep: Practice Tests and Flashcards",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 29,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.6.7.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Fate GO Ap Counter",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 70,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 19, 2018",
    "Current Ver": "1.1.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "iScore5 AP Psych",
    Category: "FAMILY",
    Rating: 2.9,
    Reviews: 10,
    Size: "73M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "April 25, 2017",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Glanceable Ap Watch Face",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 14, 2016",
    "Current Ver": "1.0.103",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "AP Psychology Prep: Practice Tests and Flashcards",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 242,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.6.7.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "meStudying: AP English Lit",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 1,
    Size: "655k",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 31, 2013",
    "Current Ver": 1.3,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "APN Settings",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 3743,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 3, 2018",
    "Current Ver": 6.4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AEE AP",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 4,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 7, 2018",
    "Current Ver": 1.01,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "AP Math & Computer Science",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 37,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 19, 2015",
    "Current Ver": 2.16,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "AP Series Solution Pro",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "7.4M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 30, 2017",
    "Current Ver": 1.3,
    numInstall: 0,
    numAndroid: 4,
  },
  {
    App: "AP Statistics Prep: Practice Tests and Flashcards",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 19,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.6.7.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "eChallan Andhra Pradesh (AP)",
    Category: "SOCIAL",
    Rating: 3,
    Reviews: 5,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "February 15, 2018",
    "Current Ver": "1.0.0.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AP Art History Flashcards",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 1,
    Size: "96M",
    Type: "Paid",
    Price: "$29.99",
    "Content Rating": "Mature 17+",
    Genres: "Education",
    "Last Updated": "January 19, 2016",
    "Current Ver": 3.3,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "True Skate",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 129409,
    Size: "73M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.5.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AP European History: Practice Tests and Flashcards",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 7,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.6.7.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AdventureQuest 3D MMO",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 22667,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.10.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AdventureQuest Dragons",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 10114,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "June 13, 2018",
    "Current Ver": "1.0.63",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AQ: First Contact",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Battle Gems (AdventureQuest)",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 48427,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Puzzle",
    "Last Updated": "March 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Undead Assault",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 4704,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "November 4, 2015",
    "Current Ver": "1.4.6",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "AQ Service",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 4,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 28, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "AQ wisdom +",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 15, 2018",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AQ SMS Notify",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 12, 2018",
    "Current Ver": "2.5.3",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "AQ Math Facts",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "16M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "May 17, 2017",
    "Current Ver": "1.0.3",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Adventure Quest World Mobile Quiz",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 28,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "January 16, 2018",
    "Current Ver": "3.1.6z",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Aqw&3d Design Notes Manager",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 11,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 15, 2017",
    "Current Ver": 3,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "AQ Aspergers Test",
    Category: "MEDICAL",
    Rating: 3.9,
    Reviews: 265,
    Size: "714k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 14, 2015",
    "Current Ver": "1.4.0",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Guess the Class 🔥 AQW",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 57,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "November 1, 2017",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Puffin Web Browser",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 541661,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 9, 2018",
    "Current Ver": "7.5.3.20547",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "AQ Ria Retail",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 4,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 3, 2018",
    "Current Ver": 1.1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Accounting Quiz (AQ) Malaysia",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 25,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AQ Guards",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 6, 2018",
    "Current Ver": "2.1.22",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Wowkwis aq Ka'qaquj",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 1,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "February 16, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "AQ Coach",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.1.0",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "AQ Dentals",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "December 22, 2017",
    "Current Ver": "1.0.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "AccuWeather: Daily Forecast & Live Weather Reports",
    Category: "WEATHER",
    Rating: 4.4,
    Reviews: 2052407,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "中国語 AQリスニング",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 21,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 22, 2016",
    "Current Ver": "2.4.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "ClanHQ",
    Category: "COMMUNICATION",
    Rating: 2.7,
    Reviews: 560,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.0.21",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "QuickShortcutMaker",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 41000,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "February 23, 2014",
    "Current Ver": "2.4.0",
    numInstall: 1000000,
    numAndroid: 1,
  },
  {
    App: "Moovit: Bus Time & Train Time Live Info",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.4,
    Reviews: 616742,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Iron Blade",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 161637,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.7.0m",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "QR Droid",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 349151,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "QR BARCODE SCANNER",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 169369,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 5, 2016",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Dungeon Boss – Strategy RPG",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 218881,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "March 28, 2018",
    "Current Ver": "0.5.10011",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Questland: Turn Based RPG",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 31134,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.10.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Order & Chaos 2: 3D MMO RPG",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 242722,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 9, 2018",
    "Current Ver": "3.1.2b",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Dungeon Quest",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 244039,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "June 4, 2018",
    "Current Ver": "3.0.5.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Dungeon Hunter 5 – Action RPG",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 720685,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "June 21, 2018",
    "Current Ver": "3.6.1a",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Grow Stone Online : 2d pixel RPG, MMORPG game",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 84389,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "August 5, 2018",
    "Current Ver": 1.375,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Evil Apples: A Dirty Card Game",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 137696,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Word",
    "Last Updated": "July 19, 2018",
    "Current Ver": "2.3.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Megatramp - a Story of Success!",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 322976,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "June 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Knightfall™ AR",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 254,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "March 17, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 7,
  },
  {
    App: "Ghost Snap AR Horror Survival",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 898,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "December 21, 2016",
    "Current Ver": "1.2.3.1",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "The Walking Dead: Our World",
    Category: "GAME",
    Rating: 4,
    Reviews: 22435,
    Size: "100M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.1.0.3",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Jurassic World™ Alive",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 308944,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Simulation",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.3.15",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Snaappy – 3D fun AR core communication platform",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 16801,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 16, 2018",
    "Current Ver": "1.5.341",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Sketchfab",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 906,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "March 9, 2018",
    "Current Ver": "0.46.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Ingress",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 391325,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "June 20, 2018",
    "Current Ver": "1.131.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "My Tamagotchi Forever",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 28735,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.12.0.1654",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Egg, Inc.",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 580160,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 13, 2018",
    "Current Ver": "1.7.5",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Houzz Interior Design Ideas",
    Category: "HOUSE_AND_HOME",
    Rating: 4.6,
    Reviews: 353813,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Flat Pack",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 862,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "March 16, 2018",
    "Current Ver": "1.0.4",
    numInstall: 100000,
    numAndroid: 7,
  },
  {
    App: "Crayola Color Blaster",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 17,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "March 13, 2018",
    "Current Ver": 1.5,
    numInstall: 1000,
    numAndroid: 7,
  },
  {
    App: "Guns of Boom - Online Shooter",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 1226514,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 20, 2018",
    "Current Ver": "4.4.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Guns Royale - Multiplayer Blocky Battle Royale",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 19070,
    Size: "90M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "August 4, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Build.com - Shop Home Improvement & Expert Advice",
    Category: "HOUSE_AND_HOME",
    Rating: 4.5,
    Reviews: 118,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 10, 2018",
    "Current Ver": "3.7.1",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "Wayfair - Shop All Things Home",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 20247,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.70.30",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "NYTimes - Latest News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.9,
    Reviews: 63640,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 1, 2018",
    "Current Ver": "6.19.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Overstock – Home Decor, Furniture Shopping",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 25717,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Stack It AR",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 1363,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "June 29, 2018",
    "Current Ver": "1.1.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ARuler - AR Ruler app, Measure tools",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 1602,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.1.7",
    numInstall: 100000,
    numAndroid: 7,
  },
  {
    App: "SNOW - AR Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 1017237,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 30, 2018",
    "Current Ver": "7.6.5",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Monster Park AR - Jurassic Dinosaurs in Real World",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 128,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 8, 2018",
    "Current Ver": "1.2.2.122",
    numInstall: 10000,
    numAndroid: 7,
  },
  {
    App: "AR Remote Car",
    Category: "FAMILY",
    Rating: 3.2,
    Reviews: 1354,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 12, 2017",
    "Current Ver": 2.14,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Solar System AR ( ARCore )",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 211,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 23, 2018",
    "Current Ver": "0.8.6",
    numInstall: 10000,
    numAndroid: 7,
  },
  {
    App: "Super AR",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 410,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "December 18, 2017",
    "Current Ver": 2.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Spacecraft AR",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 83,
    Size: "85M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 28, 2018",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 7,
  },
  {
    App: "Assemblr - Create 3D Models (Sandbox AR)",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 1745,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 17, 2018",
    "Current Ver": 2.25,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "MCRAFT AR - EDITOR",
    Category: "FAMILY",
    Rating: 3.4,
    Reviews: 131,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 24, 2018",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Jenga® AR",
    Category: "FAMILY",
    Rating: 2.9,
    Reviews: 53,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "March 17, 2018",
    "Current Ver": "1.0.1",
    numInstall: 10000,
    numAndroid: 7,
  },
  {
    App: "Nightenfell: Shared AR",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 20,
    Size: "65M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "March 27, 2018",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 7,
  },
  {
    App: "Portal AR - Step Into Scotland",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.7,
    Reviews: 25,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 4, 2018",
    "Current Ver": 1.4,
    numInstall: 5000,
    numAndroid: 7,
  },
  {
    App: "Arcraft - AR Sandbox",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 469,
    Size: "80M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "May 19, 2017",
    "Current Ver": 1.4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Augment - 3D Augmented Reality",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 25195,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 26, 2018",
    "Current Ver": "v3.4.0-3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Satellite AR",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.1,
    Reviews: 9636,
    Size: "93k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "September 22, 2011",
    "Current Ver": 2.4,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Figment AR",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 22,
    Size: "90M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 10, 2018",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 7,
  },
  {
    App: "AR Tank Battle",
    Category: "GAME",
    Rating: 3.6,
    Reviews: 153,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "December 31, 2016",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AR Dragon Pet",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "November 9, 2017",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Paint Space AR",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 17,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 7, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 7,
  },
  {
    App: "Just a Line - Draw Anywhere, with AR",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 1152,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 30, 2018",
    "Current Ver": "2.0.0",
    numInstall: 100000,
    numAndroid: 7,
  },
  {
    App: "AR Toybox - Augmented Reality Demos",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 20,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 17, 2017",
    "Current Ver": "1.0.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Mind Map AR, Augmented Reality ARCore Mind Mapping",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 29,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1.23,
    numInstall: 5000,
    numAndroid: 7,
  },
  {
    App: "【Miku AR Camera】Mikuture",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 36268,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "April 25, 2017",
    "Current Ver": "3.0.15",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AR Toys: Playground Sandbox | Remote Car",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 153,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 3, 2018",
    "Current Ver": 0.8,
    numInstall: 10000,
    numAndroid: 7,
  },
  {
    App: "Summer Camp Island AR",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 740,
    Size: "71M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.0.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "AR Sport Cars",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 284,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 10, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AS - News and sports results.",
    Category: "SPORTS",
    Rating: 3.7,
    Reviews: 20879,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 9, 2018",
    "Current Ver": "5.1.13",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "MARCA - Diario Líder Deportivo",
    Category: "SPORTS",
    Rating: 3.9,
    Reviews: 76340,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.3.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "AS - Diario online deportivo. Fútbol, motor y más",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 0,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 24, 2018",
    "Current Ver": 7.8,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "SleepCloud Backup for Sleep as Android",
    Category: "LIFESTYLE",
    Rating: 4.2,
    Reviews: 2563,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "AS Guía de las Ligas 2017-2018",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 4374,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "September 14, 2017",
    "Current Ver": "1.0.10",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Sleep as Android Unlock",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 23966,
    Size: "872k",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 27, 2018",
    "Current Ver": 20180608,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Sleep as Android Gear Addon",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.8,
    Reviews: 961,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "February 27, 2018",
    "Current Ver": 1.5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Sleep as Android Garmin Addon",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.6,
    Reviews: 114,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 20, 2018",
    "Current Ver": 20180620,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Sleep as Android: Sleep cycle tracker, smart alarm",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 246201,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Sonic the Hedgehog™ Classic",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 125652,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "June 18, 2018",
    "Current Ver": "3.3.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "The Aether: Life as a God",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 1407,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "March 12, 2018",
    "Current Ver": "1.0.5",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CAPTCHA Pack for Sleep as Android",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 448,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 8, 2018",
    "Current Ver": 1.3,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Pacific Navy Fighter C.E. (AS)",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 11379,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "July 29, 2018",
    "Current Ver": 1.4,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Lullaby Add-on for Sleep as Android",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.9,
    Reviews: 2057,
    Size: "6.2M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "October 18, 2017",
    "Current Ver": 2.4,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Sleep as Microsoft Band Add-On",
    Category: "LIFESTYLE",
    Rating: 3.5,
    Reviews: 28,
    Size: "121k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 23, 2016",
    "Current Ver": "1.0.0.8",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ear Agent: Super Hearing",
    Category: "COMMUNICATION",
    Rating: 3.7,
    Reviews: 42329,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Ninja Turtles: Legends",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 344283,
    Size: "95M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "December 18, 2017",
    "Current Ver": "1.11.39",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Timely Alarm Clock",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 258717,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 25, 2017",
    "Current Ver": "1.3.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "PDF Viewer & Book Reader",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 40437,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "February 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "My OldBoy! Free - GBC Emulator",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 51787,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "January 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "My Boy! Free - GBA Emulator",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 531074,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "January 9, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Google Voice",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 171052,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Choices: Stories You Play",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 807155,
    Size: "93M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "July 30, 2018",
    "Current Ver": "2.3.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Samsung Health",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.3,
    Reviews: 480208,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 31, 2018",
    "Current Ver": "5.17.2.009",
    numInstall: 500000000,
    numAndroid: 5,
  },
  {
    App: "WiFi Baby Monitor - NannyCam",
    Category: "VIDEO_PLAYERS",
    Rating: 4.1,
    Reviews: 29867,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "May 24, 2017",
    "Current Ver": "3.1.0 (build 1210)",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Maleficent Free Fall",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 450013,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 11, 2018",
    "Current Ver": "5.9.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Star Wars™: Force Arena",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 228130,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 19, 2018",
    "Current Ver": "3.1.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Runtastic Sleep Better: Sleep Cycle & Smart Alarm",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.1,
    Reviews: 111465,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Google Pay",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 348132,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.70.206190089",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Alarm Clock Plus★",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 155693,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 30, 2014",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Image 2 Wallpaper",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 81668,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 26, 2016",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "PS4 Second Screen",
    Category: "FAMILY",
    Rating: 2.4,
    Reviews: 11773,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 13, 2018",
    "Current Ver": "18.6.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Alarm Clock: Stopwatch & Timer",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 870928,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 8, 2018",
    "Current Ver": "5.9.6",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Ringtone Maker",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 495748,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "SAMURAI vs ZOMBIES DEFENSE",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 407788,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 18, 2013",
    "Current Ver": "3.4.0",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Seen",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 118285,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.2.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Google Allo",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 347086,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Plants vs. Zombies™ Heroes",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 379245,
    Size: "68M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "June 26, 2018",
    "Current Ver": "1.28.01",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "CM FILE MANAGER HD",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 144873,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 24, 2016",
    "Current Ver": "3.5.0",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Ringdroid",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 326232,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "December 3, 2016",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Twilight: Blue light filter",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 318134,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "May 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "AT&T THANKS®",
    Category: "FAMILY",
    Rating: 3.4,
    Reviews: 2445,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.4.0",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Galaxy at War Online",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 65119,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "May 22, 2018",
    "Current Ver": "2.1.0",
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Kingdoms at War: Hardcore PVP",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 34898,
    Size: "92M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "June 28, 2018",
    "Current Ver": 4.05,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Five Nights at Freddy's 4 Demo",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 889425,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 26, 2015",
    "Current Ver": 1.1,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Five Nights at Freddy's 3 Demo",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1041836,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "April 2, 2015",
    "Current Ver": 1.07,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Fandom: Five Nights at Freddys",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 17945,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "June 6, 2018",
    "Current Ver": "2.9.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "MLB At Bat",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 82857,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Nights at Cube Pizzeria 3D – 2",
    Category: "GAME",
    Rating: 4,
    Reviews: 47151,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "December 26, 2017",
    "Current Ver": "2.4.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "World at War: WW2 Strategy MMO",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 107765,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "May 25, 2018",
    "Current Ver": "3.1.9",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "HotelTonight: Book amazing deals at great hotels",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 57556,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Five Tries At Love Dating Sim",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 37165,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "February 14, 2018",
    "Current Ver": "5.1.0",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Rivals at War: 2084",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 174127,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "October 3, 2016",
    "Current Ver": 1.3,
    numInstall: 5000000,
    numAndroid: 3,
  },
  {
    App: "Multiple Videos at Same Time",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 4706,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "June 19, 2018",
    "Current Ver": "Z (Special Edition R9)",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Five Nights at Freddy's 2",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 73919,
    Size: "40M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "November 15, 2014",
    "Current Ver": 1.07,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Coloring Book at Five Nights",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 532,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "June 6, 2017",
    "Current Ver": 1.6,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Rivals at War: Firefight",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 344819,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "October 18, 2016",
    "Current Ver": 1.4,
    numInstall: 5000000,
    numAndroid: 3,
  },
  {
    App: "Five nights at Minecraft",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 9335,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 26, 2017",
    "Current Ver": 1.2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Five Nights at Freddy's",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 100805,
    Size: "50M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "December 2, 2014",
    "Current Ver": 1.85,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Nights at Cube Pizzeria 3D – 3",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 15875,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "March 3, 2017",
    "Current Ver": 1.5,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "7 Nights at Pixel Pizzeria - 2",
    Category: "GAME",
    Rating: 4,
    Reviews: 23168,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "July 9, 2018",
    "Current Ver": "1.3.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Nights at Slender Pizzeria 3D",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 2628,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "May 22, 2017",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DIRECTV",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 235486,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 1, 2018",
    "Current Ver": "5.9.006",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "One Night at Golden Freddy's",
    Category: "GAME",
    Rating: 3.3,
    Reviews: 2717,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "December 7, 2017",
    "Current Ver": 0.1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "DIRECTV for Tablets",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 24123,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 1, 2018",
    "Current Ver": "5.9.006",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Nights at Cube Pizzeria 3D – 4",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 7728,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.5.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Five Nights at Neighbor House",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 2180,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "January 26, 2018",
    "Current Ver": "1.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Asylum Night Shift - Five Nights Survival",
    Category: "GAME",
    Rating: 4,
    Reviews: 59223,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 26, 2018",
    "Current Ver": "1.6.5",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Five Nights at Freddy's: SL",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 16162,
    Size: "99M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "April 6, 2017",
    "Current Ver": 1.2,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Two Nights at jumpscare",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 596,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "August 17, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Five Nights at Pizzeria",
    Category: "GAME",
    Rating: 3.5,
    Reviews: 1976,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "March 3, 2018",
    "Current Ver": 1.6,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Block Battles: Heroes at War - Multiplayer PVP",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 6698,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "May 14, 2016",
    "Current Ver": "1.0.1",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Five Nights at Freddy's 4",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 21266,
    Size: "45M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 26, 2015",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Five Nights at Flappy's",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 4041,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "June 27, 2017",
    "Current Ver": "1.5.14",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "5 Nights at Cube Pizzeria City",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 2691,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "February 22, 2017",
    "Current Ver": 1.2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Five Nights at Freddy's 3",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 27856,
    Size: "50M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "April 2, 2015",
    "Current Ver": 1.07,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Undertale AU Amino",
    Category: "SOCIAL",
    Rating: 4.8,
    Reviews: 5369,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 13, 2018",
    "Current Ver": "1.8.19106",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "au",
    Category: "FAMILY",
    Rating: 3.2,
    Reviews: 9126,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "June 8, 2016",
    "Current Ver": "1.0.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Audiobooks from Audible",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 568922,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Au Mobile: Audition Chính Hiệu",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 85278,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Music",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.8.0716",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AU Mobile Indonesia",
    Category: "GAME",
    Rating: 3.6,
    Reviews: 16521,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music",
    "Last Updated": "May 9, 2018",
    "Current Ver": "1.8.0502",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Au Bon Pain",
    Category: "FOOD_AND_DRINK",
    Rating: 3.7,
    Reviews: 70,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 23, 2018",
    "Current Ver": 1.4,
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Au Pair Legend",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 28,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 19, 2018",
    "Current Ver": 3.5,
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Super Dancer",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 91667,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 24, 2018",
    "Current Ver": 3.3,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "AU Results - AU COE Corner",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 664,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 14, 2017",
    "Current Ver": "2.2.5",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "view.com.au - Buy, Rent or Research Real Estate",
    Category: "LIFESTYLE",
    Rating: 3.1,
    Reviews: 212,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 26, 2017",
    "Current Ver": "2.1.4",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Au Weather Free",
    Category: "WEATHER",
    Rating: 4,
    Reviews: 1185,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "June 18, 2018",
    "Current Ver": "2.47.2",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "BringGo AU & NZ",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 2.8,
    Reviews: 440,
    Size: "23M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "May 10, 2018",
    "Current Ver": "2.5.9",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "AU Spark",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 681,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": 5.06,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Rugby AU",
    Category: "SPORTS",
    Rating: 2.7,
    Reviews: 17,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "December 21, 2017",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Learners Test Free: AU Driver Knowledge Test (DKT)",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 623,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 26, 2018",
    "Current Ver": 3.5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "realestate.com.au - Buy, Rent & Sell Property",
    Category: "HOUSE_AND_HOME",
    Rating: 3.8,
    Reviews: 14657,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Au-allstar for KR",
    Category: "GAME",
    Rating: 3.6,
    Reviews: 2433,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music",
    "Last Updated": "June 15, 2018",
    "Current Ver": "1.6.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "STUCOR - AU",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 1827,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 5, 2018",
    "Current Ver": 1.3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "loans.com.au Smart Money",
    Category: "FINANCE",
    Rating: 3.5,
    Reviews: 30,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 27, 2018",
    "Current Ver": "1.4.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AU Students Zone (Result 2016)",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 97,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 1, 2016",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Top #5 Bσσkie in AU",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "10.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "December 6, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AU Results 2017 Auzone",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 762,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 1, 2017",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Au Pair",
    Category: "SOCIAL",
    Rating: 3.6,
    Reviews: 58,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "August 14, 2017",
    "Current Ver": "1.3.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AU Call Blocker - Block Unwanted Calls Texts 2018",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 16,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 24, 2018",
    "Current Ver": "1.0.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "realcommercial.com.au",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 128,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 26, 2018",
    "Current Ver": "2.6.1",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "Powershop AU",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 498,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.35.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Australia Newspapers - AU News Apps",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.7,
    Reviews: 48,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 8, 2018",
    "Current Ver": "7.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "news.com.au",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 23, 2018",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Media Sosial TNI AU",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 88,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "January 24, 2018",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Dance On Mobile",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 23609,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "April 13, 2018",
    "Current Ver": 1.26,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Super Dancer VN",
    Category: "GAME",
    Rating: 4,
    Reviews: 24312,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music",
    "Last Updated": "July 22, 2018",
    "Current Ver": 3.3,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Alerte au gogol",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 14,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 9, 2018",
    "Current Ver": "1.0.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Neuvaine au Saint-Esprit",
    Category: "LIFESTYLE",
    Rating: 4.7,
    Reviews: 57,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 18, 2017",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Neuvaines et prières au Coeur Sacré de Jésus",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 17,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 5, 2017",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "SMS Au revoir",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 17,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 15, 2018",
    "Current Ver": "2.0.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "allhomes.com.au",
    Category: "HOUSE_AND_HOME",
    Rating: 3.8,
    Reviews: 874,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.13.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Jobs in Canada - Emplois au Canada",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 2,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Business",
    "Last Updated": "August 5, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Predator Calls for Hunting AU",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 27,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 3, 2016",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Romance et Mystères au Lycée",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 350,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "February 23, 2017",
    "Current Ver": "1.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Au Rubis les bijoutiers",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.00.33",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Love Dance",
    Category: "GAME",
    Rating: 4,
    Reviews: 29462,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Music",
    "Last Updated": "June 14, 2018",
    "Current Ver": "1.1.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "mon guide au bank populaire -infos et instructions",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 4,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Finance",
    "Last Updated": "June 13, 2018",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Avatar Musik",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 159063,
    Size: "85M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music",
    "Last Updated": "February 9, 2018",
    "Current Ver": "0.8.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Job'Of - Emploi au Cameroun",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 294,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 5, 2018",
    "Current Ver": "4.1.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Mali 7 - Actualités au Mali",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 697,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "April 8, 2017",
    "Current Ver": 2.4,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Gâteau au yaourt",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 38,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "June 9, 2018",
    "Current Ver": "1.1.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AVG AntiVirus 2018 for Android Security",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 6207063,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "AV Tools",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 631,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 22, 2016",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Total AV",
    Category: "PRODUCTIVITY",
    Rating: 3.4,
    Reviews: 617,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 17, 2018",
    "Current Ver": "1.5.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "日本AV历史",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.1,
    Reviews: 215,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "March 6, 2018",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AV Buddy Free",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 25,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 8, 2017",
    "Current Ver": 1.2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "AV HD Video Player",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 6,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 19, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AV Tools Pro",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 35,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 22, 2016",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "Avakin Life - 3D virtual world",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 1275373,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.021.10",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "AV-IPTV",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 43,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "April 27, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Video Player All Format",
    Category: "VIDEO_PLAYERS",
    Rating: 4.8,
    Reviews: 258277,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "HD Video Player (wmv,avi,mp4,flv,av,mpg,mkv)2017",
    Category: "VIDEO_PLAYERS",
    Rating: 3.3,
    Reviews: 171,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 10, 2017",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Baby Monitor AV",
    Category: "COMMUNICATION",
    Rating: 3.3,
    Reviews: 1434,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "March 6, 2014",
    "Current Ver": "1.2.5",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "HD Video Player - Video & MP3 Player | AV Player |",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 22,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "March 6, 2018",
    "Current Ver": "1.0.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Remote for Onkyo AV Receivers & Smart TV/Blu-Ray",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 701,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Cow V3.15",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "LG AV REMOTE",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 2420,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 3, 2016",
    "Current Ver": "1.1.8",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "App Seguridad AV Villas",
    Category: "FINANCE",
    Rating: 2.3,
    Reviews: 251,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "October 12, 2017",
    "Current Ver": "1.0.5",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Gogo Vision (Biz Av)",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 11,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 23, 2017",
    "Current Ver": "3.4.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ai-Ball AV Recorder",
    Category: "PHOTOGRAPHY",
    Rating: 2.7,
    Reviews: 90,
    Size: "4.0M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "October 19, 2017",
    "Current Ver": 13,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "AV Phone",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 4,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 9, 2018",
    "Current Ver": "2.1.9",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Norton Security and Antivirus",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 1170641,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 26, 2018",
    "Current Ver": "4.2.1.4174",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "AV Pro Voice Changer",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 174,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 29, 2016",
    "Current Ver": "1.0.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Remote For Pioneer AV Receivers and Blu-Ray",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 150,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 1, 2018",
    "Current Ver": "Cow V3.11",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "AV Phonetics",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 259,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 22, 2017",
    "Current Ver": "1.3.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AV MAX",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 9,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 18, 2018",
    "Current Ver": "7.2.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Kaspersky Mobile Antivirus: AppLock & Web Security",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 2598579,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 24, 2018",
    "Current Ver": "11.17.4.1024",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Mobile Security: Antivirus, Web Scan & App Lock",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 574719,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 16, 2018",
    "Current Ver": "5.0.0.1442",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "MyAV Remote for Denon & Marantz AV Receivers",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 250,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Cow V3.15",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EML UPnP-AV Control Point",
    Category: "VIDEO_PLAYERS",
    Rating: 3,
    Reviews: 78,
    Size: "322k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "September 19, 2013",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "Kinot & Eichah for Tisha B'Av",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 98,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 4, 2014",
    "Current Ver": 1.5,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Samsung TV AV Guide 2016",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 27,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 17, 2016",
    "Current Ver": "1.1.6",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Professional AV Solution & Products information",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 24,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 12, 2017",
    "Current Ver": "2.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AV High School District",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 91,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 5, 2018",
    "Current Ver": "5.2.002",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Bitdefender Antivirus Free",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 78629,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 20, 2018",
    "Current Ver": "3.4.406",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "DEER HUNTER 2018",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 955614,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 26, 2018",
    "Current Ver": "5.1.2",
    numInstall: 10000000,
    numAndroid: 3,
  },
  {
    App: "Kinot Tisha'a Be'av - Ashkenaz",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 82,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 26, 2015",
    "Current Ver": 2.1,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "AV Anthony's",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 0,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.0.136",
    numInstall: 50,
    numAndroid: 6,
  },
  {
    App: "Avast Cleanup & Boost, Phone Cleaner, Optimizer",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 648380,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.6.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "AW - free video calls and chat",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 7317,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "July 4, 2018",
    "Current Ver": "1.0.08.73",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Aw Restaurant",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 4,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "February 6, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Nougat Android 7 Launcher : AW",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 17, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "AW Screen Recorder No Root",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 1659,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 6, 2017",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "A&W Restaurants",
    Category: "FOOD_AND_DRINK",
    Rating: 1.7,
    Reviews: 14,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "June 6, 2018",
    "Current Ver": "2.7.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Add Watermark Free",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 18325,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "September 3, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "AW Tozer Devotionals - Daily",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.2,
    Reviews: 8,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "October 7, 2016",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "AW Toolbox",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 3,
    Size: "13M",
    Type: "Paid",
    Price: "$19.90",
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "December 22, 2016",
    "Current Ver": "1.6.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Analog Clock AW Plus-7",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 725,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 14, 2018",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Analog Clock AW-7",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 2158,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 7, 2018",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "MediBeat for AW - Android (1)",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "October 24, 2017",
    "Current Ver": "0.9.16",
    numInstall: 500,
    numAndroid: null,
  },
  {
    App: "Armored Warfare: Assault",
    Category: "GAME",
    Rating: 4,
    Reviews: 7718,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.0-a22936.127",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Watch AW-7",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 249,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 17, 2018",
    "Current Ver": 2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "AW TeamUp",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.6,
    Reviews: 9,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 4, 2018",
    "Current Ver": "1.0.3",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Auction Wars : Storage King",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 29062,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casino",
    "Last Updated": "September 15, 2017",
    "Current Ver": 2.1,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "AW Training",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 11,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 5, 2018",
    "Current Ver": "3.3.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Digital Clock AW-7",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 484,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 6, 2018",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Analog and Digital Clock AW-7",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 202,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 15, 2018",
    "Current Ver": 2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "AW Connect",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 26, 2018",
    "Current Ver": "3.0.10",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Analog Clock AW-7 PRO",
    Category: "TOOLS",
    Rating: 3.3,
    Reviews: 40,
    Size: "2.7M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 7, 2018",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AW Reader: news & apps [Dutch]",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 1948,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "February 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "AW",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "August 28, 2015",
    "Current Ver": "Varies with device",
    numInstall: 5,
    numAndroid: null,
  },
  {
    App: "AW CAMERA",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 2,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 30, 2018",
    "Current Ver": "3.1.1",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "AW Browser with Chrome Custom Tabs",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 9,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 17, 2018",
    "Current Ver": 2.7,
    numInstall: 500,
    numAndroid: 6,
  },
  {
    App: "Analog and Digital Clock AW-7PRO",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 4,
    Size: "2.7M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 15, 2018",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AW Radio",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 24, 2015",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Roman Clock AW-7",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 52,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 17, 2018",
    "Current Ver": 2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Square Analog Clock AW-7",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 294,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 10, 2018",
    "Current Ver": 2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "iSniper 3D Arctic Warfare",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 35572,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "September 4, 2013",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "AirWatch Agent",
    Category: "BUSINESS",
    Rating: 3.1,
    Reviews: 20973,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 1, 2018",
    "Current Ver": "8.2.0.84",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Handbreit by a.w.niemeyer",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 21,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 31, 2017",
    "Current Ver": "3.9.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Tozer Devotional -Series 1",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 5,
    Reviews: 5,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "October 8, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Modern Action Commando 3D",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 492,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "April 6, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "HCP Anywhere",
    Category: "BUSINESS",
    Rating: 4.7,
    Reviews: 114,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 30, 2018",
    "Current Ver": "3.1.0.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Call of Duty®: Heroes",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 1604146,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 27, 2018",
    "Current Ver": "4.8.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Ultimate Watch 2 watch face",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 285,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 4, 2018",
    "Current Ver": "2.5.21",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "Amber Weather",
    Category: "WEATHER",
    Rating: 4.4,
    Reviews: 260137,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Weather",
    "Last Updated": "July 16, 2018",
    "Current Ver": "3.8.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Advanced Warfare Guns",
    Category: "FAMILY",
    Rating: 2.9,
    Reviews: 2079,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 6, 2015",
    "Current Ver": "1.2.2",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "AirWatch Inbox",
    Category: "BUSINESS",
    Rating: 2.7,
    Reviews: 8346,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "September 20, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "News.aw",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 1,
    Size: "1.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 15, 2015",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "Pujie Black Watch Face for Android Wear OS",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 7264,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "November 16, 2017",
    "Current Ver": "3.6.46",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Bits Watch Face",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 6205,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "February 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Video Editor",
    Category: "VIDEO_PLAYERS",
    Rating: 3.8,
    Reviews: 1156,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "October 20, 2015",
    "Current Ver": "1.3.9b",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "The Pursuit of God",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.8,
    Reviews: 6,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "February 14, 2017",
    "Current Ver": 5,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Food-Aw - Order Food Online in Aruba",
    Category: "FOOD_AND_DRINK",
    Rating: 5,
    Reviews: 1,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "April 5, 2018",
    "Current Ver": 10,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "F05WatchFace for Android Wear",
    Category: "PRODUCTIVITY",
    Rating: 3.9,
    Reviews: 127,
    Size: "5.9M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 24, 2017",
    "Current Ver": "7.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "ByssWeather for Wear OS",
    Category: "WEATHER",
    Rating: 4.2,
    Reviews: 19666,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "April 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "AW - Le News di AndroidWorld",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 2808,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "February 8, 2016",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Anime Expo 2018",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 54,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 8, 2018",
    "Current Ver": 2.1,
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Adventure Xpress",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 24775,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Puzzle",
    "Last Updated": "October 12, 2015",
    "Current Ver": "1.2.1",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "AXE.IO - Brutal Survival Battleground",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 3845,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.6.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Dynamics AX",
    Category: "BUSINESS",
    Rating: 3.7,
    Reviews: 244,
    Size: "976k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 26, 2015",
    "Current Ver": 3.3,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "AX Player -Nougat Video Player",
    Category: "VIDEO_PLAYERS",
    Rating: 4.1,
    Reviews: 15765,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "September 12, 2014",
    "Current Ver": 2,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Armani Exchange Connected",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 305,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 4, 2017",
    "Current Ver": "1.5.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Axe Champ",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 141,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 26, 2018",
    "Current Ver": "1.0.6",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AX Battery Saver",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 4546,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 8, 2018",
    "Current Ver": "1.2.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Axe Champ Hit",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 1,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 25, 2018",
    "Current Ver": 0.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Axe Champion",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 21,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 28, 2018",
    "Current Ver": 0.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Vikings Stickman Axe Fighting",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 924,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "October 21, 2017",
    "Current Ver": "1.5.2",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "AX Video Player",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 569,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "November 11, 2015",
    "Current Ver": "1.0.9",
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "Katalogen.ax",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "172k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "October 2, 2014",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Axe",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 18,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "December 1, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Axetatic - Axe Throwing Game",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 29,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "October 22, 2017",
    "Current Ver": "1.3.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Axe Champs! Wars",
    Category: "GAME",
    Rating: 5,
    Reviews: 8,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "June 26, 2018",
    "Current Ver": 1.1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Tips Microsoft Dynamics Ax",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 8, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Axe Knight",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 52,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "June 26, 2018",
    "Current Ver": "1.0.5",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "AX Timesheets App for Dynamics",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 15, 2018",
    "Current Ver": "1.0.5",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Axxess AX-DSP",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 17,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 4, 2018",
    "Current Ver": "3_1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "AX Window",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 10, 2017",
    "Current Ver": "1.0.2",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Axxess Updater",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 56,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 19, 2016",
    "Current Ver": "1.3.2",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "The Vikings",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 15806,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.0.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Axe Spinner",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 2,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "January 4, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "INTERACTIVE CALCULUS PRO",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.3M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 22, 2018",
    "Current Ver": 1.2,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Knife&Axe Throwing",
    Category: "GAME",
    Rating: 3.1,
    Reviews: 440,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "November 26, 2012",
    "Current Ver": "1.0.6",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Stickman and Axe",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 69,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "November 25, 2017",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Axe Throw: Flip Champ Axes Champion Throwing Games",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 1,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 31, 2018",
    "Current Ver": "1.0.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Q7 SmartWatch",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3,
    Reviews: 94,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "1.0.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Workflow Approvals App AX 2012",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.6(3)-demo",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Tips & Tricks Dynamics AX 365",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 14, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Axe Man",
    Category: "GAME",
    Rating: 3.7,
    Reviews: 53,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "February 23, 2015",
    "Current Ver": 3,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "AX Watch for WatchMaker",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 2,
    Size: "238k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 18, 2017",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 2,
  },
  {
    App: "Throw Knife",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 291,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "September 14, 2017",
    "Current Ver": 2.04,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dead Zombie Evil Killer:Axe",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 71,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "December 1, 2016",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "INTERACTIVE CALCULUS FOR MATHS AND PHYSICS",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 53,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 28, 2018",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AX-PIC Pedidos",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "AX!OM",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 5,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "February 16, 2017",
    "Current Ver": 1.3,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Zlax.io Zombs Luv Ax",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 6344,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "April 4, 2018",
    "Current Ver": 1.7,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "AX Selfie",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 10,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 31, 2015",
    "Current Ver": "1.0.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Ax 3 Domaines",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 12,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "January 26, 2018",
    "Current Ver": "5.0.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Clash of Axe: Flippy Lumberjack Action X",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 6,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "September 14, 2017",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Flippy Axe : Flip The Knife & Axe Simulator",
    Category: "GAME",
    Rating: 5,
    Reviews: 7,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "September 27, 2017",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Axe Clicker",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 10446,
    Size: "64M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 13, 2018",
    "Current Ver": "1.0.142",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Cyborg AX-001",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "June 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50,
    numAndroid: null,
  },
  {
    App: "Axe Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 9,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "February 3, 2017",
    "Current Ver": 2.6,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Woodman Deluxe",
    Category: "GAME",
    Rating: 4,
    Reviews: 82,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 6, 2015",
    "Current Ver": "1.0.2",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Ay",
    Category: "VIDEO_PLAYERS",
    Rating: 3.8,
    Reviews: 11,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "May 4, 2018",
    "Current Ver": "1.0.261",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "A-Y Collection",
    Category: "SHOPPING",
    Rating: 5,
    Reviews: 2,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "February 16, 2018",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AY Sing",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.8,
    Reviews: 111,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 21, 2018",
    "Current Ver": "1.6.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Ay Up",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 11,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "October 27, 2015",
    "Current Ver": "3.0.0",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "AY Recorder - Screen Recorder, Live, Video Editor",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 12,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 15, 2017",
    "Current Ver": 2.2,
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "¡Ay Caramba!",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "549k",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 13, 2014",
    "Current Ver": 1.2,
    numInstall: 1,
    numAndroid: 3,
  },
  {
    App: "Ay Sabz Gunbad Waly",
    Category: "VIDEO_PLAYERS",
    Rating: "NaN",
    Reviews: 4,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "September 11, 2017",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ay Yıldız - Xperia Live Theme",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.9M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 26, 2017",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "25 Mins Ako ay may lobo Etc Pinoy Kid Song Offline",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "July 29, 2018",
    "Current Ver": 3,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "camera zoom moon",
    Category: "PHOTOGRAPHY",
    Rating: 3.7,
    Reviews: 1213,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "January 23, 2018",
    "Current Ver": 1.06,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Ako ay may lobo Pinoy Kid Song Offline",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "July 30, 2018",
    "Current Ver": 3,
    numInstall: 1,
    numAndroid: 2,
  },
  {
    App: "Ay Yıldız Analog Saat",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 37,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 21, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ay Telekom Oim",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 6,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "February 17, 2018",
    "Current Ver": "1.0.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Holy Quran Mehmet Emin Ay",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 649,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 14, 2017",
    "Current Ver": "1.3.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Ay Yıldız Duvar Kağıtları",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 3,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 10, 2017",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ay Hasnain k Nana Milad Naat",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.3,
    Reviews: 72,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "December 21, 2015",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Mehmet Emin Ay İlahileri",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 13, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "¡Ay Metro!",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 489,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "March 17, 2015",
    "Current Ver": "1.0.3.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AY Oakmont",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "4.2.2",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "YAKALA AY",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 0,
    Size: "14M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 7, 2018",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Lunar Calendar",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 484,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Mature 17+",
    Genres: "Lifestyle",
    "Last Updated": "July 17, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "Pinoy Kid Song Ako ay may Lobo",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 23,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 12, 2016",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Lunar Calendar Lite",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 2954,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Lifestyle",
    "Last Updated": "July 17, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Ay Mohabbat Teri Khatir Novel",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.2,
    Reviews: 27,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "January 30, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AY Recruitment",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.1.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Quran Khmer Offline AY",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 41,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 13, 2017",
    "Current Ver": 10.6,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ay Yıldız Keyboard",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 26,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 23, 2018",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AY EMLAK",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 8,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Business",
    "Last Updated": "July 11, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Ay Vamos - PJ. Balvin - Piano",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 9, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Google Play Games",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 7168735,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000000,
    numAndroid: null,
  },
  {
    App: "Ay Peruk",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 31, 2017",
    "Current Ver": "1.1.0",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Sun & Moon AR Locator",
    Category: "WEATHER",
    Rating: 3.3,
    Reviews: 115,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "February 23, 2017",
    "Current Ver": 1.4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Display Phone Screen On TV",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 9895,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 3, 2017",
    "Current Ver": 2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "San Andreas Crime Stories",
    Category: "GAME",
    Rating: 4,
    Reviews: 162530,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Racing",
    "Last Updated": "July 2, 2018",
    "Current Ver": "1.0.0.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Masha and The Bear",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 39779,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors;Music & Video",
    "Last Updated": "August 5, 2016",
    "Current Ver": "4.0.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Miami crime simulator",
    Category: "GAME",
    Rating: 4,
    Reviews: 254518,
    Size: "100M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "July 9, 2018",
    "Current Ver": 2,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ai.type Free Emoji Keyboard",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 647721,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Strange Hero: Future Battle",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 88901,
    Size: "73M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "May 24, 2018",
    "Current Ver": "11.0.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Gangster Town: Vice District",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 65146,
    Size: "100M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Simulation",
    "Last Updated": "May 31, 2018",
    "Current Ver": 2.1,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "iMediaShare – Photos & Music",
    Category: "VIDEO_PLAYERS",
    Rating: 4.2,
    Reviews: 104551,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "December 19, 2017",
    "Current Ver": "1.0.10",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Earth & Moon in HD Gyro 3D Parallax Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 66321,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 11, 2018",
    "Current Ver": 2.4,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Mad Day - Truck Distance Game",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 29270,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.4.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "AZ Screen Recorder - No Root",
    Category: "VIDEO_PLAYERS",
    Rating: 4.6,
    Reviews: 751911,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "AZ Browser. Private & Download",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 1520,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "December 31, 2016",
    "Current Ver": 1.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "AZ Lottery Players Club",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 97,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 9, 2018",
    "Current Ver": "2.0.0(9)",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AZ Plugin 2 (newest)",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.2,
    Reviews: 11087,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "March 16, 2017",
    "Current Ver": "4.1.4",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Kids A-Z",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 26426,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.1.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AZ Camera - Manual Pro Cam",
    Category: "PHOTOGRAPHY",
    Rating: 3.4,
    Reviews: 2332,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 28, 2015",
    "Current Ver": 2.2,
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "A-Z App Store",
    Category: "PRODUCTIVITY",
    Rating: 3.2,
    Reviews: 2728,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 5, 2016",
    "Current Ver": "1.0.5",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "AZ Screen Recorder pro",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 60,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 19, 2018",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "Permit Test AZ Arizona MVD DOT",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 227,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 12, 2017",
    "Current Ver": "2.9.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AZ PLAYER HD",
    Category: "TOOLS",
    Rating: 3.2,
    Reviews: 24,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 11, 2016",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Long Realty AZ Home Search",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 132,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 6, 2018",
    "Current Ver": "5.805.180306",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "NB|AZ Mobile Banking",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 463,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 5, 2018",
    "Current Ver": "4.2.31",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Movie Downloader Torrent : Az Torrent",
    Category: "VIDEO_PLAYERS",
    Rating: 4.7,
    Reviews: 70,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 7, 2018",
    "Current Ver": 1.9,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "A-Z Screen Recorder -",
    Category: "VIDEO_PLAYERS",
    Rating: "NaN",
    Reviews: 17,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 23, 2018",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "AZ Immune Related AEManagement",
    Category: "MEDICAL",
    Rating: 3.7,
    Reviews: 3,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 24, 2018",
    "Current Ver": 1.4,
    numInstall: 500,
    numAndroid: 3,
  },
  {
    App: "Alphabet A-Z",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 306,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "April 17, 2014",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "AZ Rockets",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 162,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.2.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "NB|AZ Business Mobile Banking",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 44,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 5, 2018",
    "Current Ver": "4.2.31",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Az Content",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 24,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 5, 2018",
    "Current Ver": "1.0.15",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Catalyst AZ",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 12,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Education",
    "Last Updated": "June 27, 2018",
    "Current Ver": "3.8.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Casino AZ/Talking Stick Resort",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 201,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 16, 2018",
    "Current Ver": "7.9.2.6",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Graffiti Letters (A-Z)",
    Category: "LIFESTYLE",
    Rating: 3.9,
    Reviews: 386,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "February 18, 2017",
    "Current Ver": "2.1.5",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "GPS.AZ",
    Category: "MAPS_AND_NAVIGATION",
    Rating: "NaN",
    Reviews: 30,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "April 2, 2015",
    "Current Ver": "1.0.10",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "First Credit Union (AZ) Mobile",
    Category: "FINANCE",
    Rating: 3.5,
    Reviews: 100,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 13, 2017",
    "Current Ver": "3.0.830",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Arizona Mobile",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 285,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 7, 2017",
    "Current Ver": 4.7,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AZ Mobile Gizmo",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 16,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 2, 2018",
    "Current Ver": "3.4.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Az Video Status",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 13,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.0.4",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Arizona Statutes, ARS (AZ Law)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.9,
    Reviews: 9,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "October 18, 2017",
    "Current Ver": 1.6,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Explore Sedona & Northern AZ",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.8,
    Reviews: 43,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "March 7, 2017",
    "Current Ver": "16.51.1",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Arizona DMV Permit Test - AZ",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 109,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 15, 2018",
    "Current Ver": "6.0.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Oxford A-Z of English Usage",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4,
    Reviews: 5300,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "November 28, 2017",
    "Current Ver": "9.1.284",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Cures A-Z",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4,
    Reviews: 265,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 13, 2015",
    "Current Ver": 2.1,
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "AZ Practice Test & Questions",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 13,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 23, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Arizona Trail",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.7,
    Reviews: 65,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "April 6, 2017",
    "Current Ver": "6.0.19",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Ultrasound A-Z",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 112,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 5, 2018",
    "Current Ver": 1.5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "A-Z Punjabi Songs & Music Videos 2018",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 367,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 17, 2018",
    "Current Ver": "1.0.19",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Manga AZ - Manga Comic Reader",
    Category: "COMICS",
    Rating: 3.3,
    Reviews: 126,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.0.4",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Barista Coffee Dictionary A-Z",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 127,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 3, 2016",
    "Current Ver": "3.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Phoenix and Arizona Cameras",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 134,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 20, 2018",
    "Current Ver": "6.3.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AZ REMOTE CONTROL",
    Category: "TOOLS",
    Rating: 2.1,
    Reviews: 149,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 28, 2016",
    "Current Ver": 1.9,
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "Greater London A-Z 2016",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.7,
    Reviews: 40,
    Size: "9.0M",
    Type: "Paid",
    Price: "$8.49",
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 18, 2016",
    "Current Ver": "1.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "British Airways",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 25726,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 24, 2018",
    "Current Ver": 4.2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ba Financial Calculator plus",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 31,
    Size: "206k",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 15, 2018",
    "Current Ver": "2.9.1",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Financial Calculator BA Chien.",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 23,
    Size: "954k",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "December 14, 2016",
    "Current Ver": "1.9.10",
    numInstall: 500,
    numAndroid: 3,
  },
  {
    App: "BA4You",
    Category: "BUSINESS",
    Rating: 2.1,
    Reviews: 87,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 26, 2018",
    "Current Ver": "1.6.0.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "BA Pro Financial Calculator",
    Category: "FINANCE",
    Rating: 2.4,
    Reviews: 36,
    Size: "9.4M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "November 16, 2015",
    "Current Ver": "1.3.3",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "BA Calculator",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 22,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 22, 2018",
    "Current Ver": "1.2.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "ba",
    Category: "FAMILY",
    Rating: 3.1,
    Reviews: 1734,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "June 8, 2016",
    "Current Ver": "1.0.3",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Ra Ga Ba",
    Category: "GAME",
    Rating: 5,
    Reviews: 2,
    Size: "20M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "February 8, 2017",
    "Current Ver": "1.0.4",
    numInstall: 1,
    numAndroid: 2,
  },
  {
    App: "Experience BA",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 6,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 27, 2018",
    "Current Ver": "2.2.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ba Cristi",
    Category: "GAME",
    Rating: 3.5,
    Reviews: 196,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "March 22, 2016",
    "Current Ver": "1.0.4",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Ba ba black sheep offline Video",
    Category: "PARENTING",
    Rating: 4.2,
    Reviews: 20,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "July 2, 2017",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BA SALES",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 31, 2018",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Goody.ba",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 303,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 22, 2018",
    "Current Ver": "2.0.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BA Status",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 13, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Alif Ba Ta Bullseye",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "16M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "May 30, 2016",
    "Current Ver": 1.1,
    numInstall: 5,
    numAndroid: 2,
  },
  {
    App: "BA Accesible",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 31,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 19, 2016",
    "Current Ver": "0.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Learn alif ba ta",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 23,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "November 28, 2017",
    "Current Ver": "1.0.2",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Learn Quran with Elif Ba",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "12M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 3, 2017",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Arabic Alif Ba Ta For Kids",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 226,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "May 30, 2017",
    "Current Ver": "1.0.0",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Arabic Alphabet Alif Ba Ta Wooden Blocks",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 66,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "February 25, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Let's Learn Alif Ba Ta",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 32,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 29, 2017",
    "Current Ver": 6,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Sufara.ba",
    Category: "FAMILY",
    Rating: 4.9,
    Reviews: 285,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 5, 2018",
    "Current Ver": "1.0.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Elif Ba - Learn The Holy Quran",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 1491,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 31, 2017",
    "Current Ver": 1.3,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Instant Ba-dum-tss",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 13,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "September 23, 2015",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 1,
  },
  {
    App: "Ba Zi Fortune",
    Category: "LIFESTYLE",
    Rating: 3.9,
    Reviews: 592,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 2, 2018",
    "Current Ver": "1.0.23",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "BA VPN - Free Unlimited VPN",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 181,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 14, 2018",
    "Current Ver": "1.2.1",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Ba dum tss - Rimshot widget",
    Category: "COMICS",
    Rating: 4.1,
    Reviews: 690,
    Size: "444k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "September 29, 2015",
    "Current Ver": "1.2.3",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Alif Ba Ta Song - Arabic Kids",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 227,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "February 24, 2018",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Fitness Dance for Zum.ba Workout Exercise",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.2,
    Reviews: 287,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 30, 2018",
    "Current Ver": 1.8,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Cafe.ba",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 677,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 7, 2017",
    "Current Ver": "5.5.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "058.ba",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.4,
    Reviews: 27,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 6, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Loreal - BA Makeup",
    Category: "TOOLS",
    Rating: 1.9,
    Reviews: 8,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 18, 2018",
    "Current Ver": "1.1.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "PROFESSOR SEE-BA LINGUAGENS E SUAS TECNOLOGIAS",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.7M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 1, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Poteau BA",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 16, 2017",
    "Current Ver": "1.0.2",
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "Elif Ba Oyunu",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 26,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 2, 2015",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Ain Arabic Kids Alif Ba ta",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "33M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 15, 2016",
    "Current Ver": 1,
    numInstall: 0,
    numAndroid: 3,
  },
  {
    App: "Bedouin Rivals",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 79826,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 26, 2018",
    "Current Ver": "4.0.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Klix.ba",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 3647,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "February 25, 2017",
    "Current Ver": "4.1.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "PBA® Bowling Challenge",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 242096,
    Size: "87M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.4.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Avios for Android",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 2.5,
    Reviews: 862,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "April 10, 2018",
    "Current Ver": "7.8.0",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Banana Kong",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 3452530,
    Size: "68M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "February 7, 2018",
    "Current Ver": "1.9.6.6",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "BA 3 Banjarmasin",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 2,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 28, 2018",
    "Current Ver": "1.0.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "American Airlines",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.7,
    Reviews: 16973,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Elifba Quran Learning Game",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 1424,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "June 7, 2018",
    "Current Ver": 2.2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Space Shooter : Galaxy Attack",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 169661,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "August 1, 2018",
    "Current Ver": 1.246,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Hunt Buddy BC",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 172,
    Size: "49M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 10, 2018",
    "Current Ver": 1.5,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Survival Mobile:10,000 BC",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 7441,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "August 2, 2018",
    "Current Ver": "0.1.801",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "iHunter BC",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 55,
    Size: "63M",
    Type: "Paid",
    Price: "$4.49",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.0.38",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Anthem BC Anywhere",
    Category: "MEDICAL",
    Rating: 2.6,
    Reviews: 496,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 27, 2018",
    "Current Ver": "8.0.226",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "iFish BC",
    Category: "SPORTS",
    Rating: 3.6,
    Reviews: 25,
    Size: "6.0M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 18, 2015",
    "Current Ver": 2.1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "BC Connect",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 11,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 14, 2018",
    "Current Ver": "2.6.12",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ice Crush 10.000 B.C.",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 31,
    Size: "4.2M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "August 15, 2013",
    "Current Ver": 1.48,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "BC Navigator",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 21,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 10, 2018",
    "Current Ver": 3.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BC Lotto Check",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 10,
    Size: "717k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 22, 2016",
    "Current Ver": "0.0.7",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Transit: Real-Time Transit App",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 43252,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 18, 2018",
    "Current Ver": "4.4.7",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "BC Liquor Stores",
    Category: "LIFESTYLE",
    Rating: 3.7,
    Reviews: 492,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "October 5, 2015",
    "Current Ver": 3.6,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "BC MVA Fines",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 5,
    Reviews: 5,
    Size: "7.2M",
    Type: "Paid",
    Price: "$1.75",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "October 8, 2015",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "British Columbia Transit Info",
    Category: "MAPS_AND_NAVIGATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Maps & Navigation",
    "Last Updated": "February 19, 2016",
    "Current Ver": 3,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "BC Hospital Wait Times",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 8,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 19, 2016",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Town of Princeton, BC",
    Category: "PRODUCTIVITY",
    Rating: 4.8,
    Reviews: 4,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 25, 2018",
    "Current Ver": "3.3.8",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Explore British Columbia - BC Travel Guide",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 7,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "October 9, 2017",
    "Current Ver": "2.0.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Bridge Constructor Stunts FREE",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 36151,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "April 22, 2017",
    "Current Ver": 2.7,
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "BC's Pizza",
    Category: "LIFESTYLE",
    Rating: 4.7,
    Reviews: 113,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 30, 2016",
    "Current Ver": "3.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Baby Connect (activity log)",
    Category: "PARENTING",
    Rating: 4.7,
    Reviews: 8343,
    Size: "8.3M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "July 10, 2018",
    "Current Ver": "6.3.16",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "BC Wildfire",
    Category: "TOOLS",
    Rating: 3.3,
    Reviews: 27,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 31, 2018",
    "Current Ver": "10.1.0",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "BC Slots - The Lost Reels FREE",
    Category: "GAME",
    Rating: 4,
    Reviews: 209,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "July 13, 2018",
    "Current Ver": 7,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BC Mobile Intro - Americas",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 21, 2018",
    "Current Ver": "4.1.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Car Driving Theory Test BC",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.2M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 9, 2012",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "Truck Driving Test Class 3 BC",
    Category: "FAMILY",
    Rating: 1,
    Reviews: 1,
    Size: "2.0M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 9, 2012",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "BC Highways - Road Conditions",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 382,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "February 1, 2018",
    "Current Ver": "2.1.3",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "BC Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 5,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "January 10, 2018",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "BC iptv player",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 8,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "October 12, 2017",
    "Current Ver": "Final",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Business Calendar Pro",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 27135,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Victoria, BC | Tour City",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 20,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 2, 2016",
    "Current Ver": 1.7,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BC Wildflowers",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 7,
    Size: "81M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 10, 2017",
    "Current Ver": 3.5,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Bc Vod",
    Category: "VIDEO_PLAYERS",
    Rating: "NaN",
    Reviews: 1,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "April 17, 2018",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BC Hockey",
    Category: "SPORTS",
    Rating: 3.7,
    Reviews: 20,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "December 8, 2017",
    "Current Ver": 3.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Outdoor Movies BC",
    Category: "EVENTS",
    Rating: 2.9,
    Reviews: 7,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "June 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "British Columbia Tourist Places (Guide)",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4,
    Reviews: 1,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "November 8, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "PMHNP-BC Pocket Prep",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 112,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 12, 2018",
    "Current Ver": "4.5.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "British Columbia License",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 14,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 19, 2015",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BC browser",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 17, 2018",
    "Current Ver": "1.1.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "PPCNP-BC Pocket Prep",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 3,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 12, 2018",
    "Current Ver": "4.5.2",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "AP Calculus BC Practice Test",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 4,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 25, 2018",
    "Current Ver": "6.0.2",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "BackCountry Navigator TOPO GPS PRO",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.5,
    Reviews: 6230,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$11.99",
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "BC Pizza",
    Category: "LIFESTYLE",
    Rating: 2.3,
    Reviews: 3,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 12, 2016",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Railroad Radio Vancouver BC",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 4,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 28, 2015",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "AP Calculus BC: Practice Tests and Flashcards",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 5,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.6.7.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Aura Hair Group BC",
    Category: "BEAUTY",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "April 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Bridge Constructor Playground FREE",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 137377,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "April 12, 2017",
    "Current Ver": 2.2,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "BDCast - Bangla Live TV,Radio",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 7461,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 20, 2018",
    "Current Ver": "4.2.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "bd's Mongolian Grill",
    Category: "LIFESTYLE",
    Rating: 4.2,
    Reviews: 120,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "February 23, 2018",
    "Current Ver": "1.5.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BD Briight: Your Diabetes Personal Assistant",
    Category: "MEDICAL",
    Rating: 4.8,
    Reviews: 17,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.5.0",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "Jagobd - Bangla TV(Official)",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 39109,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 20, 2017",
    "Current Ver": 6.5,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Business Dictionary",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 5988,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 16, 2016",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "BD Data Plan (3G & 4G)",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 10341,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 5, 2018",
    "Current Ver": "5.2.4",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "বাংলা টিভি প্রো BD Bangla TV",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 193,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 29, 2017",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BD tools",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 21,
    Size: "210k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 18, 2015",
    "Current Ver": 6.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BD Provider App",
    Category: "HEALTH_AND_FITNESS",
    Rating: 1.4,
    Reviews: 45,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "September 12, 2016",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Izneo, Read Manga, Comics & BD",
    Category: "COMICS",
    Rating: 3.3,
    Reviews: 1476,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "June 11, 2018",
    "Current Ver": 7.3,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "BD Radio TV Free List",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 539,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 1, 2018",
    "Current Ver": 1.3,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "BD Simplist Through Their Eyes",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "December 4, 2015",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BD Online News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.6,
    Reviews: 30,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "March 20, 2018",
    "Current Ver": 1.5,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BD Bank Interest",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 289,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 4, 2018",
    "Current Ver": 1.2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "BD Earn Pro",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 540,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 1, 2018",
    "Current Ver": 2.4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Comics Reader",
    Category: "COMICS",
    Rating: 3.9,
    Reviews: 4496,
    Size: "609k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "October 29, 2017",
    "Current Ver": "2.3.216",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Upohar BD",
    Category: "BUSINESS",
    Rating: 3.4,
    Reviews: 9,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 8, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Electricity Bill Calculator BD",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 247,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 22, 2016",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BD Fishpedia",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.8,
    Reviews: 123,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "March 15, 2017",
    "Current Ver": 3.15317,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "BD Attendance",
    Category: "PRODUCTIVITY",
    Rating: 4.8,
    Reviews: 93,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 17, 2018",
    "Current Ver": "2.3.14",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BD All Sim Offer",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 197,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "January 3, 2017",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BD TYCOON",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 16,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 6, 2017",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "BD Sports Box & TV",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 5,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 13, 2018",
    "Current Ver": 1.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Tour BD (Bahir Dar Map)",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.9,
    Reviews: 49,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "October 16, 2017",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BD Field Force",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 41,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.3.13",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BD CRICKET LIVE",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 1238,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "January 15, 2018",
    "Current Ver": 3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BD All Results",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 205,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 29, 2017",
    "Current Ver": 9,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "BD Online Passport Application",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 12,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 7, 2017",
    "Current Ver": 3,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "BD Internet Packages (Updated)",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 474,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 5, 2016",
    "Current Ver": "0.0.5",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Live Radio BD",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 69,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 4, 2015",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "iCard BD Plus",
    Category: "SOCIAL",
    Rating: 5,
    Reviews: 2,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 15, 2016",
    "Current Ver": "3.7.5",
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "BD Dialer",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 29,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 9, 2018",
    "Current Ver": "1.8.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Youboox - Livres, BD et magazines",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.7,
    Reviews: 4071,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "April 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "BANGLA TV 3G/4G",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 142,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 7, 2018",
    "Current Ver": 2.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Earn Money BD",
    Category: "FINANCE",
    Rating: 3.8,
    Reviews: 103,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 11, 2018",
    "Current Ver": 3.4,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "BD Hospital's",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 12,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 7, 2015",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "Rabbithole",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 3347,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.1.15.12",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Educationboard Results BD",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 983,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 12, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BD Online Shop",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 63,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "September 13, 2015",
    "Current Ver": "3.0.1",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Remote for Samsung TV & BluRay Players (Read Desc)",
    Category: "TOOLS",
    Rating: 3.3,
    Reviews: 1988,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Cow V3.15",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Vehicle Case Checker BD",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 29,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 13, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Remote for Sony TV & Sony Blu-Ray Players MyAV",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 3491,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Cow V3.15",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Remote for Panasonic TV+BD+AVR",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 533,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Cow V3.15",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Exam Result BD",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 2,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 22, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 3,
  },
  {
    App: "BD Live Call",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 7,
    Size: "308k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "September 6, 2016",
    "Current Ver": 1.01,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Helping BD",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 15,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 19, 2018",
    "Current Ver": 2.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Best Browser BD social networking",
    Category: "COMMUNICATION",
    Rating: 4.8,
    Reviews: 6,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 4, 2018",
    "Current Ver": 2,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Traffic signs BD",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 7,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "October 8, 2015",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "BD Internet Package Activator",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.9,
    Reviews: 13,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "March 9, 2018",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "be Produbanco",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 967,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.2.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Millionaire : Who want to be?",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 4396,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "April 12, 2017",
    "Current Ver": 1.5,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Photo Editor by BeFunky",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 192851,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "September 12, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Be My Eyes - Helping the blind",
    Category: "LIFESTYLE",
    Rating: 4.9,
    Reviews: 8418,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.2.9",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Be My Princess: PARTY",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 9443,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "December 12, 2016",
    "Current Ver": "1.8.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BeautyPlus - Easy Photo Editor & Selfie Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 3156484,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 31, 2018",
    "Current Ver": "6.9.031",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Movement BE",
    Category: "SOCIAL",
    Rating: 5,
    Reviews: 20,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "November 10, 2016",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Be Stronger",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 787,
    Size: "53M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.4.7",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Be My Love Animated Keyboard",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 838,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "March 30, 2018",
    "Current Ver": 1.7,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Be My Princess 2",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 2806,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "March 20, 2018",
    "Current Ver": 3.6,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Millionaire Quiz Free: Be Rich",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 66033,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "January 1, 2018",
    "Current Ver": "2.5.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Be the Manager 2018 - Football Strategy",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 7557,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 12, 2018",
    "Current Ver": "2.2.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Be like Me - Hay Nhu Toi",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 44,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "May 26, 2016",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Be Fabulous PHOTO BOOTH",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 560,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 1, 2017",
    "Current Ver": 1.07,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "RadarNow!",
    Category: "WEATHER",
    Rating: 4.5,
    Reviews: 54090,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "February 28, 2018",
    "Current Ver": 6.6,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Be My Princess",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 3103,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "September 19, 2017",
    "Current Ver": 6.5,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Fat No More - Be the Biggest Loser in the Gym!",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 48545,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.2.14",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Be Like Bill - Maker",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 18,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 27, 2016",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Top Eleven 2018 - Be a Soccer Manager",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 3451011,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 26, 2018",
    "Current Ver": 7.4,
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Free GPS Navigation",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 618562,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "June 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Be the Manager 2016 (football)",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 4330,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "October 19, 2017",
    "Current Ver": 3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Hair Salon - Fun Games",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 484226,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "June 15, 2018",
    "Current Ver": "3.0.10",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Adobe Photoshop Fix",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 28390,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 19, 2017",
    "Current Ver": "1.0.499",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Make your Be Like Bill",
    Category: "COMICS",
    Rating: 4,
    Reviews: 78,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "January 16, 2016",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Be like Bill Generator",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 67,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "January 29, 2016",
    "Current Ver": 1.08,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Be you GO Launcher Theme",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 1580,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "November 12, 2014",
    "Current Ver": "v1.0",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Star Girl - Fashion, Makeup & Dress Up",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 556929,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "April 19, 2018",
    "Current Ver": "4.2.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Be Like Bro - Compilation",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 146,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "March 30, 2018",
    "Current Ver": 2.4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Bowmasters",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 1535581,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.12.5",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "YAY - TBH",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 2520,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "November 17, 2017",
    "Current Ver": "1.1.5",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "The Sims™ Mobile",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 559597,
    Size: "89M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "July 26, 2018",
    "Current Ver": "11.1.1.179661",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Find My Friends",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 305367,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "August 1, 2018",
    "Current Ver": "16.7.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Beauty Idol: Fashion Queen",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 128367,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "October 27, 2017",
    "Current Ver": "2.1.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Unseen - No Last Seen",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 103909,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 11, 2018",
    "Current Ver": "2.2.7",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "OK K.O.! Lakewood Plaza Turbo",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 76608,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action;Action & Adventure",
    "Last Updated": "January 5, 2017",
    "Current Ver": "1.3.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hard Time (Prison Sim)",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 275843,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "July 19, 2018",
    "Current Ver": 1.401,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "She Will Be Loved Lyrics",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "705k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 1, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Nick",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 123309,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "January 24, 2018",
    "Current Ver": "2.0.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Battlefield™ Companion",
    Category: "GAME",
    Rating: 4,
    Reviews: 263907,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "November 1, 2016",
    "Current Ver": "3.0.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Wolf of the BF:Commando MOBILE",
    Category: "GAME",
    Rating: 3.4,
    Reviews: 32,
    Size: "27M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "March 23, 2017",
    "Current Ver": "1.00.10",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BF at Sea Refueled",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 1849,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "October 20, 2015",
    "Current Ver": "1.1.8",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "BF Movies Fun",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 63,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "April 7, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "BF Browser by Betfilter - Stop Gambling Today!",
    Category: "COMMUNICATION",
    Rating: 3,
    Reviews: 39,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "September 4, 2017",
    "Current Ver": 1.4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "My BF App",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 141,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "December 19, 2017",
    "Current Ver": 2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Funny videos for whatsapp",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 3066,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "December 17, 2017",
    "Current Ver": 1.7,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BF games",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 262,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "November 1, 2017",
    "Current Ver": 1.1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "BF 3d Wallpapers",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 256,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 18, 2015",
    "Current Ver": 4.7,
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Hot Bhojpuri Video songs",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 28892,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 11, 2018",
    "Current Ver": 1.3,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Bullet Force",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 634159,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 21, 2018",
    "Current Ver": 1.4,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "GF - BF Chat Stories - Hindi English Convesation",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 32,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 18, 2018",
    "Current Ver": 1.5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BF Scale Health Fitness Tool",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.2,
    Reviews: 19,
    Size: "9.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "November 29, 2017",
    "Current Ver": 2.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BF-Calc",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 428,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 31, 2015",
    "Current Ver": "1.2.5",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "BF 4 Guns",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 1542,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 9, 2015",
    "Current Ver": 3,
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "My Virtual Boyfriend",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 105,
    Size: "51M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "February 17, 2017",
    "Current Ver": 3.6,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Sexy Hot Detector Prank",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 17067,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "February 13, 2018",
    "Current Ver": "2.4.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "BF Combat: Genesis",
    Category: "GAME",
    Rating: 4,
    Reviews: 3322,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "March 2, 2017",
    "Current Ver": "5.1.6",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: 'Women"s Health Tips(Breast,Face,Body,weight lose)',
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.2,
    Reviews: 2509,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Health & Fitness",
    "Last Updated": "April 20, 2018",
    "Current Ver": 1.8,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Combat BF: Black Ops 3",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 7699,
    Size: "83M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "March 2, 2017",
    "Current Ver": "5.1.6",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "BF Beautiful Nature",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 5,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "June 11, 2015",
    "Current Ver": 4.1,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "BF 3d Images",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 19,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 17, 2015",
    "Current Ver": 4.5,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Jigsaw Puzzles Bus Scania BF",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Puzzle",
    "Last Updated": "November 7, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BF 3d View Wallpapers",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 4,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 18, 2015",
    "Current Ver": 4.6,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Hot Bhojpuri Video Song 2018 - Free Movies",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 447,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "April 4, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Body Scanner xray Real Camera Prank Entertaintment",
    Category: "FAMILY",
    Rating: 2.6,
    Reviews: 17,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 5, 2018",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "BF Frontline City",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 29798,
    Size: "80M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "March 6, 2017",
    "Current Ver": "5.1.7",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Bf Light",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 6,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 9, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Droid PRoCon BF3",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 412,
    Size: "2.6M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 12, 2015",
    "Current Ver": 2.2,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "BF Abstract 3d Pictures",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 72,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 18, 2015",
    "Current Ver": 5.1,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "CE BF",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 2, 2018",
    "Current Ver": "1.0.1",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Freedom Christian BF",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "February 22, 2016",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Random Love (BF)",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 3,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "October 4, 2015",
    "Current Ver": "1.0.0",
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "BeFunky Photo Editor Pro",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 4724,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 14, 2017",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Virtual Boyfriend Chat",
    Category: "FAMILY",
    Rating: 2.4,
    Reviews: 407,
    Size: "306k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "April 11, 2017",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "BF Family user",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 8,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 1, 2018",
    "Current Ver": "0.0.9",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Talking Boyfriend",
    Category: "FAMILY",
    Rating: 2.9,
    Reviews: 1073,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 28, 2016",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Faketalk - Chatbot",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 63056,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Word",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.9.7",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "XXX DISTILLERY",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 509,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2017",
    "Current Ver": "1.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Cute Questions BF",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 3,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 2, 2018",
    "Current Ver": "3.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BG Score",
    Category: "SPORTS",
    Rating: 2.6,
    Reviews: 64,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 26, 2017",
    "Current Ver": 2.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BG Advisor™",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 7,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 10, 2017",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BG Products",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.8,
    Reviews: 4,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "November 28, 2017",
    "Current Ver": 1.3,
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "BG LINKED (BGLINKED)",
    Category: "SOCIAL",
    Rating: 4.7,
    Reviews: 22,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "January 19, 2018",
    "Current Ver": "v2.0.02_prod",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BG Monitor Diabetes",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 643,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 23, 2017",
    "Current Ver": "8.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BG Monitor Diabetes Pro",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 87,
    Size: "2.8M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 23, 2017",
    "Current Ver": "8.0.1",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "HTC Sense Input-BG",
    Category: "TOOLS",
    Rating: 2.7,
    Reviews: 198,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 22, 2014",
    "Current Ver": "9.7.753080",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Photo BG Changer",
    Category: "PHOTOGRAPHY",
    Rating: 3.8,
    Reviews: 11,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 21, 2018",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BG TV App",
    Category: "FAMILY",
    Rating: 1.7,
    Reviews: 6,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 21, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BG BRIDAL GALLERY",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 17,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 27, 2018",
    "Current Ver": "2.1.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "HTC Sense Input - BG",
    Category: "TOOLS",
    Rating: 3.3,
    Reviews: 218,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 9, 2015",
    "Current Ver": "1.0.606877",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "BG Editor",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 23, 2018",
    "Current Ver": 1.2,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "BG Sports News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 41,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "February 9, 2016",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Board Game Stats: Play tracking for tabletop games",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 275,
    Size: "3.9M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 17, 2018",
    "Current Ver": "2.8.3",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Bg TV Online",
    Category: "FAMILY",
    Rating: 2.3,
    Reviews: 50,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "October 21, 2017",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "PhotoLayers〜Superimpose,Eraser",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 81219,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 14, 2015",
    "Current Ver": "1.4.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Zdravei.BG",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 6,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "January 8, 2018",
    "Current Ver": "3.7.17",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BG+Phone Backup",
    Category: "PRODUCTIVITY",
    Rating: 4.8,
    Reviews: 16,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "February 17, 2017",
    "Current Ver": "1.0.3",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "BGKontakti London BG Kontakti",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 4,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "March 23, 2017",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 3,
  },
  {
    App: "ReactNative BG Geolocation",
    Category: "TOOLS",
    Rating: 5,
    Reviews: 5,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 25, 2018",
    "Current Ver": "2.12.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BG TV Stations",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 10, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BG video - floating video - background video",
    Category: "VIDEO_PLAYERS",
    Rating: 4.1,
    Reviews: 64,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "May 21, 2018",
    "Current Ver": 2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "BG TV Program",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 22, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BG Cable TV",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 5,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 25, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BG Middle East",
    Category: "AUTO_AND_VEHICLES",
    Rating: "NaN",
    Reviews: 1,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "December 20, 2017",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Blender BG - Photo Blend With Background",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 0,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "September 20, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BG MUSIC PLAYER - MUSIC PLAYER",
    Category: "VIDEO_PLAYERS",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "June 26, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Sommelier.BG",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Food & Drink",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10,
    numAndroid: null,
  },
  {
    App: "BG Future School",
    Category: "FAMILY",
    Rating: 4.9,
    Reviews: 16,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 22, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Cordova BG Geolocation",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3,
    Reviews: 4,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "May 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "Simple Photo BG Changer",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 8, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "BGKontakti Bayern BG Kontakti",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 32,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "May 25, 2016",
    "Current Ver": 1.6,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "BGKontakti Vienna BG Kontakti",
    Category: "SOCIAL",
    Rating: 4.8,
    Reviews: 111,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 18, 2018",
    "Current Ver": 2.42,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CARS.bg",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.5,
    Reviews: 276,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 5, 2017",
    "Current Ver": "1.1.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "bgtime.tv",
    Category: "VIDEO_PLAYERS",
    Rating: 3.4,
    Reviews: 694,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "BG Torneos",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 7,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 13, 2018",
    "Current Ver": "2.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "YourTube Video Views BG",
    Category: "VIDEO_PLAYERS",
    Rating: "NaN",
    Reviews: 8,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "November 12, 2015",
    "Current Ver": "1.1.1",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "BG Television",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 10, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Cъновник BG",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 13,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "January 21, 2017",
    "Current Ver": 250,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Auto Background Changer",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 35188,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 22, 2018",
    "Current Ver": "1.0.11",
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Block Gun 3D: Call of Destiny",
    Category: "GAME",
    Rating: 3.7,
    Reviews: 31883,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "March 23, 2017",
    "Current Ver": "1.4.3",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "BG Remover & Eraser Pro",
    Category: "TOOLS",
    Rating: 2.2,
    Reviews: 4,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 3, 2018",
    "Current Ver": 3,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "BG Metro - Red voznje",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.8,
    Reviews: 89,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "February 21, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "BG Cricket",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 6,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 14, 2018",
    "Current Ver": "2.4.4",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "BG Guide",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 5,
    Reviews: 3,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "November 28, 2016",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Bg Radios - Bulgarian radio stations online",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 8,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 13, 2018",
    "Current Ver": "1.3.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Micro.bg Cloud POS System",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 6,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 12, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "BG-FLEET",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "trip.bg",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 103,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 30, 2018",
    "Current Ver": "8.2.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Dete.bg",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 12, 2017",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BLOOD & GLORY: IMMORTALS",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 101762,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 11, 2015",
    "Current Ver": "2.0.0",
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Change photo background",
    Category: "PHOTOGRAPHY",
    Rating: 3.8,
    Reviews: 28660,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 21, 2018",
    "Current Ver": "1.0.12",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Es-Bg Offline Voice Translator",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "87M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "March 19, 2017",
    "Current Ver": 2.55,
    numInstall: 10,
    numAndroid: 3,
  },
  {
    App: "Baldur's Gate: Enhanced Edition",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 20101,
    Size: "7.8M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "October 2, 2015",
    "Current Ver": 1.3,
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Shadow Fight 2 Special Edition",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 10440,
    Size: "86M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "May 30, 2018",
    "Current Ver": "1.0.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "ePazar.bg",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 28,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "January 7, 2017",
    "Current Ver": 3,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Revita.bg",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 10,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 13, 2018",
    "Current Ver": 3.55,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Background Eraser",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 267378,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 11, 2015",
    "Current Ver": "1.4.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ePay.bg",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 2017,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 26, 2018",
    "Current Ver": 2.22,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Top Novini BG",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 2,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 14, 2016",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Block Gun 3D: Ghost Ops",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 142693,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 7, 2018",
    "Current Ver": "1.4.0",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Music for Youtube - Tube Music BG, Red+",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 47,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "September 23, 2017",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Bg+ Call Blocker",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 80,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 20, 2018",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BG Blurry HD Wallpapers",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 12, 2018",
    "Current Ver": "1.0.0.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Background Changer & Eraser",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 2076,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Photography",
    "Last Updated": "May 21, 2018",
    "Current Ver": 2.5,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Stolica.bg",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 1,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 2, 2018",
    "Current Ver": 1.1,
    numInstall: 50,
    numAndroid: 5,
  },
  {
    App: "Cut Out : Background Eraser and background changer",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 7118,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 29, 2018",
    "Current Ver": 1.6,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "mySugr: the blood sugar tracker made just for you",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 21187,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 23, 2018",
    "Current Ver": "3.52.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Photo Background Changer 2018 - Blur Background",
    Category: "LIFESTYLE",
    Rating: 3.7,
    Reviews: 34079,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 21, 2018",
    "Current Ver": "Arrow-202",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "BGCN TV",
    Category: "VIDEO_PLAYERS",
    Rating: 3.4,
    Reviews: 4334,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "November 4, 2015",
    "Current Ver": "3.1.891",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "ScorePal",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 1439,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 9, 2018",
    "Current Ver": "2.10.7",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Backgammon NJ for Android",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 1644,
    Size: "15M",
    Type: "Paid",
    Price: "$7.99",
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "April 5, 2017",
    "Current Ver": 4.1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "BG Burger",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 1,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "March 29, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "JOBS.bg",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 1630,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 22, 2017",
    "Current Ver": "3.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CSCS BG (в български)",
    Category: "FAMILY",
    Rating: 2.4,
    Reviews: 7,
    Size: "2.1M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 23, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "LEGO ® Batman: Beyond Gotham",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 10758,
    Size: "8.0M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone 10+",
    Genres: "Adventure;Action & Adventure",
    "Last Updated": "December 15, 2015",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Backgrounds HD (Wallpapers)",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 2390099,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Blood Glucose Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 9612,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "May 18, 2018",
    "Current Ver": "1.8.12",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Baldur's Gate II",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 5442,
    Size: "16M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "June 28, 2018",
    "Current Ver": "2.5.16.6",
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "Rento - Dice Board Game Online",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 205830,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "June 20, 2018",
    "Current Ver": "4.4.9",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Learn Bulgarian Free",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 3049,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "N+ News Bulgaria",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 2,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "August 2, 2017",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Remix Second Hand",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 867,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.5.8",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Ultimate Background Eraser",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 14453,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 13, 2018",
    "Current Ver": 1.9,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "OnTrack Diabetes",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 6079,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 17, 2018",
    "Current Ver": "3.2.7",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Blur Image Background",
    Category: "PHOTOGRAPHY",
    Rating: 3.9,
    Reviews: 129268,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 30, 2018",
    "Current Ver": 1.32,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ALL-IN-ONE PACKAGE TRACKING",
    Category: "PRODUCTIVITY",
    Rating: 4.7,
    Reviews: 167406,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 23, 2018",
    "Current Ver": "3.1.1281",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Survival Run with Bear Grylls",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 128579,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "May 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "VIP Backgammon Free : Play Backgammon Online",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 389,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Board",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.16.32",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "Grabo.bg",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 8175,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "April 5, 2018",
    "Current Ver": "3.2.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BusyBox Pro",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 8114,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 9, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "GEM™",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 6,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 23, 2018",
    "Current Ver": 1.93,
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "Diabetes Connect",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 4027,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 10, 2017",
    "Current Ver": "2.4.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "B&H Photo Video Pro Audio",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 17180,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "5.3.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BH by Kinomap",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.9,
    Reviews: 141,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 30, 2018",
    "Current Ver": "3.2.9",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BH Cosmetics",
    Category: "BEAUTY",
    Rating: 4,
    Reviews: 2,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "May 29, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BH Bikes Premium",
    Category: "SPORTS",
    Rating: 3,
    Reviews: 26,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 9, 2017",
    "Current Ver": "2.1.1",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "B&H Kids AR",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.9,
    Reviews: 286,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "September 29, 2017",
    "Current Ver": "3.2.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BH Bikes GPS Locator",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 19, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 5,
  },
  {
    App: "BH Patrole",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.8,
    Reviews: 27,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "February 15, 2018",
    "Current Ver": 2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CINEMA.BH",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 11,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 30, 2018",
    "Current Ver": "1.2.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DSLR Photography Training apps",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 675,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 29, 2017",
    "Current Ver": 2.1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Radio Belo Horizonte",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "August 3, 2018",
    "Current Ver": 2,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BH Online",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 4, 2018",
    "Current Ver": "2.2.6",
    numInstall: 10,
    numAndroid: 5,
  },
  {
    App: "Belo Horizonte Map offline",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 11,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 12, 2018",
    "Current Ver": 1.73,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Bh Public School",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 2,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 21, 2018",
    "Current Ver": 1.2,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BH Mission Playbook",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "April 2, 2018",
    "Current Ver": "1.5.4",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BH INVEST",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 7,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 5, 2016",
    "Current Ver": 1.3,
    numInstall: 500,
    numAndroid: 3,
  },
  {
    App: "Comunidad BH",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 23,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 9, 2016",
    "Current Ver": "1.3.9",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "VIVA BH",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 2055,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 9, 2018",
    "Current Ver": 2.44,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Discípulos em BH",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 24,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "February 24, 2018",
    "Current Ver": "1.1.4",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Barbers.BH",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 2,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 24, 2018",
    "Current Ver": 2.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BH - Fitness & Nutrition",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 4, 2018",
    "Current Ver": "4.3.6",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Lexus Tech BH Service Pro",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "904k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "July 26, 2016",
    "Current Ver": 5,
    numInstall: 10,
    numAndroid: 3,
  },
  {
    App: "Photo Editor - BPhoto",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 42,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "September 17, 2016",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BH Challenge - Museum of the Jewish People",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 12,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 26, 2018",
    "Current Ver": "1.3.6",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "B'H BURGER HEIM",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 26, 2016",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "B y H Niños ES",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 53,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "September 22, 2015",
    "Current Ver": "1.0.2",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "ZUL - Rotativo Digital BH",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.2,
    Reviews: 29,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.6.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Coomotaxi BH",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 94,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 24, 2018",
    "Current Ver": "3.44.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "BH Mail",
    Category: "COMMUNICATION",
    Rating: 3.4,
    Reviews: 7,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 3, 2018",
    "Current Ver": 5.403,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FitConsole",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.6,
    Reviews: 219,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "October 30, 2015",
    "Current Ver": "v1.1-20151030",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Run on Earth",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.4,
    Reviews: 577,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "April 25, 2018",
    "Current Ver": "1.7.5",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "BH Rocking",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 13,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "January 17, 2018",
    "Current Ver": "1.0.7",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Newegg Mobile",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 35479,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 11, 2018",
    "Current Ver": "4.16.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Battleheart Legacy",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 7420,
    Size: "7.4M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "November 10, 2014",
    "Current Ver": "1.2.5",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Treadmill Workouts Free (P)",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.3,
    Reviews: 10,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "April 5, 2018",
    "Current Ver": "1.8 P",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "ZiraatBank BH",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 58,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 4, 2017",
    "Current Ver": "2.3.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Digital Tourist BH Itinerary",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.6,
    Reviews: 19,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "October 13, 2015",
    "Current Ver": "0.9.2",
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "BH Táxi",
    Category: "BUSINESS",
    Rating: 3.9,
    Reviews: 91,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 7, 2018",
    "Current Ver": "3.44.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "BH Connect",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "March 22, 2018",
    "Current Ver": "1.4.4",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Out of Bounds BH Demo",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 3,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "November 19, 2015",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "EduNAV.BH",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 12, 2018",
    "Current Ver": "1.2.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "BH Açaí",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 3,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "May 29, 2018",
    "Current Ver": "7.0 RELEASE",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BH Recepti",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 3,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 16, 2016",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Bi en Línea",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 5055,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 5, 2018",
    "Current Ver": "4.4.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Gayvox - Gay Lesbian Bi Dating",
    Category: "SOCIAL",
    Rating: 3.4,
    Reviews: 3640,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "June 13, 2016",
    "Current Ver": "3.1.9",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Microsoft Power BI–Business data analytics",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 1819,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 16, 2018",
    "Current Ver": "2.2.180712.112152",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "BI Mobile Banking",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 180,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 27, 2018",
    "Current Ver": "4.17.38",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BI News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 5,
    Reviews: 22,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 10, 2018",
    "Current Ver": "1.5.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BI SmartLINK",
    Category: "BUSINESS",
    Rating: 3.6,
    Reviews: 16,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 25, 2018",
    "Current Ver": "2.7.0",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "BI-LO",
    Category: "LIFESTYLE",
    Rating: 3.5,
    Reviews: 43,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 11, 2018",
    "Current Ver": "2.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Bitmoji – Your Personal Emoji",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 2312084,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Sisense Mobile BI",
    Category: "BUSINESS",
    Rating: 4.9,
    Reviews: 23,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 30, 2018",
    "Current Ver": "2.4.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Starg - Gay, Same Sex, Bi",
    Category: "DATING",
    Rating: 3.7,
    Reviews: 66,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "November 29, 2016",
    "Current Ver": "1.0.6",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Propel BI APP",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 3,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 24, 2018",
    "Current Ver": 1.39,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BI Office",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 76,
    Size: "201k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 7, 2017",
    "Current Ver": "2.7.1",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "BI-LO Rx",
    Category: "LIFESTYLE",
    Rating: 3.9,
    Reviews: 77,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "BI APP",
    Category: "FINANCE",
    Rating: 5,
    Reviews: 2,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 19, 2016",
    "Current Ver": 1.8,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Oracle BI Mobile",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 282,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 1, 2018",
    "Current Ver": "20.0.0.0",
    numInstall: 10000,
    numAndroid: 6,
  },
  {
    App: "Bi-Tank Ads Free",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 31, 2017",
    "Current Ver": 1.1,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "bi-Cube Mobile Token",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 5,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 26, 2018",
    "Current Ver": "8.9.2.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Business Intelligence & Data",
    Category: "FAMILY",
    Rating: 4.9,
    Reviews: 7,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 26, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "BI Mobile",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 337,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 15, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Grindr - Gay chat",
    Category: "SOCIAL",
    Rating: 3.6,
    Reviews: 284795,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.1.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Zoho Reports - Mobile BI",
    Category: "BUSINESS",
    Rating: 4.7,
    Reviews: 45,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 23, 2018",
    "Current Ver": "2.0.5",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Power BI Ultimate Orientation",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 12,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 6, 2017",
    "Current Ver": "1.0.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Pool Billiards Classic - bi a",
    Category: "SPORTS",
    Rating: 3.9,
    Reviews: 5644,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "November 1, 2017",
    "Current Ver": 1.7,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Lesbian Chat & Dating - SPICY",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 63765,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.17.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Moco - Chat, Meet People",
    Category: "DATING",
    Rating: 4.2,
    Reviews: 313769,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 4, 2018",
    "Current Ver": "2.6.142",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Bi-Tank",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 12,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 31, 2017",
    "Current Ver": "Varies with device",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Hot or Not - Find someone right now",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 305737,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "happn – Local dating app",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 1118201,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Lifestyle",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Dictionary.com: Find Definitions for English Words",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 899010,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "MinT BI",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 13, 2018",
    "Current Ver": 3.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BI Barcode Scanner",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "473k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 13, 2014",
    "Current Ver": 2.2,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "MeetMe: Chat & Meet New People",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 1259723,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "TED",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 181961,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "3.2.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Learn English Vocabulary - 6,000 Words",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 205914,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 3, 2018",
    "Current Ver": 5.54,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "English Dictionary - Offline",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 341234,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Books & Reference",
    "Last Updated": "March 20, 2018",
    "Current Ver": "3.9.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Zalo – Video Call",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 1042170,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Bible KJV",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 42729,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "November 26, 2014",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "All Language Translator",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 29944,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 3, 2015",
    "Current Ver": 1.6,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Bike Rivals",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 212067,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "July 15, 2015",
    "Current Ver": "1.5.2",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Bingo Party - Free Bingo Games",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 155694,
    Size: "92M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Board",
    "Last Updated": "July 13, 2018",
    "Current Ver": "2.1.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "OkCupid Dating",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 285838,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "July 30, 2018",
    "Current Ver": "11.10.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Little Big City 2",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 344383,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "March 20, 2018",
    "Current Ver": "9.2.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Mint: Budget, Bills, Finance",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 129305,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "English Grammar Test",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 104676,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.9.7",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "BJ's Wholesale Club",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 4099,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 27, 2018",
    "Current Ver": "2.0.10",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BJ’s Mobile App",
    Category: "SHOPPING",
    Rating: 4,
    Reviews: 4722,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 9, 2018",
    "Current Ver": "3.6.5",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "BJ's Express Scan",
    Category: "SHOPPING",
    Rating: 2.3,
    Reviews: 69,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "March 19, 2018",
    "Current Ver": "1.0.16",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BJ's Bingo & Gaming Casino",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 501,
    Size: "65M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "July 26, 2018",
    "Current Ver": "5.0.1.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BJ-UFO",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 226,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 10, 2018",
    "Current Ver": "2.5_20",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "BJ Bridge Pro 2018",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 17,
    Size: "4.8M",
    Type: "Paid",
    Price: "$4.49",
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "May 21, 2018",
    "Current Ver": "6.2-pro",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "BJ Bridge Free (2018)",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 20,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "May 21, 2018",
    "Current Ver": "6.2-lite",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BJ & Jamie",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 13,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 6, 2015",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "The Daily BJ",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 38,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 10, 2018",
    "Current Ver": 1.1,
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "BJ-FPV",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 16,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.0.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BJ Bridge Acol Beginner 2018",
    Category: "GAME",
    Rating: 3.7,
    Reviews: 11,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "May 21, 2018",
    "Current Ver": "6.2-begina",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "BJ Memo Widget",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 616,
    Size: "175k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "September 22, 2014",
    "Current Ver": 1.3,
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "BJ Grand Salon Mobile App",
    Category: "BEAUTY",
    Rating: "NaN",
    Reviews: 1,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "June 14, 2018",
    "Current Ver": "1.0.7",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "BJ Bridge Standard American 2018",
    Category: "GAME",
    Rating: 1,
    Reviews: 1,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "May 21, 2018",
    "Current Ver": "6.2-sayc",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BJ Strategy Tester",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 1,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casino",
    "Last Updated": "May 19, 2015",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Eating Show - Food BJ",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 103,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "October 30, 2017",
    "Current Ver": 1.29,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Virtual DJ Sound Mixer",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 4010,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 10, 2017",
    "Current Ver": "NaN",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Cards Casino:Video Poker & BJ",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 325,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "May 8, 2015",
    "Current Ver": 7,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "DJ Music Pad",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 35121,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.0.6",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "BJ-DRONE",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 27, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Real Casino:Slot,Keno,BJ,Poker",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 341,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "August 12, 2016",
    "Current Ver": 1.18,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "AfreecaTV",
    Category: "VIDEO_PLAYERS",
    Rating: 3.3,
    Reviews: 381023,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.7.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "BJ - Confidential",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "April 23, 2018",
    "Current Ver": 1.7,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Basic Strategy Training BJ 21",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 0,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "March 7, 2016",
    "Current Ver": 1.1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "HON. B.J. ACS COLLEGE ALE",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 3,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Education",
    "Last Updated": "December 26, 2016",
    "Current Ver": 3.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "One Launcher",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 26601,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 16, 2018",
    "Current Ver": "26.1.0.20180713",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "BJ Toys",
    Category: "SHOPPING",
    Rating: 4.7,
    Reviews: 55,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "April 11, 2018",
    "Current Ver": "1.0.3",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Alumni BJ",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 2,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "November 8, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "뽕티비 - 개인방송, 인터넷방송, BJ방송",
    Category: "VIDEO_PLAYERS",
    Rating: "NaN",
    Reviews: 414,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Video Players & Editors",
    "Last Updated": "July 18, 2018",
    "Current Ver": "4.0.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BJ card game blackjack",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 3,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "December 2, 2016",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "BMH-BJ Congregation",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 29, 2018",
    "Current Ver": 1.22,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BJ's Community SoundBoard",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "February 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5,
    numAndroid: null,
  },
  {
    App: "Real DJ Simulator",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 68664,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "April 20, 2018",
    "Current Ver": 1.7,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "BJ TIKET",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 3,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 9, 2018",
    "Current Ver": 8,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BLACKJACK!",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 524467,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "July 7, 2016",
    "Current Ver": 1.126,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Blackjack Verite Drills",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 17,
    Size: "4.7M",
    Type: "Paid",
    Price: "$14.00",
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "July 9, 2017",
    "Current Ver": "1.1.10",
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "BJ Foods",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 3,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 7, 2018",
    "Current Ver": 2.7,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Blackjack",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 52199,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "May 18, 2017",
    "Current Ver": "1.2.4.69",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "3D DJ – DJ Mixer 2018",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 6333,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.1.12",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "BJ Adams",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "November 16, 2016",
    "Current Ver": "2.0.0",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Phonics Puzzles",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 4,
    Size: "54M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "August 27, 2016",
    "Current Ver": "1.8.2",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Spider grinder in screen funny",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 956,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "May 17, 2016",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "BJJ Roadmap by Stephan Kesting",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 969,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 21, 2014",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "KISW 99.9 FM SEATTLE",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 1469,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 29, 2018",
    "Current Ver": "2.1.10",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "BlackJack -21 Casino Card Game",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 2066,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "March 14, 2018",
    "Current Ver": 1.3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Metal Detector Pro 2015",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 1166,
    Size: "350k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 30, 2015",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BlackJack 21 Pro",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 26744,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "July 27, 2018",
    "Current Ver": "7.4.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "24 megapixel hd camera",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 802,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 3, 2017",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Ultimate BlackJack 3D FREE",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 1686,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "April 20, 2015",
    "Current Ver": "3.1.0",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "BURGER KING® App",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 41747,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 12, 2017",
    "Current Ver": "3.7.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "BURGER KING® MOBILE APP",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 19221,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "BK Chat",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 6,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "July 30, 2018",
    "Current Ver": 2.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BURGER KING® Puerto Rico",
    Category: "FOOD_AND_DRINK",
    Rating: 4.5,
    Reviews: 2448,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "September 1, 2017",
    "Current Ver": 5.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Free Coupons for Burger King",
    Category: "LIFESTYLE",
    Rating: 2.8,
    Reviews: 17,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 29, 2018",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "BK Manager",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 19,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "December 19, 2017",
    "Current Ver": "1.0.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Power Widget",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 928,
    Size: "383k",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 20, 2014",
    "Current Ver": 3.4,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "BK Murli Offline April 2017",
    Category: "LIFESTYLE",
    Rating: 4.8,
    Reviews: 33,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 3, 2017",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Read it easy for BK",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 1,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 15, 2018",
    "Current Ver": 1.2,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "BK Video Status",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 13,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 7, 2018",
    "Current Ver": 2.3,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "bk Group Mobile",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 26, 2018",
    "Current Ver": 2,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "SLANGY-Perfect BK World Theme",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "14M",
    Type: "Paid",
    Price: "$4.85",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "September 11, 2013",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "BK Formula Calculator 2",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 4,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 7, 2016",
    "Current Ver": "0.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Service Disabler",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 534,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 23, 2018",
    "Current Ver": "1.0.6",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BK Photography",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 20,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "January 6, 2017",
    "Current Ver": 0.1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Keyboard Theme Dusk BK Purple",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 248,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Personalization",
    "Last Updated": "May 23, 2016",
    "Current Ver": 9,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Coupons for Burger King",
    Category: "FOOD_AND_DRINK",
    Rating: 4.5,
    Reviews: 41,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Food & Drink",
    "Last Updated": "July 17, 2018",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "BK Formula Calculator",
    Category: "TOOLS",
    Rating: 5,
    Reviews: 6,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 8, 2015",
    "Current Ver": "0.1.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "VK",
    Category: "SOCIAL",
    Rating: 3.8,
    Reviews: 5793284,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Korean English Translator",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 634,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 5, 2017",
    "Current Ver": 1.6,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Dr Bk Sachin bhai",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 19,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 7, 2017",
    "Current Ver": 2.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Audio Murli Glossary For BK",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 39,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 25, 2016",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "SKIN BK",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 25, 2018",
    "Current Ver": "1.1.2",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BK Traffic Control cum Chart",
    Category: "SOCIAL",
    Rating: 4.7,
    Reviews: 549,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "June 29, 2016",
    "Current Ver": "3.0.1",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "Hungry Girl Diet Bk. Companion",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.2,
    Reviews: 4,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "February 1, 2018",
    "Current Ver": "1.1.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Daily Murli Saar Widget",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 308,
    Size: "454k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "June 10, 2015",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "BK Suraj bhai",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 9,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 8, 2017",
    "Current Ver": 2.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BK Shivani Videos",
    Category: "LIFESTYLE",
    Rating: 4.7,
    Reviews: 29,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 25, 2018",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BK News Channel",
    Category: "VIDEO_PLAYERS",
    Rating: 4.6,
    Reviews: 277,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 16, 2016",
    "Current Ver": 1.01,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "BK Dinos",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 30,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 31, 2018",
    "Current Ver": 0.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Make a burger king",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 125,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "February 21, 2017",
    "Current Ver": "v1.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "King Burger Dash",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 445,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "March 22, 2015",
    "Current Ver": 1.3,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Official Madhuban Murli",
    Category: "LIFESTYLE",
    Rating: 4.9,
    Reviews: 301,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 21, 2018",
    "Current Ver": "1.1.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Baba Yaad Hai?(BK's)",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 160,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 5, 2017",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Bk Bee Sales Manager",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.1M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "December 16, 2017",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Burger King Foot Lettuce",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 150,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 11, 2018",
    "Current Ver": 1.07,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BK Arogyam Task Track",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 8,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 5, 2018",
    "Current Ver": "1.1.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BK murli today (Mobile Murli) - Gyan",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 100,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 5, 2018",
    "Current Ver": 2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Capital Bk Mobile Business Dep",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 3, 2016",
    "Current Ver": "1.4.8",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BK Travel Solutions",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 1,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "June 14, 2018",
    "Current Ver": "1.3.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BK Murli Dictionary (H to E)",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 106,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 19, 2016",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Bk Usha behn",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 10,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 14, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BkEmu - BK-0010/11M emulator",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 222,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 7, 2016",
    "Current Ver": "0.4.0",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "BK Gold App",
    Category: "FINANCE",
    Rating: 5,
    Reviews: 4,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.0.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Of the wall Arapaho bk",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 18, 2017",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Burger King Italia",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 4160,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 6, 2018",
    "Current Ver": "2.3.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Red Embrace (BL/Yaoi Game)",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 616,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "June 12, 2018",
    "Current Ver": "4.5.5",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Blood Domination - BL Game",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 415,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Adventure",
    "Last Updated": "July 6, 2018",
    "Current Ver": "1.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Yaoi Ooku: Distorted Love",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 2614,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Simulation",
    "Last Updated": "April 14, 2015",
    "Current Ver": "1.0.8",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Yaoi Novels - Shounen ai Book&fiction",
    Category: "FAMILY",
    Rating: 3.2,
    Reviews: 304,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "February 14, 2018",
    "Current Ver": "1.0.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Cerulean Heart",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 2683,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Simulation",
    "Last Updated": "June 15, 2018",
    "Current Ver": "1.3.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BL 女性向け恋愛ゲーム◆俺プリクロス",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 3379,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Simulation",
    "Last Updated": "March 23, 2017",
    "Current Ver": "1.6.3",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "WebComics",
    Category: "COMICS",
    Rating: 4.8,
    Reviews: 33783,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "July 28, 2018",
    "Current Ver": "1.3.34",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Lezhin Comics - Daily Releases",
    Category: "COMICS",
    Rating: 3,
    Reviews: 28447,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Heirs & Graces",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 125,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "July 1, 2016",
    "Current Ver": "1.0.1",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "BL Driver",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.9,
    Reviews: 230,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 13, 2018",
    "Current Ver": "2.12.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Daily Manga - Comic & Webtoon",
    Category: "COMICS",
    Rating: 3.2,
    Reviews: 1462,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Comics",
    "Last Updated": "May 18, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Gaydorado",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 8419,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "August 1, 2018",
    "Current Ver": "0.0.42",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Chess of Blades (BL/Yaoi Game) (No VA)",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 4,
    Size: "23M",
    Type: "Paid",
    Price: "$14.99",
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "January 24, 2018",
    "Current Ver": 1.03,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "TappyToon Comics & Webtoons",
    Category: "COMICS",
    Rating: 3.5,
    Reviews: 4205,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "July 13, 2018",
    "Current Ver": 1.77,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "SecondSecret ‐「恋を読む」BLノベルゲーム‐",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 1563,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "June 29, 2017",
    "Current Ver": "1.3.6",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Lust in Terror Manor - The Truth Unveiled | Otome",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 355,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "July 10, 2018",
    "Current Ver": "1.0.6",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BL 女性向け恋愛ゲーム◆ごくメン",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1901,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Simulation",
    "Last Updated": "July 7, 2016",
    "Current Ver": "1.3.0",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "あなカレ【BL】無料ゲーム",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 6073,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Simulation",
    "Last Updated": "February 25, 2018",
    "Current Ver": "4.2.2",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "K-Rain BL",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 9,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 28, 2018",
    "Current Ver": "3.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "감성학원 BL 첫사랑",
    Category: "COMICS",
    Rating: 4.4,
    Reviews: 190,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "November 17, 2017",
    "Current Ver": "3.2.1",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "Chess of Blades (Demo)",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 45,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "January 25, 2018",
    "Current Ver": 1.5,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "BL Flowers Digital",
    Category: "SHOPPING",
    Rating: 5,
    Reviews: 21,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "October 31, 2017",
    "Current Ver": 1.6,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BL 1-Click Camera - Free",
    Category: "PHOTOGRAPHY",
    Rating: 3.5,
    Reviews: 52,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 18, 2016",
    "Current Ver": "2.0.160818",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Manga Books",
    Category: "COMICS",
    Rating: 3.8,
    Reviews: 7326,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Adults only 18+",
    Genres: "Comics",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "BL 1-Click Camera",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 4,
    Size: "1.4M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 18, 2016",
    "Current Ver": "2.0.160818",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "OTOME of Ikemen cafe",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 1318,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "March 5, 2018",
    "Current Ver": "1.0.21",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "BL info",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 98,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 17, 2018",
    "Current Ver": 2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "BL File Explorer",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "421k",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 18, 2014",
    "Current Ver": "1.5.140718",
    numInstall: 50,
    numAndroid: 1,
  },
  {
    App: "BL IP-Camera",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 15,
    Size: "1.2M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 5, 2014",
    "Current Ver": "1.3.140606",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "BL Carrier",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 27, 2018",
    "Current Ver": 5,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Skill Tree - BL Pre Sequel",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 855,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "February 22, 2016",
    "Current Ver": 5,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "BL Holo Theme",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 18,
    Size: "2.1M",
    Type: "Paid",
    Price: "$2.00",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 1, 2013",
    "Current Ver": "1.0.3",
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "BL Portfolio",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 4,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 13, 2017",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Skywatch BL",
    Category: "WEATHER",
    Rating: "NaN",
    Reviews: 15,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "February 20, 2017",
    "Current Ver": "1.1.6",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "B-L Animal Hospital",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 8, 2017",
    "Current Ver": "300000.0.84",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BL Banking DES",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 3,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 18, 2018",
    "Current Ver": 2.3,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BL ONLINE PERSONAL TRAINING",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 29, 2017",
    "Current Ver": "BL ONLINE PERSONAL TRAINING 7.9.0",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "BL Community Icon Pack",
    Category: "PERSONALIZATION",
    Rating: 4,
    Reviews: 289,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 6, 2013",
    "Current Ver": 1.01,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "BL Mobile Banking",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 23,
    Size: "93M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.6.0",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "MEGA MAN MOBILE",
    Category: "GAME",
    Rating: 4,
    Reviews: 267,
    Size: "40M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "February 17, 2017",
    "Current Ver": "1.02.01",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BL Taxi",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.9,
    Reviews: 124,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "March 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "BL!TZ - Endless",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 21,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "June 30, 2017",
    "Current Ver": 10.05,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AC-BL",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 20, 2018",
    "Current Ver": 1.7,
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "BL-ED: From BLUE to RED",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 3,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "April 24, 2016",
    "Current Ver": "1.6.5",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "B L Enterprises",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 2,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 11, 2018",
    "Current Ver": 1.8,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BL PowerPoint Remote",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 33,
    Size: "1.0M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 25, 2015",
    "Current Ver": "2.6.150226",
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "BL Kennedy Theme",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 279,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 6, 2013",
    "Current Ver": "1.0.2",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Teen Patti by BL Games",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 496,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "January 31, 2017",
    "Current Ver": "1.3.0",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "BBM - Free Calls & Messages",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 12843436,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "BeyondMenu Food Delivery",
    Category: "FOOD_AND_DRINK",
    Rating: 4.7,
    Reviews: 51543,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "bm offers",
    Category: "LIFESTYLE",
    Rating: 3.2,
    Reviews: 320,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 13, 2017",
    "Current Ver": 1.4,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "B.M.Snowboard Free",
    Category: "SPORTS",
    Rating: 3.9,
    Reviews: 9765,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 1, 2017",
    "Current Ver": "1.38.1",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "BM Wallet",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 798,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "January 3, 2018",
    "Current Ver": "1.0.46",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "BM Online OEC Verification",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 783,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 5, 2016",
    "Current Ver": "1.0.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Business Mitra (BM)",
    Category: "BUSINESS",
    Rating: 4.9,
    Reviews: 13,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.11.1prod",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Bm",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "September 21, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Basket Manager 2018 Pro",
    Category: "SPORTS",
    Rating: 3.7,
    Reviews: 84,
    Size: "6.3M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "April 17, 2018",
    "Current Ver": 3.7,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "bm Wallet",
    Category: "FINANCE",
    Rating: 3.5,
    Reviews: 196,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 20, 2017",
    "Current Ver": 1.8,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BatControl Pro",
    Category: "TOOLS",
    Rating: 4.9,
    Reviews: 83,
    Size: "3.1M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 1, 2018",
    "Current Ver": "2.0.0",
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "Myjob@BM",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "June 13, 2018",
    "Current Ver": "1.16.21",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DMR BrandMeister Tool",
    Category: "COMMUNICATION",
    Rating: 3.3,
    Reviews: 78,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "March 31, 2018",
    "Current Ver": 4.5,
    numInstall: 10000,
    numAndroid: 6,
  },
  {
    App: "Borneo Bible, BM Bible",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.9,
    Reviews: 659,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 28, 2017",
    "Current Ver": "4.4.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Basket Manager 2018 Free",
    Category: "SPORTS",
    Rating: 3.4,
    Reviews: 1520,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "April 17, 2018",
    "Current Ver": 3.7,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "MOD Black for BM",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 2,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 31, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Basket Manager 2017 Free",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 2710,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "November 27, 2017",
    "Current Ver": 4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BM Box",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.3,
    Reviews: 28,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "October 20, 2016",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "BM SPM Practice",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 6,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 24, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BM FlexCheck",
    Category: "AUTO_AND_VEHICLES",
    Rating: 3.5,
    Reviews: 2,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "June 8, 2018",
    "Current Ver": "1.10.1",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "TuenMun BM",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 6,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 17, 2017",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "bm-Events",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "November 1, 2016",
    "Current Ver": "1.1.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Poop Tracker - Toilet Log",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 622,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "May 9, 2018",
    "Current Ver": "1.3.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "B&M Stores",
    Category: "SHOPPING",
    Rating: 3.7,
    Reviews: 192,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "0.8.129",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BM CRM",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 0,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "October 31, 2017",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Mobilight-BM",
    Category: "FINANCE",
    Rating: 4.8,
    Reviews: 6,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.0.10",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "iFORA BM",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 3,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 9, 2018",
    "Current Ver": "1.0.8",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Basket Manager 2016 Free",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 1879,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 9, 2017",
    "Current Ver": 2.9,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BM Pharmacy",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.9,
    Reviews: 42,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 11, 2018",
    "Current Ver": "1.5.12",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "postit.bm",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 1,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "March 14, 2018",
    "Current Ver": 2.53,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "orderin.bm",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1,
    numAndroid: null,
  },
  {
    App: "BM Assets",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 6,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "October 25, 2016",
    "Current Ver": 1.1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "BM Interventi",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 2,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 4, 2018",
    "Current Ver": "1.4.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BM Tahmin: Ücretsiz İddaa Tahminleri",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 7,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "December 11, 2017",
    "Current Ver": 1.3,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "RIV-BM FPV",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 12, 2017",
    "Current Ver": "1.0.1",
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "BM Physiotherapy Clinic",
    Category: "HEALTH_AND_FITNESS",
    Rating: 5,
    Reviews: 3,
    Size: "9.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "October 9, 2017",
    "Current Ver": "0.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BBMoji - Your personalized BBM Stickers",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 8827,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.0.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Dormi - Baby Monitor",
    Category: "PARENTING",
    Rating: 4.3,
    Reviews: 11760,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "June 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "På sporet ABC (BM)",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "December 21, 2016",
    "Current Ver": "v1.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BAMMS for BM 1Park",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 7,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.3.2",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Bet Master Pro Soccer Predictions",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 328,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.0.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "MbH BM",
    Category: "MEDICAL",
    Rating: 1,
    Reviews: 1,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "December 14, 2016",
    "Current Ver": "1.1.3",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Basket Manager 2016 Pro",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 117,
    Size: "4.4M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 9, 2017",
    "Current Ver": 2.9,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Anime Mod for BM",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 28, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BAMMS for BM SQ",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 2,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.3.3",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BM speed test",
    Category: "TOOLS",
    Rating: 5,
    Reviews: 1,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 13, 2018",
    "Current Ver": 2,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Word Hunt",
    Category: "GAME",
    Rating: 4.9,
    Reviews: 59,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "June 22, 2018",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Basket Manager 2017 Pro",
    Category: "SPORTS",
    Rating: 4.7,
    Reviews: 163,
    Size: "4.6M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "October 6, 2017",
    "Current Ver": 3.9,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "NOOK: Read eBooks & Magazines",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 155466,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "April 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "BN Más Cerca de Usted",
    Category: "FINANCE",
    Rating: 3.9,
    Reviews: 8185,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 6, 2018",
    "Current Ver": 5.1,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Radio BN",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 53,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 12, 2018",
    "Current Ver": "1.0.3",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "My College Bookstore",
    Category: "SHOPPING",
    Rating: 3.2,
    Reviews: 661,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "March 19, 2018",
    "Current Ver": "3.0.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "NOOK Audiobooks",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.5,
    Reviews: 2539,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 26, 2018",
    "Current Ver": "v1.1.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "BN PERKS™",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 2, 2018",
    "Current Ver": 2.13,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BNCR Token Celular",
    Category: "FINANCE",
    Rating: 3.7,
    Reviews: 913,
    Size: "70k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 20, 2012",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 1,
  },
  {
    App: "BN Mi Banco",
    Category: "BUSINESS",
    Rating: 3,
    Reviews: 597,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 12, 2018",
    "Current Ver": 9,
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "BN Pro BlueICS-b HD Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.2,
    Reviews: 78,
    Size: "812k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "BN Whitening Shoppe Ph",
    Category: "BEAUTY",
    Rating: 4,
    Reviews: 2,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "March 6, 2018",
    "Current Ver": "1.0.8",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BN Pro ArialXL Legacy Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.1,
    Reviews: 142,
    Size: "442k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "Sam.BN Pro",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 11,
    Size: "2.0M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 27, 2015",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "NOOK App for NOOK Devices",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 19090,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "April 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "BN Pro PercentXL-b Neon HD Txt",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4,
    Reviews: 45,
    Size: "842k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 5000,
    numAndroid: 1,
  },
  {
    App: "BN Bank Mobilbank",
    Category: "FINANCE",
    Rating: 3.1,
    Reviews: 72,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 13, 2018",
    "Current Ver": "2.0.9",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BN Pro Play-b HD Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.4,
    Reviews: 34,
    Size: "417k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 1000,
    numAndroid: 1,
  },
  {
    App: "[BN] Blitz",
    Category: "SPORTS",
    Rating: 3.2,
    Reviews: 4,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 17, 2018",
    "Current Ver": 4.6,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BN Pro LcdD Legacy Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 3.9,
    Reviews: 71,
    Size: "412k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "BN Pro RobotoXL-b HD Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.2,
    Reviews: 86,
    Size: "459k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "Browsery by Barnes & Noble",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 146,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "April 30, 2018",
    "Current Ver": "1.1.3",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "BN Pro ArialXL-b HD Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4,
    Reviews: 24,
    Size: "478k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 1000,
    numAndroid: 1,
  },
  {
    App: "2017 BN SM Sales Conference",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Business",
    "Last Updated": "September 28, 2017",
    "Current Ver": "v2.7.11.6",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BN Inscript Improved Input keyboard",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 7, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "BN Pro Percent White HD Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4,
    Reviews: 45,
    Size: "335k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 5000,
    numAndroid: 1,
  },
  {
    App: "RTVBN",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.7,
    Reviews: 533,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "August 5, 2018",
    "Current Ver": 4.4,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "BN Pro White HD Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.1,
    Reviews: 120,
    Size: "782k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "BN Pro Roboto-b Neon HD Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.4,
    Reviews: 30,
    Size: "721k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 5000,
    numAndroid: 1,
  },
  {
    App: "BN Pro LcdD HD Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4,
    Reviews: 50,
    Size: "430k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 5000,
    numAndroid: 1,
  },
  {
    App: "BN Pro LcdD-b HD Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 3.9,
    Reviews: 131,
    Size: "429k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "BN Pro Solid Battery-White",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 3.6,
    Reviews: 7,
    Size: "192k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 1000,
    numAndroid: 1,
  },
  {
    App: "BN Pro Battery Level-White",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 21,
    Size: "200k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 5000,
    numAndroid: 1,
  },
  {
    App: "BN MALLORCA Radio",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 23,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "November 29, 2017",
    "Current Ver": "2.0.14.4",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Calendars (En, Bn, Ar)",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 27,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 5, 2017",
    "Current Ver": "1.2.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BN Habitat - Property Experts - Buy | Sell | Rent",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 4, 2017",
    "Current Ver": 1.8,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "BN Pro Play HD Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.4,
    Reviews: 63,
    Size: "417k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 5000,
    numAndroid: 1,
  },
  {
    App: "Yuzu eReader",
    Category: "FAMILY",
    Rating: 1.9,
    Reviews: 250,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "BN Pro RobotoXL HD Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.3,
    Reviews: 15,
    Size: "460k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 1000,
    numAndroid: 1,
  },
  {
    App: "New York Mysteries (Full)",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 514,
    Size: "5.9M",
    Type: "Paid",
    Price: "$6.99",
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "June 4, 2018",
    "Current Ver": "1.0.36",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "BN Pro ArialXL-b Neon HD Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.1,
    Reviews: 66,
    Size: "728k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "BN Pro Black Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 3.8,
    Reviews: 18,
    Size: "496k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 1000,
    numAndroid: 1,
  },
  {
    App: "BN Pro BlueICS HD Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.1,
    Reviews: 174,
    Size: "816k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "The Legacy (Full)",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 144,
    Size: "6.3M",
    Type: "Paid",
    Price: "$6.99",
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "May 15, 2018",
    "Current Ver": "1.0.9",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BN Pro Arial Legacy Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 3.7,
    Reviews: 83,
    Size: "414k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "BN Pro Black Text on White",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 3.9,
    Reviews: 53,
    Size: "334k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "BN Pro White Text",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.4,
    Reviews: 50,
    Size: "506k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "February 5, 2017",
    "Current Ver": "2.3.2",
    numInstall: 5000,
    numAndroid: 1,
  },
  {
    App: "Sam.BN",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 83,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 27, 2015",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Bangla Calendar 1425: (EN-BN-AR) Holiday",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 31,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "April 21, 2018",
    "Current Ver": "2.1.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BN DB1 App",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 2,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 4, 2017",
    "Current Ver": 1.2,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "BN Inscript Improved Keyboard",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 6, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "Badoo - Free Chat & Dating App",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 3781467,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Skip-Bo™",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 33661,
    Size: "60M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.4.6",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Skip-Bo™ Free",
    Category: "GAME",
    Rating: 3.5,
    Reviews: 46801,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.4.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Beck & Bo: Toddler First Words",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 41,
    Size: "7.9M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "May 31, 2018",
    "Current Ver": "2.4.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Bubble Bo-Bo",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 65,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 5, 2018",
    "Current Ver": 6,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Boom Beach",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 5591653,
    Size: "95M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 18, 2018",
    "Current Ver": 35.119,
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Red Ball 4",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 1432447,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "November 9, 2017",
    "Current Ver": "1.3.21",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Bo's Bedtime Story",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 13,
    Size: "23M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "December 25, 2017",
    "Current Ver": 2.6,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Skater Boy",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1167143,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "September 20, 2017",
    "Current Ver": "1.18.35",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Sic Bo",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 1,
    Size: "11M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "August 27, 2013",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "FX LITE BO",
    Category: "FINANCE",
    Rating: 3.6,
    Reviews: 73,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "October 18, 2016",
    "Current Ver": "1.5.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Casual Sic Bo (骰寶)",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 3,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "July 22, 2018",
    "Current Ver": "1.1.1",
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "Sic Bo Online! Free Casino",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 488,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "June 10, 2016",
    "Current Ver": 1.3,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Dr.Dice - Sic bo analyzer",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "8.5M",
    Type: "Paid",
    Price: "$46.99",
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 5, 2016",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Bo's Matching Game",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "19M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Education;Brain Games",
    "Last Updated": "December 28, 2017",
    "Current Ver": 1.4,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Hambo",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 125578,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 6, 2015",
    "Current Ver": "1.1.8",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "HBO GO: Stream with TV Package",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 87734,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 19, 2018",
    "Current Ver": "16.0.0.437",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Sic Bo Rave",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 164,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "September 23, 2013",
    "Current Ver": "1.0.1",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Thai Sic Bo",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 14283,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "October 1, 2017",
    "Current Ver": "1.1.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Bo's Dinnertime Story",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 6,
    Size: "33M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "December 25, 2017",
    "Current Ver": 1.5,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BOO! - Next Generation Messenger",
    Category: "SOCIAL",
    Rating: 3.5,
    Reviews: 20675,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.4.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Socle Commun BO du 23-04-2015",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 4,
    Size: "4.7M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "August 8, 2016",
    "Current Ver": "0.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Wishbone - Compare Anything",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 51569,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 30, 2018",
    "Current Ver": "5.4.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Bee.Bo",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 11,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "April 13, 2017",
    "Current Ver": "1.2.9",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Bo's School Day",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 10,
    Size: "30M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "December 18, 2017",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Bounce Classic",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 38297,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.0.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Habbo - Virtual World",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 159398,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "May 30, 2018",
    "Current Ver": "2.22.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Bomber Friends",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 776730,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "July 26, 2018",
    "Current Ver": 2.23,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Sic Bo (Tai Xiu) - Multiplayer Casino",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 152,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "July 8, 2018",
    "Current Ver": "2.1.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Power Spheres by BoBoiBoy",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 70903,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "May 3, 2018",
    "Current Ver": "1.3.20",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Bo Aung Din",
    Category: "EVENTS",
    Rating: 4.1,
    Reviews: 110,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Events",
    "Last Updated": "June 5, 2018",
    "Current Ver": "Version 1.3.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "No Crop & Square for Instagram",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 819694,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 26, 2018",
    "Current Ver": "4.2.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Township",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 4451317,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 19, 2018",
    "Current Ver": "5.9.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Hungry Shark World",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1243017,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 18, 2018",
    "Current Ver": "3.0.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Go-Go-Goat! Free Game",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 66740,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade;Action & Adventure",
    "Last Updated": "July 8, 2016",
    "Current Ver": "2.4.4",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "BPme - Mobile Fuel Payment & BP Driver Rewards app",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3,
    Reviews: 69,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 11, 2018",
    "Current Ver": "3.4.1",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "My BP Lab",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.6,
    Reviews: 186,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "May 19, 2018",
    "Current Ver": "1.1.0",
    numInstall: 10000,
    numAndroid: 8,
  },
  {
    App: "BP World Energy",
    Category: "BUSINESS",
    Rating: 3.4,
    Reviews: 25,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.1.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "iBP Blood Pressure",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 578,
    Size: "704k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "November 30, 2014",
    "Current Ver": "7.0.1",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Blood Pressure",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 33033,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 24, 2018",
    "Current Ver": "3.27.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "BP and Sugar Test Prank",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 7808,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "November 5, 2015",
    "Current Ver": "1.2.1",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Blood Pressure Log - MyDiary",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 8347,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 13, 2018",
    "Current Ver": "1.4.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "iFORA BP",
    Category: "MEDICAL",
    Rating: 3.4,
    Reviews: 18,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 5, 2018",
    "Current Ver": "1.2.4",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "MbH BP",
    Category: "MEDICAL",
    Rating: 3.7,
    Reviews: 9,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 3, 2017",
    "Current Ver": "1.1.3",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Blood Pressure(BP) Diary",
    Category: "MEDICAL",
    Rating: 3.7,
    Reviews: 3596,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 18, 2018",
    "Current Ver": "4.0.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Cardio Journal — Blood Pressure Log",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 3320,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "February 12, 2018",
    "Current Ver": "3.1.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Blood Pressure Info",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 174423,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 2, 2018",
    "Current Ver": 2.28,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "BP Journal - Blood Pressure Diary",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 6,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.0.32",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Blood Pressure Monitor",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 17,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "February 25, 2017",
    "Current Ver": "1.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Blood Pressure Companion",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 178,
    Size: "4.8M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 22, 2018",
    "Current Ver": "4.1.5 (Steglitz)",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Monitor My BP",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.6M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "November 26, 2016",
    "Current Ver": "2.0.1",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "MedM Blood Pressure",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 255,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 25, 2018",
    "Current Ver": "2.5.80",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Free Blood Pressure",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 7,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 13, 2016",
    "Current Ver": "3.0.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Diabetes, Blood Pressure, Health Tracker App",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 309,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 15, 2017",
    "Current Ver": 2.21,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Blood Pressure(BP) Report Lite",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 91,
    Size: "335k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "February 8, 2012",
    "Current Ver": 1.6,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "bp e-store",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 52,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "January 15, 2016",
    "Current Ver": "2.0.7",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Wireless BP",
    Category: "MEDICAL",
    Rating: 1.8,
    Reviews: 30,
    Size: "887k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 27, 2016",
    "Current Ver": 1.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "BP Tracker",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.3,
    Reviews: 12,
    Size: "613k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "February 20, 2016",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "BP Log lite",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 3,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "November 15, 2014",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "MI-BP",
    Category: "HEALTH_AND_FITNESS",
    Rating: 5,
    Reviews: 1,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "April 9, 2018",
    "Current Ver": "1.0.8.506",
    numInstall: 50,
    numAndroid: 5,
  },
  {
    App: "BP Service",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 17, 2018",
    "Current Ver": "Rocksteady 1.3",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BP-Tech",
    Category: "FAMILY",
    Rating: 3.2,
    Reviews: 12,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "February 3, 2018",
    "Current Ver": "1.3_4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Blood Pressure Log - bpresso.com",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 5661,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 19, 2017",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Blood Pressure Diary",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 47,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 1, 2018",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "High Blood Pressure",
    Category: "MEDICAL",
    Rating: 3.8,
    Reviews: 4,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 1, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Simple Blood Pressure log",
    Category: "MEDICAL",
    Rating: 3.9,
    Reviews: 31,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 15, 2016",
    "Current Ver": "1.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BP Tracker-Symptoms & Solution",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 34,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 12, 2016",
    "Current Ver": 1.2016,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Compas BP Store",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "December 21, 2017",
    "Current Ver": "1.0.3",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Blood Pressure Tracker",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 11,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "November 8, 2017",
    "Current Ver": "1.1.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Hypertension Hi blood pressure",
    Category: "MEDICAL",
    Rating: 3.8,
    Reviews: 292,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 16, 2018",
    "Current Ver": 43,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BP Scanner Prank",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 157,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "September 20, 2016",
    "Current Ver": 1.2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Deep Breathe BP",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.9,
    Reviews: 26,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 9, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "bpresso PRO",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 515,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$5.49",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 19, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "BP Toolbox",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.1,
    Reviews: 32,
    Size: "9.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "May 22, 2018",
    "Current Ver": 5.9,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "bp Magazine for Bipolar",
    Category: "LIFESTYLE",
    Rating: 1.8,
    Reviews: 5,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Lifestyle",
    "Last Updated": "February 12, 2018",
    "Current Ver": 26,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Blood Pressure - Heartcare",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 70,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 27, 2016",
    "Current Ver": "2.46 Saber",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "UM BP Track",
    Category: "MEDICAL",
    Rating: 2,
    Reviews: 1,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 27, 2017",
    "Current Ver": "7.9.0 (5192)",
    numInstall: 50,
    numAndroid: 5,
  },
  {
    App: "BP Assist",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 3, 2018",
    "Current Ver": "4.4.14.4487",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BP Fitness Lead Scanner",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "6.7M",
    Type: "Paid",
    Price: "$109.99",
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "August 23, 2017",
    "Current Ver": "0.0.1",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Blood pressure",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.4,
    Reviews: 2256,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 31, 2014",
    "Current Ver": "1.1.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "High Blood Pressure Symptoms",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 46,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 5, 2017",
    "Current Ver": "1.0.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BQ Camera",
    Category: "PHOTOGRAPHY",
    Rating: 3.6,
    Reviews: 2526,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "BQ Services",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 5004,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 9, 2018",
    "Current Ver": "8.3.6-e04ac87",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "BQ-መጽሐፍ ቅዱሳዊ ጥያቄዎች",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 191,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.1.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Brilliant Quotes: Life, Love, Family & Motivation",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 67186,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Books & Reference",
    "Last Updated": "May 18, 2018",
    "Current Ver": "4.4.10",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "BQ Scan",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 18,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 1, 2018",
    "Current Ver": "3.4.5",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Add-On: bq (a)",
    Category: "PRODUCTIVITY",
    Rating: 3.6,
    Reviews: 26,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 19, 2015",
    "Current Ver": "10.0.3086",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "BQ Partners",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "gardening ideas flower diy",
    Category: "HOUSE_AND_HOME",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "May 29, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Software Update",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 8259,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 18, 2018",
    "Current Ver": 13.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "RoboPad",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 41,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 7, 2017",
    "Current Ver": 5.1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Add-On: bq (c)",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 17,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 19, 2015",
    "Current Ver": "10.0.3086",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BQ Llicència",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 18,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "January 30, 2016",
    "Current Ver": "Varies with device",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Wherever BQ",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 7,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Travel & Local",
    "Last Updated": "September 5, 2017",
    "Current Ver": "5.63.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Bono’s Pit Bar-B-Q",
    Category: "FAMILY",
    Rating: 2.3,
    Reviews: 3,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Entertainment",
    "Last Updated": "January 23, 2018",
    "Current Ver": 2.4,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Add-On: bq (b)",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 9,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 19, 2015",
    "Current Ver": "10.0.3086",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "bq magazine",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 2,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 19, 2018",
    "Current Ver": "7.2.2",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "QR Scanner & Barcode Scanner 2018",
    Category: "PRODUCTIVITY",
    Rating: 3.8,
    Reviews: 8211,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 20, 2018",
    "Current Ver": "1.8.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Bill Miller Bar-B-Q Store Ops",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 19, 2018",
    "Current Ver": 1.3,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BQ Scanner",
    Category: "TOOLS",
    Rating: 3,
    Reviews: 2,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 10, 2017",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Bar-B-Q Rib House",
    Category: "FOOD_AND_DRINK",
    Rating: 5,
    Reviews: 2,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "March 8, 2018",
    "Current Ver": 0.8,
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "Gold Wallpapers",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 43,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 26, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "[Substratum] M5 Theme",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 16,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 10, 2018",
    "Current Ver": "1.3.4",
    numInstall: 5000,
    numAndroid: 7,
  },
  {
    App: "Zowi App",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 516,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "December 21, 2016",
    "Current Ver": "1.4.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Bar-B-Q Recipes",
    Category: "FOOD_AND_DRINK",
    Rating: 4.8,
    Reviews: 18,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 15, 2016",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "System Update Free",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 3068,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 20, 2018",
    "Current Ver": 11.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Camera FV-5",
    Category: "PHOTOGRAPHY",
    Rating: 3.8,
    Reviews: 16317,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$3.95",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 10, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Bar BQ Tonight Dublin",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 20, 2018",
    "Current Ver": "1.1.9371",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Camera MX - Free Photo & Video Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 244302,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Woody's Bar-B-Q",
    Category: "FOOD_AND_DRINK",
    Rating: 3.7,
    Reviews: 3,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "March 5, 2018",
    "Current Ver": "1.01.03",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Launcher Oreo 8.1",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 13466,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 19, 2018",
    "Current Ver": 1.9,
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Theme for Android 7.0",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "October 18, 2017",
    "Current Ver": "Varies with device",
    numInstall: 5000,
    numAndroid: null,
  },
  {
    App: "Free antivirus and VPN",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 27749,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 19, 2018",
    "Current Ver": "3.3.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Jimbo's Pit Bar B-Q",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 3,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "November 28, 2016",
    "Current Ver": "2.6.003",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "RoboPad++",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 77,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 7, 2017",
    "Current Ver": 1.6,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "IKEA Store",
    Category: "SHOPPING",
    Rating: 3.4,
    Reviews: 25515,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Simple Gallery",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 28030,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.4.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Pick-a-Paint",
    Category: "LIFESTYLE",
    Rating: 1.6,
    Reviews: 242,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 14, 2018",
    "Current Ver": "1.2.1",
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "Miller's Bar B-Q",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 0,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "November 30, 2016",
    "Current Ver": "2.6.003",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "BAR-B-Q Recipes",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "January 30, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Left vs Right: Brain Training",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 75719,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "November 24, 2017",
    "Current Ver": "3.3.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Bar BQ Night Middlesbrough",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 0,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "July 2, 2018",
    "Current Ver": "5.13.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BQ Wings",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 1,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 17, 2018",
    "Current Ver": "2.7.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Bible Quizzer - The App for Bible Quizzers",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 2, 2018",
    "Current Ver": 30,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Texas Bar-B-Q Rewards",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 0,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "March 28, 2018",
    "Current Ver": "2.0.24",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "4-T's Bar-BQ & Catering",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 0,
    Size: "243k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "January 16, 2017",
    "Current Ver": "1.0.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Zetup, print in one click",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 40,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 26, 2018",
    "Current Ver": "1.11.6",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Bleacher Report: sports news, scores, & highlights",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 122280,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Sports",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Baskin-Robbins",
    Category: "FOOD_AND_DRINK",
    Rating: 3.8,
    Reviews: 1103,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "June 8, 2018",
    "Current Ver": "1.4.0-2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Infinity Dungeon VIP",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 21804,
    Size: "44M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "July 3, 2018",
    "Current Ver": "2.6.6",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Carros Rebaixados BR",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 20691,
    Size: "89M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "July 31, 2018",
    "Current Ver": "5.7.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BR",
    Category: "LIFESTYLE",
    Rating: 3,
    Reviews: 859,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.7.7",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Bleacher Report Live",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 232,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.1.2",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "Cardboard",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.2,
    Reviews: 130287,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "March 14, 2016",
    "Current Ver": 1.8,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "QR Code Pro",
    Category: "PRODUCTIVITY",
    Rating: 4.8,
    Reviews: 5865,
    Size: "15M",
    Type: "Paid",
    Price: "$4.49",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 18, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BR Video Player",
    Category: "VIDEO_PLAYERS",
    Rating: 4,
    Reviews: 46,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "April 20, 2015",
    "Current Ver": "1.0.6",
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "Br. Parking - Busy road Parking 3D 2018",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 41,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "January 13, 2018",
    "Current Ver": 1.01,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Br video editing",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "September 1, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "B R Telco FCU Mobile Banking",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 413,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 30, 2018",
    "Current Ver": "5.9.1.0",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "BR Chat Bot",
    Category: "SOCIAL",
    Rating: 1.9,
    Reviews: 16,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "June 30, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Br Browser",
    Category: "SOCIAL",
    Rating: 4.9,
    Reviews: 29,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "March 20, 2018",
    "Current Ver": 5,
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "TV Guide BR Gold",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 544,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 20, 2017",
    "Current Ver": "Varies with device",
    numInstall: 5000,
    numAndroid: null,
  },
  {
    App: "Dr B R Ambedkar (Jai Bhim)",
    Category: "SOCIAL",
    Rating: 4.7,
    Reviews: 2068,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "April 13, 2014",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Tv Br News",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 4,
    Size: "569k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 10, 2018",
    "Current Ver": 1.4,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Br Shafi",
    Category: "FAMILY",
    Rating: 4.9,
    Reviews: 1288,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 11, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Dr. B.R.Ambedkar",
    Category: "SOCIAL",
    Rating: 4.8,
    Reviews: 1902,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "June 5, 2014",
    "Current Ver": 1.3,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "cronometra-br",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.4M",
    Type: "Paid",
    Price: "$154.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 24, 2017",
    "Current Ver": "1.0.0",
    numInstall: 0,
    numAndroid: 4,
  },
  {
    App: "Táxi Nacional BR",
    Category: "MAPS_AND_NAVIGATION",
    Rating: "NaN",
    Reviews: 88,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.46.5",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Texas HoldEm Poker Deluxe (BR)",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1418,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "May 30, 2018",
    "Current Ver": "1.2.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BR Classified",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 30, 2017",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Top BR Chaya Songs",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 18, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Companion for Fortnite & Fortnite Battle Royale",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 2736,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Mu Mobile BR",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 43,
    Size: "92M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 20, 2018",
    "Current Ver": "3.0.0 By Luccas",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Cube BR LWP simple",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 19,
    Size: "206k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "November 25, 2016",
    "Current Ver": "1.5.2",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Brick Breaker BR",
    Category: "GAME",
    Rating: 5,
    Reviews: 7,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 23, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Mu Elite BR",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 30,
    Size: "93M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Business",
    "Last Updated": "July 16, 2018",
    "Current Ver": "3.0.By.EliteMu",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "BR Series",
    Category: "VIDEO_PLAYERS",
    Rating: 3.9,
    Reviews: 1016,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "May 28, 2018",
    "Current Ver": 6,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Loteria BR",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 17, 2017",
    "Current Ver": "1.0.6",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Vidroid.com.br",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 49,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "November 25, 2017",
    "Current Ver": 8,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "CJ - BR MEMES",
    Category: "COMICS",
    Rating: 4.3,
    Reviews: 109,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "January 18, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CINE BR",
    Category: "VIDEO_PLAYERS",
    Rating: "NaN",
    Reviews: 23,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "March 29, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Vlogger Go Viral - Tuber Game",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 1304467,
    Size: "68M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "July 27, 2018",
    "Current Ver": 2.9,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Next Portuguese(BR) Langpack",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 1320,
    Size: "778k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 13, 2013",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "BR Ambedkar Biography & Quotes",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 156,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 11, 2018",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "B R COACHINGS",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 12, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "B. R. Ambedkar Jayanti SMS",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 19, 2018",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Black Commando | Special Ops | FPS Shooting",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 1167,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "May 3, 2018",
    "Current Ver": 1.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "GearBest Online Shopping",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 245104,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 1, 2018",
    "Current Ver": "3.6.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "iPlayIT for YouTube VR Player",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 5879,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "June 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "True Skateboarding Ride Skateboard Game Freestyle",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 8175,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "January 3, 2018",
    "Current Ver": "2.11.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Bullshit! (Free)",
    Category: "GAME",
    Rating: 2.4,
    Reviews: 45,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "August 26, 2016",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BSPlayer FREE",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 138337,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "April 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Bullshite!",
    Category: "GAME",
    Rating: 2.8,
    Reviews: 48,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "April 10, 2016",
    "Current Ver": "1.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Block Strike",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 947515,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 25, 2018",
    "Current Ver": "5.3.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Loved by King Bs",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 5546,
    Size: "85M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 15, 2018",
    "Current Ver": 1.21,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BombSquad Remote",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 13304,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "November 30, 2016",
    "Current Ver": "1.2.21",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BSPlayer",
    Category: "VIDEO_PLAYERS",
    Rating: 4.2,
    Reviews: 4585,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "March 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "BS CS IT & SE",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 9,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 16, 2018",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BSPlayer ARMv7 VFP CPU support",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 9966,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "March 31, 2017",
    "Current Ver": 1.23,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Marked by King Bs",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 70335,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "October 17, 2017",
    "Current Ver": "1.0.7",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "COMSATS BOOK STORE FOR BS(CS)",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 15,
    Size: "94M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 11, 2018",
    "Current Ver": 2,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "BS-Mobile",
    Category: "COMMUNICATION",
    Rating: 5,
    Reviews: 1,
    Size: "683k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "September 3, 2015",
    "Current Ver": 0.1,
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "BS Meter (Ad Supported)",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 14,
    Size: "592k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 14, 2013",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "BS Calendar / Patro / पात्रो",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 218,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 15, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Simulator Brawl Box for BS",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 168,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 27, 2017",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "BS Generator",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 5,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 23, 2016",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BS Match Maker Premium",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 3,
    Size: "319k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 10, 2018",
    "Current Ver": "1.11.2",
    numInstall: 10,
    numAndroid: 5,
  },
  {
    App: "BS Films",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 12, 2017",
    "Current Ver": "2.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BS Tractor",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 3,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "December 6, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BS player remote",
    Category: "VIDEO_PLAYERS",
    Rating: 3.5,
    Reviews: 54,
    Size: "186k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "April 22, 2013",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "BibApp TU BS",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 16,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 15, 2014",
    "Current Ver": "2.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "King of B.S.",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 4,
    Size: "840k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 9, 2014",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BS Chopper",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 0,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "October 5, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BS Play",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 56,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 4, 2015",
    "Current Ver": "1.1.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "B@dL!bs Lite",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 10,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Word",
    "Last Updated": "April 5, 2016",
    "Current Ver": 6,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BS Battery+",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 269,
    Size: "647k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 18, 2012",
    "Current Ver": "4.0.1",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "ATC Unico BS",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 10,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "October 16, 2015",
    "Current Ver": 0.12,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Revista BS",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 10,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "January 13, 2017",
    "Current Ver": "0.0.5",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BS MAPS",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.5,
    Reviews: 6,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 28, 2018",
    "Current Ver": 2.1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Beauty Rental Shop",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 11480,
    Size: "93M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.0.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BS Where Am I",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 9,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 5, 2018",
    "Current Ver": 2.3,
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "Bsc Agri Notes",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 301,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 1, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Love Signal: D-Mate",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1895,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "February 27, 2018",
    "Current Ver": "1.0.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "BSC IT",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 847,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 16, 2018",
    "Current Ver": 2.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BS TRACK CLIENT",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "191k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 13, 2017",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 1,
  },
  {
    App: "Kiosko BS",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 55,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 12, 2017",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Sleeping Delivery",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 19640,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "May 18, 2018",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BS Detector - Diss 'n' Gauges",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "842k",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 22, 2013",
    "Current Ver": 1.3,
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "CABLE SIZE CALCULATOR BS 7671",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 333,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 3, 2016",
    "Current Ver": 2.4,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Corporate B.S. Generator",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "November 20, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 3,
  },
  {
    App: "Banco Sabadell App. Your mobile bank",
    Category: "FINANCE",
    Rating: 3.9,
    Reviews: 25205,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Strætó.is",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.1,
    Reviews: 742,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 9, 2018",
    "Current Ver": 5.7,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "VOLT DROP CALCULATOR BS 7671",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 71,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 26, 2016",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "BSc Ag Entrance Preparation",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 138,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 31, 2018",
    "Current Ver": 3.7,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "17th Edition Cable Sizer",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 47,
    Size: "1.4M",
    Type: "Paid",
    Price: "$3.08",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 27, 2016",
    "Current Ver": 1.22,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Black Survival",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 48451,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.6.00",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Black Social",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 22,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 5, 2018",
    "Current Ver": "31.1.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BTNotification",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 15665,
    Size: "373k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 8, 2016",
    "Current Ver": "1.1.43",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Little Magnet BT",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 3703,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 5, 2018",
    "Current Ver": "4.1.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BT Notifier",
    Category: "TOOLS",
    Rating: 2.5,
    Reviews: 2794,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 28, 2018",
    "Current Ver": 2.9,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Little Magnet BT Pro",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 251,
    Size: "3.8M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 5, 2018",
    "Current Ver": "4.1.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Bt Notifier -Smartwatch notice",
    Category: "TOOLS",
    Rating: 2.8,
    Reviews: 632,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 23, 2017",
    "Current Ver": 1,
    numInstall: 500000,
    numAndroid: 6,
  },
  {
    App: "BT One Voice mobile access",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 32,
    Size: "437k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 30, 2015",
    "Current Ver": "Version 1.6",
    numInstall: 5000,
    numAndroid: 1,
  },
  {
    App: "BT One Mobile secure access",
    Category: "BUSINESS",
    Rating: 3.4,
    Reviews: 54,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 28, 2016",
    "Current Ver": 3.61,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "BT Communicator",
    Category: "SOCIAL",
    Rating: 3.8,
    Reviews: 32,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "December 16, 2016",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "BT One Voice anywhere",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 80,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "December 23, 2016",
    "Current Ver": "2.54.3",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "BT Find Address for Bluetooth",
    Category: "BUSINESS",
    Rating: 4.8,
    Reviews: 8,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 31, 2017",
    "Current Ver": 2,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "BT Camera",
    Category: "PHOTOGRAPHY",
    Rating: 3.3,
    Reviews: 1307,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 24, 2017",
    "Current Ver": 1.8,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "BT Messenger",
    Category: "COMMUNICATION",
    Rating: 3.9,
    Reviews: 97,
    Size: "598k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 15, 2015",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "BT One Phone Mobile App",
    Category: "COMMUNICATION",
    Rating: 3.5,
    Reviews: 33,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "September 18, 2017",
    "Current Ver": "2.2.6",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BitTorrent®- Torrent Downloads",
    Category: "VIDEO_PLAYERS",
    Rating: 4.5,
    Reviews: 641219,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 26, 2018",
    "Current Ver": "5.2.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "SW-100.tch by Callstel",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 1926,
    Size: "716k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "December 16, 2015",
    "Current Ver": "1.3.20",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "BT App",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 24,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.0.124",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BT MeetMe with Dolby Voice",
    Category: "COMMUNICATION",
    Rating: 3.6,
    Reviews: 437,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 13, 2018",
    "Current Ver": "2.66.5",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "ProGrade BT",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 27, 2018",
    "Current Ver": "1.0.2",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "BT Share It",
    Category: "BUSINESS",
    Rating: 4.7,
    Reviews: 12,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 16, 2018",
    "Current Ver": "3.4.2",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Bluetooth Auto Connect",
    Category: "COMMUNICATION",
    Rating: 3.9,
    Reviews: 20829,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "November 17, 2017",
    "Current Ver": "4.5.4",
    numInstall: 5000000,
    numAndroid: 3,
  },
  {
    App: "Wifi BT Scanner",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 2,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 3, 2016",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Ultimate Control BT",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 14,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 6, 2018",
    "Current Ver": "3.3.2",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "BT Controller",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 4374,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 25, 2018",
    "Current Ver": "3.1.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BT Church",
    Category: "LIFESTYLE",
    Rating: 4.9,
    Reviews: 26,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "June 25, 2018",
    "Current Ver": "3.8.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Mediatek SmartDevice",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 11187,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 17, 2017",
    "Current Ver": "V1.7.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "LG BT Reader Plus",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 2992,
    Size: "585k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 25, 2016",
    "Current Ver": "2.1.11",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "BT Mobile",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.9,
    Reviews: 22,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 4, 2018",
    "Current Ver": 2.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "MagicLight BT",
    Category: "LIFESTYLE",
    Rating: 2.7,
    Reviews: 135,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.2.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Bluetooth Control BT->uC FREE",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 67,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 6, 2016",
    "Current Ver": "1.9.0",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "B.T.",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 2.8,
    Reviews: 636,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 8, 2018",
    "Current Ver": "1.12.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Autool BT-BOX",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 4,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 12, 2018",
    "Current Ver": "1.0.1",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "BT Remote (SPP) for Bluetooth",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 36,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 24, 2016",
    "Current Ver": 1.16,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "BT Satmeter",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 12, 2018",
    "Current Ver": "V2.3",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Battery Notifier Pro BT",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 1363,
    Size: "1.6M",
    Type: "Paid",
    Price: "$2.59",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 7, 2017",
    "Current Ver": "2.5.18",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "BT Panorama",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 34,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 14, 2017",
    "Current Ver": "Varies with device",
    numInstall: 5000,
    numAndroid: null,
  },
  {
    App: "Battery Notifier BT Free",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 21979,
    Size: "982k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 7, 2017",
    "Current Ver": "2.1.15",
    numInstall: 1000000,
    numAndroid: 1,
  },
  {
    App: "BT Dating -Find your match, help cupid, be social",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 158,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 19, 2018",
    "Current Ver": 2.3,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "BT (Usage Interne)",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 3,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "August 17, 2017",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "BT Position Sender - Bluetooth Position Sender",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.2.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Aegis BT",
    Category: "BUSINESS",
    Rating: 4.8,
    Reviews: 16,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "September 6, 2017",
    "Current Ver": "1.0.10",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "BT Master",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "222k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 6, 2016",
    "Current Ver": "NaN",
    numInstall: 100,
    numAndroid: 1,
  },
  {
    App: "OSRAM BT Control",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 2,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 15, 2017",
    "Current Ver": "1.0.5",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Vip视频免费看-BT磁力搜索",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 20,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 8, 2018",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AudioBT: BT audio GPS/SMS/Text",
    Category: "COMMUNICATION",
    Rating: 3.4,
    Reviews: 198,
    Size: "219k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "February 21, 2017",
    "Current Ver": "3.2.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Jabbla BT",
    Category: "TOOLS",
    Rating: 5,
    Reviews: 3,
    Size: "55k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 6, 2014",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BT Speed",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 3,
    Size: "948k",
    Type: "Paid",
    Price: "$4.80",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 21, 2015",
    "Current Ver": "1.0.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "USB BT Wi-Fi Color Terminal Modem",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "7.3M",
    Type: "Paid",
    Price: "$8.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 9, 2018",
    "Current Ver": 5.3,
    numInstall: 5,
    numAndroid: 3,
  },
  {
    App: "SenseView BT Zephyr Sensor",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 37,
    Size: "323k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 15, 2015",
    "Current Ver": "1.1.15205",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Bu the Baby Bunny - Cute pet care game",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 37122,
    Size: "89M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "June 14, 2018",
    "Current Ver": 1.03,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Boston University Alumni",
    Category: "FAMILY",
    Rating: 1.8,
    Reviews: 5,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 2, 2017",
    "Current Ver": 4,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BU Bus Tracker",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 57,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "September 5, 2017",
    "Current Ver": 2.02,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "kick the buddy",
    Category: "GAME",
    Rating: 3.3,
    Reviews: 294,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 19, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "BU Bookstore",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 2,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "March 19, 2018",
    "Current Ver": "3.0.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BU Study",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 7,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 7, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BU Dental GoGoldman",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "September 1, 2017",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Bu Hangi Uygulama ?",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "March 6, 2018",
    "Current Ver": "3.2.6z",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BU Questrom Launch",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 3,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 17, 2015",
    "Current Ver": "1.0.4",
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "sustainability@BU",
    Category: "LIFESTYLE",
    Rating: 4.8,
    Reviews: 10,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 18, 2018",
    "Current Ver": "4.2.7",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BU School of Public Health",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 20, 2018",
    "Current Ver": 1.4,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BU Mobile",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 472,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 6, 2018",
    "Current Ver": "2.4.1",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Barisal University App-BU Face",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 100,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 6, 2018",
    "Current Ver": "3.1.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Pu - Cute giant panda bear, baby pet care game",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 22167,
    Size: "88M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "June 12, 2018",
    "Current Ver": 1.18,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BU Students' Rep. Council",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 38,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 5, 2018",
    "Current Ver": "5.45.0_713",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "On a Bu Pour Vous OBPV",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "February 6, 2018",
    "Current Ver": 3,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BU Calculator",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 69,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 24, 2017",
    "Current Ver": 2.4,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BU Beauty Rooms",
    Category: "BEAUTY",
    Rating: "NaN",
    Reviews: 1,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "February 17, 2017",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Bu Hangi Firma?",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 8,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia;Education",
    "Last Updated": "December 10, 2017",
    "Current Ver": "3.3.6z",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BU Syllabus",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 38,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 21, 2017",
    "Current Ver": "1.0.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Bu Hangi Ünlü?",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 1,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "June 9, 2018",
    "Current Ver": "3.3.7z",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Bu Nedir ?",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 0,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "April 15, 2018",
    "Current Ver": "3.1.6z",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "BU Bison Nation",
    Category: "SPORTS",
    Rating: 3.5,
    Reviews: 4,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "September 21, 2017",
    "Current Ver": "6.0.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Kim Bu Youtuber?",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 11,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "September 9, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BU HANGİ ŞARKI ? - 2018",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 4,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "June 2, 2018",
    "Current Ver": "3.1.7z",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BU Library",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 4,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 22, 2017",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "SkyTest BU/GU Lite",
    Category: "BUSINESS",
    Rating: 2.9,
    Reviews: 28,
    Size: "20M",
    Type: "Paid",
    Price: "$17.99",
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 24, 2017",
    "Current Ver": "2.0.5",
    numInstall: 500,
    numAndroid: 3,
  },
  {
    App: "BU Alsace",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 3,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "October 3, 2017",
    "Current Ver": "3.1.1",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Bu Hangi Oyun ?",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 2,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "March 11, 2018",
    "Current Ver": "3.1.6z",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Catholic La Bu Zo Kam",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 5,
    Reviews: 23,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "March 20, 2016",
    "Current Ver": "0.0.1",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Bu Hangi Youtuber ?",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 31,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "August 31, 2017",
    "Current Ver": "3.2.2dk",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Nedir Bu ?",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 0,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "March 18, 2018",
    "Current Ver": "3.1.6z",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Bu Hangi Film ?",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "August 31, 2017",
    "Current Ver": "3.2.2dk",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Khrifa Hla Bu (Solfa)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 8, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "Kick the Buddy",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1004709,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Bu Hangi Dizi ?",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 14,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "May 4, 2018",
    "Current Ver": "3.1.7z",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Kristian Hla Bu",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.8,
    Reviews: 238,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 25, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "SA HLA BU",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 119,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "September 21, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Bubble Witch 2 Saga",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 2838064,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Büfe BU",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 14,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "October 17, 2015",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BV Mobile Apps",
    Category: "PRODUCTIVITY",
    Rating: 5,
    Reviews: 3,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 5, 2018",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BV",
    Category: "COMMUNICATION",
    Rating: 5,
    Reviews: 3,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 4, 2016",
    "Current Ver": "1,01",
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "Bacterial Vaginosis",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "February 21, 2018",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Bacterial Vaginosis 🇺🇸",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "November 1, 2017",
    "Current Ver": 1.1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Bacterial Vaginosis Symptoms & Treatment",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 18, 2018",
    "Current Ver": 1.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Bacteria Vaginosis",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4,
    Reviews: 4015,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Health & Fitness",
    "Last Updated": "April 27, 2017",
    "Current Ver": 6,
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Hilverda De Boer B.V. App",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 5,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "February 2, 2018",
    "Current Ver": "2.5.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "BV Smart",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 28,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 1, 2015",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BV Forest",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 9, 2018",
    "Current Ver": "2.1.18",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Bacterial Vaginosis Symptoms",
    Category: "MEDICAL",
    Rating: 4.1,
    Reviews: 698,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Medical",
    "Last Updated": "February 3, 2015",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "BV Sridhara Maharaj",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 8,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 3, 2017",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BV Aventure",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 22, 2016",
    "Current Ver": "1.3.6",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Bacterial vaginosis Treatment - Sexual disease",
    Category: "HEALTH_AND_FITNESS",
    Rating: 5,
    Reviews: 2,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 25, 2018",
    "Current Ver": 2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "BV Link",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 10,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 11, 2018",
    "Current Ver": "1.3.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Bacterial Vaginosis Treatment",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 25, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "BV Bombers",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "January 31, 2017",
    "Current Ver": "7.1.5",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Schulman B.V.",
    Category: "SHOPPING",
    Rating: 4,
    Reviews: 6,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "September 14, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BV MAAp",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 9,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "December 4, 2015",
    "Current Ver": "1.1.3",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BV Taxi - Driver",
    Category: "MAPS_AND_NAVIGATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "January 17, 2018",
    "Current Ver": "2.19.20180117",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BV Taxi Sudan",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.5,
    Reviews: 8,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "January 17, 2018",
    "Current Ver": "1.2.20180117",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "van Gennip Textiles BV",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 1,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 28, 2018",
    "Current Ver": "1.1.5",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "bacterial vaginosis",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Medical",
    "Last Updated": "March 26, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "PIO bv App",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "98M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.6.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Meu Cartão BV",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 15057,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.4.0",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "BV Rando",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 22, 2016",
    "Current Ver": "1.2.4",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Kovax Europe B.V.",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 17,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "September 10, 2017",
    "Current Ver": "24.0.11",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "StartPage Private Search",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 10198,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 21, 2017",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "DHV accountancy BV",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 21, 2016",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BV Frankfurt inside",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 3,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 21, 2018",
    "Current Ver": 1.5,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "BV Teknisk App",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 15, 2016",
    "Current Ver": "4.1.2099",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "TomTom GPS Navigation Traffic",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.1,
    Reviews: 132792,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "October 25, 2017",
    "Current Ver": "1.17.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Maps & GPS Navigation — OsmAnd",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 60820,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "OLX Uganda Sell Buy Cellphones",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 4977,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 25, 2018",
    "Current Ver": "11.15.03",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Feel Performer",
    Category: "COMMUNICATION",
    Rating: 2.2,
    Reviews: 62,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 9, 2018",
    "Current Ver": "2.0.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Smashy Road: Arena",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 45558,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.1.9",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "My Budget Book",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 19784,
    Size: "7.3M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 13, 2018",
    "Current Ver": 7.6,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "VictronConnect",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 400,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 5, 2018",
    "Current Ver": 4.8,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "BV Productions",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 25, 2016",
    "Current Ver": "1.0.1",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Allsetra B.V.",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 15,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 5, 2018",
    "Current Ver": "3.1.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "PIO bv Transport App",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "73M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 22, 2018",
    "Current Ver": "1.0.0",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Philips Hue",
    Category: "LIFESTYLE",
    Rating: 3.1,
    Reviews: 10006,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 26, 2018",
    "Current Ver": "3.2.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Evolution: Battle for Utopia",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 246705,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "May 4, 2018",
    "Current Ver": "3.5.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Home Remedies for Bacterial Infections",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "April 19, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "Best Western To Go",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3,
    Reviews: 2719,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Travel & Local",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.14.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BW-Go",
    Category: "GAME",
    Rating: 4.8,
    Reviews: 265,
    Size: "1.3M",
    Type: "Paid",
    Price: "$3.49",
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "June 18, 2015",
    "Current Ver": "4.8.1",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "BW Smart",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 50,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 6, 2017",
    "Current Ver": "v1.2.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Watch Face BW Inter",
    Category: "PERSONALIZATION",
    Rating: 3.1,
    Reviews: 112,
    Size: "8.8M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 26, 2017",
    "Current Ver": "2.1.7",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BW-Go Free",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 547,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "June 18, 2015",
    "Current Ver": "4.8.1",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "BlitzWolf Shutter - BW Shutter",
    Category: "PHOTOGRAPHY",
    Rating: 2.9,
    Reviews: 333,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 22, 2017",
    "Current Ver": "1.8.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Black & White Camera - Lovely BW",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 329,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 13, 2017",
    "Current Ver": "1.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BW-Joseki",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 705,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "July 28, 2015",
    "Current Ver": "1.2.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BW-DGS plugin",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 70,
    Size: "691k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "May 13, 2018",
    "Current Ver": "1.6.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BW App",
    Category: "LIFESTYLE",
    Rating: 2.8,
    Reviews: 48,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 27, 2017",
    "Current Ver": "2.8.216.6-ba",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Learn SAP BW",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 2,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "February 13, 2018",
    "Current Ver": 1.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Next Launcher 3D Theme Stun-BW",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 2839,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 11, 2014",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Standard Chartered Mobile (BW)",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 96,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 5, 2018",
    "Current Ver": 2.9,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BW Mobilbanking für Smartphone und Tablet",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 2048,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 10, 2018",
    "Current Ver": "4.2.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BW COMPANY FINDER",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 48,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 21, 2017",
    "Current Ver": 1.5,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BW Taxi",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3,
    Reviews: 67,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "May 1, 2018",
    "Current Ver": "3.19.34",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "BW-GnuGo",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 64,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "June 2, 2013",
    "Current Ver": "2.0.0",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Beautiful Widgets Pro",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 97890,
    Size: "14M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 24, 2016",
    "Current Ver": "5.7.8",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "BW SmartLife",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 5, 2017",
    "Current Ver": "1.1.8",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Bw Events",
    Category: "EVENTS",
    Rating: 4.4,
    Reviews: 16,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "August 9, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Beautiful Widgets Free",
    Category: "PERSONALIZATION",
    Rating: 3.9,
    Reviews: 25035,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "October 20, 2016",
    "Current Ver": "5.7.6",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Learn SAP BW on HANA",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "February 13, 2018",
    "Current Ver": 1.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Analog BW - Camera filter effect foto film retouch",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 2,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 23, 2018",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BW Ultra",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 3, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BW-IVMS",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 26, 2018",
    "Current Ver": "12.0.18071400",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "HD Widgets",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 58614,
    Size: "26M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 7, 2016",
    "Current Ver": "4.3.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BW Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 4,
    Size: "511k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 31, 2016",
    "Current Ver": 1.4,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Skull Widget BW",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 4,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "February 28, 2018",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BW Map mobile",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.6,
    Reviews: 57,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 31, 2018",
    "Current Ver": 3.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Bell and Wyson Camera BW Pix +",
    Category: "LIFESTYLE",
    Rating: 2,
    Reviews: 8,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "November 14, 2016",
    "Current Ver": "2.0.18.23",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Best Western e-Concierge Hotel",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4,
    Reviews: 41,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 4, 2018",
    "Current Ver": "2.8.1",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "BlackCam Pro - B&W Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 1376,
    Size: "5.5M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 26, 2018",
    "Current Ver": 1.51,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "SAP BW Tutorial",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 11,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 10, 2016",
    "Current Ver": "0.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Kromium BW Theme for NEXT",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 1098,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "October 11, 2014",
    "Current Ver": "1.0.1",
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "IP address BW",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 7,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 20, 2014",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Color Changer Pro [root]",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 69,
    Size: "951k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 12, 2017",
    "Current Ver": 1.11,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Fantasy theme dark bw black building",
    Category: "ART_AND_DESIGN",
    Rating: 4.8,
    Reviews: 41,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "March 20, 2018",
    "Current Ver": "1.0.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Keyboard Theme Gate Flat BW",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 75,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Personalization",
    "Last Updated": "May 26, 2016",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BW Switch",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 1,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "April 16, 2018",
    "Current Ver": 1.25,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Tutorials for SAP BW Offline",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 21, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BL Essentials BW Icon Pack",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 17,
    Size: "963k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 6, 2013",
    "Current Ver": "1.0.1",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Hypocam",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 12572,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 14, 2018",
    "Current Ver": 1.31,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hitman GO",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 84114,
    Size: "23M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone 10+",
    Genres: "Puzzle",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.13.108869",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "BW Fuhlenbrock",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 4,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "September 27, 2017",
    "Current Ver": "4.2.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BW eServices",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 5, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "B&W Photo Filter Editor",
    Category: "PHOTOGRAPHY",
    Rating: 3.9,
    Reviews: 205,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 29, 2017",
    "Current Ver": "1.0.5",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "BW t&t",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 2,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 15, 2016",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EBook For SAP BW ON HANA Learning Free",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 2, 2018",
    "Current Ver": "1.0.1",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "BX Memo",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 131,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 17, 2016",
    "Current Ver": "3.3.1",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Bixby Button Remapper - bxActions Pro / Coffee",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 319,
    Size: "25k",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 28, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 7,
  },
  {
    App: "Bixby Button Remapper - bxActions",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 13064,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 23, 2018",
    "Current Ver": 4.72,
    numInstall: 1000000,
    numAndroid: 7,
  },
  {
    App: "Bitcoin BX Thailand",
    Category: "FINANCE",
    Rating: 3.7,
    Reviews: 120,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "October 23, 2017",
    "Current Ver": 4.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Bx Thailand Alert (Bitcoin)",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 3,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 5, 2018",
    "Current Ver": "1.0.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "bX Hot Articles by Ex Libris",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 42,
    Size: "554k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 9, 2017",
    "Current Ver": 2,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Bitcoin BX Thailand PRO",
    Category: "FINANCE",
    Rating: 1.7,
    Reviews: 21,
    Size: "21M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "October 22, 2017",
    "Current Ver": 5,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Bitcoin Bx (Thailand)",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 101,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.8.4",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Bx-WiFi-GI",
    Category: "VIDEO_PLAYERS",
    Rating: "NaN",
    Reviews: 0,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 15, 2017",
    "Current Ver": "1.3.6",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BX Mobile TMC for SAP B1",
    Category: "BUSINESS",
    Rating: 4.7,
    Reviews: 3,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 20, 2015",
    "Current Ver": "1.0.16",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BX Thailand - Crypto Tracking & Analyse Bitcoin",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 2,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 10, 2018",
    "Current Ver": 1.7,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BxPort - Bitcoin Bx (Thailand)",
    Category: "FINANCE",
    Rating: 5,
    Reviews: 4,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 14, 2018",
    "Current Ver": "1.0.4",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Bx Access 4d",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 29, 2016",
    "Current Ver": "2.2.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "bX Thailand Simple Market Price and Alert",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 8,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 29, 2018",
    "Current Ver": "2.5.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "QR & Barcode Scanner BX PRO",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 4,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 30, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BX Diff - Crypto Coins Checker",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 83,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 16, 2018",
    "Current Ver": "1.0.21",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "bitcoin exchange bx thailand",
    Category: "FINANCE",
    Rating: 2.9,
    Reviews: 19,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 26, 2017",
    "Current Ver": 1.6,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "CSHS BX",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 17, 2018",
    "Current Ver": "1.0.5.170418-cardspl",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Bitcoin & Cryptocurrency - Bx",
    Category: "FINANCE",
    Rating: 4.8,
    Reviews: 11,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "November 28, 2017",
    "Current Ver": "0.1.6",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Benefit Extras Mobile App",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.3,
    Reviews: 3,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 18, 2018",
    "Current Ver": 6,
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Kick Axe Bx",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "9.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 7, 2017",
    "Current Ver": "1.0.1",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Car Driving Simulator Citroen",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 174,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 18, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "LEDSHOWTW",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 5,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 23, 2018",
    "Current Ver": "1.3.3",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "C3-C4-PİCASSO-ELYSEE RACİNG",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 12,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "February 12, 2017",
    "Current Ver": "1,01",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Water Surfer Floating BMX Bicycle Rider Racing",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 551,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 3, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Driving Cars Simulator Citroen",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 3,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "April 5, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "RC Monster Truck - Offroad Driving Simulator",
    Category: "GAME",
    Rating: 4,
    Reviews: 38448,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "June 16, 2018",
    "Current Ver": "1.4.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Tiny Call Confirm",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 22782,
    Size: "351k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "March 25, 2015",
    "Current Ver": "4.2.0",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Casa de Bolsa Bx+ Móvil",
    Category: "FINANCE",
    Rating: 3.4,
    Reviews: 5,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 18, 2017",
    "Current Ver": "1.0.7",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Super Jabber Jump",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 85882,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "November 7, 2017",
    "Current Ver": "6.6.3106",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Commando Adventure Assassin",
    Category: "GAME",
    Rating: 4,
    Reviews: 51067,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "May 29, 2018",
    "Current Ver": 1.18,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Limbo PC Emulator QEMU ARM x86",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 13005,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 21, 2018",
    "Current Ver": "no_update_signal.2_9_1_arm-x86_64-alpha",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Lollipop Launcher Plus",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 131,
    Size: "27k",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 8, 2015",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Crypto Tracker by BitScreener",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 396,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 5, 2018",
    "Current Ver": "3.1.5",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "City Builder 2016: County Mall",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 41693,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 4, 2018",
    "Current Ver": "1.0.23",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fists For Fighting (Fx3)",
    Category: "SPORTS",
    Rating: 3.9,
    Reviews: 138739,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Sports",
    "Last Updated": "July 7, 2018",
    "Current Ver": 1.998,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Train driving simulator",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 91645,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "May 8, 2018",
    "Current Ver": 1.94,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Roulette Advisor LITE",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 41,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casino",
    "Last Updated": "August 21, 2014",
    "Current Ver": 2.2,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "Mini Motor Racing WRT",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 107497,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "February 2, 2016",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "BMX Boy Bike Stunt Rider Game",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 299,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "November 10, 2017",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CoinMarketApp - CryptoCurrency Portfolio, News,ICO",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 20535,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Best Friends Dress Up & Makeup",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 7664,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "September 9, 2015",
    "Current Ver": "1.0.3",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "World of Warriors: Duel",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 25952,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "September 7, 2015",
    "Current Ver": "1.1.2",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Trinomial Factoring Wizard",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 22,
    Size: "82k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 10, 2014",
    "Current Ver": 2.4,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Driving Zone",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 51791,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "June 6, 2018",
    "Current Ver": 1.53,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Bitcoin Ticker Widget",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 25744,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Quadratic Equation Solver with Steps and Graphs",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 513,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 14, 2017",
    "Current Ver": "1.4.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Color by Number – New Coloring Book",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 142308,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Board",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.0.6",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Car Race by Fun Games For Free",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 54221,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "June 15, 2013",
    "Current Ver": 1.2,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Adult Color By Number Book: Number Coloring Pages",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 2231,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 23, 2018",
    "Current Ver": 2.9,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Glitter Color By Number - Glitter Number Coloring",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 1380,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 18, 2018",
    "Current Ver": 1.6,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Sandbox - Color by Number Coloring Pages",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 412744,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Creativity",
    "Last Updated": "July 19, 2018",
    "Current Ver": "0.2.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Sandbox Art-Sandbox Color by Number Coloring Pages",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 12784,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.3.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "One Today by Google",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 2586,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 17, 2015",
    "Current Ver": "1.9.0.110162364",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Art Pixel Coloring. Color by Number.",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 992,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.2.0.200",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Color By Number - Sandbox Pixel Coloring Book",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 24557,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Creativity",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.3.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "PixelDot - Color by Number Sandbox Pixel Art",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 16041,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.3.3.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Slot Machines by IGG",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 267229,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "May 28, 2018",
    "Current Ver": "1.7.4",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "PixPanda - Color by Number Pixel Art Coloring Book",
    Category: "FAMILY",
    Rating: 4.9,
    Reviews: 55723,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 4, 2018",
    "Current Ver": 3.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Sandbox Number Coloring Book Art - Color By Number",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 14356,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Brain Games",
    "Last Updated": "March 9, 2018",
    "Current Ver": 2.5,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Adult Color by Number Book - Paint Mandala Pages",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 997,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 27, 2018",
    "Current Ver": 2.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Photo Editor by Aviary",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 1490722,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 19, 2018",
    "Current Ver": "4.8.4",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "No.Color – Color by Number",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 23474,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Creativity",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.0.7",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "PixBox Coloring - Color by number Sandbox",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 12293,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 6, 2018",
    "Current Ver": "1.2.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "3D Color by Number: Voxel, Unicorn, Pixel Art 3D",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 2017,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 16, 2018",
    "Current Ver": 2.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Pixelmania - Color by number & create pixel art",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 3588,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 25, 2018",
    "Current Ver": 1.18,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Valentines love color by number-Pixel art coloring",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 767,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 23, 2018",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Rized ‼️ Color By Number & Pixel Coloring Book",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 1279,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "June 13, 2018",
    "Current Ver": "1.1.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Pixyfy: coloring by number coloring book",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 22290,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "August 5, 2018",
    "Current Ver": "18.08.05",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Draw Color by Number - Sandbox Pixel Art",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 34279,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Creativity",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.2.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Project Fi by Google",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 7342,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Tattoo Color By Number Draw Book Page Pixel Art",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 309,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 2, 2018",
    "Current Ver": 1.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "SegPlay Mobile Paint by Number",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 1478,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "April 22, 2017",
    "Current Ver": "4.0.15",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Paint By Number",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 807,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 1, 2018",
    "Current Ver": "1.4.0",
    numInstall: 500000,
    numAndroid: 3,
  },
  {
    App: "Color by Disney",
    Category: "FAMILY",
    Rating: 2.7,
    Reviews: 5706,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 13, 2017",
    "Current Ver": 1.7,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Bingo by IGG: Top Bingo+Slots!",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 183343,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "May 28, 2018",
    "Current Ver": "1.5.1",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Painting By Numbers",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 213,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "June 8, 2018",
    "Current Ver": "1.2.100",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "3D Color by Number with Voxels",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 5481,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 7, 2018",
    "Current Ver": 1.3,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Butterfly Pixel Art - coloring by number",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 769,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 4, 2018",
    "Current Ver": 1.06,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Best Hairstyles step by step",
    Category: "BEAUTY",
    Rating: 4.5,
    Reviews: 45452,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "July 19, 2018",
    "Current Ver": 1.25,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Halloween Sandbox Number Coloring- Color By Number",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 289,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 17, 2018",
    "Current Ver": 1.2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Fiesta by Tango - Find, Meet and Make New Friends",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 112223,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 5, 2018",
    "Current Ver": "5.68.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Poly Art: Paint by Sticker, Color by Number Puzzle",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 2100,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Brain Games",
    "Last Updated": "July 28, 2018",
    "Current Ver": 2.3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Pixel art pro-Sand box,paint by number,number draw",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 2442,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Brain Games",
    "Last Updated": "July 6, 2018",
    "Current Ver": "2.5.111",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Color by Number: Pixel Art",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 12034,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 26, 2018",
    "Current Ver": 4.8,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "UNICORN - Color By Number & Pixel Art Coloring",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 8264,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design;Creativity",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.0.9",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "FunnyPixels - Color by number Sandbox",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 1977,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 21, 2018",
    "Current Ver": "1.0.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Color By Numbers - Art Game for Kids and Adults",
    Category: "FAMILY",
    Rating: 3.1,
    Reviews: 305,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Brain Games",
    "Last Updated": "July 7, 2016",
    "Current Ver": 3,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Elmo Calls by Sesame Street",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 6903,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "January 31, 2018",
    "Current Ver": "2.0.7",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Voxel - 3D Color by Number & Pixel Coloring Book",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 62561,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.4.11",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "No.Diamond – Colors by Number",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 9016,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Creativity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "0.9.34",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BZ Reminder",
    Category: "BUSINESS",
    Rating: 4.7,
    Reviews: 41625,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "December 21, 2017",
    "Current Ver": "2.3.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "B.Z. Live-Ticker",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 114,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 25, 2018",
    "Current Ver": 1.6,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "420 BZ Budeze Delivery",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 2,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Medical",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Weather BZ",
    Category: "WEATHER",
    Rating: 4.4,
    Reviews: 8433,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "June 6, 2018",
    "Current Ver": "5.0.1 build 1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BZ Reminder PRO",
    Category: "BUSINESS",
    Rating: 4.8,
    Reviews: 726,
    Size: "5.4M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "December 20, 2017",
    "Current Ver": "2.3.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BZ Bingo",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 3, 2018",
    "Current Ver": 1.3,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Evasion.bz",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 8,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 14, 2017",
    "Current Ver": "0.0.9",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BZ Berner Zeitung E-Paper",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 4,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 30, 2018",
    "Current Ver": "5.1.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BZ-Smart",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 828,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "October 10, 2017",
    "Current Ver": 1.98,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "BZ Zombie VR",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 12,
    Size: "98M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "February 7, 2018",
    "Current Ver": 1.4,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BZ Conferencing",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 7,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 27, 2018",
    "Current Ver": "3.8.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "GITZ.bz",
    Category: "SHOPPING",
    Rating: 4,
    Reviews: 4,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 4, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Berner Zeitung",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.4,
    Reviews: 736,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "August 3, 2018",
    "Current Ver": "7.5.9.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "BZ Fingers",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 15,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 5, 2017",
    "Current Ver": 1.3,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Dragon B.Z Wallpapers",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 6, 2018",
    "Current Ver": 2.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "bz Basellandschaftliche News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 2.8,
    Reviews: 33,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.4.0",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "BZ Langenthaler Tagblatt E-Paper",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 30, 2018",
    "Current Ver": "5.1.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "24/7 BZ Reis",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.1,
    Reviews: 421,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "March 9, 2018",
    "Current Ver": "4.4.15",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BZ Delivery",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 1,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "January 15, 2018",
    "Current Ver": "1.1.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Badische Zeitung",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.9,
    Reviews: 262,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 26, 2018",
    "Current Ver": 5.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Dragon BZ Wallpapers HD",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 5,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 4, 2018",
    "Current Ver": 1.11,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "bz Baselland E-Paper",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.2,
    Reviews: 69,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "August 24, 2017",
    "Current Ver": "5.1.4",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "BZWBK24 mobile",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 64983,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 18, 2018",
    "Current Ver": "5.0.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BZ Dealer",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 5,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 31, 2017",
    "Current Ver": "1.0.3",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "BZ Vesper-App",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 60,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2015",
    "Current Ver": "1.0.2",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "BZ-Digital",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 4,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "March 5, 2018",
    "Current Ver": "2.4.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Dragon BZ Super Wallpapers",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 12,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 16, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BZ Berner Oberländer",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 64,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "August 3, 2018",
    "Current Ver": "7.5.9.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "bz Basel E-Paper",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 72,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "August 24, 2017",
    "Current Ver": "5.1.4",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Südtirol2Go",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.3,
    Reviews: 555,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "December 20, 2017",
    "Current Ver": "2.1.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "TFO BZ Lessons",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 75,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 28, 2017",
    "Current Ver": "2.1.1",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "BZ Langenthaler Tagblatt",
    Category: "VIDEO_PLAYERS",
    Rating: "NaN",
    Reviews: 22,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 3, 2018",
    "Current Ver": "7.5.9.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "City Driving Jeep Mania: Parking Passion 2018",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 36,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 14, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Sniper Gun Shot 3D: Impossible Missions",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 20,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "May 4, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "ePN Cashback AliExpress",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 19212,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "0.2.9.17",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Elite Commando Shooting War",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 14,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 29, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Restaurantführer Südbaden",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 46,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "January 11, 2017",
    "Current Ver": "2.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "bz Basel News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 2.2,
    Reviews: 23,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.4.0",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Contractor City Construction - Heavy Logistics",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 31,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 12, 2018",
    "Current Ver": 1.01,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Park Limousine: Realistic Limo Parking Simulator",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 4,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 20, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Animal Hunting: Sniper Shooting",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 0,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 6, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "WISE- MOBILE PORTAL",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 3,
    Size: "1.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2015",
    "Current Ver": "1.0.0.4",
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Inwestor mobile",
    Category: "FINANCE",
    Rating: 3.2,
    Reviews: 124,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "January 3, 2018",
    "Current Ver": "1.2.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BZ Straußenführer",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 291,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "March 17, 2016",
    "Current Ver": "1.2.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Zoosk Dating App: Meet Singles",
    Category: "DATING",
    Rating: 4,
    Reviews: 516917,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Putzmeister Experts",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 21,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 8, 2018",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Filmi Gaane",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 572,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 17, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Bubble",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 31621,
    Size: "208k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 10, 2011",
    "Current Ver": "2.0.1",
    numInstall: 5000000,
    numAndroid: 1,
  },
  {
    App: "iBiznes24 mobile",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 38,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 30, 2018",
    "Current Ver": "1.8.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "CA Service Management",
    Category: "BUSINESS",
    Rating: 3.4,
    Reviews: 91,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 20, 2018",
    "Current Ver": "3.1.13",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "CA Mobile Authenticator",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 9,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "December 15, 2016",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CA Latam Partners",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.1.2",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CA Mobile OTP",
    Category: "TOOLS",
    Rating: 3.3,
    Reviews: 688,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 5, 2017",
    "Current Ver": "2.3.5",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "CA Lottery Official App",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 7000,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.0.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CA Technologies",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "98M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "October 20, 2017",
    "Current Ver": 1.093,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CA Case Management",
    Category: "BUSINESS",
    Rating: 2.4,
    Reviews: 16,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 4, 2016",
    "Current Ver": "1.0.1",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CA UIM Mobile",
    Category: "BUSINESS",
    Rating: 3.2,
    Reviews: 54,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 29, 2016",
    "Current Ver": "8.4.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CA Clarity Mobile Time Manager",
    Category: "BUSINESS",
    Rating: 3.1,
    Reviews: 104,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 14, 2015",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "CA Auth ID",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 39,
    Size: "375k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Tools",
    "Last Updated": "October 17, 2014",
    "Current Ver": "2.2.1",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "Patchcord.ca Inc. App Launcher",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "December 23, 2016",
    "Current Ver": 1.21,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CA Speakers Free",
    Category: "LIFESTYLE",
    Rating: 4.8,
    Reviews: 74,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "September 30, 2015",
    "Current Ver": 1.6,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "CA World '17",
    Category: "PRODUCTIVITY",
    Rating: 3.7,
    Reviews: 7,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Productivity",
    "Last Updated": "June 10, 2018",
    "Current Ver": "7.17.2.0",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "CA DMV",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 5463,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 25, 2017",
    "Current Ver": 4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Save.ca",
    Category: "SHOPPING",
    Rating: 3.7,
    Reviews: 2094,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 2, 2018",
    "Current Ver": "4.8.18.12",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "California Cop Assist CA Cop",
    Category: "PRODUCTIVITY",
    Rating: 3,
    Reviews: 5,
    Size: "7.0M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "February 11, 2014",
    "Current Ver": 1.3,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "CA Laws 2018 (California Laws and Codes)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.9,
    Reviews: 56,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "March 24, 2018",
    "Current Ver": 1.17,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "California Cameras - Traffic",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4,
    Reviews: 305,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 20, 2018",
    "Current Ver": "6.3.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CA Speakers",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 12,
    Size: "1.2M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "March 25, 2014",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "Register.ca Mobile",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 19, 2016",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "CB Radio Chat - for friends!",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 17998,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "March 27, 2018",
    "Current Ver": "2.6.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Truck Chat & CB for Truckers",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 2.7,
    Reviews: 89,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Maps & Navigation",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.0.10.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CB Frequencies FREE!",
    Category: "TOOLS",
    Rating: 3.1,
    Reviews: 364,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 2, 2018",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CB On Mobile",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 901,
    Size: "323k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "April 26, 2017",
    "Current Ver": "1.0.5",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Cricbuzz - Live Cricket Scores & News",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 838738,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "CB Frequencies",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 5,
    Size: "1.4M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 24, 2015",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Virtual Walkie Talkie",
    Category: "COMMUNICATION",
    Rating: 3.8,
    Reviews: 21785,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 13, 2015",
    "Current Ver": 1.41,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "CB Outdoors",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 5,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 30, 2017",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Viking CB Radios",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 6,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 24, 2017",
    "Current Ver": "1.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Frequencies Free",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 382,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 4, 2018",
    "Current Ver": 1.9,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CB-Mobile Banking",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 96,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 22, 2018",
    "Current Ver": "4.17.38",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CBRadioTab",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 127,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 1, 2017",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "CB SMART LIFE",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 30,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 3, 2018",
    "Current Ver": "2.4.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CB Bank Mobile Banking",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 1308,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 8, 2015",
    "Current Ver": 13,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "CB Martial Arts",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "May 15, 2018",
    "Current Ver": "1.1.7",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "C.B. Shop",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 19,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "May 9, 2017",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CB Underground",
    Category: "LIFESTYLE",
    Rating: 3.3,
    Reviews: 3,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 15, 2015",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 3,
  },
  {
    App: "CB Background - Free HD Wallpaper Images",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 4538,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 24, 2018",
    "Current Ver": "3.1.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CB NFC Pendant",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "913k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "October 4, 2017",
    "Current Ver": "1.0.2",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "WRLP CB Repeater",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 14,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 21, 2018",
    "Current Ver": "1.1.11",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "CB Fit",
    Category: "HEALTH_AND_FITNESS",
    Rating: 5,
    Reviews: 1,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "4.2.2",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Minwa HA ( C.B )",
    Category: "HOUSE_AND_HOME",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "September 15, 2017",
    "Current Ver": "1.0.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Channel 19",
    Category: "COMMUNICATION",
    Rating: 3.7,
    Reviews: 916,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Communication",
    "Last Updated": "July 13, 2018",
    "Current Ver": "2.2.6",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Citizens Bank - CB Mobile",
    Category: "FINANCE",
    Rating: 4.8,
    Reviews: 6,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.19.62",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CB Mobile Access",
    Category: "FINANCE",
    Rating: 1.5,
    Reviews: 57,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 26, 2018",
    "Current Ver": "4.3.6",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CB VIDEO VISION",
    Category: "PHOTOGRAPHY",
    Rating: 5,
    Reviews: 13,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "September 12, 2017",
    "Current Ver": "0.0.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CB Hair Png - New Hair Png For CB Editing",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 26,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 29, 2018",
    "Current Ver": 2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CB STARS",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 30, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 1,
  },
  {
    App: "CB Mobile",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 3,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 26, 2018",
    "Current Ver": 10,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "C B Patel Health Club",
    Category: "HEALTH_AND_FITNESS",
    Rating: 5,
    Reviews: 5,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 2, 2018",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CB Trader",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 11,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 11, 2018",
    "Current Ver": "1.6.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CB TV",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "September 13, 2016",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Football-CB GO Clock Theme",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 26,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 3, 2017",
    "Current Ver": "1.0.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CB SmartCAR Monitor",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "514k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 20, 2017",
    "Current Ver": 4,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CB News",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 7,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 10, 2016",
    "Current Ver": "1.2.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CB Pay",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 198,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 9, 2018",
    "Current Ver": "1.8.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CB Mobile GA",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "November 21, 2017",
    "Current Ver": "1.9.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CB Register",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 1,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 27, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Cádiz CB Gades",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 5, 2018",
    "Current Ver": "opciÃ³n de cerrar",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CB Land",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 13, 2018",
    "Current Ver": "6.3.5",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Cb browser",
    Category: "COMMUNICATION",
    Rating: 5,
    Reviews: 5,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 2, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CB Edits PNG & CB Backgrounds",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 17,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 20, 2018",
    "Current Ver": "1.0.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "CB Mobile Biz",
    Category: "FINANCE",
    Rating: 1,
    Reviews: 3,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 22, 2016",
    "Current Ver": "4.4.1255",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Antenna Tool Premium",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 14,
    Size: "2.9M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 26, 2017",
    "Current Ver": 2.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Antenna Tool",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 522,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 26, 2017",
    "Current Ver": "2.2 Free",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "CB Heroes",
    Category: "SOCIAL",
    Rating: 5,
    Reviews: 5,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.2.4",
    numInstall: 5,
    numAndroid: 5,
  },
  {
    App: "Frequencies",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 11,
    Size: "3.1M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 4, 2018",
    "Current Ver": 1.9,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Creative Destruction",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 201426,
    Size: "80M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.0.6",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "CD Library",
    Category: "PRODUCTIVITY",
    Rating: 3.9,
    Reviews: 44,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "February 18, 2017",
    "Current Ver": "5.7.2",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Sonic CD Classic",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 26138,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "February 14, 2018",
    "Current Ver": "1.0.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ARK: Survival Evolved",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 51523,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.0.90",
    numInstall: 500000,
    numAndroid: 7,
  },
  {
    App: "APagri CD",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 5,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10,
    numAndroid: null,
  },
  {
    App: "Design innovation CD Cassette",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 5,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "February 6, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "DIY Crafts Cds",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 209,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 24, 2017",
    "Current Ver": 3,
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "CD Events",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 27, 2015",
    "Current Ver": "0.9.0",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "PRIMATURE.CD",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 6,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "October 30, 2017",
    "Current Ver": "6.3.7.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CD Roma's",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 4, 2015",
    "Current Ver": "2.00.0.3",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CD Ready",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 52,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 2, 2017",
    "Current Ver": "6.3.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "INTERKINOIS.CD",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 1,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 9, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "CD Live - Club del Deportista",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 8,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 12, 2018",
    "Current Ver": 4.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Bootable Methods(USB-CD-DVD)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.4,
    Reviews: 37,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 31, 2018",
    "Current Ver": 1.5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Creative CD Letter Holder",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "November 15, 2017",
    "Current Ver": 7.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CD CHOICE TUBE",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 10,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 23, 2017",
    "Current Ver": "0.0.4",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "My Movies Pro - Movie & TV Collection Library",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 6477,
    Size: "20M",
    Type: "Paid",
    Price: "$7.99",
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 16, 2018",
    "Current Ver": "2.26 Build 17",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CD View Lite",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 2,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 2, 2018",
    "Current Ver": "1.0.180202",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CD - Teach me ABC English L1",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 18, 2017",
    "Current Ver": "1.0.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Best Design CD Ideas",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "April 18, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CD Carpe Diem App",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 17,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 18, 2018",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Yazdani Cd Center EllahAbad Official App",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 8,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 12, 2018",
    "Current Ver": 2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CD JUANITO",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 6,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "October 26, 2017",
    "Current Ver": 6,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CD Music",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "March 30, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DIY cd rom ideas",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 5,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "October 17, 2016",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Easy DIY CD Craft Ideas",
    Category: "ART_AND_DESIGN",
    Rating: "NaN",
    Reviews: 7,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "May 30, 2018",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Disc Label Print",
    Category: "TOOLS",
    Rating: 3,
    Reviews: 262,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 20, 2016",
    "Current Ver": "1.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Kiosque CD",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 18, 2018",
    "Current Ver": "4.6.2201",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "CD-Zing",
    Category: "BUSINESS",
    Rating: 3.8,
    Reviews: 70,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 26, 2016",
    "Current Ver": "6.2.7",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Nero AirBurn",
    Category: "VIDEO_PLAYERS",
    Rating: 4.2,
    Reviews: 1008,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "June 26, 2015",
    "Current Ver": "1.0.9",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CD COMET",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.3,
    Reviews: 12,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 4, 2018",
    "Current Ver": 4,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DIY Recycled CD Wall Art",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 3,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 14, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "CD View",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 6, 2018",
    "Current Ver": "1.0.180206",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "US 115th CD",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "November 3, 2017",
    "Current Ver": 106,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Билеты ПДД CD 2019 PRO",
    Category: "AUTO_AND_VEHICLES",
    Rating: "NaN",
    Reviews: 21,
    Size: "16M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 27, 2018",
    "Current Ver": 1.49,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "STADE.CD",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 9, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "OBJECTIFINFOS.CD",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 2,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 23, 2018",
    "Current Ver": 1.1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "DIY CD Craft Ideas",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 5,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 14, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "РееI Smart Remote MP3 CD Player",
    Category: "TOOLS",
    Rating: 3.2,
    Reviews: 27,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 22, 2018",
    "Current Ver": 1.2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "CD Padel Mora",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 1,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 14, 2018",
    "Current Ver": 7.3,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Diligan CD VR",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 21, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CD Supply",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Business",
    "Last Updated": "May 28, 2018",
    "Current Ver": "2.3.2",
    numInstall: 5,
    numAndroid: 5,
  },
  {
    App: "Music Collector Inventory Organizer UPC Discogs",
    Category: "LIFESTYLE",
    Rating: 3.5,
    Reviews: 155,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "October 13, 2017",
    "Current Ver": 3.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CE on the go",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 79,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 15, 2018",
    "Current Ver": "1.283.0037",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "CE Map - Interactive Conan Exiles Map",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.5,
    Reviews: 62,
    Size: "1.6M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "June 30, 2018",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CE Broker",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 190,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 22, 2017",
    "Current Ver": "2.2.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CE Smart",
    Category: "TOOLS",
    Rating: 5,
    Reviews: 3,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 28, 2018",
    "Current Ver": "2.2.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "PAC-MAN CE DX",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1692,
    Size: "36M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "April 23, 2018",
    "Current Ver": "1.1.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CEHQ - CE Credits for Nurses",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 12,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 25, 2018",
    "Current Ver": "3.0.18",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Theatre of the Absurd CE(Full)",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 1143,
    Size: "15M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone 10+",
    Genres: "Casual",
    "Last Updated": "May 21, 2013",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "CE SmartApp.com",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 16, 2018",
    "Current Ver": "102.0.875",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "OE TRACKER CE Attendance App",
    Category: "MEDICAL",
    Rating: 3.4,
    Reviews: 16,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 20, 2018",
    "Current Ver": "1.3.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Professor Online SEDUC-CE",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 188,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 6, 2018",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "ABAI CE Scanner",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 23, 2018",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "C-E Federal Credit Union",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 23, 2018",
    "Current Ver": "3.0.6",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "TI-84 CE Graphing Calculator Manual TI 84",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 1,
    Size: "27M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 28, 2018",
    "Current Ver": "1.5.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ultra CE calculator",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 28,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 17, 2018",
    "Current Ver": 1.52,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Shiver: Moonlit Grove CE",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 3433,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Casual",
    "Last Updated": "March 14, 2016",
    "Current Ver": "1.1.0",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Beast of Lycan Isle CE",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 2683,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Casual",
    "Last Updated": "January 23, 2014",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "QUI EST CE ?",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 7,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "October 11, 2015",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Volvo CE Insider",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 45,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 16, 2018",
    "Current Ver": "1.15.5",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Grim Tales: The Wishes CE",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 4923,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Adventure",
    "Last Updated": "August 26, 2015",
    "Current Ver": "1.0.0",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "AC CE BJT Actorial",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "1.4M",
    Type: "Paid",
    Price: "$2.00",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 27, 2015",
    "Current Ver": 2.4,
    numInstall: 50,
    numAndroid: 1,
  },
  {
    App: "MCQ CE IT",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 22,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 7, 2017",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Placement Tips for BE (CE/IT)",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 7,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 24, 2016",
    "Current Ver": 1.4,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "NetApp CE",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 27, 2018",
    "Current Ver": "v6.6.0",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "Depths of Betrayal CE (Full)",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 363,
    Size: "14M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone 10+",
    Genres: "Casual",
    "Last Updated": "August 19, 2013",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Merck CE",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 2,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 13, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CE-STRONG",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 17, 2016",
    "Current Ver": "1.0.4",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Magana Jari ce Littafi Na Uku : Part 3 of 3",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 65,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 19, 2017",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "CCleaner",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 885187,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 19, 2018",
    "Current Ver": "4.7.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Qu'est ce qui est jaune et qui attend ?",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 10,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 13, 2017",
    "Current Ver": "1.1 (j'sais pas)",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CE-SETRAM l’Appli",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "December 5, 2017",
    "Current Ver": "1.1.8",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CE KISIO",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 1,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "February 5, 2018",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Terminal Emulator for Android",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 113951,
    Size: "551k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 15, 2015",
    "Current Ver": "1.0.70",
    numInstall: 10000000,
    numAndroid: 1,
  },
  {
    App: "Ceasa CE",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 13, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CE Genius Nurses Edition",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.1M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 1, 2018",
    "Current Ver": 1.5,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "CE HPJM 69",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 2,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "November 9, 2017",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CE SODEXO PASS FRANCE",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 6, 2018",
    "Current Ver": 2.3,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CE AH VLJ",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "November 9, 2017",
    "Current Ver": 1.4,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Pregnancy Tracker & Countdown to Baby Due Date",
    Category: "PARENTING",
    Rating: 4.7,
    Reviews: 658087,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "May 24, 2018",
    "Current Ver": "3.15.1",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "ACCEPT CE MARKING",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 28, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CE AR LOG",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.0.1",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "CE Airbus",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "April 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100,
    numAndroid: null,
  },
  {
    App: "Führerschein Klasse CE, LKW 2018",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 57,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 9, 2018",
    "Current Ver": "4.2.0",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "CE Intelligence",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "November 15, 2016",
    "Current Ver": 1.1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "CrossFire: Legends",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 144040,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.0.9.10",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "CF.lumen",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 4901,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 9, 2017",
    "Current Ver": 3.7,
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "CF-Bench Pro",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 159,
    Size: "29k",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 23, 2011",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 1,
  },
  {
    App: "CF SHOP!",
    Category: "LIFESTYLE",
    Rating: 2.8,
    Reviews: 88,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 30, 2018",
    "Current Ver": "1.8.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CF Life",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 4,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 27, 2018",
    "Current Ver": "3.8.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Cheapflights – Flight Search",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 47777,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "CF-Bench",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 2132,
    Size: "103k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 3, 2013",
    "Current Ver": 1.3,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "CF Appreciation",
    Category: "LIFESTYLE",
    Rating: 2,
    Reviews: 11,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 12, 2018",
    "Current Ver": "2.4.78-s",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Unity CF",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 5,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "April 12, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Next Launcher 3D Bold-CF Theme",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 175,
    Size: "5.5M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 11, 2014",
    "Current Ver": 1.042,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Overcomers CF - GA",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 7,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 20, 2017",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Themes DAF CF 85 Trucks",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 2,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "June 9, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "CF Chat: Connecting Friends",
    Category: "COMMUNICATION",
    Rating: 3.4,
    Reviews: 5,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "April 27, 2016",
    "Current Ver": 1.4,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "CF Invest",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 11,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 2, 2018",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Team CF",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 7, 2018",
    "Current Ver": "3.9.9.2",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "iOBD2-CF",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 5,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 26, 2016",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "CF PD",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 4,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 28, 2018",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Themes DAF CF Trucks",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 2,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "June 9, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "CF Calculator",
    Category: "LIFESTYLE",
    Rating: 3.3,
    Reviews: 25,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 10, 2015",
    "Current Ver": "1.0.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CF Climb",
    Category: "LIFESTYLE",
    Rating: 1.5,
    Reviews: 2,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 7, 2018",
    "Current Ver": "3.9.9.2",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Squeezy CF",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.4M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 26, 2017",
    "Current Ver": "1.2.11",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Wallpapers DAF CF Trucks",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "June 13, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Wallpapers DAF CF 85 Trucks",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "April 29, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CF",
    Category: "FINANCE",
    Rating: 5,
    Reviews: 2,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 30, 2016",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Wallpapers Truck DAF CF",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 19,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 27, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "CF cal",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 123,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 9, 2016",
    "Current Ver": "1.0.6",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CF GeneE",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 16,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 31, 2018",
    "Current Ver": "5.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Themes DAF CF 85",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 3,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "May 13, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "CF SPOT",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "4.2.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CF Talenti",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 4,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "4.2.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Villarreal CF Wallpapers 4 Fans",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 2,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 22, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Thrive CF",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.2,
    Reviews: 6,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "January 5, 2018",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Special Forces Group 2",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 1432809,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "July 29, 2018",
    "Current Ver": 3.3,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Valencia CF Wallpapers 4 Fans",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 4,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 22, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Cacique CF",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 19,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "October 10, 2016",
    "Current Ver": "01e",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CF Townsville",
    Category: "HEALTH_AND_FITNESS",
    Rating: 5,
    Reviews: 4,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "4.2.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CF Church",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Education",
    "Last Updated": "June 26, 2018",
    "Current Ver": "3.8.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CF Etowah",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "4.2.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Cystic Fibrosis Symptoms, Doctors & Treatments",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.7,
    Reviews: 6,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "April 24, 2018",
    "Current Ver": "1.0.7",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "Málaga CF Wallpapers 4 Fans",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 2,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 22, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Cluster CF",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 10,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 15, 2018",
    "Current Ver": 4.11,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CF Themis",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 12, 2018",
    "Current Ver": "3.1.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Imperium CF",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 9,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 22, 2017",
    "Current Ver": "01e",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Azulones Getafe CF Fans",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 4,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Sports",
    "Last Updated": "March 25, 2017",
    "Current Ver": "2.3.11",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "CF Riga",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 12,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "4.2.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Casa CF",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.7,
    Reviews: 12,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 12, 2018",
    "Current Ver": "3.1.2",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CampGladiator",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.5,
    Reviews: 293,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.4.43",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "CG Creative Sets: 2D/3D Artist",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 117,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 22, 2016",
    "Current Ver": 3.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Motocross Motorbike Simulator Offroad",
    Category: "GAME",
    Rating: 3.6,
    Reviews: 51366,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "June 14, 2017",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "CG Daily News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 65,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "April 29, 2018",
    "Current Ver": 8.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CG - Calendars Add-On",
    Category: "PRODUCTIVITY",
    Rating: 3.6,
    Reviews: 49,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Productivity",
    "Last Updated": "July 29, 2015",
    "Current Ver": "1.0.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "CG Fit Scale",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.6,
    Reviews: 13,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "October 13, 2015",
    "Current Ver": "1.1.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "All Info about Cg",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 15,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Education",
    "Last Updated": "November 10, 2017",
    "Current Ver": 7.4,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "cg guruji",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 170,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 14, 2017",
    "Current Ver": 7.2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "CG Yojna & Jansampark",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 54,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Education",
    "Last Updated": "September 12, 2017",
    "Current Ver": 7.2,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Offline Jízdní řády CG Transit",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.6,
    Reviews: 7314,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "September 7, 2017",
    "Current Ver": "3.1.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CG Prints",
    Category: "PHOTOGRAPHY",
    Rating: 5,
    Reviews: 1,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "January 24, 2017",
    "Current Ver": "1.0.5",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CG Job Alerts",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 116,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 11, 2017",
    "Current Ver": 7.2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "CG - Conference Call Add-On",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 6,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 2, 2018",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Somos CG",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 2,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 26, 2018",
    "Current Ver": "1.2.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CG Samanya Gyan",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 145,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Education",
    "Last Updated": "September 12, 2017",
    "Current Ver": 7.2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "CG Smart",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 2,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 12, 2016",
    "Current Ver": 1.4,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CG Freelancer",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.7,
    Reviews: 10,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 30, 2014",
    "Current Ver": "2.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CG Wallpapers",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 11,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "June 19, 2018",
    "Current Ver": 12.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Best CG Backgrounds",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 8,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 20, 2018",
    "Current Ver": 8,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CG Districts",
    Category: "SOCIAL",
    Rating: 3.8,
    Reviews: 14,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "May 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "Amazing CG Backgrounds",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 34,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 17, 2018",
    "Current Ver": 9,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CG BILASPUR CARNIVAL",
    Category: "EVENTS",
    Rating: 3.8,
    Reviews: 59,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "April 11, 2018",
    "Current Ver": 1.5,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Chat Anónimo Gratis Español CG",
    Category: "DATING",
    Rating: 3.5,
    Reviews: 69,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "July 10, 2017",
    "Current Ver": "1.0.2",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "CG Shikshak Mitan",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 295,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 5, 2018",
    "Current Ver": 1.1,
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "CG 3D Model Viewer: view 3D models interactively",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.0.4.91",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CG Wizard",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 6,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.6d",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "CG FM",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 2,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 31, 2018",
    "Current Ver": "1.0.9",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "ASCP® CG Exam Flashcards 2018",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 13, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Best CG views",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 4,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 24, 2015",
    "Current Ver": 5.1,
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "Bhunaksha CG",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 67,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 7, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "My CG",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Productivity",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10,
    numAndroid: null,
  },
  {
    App: "Best CG Photography",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Unrated",
    Genres: "Entertainment",
    "Last Updated": "June 24, 2015",
    "Current Ver": 5.2,
    numInstall: 500,
    numAndroid: 3,
  },
  {
    App: "BF CG View Wallpapers",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 13,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 19, 2015",
    "Current Ver": 3,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "CG Sanyukt Bharti Pariksha 2018",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 14,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Education",
    "Last Updated": "January 10, 2018",
    "Current Ver": 7.4,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Betting Tips / Sports Tips by CG Tipster",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 315,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 18, 2018",
    "Current Ver": 6.95,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CG Shikshak",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 211,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 5, 2016",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CG Vidhansabha Chunav 2018",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "April 12, 2018",
    "Current Ver": 8.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "gps tracker cg",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 27, 2017",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CG Backgrounds",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 8,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 19, 2018",
    "Current Ver": 8.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CG - Chemistry free",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 7,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 25, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CG Jobs",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 8,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "music (CG)",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 24, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CG Patwari Exam",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 28,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Education",
    "Last Updated": "October 23, 2017",
    "Current Ver": 7.2,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Naidunia: MP News & CG News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 2746,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "April 9, 2018",
    "Current Ver": 3.2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "BF CG Abstract Pictures",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 6,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 19, 2015",
    "Current Ver": 2.7,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Bhuiyan Land Records Chhattisgarh (CG)",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 12,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "February 3, 2018",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "CG JOKES - Copy & Share",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 31,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 3, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ultimate Public Campgrounds (Over 37,100 in US&CA)",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.7,
    Reviews: 213,
    Size: "6.1M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 5, 2018",
    "Current Ver": "1.8.8.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Chrome Beta",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 228755,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 19, 2018",
    "Current Ver": "68.0.3440.70",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "20 minutes (CH)",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.7,
    Reviews: 4379,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "OurHome – chores, rewards, groceries and calendar",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 3146,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle;Education",
    "Last Updated": "January 31, 2018",
    "Current Ver": "3.13.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Weather Data CH",
    Category: "WEATHER",
    Rating: "NaN",
    Reviews: 15,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 9, 2016",
    "Current Ver": "Varies with device",
    numInstall: 500,
    numAndroid: null,
  },
  {
    App: "Dots puzzle",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 179,
    Size: "14M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 18, 2018",
    "Current Ver": "NaN",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "CH info",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.9,
    Reviews: 45,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "February 20, 2018",
    "Current Ver": "6.0.0.12",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Dive-Store.ch",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "6.3M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 25, 2018",
    "Current Ver": "2.0.4",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "FAV KWGT",
    Category: "PERSONALIZATION",
    Rating: 4.9,
    Reviews: 88,
    Size: "66M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 26, 2018",
    "Current Ver": 8,
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Flo's CH Boss Timer",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 163,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "March 27, 2017",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "20 Minuten (CH)",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.5,
    Reviews: 14153,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Reading Race 1b: sh, ch words",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "76M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "January 8, 2016",
    "Current Ver": 1.01,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Calvary.ch App",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 10,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "June 25, 2018",
    "Current Ver": "3.8.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "autolina.ch has over 120'000 cars on offer.",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.2,
    Reviews: 25,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "August 2, 2017",
    "Current Ver": 1.02,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Speech Therapy: CH",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "14M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 8, 2016",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "Digi-TV.ch",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 62,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "May 3, 2018",
    "Current Ver": "7.1.29",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "retteMi.ch",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 31,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000,
    numAndroid: null,
  },
  {
    App: "Chrome Canary (Unstable)",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 21866,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 4, 2018",
    "Current Ver": "70.0.3512.0",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "ch-mm Dict",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.4M",
    Type: "Paid",
    Price: "$1.96",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 18, 2014",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "boattheory.ch Full 2018",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 54,
    Size: "50M",
    Type: "Paid",
    Price: "$19.40",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 18, 2017",
    "Current Ver": "3.1.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "waut.ch!",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 10,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "June 30, 2018",
    "Current Ver": "fcbd82b2-dd5b-41d2-af62-432271c42921",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "search.ch",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 11514,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "March 29, 2018",
    "Current Ver": 5.5,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "homegate.ch",
    Category: "HOUSE_AND_HOME",
    Rating: 4.2,
    Reviews: 2543,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 27, 2018",
    "Current Ver": "8.4.2",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "tutti.ch - Free Classifieds",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 9950,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 18, 2018",
    "Current Ver": "3.7.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "autoricardo.ch – vehicles",
    Category: "LIFESTYLE",
    Rating: 3.3,
    Reviews: 1045,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 13, 2018",
    "Current Ver": 5.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Chrome Dev",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 63576,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 2, 2018",
    "Current Ver": "69.0.3497.24",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Legit Check App by Ch Daniel",
    Category: "LIFESTYLE",
    Rating: 4.9,
    Reviews: 66,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 18, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Threema",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 51110,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Battery HD Pro",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 17861,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "DRAGON QUEST IV",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 1647,
    Size: "16M",
    Type: "Paid",
    Price: "$14.99",
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "February 28, 2017",
    "Current Ver": "1.0.5",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "swissinfo.ch",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.9,
    Reviews: 271,
    Size: "9.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 18, 2018",
    "Current Ver": "3.3.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Automagic * Automation",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 1947,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$3.90",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "FlashLight HD LED Pro",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 4928,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Students.ch",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 5,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "June 11, 2018",
    "Current Ver": "1.0.12",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CH Kadels",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 36,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 26, 2018",
    "Current Ver": "1.0.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Sermon on Proverbs CH Spurgeon",
    Category: "GAME",
    Rating: 4.8,
    Reviews: 35,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "July 29, 2016",
    "Current Ver": "1.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Pixxy KWGT",
    Category: "PERSONALIZATION",
    Rating: 4.8,
    Reviews: 60,
    Size: "78M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 29, 2018",
    "Current Ver": "4.0.1",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "ricardo.ch",
    Category: "SHOPPING",
    Rating: 4,
    Reviews: 13232,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 21, 2018",
    "Current Ver": "7.5.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "usgang.ch",
    Category: "LIFESTYLE",
    Rating: 3.7,
    Reviews: 492,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Lifestyle",
    "Last Updated": "June 11, 2018",
    "Current Ver": "3.0.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Startupticker.ch News, Events",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 5,
    Reviews: 4,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "ci",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 1691,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "June 8, 2016",
    "Current Ver": "1.0.3",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Green Build - An unofficial Travis CI client",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 7,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.2.1",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "mySharpBranded CI Test",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "898k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 4, 2017",
    "Current Ver": "1.0.7",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Valmet CI Tool",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 13, 2018",
    "Current Ver": "0.0.6",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CI Remote for Go",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 20,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100,
    numAndroid: null,
  },
  {
    App: "myNaida CI",
    Category: "MEDICAL",
    Rating: 4.6,
    Reviews: 64,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 10, 2018",
    "Current Ver": "3.1.4",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "CI MOBI",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 108,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 7, 2017",
    "Current Ver": "1.2.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Paris ci la Sortie du Métro",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 453,
    Size: "36M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "April 2, 2018",
    "Current Ver": 4.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Supply Travis-CI POC",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "July 20, 2016",
    "Current Ver": "1.0.7",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CI 174 Gray Icon Pack",
    Category: "PERSONALIZATION",
    Rating: 5,
    Reviews: 1,
    Size: "46M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 21, 2018",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CI Crew",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 8, 2018",
    "Current Ver": 0.7,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Pharmacy CI - Pharmacies de garde Côte d'Ivoire",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 5509,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 3, 2018",
    "Current Ver": "4.7.0 Phoenix",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CI Staff App",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "October 4, 2017",
    "Current Ver": "1.0.7",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "IQ Test",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 1623,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 6, 2018",
    "Current Ver": 1.8,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "1st Fed CI Mobile Banking",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "September 29, 2016",
    "Current Ver": "6.0.0.1775",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Thistletown CI",
    Category: "PRODUCTIVITY",
    Rating: 1,
    Reviews: 1,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 15, 2018",
    "Current Ver": 41.9,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "All-night drugstore CI & Price",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.1M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "November 27, 2017",
    "Current Ver": "3.0.2.0",
    numInstall: 10,
    numAndroid: 1,
  },
  {
    App: "CI Dictionary",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 31,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 1, 2015",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "RGN CI-Control",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 28, 2018",
    "Current Ver": 1.2,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CI Time",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 4,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 17, 2017",
    "Current Ver": "1.2.392",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CI View",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 19, 2017",
    "Current Ver": 2.9,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ci - Logistics Group",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 4, 2015",
    "Current Ver": "1.0.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CI Attendance",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "172k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 17, 2013",
    "Current Ver": "1.0.0",
    numInstall: 5,
    numAndroid: 3,
  },
  {
    App: "Annonces.ci",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 14,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "April 5, 2016",
    "Current Ver": "1.0.3",
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "C I Patel School",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 101,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 10, 2017",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CI Screwed - Icon Pack",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 19,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 30, 2016",
    "Current Ver": 1.5,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CI Stream",
    Category: "VIDEO_PLAYERS",
    Rating: "NaN",
    Reviews: 0,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 12, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Majestic Cinema CI",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 45,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "November 23, 2017",
    "Current Ver": "1.2.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Bonjour 2017 Abidjan CI ❤❤❤❤❤",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 235,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 16, 2017",
    "Current Ver": "1.0.2.0",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Pharmacie de Garde CI et Prix",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 2599,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Health & Fitness",
    "Last Updated": "January 9, 2018",
    "Current Ver": "3.0.5.0",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "CI Capital - Dynamic",
    Category: "FINANCE",
    Rating: 4.8,
    Reviews: 4,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 23, 2018",
    "Current Ver": "1.0.17.0423",
    numInstall: 50,
    numAndroid: 5,
  },
  {
    App: "Chicken Invaders 3",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 52390,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 4, 2018",
    "Current Ver": "1.28ggl",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "CI SA",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "10.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 11, 2018",
    "Current Ver": "1.0.2",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Mesure CI",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 9,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 4, 2016",
    "Current Ver": "1.0.1",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Trovami se ci riesci",
    Category: "GAME",
    Rating: 5,
    Reviews: 11,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "March 11, 2017",
    "Current Ver": 0.1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "CircleCI Viewer",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 16,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 23, 2017",
    "Current Ver": "1.3.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "SimCity BuildIt",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 4218587,
    Size: "100M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Simulation",
    "Last Updated": "June 19, 2018",
    "Current Ver": "1.23.3.75024",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Nur təfsiri 1-ci cild",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 5,
    Reviews: 15,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "April 27, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 1,
  },
  {
    App: "Test de Inteligencia CI",
    Category: "FAMILY",
    Rating: 2.9,
    Reviews: 21,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 11, 2015",
    "Current Ver": 1.05,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Calculate My IQ",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 44,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 3, 2017",
    "Current Ver": "NaN",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "South Park: Phone Destroyer™",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 288835,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Strategy",
    "Last Updated": "July 19, 2018",
    "Current Ver": "2.7.6",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "CI CAFETERIAS UBER",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 11, 2018",
    "Current Ver": "18.6.5",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Mizanul-Hikmət 2-ci cild",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 16,
    Size: "743k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "January 4, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 1,
  },
  {
    App: "CI On The Go",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3,
    Reviews: 2,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 18, 2018",
    "Current Ver": "v4.30.0.8",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "CJ SO COOL",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 145,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 11, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CJ Fitness",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.4,
    Reviews: 221,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "February 14, 2018",
    "Current Ver": "4.3.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CJ: Strike Back",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 29330,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "August 17, 2012",
    "Current Ver": "1.0.9",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "The Grand Wars: San Andreas",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 29990,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "December 8, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "CJ Fallon eBook Reader",
    Category: "FAMILY",
    Rating: 1.9,
    Reviews: 76,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 13, 2014",
    "Current Ver": "2.2.1",
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "Grand Theft Auto: San Andreas",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 348962,
    Size: "26M",
    Type: "Paid",
    Price: "$6.99",
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "March 21, 2015",
    "Current Ver": 1.08,
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "CJ Gospel Hour",
    Category: "SOCIAL",
    Rating: 5,
    Reviews: 7,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 25, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CJ's Tire & Automotive",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4,
    Reviews: 5,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 30, 2018",
    "Current Ver": 2.8,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "CJ Camcorder",
    Category: "VIDEO_PLAYERS",
    Rating: 4.7,
    Reviews: 3,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "November 26, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "The Grand Way",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 1995,
    Size: "92M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 3, 2018",
    "Current Ver": 1.9,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "CJ'S TIRE AND AUTO INC.",
    Category: "PRODUCTIVITY",
    Rating: 5,
    Reviews: 5,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 30, 2018",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CJ Browser - Fast & Private",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 5,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "November 7, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CJ WOW SHOP",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 2099,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "December 23, 2017",
    "Current Ver": "1.1.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Gold Teeth Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 2.8,
    Reviews: 1022,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 24, 2016",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "CJ VLC HD Remote (+ Stream)",
    Category: "VIDEO_PLAYERS",
    Rating: 4.2,
    Reviews: 4074,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "November 13, 2013",
    "Current Ver": "1.2.4",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "CJ DVD Rentals",
    Category: "COMMUNICATION",
    Rating: 1,
    Reviews: 5,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "October 6, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "San Andreas City : Auto Theft Car gangster",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 923,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 17, 2018",
    "Current Ver": 1.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Miami Crime Vice Town",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 154519,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "May 9, 2017",
    "Current Ver": 1.4,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "CJ Poker Odds Calculator",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 207,
    Size: "116k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "January 30, 2011",
    "Current Ver": 1.2,
    numInstall: 50000,
    numAndroid: 1,
  },
  {
    App: "Commission Manager",
    Category: "PRODUCTIVITY",
    Rating: 3.2,
    Reviews: 12,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 26, 2015",
    "Current Ver": "1.0.0.0",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "CJ Apps",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 10, 2018",
    "Current Ver": 2.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "The CJ Rubric",
    Category: "HEALTH_AND_FITNESS",
    Rating: 5,
    Reviews: 5,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "December 5, 2017",
    "Current Ver": "The CJ Rubric 7.12.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Pekalongan CJ",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 21, 2018",
    "Current Ver": "0.0.1",
    numInstall: 0,
    numAndroid: 4,
  },
  {
    App: "CJ's Coffee Cafe",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 5,
    Reviews: 6,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 21, 2017",
    "Current Ver": "7.5.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Gangster City Auto Theft",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 350,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "China Town Auto Theft 2",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 364,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "May 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Codes for GTA San Andreas",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 12414,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 4, 2017",
    "Current Ver": "1.0.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CJ Wilson's ZoomZoomnation",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 4,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 11, 2018",
    "Current Ver": "3.5.3",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "C J Academy",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 2, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Grand Gangsters 3D",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 401643,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Sir C J New Primary School",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 3,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.0.10",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Gang Wars of San Andreas",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 9898,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "February 15, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CJ the REALTOR",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 1,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 31, 2017",
    "Current Ver": "1.0.8",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CJ Infinity",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 0,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "January 5, 2018",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CJmall",
    Category: "SHOPPING",
    Rating: 3.7,
    Reviews: 18253,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 6, 2018",
    "Current Ver": "6.3.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "CJ IT ApS",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 2, 2015",
    "Current Ver": "1.31.62.109",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CJ Auto école",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 24, 2014",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "Sin City Hero : Crime Simulator of Vegas",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 3371,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "September 8, 2017",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Courier Journal",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.5,
    Reviews: 254,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "June 20, 2018",
    "Current Ver": "5.9.5",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "FANDOM for: GTA",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 39038,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "June 6, 2018",
    "Current Ver": "2.9.8",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "San Andreas Crime City Gangster 3D",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 9403,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "July 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Death Shooter",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 17372,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Arcade",
    "Last Updated": "August 8, 2015",
    "Current Ver": 1.3,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Project Grand Auto Town Sandbox Beta",
    Category: "GAME",
    Rating: 3.7,
    Reviews: 7885,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Racing",
    "Last Updated": "February 9, 2018",
    "Current Ver": 1.07,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Credit Karma",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 706618,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Company Kitchen",
    Category: "LIFESTYLE",
    Rating: 2.8,
    Reviews: 81,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 6, 2018",
    "Current Ver": "2.0.0 (18.03.01)",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Calvin Klein – US Store",
    Category: "SHOPPING",
    Rating: 4.7,
    Reviews: 221,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 1, 2017",
    "Current Ver": "3.6.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "CK FFXIV Companion",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1364,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 12, 2018",
    "Current Ver": "4.3.5",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Can Knockdown",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 155649,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 11, 2018",
    "Current Ver": 1.38,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Calvin Klein Petite Dresses",
    Category: "BEAUTY",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "March 23, 2018",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Louis CK",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 244,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "October 11, 2017",
    "Current Ver": "1.2.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CK-12: Practice Math & Science",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 562,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "December 21, 2017",
    "Current Ver": "3.8.0.251918",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "CK 初一 十五",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 294,
    Size: "153k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 3, 2013",
    "Current Ver": "1.0.12",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "CK Eorzea Timepiece",
    Category: "PERSONALIZATION",
    Rating: 3.2,
    Reviews: 8,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 5, 2015",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "F*ck This Game",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 8,
    Size: "6.3M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 18, 2015",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "211:CK",
    Category: "GAME",
    Rating: 5,
    Reviews: 8,
    Size: "38M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "April 11, 2018",
    "Current Ver": 1.3,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CONTRACT KILLER: ZOMBIES (NR)",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 206602,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "July 1, 2013",
    "Current Ver": "3.1.0",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "ck-modelcars Shop",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 118,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 15, 2018",
    "Current Ver": "5.29.0",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "Brainf*ck Interpreter",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 24,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "September 3, 2016",
    "Current Ver": "1.0.6",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "ck-modelcars-UK Shop",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 69,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 15, 2018",
    "Current Ver": "5.29.0",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "CK Multimedia - Gaming Accessories",
    Category: "SHOPPING",
    Rating: 4.7,
    Reviews: 10,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "February 3, 2017",
    "Current Ver": 1.5,
    numInstall: 500,
    numAndroid: 3,
  },
  {
    App: "CK SKILLZ",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "May 15, 2018",
    "Current Ver": "1.1.7",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CK-12 Physics Simulations",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 30,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "April 18, 2018",
    "Current Ver": "1.0.7",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "CKZ ORIGINS",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 219821,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "October 28, 2013",
    "Current Ver": "2.0.1",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "211:CK Lite",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 3,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "September 22, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CK Life",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 3,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "USMLE Step 2 CK Flashcards",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 1,
    Size: "40M",
    Type: "Paid",
    Price: "$19.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 26, 2014",
    "Current Ver": 2.47,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "CK Employee Portal",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 7,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 5, 2017",
    "Current Ver": "1.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FML F*ck my life + widget",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1415,
    Size: "209k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 21, 2010",
    "Current Ver": 3.1,
    numInstall: 100000,
    numAndroid: 1,
  },
  {
    App: "USMLE Step 2 CK Cards Lite",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 28,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 20, 2014",
    "Current Ver": 2.46,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Company Kitchen Inventory",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 3,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 16, 2015",
    "Current Ver": 2.38,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Tic Tac CK",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 3,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 3, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CK Pharmacies",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.7,
    Reviews: 3,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Health & Fitness",
    "Last Updated": "June 28, 2018",
    "Current Ver": "7.4.8",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "INFAMY RO",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 2167,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "December 14, 2017",
    "Current Ver": 202,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "CK Call NEW",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 26, 2017",
    "Current Ver": "3.8.8",
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "Ck Coif",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "April 30, 2016",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "CONTRACT KILLER: ZOMBIES",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 144545,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "December 1, 2011",
    "Current Ver": "1.1.0",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "CK Shop",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 13,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 9, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "FlexBook",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 104,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "May 21, 2018",
    "Current Ver": "1.0.6",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Can Knockdown 3",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 349503,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "August 26, 2015",
    "Current Ver": 1.31,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Fu*** Weather (Funny Weather)",
    Category: "WEATHER",
    Rating: 4.7,
    Reviews: 20001,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Weather",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "OB-GYN USMLE Stp2 CK 300 Q & A",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 34,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 16, 2015",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "CK Active",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "February 27, 2018",
    "Current Ver": "3.0.6",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "USMLE CK Clinical Knowledge Flashcards 2018 Ed",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 21, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Night Camera Blur Effect",
    Category: "PHOTOGRAPHY",
    Rating: 3.6,
    Reviews: 100,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 5, 2018",
    "Current Ver": 4.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Camera V7 24 Megapixel",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 2480,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 1, 2018",
    "Current Ver": 4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CL Mobile Pro - Classifieds for Craigslist",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 1288,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Shopping",
    "Last Updated": "July 9, 2018",
    "Current Ver": 48,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "cloudLibrary",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4,
    Reviews: 10774,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 28, 2018",
    "Current Ver": "3.8.10",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CL Reader for Craigslist(For sale, jobs, rental..)",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 61,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 14, 2017",
    "Current Ver": 1.9,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CL Pro App for Craigslist",
    Category: "SHOPPING",
    Rating: 4,
    Reviews: 119,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 1, 2017",
    "Current Ver": "CL Pro for Craigslist - Canada 150",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Castle Clash: Heroes of the Empire US",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 4578890,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.4.51",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "CL 2NE1 Wallpaper KPOP Fans HD",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 7,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 19, 2018",
    "Current Ver": "1.1.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CL 2ne1 Wallpaper KPOP HD Best",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 3,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 9, 2018",
    "Current Ver": "1.1.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FREE CHATS C.L.",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 4,
    Size: "3.4M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Mature 17+",
    Genres: "Communication",
    "Last Updated": "February 12, 2018",
    "Current Ver": 11,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CL 2ne1 Wallpaper KPOP UHD Fans",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 15, 2018",
    "Current Ver": "1.1.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CL REPL",
    Category: "TOOLS",
    Rating: 5,
    Reviews: 47,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 10, 2018",
    "Current Ver": "1.0.19",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CL Pro Client for Craigslist",
    Category: "SHOPPING",
    Rating: 3.6,
    Reviews: 48,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "September 10, 2016",
    "Current Ver": "Bowser4Craigslist",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DAILY: Free Classifieds App for Android",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 5025,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Lifestyle",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "App for Craigslist Pro - Buy & Sell Postings",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 707,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 9, 2018",
    "Current Ver": "App copyright",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Pro App for Craigslist",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 5618,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "May 9, 2018",
    "Current Ver": "Copyright",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Car Search For Craigslist CL Free",
    Category: "AUTO_AND_VEHICLES",
    Rating: 2.6,
    Reviews: 5,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "May 8, 2018",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "CL Clock",
    Category: "BUSINESS",
    Rating: 2.7,
    Reviews: 7,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 22, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Old: CL-150",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 120,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 21, 2018",
    "Current Ver": "1.1.7",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CL Keyboard - Myanmar Keyboard (No Ads)",
    Category: "TOOLS",
    Rating: 5,
    Reviews: 24,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 13, 2018",
    "Current Ver": "1.1.3",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Clash of Kings : The King Of Fighters version",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 2233681,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "August 1, 2018",
    "Current Ver": "3.44.0",
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "Cl-app!",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 41,
    Size: "353k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 2, 2013",
    "Current Ver": "1.1.11",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "CL Notifier",
    Category: "TOOLS",
    Rating: 5,
    Reviews: 36,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Tools",
    "Last Updated": "August 2, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Leica CL",
    Category: "PHOTOGRAPHY",
    Rating: 2.6,
    Reviews: 8,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 21, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "cPro Marketplace: Buy. Sell. Rent. Date. Jobs.",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 385764,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Shopping",
    "Last Updated": "August 5, 2018",
    "Current Ver": 3.82,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Postings (Craigslist Search App)",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 151095,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Shopping",
    "Last Updated": "July 1, 2018",
    "Current Ver": "4.0.13",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "New CL 2ne1 Wallpaper KPOP live",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.1.1",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "CL 2ne1 Wallpaper KPOP Fans All",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 29, 2018",
    "Current Ver": "1.1.1",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "CL-Phlebotomist",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 19,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 16, 2018",
    "Current Ver": "1.0.23",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "New: CL-150",
    Category: "FAMILY",
    Rating: 2.8,
    Reviews: 4,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.2.0",
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "Battle of Zombies: Clans War",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 488039,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "November 15, 2017",
    "Current Ver": "1.0.175",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "CL-Customer Care",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 14, 2018",
    "Current Ver": 1.3,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "CL Pebble Apps",
    Category: "LIFESTYLE",
    Rating: 3.6,
    Reviews: 67,
    Size: "499k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 23, 2015",
    "Current Ver": 3.5,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "MPS CL",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.0.3",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Turnotronik CL",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.0.3",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CL e-bank",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 210,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.5.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "E2CR CL",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 30, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Wallpapers Mercedes Benz CL",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 2,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "March 5, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Color CL",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 2,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "February 2, 2017",
    "Current Ver": 1.01,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CL Strength",
    Category: "HEALTH_AND_FITNESS",
    Rating: 5,
    Reviews: 3,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 27, 2018",
    "Current Ver": "CL Strength 7.12.1",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CL-App",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 6,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "February 17, 2017",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Security Master - Antivirus, VPN, AppLock, Booster",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 24900999,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 4, 2018",
    "Current Ver": "4.6.6",
    numInstall: 500000000,
    numAndroid: null,
  },
  {
    App: "CM Launcher 3D - Theme, Wallpapers, Efficient",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 6700847,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "August 3, 2018",
    "Current Ver": "5.41.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "CM Launcher 3D Pro💎",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 23802,
    Size: "173k",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "November 17, 2016",
    "Current Ver": "1.0.9",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CM Locker - Security Lockscreen",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 3090680,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Clean Master Lite - For Low-End Phone",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 2246379,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 28, 2018",
    "Current Ver": "2.1.4",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "CM Security Open VPN - Free, fast unlimited proxy",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 85496,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 14, 2018",
    "Current Ver": "1.6.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CM Security Lite - Antivirus",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 262076,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 4, 2018",
    "Current Ver": "1.0.2",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "CM Transfer - Share any files with friends nearby",
    Category: "COMMUNICATION",
    Rating: 4.6,
    Reviews: 71740,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 27, 2018",
    "Current Ver": "2.0.7.0014",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "CM Flashlight (Compass, SOS)",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 166363,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.4.0",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "CM Apps",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 3341,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 17, 2016",
    "Current Ver": 4.5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CM AppLock",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 843,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 25, 2016",
    "Current Ver": "2.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Ruler(cm, inch)",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 2889,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 27, 2016",
    "Current Ver": "1.1.0",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "AppLock - Fingerprint Unlock",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 112482,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 10, 2018",
    "Current Ver": "1.0.5",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "CM Launcher Default Theme",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 3989,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "September 11, 2015",
    "Current Ver": "1.1.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Battery Doctor-Battery Life Saver & Battery Cooler",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 8190074,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 1, 2018",
    "Current Ver": 6.24,
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Inch/cm/Foot Conversion",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 319,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 20, 2017",
    "Current Ver": "2.0.1",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Speed Booster - Ram, Battery & Game Speed Booster",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 85079,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.0.4",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "CM FILE MANAGER",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 953790,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Technology CM Locker Theme",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 10093,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "February 26, 2016",
    "Current Ver": "1.0.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Swift Dark CM / CM13 Theme",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 1500,
    Size: "41M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 5, 2017",
    "Current Ver": "3.3.3",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Melior NUI - Material CM Theme",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 1873,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "November 7, 2016",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Height Converter feet-inch cm",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 498,
    Size: "597k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 22, 2013",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "CM Secure Browser (Authorized)",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 1147,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 2, 2017",
    "Current Ver": "1.1.6",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "📏 Smart Ruler ↔️ cm/inch measuring for homework!",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 19,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 21, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Ruler cm",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 661,
    Size: "809k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 10, 2014",
    "Current Ver": 2.1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Length Converter: convert mm,cm,m, feet,yard,mile",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 76,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 5, 2018",
    "Current Ver": 1.4,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "CM AppLock Fingerprint 2018",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 1264,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 6, 2018",
    "Current Ver": "4.0.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "m, cm, mm to yard, feet, inch converter tool",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 246,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 6, 2018",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Speed Car CM Locker Theme",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 7519,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 26, 2016",
    "Current Ver": "1.0.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Calculator CM",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 8,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 9, 2015",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Inches to cm conversion",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 29,
    Size: "70k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 14, 2015",
    "Current Ver": 1.4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Vintage Flower CM Locker Theme",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 2910,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 24, 2016",
    "Current Ver": "1.0.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Centimeter Ruler",
    Category: "TOOLS",
    Rating: 3.3,
    Reviews: 16,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 5, 2016",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CM S Pen Add-on(ROOT)",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 373,
    Size: "122k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 24, 2017",
    "Current Ver": "1.0.9",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Ruler",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 27180,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 6, 2018",
    "Current Ver": 3.24,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "My Style CM 13 Theme",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 314,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "September 8, 2016",
    "Current Ver": 1.9,
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "QuickPic - Photo Gallery with Google Drive Support",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 847144,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 10, 2017",
    "Current Ver": "4.7.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Ruler & Area Measurement (cm, inch)",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 10,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 28, 2017",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Inches to Centimeters",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 949,
    Size: "411k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 13, 2018",
    "Current Ver": 3,
    numInstall: 100000,
    numAndroid: 1,
  },
  {
    App: "cm, mm to inch, feet converter tool",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 176,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "September 27, 2016",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "City light CM Locker Theme",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 6271,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "February 24, 2016",
    "Current Ver": "1.0.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Speed Test - WiFi / Cellular speed test",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 24226,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 27, 2017",
    "Current Ver": "1.0.5",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "CM FILE MANAGER Pro",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 2359,
    Size: "2.7M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 16, 2016",
    "Current Ver": "1.16.9",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "cm to inches | centimeters to inches conversion",
    Category: "TOOLS",
    Rating: 4.8,
    Reviews: 52,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 7, 2018",
    "Current Ver": "1.3.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "OMEGA Black UI Theme - CM 12+",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 12,
    Size: "19M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 20, 2015",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "In to cm",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 5, 2018",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Cartoon Network App",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 119173,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Video Players & Editors;Music & Video",
    "Last Updated": "June 21, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "CN Summer Challenge",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 985,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Brain Games",
    "Last Updated": "May 24, 2018",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Teen Titans GO Figure!",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 1985,
    Size: "28M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone 10+",
    Genres: "Action;Action & Adventure",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.0.2",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "CN Superstar Soccer: Goal!!!",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 3863,
    Size: "41M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Sports;Action & Adventure",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.1.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Teeny Titans - Teen Titans Go!",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 20463,
    Size: "25M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone 10+",
    Genres: "Strategy;Action & Adventure",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.2.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CN Sayin' - Cartoon Network",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 85,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 27, 2018",
    "Current Ver": 1.22,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Cartoon Network Match Land",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 21979,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 9, 2018",
    "Current Ver": "1.1.3",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Card Wars Kingdom",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 920571,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Card;Action & Adventure",
    "Last Updated": "January 17, 2017",
    "Current Ver": "1.0.10",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Wrecker's Revenge - Gumball",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 2263,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Action & Adventure",
    "Last Updated": "September 21, 2017",
    "Current Ver": 14.15,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Super Slime Blitz - Gumball",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 5395,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade;Action & Adventure",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.2.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Blamburger - Clarence",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 30444,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade;Action & Adventure",
    "Last Updated": "October 26, 2015",
    "Current Ver": "1.0.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Free Fur All – We Bare Bears",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 256916,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade;Action & Adventure",
    "Last Updated": "October 8, 2015",
    "Current Ver": "1.0.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Sky Streaker - Gumball",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 37513,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "December 7, 2015",
    "Current Ver": 4,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Just A Regular Arcade",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 40847,
    Size: "94M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "January 8, 2016",
    "Current Ver": "3.1.0",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Soundtrack Attack",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 96045,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action;Action & Adventure",
    "Last Updated": "July 26, 2016",
    "Current Ver": "1.0.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "[adult swim]",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 21433,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "May 29, 2018",
    "Current Ver": "3.0.1805181047",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Ben 10: Alien Experience",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 82005,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action;Action & Adventure",
    "Last Updated": "October 24, 2017",
    "Current Ver": "1.2.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "MagiMobile – Mighty Magiswords",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 120035,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Action & Adventure",
    "Last Updated": "January 4, 2018",
    "Current Ver": "1.0.11",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Dreamland Arcade - Steven Universe",
    Category: "GAME",
    Rating: 4,
    Reviews: 6386,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "November 19, 2017",
    "Current Ver": 0.99,
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Surely You Quest - Magiswords",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 43314,
    Size: "83M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing;Action & Adventure",
    "Last Updated": "June 20, 2017",
    "Current Ver": "1.0.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Adventure Time Run",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 24628,
    Size: "88M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.25.396",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Glitch Fixers: Powerpuff Girls",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 39698,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "December 1, 2016",
    "Current Ver": "1.0.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "StirFry Stunts - We Bare Bears",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 121533,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "March 24, 2016",
    "Current Ver": "1.0.0",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Burrito Bash – We Bare Bears",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 10776,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade;Action & Adventure",
    "Last Updated": "October 26, 2017",
    "Current Ver": 3.4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "LEGO® TV",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 17250,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "August 4, 2018",
    "Current Ver": "4.0.2",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Boomerang",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 13519,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "July 27, 2018",
    "Current Ver": 2.18,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "We Bare Bears Match3 Repairs",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 39153,
    Size: "98M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.1.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Champions and Challengers - Adventure Time",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 51973,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.2.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ski Safari: Adventure Time",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 48754,
    Size: "9.3M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Arcade;Action & Adventure",
    "Last Updated": "October 7, 2014",
    "Current Ver": "1.5.2",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Block Survival Craft:The Story",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 7046,
    Size: "87M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Puzzle",
    "Last Updated": "October 12, 2017",
    "Current Ver": "0.2.7",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "What's Up, Snoopy? - Peanuts",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 773,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade;Action & Adventure",
    "Last Updated": "August 22, 2017",
    "Current Ver": "1.0.1",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "DisneyNOW – TV Shows & Games",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 82499,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Rockstars of Ooo",
    Category: "FAMILY",
    Rating: 3.4,
    Reviews: 642,
    Size: "26M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone 10+",
    Genres: "Arcade;Action & Adventure",
    "Last Updated": "August 11, 2015",
    "Current Ver": "1.0.2",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Pokémon TV",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 117461,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "June 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Angelo Rules - Crazy day",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 108336,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "June 27, 2016",
    "Current Ver": "4.0.01",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Flipped Out! - Powerpuff Girls",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 412,
    Size: "22M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone 10+",
    Genres: "Action;Action & Adventure",
    "Last Updated": "June 30, 2016",
    "Current Ver": "1.0.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Adventure Time Game Wizard",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 4107,
    Size: "40M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "July 16, 2015",
    "Current Ver": "1.2.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Best Park in the Universe",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 3904,
    Size: "5.5M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "September 10, 2014",
    "Current Ver": "1.2.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Formula Cartoon All Stars",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 1213,
    Size: "18M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "June 25, 2015",
    "Current Ver": "4.1.2",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Multicraft Miner Exploration",
    Category: "GAME",
    Rating: 4,
    Reviews: 14563,
    Size: "74M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Adventure",
    "Last Updated": "December 22, 2017",
    "Current Ver": "0.6.49",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CN TV Canal 3 - Cable Netword",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 5,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 10, 2018",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CN Resident",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 1,
    Size: "64M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 22, 2017",
    "Current Ver": 40.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Little Lovely Dentist",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 17786,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 14, 2018",
    "Current Ver": "1.1.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Foods Co",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 199,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 2, 2018",
    "Current Ver": "14.2.1",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "AND CO",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 175,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.2.0",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Tetrobot and Co.",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 709,
    Size: "18M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 20, 2015",
    "Current Ver": "1.1.2",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Brit + Co",
    Category: "LIFESTYLE",
    Rating: 3.9,
    Reviews: 987,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 29, 2017",
    "Current Ver": "2.0.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Wuwu & Co.",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 9,
    Size: "77M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Books & Reference;Creativity",
    "Last Updated": "March 22, 2017",
    "Current Ver": 2.49,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Dots & Co: A Puzzle Adventure",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 81001,
    Size: "85M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 27, 2018",
    "Current Ver": "2.15.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AppClose - The #1 FREE Co-Parenting App",
    Category: "PARENTING",
    Rating: 3.5,
    Reviews: 159,
    Size: "85M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.1.23",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Co-op CRS",
    Category: "LIFESTYLE",
    Rating: 3.6,
    Reviews: 581,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 4, 2018",
    "Current Ver": "2.4.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Co Checker",
    Category: "TOOLS",
    Rating: 1.9,
    Reviews: 12,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 20, 2017",
    "Current Ver": "1.8.6",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "VCalendar - VenkatRama and Co",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 87,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 16, 2018",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Feeder.co",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.2,
    Reviews: 77,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "March 12, 2018",
    "Current Ver": "2.2.7",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Co-op Connections",
    Category: "SHOPPING",
    Rating: 1.6,
    Reviews: 8,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "May 3, 2018",
    "Current Ver": 1.5,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "mail.co.uk Mail",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 21,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.1.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Aquarium Co-Op Podcast",
    Category: "LIFESTYLE",
    Rating: 4.9,
    Reviews: 206,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 20, 2017",
    "Current Ver": "2.3.13",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "MobileBiz Co - Cloud Invoice",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 373,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 16, 2018",
    "Current Ver": "1.3.4",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Supermarket Cashier Kids Games",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 32416,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "July 10, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Co-op Taxi",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.4,
    Reviews: 168,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "May 1, 2018",
    "Current Ver": "3.19.34",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Alex & Co Quiz",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 9,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "April 15, 2018",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Them Bombs: co-op board game play with 2-4 friends",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 8038,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Board",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.4.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "REI Co-op Mastercard",
    Category: "FINANCE",
    Rating: 2.9,
    Reviews: 320,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 14, 2018",
    "Current Ver": "2.13.11",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Websites.co.in Instant Website",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 327,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 25, 2018",
    "Current Ver": 1.48,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Co-op Credit Union on the Go",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 5,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 25, 2018",
    "Current Ver": "18.1.79",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Hashtags For Likes.co",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 420,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "December 19, 2016",
    "Current Ver": 1.1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Chinese Chess ( Xiangqi Free )",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 963,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "April 18, 2017",
    "Current Ver": "1.1.1",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Krypton by krypt.co",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 38,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 17, 2018",
    "Current Ver": "2.4.0",
    numInstall: 1000,
    numAndroid: 6,
  },
  {
    App: "Chinese Chess / Co Tuong",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 6947,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "October 25, 2017",
    "Current Ver": "2.7.7",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Fayr - Co-Parenting Simplified",
    Category: "PRODUCTIVITY",
    Rating: 3.5,
    Reviews: 16,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 20, 2018",
    "Current Ver": "1.5.1",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Co-Dependents Anonymous",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "February 28, 2018",
    "Current Ver": "1.0.1",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Sprig by CO-OP",
    Category: "FINANCE",
    Rating: 2.9,
    Reviews: 252,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "October 11, 2017",
    "Current Ver": "1.4.1033",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Good&Co: Career match tests",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 26572,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 24, 2018",
    "Current Ver": "2.9.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Central Bank and Trust Co.",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 65,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 12, 2018",
    "Current Ver": "5.9.1.0",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "Soo Co-op Mobile Banking",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 159,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "September 12, 2017",
    "Current Ver": "4.2.87",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Co-Optima Mobile",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 218,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 8, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "SharedCare™ Co-parenting",
    Category: "PARENTING",
    Rating: 2,
    Reviews: 23,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$4.59",
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "June 19, 2016",
    "Current Ver": "3.0.3",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Holl & Co Barbers",
    Category: "LIFESTYLE",
    Rating: 4.7,
    Reviews: 12,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "February 26, 2018",
    "Current Ver": "4.9.940",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Call of Mini™ Zombies 2",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 248417,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "February 10, 2015",
    "Current Ver": "2.1.3",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Grenada Co-operative Bank",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 137,
    Size: "400k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 26, 2013",
    "Current Ver": "2.4.3",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "Dungeon Legends - PvP Action MMO RPG Co-op Games",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 102215,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "June 25, 2018",
    "Current Ver": 3.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CO CASE Events",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 30, 2018",
    "Current Ver": 1.3,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Permit Test CO Colorado DMV",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 41,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 15, 2017",
    "Current Ver": "2.6.5",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Chinese Chess 3D Online (Xiangqi, 象棋, co tuong)",
    Category: "GAME",
    Rating: 3.5,
    Reviews: 23,
    Size: "37M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "December 27, 2017",
    "Current Ver": "2.2.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "2-Player Co-op Zombie Shoot",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 33,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 1, 2018",
    "Current Ver": "1.0.13",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Camping and Co - Camping in Europe",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.7,
    Reviews: 19,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "April 17, 2018",
    "Current Ver": "1.2.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Remote | Fire TV | Android TV | KODI | CetusPlay",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 15911,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 30, 2018",
    "Current Ver": "4.1.8.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Comboios de Portugal",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.4,
    Reviews: 1147,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "May 28, 2018",
    "Current Ver": "1.0.3.8",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CP Dialer",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 64,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "March 22, 2018",
    "Current Ver": "2.9.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "CP Federal Mobile",
    Category: "FINANCE",
    Rating: 3.6,
    Reviews: 180,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "October 6, 2017",
    "Current Ver": "7.0.7-qa003-prod",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Cestovné poriadky CP",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.6,
    Reviews: 2681,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "September 25, 2017",
    "Current Ver": "1.2.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CP Channel",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 7,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Education",
    "Last Updated": "March 21, 2018",
    "Current Ver": "1.1.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CP Clicker",
    Category: "LIFESTYLE",
    Rating: 4.2,
    Reviews: 251,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 22, 2018",
    "Current Ver": "3.3.003",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Evolution CP & IV Calculator for pokemon",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 9465,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 8, 2018",
    "Current Ver": "0.4.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "CP Creepypasta",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 128,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 11, 2016",
    "Current Ver": "1.0.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Hercules CP Mobile",
    Category: "TOOLS",
    Rating: 1.4,
    Reviews: 20,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 6, 2018",
    "Current Ver": "2.1.5",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Cerebral Palsy",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 38,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 30, 2014",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Speak quietly: Autism, CP",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 6,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 30, 2016",
    "Current Ver": 5,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "CP RACING 2 FREE",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 4607,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "March 12, 2018",
    "Current Ver": 3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CP-Care Mobile",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 20, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CP ToolBox",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 70,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 11, 2015",
    "Current Ver": "1.9.3",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Talking Pictures: Autism, CP",
    Category: "MEDICAL",
    Rating: 3.9,
    Reviews: 22,
    Size: "801k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 6, 2017",
    "Current Ver": 1.14,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "CP HAPPS - Pittsburgh Events",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 85,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "March 6, 2015",
    "Current Ver": "1.18.10",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Poke Genie - Safe IV Calculator",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 92958,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.13.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "IV Calc CP Calculator Toolkit",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 242,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 6, 2016",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CP Plus Showcase",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 236,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 9, 2018",
    "Current Ver": "1.0.4",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "CP Calculator",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 187,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "September 13, 2016",
    "Current Ver": 3.21,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "iTooch Mathématiques CP",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1018,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "June 28, 2017",
    "Current Ver": "4.6.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "gCMOB",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 7935,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 8, 2018",
    "Current Ver": "2.4.7",
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "CP Connect 2.0",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 17, 2017",
    "Current Ver": "3.9.4",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Evolution CP",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 13,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "September 4, 2016",
    "Current Ver": "1.0.2",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "IV Go（get IV for Pokemon）",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 132282,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "July 31, 2018",
    "Current Ver": 15,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CP Smart Check List",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 14, 2017",
    "Current Ver": "0.0.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Ditto CP Calculator GO",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 34,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 25, 2018",
    "Current Ver": 1.9,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Foothills CP",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 4,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Education",
    "Last Updated": "June 25, 2018",
    "Current Ver": "3.8.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CP Installer App",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 4,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 24, 2018",
    "Current Ver": "5.1.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CP Trivia",
    Category: "GAME",
    Rating: 5,
    Reviews: 5,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "August 6, 2018",
    "Current Ver": 0.99,
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "CP Ready",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 56,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 5, 2018",
    "Current Ver": "6.4.16",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CP Surprise",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 2548,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 30, 2018",
    "Current Ver": "4.4.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Evolve CP Calc. for PokemonGo",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 116,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 18, 2016",
    "Current Ver": 2.6,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CP Cloud",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 3,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 24, 2018",
    "Current Ver": 2.5,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "GO CP Evolution Calculator",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 5,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 29, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "ClanPlay: Community and Tools for Gamers",
    Category: "COMMUNICATION",
    Rating: 4.8,
    Reviews: 34443,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "June 28, 2018",
    "Current Ver": "1.14.3",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "CP Calculator - Poke Go Calc",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 7,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "September 17, 2016",
    "Current Ver": 1.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Contents Provider(C.P.)Explorer",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 1,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 20, 2018",
    "Current Ver": 5,
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "Cp Calculator for Evolution:GO",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 124,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 23, 2016",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Calcy IV",
    Category: "TOOLS",
    Rating: 4.8,
    Reviews: 36557,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.51f",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "CP Brown English-Telugu Dictionary",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 8,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 10, 2017",
    "Current Ver": 3,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CP Parquet",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 2,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 11, 2016",
    "Current Ver": "1.0.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CP evolution calculator Pokemo",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 78,
    Size: "787k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "February 26, 2017",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "C.P. CERVANTES (TOBARRA)",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 24, 2018",
    "Current Ver": 8.2,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Sporting CP Keyboard Theme",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 45,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "October 24, 2017",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Meu Calendário CP",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 37,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 5, 2018",
    "Current Ver": "1.55.4",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Crusaders Quest",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 475020,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "July 26, 2018",
    "Current Ver": "4.7.0.KG",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "CQ Hotels",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 15,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 6, 2018",
    "Current Ver": "5.4.13",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CQ",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.7,
    Reviews: 7,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "May 18, 2018",
    "Current Ver": "1.0.11",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Curio Quest",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 59152,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "March 29, 2018",
    "Current Ver": "1.14.00",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CQ-Mobile",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 10,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "November 28, 2016",
    "Current Ver": "5.5.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CQ Key",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 26, 2018",
    "Current Ver": 1.03,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Sabbath School 4",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 2871,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 8, 2015",
    "Current Ver": 1.6,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "CQ Mobile",
    Category: "FINANCE",
    Rating: 2.7,
    Reviews: 36,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "Cardinal Quest 2",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 19207,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "September 19, 2016",
    "Current Ver": 1.19,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "CQ-Alert",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 3,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "November 28, 2016",
    "Current Ver": "5.5.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "SDA Collegiate Quarterly",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 8,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 13, 2018",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CQ SIGNAL PRO 5",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 17, 2017",
    "Current Ver": 4,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CQ: Lost In Transmission",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 4,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "May 13, 2018",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "HR Team CQ Region Ed Qld",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 12, 2018",
    "Current Ver": 3.8,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Roll Call News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.7,
    Reviews: 24,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "December 24, 2015",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "UFO-CQ",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "237k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 4, 2016",
    "Current Ver": "NaN",
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "CQ ESPM",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 2,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 3, 2017",
    "Current Ver": "1.0.1",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "SHUTTLLS CQ - Connect Ride Go",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "April 26, 2018",
    "Current Ver": "4.6.2100",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "QRZ Assistant",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 1044,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 30, 2018",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Palavras la cq",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 783,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "October 18, 2014",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "CQ Ukraine",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 25, 2018",
    "Current Ver": "1.17.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Pocket Prefix Plus",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 192,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "February 12, 2018",
    "Current Ver": "v2.6.0",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "CQ Electrical Group",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.0.0",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "10 WPM Amateur ham radio CW Morse code trainer",
    Category: "COMMUNICATION",
    Rating: 3.5,
    Reviews: 10,
    Size: "3.8M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 12, 2018",
    "Current Ver": "2.1.4",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Sabbath School",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 28237,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "April 22, 2018",
    "Current Ver": "3.2.994",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Gunship Modern Combat 3D",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 3247,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 25, 2017",
    "Current Ver": 1.05,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Gun Simulator - Gun Games",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 134,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "February 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "ClanManagerTT2",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 55,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 24, 2018",
    "Current Ver": "2.2.9",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Christian Questions Podcast",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 222,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 28, 2018",
    "Current Ver": 2.8,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Sniper Killer Shooter",
    Category: "GAME",
    Rating: 4,
    Reviews: 119368,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "February 21, 2017",
    "Current Ver": "1.1.4",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "25WPM Amateur ham radio Koch CW Morse code trainer",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.7M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 18, 2018",
    "Current Ver": "2.0.3",
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "QST",
    Category: "FAMILY",
    Rating: 2.5,
    Reviews: 706,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 14, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "Cypress College Library",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "December 7, 2015",
    "Current Ver": "4.7.2",
    numInstall: 100,
    numAndroid: 1,
  },
  {
    App: "Create My App",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 24, 2018",
    "Current Ver": "1.0.5",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Snowboard Racing Free Fun Game",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 4552,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "October 26, 2016",
    "Current Ver": "1.4.0",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "theCut",
    Category: "LIFESTYLE",
    Rating: 4.7,
    Reviews: 499,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 10, 2018",
    "Current Ver": "1.2.7",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "الفاتحون Conquerors",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 108130,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.8.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Toughest Game Ever 2",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 293086,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "October 22, 2015",
    "Current Ver": 8.1,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "RIDE ZERO",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 8778,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Music",
    "Last Updated": "January 2, 2018",
    "Current Ver": "1.3.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CricQuick",
    Category: "SPORTS",
    Rating: 5,
    Reviews: 17,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "December 8, 2017",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Next Island: Dino Village",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 29,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Casual",
    "Last Updated": "May 4, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "iReadMe",
    Category: "PRODUCTIVITY",
    Rating: 5,
    Reviews: 8,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 6, 2018",
    "Current Ver": 1.5,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Global Shop",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 23, 2018",
    "Current Ver": "1.1.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Webmail web mobile app",
    Category: "TOOLS",
    Rating: 2.3,
    Reviews: 395,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 5, 2018",
    "Current Ver": 4.2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "QC",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 4,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "October 5, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Traffic Info and Traffic Alert",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.6,
    Reviews: 695,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "January 28, 2018",
    "Current Ver": 5.3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Color Quartets",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 42,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "November 15, 2016",
    "Current Ver": 1.46,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ham Radio Prefixes",
    Category: "COMMUNICATION",
    Rating: 3.7,
    Reviews: 218,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 12, 2014",
    "Current Ver": 1.12,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Battle Result Predictor for CR",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 7063,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 4, 2017",
    "Current Ver": "1.3.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Deck Advisor for CR",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 37975,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 2, 2017",
    "Current Ver": "1.4.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Card Creator for CR",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 117850,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 19, 2018",
    "Current Ver": "1.8.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "CR & CoC Private Server - Clash Barbarians PRO",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 167974,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Gratis",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Deck Analyzer for CR",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 2630,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 2, 2017",
    "Current Ver": "1.3.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Chest Simulator for Clash Royale",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 4756,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.1.9",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Clash Soundboard For CR & COC",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 13,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 3, 2018",
    "Current Ver": 1.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Quiz for Clash Royale™",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 3788,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 18, 2018",
    "Current Ver": "3.0.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CR Blue Icon Pack",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 323,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 4, 2014",
    "Current Ver": 1.03,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Chest Calculator for CR",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 14754,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Entertainment",
    "Last Updated": "July 22, 2018",
    "Current Ver": "1.8.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ultimate Calculator for CR",
    Category: "PRODUCTIVITY",
    Rating: 3.7,
    Reviews: 7389,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 15, 2017",
    "Current Ver": "1.0.4",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "DCUO|CR Calculator Pro",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 82,
    Size: "1.7M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 14, 2017",
    "Current Ver": 3.3,
    numInstall: 500,
    numAndroid: 3,
  },
  {
    App: "Servidor Privado CR y CoC - Royale Servers PRO",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 55,
    Size: "4.3M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 24, 2017",
    "Current Ver": "1.0.3",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Stats CR Clan for Clash Royale",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 16,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.2.9",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ultimate Clash Royale Tracker",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 92010,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "July 4, 2018",
    "Current Ver": "1.4.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Chest Opener for CR - The Circle Game",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 68,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 7, 2018",
    "Current Ver": "1.0.3",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "Deck Simulator for CR",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 202,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 16, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Stats Royale for Clash Royale",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 68226,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 6, 2018",
    "Current Ver": "1.9.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Counter Deck Calculator for CR",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 3446,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 4, 2017",
    "Current Ver": "1.3.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "CR Calculator",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 297,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 27, 2018",
    "Current Ver": 2.2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Servidor Privado de CR y CoC - Light Royale",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 3106,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 17, 2018",
    "Current Ver": 7,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Helper for Clash Royale (All-in-1)",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 6078,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 10, 2017",
    "Current Ver": "2.0.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "CR Fans: Mazos, Clanes y Grupos",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 219,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 21, 2017",
    "Current Ver": "1.0.7",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "DCUO|CR Calculator Lite",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 182,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 14, 2017",
    "Current Ver": 3.3,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "CR -Call Recorder",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 4,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 19, 2017",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CR Best Decks",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 34,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "July 5, 2017",
    "Current Ver": 1.03,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CR Family",
    Category: "FAMILY",
    Rating: 2.3,
    Reviews: 10,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 8, 2017",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CR Monitor",
    Category: "AUTO_AND_VEHICLES",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "April 27, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "JavaScript Editor CR",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 114,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 16, 2018",
    "Current Ver": "1.0.209",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Jetting for Honda CR dirt bike",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 7,
    Size: "3.4M",
    Type: "Paid",
    Price: "$3.49",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "April 13, 2016",
    "Current Ver": 2.2,
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "CR-Red",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 561,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 4, 2014",
    "Current Ver": 1.05,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Deck Shop for Clash Royale",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 2167,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 6, 2018",
    "Current Ver": "1.1.5",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Royale Tournaments",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 2420,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 28, 2018",
    "Current Ver": "5.3.6.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Deck Builder & Analyzer for CR",
    Category: "FAMILY",
    Rating: 3.1,
    Reviews: 52,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 4, 2017",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Chest Tracker for Clash Royale",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 77717,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 29, 2016",
    "Current Ver": "1.2.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Jeppesen CR Flight Computer",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.3,
    Reviews: 3,
    Size: "26M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "October 5, 2016",
    "Current Ver": "1.0.8",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Cr Aviation Academy",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 7,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 9, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "The ClubHouse CR",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 5,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "4.2.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CR-V Service Manual",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.2,
    Reviews: 12,
    Size: "88M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "February 19, 2018",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Java Editor CR",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 434,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 16, 2018",
    "Current Ver": "1.0.209",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "XML Editor CR",
    Category: "TOOLS",
    Rating: 3.3,
    Reviews: 47,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 16, 2018",
    "Current Ver": "1.0.209",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Evolution Marketing CR",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 14,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "March 30, 2018",
    "Current Ver": 3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CR Tracker for Chests",
    Category: "TOOLS",
    Rating: 5,
    Reviews: 6,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 5, 2018",
    "Current Ver": "1.0.2",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CR Magazine",
    Category: "BUSINESS",
    Rating: 1,
    Reviews: 1,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 23, 2014",
    "Current Ver": "2.4.2",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Ultimate Chest Tracker",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 40328,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 17, 2016",
    "Current Ver": 1.9,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "CamScanner - Phone PDF Creator",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 1502622,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Critical Strike CS: Counter Terrorist Online FPS",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 22773,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "August 3, 2018",
    "Current Ver": 4.84,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CamScanner (License)",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 26358,
    Size: "50k",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 17, 2014",
    "Current Ver": 1.7,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Assault Line CS Online Fps Go",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 52163,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "July 13, 2016",
    "Current Ver": "1.1.2",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Standoff 2",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 299046,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "July 12, 2018",
    "Current Ver": "0.9.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Counter Online FPS Game",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 41089,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 25, 2018",
    "Current Ver": 2.7,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "CS Customizer",
    Category: "COMMUNICATION",
    Rating: 3.7,
    Reviews: 25,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "February 6, 2017",
    "Current Ver": "1.2.11",
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Combat Strike CS 🔫 Counter Terrorist Attack FPS💣",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 1019,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.0.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CS-Touch",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 337,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 11, 2018",
    "Current Ver": 3.6,
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Ultimate Quiz for CS:GO - Skins | Cases | Players",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 2526,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "February 14, 2018",
    "Current Ver": "1.3.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Аim Training for CS",
    Category: "GAME",
    Rating: 3.6,
    Reviews: 2328,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "October 25, 2014",
    "Current Ver": 1.8,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Sniper Traning for CS GO",
    Category: "GAME",
    Rating: 3.2,
    Reviews: 655,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "May 18, 2016",
    "Current Ver": "1.0.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "NetClient CS",
    Category: "BUSINESS",
    Rating: 3.5,
    Reviews: 125,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 5, 2018",
    "Current Ver": "1.2.2",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "CS Guns Shoot",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 433,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 1, 2013",
    "Current Ver": 1.5,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Asiimov Skin - CS GO Icon Pack",
    Category: "PERSONALIZATION",
    Rating: 4.6,
    Reviews: 26,
    Size: "8.5M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 3, 2017",
    "Current Ver": "5.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CS Interview Questions (TechQ)",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 33,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 27, 2017",
    "Current Ver": 1.5,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Your rank CS:GO",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 4946,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Trivia",
    "Last Updated": "July 16, 2017",
    "Current Ver": 1.82,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Guide for CS:GO",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 16459,
    Size: "88M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 15, 2017",
    "Current Ver": "3.2.0",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "CS Interview FAQs",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 99,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 11, 2013",
    "Current Ver": 1.13,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "CS",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 5,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 13, 2015",
    "Current Ver": "Release 1.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Mobile CS",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 13,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 6, 2017",
    "Current Ver": "1.2.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Mobile CS:GO",
    Category: "GAME",
    Rating: 3.1,
    Reviews: 1015,
    Size: "643k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "November 11, 2015",
    "Current Ver": 1.3,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Counter Terrorist Gun Strike CS: Special Forces",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 211,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 18, 2017",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "C.S. Lewis Daily Quotes",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 75,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 14, 2018",
    "Current Ver": "1.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CS go bomb simulator",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 7,
    Size: "28M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 21, 2018",
    "Current Ver": 1.01,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Shooter Sniper CS - FPS Games",
    Category: "GAME",
    Rating: 3.5,
    Reviews: 14823,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "February 15, 2017",
    "Current Ver": 4,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "CS16Client",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 8668,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "April 1, 2017",
    "Current Ver": 1.33,
    numInstall: 500000,
    numAndroid: 1,
  },
  {
    App: "CS Browser | #1 & BEST BROWSER",
    Category: "COMMUNICATION",
    Rating: 3.8,
    Reviews: 52,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 28, 2015",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Counter Attack - Multiplayer FPS",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 112565,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 21, 2018",
    "Current Ver": "1.1.97",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "DU CS Lectures - Learn to Code for Free",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 16,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 29, 2018",
    "Current Ver": 4,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "What's Your CS:GO rank?",
    Category: "GAME",
    Rating: 2.3,
    Reviews: 278,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Trivia",
    "Last Updated": "February 11, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "CS Browser Beta",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 125,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "October 16, 2017",
    "Current Ver": "60.0.3112.3046279",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Helper for CS:GO",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 208,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 16, 2016",
    "Current Ver": "1.2.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "My Nexus for CS:S & CS:GO",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 783,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 25, 2016",
    "Current Ver": "1.3.4",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "CS & IT Interview Questions",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 43,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 27, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "GATE 21 years CS Papers(2011-2018 Solved)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 24, 2018",
    "Current Ver": 3,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Map Callouts for CS:GO",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 211,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "January 26, 2018",
    "Current Ver": 2.1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "GATE CS Engineering 2019 Exam Prep App",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 162,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 15, 2018",
    "Current Ver": "Y4W-GATE_CS-5.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Case Simulator Hero for CS:GO",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 14604,
    Size: "68M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "July 4, 2018",
    "Current Ver": "3.1.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "CA CS Network",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 160,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 25, 2018",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Smokes for CS:GO",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 3253,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 10, 2015",
    "Current Ver": 1.3,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Grenade Practice for CS:GO",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 431,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 13, 2016",
    "Current Ver": "1.1.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Quiz CS:GO players",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 460,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "June 23, 2018",
    "Current Ver": 4.2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Puzzle for CS:GO",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 247,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "September 16, 2016",
    "Current Ver": 1.53,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Bomb and Nade Timer for CS:GO",
    Category: "PRODUCTIVITY",
    Rating: 2.6,
    Reviews: 85,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 21, 2016",
    "Current Ver": "1.1.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Smokes Guide for CS:GO",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 445,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 1, 2017",
    "Current Ver": 3,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Philips IQon Spectral CT Fundamentals.",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 2,
    Size: "77M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "September 21, 2017",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "RadRevision: Anatomy on CT",
    Category: "MEDICAL",
    Rating: 3.8,
    Reviews: 568,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 22, 2014",
    "Current Ver": 1.2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Radiology CT Anatomy",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 345,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 20, 2018",
    "Current Ver": 1.6,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "CT Scan Viewer 3D",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 6,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 20, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Learn CT Scan Of Head",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.1,
    Reviews: 10,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 22, 2018",
    "Current Ver": 1.5,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "CT Abdomen Pelvis",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 36,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 20, 2018",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CT Neck",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 7,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 20, 2018",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CT Scan Generations",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 6,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 1, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Emergency Brain CT",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 2,
    Size: "19M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 17, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CT Prepares",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 2.6,
    Reviews: 13,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "November 1, 2016",
    "Current Ver": "1.0.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CT Abdomen",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 7,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 21, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CT Brain Interpretation",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 3,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 4, 2018",
    "Current Ver": "5.0.16",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CT-Guide & Positioning",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 6,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 6, 2018",
    "Current Ver": 1.5,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CT Sessions",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 62,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "December 15, 2014",
    "Current Ver": 2.2,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "CT - DTC Lookup",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 41,
    Size: "986k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 26, 2013",
    "Current Ver": 3,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "POCKET ATLAS OF CT HEAD",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 22,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 16, 2018",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Interactive CT & MRI Anat.Lite",
    Category: "MEDICAL",
    Rating: 3.8,
    Reviews: 534,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 30, 2012",
    "Current Ver": 1.2,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "CT POSITIONING",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 18,
    Size: "9.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 10, 2018",
    "Current Ver": 2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "CT Cervical Spine",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 5,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 20, 2018",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Trauma CT Head Rules",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 2,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 23, 2017",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CT Head Basic Interpretation",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 11, 2018",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CT MyChiroTown Mobile",
    Category: "MEDICAL",
    Rating: 3.9,
    Reviews: 40,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 7, 2015",
    "Current Ver": "4.1.0",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "CT Lottery",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 271,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 12, 2017",
    "Current Ver": "1.2.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Permit Test Connecticut CT DMV",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 186,
    Size: "9.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 12, 2017",
    "Current Ver": "2.9.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "POCKET BOOK CT ABDOMEN",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 16, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "I AM C.T.",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 28,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Health & Fitness",
    "Last Updated": "April 27, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Solar CT PV System Power",
    Category: "PRODUCTIVITY",
    Rating: 4.7,
    Reviews: 315,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 22, 2018",
    "Current Ver": "SolarCT 1.9 v",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CARDIAC CT TECHNIQUE",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 6,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 10, 2018",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "TUTORIAL CT SCAN CARDIAC",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 10, 2018",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "HEAD TRAUMA CT EVALUATION",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 18,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 16, 2018",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Simpli CT",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 4,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 30, 2017",
    "Current Ver": "1.0.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CT Scan Cross Sectional Anatomy",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 10,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 19, 2018",
    "Current Ver": "5.0.16",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Remote CT - Smart Remote",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 3988,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 22, 2015",
    "Current Ver": "1.0.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CT-REMOTE",
    Category: "GAME",
    Rating: 3.3,
    Reviews: 19,
    Size: "1.6M",
    Type: "Paid",
    Price: "$4.49",
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "February 10, 2015",
    "Current Ver": 1.4,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "CT CONNECT",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 2,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 8, 2017",
    "Current Ver": "8.2.1",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CT-ART 4.0 (Chess Tactics 1200-2400 ELO)",
    Category: "GAME",
    Rating: 4.8,
    Reviews: 8191,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CT-Stream Player",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 84,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 21, 2016",
    "Current Ver": 3.4,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "CT Pulmonary Angiography",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 24, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Results for CT Lottery",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 86,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "March 11, 2017",
    "Current Ver": 5.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Abdominal CT Sectional Walker",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 2,
    Size: "23M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 8, 2016",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Interactive CT and MRI Anatomy",
    Category: "MEDICAL",
    Rating: 3.4,
    Reviews: 35,
    Size: "24M",
    Type: "Paid",
    Price: "$15.46",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 27, 2015",
    "Current Ver": "2.0.3",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Dine In CT - Food Delivery",
    Category: "SHOPPING",
    Rating: 5,
    Reviews: 4,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "May 16, 2016",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CT Checkout",
    Category: "FINANCE",
    Rating: 5,
    Reviews: 1,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 20, 2017",
    "Current Ver": 1.2,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CT and XR Dose Calculator",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 3,
    Size: "97k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 22, 2014",
    "Current Ver": 2014.01,
    numInstall: 50,
    numAndroid: 1,
  },
  {
    App: "Chest CT Sectional Walker",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 2,
    Size: "20M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 9, 2016",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Radiological Anatomy For FRCR1",
    Category: "MEDICAL",
    Rating: 4.8,
    Reviews: 12,
    Size: "44M",
    Type: "Paid",
    Price: "$6.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 22, 2014",
    "Current Ver": 1.3,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Radiology CT Viewer",
    Category: "MEDICAL",
    Rating: 3.6,
    Reviews: 35,
    Size: "88M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 20, 2018",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "POCKET ATLAS CARDIAC MRI AND CT",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 18, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CU: UPI Payments, Chat & Call",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 693,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Finance",
    "Last Updated": "May 3, 2018",
    "Current Ver": "1.0.95",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CU of Colorado Mobile Banking",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 347,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 6, 2018",
    "Current Ver": "4.11.100",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Tech CU Mobile Banking",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 853,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 12, 2018",
    "Current Ver": "4.13.72",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "My CU - Caucasus University",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 48,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 22, 2017",
    "Current Ver": "1.2.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Service CU Mobile Banking",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 6208,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 12, 2018",
    "Current Ver": "5.9.1.0",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Redwood CU v3.1.0",
    Category: "FINANCE",
    Rating: 3.8,
    Reviews: 480,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 24, 2018",
    "Current Ver": "3.1.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Cyprus CU Mobile Banking",
    Category: "FINANCE",
    Rating: 3.4,
    Reviews: 295,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 13, 2018",
    "Current Ver": "5.3.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "BayPort CU Mobile Banking",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 2374,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 31, 2018",
    "Current Ver": "5.10.1.0",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "CU SoCal Mobile Banking",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 253,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 2, 2018",
    "Current Ver": "4.6.68",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Tropical Financial CU",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 1231,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 12, 2018",
    "Current Ver": "5.9.1.0",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Travis CU",
    Category: "FINANCE",
    Rating: 2,
    Reviews: 207,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 16, 2018",
    "Current Ver": "1.0.0.9",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Commonwealth CU Go Mobile",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 231,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "September 15, 2017",
    "Current Ver": "4.4.47",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Public Service CU Mobile",
    Category: "FINANCE",
    Rating: 2,
    Reviews: 314,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 14, 2017",
    "Current Ver": "6.5.32-prod",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Freedom CU",
    Category: "FINANCE",
    Rating: 3.6,
    Reviews: 117,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 22, 2018",
    "Current Ver": "6.5.82-prod",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Meritrust CU Mobile Banking",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 3661,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 12, 2018",
    "Current Ver": "5.9.1.0",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "Nusenda CU– Mobile Banking",
    Category: "FINANCE",
    Rating: 3.5,
    Reviews: 805,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 17, 2018",
    "Current Ver": "5.4.5",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "Lake Michigan CU Mobile",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 732,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 2, 2018",
    "Current Ver": "3.0.21",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Maps CU",
    Category: "FINANCE",
    Rating: 3.5,
    Reviews: 256,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "November 2, 2017",
    "Current Ver": 200,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Family Savings CU Mobile",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 323,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "September 8, 2017",
    "Current Ver": "4.4.47",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FORUM Credit Union CU Online",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 196,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 30, 2018",
    "Current Ver": "5.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Educators CU Mobile Banking",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 1992,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 20, 2018",
    "Current Ver": "3000.5.3532",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "Space Coast CU Mobile",
    Category: "FINANCE",
    Rating: 3.8,
    Reviews: 922,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 13, 2017",
    "Current Ver": "2.1.0.1108",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "First Tech Federal CU",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 4290,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 19, 2018",
    "Current Ver": "3000.5.3548",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "Southland CU",
    Category: "FINANCE",
    Rating: 3.8,
    Reviews: 109,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 20, 2017",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Tech CU Card Manager",
    Category: "FINANCE",
    Rating: 1,
    Reviews: 2,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 25, 2017",
    "Current Ver": "1.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Numerica CU",
    Category: "FINANCE",
    Rating: 3.8,
    Reviews: 472,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 21, 2018",
    "Current Ver": "5.0.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Red River CU",
    Category: "FINANCE",
    Rating: 3.3,
    Reviews: 343,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 21, 2017",
    "Current Ver": 2.79,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Firefighters First CU",
    Category: "FINANCE",
    Rating: 4.8,
    Reviews: 495,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 1, 2018",
    "Current Ver": "5.7.1.0",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "MYCU TX Mobile Banking",
    Category: "FINANCE",
    Rating: 3,
    Reviews: 4,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.0.2",
    numInstall: 100,
    numAndroid: null,
  },
  {
    App: "Amazing Fart Sounds",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 28136,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "August 24, 2017",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Navigator PRO - GPS Navigation with Offline Maps",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.6,
    Reviews: 892,
    Size: "70M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 1, 2018",
    "Current Ver": 1.08,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "My Vodafone (GR)",
    Category: "COMMUNICATION",
    Rating: 3.8,
    Reviews: 12667,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.5.5.1-2090AL-REL",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "HTC Transfer Tool",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 40907,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 27, 2017",
    "Current Ver": "6.0.932740",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Planet of Cubes Survival Craft",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 475944,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 26, 2018",
    "Current Ver": "4.5.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Moto Rider",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 115176,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Racing",
    "Last Updated": "June 15, 2018",
    "Current Ver": "1.2.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Shadow Fight 2",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 10981850,
    Size: "88M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "July 2, 2018",
    "Current Ver": "1.9.38",
    numInstall: 100000000,
    numAndroid: 3,
  },
  {
    App: "Crazy Wheels",
    Category: "GAME",
    Rating: 4,
    Reviews: 121082,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "January 17, 2018",
    "Current Ver": "1.0.7",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Curriculum vitae App CV Builder Free Resume Maker",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 4571,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 8, 2018",
    "Current Ver": 3.3,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Free Resume App",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 15830,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "CV Engineer - Free Resume Maker & CV Templates",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 213,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 11, 2018",
    "Current Ver": "3.5.3",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "CV Examples 2018",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 625,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 30, 2018",
    "Current Ver": 4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Curriculum Vitae",
    Category: "BUSINESS",
    Rating: 3.7,
    Reviews: 3757,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 29, 2016",
    "Current Ver": 2.8,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Free resume builder CV maker templates PDF formats",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 9555,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 19, 2018",
    "Current Ver": 7.7,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Resume Builder - Free CV Maker & Premium Templates",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 770,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1.9,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Easy Cv maker 2018",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.9,
    Reviews: 88,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "March 31, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Resume PDF Maker / CV Builder",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 2147,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "December 14, 2017",
    "Current Ver": 1.8,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Resume & CV Creator by Desygner",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 48,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.11.1",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "CV S ( CV Editor - Resume )",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 3972,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Business",
    "Last Updated": "June 25, 2018",
    "Current Ver": "5.1.14",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CV Formats 2018",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 374,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 9, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CV Maker Pro",
    Category: "BUSINESS",
    Rating: 3.7,
    Reviews: 113,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 9, 2018",
    "Current Ver": "3.4.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Free CV Creator",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 37,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 18, 2018",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Job CV Maker-Portfolio Maker , Resume Maker",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 139,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 16, 2018",
    "Current Ver": 2.1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Resume Builder and CV maker app",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 2303,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 2, 2018",
    "Current Ver": "8.9.2.pro",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "HOW TO WRITE A CV",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 489,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 27, 2018",
    "Current Ver": 14,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CV EXAMPLES",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 423,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 7, 2018",
    "Current Ver": 11,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Cv maker / Job cv maker",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 14,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 27, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Resume Builder Free, CV Maker & Resume Templates",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 20921,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 11, 2018",
    "Current Ver": "4.0.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Free Professional Resume Builder, CV, Cover Letter",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 831,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 13, 2018",
    "Current Ver": "1.3.2.9",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Resume Free",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 27820,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 29, 2018",
    "Current Ver": 2.1,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "How to Write CV",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 244,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "April 22, 2016",
    "Current Ver": "1.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Super Resume Builder Pro, CV",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 244,
    Size: "6.9M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 17, 2017",
    "Current Ver": 4.38,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Free Resume Builder – CV Maker",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 25,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 9, 2018",
    "Current Ver": 1.5,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Resume App",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 11310,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "CV Builder",
    Category: "BUSINESS",
    Rating: 3.8,
    Reviews: 203,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "September 30, 2016",
    "Current Ver": "2.2.1.0",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Curriculum Vitae - Resume CV",
    Category: "PRODUCTIVITY",
    Rating: 2.6,
    Reviews: 80,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 11, 2017",
    "Current Ver": "2.129.12",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Resume Maker:Free CV Maker,Templates Builder",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 715,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 1, 2018",
    "Current Ver": 1.8,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Resume Builder / CV Maker & Templates",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 25,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 19, 2018",
    "Current Ver": "1.0.3",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "CV maker for Job Applications and Resume Maker",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 75,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 31, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CV Templates 2018",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 13,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 9, 2017",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Job CV Maker & Portfolio Maker",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 593,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 1, 2018",
    "Current Ver": "1.0.2",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "CV Maker for Job Applications:Photo Resume Builder",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 114,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 9, 2018",
    "Current Ver": 1.5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CV Creator",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 31,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 8, 2018",
    "Current Ver": "1.2.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Resume ( CV Editor )",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 416,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 30, 2018",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CV Maker",
    Category: "PERSONALIZATION",
    Rating: 3.2,
    Reviews: 114,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 18, 2016",
    "Current Ver": 1.02,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Resume Maker - Creator",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 740,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.1.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "CV Builder for Smart Resumes",
    Category: "BUSINESS",
    Rating: 3.4,
    Reviews: 22,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 23, 2017",
    "Current Ver": 1.9,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CV-RECORD Pro",
    Category: "COMMUNICATION",
    Rating: 2.3,
    Reviews: 42,
    Size: "6.0M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 12, 2017",
    "Current Ver": "1.0.5",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CV-Library Job Search",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 6997,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 6, 2018",
    "Current Ver": "6.8.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CV Samples 2018",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 34,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 10, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CV (Curriculum Vitae / Resume) Maker",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 4,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "December 27, 2017",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Easy Resume Builder, Resume help, Curriculum vitae",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 996,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 28, 2017",
    "Current Ver": 2.3,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Resume / CV",
    Category: "BUSINESS",
    Rating: 3.6,
    Reviews: 125,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "December 28, 2015",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "VisualCV Resume Builder",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 2555,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 2, 2017",
    "Current Ver": "2.5.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Resume Maker / CV creator & Templates",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 54,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 15, 2018",
    "Current Ver": "1.0.6",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Resume Builder - Curriculum Vitae & Resume Maker",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 12,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 7, 2018",
    "Current Ver": 1.9,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "The CW",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 288209,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 23, 2018",
    "Current Ver": 2.17,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "CW Seed",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 16391,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 18, 2018",
    "Current Ver": 1.16,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "The CW TV app",
    Category: "FAMILY",
    Rating: 3.2,
    Reviews: 24,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 28, 2018",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "CW TV",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 1.7,
    Reviews: 367,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "March 2, 2018",
    "Current Ver": 1.7,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "The CW TN app 2018",
    Category: "FAMILY",
    Rating: 2.2,
    Reviews: 54,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 30, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "Archie Comics",
    Category: "COMICS",
    Rating: 3.8,
    Reviews: 5084,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "June 19, 2018",
    "Current Ver": "2.2.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "2 Amateur ham radio CW Morse code practice keys TX",
    Category: "COMMUNICATION",
    Rating: 4.8,
    Reviews: 6,
    Size: "3.5M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "March 5, 2018",
    "Current Ver": "1.0.9",
    numInstall: 100,
    numAndroid: 1,
  },
  {
    App: "All Star Of CW",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "February 6, 2018",
    "Current Ver": 2.03,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Cartoon Wars: Blade",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 165656,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "February 7, 2018",
    "Current Ver": "1.1.0",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "FANDOM: Arrow and The Flash",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 3935,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "June 7, 2018",
    "Current Ver": "2.9.8",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CW Beacon for Ham Radio",
    Category: "COMMUNICATION",
    Rating: 4.8,
    Reviews: 10,
    Size: "516k",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 22, 2015",
    "Current Ver": "KM",
    numInstall: 100,
    numAndroid: 1,
  },
  {
    App: "IZ2UUF Morse Koch CW",
    Category: "COMMUNICATION",
    Rating: 4.6,
    Reviews: 649,
    Size: "837k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 8, 2013",
    "Current Ver": "1.0.013",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Morse Decoder for Ham Radio",
    Category: "COMMUNICATION",
    Rating: 3.7,
    Reviews: 166,
    Size: "2.0M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "March 14, 2017",
    "Current Ver": 1.52,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "C W Browser",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 14,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "October 28, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Canon CameraWindow",
    Category: "PHOTOGRAPHY",
    Rating: 3.5,
    Reviews: 12204,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 14, 2017",
    "Current Ver": "1.5.2.21",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Saiyan Of CW",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 5,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.0.10",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CW Studio ®",
    Category: "COMMUNICATION",
    Rating: 3.8,
    Reviews: 9,
    Size: "780k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 19, 2015",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "20WPM Amateur ham radio Koch CW Morse code trainer",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 12,
    Size: "3.7M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 22, 2018",
    "Current Ver": "3.0.4",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "CW Bluetooth SPP",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 3,
    Size: "961k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "March 31, 2018",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 6,
  },
  {
    App: "Morse Trainer for Ham Radio",
    Category: "COMMUNICATION",
    Rating: 4.6,
    Reviews: 265,
    Size: "2.6M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 6, 2018",
    "Current Ver": 2.28,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Free CW TN Videos 2018",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 28, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 3,
  },
  {
    App: "The Church at CW",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 2,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "June 25, 2018",
    "Current Ver": "3.8.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CW Mobile",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 25, 2018",
    "Current Ver": "3.3.99",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Freeform – Stream Full Episodes, Movies, & Live TV",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 29229,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "CW BLE Peripheral Simulator",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 2,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "March 8, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Morse Machine for Ham Radio",
    Category: "COMMUNICATION",
    Rating: 4.8,
    Reviews: 341,
    Size: "9.6M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "February 20, 2015",
    "Current Ver": "iu4",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Pocket RxTx Pro",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 253,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000,
    numAndroid: null,
  },
  {
    App: "Morse Player",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 12,
    Size: "2.4M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 23, 2017",
    "Current Ver": "2.1.1",
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "FXNOW: Movies, Shows & Live TV",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 31552,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "My CW",
    Category: "TOOLS",
    Rating: 3,
    Reviews: 1,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 27, 2016",
    "Current Ver": "2.35.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CW Ringtone (Morse Code generator)",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "269k",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "March 16, 2018",
    "Current Ver": "1.0.2",
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "30WPM Amateur ham radio Koch CW Morse code trainer",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 1,
    Size: "3.7M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 18, 2018",
    "Current Ver": "2.0.2",
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "Learn CW",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "21M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 6, 2018",
    "Current Ver": 1.1,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "DC All Access",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 12639,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "October 17, 2017",
    "Current Ver": 3.5,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Koch Morse Trainer Pro",
    Category: "COMMUNICATION",
    Rating: 4.6,
    Reviews: 94,
    Size: "1.1M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "February 14, 2015",
    "Current Ver": "2.1.1",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Morse Code Reader",
    Category: "COMMUNICATION",
    Rating: 3.9,
    Reviews: 1436,
    Size: "20k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 26, 2013",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 1,
  },
  {
    App: "CW Nuclear",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.3,
    Reviews: 15,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "November 17, 2017",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Pocket RxTx Free",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 4513,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "CW Deposit",
    Category: "BUSINESS",
    Rating: 3,
    Reviews: 4,
    Size: "498k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 6, 2014",
    "Current Ver": "2.1.5",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Hallmark Channel Everywhere",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 6784,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 30, 2017",
    "Current Ver": "2.3.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Morse Player Free",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 268,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 23, 2017",
    "Current Ver": "2.1.1",
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "News 8 San Diego",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.2,
    Reviews: 1137,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 23, 2018",
    "Current Ver": "5.5.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Hulu: Stream TV, Movies & more",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 319777,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Learn Morse Code - G0HYN Learn Morse",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 27,
    Size: "600k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 8, 2018",
    "Current Ver": 5,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "SYFY",
    Category: "FAMILY",
    Rating: 3.2,
    Reviews: 3069,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "May 24, 2018",
    "Current Ver": "3.3.1.41",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Morse Notifier Free",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 79,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 8, 2017",
    "Current Ver": "2.9.9",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "AMC",
    Category: "FAMILY",
    Rating: 3.2,
    Reviews: 20843,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.3.85 (2)",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Cartoon Wars 3",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 137674,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 4, 2018",
    "Current Ver": "2.0.2",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "ABC – Live TV & Full Episodes",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 50428,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Oracle CX Cloud Mobile",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 48,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 7, 2018",
    "Current Ver": "11.13.18.05.07.03",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "CX-10WiFi",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 1419,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "October 25, 2017",
    "Current Ver": "2.5_16",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CX-OF",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 18,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 31, 2018",
    "Current Ver": "7.2.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "cx-32wifi",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 62,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 14, 2015",
    "Current Ver": 1.4,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "CX-17WIFI",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 49,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 21, 2018",
    "Current Ver": 2.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Cathay Pacific",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.3,
    Reviews: 4069,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 25, 2018",
    "Current Ver": "6.6.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Cx File Explorer",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 175,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 28, 2018",
    "Current Ver": "1.0.7",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "cx-33wifi",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 63,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 14, 2015",
    "Current Ver": 1.4,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "CX-WiFi720P",
    Category: "FAMILY",
    Rating: 3.1,
    Reviews: 47,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 14, 2015",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "CX-60",
    Category: "FAMILY",
    Rating: 3.1,
    Reviews: 19,
    Size: "94M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 9, 2017",
    "Current Ver": 1.6,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "ACTIVEON CX & CX GOLD",
    Category: "VIDEO_PLAYERS",
    Rating: 3.3,
    Reviews: 439,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "March 4, 2016",
    "Current Ver": "0.7.9",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "CX North America",
    Category: "BUSINESS",
    Rating: 3.9,
    Reviews: 10,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 14, 2018",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CX-10DS",
    Category: "FAMILY",
    Rating: 3.4,
    Reviews: 12,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "September 15, 2017",
    "Current Ver": "1.5_6",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CX-37",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 13,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 30, 2016",
    "Current Ver": "1.3_4",
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Avaya CX",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 21,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 25, 2018",
    "Current Ver": "v6.7.14",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "TI-Nspire CX Calculator Manual",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 11,
    Size: "27M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 21, 2018",
    "Current Ver": "1.3.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CX_WiFiUFO",
    Category: "SPORTS",
    Rating: 3.7,
    Reviews: 818,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 8, 2016",
    "Current Ver": "4.4_23",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CX watcher",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 4,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "June 21, 2018",
    "Current Ver": "1.5_6",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Theme For Techno Camon CX",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 42,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 10, 2017",
    "Current Ver": "1.0.",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "CX-95WIFI",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 6,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 2, 2017",
    "Current Ver": 2.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Theme for Tecno Camon CX / C8",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 147,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 2, 2017",
    "Current Ver": "1.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CX Carrier Lite",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "68M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 11, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Oración CX",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 103,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 12, 2017",
    "Current Ver": "5.1.10",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "CX-40",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 2,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 14, 2017",
    "Current Ver": 3,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Cx Wize",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 3,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 30, 2018",
    "Current Ver": "2.1.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ring",
    Category: "COMMUNICATION",
    Rating: 3.9,
    Reviews: 517,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 6, 2018",
    "Current Ver": 20180805,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Racing CX",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 4,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "June 6, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "cx advance call blocker",
    Category: "PERSONALIZATION",
    Rating: 5,
    Reviews: 3,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 9, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CX Ram Booster",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 12,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 2, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "CX-42",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "January 2, 2018",
    "Current Ver": "1.2_3",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CX Capture",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 23, 2018",
    "Current Ver": "v1.2.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CONNECT: The Mobile CX Summit",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Productivity",
    "Last Updated": "August 1, 2018",
    "Current Ver": "7.18.0.0",
    numInstall: 50,
    numAndroid: 5,
  },
  {
    App: "Hyundai CX Conference",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 27, 2018",
    "Current Ver": "2.10.2",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CX-41",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 1,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 14, 2017",
    "Current Ver": 3,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CX Monthly Tech News",
    Category: "VIDEO_PLAYERS",
    Rating: "NaN",
    Reviews: 2,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "June 9, 2016",
    "Current Ver": "6.1.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CXmodel-ufo",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 19,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 19, 2017",
    "Current Ver": 2.1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "CX Summit",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 1,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Productivity",
    "Last Updated": "September 20, 2017",
    "Current Ver": "7.12.0.1",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Secret Codes For Android",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 6060,
    Size: "592k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 4, 2016",
    "Current Ver": 2,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Absolute RC Heli Simulator",
    Category: "SPORTS",
    Rating: 3.9,
    Reviews: 654,
    Size: "50M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "December 20, 2017",
    "Current Ver": 3.29,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "WiFi FPV",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 316,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 1, 2017",
    "Current Ver": 1.8,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "CX Elevated",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 1, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "go41cx",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 171,
    Size: "1.0M",
    Type: "Paid",
    Price: "$10.00",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 18, 2016",
    "Current Ver": "1.7.0",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "FlexRelease CX",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 4,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 25, 2016",
    "Current Ver": "1.5.0",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Ambient CX",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 9, 2017",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 2,
  },
  {
    App: "QuestionPro - CX",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1.3,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "CX Network",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 6, 2018",
    "Current Ver": "1.3.1",
    numInstall: 0,
    numAndroid: 4,
  },
  {
    App: "Cymera Camera- Photo Editor, Filter,Collage,Layout",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 2418165,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "CY Security Antivirus Cleaner",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 75140,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Freecell CY",
    Category: "GAME",
    Rating: 4,
    Reviews: 387,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "April 16, 2011",
    "Current Ver": "1.3.3",
    numInstall: 50000,
    numAndroid: 1,
  },
  {
    App: "Cytus II",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 16851,
    Size: "81M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone 10+",
    Genres: "Music",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.5.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Cy-Reader",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 17,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1.7,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Cy-Fair FCU Mobile Banking",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 439,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "January 30, 2018",
    "Current Ver": "5.7.1.0",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "Cytus",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 541732,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music",
    "Last Updated": "February 9, 2018",
    "Current Ver": "10.0.10",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Cy-Ranch",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 27,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 6, 2018",
    "Current Ver": "7.5.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Recycling Cy",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 47,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 2, 2017",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "CY Konum",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 27, 2018",
    "Current Ver": 3,
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "CY.SEND Online Top Up",
    Category: "FINANCE",
    Rating: 3.2,
    Reviews: 191,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "January 25, 2018",
    "Current Ver": "4.5.6",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "ABTO CY-ET1",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 6, 2017",
    "Current Ver": "2.0.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "CY:ME - real time gps tracker",
    Category: "MAPS_AND_NAVIGATION",
    Rating: "NaN",
    Reviews: 8,
    Size: "749k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "September 28, 2013",
    "Current Ver": 1.08,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Alpha Bank CY",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 39,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 20, 2018",
    "Current Ver": 1.11,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Cy Messenger",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 4,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 30, 2014",
    "Current Ver": "1.3.0",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Amadeus GR & CY",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 4,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "February 1, 2018",
    "Current Ver": 2.07,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Igitabo cy'Indirimbo",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 93,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 5, 2018",
    "Current Ver": "INDIRIMBO V.2014.002",
    numInstall: 50000,
    numAndroid: 1,
  },
  {
    App: "Doctor Finder CY",
    Category: "MEDICAL",
    Rating: 4.9,
    Reviews: 57,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "November 11, 2015",
    "Current Ver": 1.7,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Eshopcy.com.cy",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 182,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1.3,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "NOMISMA.com.cy by FMW",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 5,
    Reviews: 3,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 29, 2016",
    "Current Ver": 700,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Cy-Fair VFD EMS Protocols",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 2,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Medical",
    "Last Updated": "September 21, 2017",
    "Current Ver": "1.8.3",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EUROBANK CY",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 30,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 12, 2018",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Cy-Fair Christian Church",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 2,
    Size: "9.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 3, 2017",
    "Current Ver": "24.8.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Mediabox CY",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 31, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Capitalnews.com.cy",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "March 23, 2017",
    "Current Ver": "0.0.2",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Shadowverse CCG",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 47340,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "July 30, 2018",
    "Current Ver": "2.2.15",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CY Digital Net",
    Category: "SHOPPING",
    Rating: 4.7,
    Reviews: 3,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 1, 2017",
    "Current Ver": "2.0.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Cy-Fair Houston Chamber",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 6, 2018",
    "Current Ver": "4.1.239",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "StudentLife.com.cy",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 17,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "March 14, 2017",
    "Current Ver": "1.0.11",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Phone Clean Best Speed Booster",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 81502,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "VAT check CY",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "642k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 18, 2013",
    "Current Ver": "1.0.16",
    numInstall: 100,
    numAndroid: 1,
  },
  {
    App: "Cy's Elma Pharmacy",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Health & Fitness",
    "Last Updated": "June 28, 2018",
    "Current Ver": "7.4.8",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "CY Spray nozzle",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 3, 2017",
    "Current Ver": "1.01.00",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "LOCX Applock Lock Apps & Photo",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 208543,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Cymath - Math Problem Solver",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 10159,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 13, 2018",
    "Current Ver": 2.17,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Rewards",
    Category: "FINANCE",
    Rating: 3.8,
    Reviews: 57,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "December 15, 2017",
    "Current Ver": 4.1,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Army of Heroes",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 85015,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.03.06",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BibleRead En Cy Zh Yue",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 17, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Math Solver",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 2250,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 21, 2017",
    "Current Ver": 1.2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "SuperBikers 2",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 6200,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Racing",
    "Last Updated": "July 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Cyprus Bus Companion",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.9,
    Reviews: 112,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "December 26, 2013",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Cyprus Police",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 226,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Social",
    "Last Updated": "January 31, 2018",
    "Current Ver": "1.122.250.1421",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "foody Cyprus - online ordering",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 214,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "February 27, 2018",
    "Current Ver": 2.92,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Death Dragon Knights RPG",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 11179,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "September 16, 2016",
    "Current Ver": 2.7,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Camera360 Lite - Selfie Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 221878,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Bank Of Cyprus",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 1514,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 14, 2018",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Map of Cyprus offline",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.6,
    Reviews: 470,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "March 12, 2018",
    "Current Ver": 3.9,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "McDelivery Cyprus",
    Category: "FOOD_AND_DRINK",
    Rating: 3.3,
    Reviews: 60,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "May 14, 2018",
    "Current Ver": "3.1.46 (CY02)",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CZ-USA",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 11,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 1, 2016",
    "Current Ver": "1.0.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CZ File Manager",
    Category: "TOOLS",
    Rating: 2.2,
    Reviews: 876,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 6, 2018",
    "Current Ver": "3.2.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Security Camera CZ",
    Category: "HOUSE_AND_HOME",
    Rating: 4.4,
    Reviews: 137,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.1.10",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Šmelina .cz inzeráty inzerce",
    Category: "SHOPPING",
    Rating: 3.9,
    Reviews: 117,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "May 13, 2018",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Alzashop.com",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 32014,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "KFC CZ",
    Category: "LIFESTYLE",
    Rating: 2.8,
    Reviews: 1189,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 27, 2018",
    "Current Ver": "5.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Skylink Live TV CZ",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 2802,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 11, 2018",
    "Current Ver": 5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CZ-70 (CZ-50) pistol explained",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 2,
    Size: "17M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "November 2, 2016",
    "Current Ver": "Android 2.1 - 2015",
    numInstall: 10,
    numAndroid: 1,
  },
  {
    App: "Mapy.cz - Cycling & Hiking offline maps",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.5,
    Reviews: 56409,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "June 26, 2018",
    "Current Ver": "6.2.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "CZ-52 pistol explained",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "9.3M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "September 3, 2015",
    "Current Ver": "Android 3.0 - 2015",
    numInstall: 10,
    numAndroid: 1,
  },
  {
    App: "CZ-27 pistol explained",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "11M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "September 2, 2015",
    "Current Ver": "Android 3.0 - 2015",
    numInstall: 10,
    numAndroid: 1,
  },
  {
    App: "Online TV CZ/SK PRO",
    Category: "VIDEO_PLAYERS",
    Rating: 3.1,
    Reviews: 167,
    Size: "2.0M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "June 21, 2018",
    "Current Ver": "3.3.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Rande.cz",
    Category: "SOCIAL",
    Rating: 3.2,
    Reviews: 398,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "December 3, 2014",
    "Current Ver": "1.0.1",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Breweries (CZ/SK)",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 1740,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "July 27, 2017",
    "Current Ver": "3.1.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "reality.cz",
    Category: "HOUSE_AND_HOME",
    Rating: 4.1,
    Reviews: 1372,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "February 15, 2018",
    "Current Ver": "2.9.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "CZ-45 pistol explained",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "12M",
    Type: "Paid",
    Price: "$5.49",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 10, 2017",
    "Current Ver": "Android 3.1 - 2015",
    numInstall: 10,
    numAndroid: 1,
  },
  {
    App: "CZ-Help",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 5,
    Reviews: 2,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 13, 2018",
    "Current Ver": 0.1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Hlášenírozhlasu.cz",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 27, 2018",
    "Current Ver": "2.1.3",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "signály.cz",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 38,
    Size: "881k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "May 9, 2013",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "CZ-Cyberon Voice Commander",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 131,
    Size: "3.3M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 7, 2017",
    "Current Ver": "3.2.17030601",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Pistolet CZ-70 CZ-50 expliqué",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "17M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "November 1, 2016",
    "Current Ver": "Android 2.0 - 2016",
    numInstall: 1,
    numAndroid: 1,
  },
  {
    App: "CZ-38 (vz 38) pistol explained",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "13M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 10, 2017",
    "Current Ver": "Android 3.1 - 2017",
    numInstall: 5,
    numAndroid: 1,
  },
  {
    App: "HTC Sense Input - CZ",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 87,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 9, 2015",
    "Current Ver": "1.0.612933",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "WebCams",
    Category: "WEATHER",
    Rating: 4.6,
    Reviews: 3963,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 17, 2018",
    "Current Ver": "5.2.11",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Wallpapers CZ 75 85",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "April 12, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "SMS Sender - sluzba.cz",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 12,
    Size: "72k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 1, 2012",
    "Current Ver": "2.00.00",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Novinky.cz",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.7,
    Reviews: 2375,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "February 23, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Wallpaper.cz",
    Category: "PHOTOGRAPHY",
    Rating: 4.9,
    Reviews: 7,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 11, 2015",
    "Current Ver": "1.2.0",
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "Strava.cz",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 2221,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "CZ Kompas",
    Category: "TOOLS",
    Rating: 5,
    Reviews: 2,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 9, 2018",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Modlitební knížka CZ",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 4,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "February 4, 2018",
    "Current Ver": 4,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Reksio cz. 1",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.6M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "March 30, 2015",
    "Current Ver": "1.0.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "MYTO CZ",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 2.9,
    Reviews: 30,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "February 17, 2016",
    "Current Ver": 1.2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "PLAYzone.cz",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 14,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 7, 2017",
    "Current Ver": "2.1.3",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Tools & Mi Band",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 15753,
    Size: "13M",
    Type: "Paid",
    Price: "$3.49",
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 26, 2018",
    "Current Ver": "3.7.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "RoutePlan.cz",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 6,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 6, 2018",
    "Current Ver": "2.5.4",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "TeeTime.cz",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 1641,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.18.34",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "What is my IP address",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 4228,
    Size: "656k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 2, 2018",
    "Current Ver": 2.95,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Windguru Lite",
    Category: "WEATHER",
    Rating: 4,
    Reviews: 9307,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "January 9, 2018",
    "Current Ver": "2.0.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Vira.cz Widget",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 86,
    Size: "601k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 15, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Da Fit",
    Category: "SPORTS",
    Rating: 3.5,
    Reviews: 1151,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 23, 2018",
    "Current Ver": "v1.0.0-195-gb96d9f2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "The House of Da Vinci",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 12400,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "June 14, 2018",
    "Current Ver": "1.0.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dan the Man: Action Platformer",
    Category: "GAME",
    Rating: 4.8,
    Reviews: 528550,
    Size: "73M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.2.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Ghost Detector",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 35337,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.7.28",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Face Filter, Selfie Editor - Sweet Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.7,
    Reviews: 142758,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 6, 2018",
    "Current Ver": "1.5.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Master for Minecraft(Pocket Edition)-Mod Launcher",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 2674051,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 6, 2018",
    "Current Ver": "2.1.69",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "King of Math",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 766,
    Size: "14M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.0.11",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Translate: text & voice translator",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 122010,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 14, 2018",
    "Current Ver": "Translator 10.9.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "The Zueira's Voice",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 136540,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 10, 2018",
    "Current Ver": 4.75,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Battery Calibration",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 134412,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 27, 2018",
    "Current Ver": "3.0.5",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "FVD - Free Video Downloader",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 327914,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Thuglife Video Maker",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 38824,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "January 21, 2018",
    "Current Ver": "2.4.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "MadLipz",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 171017,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 22, 2018",
    "Current Ver": "2.2.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Soccer FC",
    Category: "SPORTS",
    Rating: 3.9,
    Reviews: 6289,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 21, 2016",
    "Current Ver": 1.2,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Visage Lab – face retouch",
    Category: "PHOTOGRAPHY",
    Rating: 3.5,
    Reviews: 49523,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "October 5, 2016",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Geometry Dash SubZero",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 260527,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "December 21, 2017",
    "Current Ver": 1,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Escaping the Prison",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 419375,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Casual",
    "Last Updated": "June 21, 2016",
    "Current Ver": "1.2.2",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Metal Soldiers 2",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 153649,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 18, 2018",
    "Current Ver": "1.11.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Quiz TRUE or FALSE",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 2464,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "February 13, 2018",
    "Current Ver": 1.1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Glam Doll Salon - Chic Fashion",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 93898,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 26, 2017",
    "Current Ver": 1.1,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Siren Ringtones",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 42190,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "July 8, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Peppa Pig: Party Time",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 52,
    Size: "55M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "August 8, 2017",
    "Current Ver": "1.2.1",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Download Manager for Android",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 420518,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "COOKING MAMA Let's Cook!",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 528917,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.38.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Run Sausage Run!",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 276105,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Knife Hit",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 462614,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.7.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "The Visitor",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 39895,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Adventure",
    "Last Updated": "January 2, 2018",
    "Current Ver": "1.2.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Just Dance Now",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 794058,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music",
    "Last Updated": "June 12, 2018",
    "Current Ver": "2.3.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DB Navigator",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4,
    Reviews: 119685,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 2, 2018",
    "Current Ver": "18.06.p03.02",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "SQLite DB Reader",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 301,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 28, 2017",
    "Current Ver": "1.2.9",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "DB Browser",
    Category: "TOOLS",
    Rating: 3.3,
    Reviews: 236,
    Size: "221k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 20, 2011",
    "Current Ver": 1.6,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Sound Meter",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 88993,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 10, 2018",
    "Current Ver": "3.2.6",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "DRAGON BALL LEGENDS",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 338742,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.11.0",
    numInstall: 5000000,
    numAndroid: 6,
  },
  {
    App: "db.Mobil App",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.5,
    Reviews: 23,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "July 11, 2018",
    "Current Ver": "3.4.5",
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "DB Streckenagent",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.9,
    Reviews: 4569,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "December 22, 2017",
    "Current Ver": "2.1.10 (49)",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "dB: Sound Meter Pro",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 31,
    Size: "228k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 12, 2016",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Movie DB",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 10,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "December 10, 2016",
    "Current Ver": "1.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "dB Sound Level Meter",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 203,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 3, 2017",
    "Current Ver": 1.08,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "DB Sound Meter: Measure Noise Level- Decibel Meter",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 824,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 13, 2017",
    "Current Ver": "1.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DB Welt - Die Zeitung der DB",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 145,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "February 26, 2016",
    "Current Ver": "3.1.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Check DB Benchmark",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 11, 2017",
    "Current Ver": "0.9.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "ACCDB MDB DB Manager Pro - Editor for MS Access",
    Category: "PRODUCTIVITY",
    Rating: 3.1,
    Reviews: 19,
    Size: "4.5M",
    Type: "Paid",
    Price: "$8.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 3, 2016",
    "Current Ver": "1.0.8",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Scale Models DB",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 9,
    Size: "33M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 3, 2018",
    "Current Ver": "0.6.2",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "DB Train Simulator",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 6514,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "May 23, 2018",
    "Current Ver": "1.6.2",
    numInstall: 500000,
    numAndroid: 3,
  },
  {
    App: "DB Tools",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 37,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 17, 2014",
    "Current Ver": 1.9,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "dB Meter - measure sound & noise level in Decibel",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 154,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DB LINK RGB",
    Category: "TOOLS",
    Rating: 2.7,
    Reviews: 7,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 19, 2017",
    "Current Ver": "1.0.2",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "DB BAHN",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 4,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "December 19, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "DB Manager",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 3,
    Size: "108k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 21, 2014",
    "Current Ver": "2.0.0",
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "10,000 Quotes DB (Premium)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.1,
    Reviews: 70,
    Size: "3.5M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 30, 2013",
    "Current Ver": 1.3,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Guide for DB Xenoverse",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.2,
    Reviews: 459,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "October 1, 2016",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DB Transport",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 1.9,
    Reviews: 179,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "March 13, 2018",
    "Current Ver": 3.05,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DB Stay Connected",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 17,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "December 8, 2017",
    "Current Ver": 1.4,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DB FahrtProfi",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 4, 2017",
    "Current Ver": "1.0.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DB TOS - Pocket Helper",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 265,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 22, 2016",
    "Current Ver": 1.7,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "ReDNAKET DB Normalization Tool",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "940k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 3, 2016",
    "Current Ver": "1.0.2",
    numInstall: 10,
    numAndroid: 5,
  },
  {
    App: "Guide for DB Xenoverse 2",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 121,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "December 23, 2016",
    "Current Ver": "1.1.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DB Customer Connect",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 100,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 21, 2018",
    "Current Ver": "2.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Patron DB",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 64,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 1, 2017",
    "Current Ver": 1.24,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DB Event App",
    Category: "SOCIAL",
    Rating: 2.4,
    Reviews: 37,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "June 25, 2017",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DB HOME",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 5,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 31, 2017",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Bowers & Wilkins DB Subwoofers",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 21,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 19, 2018",
    "Current Ver": "1.2.0.27",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Guide for IMS DB",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 11, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DB Busradar NRW",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.7,
    Reviews: 78,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "April 12, 2017",
    "Current Ver": "1.0.2",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "DB Pickles",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 5,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 20, 2018",
    "Current Ver": "2.0.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DB for Fallout Shelter",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 3323,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "March 29, 2018",
    "Current Ver": 1.9,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "LC-DB",
    Category: "PHOTOGRAPHY",
    Rating: 3,
    Reviews: 1,
    Size: "2.5M",
    Type: "Paid",
    Price: "$3.49",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "October 20, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "dB Sound Meter",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 29,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 25, 2016",
    "Current Ver": 1.2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DB for Hustle Castle",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 21,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "July 4, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DB Ultra Saiyan Battle",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 33,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.3.7",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Preferences Manager and SQLite DB Viewer",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 13,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 18, 2017",
    "Current Ver": 1.01,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "LC-DB-LITE",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "October 20, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "db Meter - sound level meter with data logging",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "15M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 15, 2018",
    "Current Ver": "1.0.1",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Hamburg Transit - Offline HVV DB times and plans",
    Category: "MAPS_AND_NAVIGATION",
    Rating: "NaN",
    Reviews: 9,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "May 21, 2018",
    "Current Ver": 2.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "SW-DB",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 954,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Tools",
    "Last Updated": "July 11, 2016",
    "Current Ver": "0.4.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DC Legends: Battle for Justice",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 355613,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.21.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DC Comics",
    Category: "COMICS",
    Rating: 4.2,
    Reviews: 25673,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "June 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Injustice 2",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 504765,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 30, 2018",
    "Current Ver": "2.4.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Injustice: Gods Among Us",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 2440877,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 14, 2018",
    "Current Ver": 2.21,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "FANDOM for: DC",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 6715,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.9.8.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "DC Super Hero Girls™",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 43090,
    Size: "95M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action;Action & Adventure",
    "Last Updated": "June 29, 2018",
    "Current Ver": "2.8.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "LEGO Batman: DC Super Heroes",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 2557,
    Size: "5.8M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone 10+",
    Genres: "Adventure;Action & Adventure",
    "Last Updated": "May 9, 2016",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Ultimate DC Challenge",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 937,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "October 19, 2017",
    "Current Ver": "2.14.5e",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "LEGO® DC Mighty Micros",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 139545,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "January 30, 2018",
    "Current Ver": "1.6.1326",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Justice League Action Run",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 22333,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "August 7, 2018",
    "Current Ver": 2.01,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Marvel and DC Wallpapers",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 249,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 7, 2018",
    "Current Ver": 4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DC Comics Amino",
    Category: "SOCIAL",
    Rating: 4.9,
    Reviews: 117,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 13, 2018",
    "Current Ver": "1.8.19106",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Comics",
    Category: "COMICS",
    Rating: 4.1,
    Reviews: 45651,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Comics",
    "Last Updated": "May 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Quiz DC",
    Category: "GAME",
    Rating: 1.4,
    Reviews: 33,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "December 25, 2017",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Batman: Gotham’s Most Wanted!",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 16190,
    Size: "88M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action;Action & Adventure",
    "Last Updated": "April 24, 2018",
    "Current Ver": "2.1.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Superheroes, Marvel, DC, Comics, TV, Movies News",
    Category: "COMICS",
    Rating: 5,
    Reviews: 34,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.0.5",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "MARVEL Contest of Champions",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 2468915,
    Size: "92M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 30, 2018",
    "Current Ver": "19.1.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Choose SuperHero Quize Marvel | DC",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 29, 2018",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "MARVEL Avengers Academy",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 304106,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "August 6, 2018",
    "Current Ver": "2.8.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DC Universe Quiz",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 11,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "May 22, 2018",
    "Current Ver": "3.2.7z",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "DC HSEMA",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.8,
    Reviews: 38,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 18, 2018",
    "Current Ver": 4,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DC Universe Online Map",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 1186,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Unrated",
    Genres: "Tools",
    "Last Updated": "February 27, 2012",
    "Current Ver": 1.3,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "DC Public Library",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.2,
    Reviews: 20,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 8, 2015",
    "Current Ver": "4.6.1",
    numInstall: 1000,
    numAndroid: 1,
  },
  {
    App: "MARVEL Strike Force",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 166312,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.4.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Vote 4 DC",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 46,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 21, 2016",
    "Current Ver": "4.0.6",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Villains vs Superheroes",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 128,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "September 12, 2017",
    "Current Ver": "3.3.3z",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DC Rider",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.6,
    Reviews: 258,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "December 24, 2017",
    "Current Ver": 2.1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Power Rangers: Legacy Wars",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 264755,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 17, 2018",
    "Current Ver": "2.2.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "MARVEL Future Fight",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 2354042,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "July 3, 2018",
    "Current Ver": "4.2.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "DC Metro Transit - Free",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 6895,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 15, 2018",
    "Current Ver": "5.11.3.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "DC N COMPANY ENTERTAINMENT RADIO!",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 22,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "November 2, 2017",
    "Current Ver": 1.4,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Results for DC Lottery",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 160,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 11, 2017",
    "Current Ver": 5.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "FOX 5 DC",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 1440,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "March 29, 2018",
    "Current Ver": "1.3.35.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Pepsi Cards DC",
    Category: "COMICS",
    Rating: "NaN",
    Reviews: 1,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Comics",
    "Last Updated": "June 26, 2018",
    "Current Ver": "0.0.4",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Driver Permit Test Prep DC DMV Driver's License Ed",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 78,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 12, 2017",
    "Current Ver": "2.9.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Robin - DC Movie Collection",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 19, 2017",
    "Current Ver": "1.0.1",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "DC-014",
    Category: "PHOTOGRAPHY",
    Rating: 5,
    Reviews: 3,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 14, 2018",
    "Current Ver": "1.0.3",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "D.C. Driving/Walking Tours",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "32M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 27, 2018",
    "Current Ver": "3.8.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Painting Lulu DC Super Friends",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 7,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "February 9, 2017",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DC Metro",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.4,
    Reviews: 59,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "January 26, 2015",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "DC Trails-Hop On Hop Off Tours",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.1,
    Reviews: 16,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.4.9",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DC Metro Transit",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 339,
    Size: "10M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 13, 2018",
    "Current Ver": "5.11.3",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "AC DC Power Monitor",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 1,
    Size: "1.2M",
    Type: "Paid",
    Price: "$3.04",
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 29, 2016",
    "Current Ver": 1.2,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "McClatchy DC Bureau",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 80,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "June 18, 2018",
    "Current Ver": "6.0.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "AutoScout24 - used car finder",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.4,
    Reviews: 186648,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "August 2, 2018",
    "Current Ver": "9.3.52",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "WEB.DE Mail",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 226541,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "wetter.com - Weather and Radar",
    Category: "WEATHER",
    Rating: 4.2,
    Reviews: 189310,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Your Freedom VPN Client",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 74497,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 19, 2018",
    "Current Ver": "20180518-01",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Dictionary",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 264260,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Bokeh (Background defocus)",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 50109,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Speed Camera Radar",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.1,
    Reviews: 54034,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Maps & Navigation",
    "Last Updated": "May 30, 2018",
    "Current Ver": "2.1.15",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "WDAMAGE: Car Crash Engine",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 47386,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "June 6, 2018",
    "Current Ver": 31,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Babbel – Learn Languages",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 267787,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 30, 2018",
    "Current Ver": "20.7.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Coloring Book for Me & Mandala",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 401211,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "APUS File Manager (Explorer)",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 498894,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.8.9.1004",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Offroad Police Car DE",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 9149,
    Size: "80M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "March 15, 2017",
    "Current Ver": 1.3,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Easy Language Translator",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 191621,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 29, 2018",
    "Current Ver": 1.43,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Word Search multilingual",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 32849,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "September 30, 2015",
    "Current Ver": "2.2.13",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Love Collage - Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 251686,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 28, 2017",
    "Current Ver": "2.3.8.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Heavy Bus Simulator",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 252006,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "March 15, 2018",
    "Current Ver": 1.084,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "CallApp: Caller ID, Blocker & Phone Call Recorder",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 483782,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 29, 2018",
    "Current Ver": 1.286,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Love Fonts for FlipFont",
    Category: "PERSONALIZATION",
    Rating: 3.9,
    Reviews: 28694,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 14, 2018",
    "Current Ver": "1.4.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "LINE Camera - Photo editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 1517395,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Piano Free - Keyboard with Magic Tiles Music Games",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 785622,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Music",
    "Last Updated": "June 29, 2018",
    "Current Ver": "1.35.2",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Racing in Car 2",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 234589,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "November 22, 2016",
    "Current Ver": 1,
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "Escape the Prison Room",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 113183,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "December 15, 2017",
    "Current Ver": 10.6,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Bike Racing 3D",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 951435,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "January 17, 2018",
    "Current Ver": 2.2,
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "Satellite Director",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 45610,
    Size: "176k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 2, 2018",
    "Current Ver": 1.56,
    numInstall: 10000000,
    numAndroid: 1,
  },
  {
    App: "Truck Driver Cargo",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 257531,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Racing",
    "Last Updated": "January 18, 2018",
    "Current Ver": 7,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Anime Love Story Games: ✨Shadowtime✨",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 198480,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 3, 2018",
    "Current Ver": 20,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Checkers",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 375996,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "August 6, 2018",
    "Current Ver": "1.48.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Scratch Logo Quiz. Challenging brain puzzle",
    Category: "GAME",
    Rating: 3.3,
    Reviews: 152102,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Trivia",
    "Last Updated": "June 30, 2018",
    "Current Ver": 4.16,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Myth Defense 2: DF",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 17108,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "June 23, 2016",
    "Current Ver": "1.3.9",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "df",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 4,
    Size: "33k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 12, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 1,
  },
  {
    App: "DF Squid",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 1,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "December 12, 2013",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Google PDF Viewer",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 226453,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 9, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Myth Defense 2: DF Platinum",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 1764,
    Size: "8.3M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "June 22, 2016",
    "Current Ver": "1.3.8",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "DF 司機",
    Category: "MAPS_AND_NAVIGATION",
    Rating: "NaN",
    Reviews: 9,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 6, 2018",
    "Current Ver": "13.0.0",
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "DF@realtime",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 24,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 26, 2017",
    "Current Ver": "6.0.8.2.GM",
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "DF Night Selfies",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 194,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 15, 2018",
    "Current Ver": "1.6.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DF Coaching",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 1,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Digital Falak",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 3408,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 30, 2018",
    "Current Ver": "2.1.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "The Divine Feminine App: the DF App",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 8,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 16, 2016",
    "Current Ver": "0.0.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Guide to Nikon Df",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 1,
    Size: "663k",
    Type: "Paid",
    Price: "$29.99",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 18, 2014",
    "Current Ver": "2.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DF BugMeNot",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 7,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "October 29, 2015",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "DF-CAM",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 2,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 16, 2018",
    "Current Ver": "2.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DF Tracker",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "September 27, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Guia Bike DF",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 29,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 18, 2018",
    "Current Ver": 22,
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "Rádio DF FM",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 24,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 3, 2017",
    "Current Ver": 3,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Noticias DF",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 2,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "May 25, 2015",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "DF Glue Board",
    Category: "PARENTING",
    Rating: 5,
    Reviews: 1,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "January 19, 2018",
    "Current Ver": "Glueboardv.6",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DF-Server Mobile",
    Category: "PRODUCTIVITY",
    Rating: 4.9,
    Reviews: 17,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 7, 2016",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DF-View",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 4, 2016",
    "Current Ver": "1.0.9",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "MexiRoomies - roomies, mexico, df, apt, house room",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 2,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 4, 2018",
    "Current Ver": 1.9,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "DF Wall Plus – Droid Firewall",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 9,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 20, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Diario Financiero",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 30,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 18, 2018",
    "Current Ver": "v1.1.6(201806181)",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Digital FM Brasília DF",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 5,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "September 22, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "DF SmartPlus",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 23, 2018",
    "Current Ver": "1.0.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Red Transporte DF",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.3,
    Reviews: 11100,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "April 28, 2018",
    "Current Ver": "2.10.0 Summer",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "ElejaOnline DF",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 18, 2018",
    "Current Ver": "1.0.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "ProconLegis-DF",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 2,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Técnico Legislativo Câmara Legislativa DF",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 1,
    Size: "10M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 29, 2018",
    "Current Ver": 6,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Periscope - Live Video",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 479939,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 9, 2018",
    "Current Ver": "1.23.3.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Cargo de Praça PM DF",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.2M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 7, 2018",
    "Current Ver": 3,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Consultar Infracciones de Transito DF y Mexico",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 23, 2018",
    "Current Ver": 2.5,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Droidbug BusyBox Advance PRO",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 2,
    Size: "3.3M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 19, 2018",
    "Current Ver": 1.4,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "México City D.F News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 2,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 9, 2016",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "PDF Reader – PDF Editor 2018",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 1648,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": "9.5.8",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Fix Error Google Playstore",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.3,
    Reviews: 18,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 22, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "df-Vegetable",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 11, 2018",
    "Current Ver": 1.1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Aproveita DF",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 2, 2018",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "EVENTOS DF",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "December 1, 2017",
    "Current Ver": "1.0.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Citymapper - Transit Navigation",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.5,
    Reviews: 65448,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Rádio Sol Nascente DF",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 12,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 28, 2016",
    "Current Ver": 3.1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Diseño de columnas NTC - RSEE 2017",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 6,
    Size: "2.8M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 26, 2018",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Dollar General - Digital Coupons, Ads And More",
    Category: "SHOPPING",
    Rating: 3.9,
    Reviews: 16678,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "DG Coupon",
    Category: "SHOPPING",
    Rating: 3.7,
    Reviews: 668,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 16, 2018",
    "Current Ver": 20,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Penny Finder",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 470,
    Size: "4.1M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.3.7",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DG - Digital Coupons - Free Coupon and Discount",
    Category: "SHOPPING",
    Rating: 3.6,
    Reviews: 38,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 1, 2018",
    "Current Ver": 20,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DG Surveyor",
    Category: "BUSINESS",
    Rating: 3.6,
    Reviews: 5,
    Size: "6.8M",
    Type: "Paid",
    Price: "$8.99",
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 30, 2018",
    "Current Ver": 6,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "DG Smart life",
    Category: "TOOLS",
    Rating: 2.1,
    Reviews: 14,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 7, 2017",
    "Current Ver": "1.0.5",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Krazy Coupon Lady",
    Category: "SHOPPING",
    Rating: 4.7,
    Reviews: 10318,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 19, 2018",
    "Current Ver": "2.1.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "DG UPnP Player Free",
    Category: "VIDEO_PLAYERS",
    Rating: 3.2,
    Reviews: 39,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "March 18, 2016",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Penny Puss",
    Category: "TOOLS",
    Rating: 3,
    Reviews: 19,
    Size: "22M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 9, 2016",
    "Current Ver": "1.911.1944.4606",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DG Mobile",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 59,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "April 8, 2017",
    "Current Ver": "0.1.10.0",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Go Go Coupons - Free Coupon and Discount",
    Category: "SHOPPING",
    Rating: 3,
    Reviews: 4,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 1, 2018",
    "Current Ver": 10,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "ZombieVital DG",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 10,
    Size: "20M",
    Type: "Paid",
    Price: "$12.99",
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100,
    numAndroid: null,
  },
  {
    App: "DJ Electro Mix Pad",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 53301,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 16, 2017",
    "Current Ver": "1.6.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DG Screen Recorder",
    Category: "VIDEO_PLAYERS",
    Rating: 3.3,
    Reviews: 12,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "October 20, 2015",
    "Current Ver": 1.7,
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "DG Report Reminder",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 195,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "February 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "DG Video Editor",
    Category: "VIDEO_PLAYERS",
    Rating: 4,
    Reviews: 486,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "September 6, 2016",
    "Current Ver": "1.0.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "The DG Buddy",
    Category: "BUSINESS",
    Rating: 3.7,
    Reviews: 3,
    Size: "11M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 30, 2014",
    "Current Ver": "v3",
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "Roland DG Mobile Panel",
    Category: "TOOLS",
    Rating: 2.8,
    Reviews: 27,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 20, 2018",
    "Current Ver": 1.42,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Destroy Gunners Σ",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 10786,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "January 14, 2017",
    "Current Ver": 1.02,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "DG-App",
    Category: "TOOLS",
    Rating: 5,
    Reviews: 1,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 29, 2017",
    "Current Ver": "1.0.16",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Can I pack that? - DG App",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.9,
    Reviews: 58,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "October 28, 2016",
    "Current Ver": "2.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DG Phone Call Task Switcher",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 43,
    Size: "34k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 9, 2015",
    "Current Ver": 2.04,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DG Fitness",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 6,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "March 23, 2018",
    "Current Ver": "7.7.3",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Sharaf DG",
    Category: "SHOPPING",
    Rating: 4,
    Reviews: 7006,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "May 12, 2018",
    "Current Ver": 3.1,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "DG Card",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 15, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100,
    numAndroid: null,
  },
  {
    App: "Coupon Mob - Discount Coupons",
    Category: "SHOPPING",
    Rating: 3,
    Reviews: 2,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "May 30, 2018",
    "Current Ver": 6,
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "DG Users",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 8,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 7, 2018",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DG Cars",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 2.6,
    Reviews: 122,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 8, 2018",
    "Current Ver": "31.11.9.156",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Free coupons and vouchers",
    Category: "FINANCE",
    Rating: 5,
    Reviews: 4,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 28, 2018",
    "Current Ver": 1.5,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DG Hair",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 30, 2017",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DG Xplained",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "May 2, 2018",
    "Current Ver": "1.0.3",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DG OFF - 100% Free Coupons & Deals",
    Category: "SHOPPING",
    Rating: 5,
    Reviews: 1,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 11, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Digoo·Cloud",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 543,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 5, 2018",
    "Current Ver": "1.2.1009.695",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DG Monitor",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 12, 2017",
    "Current Ver": "1.0.0.17",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DG ग्राम / Digital Gram Panchayat",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 53,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "June 19, 2018",
    "Current Ver": 1.7,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DG TV",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 5,
    Reviews: 3,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 26, 2018",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Daily Horoscope",
    Category: "LIFESTYLE",
    Rating: 4.7,
    Reviews: 407589,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "DHgate-Shop Wholesale Prices",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 104068,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.5.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "DH Texas Poker - Texas Hold'em",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 562345,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "DEER HUNTER CLASSIC",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 3941129,
    Size: "77M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 16, 2018",
    "Current Ver": "3.12.0",
    numInstall: 50000000,
    numAndroid: 3,
  },
  {
    App: "DEER HUNTER RELOADED",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 314774,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "September 16, 2013",
    "Current Ver": "3.8.2",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "DH Pineapple Poker OFC",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 1878,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "November 9, 2017",
    "Current Ver": "1.0.13",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "DH UFO",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 4,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 8, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Galaxy Defense",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 78142,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "August 22, 2015",
    "Current Ver": "1.2.3",
    numInstall: 5000000,
    numAndroid: 3,
  },
  {
    App: "Call of Mini™ Dino Hunter",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 326042,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 6, 2014",
    "Current Ver": "3.1.7",
    numInstall: 10000000,
    numAndroid: 3,
  },
  {
    App: "Castle Defense 2",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 35172,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "January 20, 2017",
    "Current Ver": "3.2.2",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Dungeon Rush",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 28633,
    Size: "81M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "December 23, 2016",
    "Current Ver": "1.14.0",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Bike Mayhem Free",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 331692,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "March 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Treasure Defense",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 3527,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "September 8, 2015",
    "Current Ver": "2.2.0.23",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Car Crash III Beam DH Real Damage Simulator 2018",
    Category: "GAME",
    Rating: 3.6,
    Reviews: 151,
    Size: "100M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "May 20, 2018",
    "Current Ver": 1.03,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "The Lost Lands:DH Lite",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1130,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "April 3, 2015",
    "Current Ver": 1.01,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "DH-UFO",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 1,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.0.9",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Dungeon Hunter Champions: Epic Online Action RPG",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 26307,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.1.40",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Daddyhunt: Gay Dating",
    Category: "SOCIAL",
    Rating: 3.9,
    Reviews: 6450,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "January 22, 2018",
    "Current Ver": "1.3.5",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "DH Karaoke",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 8,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "October 23, 2017",
    "Current Ver": "3.3.6",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Tiny Defense",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 29387,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "August 22, 2015",
    "Current Ver": "1.0.6",
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Toys Defense: Horror Land",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 168,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "March 1, 2017",
    "Current Ver": "1.2.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "D-H Pharmacy",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 6,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 4, 2016",
    "Current Ver": "v6.1",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "DEER HUNTER CHALLENGE",
    Category: "GAME",
    Rating: 3.7,
    Reviews: 38767,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "April 11, 2011",
    "Current Ver": "1.4.3",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Kingdom in Chaos",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 5623,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "December 21, 2015",
    "Current Ver": "1.0.5",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Desperate Housewives: The Game",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 10440,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "August 6, 2018",
    "Current Ver": "18.30.22",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Dinosaur War",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 157997,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 4, 2016",
    "Current Ver": "1.4.4",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "DH News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 2.5,
    Reviews: 81,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "News & Magazines",
    "Last Updated": "November 27, 2017",
    "Current Ver": "3.4.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Bike Unchained",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 83545,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": 1.193,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Red Bull TV: Live Sports, Music & Entertainment",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 42069,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "DH Mariage",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 12, 2017",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Bike 3D Configurator",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 34062,
    Size: "85M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "April 3, 2018",
    "Current Ver": "1.6.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Castle Defense : Invasion",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1484,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "July 15, 2018",
    "Current Ver": "1.2.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Defender",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 152395,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "July 22, 2016",
    "Current Ver": "1.1.9",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Avenger Legends",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 3715,
    Size: "94M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "July 13, 2017",
    "Current Ver": "1.13.299",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DrivingTest",
    Category: "FAMILY",
    Rating: 2.9,
    Reviews: 975,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "February 27, 2017",
    "Current Ver": 5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "D. H. Lawrence Poems FREE",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 13,
    Size: "942k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "November 22, 2013",
    "Current Ver": 1.11,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Texas HoldEm Poker Deluxe",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 396090,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "May 30, 2018",
    "Current Ver": "1.7.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Idle Heroes",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 417197,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "May 30, 2018",
    "Current Ver": "1.14.0",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Wallpapers DH 4K",
    Category: "PERSONALIZATION",
    Rating: 3.8,
    Reviews: 23,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 16, 2018",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DH-Security Camera",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 3,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 1, 2017",
    "Current Ver": "DH-Security Camera",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "Deck Heroes: Legacy",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 466495,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "July 16, 2018",
    "Current Ver": "11.7.5",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Shred! Downhill Mountainbiking",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 41683,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "February 2, 2017",
    "Current Ver": 1.67,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Pocket Heroes",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 96658,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "September 5, 2015",
    "Current Ver": "2.0.5",
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "Duolingo: Learn Languages Free",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 6297590,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Free phone calls, free texting SMS on free number",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 412888,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.8.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DiskDigger photo recovery",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 227798,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Phone Tracker : Family Locator",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 231446,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": 4.81,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Meme Generator Free",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 303394,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "August 3, 2018",
    "Current Ver": 4.426,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Stop Smoking - EasyQuit free",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 39068,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 7, 2018",
    "Current Ver": "1.2.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "FIFA Soccer",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 3909032,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": "10.5.00",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "My Photo Keyboard",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 211620,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 29, 2018",
    "Current Ver": 7.4,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Archery Physics Objects Destruction Apple shooter",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 6026,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 7, 2018",
    "Current Ver": 1.04,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Story Saver for Instagram",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 41331,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.4.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Cameringo+ Filters Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 28107,
    Size: "5.7M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 11, 2018",
    "Current Ver": "2.8.26",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Whoscall - Caller ID & Block",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 552635,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2018",
    "Current Ver": "6.19.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Cooking in the Kitchen",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 217736,
    Size: "87M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.1.64",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Automatic Call Recorder",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 1648515,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.42.1",
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "Fancy Pants Adventures",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 55952,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "July 13, 2017",
    "Current Ver": "1.0.10",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Boomerang from Instagram",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 928720,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Shopee: No.1 Belanja Online",
    Category: "SHOPPING",
    Rating: 4.2,
    Reviews: 609186,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.25.17",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Lep's World 3 🍀🍀🍀",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 771001,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "June 11, 2018",
    "Current Ver": "2.0.1.3",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Robbery Bob",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 617732,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "July 29, 2018",
    "Current Ver": "1.18.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Google Sheets",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 496397,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Video Downloader - for Instagram Repost App",
    Category: "VIDEO_PLAYERS",
    Rating: 4.8,
    Reviews: 332623,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.1.58",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Nyan Cat: Lost In Space",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 371318,
    Size: "90M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "June 8, 2018",
    "Current Ver": "10.1.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "HOLLA Live: Meet New People via Random Video Chat",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 216513,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Quik – Free Video Editor for photos, clips, music",
    Category: "VIDEO_PLAYERS",
    Rating: 4.7,
    Reviews: 696665,
    Size: "91M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 5, 2018",
    "Current Ver": "4.7.4.3869-7b2372c3e",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Euro Truck Driver (Simulator)",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 860078,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "February 15, 2018",
    "Current Ver": "1.6.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DJ Mix Effects Simulator",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 5997,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "January 26, 2018",
    "Current Ver": 1.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "3D DJ – Music Mixer with Virtual DJ",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 796,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 3, 2018",
    "Current Ver": "6.6.8",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Virtual DJ Mixer",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 2013,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 18, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Mix Virtual DJ 2018",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 2925,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 23, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Resources For Virtual DJ",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 21095,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 16, 2016",
    "Current Ver": 4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "DK 15 Minute Language Course",
    Category: "FAMILY",
    Rating: 2.8,
    Reviews: 21,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 6, 2018",
    "Current Ver": "1.0.0.5",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DK Readers",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 30,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 2, 2014",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Eyewitness Travel Phrase Book",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 10,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 28, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DK Quiz",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 1628,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "April 10, 2014",
    "Current Ver": 1.3,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "DK Virtual Reality",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 42,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference;Education",
    "Last Updated": "March 13, 2018",
    "Current Ver": "1.7.1",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Bilingual Dictionary Audio App",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 2.7,
    Reviews: 68,
    Size: "87M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 2, 2018",
    "Current Ver": "1.0.0.22",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Super DK vs Kong Brother Advanced Free Classic",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 66,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 17, 2018",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "English for Everyone",
    Category: "FAMILY",
    Rating: 3.2,
    Reviews: 429,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 6, 2018",
    "Current Ver": "3.9.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DK Live - Sports Play by Play",
    Category: "SPORTS",
    Rating: 3.9,
    Reviews: 255,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 22, 2018",
    "Current Ver": "2.1.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DK Eyewitness Audio Walks",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 2.3,
    Reviews: 9,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "April 6, 2018",
    "Current Ver": "1.0.1.8",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DK Pittsburgh Sports",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 556,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 26, 2018",
    "Current Ver": "3.0.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "LineStar For DK",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 1387,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 6, 2018",
    "Current Ver": "3.0.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Visuelles Wörterbuch Audio-App",
    Category: "FAMILY",
    Rating: 3.1,
    Reviews: 192,
    Size: "66M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 7, 2017",
    "Current Ver": "1.1.6",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Fodbold DK Pro",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 315,
    Size: "4.3M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 6, 2018",
    "Current Ver": "2.106.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "10 Minutes a Day Times Tables",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 681,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 3, 2014",
    "Current Ver": 1.2,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "dk Verk",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 9,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 14, 2018",
    "Current Ver": "2.0.14",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "e-Boks.dk",
    Category: "PRODUCTIVITY",
    Rating: 3.2,
    Reviews: 6752,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 21, 2018",
    "Current Ver": "3.5.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Account Class-11 Solutions (D K Goel)",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 663,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 9, 2018",
    "Current Ver": "3.0.0",
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "Dating.dk",
    Category: "SOCIAL",
    Rating: 3.7,
    Reviews: 2111,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 6, 2018",
    "Current Ver": "4.1.23",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "S-Home DK",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 4,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "October 18, 2017",
    "Current Ver": 1.26,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DK Primrose for KLWP",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "16M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 2, 2017",
    "Current Ver": "v2017.Dec.01.19",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "DK Online",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 21,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 18, 2018",
    "Current Ver": 8.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Account Class-12 Solutions (D K Goel) Vol-1",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 708,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 12, 2018",
    "Current Ver": "1.0.0",
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "Salah Widget (DK+Malmo)",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 532,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 28, 2015",
    "Current Ver": "0.9.9.14",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "PK and DK Audio App",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 2,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "October 25, 2017",
    "Current Ver": "5.1.4",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "dk",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 5,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 18, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "HDWallpaper DK",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "October 5, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Account Class-12 Solutions (D K Goel) Vol-2",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 124,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 17, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "DK Browser",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 1,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 25, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Discovery K!ds Play!",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 19388,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "May 3, 2018",
    "Current Ver": "2.1.0.2173",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "cluster.dk",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 49,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 25, 2013",
    "Current Ver": "1.0.2",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Transport DK",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.1,
    Reviews: 204,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "May 29, 2017",
    "Current Ver": 2.28,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DK Childcare Centers",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "April 2, 2018",
    "Current Ver": "1.0.2",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Gokarting.dk",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 13,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 25, 2018",
    "Current Ver": "5.0.45",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DK Murali",
    Category: "SOCIAL",
    Rating: 4.8,
    Reviews: 65,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "February 25, 2017",
    "Current Ver": "1.1.2",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "DK TEL Dialer",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "November 26, 2017",
    "Current Ver": "3.8.8",
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "DK Studio Barbershop",
    Category: "BEAUTY",
    Rating: "NaN",
    Reviews: 8,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "March 20, 2018",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Dr. D.K. Olukoya Sermons",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 26, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "GirlTalk.dk",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 3,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "September 22, 2017",
    "Current Ver": "3.1.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "NY mobilbank DK - Danske Bank",
    Category: "FINANCE",
    Rating: 2.8,
    Reviews: 851,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 26, 2018",
    "Current Ver": "0.38.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dr D K Olukoya",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "July 25, 2018",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "DK Hair Design",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 15, 2017",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Advanced Download Manager Pro",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 6505,
    Size: "2.0M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 3, 2017",
    "Current Ver": "6.4.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Advanced Download Manager",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 569727,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 3, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "GetThemAll Any File Downloader",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 91186,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 22, 2018",
    "Current Ver": "2.0.9",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Downloader & Private Browser",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 1072565,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Download All Files",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 120494,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 13, 2018",
    "Current Ver": "2.0.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Download Manager Pro FREE",
    Category: "PRODUCTIVITY",
    Rating: 3.8,
    Reviews: 637,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 31, 2017",
    "Current Ver": 2.5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Download Accelerator Plus",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 43677,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 30, 2017",
    "Current Ver": 20170828,
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Download Manager",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 79132,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 3, 2018",
    "Current Ver": "1.1.6",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Download Video Free",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 39682,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 3, 2018",
    "Current Ver": "3.5.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fast Download Manager",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 18478,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.0.5",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "DL Hughley",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 12,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "March 23, 2018",
    "Current Ver": "2.0.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Turbo Download Manager (and Browser)",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 32879,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 4, 2018",
    "Current Ver": 5.19,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "D.L. Evans Bank Mobile Banking",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 85,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 2, 2018",
    "Current Ver": "18.1.79",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "The DL Hughley Show",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 23,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 29, 2018",
    "Current Ver": "3.1.2",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "Download Blazer",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 34612,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 12, 2018",
    "Current Ver": "2.0.7",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "DL Image Manager",
    Category: "PRODUCTIVITY",
    Rating: 5,
    Reviews: 2,
    Size: "1.7M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 29, 2018",
    "Current Ver": "1.0.5",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Download Manager For Android Free",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 593,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 12, 2018",
    "Current Ver": "12.04.18",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "FrostWire: Torrent Downloader & Music Player",
    Category: "VIDEO_PLAYERS",
    Rating: 4.1,
    Reviews: 253207,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.0.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Turbo Downloader",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 23348,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 4, 2018",
    "Current Ver": 3.48,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Trimble DL",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 133,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 12, 2018",
    "Current Ver": "1.0.184",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Insave-Download for Instagram",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 46242,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "September 20, 2016",
    "Current Ver": "2.1.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "+Download 4 Instagram Twitter",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 40467,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": 5.03,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Advanced Download Manager Holo",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 16192,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 13, 2016",
    "Current Ver": "4.1.9o",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "G-Download Manager",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 802,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.0.81",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Video Downloader",
    Category: "VIDEO_PLAYERS",
    Rating: 4.2,
    Reviews: 58981,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.0.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DL Calculator",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 177,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "September 17, 2015",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Inst Download - Video & Photo",
    Category: "VIDEO_PLAYERS",
    Rating: 4.6,
    Reviews: 148715,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "December 20, 2017",
    "Current Ver": 2,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Vuze Torrent Downloader",
    Category: "VIDEO_PLAYERS",
    Rating: 4.1,
    Reviews: 24565,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "March 4, 2016",
    "Current Ver": 2.1,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "IDM Internet Download Manager",
    Category: "PRODUCTIVITY",
    Rating: 3.9,
    Reviews: 1322,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 25, 2016",
    "Current Ver": "1.0.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "TorrDroid - Torrent Downloader",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 59632,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 3, 2018",
    "Current Ver": "1.5.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Download Manager - File & Video",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 8780,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 13, 2018",
    "Current Ver": "2.7.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "AndStream - Streaming Download",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 38607,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "March 19, 2017",
    "Current Ver": "3.1.8",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "DM Me - Chat",
    Category: "SOCIAL",
    Rating: 2.9,
    Reviews: 90,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 9, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DM Screen",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 283,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Books & Reference",
    "Last Updated": "January 12, 2018",
    "Current Ver": "1.1.10a",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DM for IG 😘 - Image & Video Saver for Instagram",
    Category: "SOCIAL",
    Rating: 3.7,
    Reviews: 55,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "March 3, 2018",
    "Current Ver": "3.20.3",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DM for WhatsApp",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 25,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 3, 2018",
    "Current Ver": "0.3.7",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Fifth Edition DM Tools",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 942,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "January 19, 2017",
    "Current Ver": "1.14b",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "DM Talk New",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 3,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "February 7, 2018",
    "Current Ver": "3.8.8",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "DM airdisk",
    Category: "TOOLS",
    Rating: 2.8,
    Reviews: 11,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 5, 2016",
    "Current Ver": "1.7.2",
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Diabetes mellitus (DM) from zero to hero",
    Category: "MEDICAL",
    Rating: 4.9,
    Reviews: 18,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 17, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Auto DM for Twitter 🔥",
    Category: "SOCIAL",
    Rating: 3.4,
    Reviews: 44,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "May 21, 2018",
    "Current Ver": "HTTPs",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DM HiDisk",
    Category: "TOOLS",
    Rating: 2.8,
    Reviews: 54,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 7, 2018",
    "Current Ver": "1.1.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DM EVOLUTION",
    Category: "GAME",
    Rating: 2.5,
    Reviews: 450,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.0.9",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Daily DM",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 51,
    Size: "259k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "October 4, 2013",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Dungeons and Dragons DM Tools",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.1,
    Reviews: 50,
    Size: "4.9M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "February 22, 2017",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "DM - The Offical Messaging App",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "December 20, 2017",
    "Current Ver": 1.3,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DM airdisk Pro",
    Category: "TOOLS",
    Rating: 3.2,
    Reviews: 11,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 20, 2017",
    "Current Ver": "2.4.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Convert Coordinates DM to DMS",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.3,
    Reviews: 15,
    Size: "164k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "February 3, 2013",
    "Current Ver": 1.6,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "DM security - Dragon Mobile",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 27,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 26, 2017",
    "Current Ver": "1.1.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DM 24/7",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 7,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 1, 2018",
    "Current Ver": 2.3,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "DM Storage (for twitter)",
    Category: "SOCIAL",
    Rating: 3.2,
    Reviews: 6,
    Size: "458k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "November 26, 2014",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DM Transfers Dalaman Transfers",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 51,
    Size: "245k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "February 22, 2014",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "DM Tracker",
    Category: "COMMUNICATION",
    Rating: 3.5,
    Reviews: 11,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DM Tuning",
    Category: "SPORTS",
    Rating: 3.3,
    Reviews: 64,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "April 4, 2018",
    "Current Ver": "1.9.1",
    numInstall: 5000,
    numAndroid: 6,
  },
  {
    App: "DM Die Roller 9000",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.3M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 14, 2018",
    "Current Ver": 1.2,
    numInstall: 5,
    numAndroid: 2,
  },
  {
    App: "DM Magazine",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 0,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 11, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DM הפקות",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 2,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "October 14, 2017",
    "Current Ver": 30,
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "DM TrackMan",
    Category: "MAPS_AND_NAVIGATION",
    Rating: "NaN",
    Reviews: 10,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "June 26, 2018",
    "Current Ver": "2.1.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Aster DM Healthcare",
    Category: "MEDICAL",
    Rating: 2.4,
    Reviews: 32,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "November 21, 2017",
    "Current Ver": 1.5,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Fake Chat (Direct Message)",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 5985,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 6, 2017",
    "Current Ver": "1.4.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Interactive NPC DM Tool",
    Category: "FAMILY",
    Rating: 2.8,
    Reviews: 5,
    Size: "629k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "January 31, 2015",
    "Current Ver": "1.0.0",
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "DM Buddy » Learn Digital Marketing",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 3,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 11, 2017",
    "Current Ver": 2.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "DM Accounting and Payroll",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "92M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "September 27, 2017",
    "Current Ver": "4.0.30",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "Basketball Dynasty Manager 16",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 426,
    Size: "21M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 1, 2016",
    "Current Ver": "2.2.3",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DM Collection",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 3,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 25, 2015",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "DM AirDisk HDD",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 4,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 28, 2018",
    "Current Ver": "1.4.6",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DM AirDisk NAS",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.1.4",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Shaggy's DM Assistant",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 14, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5,
    numAndroid: null,
  },
  {
    App: "Otto DM",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "March 7, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DM Adventure",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "June 18, 2018",
    "Current Ver": "1.0.4",
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "Ramdor DM Mobile",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 13, 2018",
    "Current Ver": "21 - Rel2.0",
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "Disciple Maker’s (DM) Lab",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 3,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.0.5",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ultimate DM",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "March 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10,
    numAndroid: null,
  },
  {
    App: "DN",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.3,
    Reviews: 78,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 2, 2018",
    "Current Ver": "3.2.1.258",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "DN eAvis",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 2.9,
    Reviews: 61,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "February 1, 2017",
    "Current Ver": "2.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DN Sync",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 56,
    Size: "28k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "June 13, 2016",
    "Current Ver": 1.15,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "DN Reader",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.6,
    Reviews: 18,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "March 13, 2014",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DN Managed Mobility App",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 13, 2018",
    "Current Ver": "2.1.2",
    numInstall: 50,
    numAndroid: 5,
  },
  {
    App: "e-DN - den digitala tidningen från Dagens Nyheter",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 2.2,
    Reviews: 160,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.3.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "MultiPicture Live Wallpaper dn",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 505,
    Size: "288k",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "February 10, 2013",
    "Current Ver": "0.6.11",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "DN Blog",
    Category: "SOCIAL",
    Rating: 5,
    Reviews: 20,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 23, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Dagens Nyheter",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 2.5,
    Reviews: 2055,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 4, 2018",
    "Current Ver": "4.2.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DN Events",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 4,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Productivity",
    "Last Updated": "June 7, 2018",
    "Current Ver": "7.17.2.0",
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "DN.VR",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3,
    Reviews: 29,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "May 23, 2018",
    "Current Ver": "2.1.1",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "DN - Diário de Notícias",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.7,
    Reviews: 794,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 26, 2018",
    "Current Ver": "3.2.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DN Employee",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 1,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 25, 2018",
    "Current Ver": 1.4,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DN Advanced Service Coder",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 1, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DN Premium Hookah Lounge",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 21, 2015",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "PlayMotiv dn edition",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 8, 2018",
    "Current Ver": "1.0.2",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Cossack Dictionary (DN)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 7,
    Size: "2.3M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "April 28, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DN Calculators",
    Category: "FINANCE",
    Rating: 5,
    Reviews: 12,
    Size: "775k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "September 5, 2013",
    "Current Ver": 1.11,
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "DN Diamonds",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 4,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.9.17",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DN Prasad",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 30, 2018",
    "Current Ver": "1.1.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Writing Wizard Premium - Handwriting",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 89,
    Size: "33M",
    Type: "Paid",
    Price: "$4.49",
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "December 3, 2017",
    "Current Ver": "2.5.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DN Driver",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 9, 2018",
    "Current Ver": "1.0.2",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "D.N. College Meerut",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 26, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DN Radio FM",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "July 15, 2016",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "Sverige Tidningar",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 905,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 30, 2018",
    "Current Ver": "2.2.2.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Svenska Dagbladet",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 2.6,
    Reviews: 820,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "February 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Dragon Nest M",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 11872,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.2.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Downtown Mafia: Gang Wars (Mobster Game) Free",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 69013,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "September 2, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "DN Snacks",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 9, 2018",
    "Current Ver": "1.0.0",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Guardian Hunter: SuperBrawlRPG",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 364013,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "August 6, 2018",
    "Current Ver": "14.4.4.00",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Sweden Newspapers",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 7, 2018",
    "Current Ver": 1.1,
    numInstall: 0,
    numAndroid: 4,
  },
  {
    App: "ES Remote",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 707,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 20, 2014",
    "Current Ver": "2.1.1",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "MC.Fitting",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 130,
    Size: "3.4M",
    Type: "Paid",
    Price: "$8.49",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 3, 2017",
    "Current Ver": 12,
    numInstall: 1000,
    numAndroid: 1,
  },
  {
    App: "Destiny Ninja Shall we date otome games love story",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 13079,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Adventure",
    "Last Updated": "April 20, 2018",
    "Current Ver": "1.6.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Day Night Live Wallpaper (All)",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 4856,
    Size: "18M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 31, 2018",
    "Current Ver": "1.5.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "CritDice - Dice Roller",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 2910,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "October 30, 2016",
    "Current Ver": "2.0.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Cursive Writing Wizard - Handwriting",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 3745,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "December 3, 2017",
    "Current Ver": "2.5.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Free Poker Games : Downtown Casino - Texas Holdem",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 2032,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "June 5, 2018",
    "Current Ver": "0.1.27",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "WFVS 2018 | WhatApp Full Video Status & Downloader",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 596,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 4, 2018",
    "Current Ver": 1.3,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Maher EL Mouaikly - Offline",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 166,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 24, 2017",
    "Current Ver": "1.1.0",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "Darkness Rises",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 456474,
    Size: "86M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.2.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "NARUTO X BORUTO NINJA VOLTAGE",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 267395,
    Size: "71M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.1.7",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Sword Art Online: Integral Factor",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 45359,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.0.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Mahalaxmi Dindarshika 2018",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 25427,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 5, 2018",
    "Current Ver": 18,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Google Docs",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 815974,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Microsoft To-Do: List, Task & Reminder",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 14432,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.36.82",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Any.do: To-do list, Calendar, Reminders & Planner",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 298854,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "PDF Reader - Scan、Edit & Share",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 54520,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 30, 2018",
    "Current Ver": "3.12.4",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Notepad & To do list",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 226295,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 6, 2018",
    "Current Ver": "4.3.19",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "To Do List",
    Category: "PRODUCTIVITY",
    Rating: 4.7,
    Reviews: 253155,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 19, 2018",
    "Current Ver": "3.0.17",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "File Viewer for Android",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 7063,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 25, 2018",
    "Current Ver": "2.3.2",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Polaris Office - Word, Docs, Sheets, Slide, PDF",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 549900,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 18, 2018",
    "Current Ver": "7.3.30",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Google Keep",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 691474,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "do",
    Category: "FAMILY",
    Rating: 3.1,
    Reviews: 1073,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "June 8, 2016",
    "Current Ver": "1.0.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Does not Commute",
    Category: "GAME",
    Rating: 4,
    Reviews: 154108,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "October 13, 2015",
    "Current Ver": "1.4.2",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Do It Later: Tasks & To-Dos",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 123412,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Todoist: To-do lists for task management & errands",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 155998,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 5, 2018",
    "Current Ver": "12.8.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "To Do Reminder with Alarm",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 72161,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 21, 2018",
    "Current Ver": "2.68.14",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "To-Do Calendar Planner",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 30291,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Wunderlist: To-Do List & Tasks",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 404610,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "wikiHow: how to do anything",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 43088,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "April 19, 2017",
    "Current Ver": "2.7.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ike - To-Do List, Task List",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 6320,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 10, 2016",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Kung Fu Do Fighting",
    Category: "GAME",
    Rating: 4,
    Reviews: 271214,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "My Effectiveness: To do, Tasks",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 14089,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 5, 2018",
    "Current Ver": "0.21.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Do it (Tomorrow)",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 26452,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 3, 2014",
    "Current Ver": "2.3.5",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Do Not Disturb",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 6120,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 22, 2017",
    "Current Ver": "2.10.1",
    numInstall: 100000,
    numAndroid: 6,
  },
  {
    App: "To-Do List Widget",
    Category: "PRODUCTIVITY",
    Rating: 3.9,
    Reviews: 7801,
    Size: "201k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "September 28, 2013",
    "Current Ver": 2,
    numInstall: 1000000,
    numAndroid: 1,
  },
  {
    App: "NoteToDo. Notes. To do list",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 57449,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.2.187-83",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Memory Helper - To do list, Notepad, Notes, Memo",
    Category: "PRODUCTIVITY",
    Rating: 4.7,
    Reviews: 7566,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 21, 2018",
    "Current Ver": 67,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "2Do - Reminders, To-do List & Notes",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 4649,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 19, 2018",
    "Current Ver": "2.8.12",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "TickTick: To Do List with Reminder, Day Planner",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 25370,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Notes : Colorful Notepad Note,To Do,Reminder,Memo",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 10484,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 9, 2018",
    "Current Ver": "1.4.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Time Planner - Schedule, To-Do List, Time Tracker",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 2537,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 10, 2018",
    "Current Ver": "2.2 (Protostar)",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "MyLifeOrganized: To-Do List",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 4441,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "ColorNote Notepad Notes",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 2401017,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Cal - Google Calendar + Widget",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 86172,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "February 1, 2016",
    "Current Ver": "1.1.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Clean My House – Chore To Do List, Task Scheduler",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 661,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 21, 2018",
    "Current Ver": "2.1.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Goal Meter: Goal Tracker, Habit Changer,To-Do List",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 7969,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "February 6, 2018",
    "Current Ver": "2.7.92",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "To-do list",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 688,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 17, 2018",
    "Current Ver": 2.22,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Do Not Crash",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 56664,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "February 5, 2015",
    "Current Ver": 1.4,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Do I Snore or Grind",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 2295,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 9, 2018",
    "Current Ver": "0.3.1",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "How well do you know me?",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 1290,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.3.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "EasyNote Notepad | To Do List",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 15618,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 27, 2017",
    "Current Ver": "1.5.2",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Apex Launcher",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 266434,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Adobe Fill & Sign: Easy PDF Form Filler",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 11402,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 7, 2017",
    "Current Ver": "1.3.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "DO YOU KNOW THE WAY Soundboard",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 1007,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 1, 2018",
    "Current Ver": 7,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dude Perfect 2",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 401648,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "April 12, 2017",
    "Current Ver": "1.6.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Endless Ducker",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 8193,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "September 16, 2016",
    "Current Ver": "1.0.7",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Dude Perfect",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 97,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 28, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "that's lit",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 1115,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 7, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "All Type DP",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1853,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 10, 2018",
    "Current Ver": 1.8,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Dp For WhatsApp",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 1623,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Personalization",
    "Last Updated": "June 23, 2018",
    "Current Ver": 2.7,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "DP and Status for WhatsApp 2018",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 787,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "February 17, 2018",
    "Current Ver": "2.4.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DP Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 18,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Photography",
    "Last Updated": "August 4, 2018",
    "Current Ver": 1.5,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DP & Status",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1922,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 9, 2018",
    "Current Ver": 1.13,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Dp for girls",
    Category: "ART_AND_DESIGN",
    Rating: 4.2,
    Reviews: 175,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "May 26, 2017",
    "Current Ver": 1.2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "DP Maker",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 784,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "April 29, 2018",
    "Current Ver": "1.00.15",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Download Instant DP (Full HD)",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 1283,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 4, 2018",
    "Current Ver": "4.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Square DP For Whatsapp",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 67,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 29, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Profile pictures for WhatsApp",
    Category: "PERSONALIZATION",
    Rating: 4.7,
    Reviews: 10786,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Personalization",
    "Last Updated": "May 20, 2018",
    "Current Ver": "2.3.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "DP and Status",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 623,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 11, 2017",
    "Current Ver": "1.0.1",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Dp For Whatsapp",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 39,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "April 13, 2017",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DP & Status for Whatsapp 2018",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 293,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DP Creator for WhatsApp",
    Category: "PHOTOGRAPHY",
    Rating: 3.8,
    Reviews: 4813,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 19, 2016",
    "Current Ver": 1.5,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Dp For FB",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 12,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Photography",
    "Last Updated": "October 19, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Best DP and Status (Daily Updates Photos)",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 3003,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 7, 2018",
    "Current Ver": 1.8,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Magical Insta DP",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 2,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 28, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Profile Pictures and DP for Whatsapp",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 48,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "May 12, 2017",
    "Current Ver": 1.3,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "All Types DP & Status Maker",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 16,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Photography",
    "Last Updated": "July 12, 2018",
    "Current Ver": "2.1.5",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DP Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 88,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "September 29, 2017",
    "Current Ver": 2.5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Status For WhatsApp DP - pro",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 49,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "May 31, 2018",
    "Current Ver": 1.7,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Marathi DP - status and message,jokes,Video app",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 694,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 1, 2018",
    "Current Ver": 1.6,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Cute Images for Whatsapp",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 634,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "December 23, 2015",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Profile Pictures - Best DP Status",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 131,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 29, 2017",
    "Current Ver": "1.2.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Best DP and Status - All Type DP & Status",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 30, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Dp for Facebook",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 56,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "May 16, 2017",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Fifa World Cup 2018: Photo Frame Editor & DP Maker",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 666,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 20, 2018",
    "Current Ver": 6.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DP and Status Images | All Latest Status 2018",
    Category: "LIFESTYLE",
    Rating: 4.7,
    Reviews: 25,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "July 22, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Best DP and Status",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 93,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "November 29, 2017",
    "Current Ver": "7.6.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "100000+ Messages - DP, Status, Jokes & GIF 2018",
    Category: "LIFESTYLE",
    Rating: 3.7,
    Reviews: 121,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Lifestyle",
    "Last Updated": "December 29, 2017",
    "Current Ver": "DPSTATUS1.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Instant DP Downloader for Instagram",
    Category: "SOCIAL",
    Rating: 4.7,
    Reviews: 38,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "August 4, 2018",
    "Current Ver": "1.0.4",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DP Display Pictures Life Quotes Motivational GM",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 39,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "January 1, 2018",
    "Current Ver": 20,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Latest DP and Status Pro 2018",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 19,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 5, 2018",
    "Current Ver": "1.0.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Best DP And Video Status 2018 For Whatsapp",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 91,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 31, 2018",
    "Current Ver": 9,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Qeek for Instagram - Zoom profile insta DP",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 12111,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "May 3, 2018",
    "Current Ver": 1.47,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "DP Battle",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 132,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 26, 2017",
    "Current Ver": "2.0.5",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Faceoff DP Battle App",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 38,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 15, 2018",
    "Current Ver": 5.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Insta Square Profile DP",
    Category: "PHOTOGRAPHY",
    Rating: 3.7,
    Reviews: 42,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "September 1, 2015",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Name Art DP - Focus n Filter Text 2018",
    Category: "ART_AND_DESIGN",
    Rating: 4.3,
    Reviews: 132,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "January 4, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DP Status 2017",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 302,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 15, 2017",
    "Current Ver": "15|06|17",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Dairy Queen",
    Category: "FOOD_AND_DRINK",
    Rating: 3.6,
    Reviews: 742,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 25, 2018",
    "Current Ver": "2.1.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DQ Texas",
    Category: "FOOD_AND_DRINK",
    Rating: 4.1,
    Reviews: 336,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "May 18, 2018",
    "Current Ver": "1.4.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DQ Events",
    Category: "BUSINESS",
    Rating: 2.3,
    Reviews: 41,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "December 20, 2017",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Dash Quest Heroes",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 8432,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Adventure",
    "Last Updated": "July 16, 2018",
    "Current Ver": "1.4.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Coupons for Dairy Queen",
    Category: "FOOD_AND_DRINK",
    Rating: 4.6,
    Reviews: 42,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Food & Drink",
    "Last Updated": "July 18, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "DRAGON QUEST VIII",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 7812,
    Size: "27M",
    Type: "Paid",
    Price: "$19.99",
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "April 4, 2017",
    "Current Ver": "1.1.4",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "ODTMobile v4",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 3,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 17, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DRAGON QUEST III",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1661,
    Size: "63M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "March 9, 2018",
    "Current Ver": "1.0.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "LightMeter (noAds)",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 617,
    Size: "12M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 22, 2016",
    "Current Ver": "1.5.10.NA",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "DRAGON QUEST",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 9659,
    Size: "30M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "March 10, 2017",
    "Current Ver": "1.0.7",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "DRAGON QUEST II",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 2576,
    Size: "44M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "March 9, 2018",
    "Current Ver": "1.0.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "SONIC Drive-In",
    Category: "FOOD_AND_DRINK",
    Rating: 4.3,
    Reviews: 19373,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.3.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "DRAGON QUEST VI",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 3358,
    Size: "17M",
    Type: "Paid",
    Price: "$14.99",
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.0.4",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "McDonald's",
    Category: "FOOD_AND_DRINK",
    Rating: 3.6,
    Reviews: 145646,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 31, 2018",
    "Current Ver": "5.15.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DQT GPS",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 3,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 5, 2015",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "DQ Akses",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 6, 2018",
    "Current Ver": 1.1,
    numInstall: 1,
    numAndroid: 2,
  },
  {
    App: "Discovery Insure",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 2.8,
    Reviews: 1911,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "March 17, 2018",
    "Current Ver": "di-v3.4.0.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Taco Bell",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 28140,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 30, 2018",
    "Current Ver": "5.0.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "LightMeter Free",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 5485,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "April 28, 2016",
    "Current Ver": "1.2.3",
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "CHRONO TRIGGER (Upgrade Ver.)",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 11250,
    Size: "6.3M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "June 12, 2018",
    "Current Ver": "2.0.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ODTMobile",
    Category: "BUSINESS",
    Rating: 3.4,
    Reviews: 15,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 10, 2016",
    "Current Ver": 3.2,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Whataburger",
    Category: "FOOD_AND_DRINK",
    Rating: 4.5,
    Reviews: 5093,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "April 10, 2018",
    "Current Ver": "1.9.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "FINAL FANTASY DIMENSIONS",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 8450,
    Size: "1.1M",
    Type: "Paid",
    Price: "$13.99",
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "March 15, 2017",
    "Current Ver": "1.1.3",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Arby's",
    Category: "FOOD_AND_DRINK",
    Rating: 3.1,
    Reviews: 194,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.3.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "RPG Dragon Lapis",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 13492,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 9, 2018",
    "Current Ver": "1.1.4g",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Find Fast Food",
    Category: "SHOPPING",
    Rating: 3.3,
    Reviews: 272,
    Size: "785k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "November 11, 2012",
    "Current Ver": "1.1.6",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Jungle book-The Great Escape",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 2362,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 17, 2013",
    "Current Ver": 1.3,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Bunny Skater",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 139432,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "November 20, 2013",
    "Current Ver": 1.5,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "DQSalmaan - A fan made App",
    Category: "FAMILY",
    Rating: 4.9,
    Reviews: 707,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 4, 2018",
    "Current Ver": 1.5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Culver's",
    Category: "LIFESTYLE",
    Rating: 3.9,
    Reviews: 1638,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "April 11, 2018",
    "Current Ver": 1.2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Wendy’s – Food and Offers",
    Category: "FOOD_AND_DRINK",
    Rating: 3.4,
    Reviews: 6512,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "April 12, 2018",
    "Current Ver": "5.7.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "World Webcams",
    Category: "WEATHER",
    Rating: 3.7,
    Reviews: 7896,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "November 25, 2013",
    "Current Ver": 1.6,
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Dunkin' Donuts",
    Category: "FOOD_AND_DRINK",
    Rating: 4.2,
    Reviews: 68270,
    Size: "66M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "June 20, 2018",
    "Current Ver": "5.0.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SUBWAY®",
    Category: "FOOD_AND_DRINK",
    Rating: 3.8,
    Reviews: 21381,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 24, 2018",
    "Current Ver": "7.9.0.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "The Walking Zombie: Dead City",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 58575,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "February 21, 2018",
    "Current Ver": 2.55,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Monster Fishing 2018",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 32881,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 7, 2018",
    "Current Ver": "0.0.80",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Call Blocker & Blacklist",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 6,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 13, 2018",
    "Current Ver": "3.1.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Panera Bread",
    Category: "FOOD_AND_DRINK",
    Rating: 4.2,
    Reviews: 10225,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 6, 2018",
    "Current Ver": "4.4.2",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Dulquer Salmaan HD Wallpapers",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.1.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "IHOP®",
    Category: "FOOD_AND_DRINK",
    Rating: 4.2,
    Reviews: 441,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "April 3, 2018",
    "Current Ver": "2.2.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Starbucks",
    Category: "FOOD_AND_DRINK",
    Rating: 4.5,
    Reviews: 455496,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.11.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "myGrow",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 84,
    Size: "23M",
    Type: "Paid",
    Price: "$4.29",
    "Content Rating": "Mature 17+",
    Genres: "Productivity",
    "Last Updated": "April 29, 2016",
    "Current Ver": "2.3.9",
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Dr. Parking 4",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 475369,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "March 6, 2018",
    "Current Ver": 1.14,
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Dr. Driving 2",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 358633,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "May 3, 2018",
    "Current Ver": 1.32,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Anti-virus Dr.Web Light",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 1094094,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "dr.fone - Recovery & Transfer wirelessly & Backup",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 23347,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 28, 2018",
    "Current Ver": "3.2.0.169",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Dr. Truck Driver : Real Truck Simulator 3D",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 1626,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Simulation",
    "Last Updated": "July 5, 2018",
    "Current Ver": 1.8,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dr. Cares - Pet Rescue 911 🐶",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 14432,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "September 21, 2017",
    "Current Ver": 1.5,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Dr. Panda Town",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 36578,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Dr. Parker : Parking Simulator",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 14253,
    Size: "81M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "January 18, 2018",
    "Current Ver": 3.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Dr. Parker : Real car parking simulation",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 15829,
    Size: "95M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "July 24, 2018",
    "Current Ver": 1.29,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Dr. Battery - Fast Charger - Super Cleaner 2018",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 101738,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.2.82",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Dr. Safety - Antivirus, Booster, Cleaner, AppLock",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 372553,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 6, 2018",
    "Current Ver": "3.0.1114",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DR TV",
    Category: "VIDEO_PLAYERS",
    Rating: 3.3,
    Reviews: 6716,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Video Players & Editors",
    "Last Updated": "June 25, 2018",
    "Current Ver": "3.0.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Real Car Dr Parking Master: Parking Games 2018",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 3345,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "May 12, 2018",
    "Current Ver": 1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Doctor Kids",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 200450,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1.39,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Dr. Rocket",
    Category: "GAME",
    Rating: 4,
    Reviews: 42182,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "January 6, 2018",
    "Current Ver": 1.11,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Dr. Muscle",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4,
    Reviews: 87,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 28, 2018",
    "Current Ver": 2.5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Dr. Dominoes",
    Category: "GAME",
    Rating: 4,
    Reviews: 2700,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "January 3, 2018",
    "Current Ver": 1.06,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Dr. Sudoku",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 2310,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "January 4, 2018",
    "Current Ver": 1.06,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Dr.Web Security Space",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 594406,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Dr. Unblock",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 3847,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "January 3, 2018",
    "Current Ver": 1.05,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Dr. Gomoku",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 85317,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "January 15, 2018",
    "Current Ver": 1.54,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Dr. Panda Farm",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 265,
    Size: "46M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "July 21, 2016",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DR.MEEP",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 54,
    Size: "33M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "June 29, 2018",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Dr. Panda Art Class",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1013,
    Size: "58M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Education;Creativity",
    "Last Updated": "April 26, 2017",
    "Current Ver": 1.7,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Dr. Panda's Swimming Pool",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 2311,
    Size: "9.3M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "January 15, 2015",
    "Current Ver": 1.01,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dr. Pixel: Pill mania Classic",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 2419,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "March 31, 2018",
    "Current Ver": "1.2.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dr. Chess",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 97209,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "January 14, 2018",
    "Current Ver": 1.41,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Super Dr. Parking 3D",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 4518,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "December 17, 2017",
    "Current Ver": 3.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Dr Dre - Beatmaker",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 146,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Music",
    "Last Updated": "February 28, 2018",
    "Current Ver": "5.3.8",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Dr. Panda & Toto's Treehouse",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 3397,
    Size: "9.5M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "December 9, 2014",
    "Current Ver": 1.8,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Dr. Cares - Amy's Pet Clinic 🐈 🐕",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 3580,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "April 30, 2018",
    "Current Ver": 1.8,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dr. Splorchy Presents Space Heroes",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 18,
    Size: "31M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Mature 17+",
    Genres: "Adventure",
    "Last Updated": "July 23, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 7,
  },
  {
    App: "Pet Vet Dr - Animals Hospital",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 11748,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "October 31, 2016",
    "Current Ver": 1.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Dr.Android Repair Master 2017",
    Category: "PRODUCTIVITY",
    Rating: 3.8,
    Reviews: 1205,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 10, 2018",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DR CONTROL",
    Category: "FAMILY",
    Rating: 3.4,
    Reviews: 267,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 8, 2017",
    "Current Ver": "2.1.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Dr Driving Racer",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 183,
    Size: "68M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "June 14, 2018",
    "Current Ver": 2.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Dr. McDougall Mobile Cookbook",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.8,
    Reviews: 76,
    Size: "1.2M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "January 26, 2015",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Dr. Seuss's ABC",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 429,
    Size: "12M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Books & Reference;Education",
    "Last Updated": "February 26, 2018",
    "Current Ver": 2.05,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Dr. Booster - Boost Game Speed",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 138872,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 15, 2018",
    "Current Ver": "2.0.1077",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Dr. Panda Hospital",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 1091,
    Size: "45M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Education;Pretend Play",
    "Last Updated": "December 5, 2013",
    "Current Ver": 1.6,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Dr. Panda Café Freemium",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 11788,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "August 10, 2017",
    "Current Ver": 1.01,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Dr. Panda Ice Cream Truck Free",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 23022,
    Size: "80M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing;Pretend Play",
    "Last Updated": "August 2, 2018",
    "Current Ver": 2.16,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Dr. Doug's Tips",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4,
    Reviews: 22,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "September 1, 2016",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Dr. 2048",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 1985,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "December 30, 2017",
    "Current Ver": 1.05,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Dr. Panda Restaurant 2",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 3725,
    Size: "67M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "February 17, 2016",
    "Current Ver": 1.96,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dr. Panda Supermarket",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1357,
    Size: "58M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "February 16, 2016",
    "Current Ver": 1.6,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Dr. Shogi",
    Category: "GAME",
    Rating: 3.3,
    Reviews: 19291,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "January 2, 2018",
    "Current Ver": 1.24,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "DR Sebi's Alkaline List",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 68,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 5, 2017",
    "Current Ver": 0.1,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "DraStic DS Emulator",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 87766,
    Size: "12M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 19, 2016",
    "Current Ver": "r2.5.0.3a",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "NDS Emulator - For Android 6",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 14002,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 26, 2018",
    "Current Ver": "pb1.0.0.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Free DS Emulator",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 22896,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 26, 2018",
    "Current Ver": "pb1.0.0.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "nds4droid",
    Category: "GAME",
    Rating: 3.4,
    Reviews: 107778,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "February 12, 2016",
    "Current Ver": 47,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "MegaNDS (NDS Emulator)",
    Category: "GAME",
    Rating: 3.4,
    Reviews: 2218,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "October 18, 2017",
    "Current Ver": 2,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "DS file",
    Category: "PRODUCTIVITY",
    Rating: 4.1,
    Reviews: 10676,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 23, 2018",
    "Current Ver": "4.11.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "DS finder",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 2596,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 19, 2018",
    "Current Ver": "2.0.1",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "DS get",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 71852,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 23, 2018",
    "Current Ver": "1.12.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "DS cloud",
    Category: "TOOLS",
    Rating: 3.2,
    Reviews: 4908,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 23, 2018",
    "Current Ver": "2.8.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "DS photo",
    Category: "VIDEO_PLAYERS",
    Rating: 3.8,
    Reviews: 7335,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 17, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "DS video",
    Category: "VIDEO_PLAYERS",
    Rating: 3.8,
    Reviews: 12443,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "DS note",
    Category: "PRODUCTIVITY",
    Rating: 3.9,
    Reviews: 2046,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 11, 2018",
    "Current Ver": "1.10.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DS cam",
    Category: "PRODUCTIVITY",
    Rating: 3.6,
    Reviews: 3227,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 26, 2018",
    "Current Ver": "3.0.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "DS router",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 253,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 13, 2018",
    "Current Ver": "1.1.8",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EmuBox - Fast Retro Emulator",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 1576,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "August 5, 2018",
    "Current Ver": "2.1.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Synology Drive",
    Category: "PRODUCTIVITY",
    Rating: 3.2,
    Reviews: 368,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "DS Creator 2.0",
    Category: "TOOLS",
    Rating: 1,
    Reviews: 2,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 23, 2018",
    "Current Ver": "2.0.180226.1",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "DS App Manager",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 14,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 21, 2015",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Simple x3DS Emulator - BETA",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "June 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "DS Helpdesk Plus",
    Category: "BUSINESS",
    Rating: 3.6,
    Reviews: 21,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$12.99",
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 30, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100,
    numAndroid: null,
  },
  {
    App: "DS",
    Category: "FAMILY",
    Rating: 4.9,
    Reviews: 15,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "January 19, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Ability DS UNO",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 3,
    Size: "2.3M",
    Type: "Paid",
    Price: "$2.60",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 19, 2014",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 1,
  },
  {
    App: "DS Connector 2.0",
    Category: "TOOLS",
    Rating: 2.6,
    Reviews: 5,
    Size: "636k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 23, 2018",
    "Current Ver": "2.0.180226.1",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "DS Barometer - Altimeter and Weather Information",
    Category: "WEATHER",
    Rating: 3.9,
    Reviews: 2962,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 9, 2018",
    "Current Ver": 3.67,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "DS Companion",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "November 3, 2017",
    "Current Ver": 1.7,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "DS-L4 Viewer",
    Category: "PHOTOGRAPHY",
    Rating: 3.5,
    Reviews: 13,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "January 29, 2018",
    "Current Ver": "1.2.0.9",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "DS Tower Defence",
    Category: "GAME",
    Rating: 3.2,
    Reviews: 768,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "June 5, 2013",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 1,
  },
  {
    App: "DS-Admin",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 5, 2018",
    "Current Ver": 2,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "NDS-controller",
    Category: "TOOLS",
    Rating: 3.3,
    Reviews: 35,
    Size: "916k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 23, 2017",
    "Current Ver": 0.2,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "DS-11 form",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 3,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 27, 2018",
    "Current Ver": "1.7.7",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "SmartCircle Remote DS",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 22, 2018",
    "Current Ver": 2.983,
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "RetroArch",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 21423,
    Size: "84M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "May 4, 2018",
    "Current Ver": "1.7.3",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "DS Speedometer & Odometer",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.9,
    Reviews: 22382,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "March 22, 2018",
    "Current Ver": 6.93,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "MegaN64 (N64 Emulator)",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 877576,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 14, 2016",
    "Current Ver": 6,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "DS-20000S",
    Category: "PRODUCTIVITY",
    Rating: 1.8,
    Reviews: 12,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.2.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DS Vision",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 21, 2018",
    "Current Ver": 1.2,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Learn DS [BETA]",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 9,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 12, 2017",
    "Current Ver": 0.5,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Deep Sleep Battery Saver Pro",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 1417,
    Size: "2.9M",
    Type: "Paid",
    Price: "$3.28",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 15, 2017",
    "Current Ver": 5.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DS - xR",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "November 21, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DS-Students",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 5,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 3, 2018",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DS Thermometer",
    Category: "WEATHER",
    Rating: 3.7,
    Reviews: 631,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "May 30, 2015",
    "Current Ver": 2.2,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "PhotoFrame for Synology DS",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 1,
    Size: "2.6M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 2, 2017",
    "Current Ver": 1.5,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Deep Sleep Battery Saver",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 22032,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 17, 2017",
    "Current Ver": 5.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Draft Simulator for FUT 18",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 162933,
    Size: "100M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 11, 2018",
    "Current Ver": 25.7,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "DS Flashlight",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 127,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 30, 2015",
    "Current Ver": 1.31,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "DS-82 form",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 27, 2018",
    "Current Ver": "1.7.7",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "dt Pro",
    Category: "FINANCE",
    Rating: 4.8,
    Reviews: 4,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 16, 2017",
    "Current Ver": 3.1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "DT",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 24, 2018",
    "Current Ver": "7.2.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DT Manager",
    Category: "PRODUCTIVITY",
    Rating: 4,
    Reviews: 9,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 21, 2015",
    "Current Ver": 1.7,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Real Sheet ∞: Pathfinder + DT",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 2,
    Size: "22M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "March 20, 2017",
    "Current Ver": 1.1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "DT-CAM",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 6,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 29, 2017",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "DT Fieldlink",
    Category: "BUSINESS",
    Rating: 3,
    Reviews: 2,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "September 19, 2017",
    "Current Ver": "2.1.1",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "DT Driving Test Theory",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 477,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 22, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DT Smart",
    Category: "TOOLS",
    Rating: 1.6,
    Reviews: 39,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 7, 2017",
    "Current Ver": "1.1.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Truck Simulator DT 3D",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 110,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "April 23, 2017",
    "Current Ver": "1.0.6",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "DT Baby Cam",
    Category: "TOOLS",
    Rating: 1.7,
    Reviews: 10,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 5, 2017",
    "Current Ver": 3,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Bloons TD 5",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 190086,
    Size: "94M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "July 13, 2018",
    "Current Ver": 3.16,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "WPBS-DT",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 3,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 3, 2015",
    "Current Ver": "4.1.1",
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "ReadyOp DT",
    Category: "COMMUNICATION",
    Rating: 4.6,
    Reviews: 8,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 6, 2018",
    "Current Ver": "1.0.56",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Soccer Manager 2018",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 63779,
    Size: "95M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 16, 2018",
    "Current Ver": "1.5.6",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Online Soccer Manager (OSM)",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 1312936,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.4.06",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DT-VR",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 25,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 9, 2016",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Dt Tracking",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4,
    Reviews: 4,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "October 28, 2016",
    "Current Ver": 0.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DT Simple Interval Timer",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 10,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 17, 2014",
    "Current Ver": 1.01,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "DT Health",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "November 20, 2017",
    "Current Ver": "2.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DT CLOTHINGS",
    Category: "SHOPPING",
    Rating: 5,
    Reviews: 1,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.0.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "PAY DT",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 6, 2018",
    "Current Ver": "1.1.0",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Test Application DT 02",
    Category: "ART_AND_DESIGN",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "March 14, 2017",
    "Current Ver": 4,
    numInstall: 0,
    numAndroid: 4,
  },
  {
    App: "Eat Right Diet (by Dt Shreya's Family Diet Clinic)",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 7, 2018",
    "Current Ver": "1.0.7",
    numInstall: 10,
    numAndroid: 5,
  },
  {
    App: "DT Practice",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 6,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 6, 2017",
    "Current Ver": "1.1.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Dt. Jyothi Srinivas",
    Category: "HEALTH_AND_FITNESS",
    Rating: 5,
    Reviews: 18,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "February 6, 2018",
    "Current Ver": "1.0.6",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DT future1 cam",
    Category: "TOOLS",
    Rating: 1,
    Reviews: 1,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 27, 2018",
    "Current Ver": 3.1,
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "DT Freight",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 29, 2017",
    "Current Ver": 8,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Johor DT Lock Screen",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 13,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 17, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "PES CLUB MANAGER",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 783025,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 7, 2018",
    "Current Ver": "1.7.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Riptide GP: Renegade",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 4328,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone 10+",
    Genres: "Racing",
    "Last Updated": "June 1, 2018",
    "Current Ver": "1.2.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Wheelie Challenge",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 137338,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "July 13, 2018",
    "Current Ver": 1.44,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "DT NO.I",
    Category: "HEALTH_AND_FITNESS",
    Rating: 2.4,
    Reviews: 44,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 1, 2018",
    "Current Ver": "V1.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DT Technologies",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 7, 2018",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DTPay",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 18,
    Size: "994k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 11, 2018",
    "Current Ver": "0.8.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: '"i DT" Fútbol. Todos Somos Técnicos.',
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 27,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "October 7, 2017",
    "Current Ver": 0.22,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "MasterDT",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 24,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 30, 2018",
    "Current Ver": 4.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Top Soccer Manager",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 199739,
    Size: "66M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 6, 2018",
    "Current Ver": "1.18.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "The Secret Daily Teachings",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 206,
    Size: "32M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "February 11, 2018",
    "Current Ver": 14,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Spring flowers theme couleurs d t space",
    Category: "ART_AND_DESIGN",
    Rating: 5,
    Reviews: 1,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design",
    "Last Updated": "April 18, 2018",
    "Current Ver": "1.0.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Soccer Board Tactics",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 6231,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 9, 2018",
    "Current Ver": 10.36,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dirt Trackin Sprint Cars",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 499,
    Size: "47M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "May 10, 2018",
    "Current Ver": "1.0.13",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "senior easy phone",
    Category: "PERSONALIZATION",
    Rating: 3.9,
    Reviews: 168,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "March 27, 2015",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "dt.se",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.1,
    Reviews: 124,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 29, 2018",
    "Current Ver": "4.9.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "WhatsVPN - Unlimited Free VPN",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 24985,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 27, 2018",
    "Current Ver": "2.2.927",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Cache Cleaner-DU Speed Booster (booster & cleaner)",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 12759815,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 25, 2018",
    "Current Ver": "3.1.2",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "du app",
    Category: "LIFESTYLE",
    Rating: 3.5,
    Reviews: 7578,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 24, 2018",
    "Current Ver": 3.98,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "DU Battery Saver - Battery Charger & Battery Life",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 13479633,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 5, 2018",
    "Current Ver": "4.8.7.8",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "DU Antivirus Security - Applock & Privacy Guard",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 436615,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 5, 2018",
    "Current Ver": "3.3.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DU Cleaner – Memory cleaner & clean phone cache",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 465831,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.5.9.9",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DU Launcher - Boost Your Phone",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 67707,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "February 7, 2016",
    "Current Ver": "1.8.0.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "DU Security",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 4847,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 29, 2016",
    "Current Ver": "3.0.0.2071",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DU Browser—Browse fast & fun",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 1133539,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 1, 2016",
    "Current Ver": "6.4.0.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DU Privacy-hide apps、sms、file",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 21762,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "August 16, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "DU Browser Mini(Small&Fast)",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 20941,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 23, 2016",
    "Current Ver": "1.12.23",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Caller ID & Call Block - DU Caller",
    Category: "COMMUNICATION",
    Rating: 4.6,
    Reviews: 93930,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2018",
    "Current Ver": "4.0.8",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Lock Screen - DU Locker & Lock screen wallpaper",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 5174,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 26, 2018",
    "Current Ver": "2.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "du View",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 935,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "March 26, 2018",
    "Current Ver": "6.4.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "DU Emoji Keyboard（Simeji）",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 19234,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 23, 2017",
    "Current Ver": "3.1.3",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "DU GIF Maker: GIF Maker, Video to GIF & GIF Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 7605,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "April 10, 2018",
    "Current Ver": "1.2.2.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "DU Flashlight - Brightest LED & Flashlight Free",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 73821,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Upgrade for Android DU Master",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 12993,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 9, 2017",
    "Current Ver": "1.3.0",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Modern: DU Launcher Theme",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 868,
    Size: "309k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "October 15, 2015",
    "Current Ver": 1.1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Weather Forecast Pro",
    Category: "WEATHER",
    Rating: 4.7,
    Reviews: 14051,
    Size: "8.7M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 4, 2018",
    "Current Ver": 8.5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Night: DU Launcher Theme",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 1419,
    Size: "485k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "October 15, 2015",
    "Current Ver": 1.1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "DU Collage Maker - Photo Collage & Grid & Layout",
    Category: "PHOTOGRAPHY",
    Rating: 4.7,
    Reviews: 4595,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "September 4, 2017",
    "Current Ver": "1.4.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Du Chinese – Mandarin Lessons",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 3390,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 3, 2017",
    "Current Ver": "1.5.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Portes du Soleil",
    Category: "SPORTS",
    Rating: 3.1,
    Reviews: 500,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 16, 2018",
    "Current Ver": 10.012,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Sword of Chaos - Lame du Chaos",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 23599,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "June 1, 2018",
    "Current Ver": "11.0.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Hadith du jour",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 276,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 22, 2016",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Bible du Semeur-BDS (French)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 313,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 4, 2018",
    "Current Ver": 0.7,
    numInstall: 50000,
    numAndroid: 1,
  },
  {
    App: "La citadelle du musulman",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 314,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "March 17, 2016",
    "Current Ver": 2.1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Voyance du pyromancien",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 22,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 13, 2018",
    "Current Ver": "1.0.3",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Clean My Android",
    Category: "PRODUCTIVITY",
    Rating: 4.7,
    Reviews: 101163,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.4.5.2",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Citation du Jour - Motivation",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 321,
    Size: "914k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 14, 2015",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "La Poupée du Voyant",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 265,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 6, 2017",
    "Current Ver": "1.0.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Star Chart",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 128808,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "APUS Booster - Space Cleaner & Booster",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 1048766,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.6.28",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Officiel du SCRABBLE LAROUSSE",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.4,
    Reviews: 116,
    Size: "48M",
    Type: "Paid",
    Price: "$4.60",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "October 13, 2016",
    "Current Ver": 1.4,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Proverbes du monde",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 38,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 12, 2018",
    "Current Ver": "1.1.2.0",
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "GO Security－AntiVirus, AppLock, Booster",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 1251479,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "iSmart DV",
    Category: "VIDEO_PLAYERS",
    Rating: 3.6,
    Reviews: 5692,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 27, 2018",
    "Current Ver": "R1.4.14.B1.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "dv Prompter",
    Category: "VIDEO_PLAYERS",
    Rating: 3.7,
    Reviews: 321,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "March 14, 2017",
    "Current Ver": "1.2.9",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Sports DV",
    Category: "LIFESTYLE",
    Rating: 2.1,
    Reviews: 86,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 17, 2018",
    "Current Ver": "3.0.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Live DV",
    Category: "PHOTOGRAPHY",
    Rating: 2,
    Reviews: 16,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 9, 2018",
    "Current Ver": "1.0.6",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Mini DV",
    Category: "AUTO_AND_VEHICLES",
    Rating: 3.5,
    Reviews: 12,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "May 29, 2018",
    "Current Ver": 1.27,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DV-2019 Results",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 158,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 14, 2018",
    "Current Ver": 17,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "AKASO DV",
    Category: "TOOLS",
    Rating: 2.4,
    Reviews: 99,
    Size: "71M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 26, 2018",
    "Current Ver": "V1.0.9",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DV-LOTTERY 2019 REGISTRATION",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 97,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 20, 2018",
    "Current Ver": 3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Selfie DV",
    Category: "TOOLS",
    Rating: 2.8,
    Reviews: 29,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 24, 2017",
    "Current Ver": "2.3.26",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DV-4036 by Somikon",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 17,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "January 19, 2017",
    "Current Ver": "0.0.5",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DV 2019 Entry Guide",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 92,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "October 18, 2017",
    "Current Ver": "2.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Touch DV",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 1,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 7, 2017",
    "Current Ver": 10.4,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Porch DV",
    Category: "HOUSE_AND_HOME",
    Rating: 2.8,
    Reviews: 5,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "June 2, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DV 2019 - EDV Photo & Form",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.9,
    Reviews: 314,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "October 24, 2016",
    "Current Ver": "6.0.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "SDV Cam",
    Category: "TOOLS",
    Rating: 3.2,
    Reviews: 67,
    Size: "65M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 2, 2017",
    "Current Ver": "1.0.8",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "XDV",
    Category: "PHOTOGRAPHY",
    Rating: 3.1,
    Reviews: 6827,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "April 20, 2018",
    "Current Ver": "1.9.5",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "WiFi Action Camera",
    Category: "SPORTS",
    Rating: 2.4,
    Reviews: 551,
    Size: "903k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 13, 2014",
    "Current Ver": 1.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DV Car Service",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.6,
    Reviews: 10,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 9, 2017",
    "Current Ver": 1.002,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DV Lottery Photo",
    Category: "VIDEO_PLAYERS",
    Rating: 2.9,
    Reviews: 23,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "December 16, 2016",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "DV Lottery Photo Tool",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 223,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "October 28, 2017",
    "Current Ver": 1.06,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "iCam - Webcam Video Streaming",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 770,
    Size: "2.4M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 7, 2016",
    "Current Ver": "1.6.7",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "DV KING 4K",
    Category: "PHOTOGRAPHY",
    Rating: 2.3,
    Reviews: 3,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.0.10",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Wifi Action Camera",
    Category: "PHOTOGRAPHY",
    Rating: 2.9,
    Reviews: 118,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.3.5",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "US DV Lottery 2020 Apply",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.6,
    Reviews: 41,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "January 14, 2018",
    "Current Ver": 1.02,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DV-2019 PHOTO TOOL",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 21,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 20, 2018",
    "Current Ver": 5,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DV ASSIST",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 1,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 2, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "4K Ultra Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 382,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 30, 2018",
    "Current Ver": "39.272.12",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "DV Lottery Simulator",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 13,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "October 20, 2016",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "U.S.A DV Lottery Process",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 8,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 12, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DV Statistics",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 6,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "October 8, 2015",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DV 2018 Winners Guide",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.8,
    Reviews: 11,
    Size: "608k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 23, 2017",
    "Current Ver": 1.09,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "MelifeCam-M",
    Category: "VIDEO_PLAYERS",
    Rating: 3.5,
    Reviews: 81,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 21, 2016",
    "Current Ver": "R1.3.21.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DV-2019 UK/British",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 166,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 11, 2018",
    "Current Ver": 3,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "GoPlus Cam",
    Category: "VIDEO_PLAYERS",
    Rating: 3.5,
    Reviews: 3484,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "December 18, 2017",
    "Current Ver": "3.0.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "GoAction",
    Category: "VIDEO_PLAYERS",
    Rating: 3.6,
    Reviews: 1522,
    Size: "65M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 17, 2018",
    "Current Ver": "V1.5.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DV Portfolio",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 23, 2017",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "DV Youth",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 5,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "April 25, 2016",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DV KING",
    Category: "PHOTOGRAPHY",
    Rating: 3,
    Reviews: 2,
    Size: "9.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "September 19, 2017",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "DV - Digito Verificador",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 2,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 2, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "DV Web Design Tips",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 1,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Productivity",
    "Last Updated": "October 26, 2017",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DENVER ACTION CAM 3",
    Category: "PHOTOGRAPHY",
    Rating: 2.9,
    Reviews: 66,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "November 16, 2016",
    "Current Ver": "1.0.2",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "4K VIDEO PLAYER ULTRA HD",
    Category: "VIDEO_PLAYERS",
    Rating: 3.7,
    Reviews: 20,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "May 1, 2017",
    "Current Ver": 7,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "US DV Lottery 2019",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.6,
    Reviews: 14,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "April 12, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BlueDV AMBE",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "Hotel Insanity",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 3816,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "July 7, 2016",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "SportCAM",
    Category: "TOOLS",
    Rating: 3.2,
    Reviews: 427,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 4, 2018",
    "Current Ver": "1.7.6",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "SportLook",
    Category: "PHOTOGRAPHY",
    Rating: 2.5,
    Reviews: 1283,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 21, 2018",
    "Current Ver": "1.2.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DW - Breaking World News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.4,
    Reviews: 17671,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "August 6, 2018",
    "Current Ver": "2.3.10",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "DW Learn German - A1, A2, B1 and placement test",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 902,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 28, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DW Mobile",
    Category: "BUSINESS",
    Rating: 2.7,
    Reviews: 33,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "DW Spectrum™ IPVMS Mobile",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 44,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 19, 2018",
    "Current Ver": "18.1.18164",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DW Amharic by AudioNow Digital",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 322,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 26, 2018",
    "Current Ver": "4.0.9",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DW VMAX",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 843,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 4, 2017",
    "Current Ver": "3.7.1",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "News: DW Español",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 25,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "April 26, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DW Contacts & Phone & Dialer",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 21186,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "DW",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 13, 2018",
    "Current Ver": "1.0.5",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "DW Arabic By dw-arab.com",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 386,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "October 27, 2017",
    "Current Ver": 3.2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "DW Espanol",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 5, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "News :DW Bangali",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 1,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 2, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Learn German: Die Bienenretter",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 25,
    Size: "79M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "July 26, 2017",
    "Current Ver": "1.0.5",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "News: DW Hausa",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.9,
    Reviews: 9,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "April 26, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DW Spectrum™ IP VMS",
    Category: "BUSINESS",
    Rating: 3.4,
    Reviews: 102,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 14, 2016",
    "Current Ver": "2.5.0-prod",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "DW Audio",
    Category: "FAMILY",
    Rating: 4.9,
    Reviews: 38,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 16, 2017",
    "Current Ver": "0.9.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DW Contacts widget",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 56,
    Size: "2.0M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 5, 2014",
    "Current Ver": "1.1.0.0",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "DW فارسی By dw-arab.com",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.7,
    Reviews: 11,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "March 26, 2017",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "German Listening",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 18298,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 23, 2018",
    "Current Ver": 2.94,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Deaf World DW",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 298,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "November 28, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DW Event",
    Category: "EVENTS",
    Rating: 4.3,
    Reviews: 9,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "May 29, 2018",
    "Current Ver": "2.32.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DW Witness",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 6,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 14, 2018",
    "Current Ver": "1.1.2",
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "Fahrschule DW",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 5,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 19, 2016",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Downvids Helper - One touch DW",
    Category: "VIDEO_PLAYERS",
    Rating: 3.5,
    Reviews: 197,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "February 5, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DW Tech Tools",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 24, 2018",
    "Current Ver": 26.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DW Security",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 6,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 25, 2018",
    "Current Ver": 69.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "News: RFI Hausa",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.7,
    Reviews: 10,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "April 28, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "ZAK DW",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Business",
    "Last Updated": "November 13, 2015",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DW Contacts Wear",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 37,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 9, 2015",
    "Current Ver": "0.0.0.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Hausa Radio",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.4,
    Reviews: 3375,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 31, 2018",
    "Current Ver": 4.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Digi Dex for DW Next Order @PS4",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 155,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 24, 2018",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "DW Timer",
    Category: "TOOLS",
    Rating: 5,
    Reviews: 9,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 5, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 1,
  },
  {
    App: "DW Streaming",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "May 27, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "RETRO Shocked DW-6000",
    Category: "PERSONALIZATION",
    Rating: 5,
    Reviews: 13,
    Size: "500k",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 4, 2017",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "VMAX IP Plus Mobile Client",
    Category: "BUSINESS",
    Rating: 2,
    Reviews: 9,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 9, 2017",
    "Current Ver": "1.1.12",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Rose Gold DW Watch Theme",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.1.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DW Maps",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.7,
    Reviews: 35,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 6, 2017",
    "Current Ver": 1.9,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "DW Uninstall Applications",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 5, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "Bodyworks DW",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "4.2.2",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DW Cleaner",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 7,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 5, 2018",
    "Current Ver": 1.7,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "DW Missed call cleaner patch",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 65,
    Size: "54k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 27, 2014",
    "Current Ver": 1.4,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Swahili Radio",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 171,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 30, 2018",
    "Current Ver": 3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Black Classic DW Watch Theme",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.1.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "White Classic Petite Watch Theme for DW",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 2,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.1.1",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "D.W Bien Être",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "April 6, 2016",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "DX",
    Category: "SHOPPING",
    Rating: 3.1,
    Reviews: 6697,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "February 1, 2018",
    "Current Ver": "4.2.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Direct Express®",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 6156,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 9, 2017",
    "Current Ver": "1.0.10",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Retro City Rampage DX",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 416,
    Size: "16M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "January 12, 2017",
    "Current Ver": "1.0.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "KeePass DX",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000,
    numAndroid: null,
  },
  {
    App: "PORTABLE SOCCER DX",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 552,
    Size: "1.6M",
    Type: "Paid",
    Price: "$1.00",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 19, 2018",
    "Current Ver": 3.4,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Across Age DX",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 5964,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "January 9, 2015",
    "Current Ver": "1.1.0",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "ZOOKEEPER DX TouchEdition",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 3195,
    Size: "4.6M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "November 26, 2015",
    "Current Ver": "1.2.7",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Ham DX Cluster & Spots Finder",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 115,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 15, 2016",
    "Current Ver": "1.4.4",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "KeePass DX Pro",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100,
    numAndroid: null,
  },
  {
    App: "DX Alerts",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 22,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 19, 2016",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Piczle Lines DX",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 281,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 15, 2018",
    "Current Ver": "1.4.6",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "PORTABLE SOCCER DX Lite",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 15068,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 19, 2018",
    "Current Ver": 3.4,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "DX Spots Free",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 46,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 18, 2018",
    "Current Ver": "2.0.402",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "3DAnimeGirl DX DreamPortrait KAWAII Girl DressUp",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 449,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "February 16, 2018",
    "Current Ver": 1.5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Bubble Shooter DX",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 636,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "June 21, 2018",
    "Current Ver": 1.21,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DX Alert",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 27,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 28, 2016",
    "Current Ver": 1.131,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Age of Procreation DX",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1894,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Simulation",
    "Last Updated": "April 22, 2016",
    "Current Ver": 1.441,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Chronolink DX",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 7,
    Size: "73M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 6, 2017",
    "Current Ver": 1.2,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DX Simulation for OOO Dx Belt",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 67,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 4, 2018",
    "Current Ver": 1.7,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Differential Dx Free",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 238,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Medical",
    "Last Updated": "January 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Tricky Bike Stunt Rider DX",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 16,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation;Education",
    "Last Updated": "July 29, 2018",
    "Current Ver": "1.1.1",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "DX Gashacon Sword for Ex-Aid Henshin",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 17,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 14, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DX Simulation Belt for Build henshin",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 182,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 11, 2018",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Active Soccer 2 DX",
    Category: "SPORTS",
    Rating: 3.6,
    Reviews: 28,
    Size: "48M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 28, 2017",
    "Current Ver": "1.0.3",
    numInstall: 500,
    numAndroid: 1,
  },
  {
    App: "DX Simulation for Kabuto Henshin Belt 2018",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 14,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 6, 2018",
    "Current Ver": 1.5,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DX Simulation for Decade Henshin Belt 2018",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 23,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 6, 2018",
    "Current Ver": 1.6,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Elemental Galaxy Dx - Match3",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 127,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "March 11, 2014",
    "Current Ver": "1.0.9",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "DX Simulation for Double Dx Henshin Belt 2018",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 33,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 6, 2018",
    "Current Ver": 1.5,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Mircules DX Cluster Lite",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 51,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 10, 2016",
    "Current Ver": 3,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DX Simulation Belt for Decade henshin",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 64,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 27, 2018",
    "Current Ver": 3,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Chronolink DX Lite",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "October 9, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Shoot! DX - lights for FREE",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 4,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "June 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100,
    numAndroid: null,
  },
  {
    App: "Bubble Shooter DX AdFree",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.1M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 31, 2016",
    "Current Ver": 1.02,
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "Human Dx",
    Category: "MEDICAL",
    Rating: 4.8,
    Reviews: 6,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Human Dx",
    numInstall: 500,
    numAndroid: 6,
  },
  {
    App: "Santa's Monster Shootout DX",
    Category: "GAME",
    Rating: 5,
    Reviews: 4,
    Size: "33M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 15, 2013",
    "Current Ver": 1.05,
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "DX Glow - Clock Widget",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 5,
    Size: "3.4M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 20, 2015",
    "Current Ver": 2,
    numInstall: 50,
    numAndroid: 3,
  },
  {
    App: "iCluster - The DX-Cluster database",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "17M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 26, 2018",
    "Current Ver": 1.7,
    numInstall: 10,
    numAndroid: 6,
  },
  {
    App: "MBU DX Cluster",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 5,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 16, 2015",
    "Current Ver": "0.0.1",
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Dress Up RagazzA13 DX",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 13,
    Size: "42M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "September 16, 2016",
    "Current Ver": "1.0.5",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Cloud DX Connected Health",
    Category: "HEALTH_AND_FITNESS",
    Rating: 5,
    Reviews: 6,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 19, 2017",
    "Current Ver": "1.7.10713 (281)",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DX Simulation for X-aid Dx Belt",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 35,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 4, 2018",
    "Current Ver": 1.6,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Unstoppaball DX",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 5,
    Size: "40M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "May 20, 2014",
    "Current Ver": 1.7,
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "Differential Dx",
    Category: "MEDICAL",
    Rating: 4,
    Reviews: 8,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500,
    numAndroid: null,
  },
  {
    App: "Sokoban Land DX",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 46,
    Size: "20M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "January 29, 2018",
    "Current Ver": "1.0.6",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Multiple Sclerosis Dx & Mgmt.",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 131,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "September 25, 2017",
    "Current Ver": 5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Dx Ludo",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 215,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 18, 2011",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "My Dy Dice - 3D Dice Roller",
    Category: "LIFESTYLE",
    Rating: 4.2,
    Reviews: 9,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 20, 2016",
    "Current Ver": 1.01,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Dy So Exam",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 6,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 3, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "edp re:dy",
    Category: "TOOLS",
    Rating: 3,
    Reviews: 172,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 20, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "Dr. D. Y. Patil Vidyapeeth GBS",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 3,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 14, 2017",
    "Current Ver": "1.0.1702140017",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "edp re:dy smarthome",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 30,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 7, 2017",
    "Current Ver": "1.2.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "KPS CHAUHAN DY/DX",
    Category: "FAMILY",
    Rating: 4.9,
    Reviews: 37,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 28, 2018",
    "Current Ver": "1.0.32.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DY Fitness",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 6, 2018",
    "Current Ver": "4.4.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "dy n fly",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 1,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 5, 2018",
    "Current Ver": "1.0.3",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Cnady Selfie : You Can Dy Snap Camera",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 8,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 6, 2018",
    "Current Ver": 2.6,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "junainfo.dy.fi",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 8,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "October 21, 2015",
    "Current Ver": "0.0.9",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "DY TECHNICAL GYAN",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 2,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 17, 2018",
    "Current Ver": "1.1.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "JONACK (D Story Teller)",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 152,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 28, 2015",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "American Sniper City Fight Shooting Assassin",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 395,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "November 24, 2017",
    "Current Ver": 1.4,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Guardians of Ancora",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 969,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Action & Adventure",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.9.1",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Train Sim Pro",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 1763,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Simulation;Pretend Play",
    "Last Updated": "June 25, 2018",
    "Current Ver": "3.9.9",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Displaying You VR",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 1,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "October 19, 2016",
    "Current Ver": "3.0.6.2",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Cute Dolphin Keyboard",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 237,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.279.13.93",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Truck Transport Raw Material",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 632,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 20, 2018",
    "Current Ver": 1.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Hidden Camera Detector",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 167,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 8, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DYPhyzio-Physiology Forum",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 4,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 22, 2017",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Street Skater 3D",
    Category: "GAME",
    Rating: 3.6,
    Reviews: 120852,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "October 24, 2017",
    "Current Ver": 1.1,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "DYPSOET",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 8,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 7, 2018",
    "Current Ver": "1.0.2",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Triceratops - Dino Robot",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 3032,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "December 18, 2017",
    "Current Ver": "1.2.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Differential Equations Steps",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 1185,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 11, 2017",
    "Current Ver": "5.3.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dz Dinars Numbers to letters",
    Category: "PRODUCTIVITY",
    Rating: 4.7,
    Reviews: 2807,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 15, 2016",
    "Current Ver": "0.74 11.12.2016",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "dz NEWS Algerie",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.2,
    Reviews: 2318,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "December 13, 2014",
    "Current Ver": 2.3,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Siyaha Dz",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 289,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "March 13, 2018",
    "Current Ver": "2.6.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CCP DZ : Fill out a check | Number in letters DZD",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 642,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 27, 2018",
    "Current Ver": "2018-04-27",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DZ Puzzle",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 14,
    Size: "47M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 22, 2017",
    "Current Ver": 1.2,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "DZ Mobile Market",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 59,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "February 1, 2018",
    "Current Ver": "1.0.3-DzMobile",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "3G DZ Configuration",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 488,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "November 19, 2015",
    "Current Ver": "6.2.3",
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "3G/4G Config Dz",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 2058,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 15, 2017",
    "Current Ver": "3.0.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Drugs Dz - Algeria",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 187,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 29, 2017",
    "Current Ver": "0.0.7",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "amm dz",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "14M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 8, 2018",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "IRIS : Customer Service - DZ Algeria",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.7,
    Reviews: 57,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "March 10, 2018",
    "Current Ver": "2018-03",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Numbers Into Words",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 457,
    Size: "562k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 6, 2014",
    "Current Ver": 1.2,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Dz kayas",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "14M",
    Type: "Paid",
    Price: "$28.99",
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 12, 2018",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Météo Algérie DZ",
    Category: "WEATHER",
    Rating: 4.1,
    Reviews: 1238,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "December 17, 2014",
    "Current Ver": "1.1.6",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "DZ Popup Video Player",
    Category: "VIDEO_PLAYERS",
    Rating: 4.5,
    Reviews: 83,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "May 16, 2018",
    "Current Ver": 4.6,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "DZ PROMOS - Promotions & Sale Alerts in Algeria",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 331,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 10, 2017",
    "Current Ver": 2.51,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "JNews DZ - Algerian Newspapers",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 146,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 16, 2016",
    "Current Ver": 2.4,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "DZ-JOKER",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 6,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 4, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Super ball DZ",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 24,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "September 21, 2017",
    "Current Ver": "1.0.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ouedkniss",
    Category: "SHOPPING",
    Rating: 4.3,
    Reviews: 10355,
    Size: "847k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "June 19, 2018",
    "Current Ver": "1.5.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Files To SD Card Pro",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 994,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 18, 2018",
    "Current Ver": "6.0.0",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "News Dz",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 3,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 19, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "My Ooredoo Algeria",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 3606,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 24, 2018",
    "Current Ver": "1.22.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Currency Exchange DZ",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 4,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "November 10, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "PHARMAGUIDE (DZ)",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.1,
    Reviews: 131,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "April 1, 2016",
    "Current Ver": 1.06,
    numInstall: 5000,
    numAndroid: 1,
  },
  {
    App: "لعبة تقدر تربح DZ",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 238,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 18, 2016",
    "Current Ver": "6.0.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DEM DZ",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "957k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "November 13, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "chat dz",
    Category: "COMMUNICATION",
    Rating: 5,
    Reviews: 8,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "March 14, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Devise Dz",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 26,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 29, 2017",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "BAC DZ Questionnaire",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 38,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000,
    numAndroid: null,
  },
  {
    App: "Ludo Dz",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 17,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "August 27, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "ONEC DZ",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 40,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 13, 2018",
    "Current Ver": 4,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Agent HQ for The Division",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 1060,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 17, 2018",
    "Current Ver": 0.35,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DZ Urgences",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 16,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 21, 2016",
    "Current Ver": 2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "infirmiers",
    Category: "MEDICAL",
    Rating: 4.7,
    Reviews: 125,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 7, 2018",
    "Current Ver": 12,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "DZ sim",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 417,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 26, 2018",
    "Current Ver": 3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Tuberculose Dz",
    Category: "MEDICAL",
    Rating: 4.9,
    Reviews: 26,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "November 6, 2016",
    "Current Ver": "1.0.7",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DZ Fly Algérie Horaire Vols",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.6,
    Reviews: 114,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "October 31, 2016",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "3G to 4G Converter - Simulator",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 268,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 21, 2018",
    "Current Ver": "3.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "dekoreko-dz",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 16,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "March 3, 2018",
    "Current Ver": "1.0.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "ChangeDA - Cours du DZD sur le marché parallèle",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 188,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 28, 2018",
    "Current Ver": 2.5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "dz press",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 30,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 30, 2015",
    "Current Ver": 1.8,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Tunisian Dinar: Exchange rate",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 625,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 30, 2018",
    "Current Ver": 2.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "love sms good morning",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 10,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 28, 2016",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Dz Camera",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 19, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "quran-DZ",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "June 13, 2018",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "DZ Blagues",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 580,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 19, 2012",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "DZ Register",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.0.6",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "EA SPORTS UFC®",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 2371338,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Sports",
    "Last Updated": "July 24, 2017",
    "Current Ver": "1.9.3097721",
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "NBA LIVE Mobile Basketball",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 1690802,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 21, 2018",
    "Current Ver": "2.3.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Need for Speed™ No Limits",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 3344300,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Racing",
    "Last Updated": "July 24, 2018",
    "Current Ver": "2.12.1",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Real Racing 3",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 354454,
    Size: "71M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "July 2, 2018",
    "Current Ver": "6.4.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Madden NFL Football",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 1455952,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports;Action & Adventure",
    "Last Updated": "May 15, 2018",
    "Current Ver": "4.3.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "EA SPORTS™ FIFA 18 Companion",
    Category: "SPORTS",
    Rating: 3.9,
    Reviews: 282727,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "December 7, 2017",
    "Current Ver": "18.0.5.172734",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "The Simpsons™: Tapped Out",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 636995,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.34.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Plants vs. Zombies™ 2",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 567632,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Casual",
    "Last Updated": "June 12, 2018",
    "Current Ver": "6.8.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Command & Conquer: Rivals",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "NaN",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "June 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 0,
    numAndroid: null,
  },
  {
    App: "Star Wars™: Galaxy of Heroes",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 1461698,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "May 21, 2018",
    "Current Ver": "0.12.334385",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Dungeon Keeper",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 69574,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.8.91",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Lost Journey (Dreamsky)",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 32344,
    Size: "29M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "October 21, 2016",
    "Current Ver": "1.3.12",
    numInstall: 1000000,
    numAndroid: 3,
  },
  {
    App: "TETRIS",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 199808,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "June 14, 2018",
    "Current Ver": "3.0.10",
    numInstall: 10000000,
    numAndroid: 3,
  },
  {
    App: "Bejeweled Classic",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 203101,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "NBA JAM by EA SPORTS™",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 56444,
    Size: "43M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Sports;Action & Adventure",
    "Last Updated": "February 8, 2017",
    "Current Ver": "04.00.40",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "EA Plus",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 2.5,
    Reviews: 12,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "November 3, 2017",
    "Current Ver": 1.4,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "TETRIS Blitz",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 201631,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "June 1, 2018",
    "Current Ver": "4.4.4",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "POGO Games",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 32600,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "February 22, 2017",
    "Current Ver": "1.4.10",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SW Battlefront Companion",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 93870,
    Size: "79M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "February 3, 2016",
    "Current Ver": "1.0.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Bejeweled Blitz",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 222664,
    Size: "98M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.6.0.125",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Peggle Blast",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 166251,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "December 11, 2017",
    "Current Ver": "2.16.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Heroes of Dragon Age",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 70389,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "May 9, 2018",
    "Current Ver": "5.3.1",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "SCRABBLE",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 172281,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.27.0.729",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Asphalt Xtreme: Rally Racing",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 567984,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "July 16, 2018",
    "Current Ver": "1.7.3b",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "FIFA 16 Soccer",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 820577,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "January 25, 2017",
    "Current Ver": "3.3.118003",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "League of Stickman 2018- Ninja Arena PVP(Dreamsky)",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 32496,
    Size: "99M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 3, 2018",
    "Current Ver": "5.3.3",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Modern Combat 5: eSports FPS",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 2903386,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "July 24, 2018",
    "Current Ver": "3.2.1c",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Bejeweled Stars: Free Match 3",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 85484,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "August 2, 2018",
    "Current Ver": "2.17.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Mass Effect: Andromeda APEX HQ",
    Category: "GAME",
    Rating: 3.4,
    Reviews: 4490,
    Size: "92M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "September 21, 2017",
    "Current Ver": "1.18.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Mirror’s Edge™ Companion",
    Category: "GAME",
    Rating: 3.4,
    Reviews: 1995,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "June 28, 2016",
    "Current Ver": "1.2.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Stickman Legends: Shadow Wars",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 38419,
    Size: "100M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.3.24",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "MLB Perfect Inning 2018",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 42767,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.0.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Gear.Club - True Racing",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 140658,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.21.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Plants vs. Zombies™ Watch Face",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 33178,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "February 2, 2015",
    "Current Ver": "1.0.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Real Football",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 585564,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 1, 2018",
    "Current Ver": "1.5.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Typical EA Game",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 33,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "November 18, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EB Mobile",
    Category: "FAMILY",
    Rating: 1.7,
    Reviews: 1172,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 9, 2017",
    "Current Ver": "1.1.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EB Events",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.3,
    Reviews: 97,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "January 27, 2016",
    "Current Ver": 1.6,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "i am EB",
    Category: "PHOTOGRAPHY",
    Rating: 5,
    Reviews: 1,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Photography",
    "Last Updated": "February 1, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EB-Link",
    Category: "BUSINESS",
    Rating: 4.8,
    Reviews: 6,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 7, 2018",
    "Current Ver": "1.2.7",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Debra Care Conference",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 15, 2018",
    "Current Ver": "5.29.02",
    numInstall: 50,
    numAndroid: 5,
  },
  {
    App: "Exchange Bank - EB Mobile",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 8,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 2, 2018",
    "Current Ver": "18.1.79",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "TANGEDCO Mobile App (Official)",
    Category: "BUSINESS",
    Rating: 3.3,
    Reviews: 2915,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "November 3, 2017",
    "Current Ver": "1.0.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "EB-TV",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 6,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 25, 2018",
    "Current Ver": "2.2.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Free E B Garamond Cool Font",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 410,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 20, 2018",
    "Current Ver": 33,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "EB Kit",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 4,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 15, 2018",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Epson iProjection",
    Category: "PRODUCTIVITY",
    Rating: 3.5,
    Reviews: 3930,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 22, 2018",
    "Current Ver": "3.0.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "TN e Sevai TN EB Bill Patta Citta EC Birth All Hub",
    Category: "SOCIAL",
    Rating: 3.7,
    Reviews: 23,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "April 26, 2018",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "EB Scanner",
    Category: "PRODUCTIVITY",
    Rating: 5,
    Reviews: 9,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "February 11, 2018",
    "Current Ver": "1.7.8",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "TNEB Bill Online Payment (Tamil)",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 7,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 13, 2018",
    "Current Ver": 2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "EB Demo for Android",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "May 17, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "eBay Kleinanzeigen for Germany",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 318142,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Mental Hospital:EB 2 Lite",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 5341,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "April 30, 2014",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "EB Annual Meetings",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.5,
    Reviews: 11,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "April 13, 2018",
    "Current Ver": "9.4.7.6",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "UP EB Bill Payment & Details",
    Category: "SOCIAL",
    Rating: 5,
    Reviews: 3,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 11, 2018",
    "Current Ver": 2,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "EB-Banking (ersetzt)",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 24,
    Size: "70M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 18, 2018",
    "Current Ver": "17.25.11",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Tamilnadu EB Online Payment",
    Category: "FINANCE",
    Rating: 3.7,
    Reviews: 155,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Online Kerala EB Bill Pay",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 37,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "November 16, 2017",
    "Current Ver": "1.0.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "EB Remote Deposit",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 10, 2018",
    "Current Ver": 5.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EB-Chat – For my Events",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 2,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Events",
    "Last Updated": "November 16, 2017",
    "Current Ver": 1.4,
    numInstall: 10,
    numAndroid: 3,
  },
  {
    App: "বাংলাflix",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1111,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 5, 2018",
    "Current Ver": "3.6.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "EB Experience",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "October 19, 2017",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "TNEB Quick Pay Easy",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 28,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Finance",
    "Last Updated": "January 29, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "TNEB",
    Category: "BUSINESS",
    Rating: 3.8,
    Reviews: 1777,
    Size: "948k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 18, 2014",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "TNEB Bill Checker / TNEB Bill Status",
    Category: "FINANCE",
    Rating: 2.5,
    Reviews: 2,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 3, 2018",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Skin Disease",
    Category: "BEAUTY",
    Rating: 4,
    Reviews: 1,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "August 30, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Schlaumeier",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "688k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 17, 2015",
    "Current Ver": 0.1,
    numInstall: 5,
    numAndroid: 2,
  },
  {
    App: "Bihar Land Records - RoR and EB Quick Pay",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 8,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 7, 2018",
    "Current Ver": "1.0.1",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "TNEB Reading",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 28,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 19, 2017",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Eb & flow Yoga Studio",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "4.2.2",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Audiowalk EB",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "90M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 30, 2018",
    "Current Ver": "1.0.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "RPG ブレイジング ソウルズ アクセレイト",
    Category: "FAMILY",
    Rating: 3.4,
    Reviews: 159,
    Size: "3.1M",
    Type: "Paid",
    Price: "$10.99",
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "April 26, 2018",
    "Current Ver": 2.12,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Tamilnadu Electricity Info",
    Category: "TOOLS",
    Rating: 3.6,
    Reviews: 216,
    Size: "811k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 9, 2014",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "Punjab Online - Land Records • EB Bill Pay • RC/DL",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 16,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 7, 2018",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "energyly (TNEB,BESCOM,MH,DL..)",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 627,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 21, 2017",
    "Current Ver": 6,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Paraglider Dashboard",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 549,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 3, 2018",
    "Current Ver": "2.1.4",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Goodbox - Mega App",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 3429,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "March 8, 2018",
    "Current Ver": "1.10.279.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Exército Brasileiro",
    Category: "PRODUCTIVITY",
    Rating: 4.7,
    Reviews: 1730,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "February 1, 2018",
    "Current Ver": 1.5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "EB Cash Collections",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 1,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 31, 2018",
    "Current Ver": 1.1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "TN Electricity (TNEB)",
    Category: "LIFESTYLE",
    Rating: 3.9,
    Reviews: 73,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 21, 2016",
    "Current Ver": 8,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Electrician Calculator Pro",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 47,
    Size: "270k",
    Type: "Paid",
    Price: "$14.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 3, 2014",
    "Current Ver": 3.1,
    numInstall: 1000,
    numAndroid: 1,
  },
  {
    App: "Call Blocker - Blacklist, SMS Blocker",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 30350,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 16, 2018",
    "Current Ver": "10.0.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "英漢字典 EC Dictionary",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 55408,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 8, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "EC - AP & Telangana",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.5,
    Reviews: 10,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "November 10, 2017",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "TN EC Online New",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 7,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 21, 2018",
    "Current Ver": 2.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "TN Patta, Chitta, EC",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 633,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 21, 2016",
    "Current Ver": 6.7,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "TN Patta Chitta EC Info",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 1611,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 6, 2018",
    "Current Ver": 5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "EC music dictionary",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 20,
    Size: "2.2M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 29, 2014",
    "Current Ver": 2.1,
    numInstall: 500,
    numAndroid: 3,
  },
  {
    App: "EC Security",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 13,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 9, 2017",
    "Current Ver": "1.17.0.0",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "TN Patta Citta & EC",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.8,
    Reviews: 48,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "March 27, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "EC - Encumbrance Search - telangana state",
    Category: "BUSINESS",
    Rating: 3.4,
    Reviews: 45,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 18, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Ec Solutions Mobile",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "November 20, 2016",
    "Current Ver": 1.02,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Encumbrance Certificate - (Obsolete)",
    Category: "BUSINESS",
    Rating: 3.9,
    Reviews: 184,
    Size: "48k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 12, 2014",
    "Current Ver": 1.1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "My Handbook : EE, EC, EI, E&T, EEE, EECS",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 3776,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 24, 2017",
    "Current Ver": "8.07.021",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ec-Work",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 3,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 9, 2018",
    "Current Ver": 1.12,
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "ec.tv",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "November 11, 2016",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "EC-HRV test",
    Category: "SPORTS",
    Rating: 3,
    Reviews: 9,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 26, 2018",
    "Current Ver": "3.9.13",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EC MANAGER",
    Category: "VIDEO_PLAYERS",
    Rating: "NaN",
    Reviews: 2,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "June 13, 2018",
    "Current Ver": "8.3.13.6",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Barry EC",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 14,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 18, 2017",
    "Current Ver": "1.278.0037",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "New Holland Agriculture T5 EC",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 12,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "February 24, 2017",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "tv-ec",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 7, 2018",
    "Current Ver": 8.1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "EC Taximeter",
    Category: "PRODUCTIVITY",
    Rating: 3.9,
    Reviews: 162,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 14, 2018",
    "Current Ver": "3.0.21",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Walk Freely (Ec Shlire)",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 62,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 13, 2017",
    "Current Ver": "1.1.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EC Apps List",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 2,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 12, 2015",
    "Current Ver": 1.3,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "AP Stamps and Registration",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.4,
    Reviews: 82,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "March 27, 2018",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "EC Calgary",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 6,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Education",
    "Last Updated": "June 26, 2018",
    "Current Ver": "3.8.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Victoria EC",
    Category: "TOOLS",
    Rating: 5,
    Reviews: 5,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 30, 2018",
    "Current Ver": "1.283.0037",
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "EC SPORTS",
    Category: "SPORTS",
    Rating: 5,
    Reviews: 1,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 26, 2015",
    "Current Ver": "4.1.1",
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "ECナビ×シュフー",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 576,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 7, 2018",
    "Current Ver": "1.0.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EC Designer 2.0",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 9, 2018",
    "Current Ver": "0.0.44",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Arrayanes EC",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 2,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 27, 2018",
    "Current Ver": 3.5,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EC Reps",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 1,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 15, 2017",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EC QR",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.0.2",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EC Tax",
    Category: "FINANCE",
    Rating: 4.9,
    Reviews: 8,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 9, 2018",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "EC Fairgrounds",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 3,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 13, 2018",
    "Current Ver": "erie1.3.23.42-release",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "CompactiMa EC pH Calibration",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "December 22, 2016",
    "Current Ver": "1.1.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Kiamichi EC",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 7,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 23, 2018",
    "Current Ver": "1.283.0037",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "EC Games Datecs",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 76,
    Size: "329k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 12, 2016",
    "Current Ver": 4.4,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "TN Patta /Chitta /EC New",
    Category: "SOCIAL",
    Rating: 4.8,
    Reviews: 5,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 20, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "HOLSTON EC",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 7,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 23, 2018",
    "Current Ver": "1.278.0037",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "FILL EC",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 13,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 23, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Marítimo EC",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 14, 2018",
    "Current Ver": "1.9.8",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EC-Contractors",
    Category: "HOUSE_AND_HOME",
    Rating: "NaN",
    Reviews: 0,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "April 25, 2018",
    "Current Ver": 14.01,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "GATE Syllabus for EC 2018 & Notifications",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 23,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 28, 2017",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EC Sampler",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 31, 2018",
    "Current Ver": 1.4,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "EC Mover",
    Category: "GAME",
    Rating: 5,
    Reviews: 5,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "August 1, 2018",
    "Current Ver": 1.11,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "SCS eC",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 7,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 21, 2016",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "My EF",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 4114,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 10, 2018",
    "Current Ver": 3.29,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "EF Mentor: Words",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 403,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Education",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.7.0.00115",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EF Smart English for Phone",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 208,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 29, 2018",
    "Current Ver": "1.2.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "My EF Center",
    Category: "FAMILY",
    Rating: 2.8,
    Reviews: 89,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.10.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EF Mentor: Sounds",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 19,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 16, 2017",
    "Current Ver": "1.0.1.00613",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "EF English Live Business",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 496,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 4, 2018",
    "Current Ver": "2.0.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "EF Classroom",
    Category: "FAMILY",
    Rating: 3.2,
    Reviews: 190,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 23, 2018",
    "Current Ver": "3.0.0.2927",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "EF English Live for phone",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 2210,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 24, 2018",
    "Current Ver": "3.1.0",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "EF Smart English",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 150,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 11, 2018",
    "Current Ver": "1.6.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "EF English Live Business Tablet",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 279,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 25, 2017",
    "Current Ver": "1.6.6",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EF English Live for tablets",
    Category: "FAMILY",
    Rating: 3.1,
    Reviews: 1242,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 24, 2018",
    "Current Ver": "1.7.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EF Parеnts",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 435,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 21, 2018",
    "Current Ver": "3.1.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EF Teacher",
    Category: "FAMILY",
    Rating: 3.1,
    Reviews: 16,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 19, 2018",
    "Current Ver": 1.6,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "English Bite",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 268,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 25, 2016",
    "Current Ver": "1.3.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EF/VR – VR Tours of EF Schools",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 17,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Education",
    "Last Updated": "September 15, 2015",
    "Current Ver": "1.0.05",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EF Events",
    Category: "EVENTS",
    Rating: 5,
    Reviews: 7,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Events",
    "Last Updated": "October 5, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100,
    numAndroid: null,
  },
  {
    App: "EF Go Ahead Tour Companion",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 2.3,
    Reviews: 23,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 18, 2018",
    "Current Ver": "3.0.7",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EF Summits",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 20, 2018",
    "Current Ver": "1.1.3",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EF Sidekick",
    Category: "VIDEO_PLAYERS",
    Rating: 3.1,
    Reviews: 36,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "March 20, 2017",
    "Current Ver": "Varies with device",
    numInstall: 5000,
    numAndroid: null,
  },
  {
    App: "EF-myHR",
    Category: "FINANCE",
    Rating: 2.9,
    Reviews: 26,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 21, 2018",
    "Current Ver": "1.0.38",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EF Spelling Bee",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 2,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "October 12, 2017",
    "Current Ver": "1.2.2",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Education First FCU Mobile",
    Category: "FINANCE",
    Rating: 2.9,
    Reviews: 204,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 9, 2018",
    "Current Ver": "18.1.79",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Travelmoji",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 13,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 24, 2016",
    "Current Ver": 2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "EF Forms",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 2,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 24, 2018",
    "Current Ver": 1.29,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "EFAmbassador",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 5,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 10, 2018",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "Agenda EF",
    Category: "FAMILY",
    Rating: 3.4,
    Reviews: 79,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 27, 2015",
    "Current Ver": 1.03,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "EF App",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 8,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 23, 2017",
    "Current Ver": "1.0.5",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EF Lens Simulator",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 2,
    Size: "33M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 27, 2017",
    "Current Ver": "2.8.3.1",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "EF Coach",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 17,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "March 12, 2018",
    "Current Ver": "1.1.1",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "e-Docente EI/anos iniciais EF",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EF Universe: Endless Battle",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 5,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4541.25.51",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "[EF]ShoutBox",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 3,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "August 7, 2018",
    "Current Ver": "Build 54",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EF Catalogues · Kataloge",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 15,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "September 21, 2016",
    "Current Ver": "1.0.1 (1.5.1)",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "EF Staff",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 8, 2018",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EF Academy",
    Category: "HEALTH_AND_FITNESS",
    Rating: 5,
    Reviews: 4,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "March 23, 2018",
    "Current Ver": "7.7.3",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "EF First",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "February 9, 2018",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Financial Calculator Pro EF",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 634,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "October 4, 2013",
    "Current Ver": "2.1.0.9",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Carrier Landings Pro",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 5969,
    Size: "31M",
    Type: "Paid",
    Price: "$12.99",
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 29, 2018",
    "Current Ver": "4.2.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EF Calculator",
    Category: "PRODUCTIVITY",
    Rating: 4.7,
    Reviews: 19,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "September 20, 2017",
    "Current Ver": "1.6.1",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "EF Utilities",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 7, 2018",
    "Current Ver": "1.1.0",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "EF Financial Control Free",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 58,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 6, 2018",
    "Current Ver": "1.9.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "أحداث وحقائق | خبر عاجل في اخبار العالم",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.8,
    Reviews: 311,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 15, 2018",
    "Current Ver": "2.9.19a",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Diário Escola Mestres EF",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 11,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 31, 2018",
    "Current Ver": "3.0.18 Fundamental",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EF Jumper",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 4,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 13, 2017",
    "Current Ver": "Build 12",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "StudyLock - Education First",
    Category: "PARENTING",
    Rating: 4.1,
    Reviews: 27,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Parenting",
    "Last Updated": "October 12, 2017",
    "Current Ver": 1.13,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "E.F.JUVENTUD MADRID",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 3,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 13, 2017",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "English Conversation Courses",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 22165,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 28, 2018",
    "Current Ver": "4.1806.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Equestria Girls",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 392819,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing;Action & Adventure",
    "Last Updated": "July 22, 2016",
    "Current Ver": 37893,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "eG Monitor",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 8,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 27, 2018",
    "Current Ver": "2.0.7",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "E.G. Chess Free",
    Category: "GAME",
    Rating: 4,
    Reviews: 505,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "December 6, 2014",
    "Current Ver": "1.0.28",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "EG SIM CARD (EGSIMCARD, 이지심카드)",
    Category: "BUSINESS",
    Rating: 2.9,
    Reviews: 322,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 28, 2017",
    "Current Ver": 2.13,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "EG-Boost",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 25,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "November 27, 2017",
    "Current Ver": 7,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "EG Mantenimiento",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Business",
    "Last Updated": "May 30, 2018",
    "Current Ver": "0.0.3",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "EG CrossPad - ASPECT4",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 4,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.6.07",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EG CrossPad",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 3,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "December 19, 2016",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "EG Player",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 20, 2017",
    "Current Ver": "Final",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Bee Mobile EG",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 883,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 5, 2018",
    "Current Ver": "3.1.9",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "EG",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 3,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 1, 2016",
    "Current Ver": 4.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "E.G. Chess",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 56,
    Size: "23M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "December 6, 2014",
    "Current Ver": "1.0.28",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "EG SIM CARD (EGSIMCARD)",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 105,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 2, 2018",
    "Current Ver": 2.5,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "EG Retail",
    Category: "BUSINESS",
    Rating: 2.4,
    Reviews: 29,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 5, 2018",
    "Current Ver": "2.2.1335",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "EG Movi",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 40,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 12, 2017",
    "Current Ver": "0.9.1",
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "EG Groups",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "October 15, 2017",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EG Way Life",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "April 27, 2016",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "EG Tax Service",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 23, 2018",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Energenie EG-PM1W Setup Wizard",
    Category: "TOOLS",
    Rating: 3.1,
    Reviews: 17,
    Size: "523k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 10, 2014",
    "Current Ver": "1.8 (2014-10-10 11:10:51 +0400)",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "qEG APP / Química EG SRL",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "118k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 24, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EG Classroom Decimals™",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 2,
    Size: "18M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "June 12, 2017",
    "Current Ver": "2.2.2",
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "EGW Writings 2",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 6547,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "December 8, 2017",
    "Current Ver": "4.0.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Alipay",
    Category: "FINANCE",
    Rating: 3.4,
    Reviews: 42497,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Finance",
    "Last Updated": "July 2, 2018",
    "Current Ver": "10.1.28.560",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "EG | Explore Folegandros",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "56M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "January 22, 2017",
    "Current Ver": "1.1.1",
    numInstall: 0,
    numAndroid: 4,
  },
  {
    App: "EGW Writings",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 24278,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "December 27, 2017",
    "Current Ver": "2.1.2",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Bible with EGW Comments",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 3776,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "February 7, 2018",
    "Current Ver": "2.12.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Eg Call",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 91,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "February 26, 2017",
    "Current Ver": "3.8.6",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "EG India",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 3,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 29, 2018",
    "Current Ver": "1.1.3",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Fashion Pony Girls Dress Up Makeup Game",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 256,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 13, 2018",
    "Current Ver": 1.7,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "My Little Pony Celebration",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 63192,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation;Pretend Play",
    "Last Updated": "July 22, 2016",
    "Current Ver": "1.0.0",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "My Little Pony AR Guide",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.3,
    Reviews: 7993,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "November 3, 2017",
    "Current Ver": "1.0.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "MY LITTLE PONY: Magic Princess",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 1309728,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Equestria Girl Snapchat Addict",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 20,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "April 19, 2018",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "L.A. Crime Stories 2 Mad City Crime",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 3946,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Racing",
    "Last Updated": "March 30, 2017",
    "Current Ver": 1.04,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "LA Stories 4 New Order Sandbox 2018",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 17453,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Racing",
    "Last Updated": "June 1, 2018",
    "Current Ver": 1.06,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "SDA Sabbath School Quarterly",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 14773,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "October 9, 2017",
    "Current Ver": "4.1.92",
    numInstall: 500000,
    numAndroid: 3,
  },
  {
    App: "Sirens Fashion Style Game",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 2282,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "February 20, 2018",
    "Current Ver": 1,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Equestria Amino for MLP",
    Category: "SOCIAL",
    Rating: 4.8,
    Reviews: 8369,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 13, 2018",
    "Current Ver": "1.8.19106",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Propertyfinder",
    Category: "LIFESTYLE",
    Rating: 4.2,
    Reviews: 1506,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 7, 2018",
    "Current Ver": "6.5.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "L.A. Crime Stories Mad City Crime",
    Category: "GAME",
    Rating: 4,
    Reviews: 30008,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Racing",
    "Last Updated": "March 30, 2017",
    "Current Ver": 1.26,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "My Little Pony: Story Creator",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 11002,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Action & Adventure",
    "Last Updated": "May 11, 2017",
    "Current Ver": 1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Pocket Little Pony",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 47576,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Simulation",
    "Last Updated": "March 1, 2017",
    "Current Ver": 1.95,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Dance Magic Fashion Style Games",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 2533,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "February 27, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Inventory & Barcode scanner & WIFI scanner",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 1880,
    Size: "18M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 1, 2018",
    "Current Ver": 6.08,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "MLP Colouring Adventures",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 7379,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 28, 2017",
    "Current Ver": 1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Miraculous Ladybug & Cat Noir - The Official Game",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 185382,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.0.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Fashion Girls Dress up Makeup",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 115,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 13, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "My Little Pony: Harmony Quest",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 148405,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "March 5, 2018",
    "Current Ver": 1.6,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Home Pony 2",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 20977,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 18, 2018",
    "Current Ver": "1.4.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Eh Volevi!",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 1619,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "October 7, 2017",
    "Current Ver": "1.2.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "VITEK EH DVR Viewer (Pro)",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 78,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 11, 2013",
    "Current Ver": "1.2.10",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Eh Bee Wallpapers HD",
    Category: "PERSONALIZATION",
    Rating: 5,
    Reviews: 4,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 24, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EH!",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 10,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 18, 2018",
    "Current Ver": "7.2.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Me-eh",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 13,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 6, 2018",
    "Current Ver": 3.33,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Arogyam EH",
    Category: "MEDICAL",
    Rating: 3.6,
    Reviews: 18,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 12, 2018",
    "Current Ver": 1.9,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Betul Ke Bohong Eh?",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 601,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "April 3, 2015",
    "Current Ver": "1.0.1",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "EH National Mobile Banking",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "October 12, 2017",
    "Current Ver": "5.2.12",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "EH Autolink",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "921k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 11, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 3,
  },
  {
    App: "Eh Amego!",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 13388,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "August 24, 2015",
    "Current Ver": "2.0.5",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Eh Plus English Application",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "874k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 27, 2015",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EH kontrollrakendus",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 43,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 10, 2017",
    "Current Ver": "3.1.8",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Fit the Fat 2",
    Category: "SPORTS",
    Rating: 3.8,
    Reviews: 35746,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "December 15, 2017",
    "Current Ver": "1.4.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "My Theme Park: RollerCoaster & Water Park Tycoon",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 128,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "June 12, 2018",
    "Current Ver": 1.5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Doomsday Preppers™",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 137167,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "January 17, 2017",
    "Current Ver": "130.48.08",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "TAXI DRIVER",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 7203,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "January 11, 2016",
    "Current Ver": 1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Crazy Doctor",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 267636,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "March 3, 2014",
    "Current Ver": 1.5,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "MazeMilitia Classic Multiplayer Shooting Game",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 1294,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "March 8, 2018",
    "Current Ver": 1.2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Endress+Hauser Operations",
    Category: "BUSINESS",
    Rating: 4.5,
    Reviews: 234,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 16, 2018",
    "Current Ver": "2.4.3.1523",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "ZOMBIE RIPPER",
    Category: "GAME",
    Rating: 3.7,
    Reviews: 16073,
    Size: "94M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "November 14, 2017",
    "Current Ver": 1.4,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Soldiers of Glory: Modern War",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 64815,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "June 1, 2018",
    "Current Ver": "1.7.5",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Driving School 3D 2017",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 5075,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "April 4, 2017",
    "Current Ver": "2.1.5",
    numInstall: 500000,
    numAndroid: 3,
  },
  {
    App: "Retro Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 125616,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 10, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Horror Hospital",
    Category: "GAME",
    Rating: 3.7,
    Reviews: 63986,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "October 10, 2017",
    "Current Ver": 6,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Ludo Family Dice Game",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 3593,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board;Brain Games",
    "Last Updated": "March 7, 2018",
    "Current Ver": 1.4,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Mad Skills Motocross",
    Category: "GAME",
    Rating: 4,
    Reviews: 32522,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "January 25, 2016",
    "Current Ver": "1.2.0",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Masterchef Cooking Games: Fun Restaurant & Kitchen",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 1036,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 6, 2018",
    "Current Ver": 2.6,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "US Army Training Courses Game",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 27130,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "December 8, 2017",
    "Current Ver": 1.4,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Pineapple Pen",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 157264,
    Size: "65M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "December 30, 2016",
    "Current Ver": 1.31,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Instant Buttons: The Best Soundboard",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 157322,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "January 5, 2018",
    "Current Ver": "1.0.15",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Guess The Emoji",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 76627,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "July 3, 2018",
    "Current Ver": "8.16g",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Camping RV Caravan Parking 3D",
    Category: "GAME",
    Rating: 3.3,
    Reviews: 5290,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "December 18, 2014",
    "Current Ver": 1.3,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Grand Bat Superhero Flying Assault Rescue Mission",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 1094,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 9, 2018",
    "Current Ver": 1.1,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Zombie Frontier",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 326689,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "May 30, 2018",
    "Current Ver": 1.31,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "eHub",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 6969,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 29, 2018",
    "Current Ver": "3.9.11",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Voice Changer",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 138050,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Music & Video",
    "Last Updated": "April 19, 2018",
    "Current Ver": 2.4,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Heart Surgery Emergency Doctor",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 2248,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Educational",
    "Last Updated": "April 28, 2017",
    "Current Ver": 1.3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "RUN JUMP RUN-fun games for free",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 661,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "April 20, 2018",
    "Current Ver": "1.5.2",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "100 Doors of Revenge",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 105766,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Puzzle",
    "Last Updated": "May 24, 2018",
    "Current Ver": "2.2.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Lie Detector Prank",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 80313,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "November 22, 2017",
    "Current Ver": 1.7,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Virtual Mother Surgery Doctor : Emergency Hospital",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 70,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Educational",
    "Last Updated": "May 30, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Princess Palace: Royal Pony",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 11442,
    Size: "66M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Creativity",
    "Last Updated": "June 30, 2016",
    "Current Ver": 1.4,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "EI Mobile",
    Category: "FINANCE",
    Rating: 3.8,
    Reviews: 4231,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 19, 2018",
    "Current Ver": "4.3.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "TAMAGO",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 42515,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 23, 2018",
    "Current Ver": "1.0.3",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Ei Electronics AudioLINK",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 59,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 19, 2017",
    "Current Ver": "2.3.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Ei Samay - Bengali News Paper",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 20620,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 17, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Vital Tones EI Pro",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "85M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "December 1, 2017",
    "Current Ver": 1.4,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "EI HabitTracker",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "981k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 17, 2017",
    "Current Ver": "1.40.170809",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "NEMA ei",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 4,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "November 6, 2017",
    "Current Ver": "1.0.4",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "ei",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 2,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "July 16, 2018",
    "Current Ver": "0.0.10",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "the Egg - crack the egg",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 211,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "November 21, 2016",
    "Current Ver": "1.1.0",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Yeled EI",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 26, 2018",
    "Current Ver": 0.62,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EI SmartMiles",
    Category: "FINANCE",
    Rating: 2.4,
    Reviews: 9,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "January 21, 2018",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Code on the egg",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 146,
    Size: "784k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 10, 2017",
    "Current Ver": 1.15,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Sensenuts eI",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5,
    numAndroid: null,
  },
  {
    App: "EI!",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.1.14",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EI App 1",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 23, 2017",
    "Current Ver": "1.0.4",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EI Calculator",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 8,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 23, 2016",
    "Current Ver": 1.3,
    numInstall: 100,
    numAndroid: 1,
  },
  {
    App: "Verdant EI",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 6, 2017",
    "Current Ver": "1.1.4",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Tamago egg",
    Category: "GAME",
    Rating: 3,
    Reviews: 49,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "October 31, 2017",
    "Current Ver": "1.0.1",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Ei-ij Spelling Dutch",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 20,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 12, 2017",
    "Current Ver": 2.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Esporte Interativo - Notícias e Resultados Ao Vivo",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 4600,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "January 14, 2018",
    "Current Ver": "6.2.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Let's Poke The Egg",
    Category: "GAME",
    Rating: 3.4,
    Reviews: 9051,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "February 4, 2017",
    "Current Ver": 1.2,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Egg",
    Category: "FAMILY",
    Rating: 2.9,
    Reviews: 72,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Simulation",
    "Last Updated": "June 9, 2018",
    "Current Ver": "1.2.2",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "ei Calc",
    Category: "TOOLS",
    Rating: 5,
    Reviews: 2,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 12, 2015",
    "Current Ver": "1.2.2",
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "Disaster Will Strike",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 14692,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.173.126",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Egg: clicker",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 40678,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 22, 2017",
    "Current Ver": "2.1.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Egg for Pou",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 59096,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "September 14, 2017",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "EI App 2",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 23, 2017",
    "Current Ver": "1.0.4",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Survival: Prison Escape",
    Category: "GAME",
    Rating: 4,
    Reviews: 127810,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.8.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Crack the blue angry birds egg",
    Category: "FAMILY",
    Rating: 3.2,
    Reviews: 85,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "April 22, 2016",
    "Current Ver": "1.0.0",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Tamago Tap Clicker Egg",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 209,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "October 19, 2016",
    "Current Ver": 1.1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Tap The Easter Egg!",
    Category: "FAMILY",
    Rating: 3.2,
    Reviews: 111,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "March 18, 2016",
    "Current Ver": 1.7,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Esporte Interativo Plus",
    Category: "SPORTS",
    Rating: 3.7,
    Reviews: 27179,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 30, 2018",
    "Current Ver": "5.12.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "EI国际",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 15,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 9, 2016",
    "Current Ver": "1.0.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Egg Baby",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 351607,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Casual",
    "Last Updated": "June 29, 2016",
    "Current Ver": "1.26.03",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Surprise Eggs",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 81543,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "PJ Masks: Moonlight Heroes",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 87045,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Action & Adventure",
    "Last Updated": "June 5, 2018",
    "Current Ver": "2.0.1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Crack Attack",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 31970,
    Size: "77M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "June 7, 2017",
    "Current Ver": 1.8,
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Aaj Bangla: ei samay er khobor",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.9,
    Reviews: 34,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "January 15, 2017",
    "Current Ver": 6.7,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Break the Egg",
    Category: "FAMILY",
    Rating: 2.6,
    Reviews: 366,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 5, 2018",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Kolkata News:Anandbazar Patrika,ei samay&AllRating",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 5,
    Reviews: 10,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 14, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "PJ Masks: HQ",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 13731,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Action & Adventure",
    "Last Updated": "June 22, 2018",
    "Current Ver": "1.2.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ei Somoy & Dainik Sangbad & Statesman (PDF)",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 4,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 25, 2018",
    "Current Ver": 25072018,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "TAMAGO Monsters Returns",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 104583,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "August 18, 2016",
    "Current Ver": 3.45,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "EJ.by",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 10,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "October 27, 2015",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "EJ Elite Prospects League",
    Category: "SPORTS",
    Rating: 3.3,
    Reviews: 3,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 23, 2018",
    "Current Ver": "5.5.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Super Sport Car Simulator",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 58553,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "December 25, 2016",
    "Current Ver": 3.1,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "EJ Insight",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 33,
    Size: "280k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "September 30, 2014",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ambulance Rescue Simulator 17",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 6669,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "March 1, 2018",
    "Current Ver": "1.0.8",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "EJ Trívia Game",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 19, 2018",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Bad Piggies HD",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 764967,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 5, 2018",
    "Current Ver": "2.3.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "EJ messenger",
    Category: "COMMUNICATION",
    Rating: 5,
    Reviews: 1,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "October 18, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Traffic Sniper Counter Attack",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 5339,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "December 5, 2017",
    "Current Ver": 1,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Rope Superhero Unlimited",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 6735,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "May 10, 2017",
    "Current Ver": 1.1,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Painel EJ SSH - INTERNET GRÁTIS",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 10,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": 5.1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "EJ Ecuador",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 9,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "November 22, 2016",
    "Current Ver": "3.0.16",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ej-buy",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.2.0",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Extreme Super Car Driving 3D",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 23104,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "August 5, 2015",
    "Current Ver": 2.2,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Footej Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 13258,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 20, 2018",
    "Current Ver": "2.3.0 build 180",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Sport Car Simulator",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 48731,
    Size: "68M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "April 19, 2018",
    "Current Ver": "4.0.5",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Fast Racing Car Simulator",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 8482,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "August 10, 2015",
    "Current Ver": 1.3,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Silence Premium Do Not Disturb",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 3356,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.95",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 17, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "パーリーゲイツ公式通販｜EJ STYLE（イージェイスタイル）",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 1,
    Size: "9.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "November 16, 2017",
    "Current Ver": 3,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Beach Head Shooting Assault",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 555,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "March 2, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Stickman Warriors Heroes 2",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 13714,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "April 15, 2017",
    "Current Ver": "1.0.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Dead Target Zombie Shooting US Sniper Killer Squad",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 240,
    Size: "65M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "October 3, 2017",
    "Current Ver": "1.0.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Learn Music Notes",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 143,
    Size: "4.4M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Music;Music & Video",
    "Last Updated": "June 17, 2018",
    "Current Ver": "1.2.1",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Luxury Car Simulator",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 35989,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 7, 2015",
    "Current Ver": 2.3,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Dubai Racing",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 16237,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "December 23, 2015",
    "Current Ver": "1.9.1",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Office Bike Racing Simulator",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 21149,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "October 9, 2015",
    "Current Ver": 2.1,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Pregnant Mom Surgery Newborn Twins Baby Birth Care",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 95,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Educational",
    "Last Updated": "February 24, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Pet Beauty Salon",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 20292,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Creativity",
    "Last Updated": "May 24, 2015",
    "Current Ver": 1.2,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Booking Revolution",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 140883,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Sports",
    "Last Updated": "July 21, 2018",
    "Current Ver": 1.932,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Nights Keeper (do not disturb)",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 16426,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "February 26, 2017",
    "Current Ver": "2.7.8",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Farming Simulator 16",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 32812,
    Size: "14M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Simulation;Education",
    "Last Updated": "April 10, 2018",
    "Current Ver": "1.1.1.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Lily & Leo - Crazy Circus Day",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 8091,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "June 5, 2018",
    "Current Ver": "1.0.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "WIZARD Card Game",
    Category: "GAME",
    Rating: 4,
    Reviews: 48,
    Size: "4.1M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "December 15, 2014",
    "Current Ver": "1.0.141215",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Period Tracker, Pregnancy Calculator & Calendar 🌸",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "Fake Call From Wengie Prank",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 352,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 23, 2017",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "Robot Fighting Games™ - Real Boxing Champions 3D",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 30,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 2, 2018",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Ghost Hunting camera",
    Category: "GAME",
    Rating: 3.5,
    Reviews: 3048,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "March 6, 2017",
    "Current Ver": 1.1,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Santa Panda Bubble Christmas",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 101,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "March 14, 2017",
    "Current Ver": 1.5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "TeamWard – live help for LoL",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 3136,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 27, 2018",
    "Current Ver": "2.19.6",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "3D Metal Piano Keys Keyboard Theme",
    Category: "FOOD_AND_DRINK",
    Rating: 4.4,
    Reviews: 467,
    Size: "7.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "July 1, 2018",
    "Current Ver": "6.7.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "OffRoad US Army Train Driving Simulator",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1216,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Simulation",
    "Last Updated": "June 11, 2018",
    "Current Ver": 1.3,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Do Not Disturb! 2 - Challenge Your Prank Skills!",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 34417,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "August 6, 2018",
    "Current Ver": "1.0.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "WiFi Tether Router",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 5599,
    Size: "1.3M",
    Type: "Paid",
    Price: "$2.90",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 2, 2018",
    "Current Ver": "6.2.7",
    numInstall: 100000,
    numAndroid: 1,
  },
  {
    App: "Local weather Forecast",
    Category: "WEATHER",
    Rating: 4.4,
    Reviews: 5482,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 7, 2018",
    "Current Ver": 2.42,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Kiss Me! Lip Kissing Test",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 191,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 18, 2018",
    "Current Ver": 5,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Smoke Effect Name Art Maker-Avatar Text Art Editor",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 1961,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 29, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "The Emirates App",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 22776,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 6, 2018",
    "Current Ver": "4.7.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "ek tuhi",
    Category: "VIDEO_PLAYERS",
    Rating: 4.7,
    Reviews: 316,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 4, 2014",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Master E.K",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 90,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 11, 2017",
    "Current Ver": "1.5.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EK Platinum",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 52,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 26, 2017",
    "Current Ver": "1.0.6®",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EK Bailey Preaching Conference",
    Category: "EVENTS",
    Rating: 5,
    Reviews: 3,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "July 2, 2018",
    "Current Ver": "5.30.01",
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "Ek Maratha",
    Category: "SOCIAL",
    Rating: 4.8,
    Reviews: 725,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "October 12, 2016",
    "Current Ver": "7.5.3",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Ek Onkar",
    Category: "FAMILY",
    Rating: 4.9,
    Reviews: 107,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 3, 2016",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Racing Moto",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 697805,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "July 3, 2018",
    "Current Ver": "1.2.13",
    numInstall: 50000000,
    numAndroid: 3,
  },
  {
    App: "Pyaar Ek Dhoka hai Game - Anti Valentines",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 8,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "February 11, 2018",
    "Current Ver": 3,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Pyaar Ek Dhoka",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 18,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "February 13, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Ek Biladi Jadi Video Song",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "October 20, 2016",
    "Current Ver": 4.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Duaa Ek Ibaadat",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.9,
    Reviews: 122,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "April 10, 2016",
    "Current Ver": 1.5,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Ek Onkar Mantras",
    Category: "LIFESTYLE",
    Rating: 4.9,
    Reviews: 82,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 7, 2016",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Alex Fuel Calculator for EK",
    Category: "TOOLS",
    Rating: 4.9,
    Reviews: 19,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 15, 2018",
    "Current Ver": 1.8,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Ringtones Of Ek Onkar",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 6,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 31, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EK Carevec",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 17, 2018",
    "Current Ver": "2.177.5489",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Ek Kahani Aisi Bhi Season 2 - The Horror Story",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 28,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 20, 2018",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Ek Bander Ne Kholi Dukan",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 10,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 26, 2017",
    "Current Ver": "1.0.9",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Hum Ek Hain 2.02",
    Category: "SOCIAL",
    Rating: 5,
    Reviews: 2,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "March 18, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 5,
  },
  {
    App: "Ek Kahani Aisi Bhi Season 3 - The Horror Story",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 1,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 21, 2018",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "Ek IRA",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 27, 2018",
    "Current Ver": "0.3.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Sanu Ek Pal Chain - Raid",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 12, 2018",
    "Current Ver": 2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Sai Baba - Sabka Malik Ek",
    Category: "PRODUCTIVITY",
    Rating: 4.9,
    Reviews: 42,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 26, 2018",
    "Current Ver": 1.4,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ek Vote",
    Category: "PRODUCTIVITY",
    Rating: 5,
    Reviews: 43,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 7, 2017",
    "Current Ver": 1.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Asha Ek Hope - ALS/ MND",
    Category: "MEDICAL",
    Rating: 5,
    Reviews: 2,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 23, 2018",
    "Current Ver": "1.1.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Meslek Lisesi YGS Ek Puan",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 11,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 8, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Airplane Pilot Car Transporter",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 182363,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 27, 2018",
    "Current Ver": "2.1.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Mahila Vashikaran(Ek rat me)-Hindi",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 23, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ek Kauwa Pyasa Tha",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 35,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 25, 2017",
    "Current Ver": "1.3.6",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Train Racing Games 3D 2 Player",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 192374,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "January 9, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Video Maker with Photo and Music",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 4871,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 19, 2018",
    "Current Ver": "1.0.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SIM Card Info",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 4234,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 25, 2018",
    "Current Ver": "5.3.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Toilet Ek Prem Katha Songs Lyrics in Hindi",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 3,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 10, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Ek Do Teen Song Videos - Baaghi 2 Video Songs",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 20, 2018",
    "Current Ver": "1.4.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Sanu Ek Pal Chain Song Videos - RAID Movie Songs",
    Category: "FAMILY",
    Rating: 4.9,
    Reviews: 11,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 8, 2018",
    "Current Ver": "1.2.8",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Phogy, 3D Camera",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 35725,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 11, 2015",
    "Current Ver": 1.4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ek Qissa He Quran Se (Qurani Waqiyat)",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 4,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "October 30, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Lyrics of Ek Paheli Leela",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 4,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 23, 2016",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Ek-yatri: Travel where you Belong",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.0.0",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Exiled Kingdoms RPG",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 49210,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.2.1107",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Sabka Malik Ek Sai",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 17,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "May 25, 2013",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Voice Lock Screen",
    Category: "LIFESTYLE",
    Rating: 3.7,
    Reviews: 6667,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "April 2, 2018",
    "Current Ver": "2.4.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Shabad Gurubani Punjabi mp3 free - Ek Onkar Satnam",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 5,
    Size: "64M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 19, 2018",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Bus Driver 3D: Hill Station",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 31705,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "November 6, 2017",
    "Current Ver": 1.7,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Extreme Motorbike Jump 3D",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 94308,
    Size: "79M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "December 25, 2016",
    "Current Ver": 4.2,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "el",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 32405,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "December 18, 2014",
    "Current Ver": "1.2.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "El Pollo Loco - Loco Rewards",
    Category: "FOOD_AND_DRINK",
    Rating: 4,
    Reviews: 848,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "February 23, 2018",
    "Current Ver": 2.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "El Chavo",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 751,
    Size: "49M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "November 4, 2014",
    "Current Ver": "1.2.9",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "EL AL Flights",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.1,
    Reviews: 1563,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 24, 2018",
    "Current Ver": 4.3,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DreamStream By EL AL",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.4,
    Reviews: 595,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "January 18, 2016",
    "Current Ver": "3.4.20.6 / BuyDRM Labgency 4.8.22 / PED",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Learn English with El Chavo.",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 6133,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 1, 2015",
    "Current Ver": 6.2,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Learn Math with el Chavo",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 840,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 28, 2018",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "El Nuevo Día",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 8011,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "June 13, 2018",
    "Current Ver": "4.11.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "EL NORTE",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.4,
    Reviews: 2436,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "El Nueve",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 221,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "October 16, 2017",
    "Current Ver": "1.1.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "El Laberinto del Demonio 3D",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 20421,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Puzzle",
    "Last Updated": "August 20, 2015",
    "Current Ver": 1.5,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Monastery of El Escorial",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 12,
    Size: "50M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 30, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Learn to code with el Chavo",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 5933,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "March 27, 2018",
    "Current Ver": 2.6,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "El Falı",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 36968,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 3, 2017",
    "Current Ver": "1.2.9",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "El Laberinto del Demonio 2",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 3654,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Puzzle",
    "Last Updated": "April 14, 2017",
    "Current Ver": "1.0.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "TV Local El Salvador",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 323,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 8, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Tigo Money El Salvador",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 4642,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 23, 2018",
    "Current Ver": "5.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Hangman",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 23302,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "March 24, 2018",
    "Current Ver": "1.0.6",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Explora con el Chavo",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "June 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "El Dorado App",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 221,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "April 6, 2018",
    "Current Ver": 2.4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Adivina el cantante de Trap y Reggaeton",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1914,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "June 29, 2018",
    "Current Ver": "3.6.7z",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "The translator",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 23805,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 13, 2017",
    "Current Ver": "2.0.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fernanfloo",
    Category: "GAME",
    Rating: 4.8,
    Reviews: 526595,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Arcade",
    "Last Updated": "June 26, 2018",
    "Current Ver": 2.9,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Weather 14 Days",
    Category: "WEATHER",
    Rating: 4.4,
    Reviews: 279917,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "The dollar in mexico",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 4254,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 29, 2017",
    "Current Ver": 2.5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Real Madrid App",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 161423,
    Size: "73M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": "6.5.3",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "OWLIE BOO",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 834,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Education",
    "Last Updated": "March 15, 2018",
    "Current Ver": "1.8.11",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Trazado de tuberia El Tubero",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 313,
    Size: "4.4M",
    Type: "Paid",
    Price: "$1.97",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 29, 2015",
    "Current Ver": 4.1,
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "Adivina el Emoji",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 2536,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "October 2, 2016",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Weather by eltiempo.es",
    Category: "WEATHER",
    Rating: 4.2,
    Reviews: 67854,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "The Game of Life",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 18652,
    Size: "63M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "July 4, 2018",
    "Current Ver": "2.1.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Spanish English Translator",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.2,
    Reviews: 87919,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "May 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "The Holy Rosary",
    Category: "LIFESTYLE",
    Rating: 4.7,
    Reviews: 56197,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 6, 2018",
    "Current Ver": "1.6.17",
    numInstall: 1000000,
    numAndroid: 1,
  },
  {
    App: "Western Union US - Send Money Transfers Quickly",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 80904,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 5, 2018",
    "Current Ver": 5.7,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Maps, GPS Navigation & Directions, Street View",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 207440,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 23, 2018",
    "Current Ver": "7.0.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Human Anatomy Atlas 2018: Complete 3D Human Body",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 2923,
    Size: "25M",
    Type: "Paid",
    Price: "$24.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "May 25, 2018",
    "Current Ver": "2018.5.47",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Red Hands – 2-Player Games",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 93608,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "February 9, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Narcos: Cartel Wars",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 244797,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.24.09",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Get 'Em",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 7904,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "October 26, 2016",
    "Current Ver": "1.6.7",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "EM Launcher for EMUI",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 3175,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 6, 2018",
    "Current Ver": "1.0.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Live Hold’em Pro Poker - Free Casino Games",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 1123190,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "August 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Beach Shoot Em Up: Head Hunter",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 1218,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "March 6, 2018",
    "Current Ver": "1.0.9",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Connect'Em",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 49381,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "June 25, 2018",
    "Current Ver": "1.0.17",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Stick 'Em Up 2 Starter Edition",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 2102,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "September 11, 2015",
    "Current Ver": "1.1.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Shoot`Em Down: Shooting game",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 7972,
    Size: "88M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 12, 2017",
    "Current Ver": 56,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Texas Hold’em Poker + | Social",
    Category: "GAME",
    Rating: 3.5,
    Reviews: 4416,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "January 18, 2017",
    "Current Ver": "2.1.7",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "PlayTexas Hold'em Poker Free",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 3543,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "March 10, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "EM Launcher Pro",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 35,
    Size: "24k",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 2, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "HAWK – Force of an Arcade Shooter. Shoot 'em up",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 190274,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "July 9, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Shoot Em Down Free",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 2850,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "February 9, 2018",
    "Current Ver": 23,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Game for KIDS: KIDS match'em",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 7006,
    Size: "6.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 23, 2016",
    "Current Ver": 1.17,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Texas Hold'em Poker",
    Category: "GAME",
    Rating: 3.6,
    Reviews: 12846,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "December 29, 2017",
    "Current Ver": 3.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Nuke Em All",
    Category: "FAMILY",
    Rating: 3.4,
    Reviews: 2714,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Casual",
    "Last Updated": "November 19, 2017",
    "Current Ver": "1.1.8",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Poker Equity Calculator Pro for No Limit Hold'em",
    Category: "GAME",
    Rating: 4,
    Reviews: 21,
    Size: "14M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "September 10, 2017",
    "Current Ver": 1.3,
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "Poker Live! 3D Texas Hold'em",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 6143,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CBS Sports App - Scores, News, Stats & Watch Live",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 91035,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "Fun Texas Hold'em Poker",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 32831,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "May 12, 2017",
    "Current Ver": "17.05.11",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Elevator Simulator Lift EM ALL",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 2941,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.4.1343-prod",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Dragonplay™ Poker Texas Holdem",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 197979,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "August 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Punch em",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 2208,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 24, 2018",
    "Current Ver": "2.0.8",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Zynga Poker – Texas Holdem",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 1986068,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "July 25, 2018",
    "Current Ver": 21.54,
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Boyaa Poker (En) – Social Texas Hold’em",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 71468,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "June 12, 2018",
    "Current Ver": "5.8.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "World Series of Poker – WSOP Free Texas Holdem",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 910051,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.11.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Connect'Em Halloween",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 6673,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "September 23, 2016",
    "Current Ver": "1.0.7",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Yahoo Fantasy Sports - #1 Rated Fantasy App",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 277939,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Sports",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Texas Holdem Poker Pro",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 114479,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "December 20, 2017",
    "Current Ver": "4.7.0",
    numInstall: 5000000,
    numAndroid: 3,
  },
  {
    App: "Rage Fight of Streets - Beat Em Up Game",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 1489,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "May 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "HANGAME Casino - Baccarat & Texas Hold'em",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 8608,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "May 17, 2018",
    "Current Ver": "1.4.5",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "PokerStars Play: Free Texas Holdem Poker Game",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 14989,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "July 6, 2018",
    "Current Ver": "1.9.2",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Yoong: Kick 'Em Up!",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 7107,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "December 16, 2015",
    "Current Ver": "1.1.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Texas Holdem Poker",
    Category: "GAME",
    Rating: 4,
    Reviews: 127831,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "December 20, 2017",
    "Current Ver": "4.7.0",
    numInstall: 10000000,
    numAndroid: 3,
  },
  {
    App: "Instabridge - Free WiFi Passwords and Hotspots",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 211308,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Big Fish Casino – Play Slots & Vegas Games",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 382100,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "July 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Em Fuga Brasil",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1317,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "April 22, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "LocaToWeb - Live GPS tracking",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 200,
    Size: "3.0M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.9.1",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "TRANSFORMERS: Forged to Fight",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 291941,
    Size: "90M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "July 27, 2018",
    "Current Ver": "6.3.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Texas Holdem & Omaha Poker: Pokerist",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 187200,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "July 31, 2018",
    "Current Ver": "18.4.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Governor of Poker 2 - OFFLINE POKER GAME",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 246538,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "March 6, 2018",
    "Current Ver": "3.0.8",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Squadron - Bullet Hell Shooter",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 177542,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 2, 2016",
    "Current Ver": "1.0.7",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Telemundo Deportes - En Vivo",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 36255,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.10.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Holy Knight EN",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 26202,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "May 5, 2018",
    "Current Ver": "1.1.700",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Hello English: Learn English",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 750321,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Dictionary - Merriam-Webster",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 454412,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "May 18, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "English in a Month Free",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 6577,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 23, 2017",
    "Current Ver": 1.28,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Words With Friends – Play Free",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 711719,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "July 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "FRANCE 24",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 47069,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "June 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "JW Library",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.9,
    Reviews: 922752,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 15, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Learn Body Parts in English",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 7243,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 6, 2016",
    "Current Ver": 5.13,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "ai.type keyboard Plus + Emoji",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 57076,
    Size: "35M",
    Type: "Paid",
    Price: "$4.49",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Paid-9.4.1.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Edmodo",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 200214,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 6, 2018",
    "Current Ver": "9.12.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Learn English Daily",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 7881,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 6, 2018",
    "Current Ver": 7,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Orfox: Tor Browser for Android",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 44233,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 2, 2018",
    "Current Ver": "Fennec-52.9.0esr/TorBrowser-7.5-1/Orfox-1.5.4-RC-1",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "NewsDog - Latest News, Breaking News, Local News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.4,
    Reviews: 291901,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "News & Magazines",
    "Last Updated": "July 20, 2018",
    "Current Ver": "2.6.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Keyboard ManMan",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 121304,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "RightNow English Conversation",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 5118,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 2, 2018",
    "Current Ver": "1.4.1",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "HTC Sense Input - EN",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 24175,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 30, 2015",
    "Current Ver": "1.0.612931",
    numInstall: 5000000,
    numAndroid: 5,
  },
  {
    App: "busuu: Learn Languages - Spanish, English & More",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 207294,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Education",
    "Last Updated": "August 1, 2018",
    "Current Ver": "13.9.0.161",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Classic Words Solo",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 135739,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "August 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Ginger Keyboard - Emoji, GIFs, Themes & Games",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 162831,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 1, 2018",
    "Current Ver": "8.1.01",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "English Audio Books - Librivox",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 10773,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 29, 2017",
    "Current Ver": 8.02,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Learn Top 300 English Words",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 61600,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 24, 2018",
    "Current Ver": 3.1,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Univision Deportes: Liga MX, MLS, Fútbol En Vivo",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 75566,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Chess Free",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 1375988,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "June 7, 2018",
    "Current Ver": 2.72,
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Oxford Dictionary of English : Free",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.1,
    Reviews: 364452,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 11, 2018",
    "Current Ver": "9.1.363",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "English Hindi Dictionary",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 384368,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "English to Hindi Dictionary",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.1,
    Reviews: 71328,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 11, 2017",
    "Current Ver": "BlueOrange",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "EO.TRADE - Coin sale",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 95,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 5, 2018",
    "Current Ver": 0.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EO Network",
    Category: "BUSINESS",
    Rating: 3.5,
    Reviews: 13,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Business",
    "Last Updated": "September 20, 2017",
    "Current Ver": "1.0.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "The EO Bar",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.7,
    Reviews: 416,
    Size: "34M",
    Type: "Paid",
    Price: "$6.99",
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 2, 2018",
    "Current Ver": "1.3.7",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EO Mumbai",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "February 21, 2018",
    "Current Ver": 1.02,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EO Global",
    Category: "BUSINESS",
    Rating: 2.6,
    Reviews: 13,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 20, 2016",
    "Current Ver": 3.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EO SouthAsia",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 8,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Business",
    "Last Updated": "April 25, 2018",
    "Current Ver": "1.0.23",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EO RAIPUR",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "June 21, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EO Forum",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 5, 2013",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "EO Events",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Business",
    "Last Updated": "June 21, 2018",
    "Current Ver": "v2.7.11.27",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EO KOREA",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Business",
    "Last Updated": "December 4, 2017",
    "Current Ver": "1.0.7",
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "EO App. SelfCompassion to you",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "September 12, 2015",
    "Current Ver": "Varies with device",
    numInstall: 100,
    numAndroid: null,
  },
  {
    App: "EO GSEA",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 4, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EO Guide",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 15,
    Size: "24M",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.0.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EO SA Benefits",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "518k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 25, 2014",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "FAST EO",
    Category: "EVENTS",
    Rating: 5,
    Reviews: 1,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "May 15, 2018",
    "Current Ver": "1.0.3",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "23rd QM BDE EO",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "September 27, 2017",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EO Bijbel Open",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 102,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "November 24, 2016",
    "Current Ver": "2.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EO LAC",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 17, 2017",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EO Hub",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Business",
    "Last Updated": "February 6, 2018",
    "Current Ver": "3.5.4",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Kenny e o Cupcake",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade;Action & Adventure",
    "Last Updated": "July 19, 2018",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 2,
  },
  {
    App: "EO",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 1, 2015",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "4Eternity EO",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 17, 2018",
    "Current Ver": 1.2,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Masha and the Bear",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 15105,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 11, 2018",
    "Current Ver": "3.1.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Free games: Masha and the Bear",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 34514,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "July 20, 2018",
    "Current Ver": "1.2.8",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Masha and the Bear- House Cleaning Games for Girls",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "74M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "January 25, 2018",
    "Current Ver": "0.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EO Hotels",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 4,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 4, 2017",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Masha and the Bear Child Games",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 288606,
    Size: "92M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure;Education",
    "Last Updated": "May 8, 2018",
    "Current Ver": "2.7.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Masha and the Bear - Hair Salon and MakeUp Games",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "83M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Role Playing;Education",
    "Last Updated": "March 5, 2018",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Masha and Bear: Cooking Dash",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 151374,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing;Brain Games",
    "Last Updated": "June 5, 2018",
    "Current Ver": "1.2.7",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Masha and the Bear: Evolution",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 2062,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy;Education",
    "Last Updated": "June 14, 2018",
    "Current Ver": "1.0.9",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Cryptocurrency Trading - How To Trade Crypto",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 16, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Masha and the Bear. Games for kids",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 6231,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "July 13, 2018",
    "Current Ver": 2.6,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Masha and The Bear Jam Day Match 3 games for kids",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 50060,
    Size: "98M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "August 7, 2018",
    "Current Ver": "1.4.83",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Where's My Water?",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 188740,
    Size: "69M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.16.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "O Céu e o Inferno",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 14,
    Size: "754k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "October 7, 2013",
    "Current Ver": 1.1,
    numInstall: 500,
    numAndroid: 1,
  },
  {
    App: "Frozen Free Fall",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1574546,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Action & Adventure",
    "Last Updated": "July 27, 2018",
    "Current Ver": "6.7.0",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Urban Car Simulator",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 23292,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "September 19, 2017",
    "Current Ver": 1.4,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Masha and the Bear: House Cleaning Games for Girls",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 43852,
    Size: "77M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing;Pretend Play",
    "Last Updated": "July 19, 2018",
    "Current Ver": "1.9.10",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Masha and The Bear Puzzle Game",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 13330,
    Size: "73M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Brain Games",
    "Last Updated": "May 24, 2018",
    "Current Ver": 2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Masha and the Bear. Educational Games",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 46369,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Brain Games",
    "Last Updated": "July 13, 2018",
    "Current Ver": 2.3,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Bluetooth Pair",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 1960,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 4, 2018",
    "Current Ver": 2.5,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Sports Car Driving Simulator 2018",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 2178,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "March 28, 2018",
    "Current Ver": 1.1,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Masha and the Bear: Good Night!",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 29155,
    Size: "83M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Pretend Play",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.0.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Masha and the Bear: Climb Racing and Car Games",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 2200,
    Size: "73M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Pretend Play",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.1.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Episode - Choose Your Story",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 1842381,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Out There Chronicles - Ep. 1",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 1516,
    Size: "44M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "November 27, 2017",
    "Current Ver": "1.0.4",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EP FCU",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 2,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 22, 2018",
    "Current Ver": "3.0.6",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EP Home Energy Hub",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 4,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 21, 2018",
    "Current Ver": "3.4.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EP",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 3,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "November 13, 2015",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "EP Spotter",
    Category: "FAMILY",
    Rating: 3.4,
    Reviews: 9,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "September 28, 2016",
    "Current Ver": 314007,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "EP Mobile",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 267,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 8, 2018",
    "Current Ver": 2.18,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EP RSS Reader",
    Category: "COMMUNICATION",
    Rating: 3.8,
    Reviews: 4,
    Size: "892k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 16, 2018",
    "Current Ver": 0.99,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Out There Chronicles - Ep. 2",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 144,
    Size: "70M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "January 26, 2018",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EP Cloud",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 9,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.2.2",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "eP Scanner",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "October 13, 2017",
    "Current Ver": 1.5,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EP McGuffey Primer",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 16, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50,
    numAndroid: null,
  },
  {
    App: "EP Church Annapolis",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 2,
    Size: "8.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 14, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EP Horlogerie",
    Category: "LIFESTYLE",
    Rating: 4.9,
    Reviews: 18,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 28, 2018",
    "Current Ver": "4.0.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "ep-liggare - Elektronisk personalliggare",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 26, 2018",
    "Current Ver": "1.1.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EP Calipers",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 4,
    Size: "15M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "February 10, 2018",
    "Current Ver": 2.12,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EP Radio",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 3,
    Size: "154k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 26, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 3,
  },
  {
    App: "EP Joaillerie",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 54,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "March 28, 2018",
    "Current Ver": "4.0.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Tester EP",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 9,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 15, 2018",
    "Current Ver": 3,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "The Great Wobo Escape Ep. 1",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 5449,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "September 13, 2016",
    "Current Ver": "1.0.3386",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "The Visitor: Ep.2 - Sleepover Slaughter",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 5731,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Adventure",
    "Last Updated": "January 2, 2018",
    "Current Ver": "1.1.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Superbrothers Sword & Sworcery",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 11023,
    Size: "16M",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "January 26, 2018",
    "Current Ver": "1.0.20",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "EP Lab Digest",
    Category: "MEDICAL",
    Rating: 2.3,
    Reviews: 11,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 12, 2018",
    "Current Ver": 1000000.6,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "EP Research Service",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.7,
    Reviews: 14,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "March 5, 2018",
    "Current Ver": 1.9,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "eP Finder",
    Category: "AUTO_AND_VEHICLES",
    Rating: "NaN",
    Reviews: 0,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "June 21, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EP Music",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 26, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EP Coding",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.0M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 5, 2017",
    "Current Ver": 1.6,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "EP Kalkulator el. energije",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 13,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 20, 2015",
    "Current Ver": 4,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "The Great Wobo Escape Ep.1",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 11,
    Size: "20M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone 10+",
    Genres: "Action;Action & Adventure",
    "Last Updated": "May 3, 2016",
    "Current Ver": "1.0.3289",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "The Visitor: Ep.1 - Kitty Cat Carnage",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 3017,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Adventure",
    "Last Updated": "January 2, 2018",
    "Current Ver": "1.3.7",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "EP Cook Book",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.2M",
    Type: "Paid",
    Price: "$200.00",
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 26, 2015",
    "Current Ver": 1,
    numInstall: 0,
    numAndroid: 3,
  },
  {
    App: "Dr.Slender Ep 1 Guide (Eng)",
    Category: "GAME",
    Rating: 4,
    Reviews: 454,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "December 2, 2014",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Decay: The Mare - Ep.1 (Trial)",
    Category: "GAME",
    Rating: 3.6,
    Reviews: 5291,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "May 24, 2014",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "EP Search and Find",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 20,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 27, 2015",
    "Current Ver": "1.0.0",
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "What's Your Story?™ ft Charmed",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 39661,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.10.4",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "EP Gem Hunter",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 79,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "January 17, 2016",
    "Current Ver": "1.1.0",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "EP Chain Reaction",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 249,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Brain Games",
    "Last Updated": "April 10, 2016",
    "Current Ver": "1.2.2",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Gate Of Death Ep: 1",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 7,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "October 7, 2016",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "EP Mobil",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 3,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 18, 2018",
    "Current Ver": 1.9,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Sonic 4™ Episode I",
    Category: "GAME",
    Rating: 3.7,
    Reviews: 8014,
    Size: "37M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "April 4, 2016",
    "Current Ver": "1.5.0",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Naruto Shippuden - Watch Free!",
    Category: "VIDEO_PLAYERS",
    Rating: 3.9,
    Reviews: 141515,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Video Players & Editors",
    "Last Updated": "April 23, 2014",
    "Current Ver": "0.6.0",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Lean EQ",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 6,
    Size: "10M",
    Type: "Paid",
    Price: "$89.99",
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 14, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Operate Now: Hospital",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 254861,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.20.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Multi Surgery ER Emergency Hospital : Doctor Game",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 227,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Educational",
    "Last Updated": "June 21, 2018",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "ER Surgery Simulator",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 19601,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Casual",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.0.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Dentist Surgery ER Emergency Doctor Hospital Games",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 2580,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 6, 2018",
    "Current Ver": 10,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Eye Transplant : ER Emergency Hospital",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 1938,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Educational",
    "Last Updated": "May 25, 2018",
    "Current Ver": 1.6,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Lifeguard Beach Rescue ER Emergency Hospital Games",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 519,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 7, 2018",
    "Current Ver": 12,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Hospital ER Emergency Heart Surgery: Doctor Games",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 1652,
    Size: "71M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 11, 2018",
    "Current Ver": 10,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Superhero Doctor 2 -ER Surgery",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 39647,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Casual",
    "Last Updated": "September 30, 2017",
    "Current Ver": 1.7,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ER",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 2,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "September 1, 2017",
    "Current Ver": "1.1.2",
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Noot-Noot-er!",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 74,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 22, 2017",
    "Current Ver": 2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Doctor X - ER On Wheels",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 12781,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.0.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Foot Surgery Hospital Simulator: ER Doctor Games",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 314,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "January 15, 2018",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "ER Heart Surgery - Emergency Simulator Game",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 429,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "July 19, 2018",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Pregnant Mom ER Emergency Doctor Hospital Games",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 325,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "June 12, 2018",
    "Current Ver": 1.2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Doctr – ER wait times in Canada",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 980,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "August 4, 2018",
    "Current Ver": "2.2.2926",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Plastic Surgery Surgeon Simulator Er Doctor Games",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 3482,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "August 7, 2018",
    "Current Ver": 1.6,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Shoulder Surgery ER Emergency Doctor Game",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 55,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Educational",
    "Last Updated": "November 7, 2017",
    "Current Ver": "1.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Superhero Doctor 3 ER Surgery",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 2801,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "March 22, 2017",
    "Current Ver": 1,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Mom Doctor ER Emergency Family Game",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 173,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "January 26, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "ER Blood Draw Doctor & Surgeon",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 154,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Educational",
    "Last Updated": "June 13, 2018",
    "Current Ver": 1.8,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "ER Emergency Hospital - Brain, Knee, Eye Surgery",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 25,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Educational",
    "Last Updated": "July 21, 2017",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Super Doctor 1-Pregnant Mom ER Surgery Simulator",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 290,
    Size: "73M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "May 23, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Multi Surgery Hospital Pro: Virtual Doctor ER Game",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 23,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "April 3, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Clumsy Santa ER Surgery",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 214,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "December 22, 2016",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Little Eye Surgery Simulator - ER Doctor Game",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 12,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "April 20, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Spinal Cord Surgery Doctor: Operation ER surgery",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 52,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "February 26, 2018",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "ER Neck Surgery: Hospital Christmas Emergency",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 11,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "November 24, 2017",
    "Current Ver": "1.0.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Super Doctor 2 - My Newborn Baby ER Injection",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 54,
    Size: "92M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "June 25, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Virtual Brain Surgery Simulator : Kid ER Emergency",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 20,
    Size: "55M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Educational",
    "Last Updated": "February 23, 2018",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Crazy ER Open Heart Surgery Simulator",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 2936,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "October 26, 2017",
    "Current Ver": 1.5,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "ER Injection Simulator: Blood Test Doctor Hospital",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 3263,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "May 29, 2018",
    "Current Ver": "2.6.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Kids Doctor ER Emergency Rescue Kids Hospital Game",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 515,
    Size: "85M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 20, 2018",
    "Current Ver": 7,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Heart Surgery Doctor - ER Emergency Game",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 2510,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Educational",
    "Last Updated": "July 19, 2018",
    "Current Ver": 2.1,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Virtual Mom Surgery Doctor : ER Emergency Hospital",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 1130,
    Size: "77M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Educational",
    "Last Updated": "May 15, 2018",
    "Current Ver": 1.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ER Doctor Kids Emergency Room",
    Category: "FAMILY",
    Rating: 3.1,
    Reviews: 4798,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "June 13, 2018",
    "Current Ver": 1.9,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "ER Assist",
    Category: "PRODUCTIVITY",
    Rating: 5,
    Reviews: 3,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 6, 2016",
    "Current Ver": "0.1.7",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Blood Injection : ER Emergency Doctor ER injection",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 246,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "September 23, 2016",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Lead'er",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 54,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 20, 2018",
    "Current Ver": 1.5,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Doctor Games For Girls - Hospital ER",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 51,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "April 16, 2018",
    "Current Ver": 2.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Open Heart Surgery Hospital ER: Crazy Doctor Sim",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 7,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "April 5, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Hand Doctor Games ER Surgery Simulator",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 120,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "March 13, 2018",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Get SMART ER/LA Opioids",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "April 26, 2018",
    "Current Ver": 36,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "ER Doctor City Emergency - Surgery City Doc FREE",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 1909,
    Size: "84M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Educational",
    "Last Updated": "June 13, 2018",
    "Current Ver": 2.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ER Hospital Simulator",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 286,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 28, 2018",
    "Current Ver": 4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "DMC ER Now",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 6,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 16, 2017",
    "Current Ver": 1.4,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Nose Surgery ER Simulator Lite",
    Category: "FAMILY",
    Rating: 3.1,
    Reviews: 269,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Educational",
    "Last Updated": "June 3, 2017",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "FAHREDDİN er-RÂZİ TEFSİRİ",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 9,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "March 19, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Cardinal Glennon ER Reference",
    Category: "MEDICAL",
    Rating: 4.2,
    Reviews: 19,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Medical",
    "Last Updated": "September 21, 2017",
    "Current Ver": "1.8.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "The NBC App - Watch Live TV and Full Episodes",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 58104,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 5, 2018",
    "Current Ver": "4.18.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Scanner Radio - Fire and Police Scanner",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 175509,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Fill 'er Up",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.2,
    Reviews: 58,
    Size: "18k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "February 27, 2017",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 1,
  },
  {
    App: "SnakeBite911 ER",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 9, 2017",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Ankle Surgery ER Emergency",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 10449,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Educational",
    "Last Updated": "December 2, 2016",
    "Current Ver": 1.7,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Voxer Walkie Talkie Messenger",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 230564,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "ES File Explorer/Manager PRO",
    Category: "PRODUCTIVITY",
    Rating: 4.7,
    Reviews: 81614,
    Size: "6.6M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 11, 2018",
    "Current Ver": "Pro 1.1.4.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "ES Task Manager (Task Killer )",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 171771,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 15, 2018",
    "Current Ver": "2.0.6.4",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "ES Audio Player ( Shortcut )",
    Category: "VIDEO_PLAYERS",
    Rating: 4.2,
    Reviews: 1236,
    Size: "33k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 17, 2013",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "ES Disk Analyzer - Storage Space",
    Category: "PRODUCTIVITY",
    Rating: 4.7,
    Reviews: 5867,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 31, 2017",
    "Current Ver": "1.0.2.9",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ES App Locker",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 32207,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 16, 2017",
    "Current Ver": "1.1.8.2",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "ES Chromecast plugin",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.2,
    Reviews: 23859,
    Size: "860k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "October 29, 2014",
    "Current Ver": 1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ES Material Theme for Pro",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 14428,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 3, 2015",
    "Current Ver": "2.0.3",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "ES Holo Theme for Pro",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 4737,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 26, 2015",
    "Current Ver": "2.0.3",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "ES File Explorer",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 278,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 2, 2018",
    "Current Ver": "3.1.5",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ES Dark Theme for free",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 7851,
    Size: "364k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 22, 2017",
    "Current Ver": "2.0.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "ES Classic Theme",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 20865,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 30, 2015",
    "Current Ver": "2.0.3",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "ES Themes -- Classic Theme",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 77609,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 24, 2015",
    "Current Ver": 1.14,
    numInstall: 1000000,
    numAndroid: 1,
  },
  {
    App: "ES Holo Theme",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 11449,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 2, 2016",
    "Current Ver": "2.0.4",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "ES File Explorer & Manager, Locker Xplorer 2018",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 11,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 17, 2018",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "ES Summer Chill Theme for Free",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 940,
    Size: "387k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 24, 2017",
    "Current Ver": "2.0.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Furrion ES Control",
    Category: "VIDEO_PLAYERS",
    Rating: 1.8,
    Reviews: 26,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "September 29, 2016",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "OpenGL ES Extensions - The OpenGL Utility",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 513,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 6, 2018",
    "Current Ver": "5.0.5",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "File Ex - ES File Explorer",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 24,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 27, 2017",
    "Current Ver": "1.1.6",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "OpenGL ES CapsViewer",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 78,
    Size: "375k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 1, 2018",
    "Current Ver": 0.6,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "ES-IPTV",
    Category: "VIDEO_PLAYERS",
    Rating: 4,
    Reviews: 944,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "October 15, 2017",
    "Current Ver": "4.2.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "OpenGL-ES Info",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 249,
    Size: "626k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 8, 2013",
    "Current Ver": 1.4,
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "Dr. ES PV Calculator",
    Category: "TOOLS",
    Rating: 5,
    Reviews: 19,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 11, 2018",
    "Current Ver": "3.4.7.2.16",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "ES File Explorer & File Manager 2018",
    Category: "TOOLS",
    Rating: 3.8,
    Reviews: 24,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 17, 2018",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "HTC Sense Input - ES",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 3509,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 30, 2015",
    "Current Ver": "1.0.612919",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "2019 Tricks Es File Explores",
    Category: "TOOLS",
    Rating: 3,
    Reviews: 4,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 16, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "ES Billing System (Offline App)",
    Category: "PRODUCTIVITY",
    Rating: 5,
    Reviews: 1,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 17, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "ES Anywhere",
    Category: "BUSINESS",
    Rating: 4.7,
    Reviews: 10,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 28, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "YEBIS OpenGL ES 3.0 Tech Demo",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 380,
    Size: "6.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 11, 2014",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "RAR",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 669901,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Advanced calculator fx 991 es plus & 991 ms plus",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 7252,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.3.1-build-02-08-2018-19-release",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "ES Solar",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 3,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 17, 2018",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "File Manager by Xiaomi: release file storage space",
    Category: "TOOLS",
    Rating: 4.8,
    Reviews: 337532,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 11, 2018",
    "Current Ver": "V1-180703",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "ESLock File Recovery Lite",
    Category: "PRODUCTIVITY",
    Rating: 3,
    Reviews: 460,
    Size: "161k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 5, 2016",
    "Current Ver": "1.5.9",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Castle Clash: Epic Empire ES",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 584070,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.4.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "¿Es Vegan?",
    Category: "FOOD_AND_DRINK",
    Rating: 4.6,
    Reviews: 438,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "August 1, 2017",
    "Current Ver": "2.2.3",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "ES-1",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 6,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 5, 2016",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 1,
  },
  {
    App: "Moto File Manager",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 38679,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 1, 2018",
    "Current Ver": "v3.7.93",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "School scientific calculator fx 500 es plus 500 ms",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 1553,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.3.1-build-02-08-2018-19-release",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Esto Es Guerra TVN",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 1303,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.7.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Economic Times : Market News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 93708,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 9, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "ET Markets : NSE & BSE India",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 24980,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 16, 2018",
    "Current Ver": "2.1.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "HBO NOW: Stream TV & Movies",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 61230,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 19, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "ET Telecom from Economic Times",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.7,
    Reviews: 273,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "August 7, 2018",
    "Current Ver": "2.9.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Égalité et Réconciliation",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.9,
    Reviews: 58,
    Size: "3.8M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 26, 2018",
    "Current Ver": "1.1.1",
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "Economic Times : Market News Go Edition",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.3,
    Reviews: 39,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "April 18, 2018",
    "Current Ver": "1.0.4",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Hymnes et Louanges",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.4,
    Reviews: 1877,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "March 21, 2017",
    "Current Ver": "2.4.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Lire avec Sami et Julie",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 569,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "June 13, 2014",
    "Current Ver": 1.2,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Lettre et demande d'emploi",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 302,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 2, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "MAPS.ME – Offline Map and Travel Navigation",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 932870,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 27, 2018",
    "Current Ver": "8.3.3-Google",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Recettes Faciles et Rapides",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 95,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "January 6, 2018",
    "Current Ver": "3.0.1",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Blagues et Histoires Drôles",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 859,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "February 18, 2017",
    "Current Ver": "0.0.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Lettre de motivation et CV",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 979,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 30, 2018",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Anime et Manga Amino en Français",
    Category: "SOCIAL",
    Rating: 4.8,
    Reviews: 3782,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 13, 2018",
    "Current Ver": "1.8.19106",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Google Arts & Culture",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 24137,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Moneycontrol – Stocks, Sensex, Mutual Funds, IPO",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 281635,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "CNBC: Breaking Business News & Live Market Data",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 24666,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Google Earth",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 2339098,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 18, 2018",
    "Current Ver": "9.2.17.13",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "Groupon - Shop Deals, Discounts & Coupons",
    Category: "SHOPPING",
    Rating: 4.6,
    Reviews: 1371082,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Shopping",
    "Last Updated": "August 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Photo Lab Picture Editor: face effects, art frames",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 1536512,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 17, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Google News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.9,
    Reviews: 878065,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "August 1, 2018",
    "Current Ver": "5.2.0",
    numInstall: 1000000000,
    numAndroid: 4,
  },
  {
    App: "Empires and Allies",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 398746,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Beauty and the Beast",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 70883,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle;Creativity",
    "Last Updated": "August 7, 2018",
    "Current Ver": "1.7.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hornet - Gay Social Network",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 163679,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Learn Italian with MosaLingua",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 1719,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Teen",
    Genres: "Education",
    "Last Updated": "May 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "iTranslate Translator & Dictionary",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 201718,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 11, 2018",
    "Current Ver": "4.6.15",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Oggy",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 49971,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "August 29, 2017",
    "Current Ver": "1.3.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "MomentCam Cartoons & Stickers",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 1260143,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "July 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "News by The Times of India Newspaper - Latest News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.2,
    Reviews: 522205,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "August 7, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Amino: Communities and Chats",
    Category: "SOCIAL",
    Rating: 4.8,
    Reviews: 1264084,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 7, 2018",
    "Current Ver": "1.8.19179",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Nike Training Club - Workouts & Fitness Plans",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 251618,
    Size: "93M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 18, 2018",
    "Current Ver": "5.14.0",
    numInstall: 10000000,
    numAndroid: 5,
  },
  {
    App: "Pocket Mortys",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 174215,
    Size: "93M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 3, 2018",
    "Current Ver": "2.5.2",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Hangouts Dialer - Call Phones",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 122512,
    Size: "79k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "September 2, 2015",
    "Current Ver": "0.1.100944346",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Ideal Weight, BMI Calculator",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.2,
    Reviews: 112384,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "February 23, 2018",
    "Current Ver": "2.1.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Epson iPrint",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 108169,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Offline Maps & Navigation",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.7,
    Reviews: 193364,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 7, 2018",
    "Current Ver": "17.4.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Voice changer with effects",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1260903,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.4.8",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Fitness & Bodybuilding",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.6,
    Reviews: 95201,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "2.4.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "A+ Gallery - Photos & Videos",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 223941,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "EU Mobile Money",
    Category: "FINANCE",
    Rating: 3.9,
    Reviews: 460,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 16, 2018",
    "Current Ver": 1.6,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "European Union Simulator",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 688,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "September 20, 2016",
    "Current Ver": 1.2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EU Charter",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 33,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "January 16, 2017",
    "Current Ver": "1.0.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EU Council",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 7,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 4, 2018",
    "Current Ver": "1.3.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EU Flags Free Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 3.4,
    Reviews: 730,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "November 18, 2013",
    "Current Ver": 1.95,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "myLPG.eu",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 556,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 25, 2018",
    "Current Ver": 1.95,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "YouCamp EU",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.4,
    Reviews: 39,
    Size: "32M",
    Type: "Paid",
    Price: "$2.56",
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 20, 2013",
    "Current Ver": "1.3.1",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "EU Economy",
    Category: "PRODUCTIVITY",
    Rating: 3.6,
    Reviews: 47,
    Size: "879k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 19, 2017",
    "Current Ver": 9,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Flag of European Union",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 36,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 10, 2016",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "EU Data Protection",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.5,
    Reviews: 29,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 15, 2016",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Flag Of European Union LWP",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 88,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 24, 2018",
    "Current Ver": 7,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "European Union Flag LWP",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 3,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 29, 2016",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Council Voting Calculator",
    Category: "COMMUNICATION",
    Rating: 3.9,
    Reviews: 33,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 6, 2017",
    "Current Ver": "2.3.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "EU Flags Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 444,
    Size: "12M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "November 18, 2013",
    "Current Ver": 1.95,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "EU FTL Calculator",
    Category: "BUSINESS",
    Rating: 3.6,
    Reviews: 60,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 1, 2018",
    "Current Ver": "1.5.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "The EU Relocation Programme",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 27,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 28, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Passenger rights",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.9,
    Reviews: 442,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "January 16, 2018",
    "Current Ver": "1.1.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EU Mobile Money Partenaire Commercial",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 70,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 14, 2018",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Eurostat Country Profiles",
    Category: "PRODUCTIVITY",
    Rating: 3.7,
    Reviews: 87,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 12, 2018",
    "Current Ver": 37,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EU in the World",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 8,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 2, 2018",
    "Current Ver": "1.1.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "My EU",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 4,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 15, 2017",
    "Current Ver": "3.2.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Invasion: Defend EU",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 7,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "December 8, 2017",
    "Current Ver": "1.0.|",
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "R-EU-READY",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 13,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "March 2, 2016",
    "Current Ver": 1.5,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "taxi.eu",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 1865,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 28, 2018",
    "Current Ver": "10.7.1388",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "CVRIA",
    Category: "BUSINESS",
    Rating: 4.7,
    Reviews: 68,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 11, 2017",
    "Current Ver": "1.1.10",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Speed Racing Ultimate 2",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 66894,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Racing",
    "Last Updated": "July 21, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "EU Flag Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 19,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 9, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "TAXLANDIA",
    Category: "FAMILY",
    Rating: 1.9,
    Reviews: 141,
    Size: "65M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational",
    "Last Updated": "March 6, 2018",
    "Current Ver": "1.8.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "European Solidarity Corps",
    Category: "SOCIAL",
    Rating: 3.6,
    Reviews: 9,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.2.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Have your say on Europe",
    Category: "COMMUNICATION",
    Rating: 3.8,
    Reviews: 19,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "April 19, 2018",
    "Current Ver": "1.1.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "EU CBRNE Glossary",
    Category: "LIBRARIES_AND_DEMO",
    Rating: "NaN",
    Reviews: 3,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "June 15, 2016",
    "Current Ver": "1.0.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Doorstep EU",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 67,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 26, 2018",
    "Current Ver": 1.8,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EURES - Your Job in Europe",
    Category: "BUSINESS",
    Rating: 2.7,
    Reviews: 358,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "September 18, 2017",
    "Current Ver": "1.4.1",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Autoroute.EU",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 10,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 19, 2016",
    "Current Ver": 2.6,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Invasive Alien Species Europe",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 13,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 20, 2017",
    "Current Ver": "1.0.6",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Countries of the European Union (Quiz)",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 11,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "February 3, 2018",
    "Current Ver": 1.3,
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "EU Exit poll",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 10,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 15, 2016",
    "Current Ver": 1.6,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Schengen/EU App",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 24,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 27, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "I Know Stuff",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 214923,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "July 31, 2018",
    "Current Ver": "9.1.3",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "EU WHO War",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 23, 2013",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 3,
  },
  {
    App: "Lazionews.eu",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 25,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 18, 2018",
    "Current Ver": "1.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Brexit EU",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 7,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "March 10, 2016",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Eu sou Rico",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.6M",
    Type: "Paid",
    Price: "$30.99",
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "January 9, 2018",
    "Current Ver": 1,
    numInstall: 0,
    numAndroid: 4,
  },
  {
    App: "EU Life Explorer",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 2,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "May 8, 2017",
    "Current Ver": 1.1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "E.U. Trademark Search Tool",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 29, 2018",
    "Current Ver": 1.5,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EU VAT Checker",
    Category: "BUSINESS",
    Rating: 3.1,
    Reviews: 7,
    Size: "39k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 12, 2011",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 1,
  },
  {
    App: "Dotti EU",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 15,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 9, 2018",
    "Current Ver": "2.1.18",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EU RCD Guide",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "45M",
    Type: "Paid",
    Price: "$3.61",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 29, 2016",
    "Current Ver": 2,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "daskal.eu",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 5,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 6, 2017",
    "Current Ver": "2.3.3",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Intra- and extra-EU trade data",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "December 16, 2015",
    "Current Ver": "1.0.5",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Programi podrške EU",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 15, 2018",
    "Current Ver": "1.0.3",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EU FP7 Adventure",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 15, 2013",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "GastroHunter.EU",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 1,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "April 23, 2015",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EU IP Codes",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 2,
    Size: "970k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "January 8, 2014",
    "Current Ver": "1.0.4",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Eu Sou Rico",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.4M",
    Type: "Paid",
    Price: "$394.99",
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 11, 2018",
    "Current Ver": 1,
    numInstall: 0,
    numAndroid: 4,
  },
  {
    App: "MOTOBAZAR EU",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 6, 2018",
    "Current Ver": "1.2.36",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "TattooSupplies.eu",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 31,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 9, 2017",
    "Current Ver": "1.3.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "IF YOU TO EU PEGO",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "2.1M",
    Type: "Paid",
    Price: "$1.26",
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 12, 2012",
    "Current Ver": 3,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "VAT Checker for EU company",
    Category: "BUSINESS",
    Rating: 4.7,
    Reviews: 78,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 24, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "Inbox.eu",
    Category: "COMMUNICATION",
    Rating: 3.7,
    Reviews: 98,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 11, 2018",
    "Current Ver": "6.4.7",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "CALIOPE EU: Air Quality",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.9,
    Reviews: 21,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "October 30, 2015",
    "Current Ver": "1.1.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Konferencija.eu",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 3,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 21, 2017",
    "Current Ver": "1.0.2",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Reisedealz.eu",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "September 24, 2015",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Going Abroad",
    Category: "FAMILY",
    Rating: 3,
    Reviews: 606,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Educational",
    "Last Updated": "August 16, 2016",
    "Current Ver": 1.2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EU GDPR RiskCalc",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 3, 2017",
    "Current Ver": "1.0.0",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "EU Whoiswho",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "December 1, 2016",
    "Current Ver": "0.0.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EU Brazil Green Business Forum",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 18, 2017",
    "Current Ver": "1.7.1",
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "EU-Schwerbehinderung",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 3,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 16, 2018",
    "Current Ver": "2.0.3.53",
    numInstall: 100,
    numAndroid: 6,
  },
  {
    App: "SK Bosnia Online EU Teplice",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 2,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 21, 2017",
    "Current Ver": 1.2,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Campervan.Guide Pro",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 238,
    Size: "67M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 22, 2018",
    "Current Ver": "4.6.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Qserve EU MDR First Aid",
    Category: "BUSINESS",
    Rating: 3,
    Reviews: 2,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 11, 2017",
    "Current Ver": "1.2.22",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "I'm Rich/Eu sou Rico/أنا غني/我很有錢",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "40M",
    Type: "Paid",
    Price: "$399.99",
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 1, 2017",
    "Current Ver": "MONEY",
    numInstall: 0,
    numAndroid: 4,
  },
  {
    App: "TrainPal EU- Book German Train Tickets",
    Category: "MAPS_AND_NAVIGATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "March 29, 2018",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Strawberry Shortcake Ice Cream Island",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 32200,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "November 6, 2017",
    "Current Ver": 1.2,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "NativeScript Developer Day EU",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "September 23, 2017",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EU FP7 SAM",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 12, 2015",
    "Current Ver": "1.0.3",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Rail Planner Eurail/Interrail",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 3596,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "June 15, 2018",
    "Current Ver": "3.0.1 (70)",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "eu sou franky",
    Category: "BUSINESS",
    Rating: 3.7,
    Reviews: 195,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "November 21, 2016",
    "Current Ver": "1.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Tasker",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 43045,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "efootwear.eu - online store",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 928,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.7.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ChargeHub - Find EV & Tesla Charging Stations",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.6,
    Reviews: 796,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "May 18, 2018",
    "Current Ver": "6.7.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "PlugShare",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.7,
    Reviews: 4501,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Maps & Navigation",
    "Last Updated": "July 25, 2018",
    "Current Ver": "3.5.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "NEXTCHARGE - Charging Stations",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.3,
    Reviews: 891,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 26, 2018",
    "Current Ver": "4.5.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "NissanConnect® EV & Services",
    Category: "LIFESTYLE",
    Rating: 2.3,
    Reviews: 853,
    Size: "88M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 20, 2018",
    "Current Ver": "6.2.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EV Connect",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 2.8,
    Reviews: 25,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 6, 2018",
    "Current Ver": "2.10.0",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "HondaLink EV",
    Category: "TOOLS",
    Rating: 2.8,
    Reviews: 44,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 20, 2018",
    "Current Ver": 3.8,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "EV Stations Hawaii",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.6,
    Reviews: 7,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "May 30, 2017",
    "Current Ver": "3.0.6",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Emerge EV App (eBike App)",
    Category: "LIFESTYLE",
    Rating: 3,
    Reviews: 26,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 15, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: 6,
  },
  {
    App: "EV Trip Optimizer for Tesla",
    Category: "AUTO_AND_VEHICLES",
    Rating: 3.2,
    Reviews: 46,
    Size: "6.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "June 26, 2018",
    "Current Ver": 3.4,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "JuiceNet - Smart EV Charging",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.5,
    Reviews: 106,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 9, 2018",
    "Current Ver": "2.1.223",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Zap-Map: EV charging points UK",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.8,
    Reviews: 181,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 6, 2018",
    "Current Ver": "4.0.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EV Charging",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.5,
    Reviews: 8,
    Size: "32M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 1, 2017",
    "Current Ver": "2.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Simple EV Calc",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 105,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 16, 2017",
    "Current Ver": "2.2.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "CHOSEN - EV Smart Charger",
    Category: "AUTO_AND_VEHICLES",
    Rating: "NaN",
    Reviews: 1,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "August 7, 2018",
    "Current Ver": "3.4.4",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Electric Car Charging Points: Ev charger Stations",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.5,
    Reviews: 8,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 3, 2018",
    "Current Ver": 1.3,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "ELMO EV Charging",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.4,
    Reviews: 14,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "January 25, 2018",
    "Current Ver": "2.1.05",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Bolt - EV Charging Service",
    Category: "AUTO_AND_VEHICLES",
    Rating: 3,
    Reviews: 9,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "March 23, 2018",
    "Current Ver": "2.2.0",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "To-U - free EV public charging",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 75,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 23, 2018",
    "Current Ver": "2.9.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Light Meter - EV",
    Category: "PHOTOGRAPHY",
    Rating: 4,
    Reviews: 26,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.1.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Mas Akıllı Ev",
    Category: "HOUSE_AND_HOME",
    Rating: "NaN",
    Reviews: 13,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "April 18, 2018",
    "Current Ver": 3.2,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EV Finder",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 29,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 7, 2017",
    "Current Ver": 2.7,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "SpeedApp EV",
    Category: "AUTO_AND_VEHICLES",
    Rating: "NaN",
    Reviews: 0,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 4, 2018",
    "Current Ver": 1.2,
    numInstall: 5,
    numAndroid: 6,
  },
  {
    App: "EV Real Estate Search",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 88,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 13, 2018",
    "Current Ver": "5.600.49",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Ev Dizayn",
    Category: "LIFESTYLE",
    Rating: 3.6,
    Reviews: 30,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 4, 2015",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Power Plug EV charger",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.7,
    Reviews: 13,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "December 22, 2014",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Builder Craft: House Building & Exploration",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 20807,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Simulation",
    "Last Updated": "August 2, 2017",
    "Current Ver": 1.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Texas Hold'em EV Calculator",
    Category: "TOOLS",
    Rating: 3.7,
    Reviews: 6,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 8, 2015",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Bird - Enjoy The Ride",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 2649,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 3, 2018",
    "Current Ver": "4.1.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "AÖF Ev İdaresi 1. Sınıf",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 15, 2018",
    "Current Ver": 3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EV Bon Dictionary",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 11,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 28, 2017",
    "Current Ver": 2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "German Vocabulary Trainer",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 1218,
    Size: "1.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 24, 2012",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "REV Robotic Enhance Vehicles",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 2558,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 16, 2018",
    "Current Ver": "2.0.11",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Home Workout - No Equipment",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.8,
    Reviews: 432160,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 28, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "myChevrolet",
    Category: "LIFESTYLE",
    Rating: 3.5,
    Reviews: 6747,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 11, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Electric Car Taxi Driver: NY City Cab Taxi Games",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 5886,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "May 28, 2018",
    "Current Ver": 1.2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "EV Calculator",
    Category: "TOOLS",
    Rating: 4.9,
    Reviews: 85,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 5, 2018",
    "Current Ver": 1.2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Home Decoration Game",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 17543,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "January 25, 2018",
    "Current Ver": "3.0.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "EvAk Smart Home",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 14,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 13, 2018",
    "Current Ver": "1.1.1",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "PokeType - Dex",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 36813,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 1, 2018",
    "Current Ver": "4.2.0",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Home Security Camera WardenCam - reuse old phones",
    Category: "HOUSE_AND_HOME",
    Rating: 4.3,
    Reviews: 43847,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "July 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Survival Forest : Survivor Home Builder",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 9389,
    Size: "64M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "May 31, 2018",
    "Current Ver": "1.3.4",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Room Creator Interior Design",
    Category: "HOUSE_AND_HOME",
    Rating: 3.9,
    Reviews: 59660,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "March 14, 2017",
    "Current Ver": 3.4,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Doll House Design & Decoration 2: Girls House Game",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 2338,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "May 29, 2018",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Lux Home Decorating Room Games",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 1518,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "October 20, 2017",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "eCooltra: scooter sharing. Share electric scooters",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 2822,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.21.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Design Home",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 539931,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 6, 2018",
    "Current Ver": "1.11.01",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "E.W. James & Sons",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 2,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "April 11, 2018",
    "Current Ver": "3.0.2",
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "EW Manager",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 20, 2018",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "PeopleTV - Watch Celebrity News",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 2223,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "March 28, 2018",
    "Current Ver": "1.2.0.8",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ew-Magazin",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 2,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "December 13, 2016",
    "Current Ver": "3.5.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EW PDF",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "February 14, 2018",
    "Current Ver": "1.0.2",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "EW Gate",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 16, 2018",
    "Current Ver": 3.07,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "E W Bookkeeping & Accountancy",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 23, 2018",
    "Current Ver": "1.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "News 5 Cleveland",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.7,
    Reviews: 1032,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "EW Login",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "December 13, 2017",
    "Current Ver": "1.0.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Water Surfer Racing In Moto",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 2233,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "February 28, 2018",
    "Current Ver": 1.1,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "EW Handbook",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 11, 2015",
    "Current Ver": 4,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Mee-EW",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.0.1",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "EW Widgets for Zooper",
    Category: "TOOLS",
    Rating: 3.4,
    Reviews: 5,
    Size: "1.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 3, 2016",
    "Current Ver": "1.0.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Ew, the small alien",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 5,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "January 21, 2017",
    "Current Ver": "Varies with device",
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "The List",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.5,
    Reviews: 66,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 1, 2017",
    "Current Ver": 6.11,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EW MOTION THERAPY",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "4.2.2",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "European War 6: 1804",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1330,
    Size: "96M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.1.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "XCOM®: Enemy Within",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 13752,
    Size: "21M",
    Type: "Paid",
    Price: "$9.99",
    "Content Rating": "Mature 17+",
    Genres: "Strategy",
    "Last Updated": "October 24, 2017",
    "Current Ver": "1.7.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "EW Neuron Scan",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 31, 2018",
    "Current Ver": "1.6.2",
    numInstall: 10,
    numAndroid: 5,
  },
  {
    App: "ABC15 Arizona",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.6,
    Reviews: 1820,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "NATIVE ENTERTAINMENT MAGAZINE - ISSUE # 1",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 0,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "News & Magazines",
    "Last Updated": "December 16, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Mobile Strike",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 903392,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "June 14, 2018",
    "Current Ver": "3.30.4.207",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "European War 5:Empire",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 9513,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Strategy",
    "Last Updated": "June 8, 2018",
    "Current Ver": "1.2.6",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "KMTV 3 News Now",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.8,
    Reviews: 265,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "Rescue Robots Survival Games",
    Category: "GAME",
    Rating: 4,
    Reviews: 27557,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 6, 2018",
    "Current Ver": "F2i",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Raytheon F-16 EW 360 VR",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 6,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 9, 2017",
    "Current Ver": "1.0.01",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Pregnant Emergency Surgery",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 127229,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "September 7, 2017",
    "Current Ver": "1.1.14",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Eddsworld Amino",
    Category: "SOCIAL",
    Rating: 4.9,
    Reviews: 3071,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 13, 2018",
    "Current Ver": "1.8.19106",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "TMJ4.com - WTMJ-TV Milwaukee",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.8,
    Reviews: 728,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Food Network",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 7823,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Storm Shield",
    Category: "WEATHER",
    Rating: 3.5,
    Reviews: 2000,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 31, 2018",
    "Current Ver": "4.1.12",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "EdiRange",
    Category: "TOOLS",
    Rating: 3,
    Reviews: 736,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 5, 2017",
    "Current Ver": 1.11,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "TRANSFORMERS: Earth Wars",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 256219,
    Size: "95M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.64.0.21247",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Beard Live Camera Photo Editor",
    Category: "BEAUTY",
    Rating: 4.7,
    Reviews: 900,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Beauty",
    "Last Updated": "March 25, 2018",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "WPTV 5 West Palm Beach",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.8,
    Reviews: 1093,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "No Pimple - Fun games",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 24091,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casual",
    "Last Updated": "August 4, 2016",
    "Current Ver": "1.1.0",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "WKBW 7 Eyewitness News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4,
    Reviews: 509,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 5, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Web Browser for Android",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 55110,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 20, 2018",
    "Current Ver": 2.2,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "OMG Gross Zit - Date Nightmare",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 70105,
    Size: "67M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.0.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Garden Fever - Free!",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 13253,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "August 9, 2016",
    "Current Ver": "2.1.080",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "GO SMS PRO EMOJI PLUGIN",
    Category: "PERSONALIZATION",
    Rating: 3.5,
    Reviews: 84779,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 4, 2018",
    "Current Ver": 2.4,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Bike Race - Bike Blast Rush",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 83891,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "July 19, 2018",
    "Current Ver": 3.1,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Subway Simulator 3D",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 25489,
    Size: "62M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "August 6, 2018",
    "Current Ver": "2.9.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "XCOM: TBG",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 2294,
    Size: "95M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "January 9, 2017",
    "Current Ver": "1.2.1",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "ETERNITY WARRIORS 2",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 568391,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 1, 2014",
    "Current Ver": "4.3.1",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "XE Currency",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 77585,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 31, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "Deus Ex GO",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 9699,
    Size: "23M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Teen",
    Genres: "Puzzle",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.1.111374",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ADWLauncher 1 EX",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 28728,
    Size: "2.8M",
    Type: "Paid",
    Price: "$2.49",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 27, 2013",
    "Current Ver": "1.3.3.9",
    numInstall: 500000,
    numAndroid: 1,
  },
  {
    App: "XE Currency Pro",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.4,
    Reviews: 1090,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 29, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "GO Launcher EX UI5.0 theme",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 111634,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "May 26, 2014",
    "Current Ver": 2.08,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Device Info Ex Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 2645,
    Size: "1.1M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 20, 2015",
    "Current Ver": "11.0.0",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "GO Weather EX Theme White",
    Category: "WEATHER",
    Rating: 4.2,
    Reviews: 8723,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 27, 2014",
    "Current Ver": 1,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Advanced EX for HYUNDAI",
    Category: "TOOLS",
    Rating: 2.7,
    Reviews: 168,
    Size: "170k",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 14, 2015",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 1,
  },
  {
    App: "MIUI Style GO Weather EX",
    Category: "WEATHER",
    Rating: 4.2,
    Reviews: 2115,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 4, 2014",
    "Current Ver": 1.3,
    numInstall: 500000,
    numAndroid: 1,
  },
  {
    App: "Remote EX for NISSAN",
    Category: "COMMUNICATION",
    Rating: 2.3,
    Reviews: 223,
    Size: "1.0M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 26, 2014",
    "Current Ver": 1.3,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "Ex Explorer : Dual view exproler / file manager",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 361,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 12, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Get Over Your Ex",
    Category: "DATING",
    Rating: 4.1,
    Reviews: 10,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Dating",
    "Last Updated": "April 12, 2017",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Advanced EX for MITSUBISHI",
    Category: "TOOLS",
    Rating: 2.9,
    Reviews: 33,
    Size: "141k",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 21, 2015",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 1,
  },
  {
    App: "Advanced EX for KIA",
    Category: "TOOLS",
    Rating: 3.3,
    Reviews: 257,
    Size: "160k",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 14, 2015",
    "Current Ver": 1.4,
    numInstall: 5000,
    numAndroid: 1,
  },
  {
    App: "Money Manager Ex for Android",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 2695,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Airway Ex - Intubate. Anesthetize. Train.",
    Category: "MEDICAL",
    Rating: 4.3,
    Reviews: 123,
    Size: "86M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 1, 2018",
    "Current Ver": "0.6.88",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Advanced EX for NISSAN",
    Category: "TOOLS",
    Rating: 2.9,
    Reviews: 164,
    Size: "144k",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 14, 2015",
    "Current Ver": 1.3,
    numInstall: 5000,
    numAndroid: 1,
  },
  {
    App: "Advanced EX for FIAT",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 138,
    Size: "141k",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 5, 2015",
    "Current Ver": 1.6,
    numInstall: 5000,
    numAndroid: 1,
  },
  {
    App: "Advanced EX for RENAULT",
    Category: "TOOLS",
    Rating: 2.8,
    Reviews: 130,
    Size: "143k",
    Type: "Paid",
    Price: "$4.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 14, 2015",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 1,
  },
  {
    App: "EX File Explorer File Manage Pro",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 1,
    Size: "6.3M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 6, 2017",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Aurum Blade EX",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 28151,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "June 4, 2015",
    "Current Ver": "1.0.2",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "SCI-Ex",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.5,
    Reviews: 8,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 28, 2018",
    "Current Ver": "1.0060.b0060",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Papyrus Ex",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 1092,
    Size: "190k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 27, 2012",
    "Current Ver": "2.3.3",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "GLASS GO Launcher EX Theme",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 18280,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 8, 2015",
    "Current Ver": 1.28,
    numInstall: 1000000,
    numAndroid: 1,
  },
  {
    App: "Moonlight GO Weather EX",
    Category: "WEATHER",
    Rating: 4.2,
    Reviews: 11510,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "August 28, 2014",
    "Current Ver": 1.4,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "My Ex Girlfriend Comes Back",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 3258,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "March 4, 2016",
    "Current Ver": "1.0.0",
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "An Elite Warrior Ex",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 15,
    Size: "93M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "November 21, 2016",
    "Current Ver": 1.59,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Gods Wars Ex : Vampire",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 1550,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Role Playing",
    "Last Updated": "October 28, 2017",
    "Current Ver": "1.0.6",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "BakaReader EX",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.3,
    Reviews: 8894,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.1.51",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Snes9x EX+",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 70351,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "March 3, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "X your Ex - Break Up Treatment",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4,
    Reviews: 32,
    Size: "64M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "May 20, 2017",
    "Current Ver": 3.9,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Ex Quotes",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 129,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Lifestyle",
    "Last Updated": "June 16, 2018",
    "Current Ver": "3.0.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "GO Contacts EX Black & Grey",
    Category: "PERSONALIZATION",
    Rating: 3.7,
    Reviews: 21,
    Size: "376k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "September 24, 2013",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 1,
  },
  {
    App: "CYANOGEN GO Launcher EX Theme",
    Category: "PERSONALIZATION",
    Rating: 4.3,
    Reviews: 60298,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "January 8, 2015",
    "Current Ver": 1.38,
    numInstall: 5000000,
    numAndroid: 1,
  },
  {
    App: "Ex Service Taxis",
    Category: "BUSINESS",
    Rating: 3.5,
    Reviews: 15,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 21, 2015",
    "Current Ver": "20.7.9.2",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Rejoin Your Ex",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "May 26, 2015",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "S.O.L : Stone of Life EX",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 171220,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "July 28, 2015",
    "Current Ver": "1.2.6",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "How To Get Your Ex Back Fast",
    Category: "LIFESTYLE",
    Rating: 4,
    Reviews: 22,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "February 7, 2018",
    "Current Ver": 15,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "ExDialer PRO Key",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 5474,
    Size: "17k",
    Type: "Paid",
    Price: "$3.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 15, 2014",
    "Current Ver": 81,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Volume Control Ex",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 5,
    Size: "2.5M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.6.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Virtual Dice EX",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 40,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "March 15, 2016",
    "Current Ver": 2.8,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "Black Theme Go Launcher EX",
    Category: "PERSONALIZATION",
    Rating: 4.1,
    Reviews: 285,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "October 3, 2017",
    "Current Ver": 5,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "EY Events",
    Category: "BUSINESS",
    Rating: 2.5,
    Reviews: 31,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 4, 2018",
    "Current Ver": 2.6,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EY GlobalOne",
    Category: "BUSINESS",
    Rating: 2.7,
    Reviews: 11,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "November 27, 2017",
    "Current Ver": "3.1.0",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "EY Team Connect",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 8, 2018",
    "Current Ver": "1.20180531.3",
    numInstall: 50,
    numAndroid: 5,
  },
  {
    App: "EY eMentor",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 5,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 3, 2016",
    "Current Ver": "1.0.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "EY Conferences",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 16, 2018",
    "Current Ver": 5.28,
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "EY Africa",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 9, 2018",
    "Current Ver": "1.42.180409",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EY TaxChat",
    Category: "FINANCE",
    Rating: 1.2,
    Reviews: 44,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 9, 2018",
    "Current Ver": "3.24.0",
    numInstall: 1000,
    numAndroid: 6,
  },
  {
    App: "EY Expenses",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 9, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EY Tax Briefing",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 3,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 21, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EY Digital Direct",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 3, 2018",
    "Current Ver": 2,
    numInstall: 5,
    numAndroid: 6,
  },
  {
    App: "EY India Tax Insights",
    Category: "BUSINESS",
    Rating: 4.7,
    Reviews: 87,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 15, 2017",
    "Current Ver": "0.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EY Forensics",
    Category: "FINANCE",
    Rating: 4.9,
    Reviews: 7,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 17, 2016",
    "Current Ver": "1.0.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EY India CFO Insights",
    Category: "BUSINESS",
    Rating: 4.7,
    Reviews: 37,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 29, 2018",
    "Current Ver": 1.5,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "EY Digital Tax AR",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "September 29, 2017",
    "Current Ver": 1.6,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EY Divest",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 11, 2017",
    "Current Ver": "1.0.0",
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "EY ATL Fuel Calculator",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 15,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 21, 2018",
    "Current Ver": 12,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Fuel Calculator for EY",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 32,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 15, 2018",
    "Current Ver": 1.11,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "EY Digi India Personal Tax",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 2,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 24, 2018",
    "Current Ver": 5,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EY Catalyst Reader",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "8.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 10, 2018",
    "Current Ver": "1.2.1",
    numInstall: 5,
    numAndroid: 5,
  },
  {
    App: "Pink Guy - Ey B0ss",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 13,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 4, 2016",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "EY Staff ENTERTAINER",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 218,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 16, 2017",
    "Current Ver": "1.0.3",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "EY EMEIA Diversity & Inclusion",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 4,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "November 25, 2016",
    "Current Ver": "1.0.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Ey Sey Storytime រឿងនិទានតាឥសី",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 1327,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education;Education",
    "Last Updated": "May 18, 2017",
    "Current Ver": "1.2.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EY Football",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 14, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Eyes - The Scary Horror Game Adventure",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 499483,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "August 2, 2018",
    "Current Ver": "5.6.14",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Amleen Ey",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 24, 2017",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "EY Events Switzerland",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 1,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Productivity",
    "Last Updated": "June 29, 2018",
    "Current Ver": "7.17.2.3",
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "EY TaxLaw NL",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 9,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 3, 2018",
    "Current Ver": "3.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "EY-Parthenon",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 1,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 25, 2018",
    "Current Ver": "5.30.01",
    numInstall: 5,
    numAndroid: 5,
  },
  {
    App: "EY Belgium Inhouse Day 2018",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "May 14, 2018",
    "Current Ver": "18.4.8.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Tenh Ey",
    Category: "SHOPPING",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "March 31, 2017",
    "Current Ver": "1.0.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "EY Oil & Gas",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 20,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 12, 2017",
    "Current Ver": "1.4.36",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Coupe Adhémar EY 2017",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 6,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "December 26, 2016",
    "Current Ver": 1.3,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "哈哈姆特不EY",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 239,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.3.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Adhenarcos - Coupe Adhemar EY 2018",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "January 10, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Third Eye",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 19877,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 7, 2018",
    "Current Ver": "1.1.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Sudoku Master",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 58387,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "December 13, 2013",
    "Current Ver": "1.1.2",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Jungle Monkey Run",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 54082,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Adventure",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.6.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Hey That's Pretty Good!",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 222,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 29, 2016",
    "Current Ver": "4.2.0",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Everbridge",
    Category: "COMMUNICATION",
    Rating: 3.1,
    Reviews: 497,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 17, 2018",
    "Current Ver": "8.6.2",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "I am Dentist - Save my Teeth",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 7443,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "September 29, 2016",
    "Current Ver": "1.0.11",
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Best Auto Call Recorder Free",
    Category: "COMMUNICATION",
    Rating: 3.7,
    Reviews: 7,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "October 2, 2017",
    "Current Ver": 2.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "FilterGrid - Cam&Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 126338,
    Size: "9.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 15, 2017",
    "Current Ver": "2.0.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "EyPools",
    Category: "HOUSE_AND_HOME",
    Rating: "NaN",
    Reviews: 2,
    Size: "656k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "November 24, 2017",
    "Current Ver": 1.3,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Etihad Airways",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.1,
    Reviews: 3674,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 9, 2018",
    "Current Ver": "1.8.1 (41)",
    numInstall: 500000,
    numAndroid: 5,
  },
  {
    App: "Beach Volleyball 3D",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 43191,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "January 10, 2018",
    "Current Ver": "1.0.3",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Organizer",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 936,
    Size: "5.4M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 17, 2018",
    "Current Ver": 2.96,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EZ Video Download for Facebook",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 34079,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "March 14, 2017",
    "Current Ver": 2.001,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "EZCast – Cast Media to TV",
    Category: "VIDEO_PLAYERS",
    Rating: 3.6,
    Reviews: 32112,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 4, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "EZ Cleaner - Booster Optimizer",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 6801,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 8, 2018",
    "Current Ver": "1.3.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "EZ PZ RPG",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 70903,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "October 27, 2016",
    "Current Ver": "2.164.4",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "EZ Receipts",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 2187,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "EZ Thanks",
    Category: "BUSINESS",
    Rating: 3.2,
    Reviews: 116,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 13, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "EZ Inspections",
    Category: "PRODUCTIVITY",
    Rating: 2.8,
    Reviews: 160,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 27, 2018",
    "Current Ver": "4.5.24",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EZ-ELD Update",
    Category: "AUTO_AND_VEHICLES",
    Rating: 3.1,
    Reviews: 14,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "February 9, 2018",
    "Current Ver": 16,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EZ Display",
    Category: "PRODUCTIVITY",
    Rating: 2.9,
    Reviews: 280,
    Size: "10.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 14, 2014",
    "Current Ver": "1.0.0.457",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EZ Web Video Cast | Chromecast",
    Category: "VIDEO_PLAYERS",
    Rating: 4.1,
    Reviews: 1276,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "December 14, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "ez Share Android app",
    Category: "PHOTOGRAPHY",
    Rating: 3.3,
    Reviews: 1461,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 31, 2017",
    "Current Ver": "3.2.6",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "EZ File Manager(Root Explorer)",
    Category: "PRODUCTIVITY",
    Rating: 3.5,
    Reviews: 626,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "June 23, 2015",
    "Current Ver": 1.1,
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "EZ Launcher",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 18926,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "September 28, 2013",
    "Current Ver": "0.5.2 beta",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "EZ-SEE",
    Category: "VIDEO_PLAYERS",
    Rating: 2.8,
    Reviews: 71,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 18, 2018",
    "Current Ver": 3.08,
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "EZ-ELD Driver App (Free)",
    Category: "AUTO_AND_VEHICLES",
    Rating: 2.1,
    Reviews: 83,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 29, 2018",
    "Current Ver": "1.0.12",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Ez Mirror Match",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 3344,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "January 3, 2018",
    "Current Ver": 2.1,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "EZ Notes Lite",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 69,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 8, 2016",
    "Current Ver": 2.79,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EZ Bluetooth",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 789,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 5, 2014",
    "Current Ver": "Varies with device",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "Dream EZ",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.1,
    Reviews: 107,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "March 24, 2016",
    "Current Ver": "1.0.0",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "Ez Texting",
    Category: "BUSINESS",
    Rating: 3.3,
    Reviews: 49,
    Size: "51k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "January 18, 2012",
    "Current Ver": 0.59,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "EZ TV Player",
    Category: "VIDEO_PLAYERS",
    Rating: 3.5,
    Reviews: 51,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "June 26, 2018",
    "Current Ver": "8.0.9",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "EZ-GUI Ground Station",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 3696,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 10, 2017",
    "Current Ver": 4.5,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Ez iCam",
    Category: "PHOTOGRAPHY",
    Rating: 3.1,
    Reviews: 7300,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Photography",
    "Last Updated": "January 12, 2018",
    "Current Ver": "V4.1.0",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "E-Z App™ Train Control",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 33,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 6, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EZ App Installer",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 533,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 22, 2017",
    "Current Ver": "1.4.13",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "EZ Clock & Weather Widget",
    Category: "WEATHER",
    Rating: 4.2,
    Reviews: 6849,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "March 5, 2014",
    "Current Ver": "v1.9.6 beta 1",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "EZ Pass",
    Category: "TOOLS",
    Rating: 2.5,
    Reviews: 15,
    Size: "228k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 10, 2016",
    "Current Ver": 1.3,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "EZ Usenet for Easynews®",
    Category: "VIDEO_PLAYERS",
    Rating: 3.9,
    Reviews: 244,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "June 23, 2016",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "EZ View",
    Category: "BUSINESS",
    Rating: 3,
    Reviews: 287,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "October 26, 2015",
    "Current Ver": "1.0.0.32",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EZ TAG Express",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.2,
    Reviews: 86,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 17, 2018",
    "Current Ver": "2.5.186032",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EZ Wifi Notification",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 260,
    Size: "193k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 11, 2014",
    "Current Ver": 1.8,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "EZ-VPNGate",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 36,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 21, 2017",
    "Current Ver": "1.0.7",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "EZ Switch Widget",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 2412,
    Size: "192k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "September 27, 2012",
    "Current Ver": "0.1.8 beta",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "EZ-Builder Mobile",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 51,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 2, 2018",
    "Current Ver": "2018.04.02.00",
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "EZ LED",
    Category: "TOOLS",
    Rating: 2.2,
    Reviews: 19,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 5, 2017",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "F&M Bank - EZ Banking",
    Category: "FINANCE",
    Rating: 3.9,
    Reviews: 49,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 24, 2017",
    "Current Ver": "3.34.0+1702241319.a",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "My EZ-Link Mobile",
    Category: "LIFESTYLE",
    Rating: 2.8,
    Reviews: 3187,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 27, 2017",
    "Current Ver": "1.0.11",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "EZ Financial Calculator",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 32,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "January 13, 2018",
    "Current Ver": 2.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EZ Quran",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 595,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 28, 2016",
    "Current Ver": 6,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "EZ Screenshot",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 55,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 12, 2017",
    "Current Ver": "1.1.4",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "EZ Utilities Extension",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 33,
    Size: "473k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 5, 2016",
    "Current Ver": 9,
    numInstall: 5000,
    numAndroid: 6,
  },
  {
    App: "EZ-Placard - Free Placard Calculator",
    Category: "TOOLS",
    Rating: 2.9,
    Reviews: 7,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 26, 2017",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "EZ game screen recorder with audio 1080P",
    Category: "VIDEO_PLAYERS",
    Rating: 4.1,
    Reviews: 40,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 13, 2017",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "FA Player Essentials",
    Category: "SPORTS",
    Rating: 5,
    Reviews: 7,
    Size: "68M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 23, 2018",
    "Current Ver": "1.6.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "HTC Sense Input - FA",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 1420,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 9, 2015",
    "Current Ver": "1.0.606863",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "FEABIE: Feedees, BBW, BHM & FA",
    Category: "DATING",
    Rating: 3.7,
    Reviews: 1212,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "February 16, 2018",
    "Current Ver": "4.4.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Test Server SMS FA",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 27, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Messages, Text and Video Chat for Messenger",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 49580,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "June 4, 2018",
    "Current Ver": 1.24,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "All Social Networks",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 22650,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "May 21, 2018",
    "Current Ver": "2.4.12",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Facebook Face to Face Events",
    Category: "BUSINESS",
    Rating: 4.4,
    Reviews: 4518,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "March 1, 2018",
    "Current Ver": 1.5,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "FA Part 1 & 2 Past Papers Solved Free – Offline",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.9,
    Reviews: 46,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "April 30, 2018",
    "Current Ver": 1.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "CNY Slots : Gong Xi Fa Cai 发财机",
    Category: "GAME",
    Rating: 3.6,
    Reviews: 33,
    Size: "71M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "June 6, 2017",
    "Current Ver": 1.2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Il Coccodrillo Come Fa",
    Category: "FAMILY",
    Rating: 3.4,
    Reviews: 17,
    Size: "246k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 21, 2014",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Hertfordshire FA",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "January 18, 2017",
    "Current Ver": 1.3,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Farsi Keyboard",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 9716,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 10, 2018",
    "Current Ver": 4.7,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Premier League - Official App",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 63782,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 7, 2018",
    "Current Ver": "1.1.5",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Golden HoYeah Slots - Real Casino Slots",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 201537,
    Size: "68M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.1.7",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Dio Fa Cose",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 35,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 15, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "FaFaFa™ Gold Casino: Free slot machines",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 11051,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "June 25, 2018",
    "Current Ver": "1.9.58",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Messenger Messenger",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 38826,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "August 7, 2018",
    "Current Ver": 1.6,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "F.A Sumon songs",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 6,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 18, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "NCLEX-RN Q&A FLASH CARDS - FA Davis",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 2,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 19, 2018",
    "Current Ver": "2.7.6",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "LEADS FA",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 31,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "October 17, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Farm Heroes Saga",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 7615646,
    Size: "71M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "August 7, 2018",
    "Current Ver": "5.2.6",
    numInstall: 100000000,
    numAndroid: 2,
  },
  {
    App: "All AJK Board Matric Fa Fsc Results",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 22, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "ESPN Fantasy Sports",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 176487,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "November 21, 2017",
    "Current Ver": "5.3.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Heart of Vegas™ Slots – Free Slot Casino Games",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 264282,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Casino",
    "Last Updated": "July 12, 2018",
    "Current Ver": "3.10.43",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Fallout Shelter",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 2721923,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "June 11, 2018",
    "Current Ver": "1.13.12",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Authy 2-Factor Authentication",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 15070,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": "23.2.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Facejjang",
    Category: "PHOTOGRAPHY",
    Rating: 4.1,
    Reviews: 100179,
    Size: "96M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 17, 2018",
    "Current Ver": 2.52,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Block Puzzle - Wood Legend",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 318867,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "July 6, 2018",
    "Current Ver": 26,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Soccer 2018",
    Category: "SPORTS",
    Rating: 3.5,
    Reviews: 172373,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 12, 2018",
    "Current Ver": 1.3,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Flash Light on Call & SMS",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 25438,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 24, 2018",
    "Current Ver": "1.2.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fart sound pranks",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 283823,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Casual",
    "Last Updated": "November 23, 2016",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Facebook Creator",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 3895,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "June 27, 2018",
    "Current Ver": "176.0.0.29.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Swift for Facebook Lite",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 9562,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "May 31, 2018",
    "Current Ver": "4.1.0",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Friendly for Facebook",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 42621,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 7, 2018",
    "Current Ver": "2.1.05",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Facebook Pages Manager",
    Category: "BUSINESS",
    Rating: 4,
    Reviews: 1279800,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 50000000,
    numAndroid: null,
  },
  {
    App: "Mini for fb lite",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 710,
    Size: "1.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 24, 2018",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Faster for Facebook Lite",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 24456,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "May 29, 2018",
    "Current Ver": 4.7,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Facebook Ads Manager",
    Category: "BUSINESS",
    Rating: 4.1,
    Reviews: 19051,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 1, 2018",
    "Current Ver": "99.0.0.35.75",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Who Viewed My FB Profile",
    Category: "FAMILY",
    Rating: 3.4,
    Reviews: 121,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 26, 2017",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Puffin for Facebook",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 10743,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "December 28, 2017",
    "Current Ver": "7.0.4.17908",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Lite for Facebook Messenger",
    Category: "COMMUNICATION",
    Rating: 4.3,
    Reviews: 76498,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "June 20, 2018",
    "Current Ver": "6.3.2",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "Profile Tracker - Who Viewed My Facebook Profile",
    Category: "SOCIAL",
    Rating: 4.7,
    Reviews: 37090,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 1, 2018",
    "Current Ver": 5.4,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Who viewed my fb profile pro★★",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 6396,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 17, 2017",
    "Current Ver": 24.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Video Downloader For FB: Save FB Videos 2018",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 434,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 8, 2018",
    "Current Ver": "1.1.9",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Pink Color for Facebook",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 5285,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "July 1, 2018",
    "Current Ver": "2.0.5",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Messenger",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 68025,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "April 16, 2018",
    "Current Ver": 1,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Stickers for Imo, fb, whatsapp",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 214,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "October 23, 2016",
    "Current Ver": "1.0.0.2",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Who Viewed My Facebook Profile - Stalkers Visitors",
    Category: "SOCIAL",
    Rating: 4.6,
    Reviews: 273244,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "June 24, 2018",
    "Current Ver": "4.1.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Downloader plus for FB",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 4,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "December 23, 2017",
    "Current Ver": 1.3,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Cover Camera for FB",
    Category: "PHOTOGRAPHY",
    Rating: 3.8,
    Reviews: 742,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "March 9, 2014",
    "Current Ver": "3.0.0",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "MB Notifications for FB (Free)",
    Category: "SOCIAL",
    Rating: 3.9,
    Reviews: 3047,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "April 29, 2015",
    "Current Ver": "1.17.0",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "MultiMessage for FB Messenger",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 182,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 28, 2018",
    "Current Ver": "1.0.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Messenger Kids – Safer Messaging and Video Chat",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 3478,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication;Creativity",
    "Last Updated": "August 6, 2018",
    "Current Ver": "33.0.0.22.76",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "FB Live",
    Category: "BUSINESS",
    Rating: 3.7,
    Reviews: 27,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 17, 2018",
    "Current Ver": "1.2.0",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "Phoenix - Facebook & Messenger",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 9606,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 18, 2018",
    "Current Ver": "2.2.0717",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Faster Social for Facebook",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 1236,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "August 2, 2018",
    "Current Ver": 1.8,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Check Your Visitors on FB ?",
    Category: "SOCIAL",
    Rating: 3.6,
    Reviews: 40,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "February 17, 2017",
    "Current Ver": 4.4,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Videos downloader for Facebook:fast fb video saver",
    Category: "VIDEO_PLAYERS",
    Rating: 4.3,
    Reviews: 20,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "April 27, 2018",
    "Current Ver": "1.0.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Stickers for Facebook",
    Category: "SOCIAL",
    Rating: 4.3,
    Reviews: 11066,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "March 13, 2018",
    "Current Ver": 1.4,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Video Download For FB",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 444,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 14, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Video Downloader for FB : Video Download with Link",
    Category: "VIDEO_PLAYERS",
    Rating: 4.5,
    Reviews: 1060,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "December 20, 2017",
    "Current Ver": 2.1,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Video Downloader for FB",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 53,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.0.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "FB Photographie",
    Category: "PHOTOGRAPHY",
    Rating: 4.7,
    Reviews: 37,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 22, 2016",
    "Current Ver": 2,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Lite Messenger for Facebook Lite",
    Category: "SOCIAL",
    Rating: 3.8,
    Reviews: 108,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "May 28, 2018",
    "Current Ver": 3.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Download Facebook Photo Albums",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 3840,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 2, 2017",
    "Current Ver": 2.4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Mini for Facebook lite",
    Category: "SOCIAL",
    Rating: 4.1,
    Reviews: 260,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "June 21, 2018",
    "Current Ver": 1.2,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "FB Advanced Search",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 2,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "July 21, 2018",
    "Current Ver": "1.1.1",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "funny Image Comments for FB",
    Category: "SOCIAL",
    Rating: 3.9,
    Reviews: 19,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "February 13, 2018",
    "Current Ver": 2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "IDM for Facebook ★ Downloader",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 1905,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 17, 2015",
    "Current Ver": 7.95,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Unlimited Group Links - Whatsapp, FB, Telegram",
    Category: "SOCIAL",
    Rating: 3.4,
    Reviews: 44,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "July 3, 2018",
    "Current Ver": 4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EasyLive - FB Live Helper",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 6,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Business",
    "Last Updated": "June 25, 2018",
    "Current Ver": "1.9.0",
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "HD VideoDownlaoder For Fb : XXVideo Downloader",
    Category: "VIDEO_PLAYERS",
    Rating: 4.2,
    Reviews: 61,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.0.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Barca News - app for Barcelona FC Fans",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 207,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "November 13, 2017",
    "Current Ver": "2.6.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FC Barcelona Fantasy Manager: Real football mobile",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 15221,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "October 2, 2017",
    "Current Ver": "7.30.005",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Classic FC 64 IN 1",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1749,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "December 29, 2017",
    "Current Ver": "1.0.0",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "FC Barcelona Official Keyboard",
    Category: "SPORTS",
    Rating: 4.7,
    Reviews: 5229,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 17, 2018",
    "Current Ver": "2.1.0.0.15734",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Barcelona Live 2018—Goals & News for Barca FC Fans",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 342,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 6, 2018",
    "Current Ver": "2.22.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Barcelona News - Sportfusion",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 382,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 6, 2018",
    "Current Ver": 3.953,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Barcelona Calendar",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 670,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "November 17, 2017",
    "Current Ver": 2.2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Barca News - FC Barcelona, World Foot & Transfers",
    Category: "SPORTS",
    Rating: 4.8,
    Reviews: 160,
    Size: "6.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 4, 2018",
    "Current Ver": 4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FC Bayern Munich",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 37140,
    Size: "71M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": "1.3.11",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "FC BARCELONA EVENTS",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 6,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "April 22, 2018",
    "Current Ver": "v2.7.11.16",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Cambridge English FC",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 761,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 6, 2016",
    "Current Ver": "2.1.0",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Barcelona Live - Goal Score & News for Barca Fans",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 38,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 17, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Seattle Sounders FC",
    Category: "SPORTS",
    Rating: 3.3,
    Reviews: 974,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2018.0.12",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FCB Connect - FC Barcelona",
    Category: "SOCIAL",
    Rating: 4.5,
    Reviews: 795,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "June 7, 2018",
    "Current Ver": "2.1.5",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "1. FC Köln App",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 2019,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 20, 2018",
    "Current Ver": "1.13.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "File Commander - File Manager/Explorer",
    Category: "BUSINESS",
    Rating: 4.3,
    Reviews: 758590,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "FC Porto",
    Category: "SPORTS",
    Rating: 4.9,
    Reviews: 15883,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 19, 2018",
    "Current Ver": "2.6.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Fulham FC",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 401,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 9, 2017",
    "Current Ver": 5,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Barcelona FC Noticias Live",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 2,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "February 4, 2018",
    "Current Ver": 2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Chelsea FC Official Keyboard",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 91397,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 3, 2018",
    "Current Ver": "3.4.4",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Burnley FC",
    Category: "SPORTS",
    Rating: 4.9,
    Reviews: 195,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2018.8.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Atlanta United FC",
    Category: "SPORTS",
    Rating: 3.7,
    Reviews: 215,
    Size: "76M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 28, 2018",
    "Current Ver": "2.10.5-prod-release",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Barcelona Wallpaper HD",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 93,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "February 28, 2018",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Sydney FC Official App",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 57,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 26, 2018",
    "Current Ver": "3.0.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Birmingham City FC",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 191,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2018.8.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FC Browser - Focus Privacy Browser",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 26,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "November 24, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "My AEK - Official ΑΕΚ FC app",
    Category: "SPORTS",
    Rating: 4.8,
    Reviews: 3346,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "January 18, 2018",
    "Current Ver": "2.0.2",
    numInstall: 50000,
    numAndroid: null,
  },
  {
    App: "FC Parking",
    Category: "MAPS_AND_NAVIGATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "December 1, 2017",
    "Current Ver": "1.0.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Noticias FC Barcelona",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 5,
    Reviews: 4,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 15, 2018",
    "Current Ver": 1.3,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Toronto FC",
    Category: "SPORTS",
    Rating: 3.4,
    Reviews: 144,
    Size: "79M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Sports",
    "Last Updated": "May 11, 2018",
    "Current Ver": "4.2.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Middlesbrough FC Official",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 152,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 29, 2018",
    "Current Ver": "2018.5.25",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "The 5th Stand",
    Category: "SPORTS",
    Rating: 4.8,
    Reviews: 1697,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": "1.2.677",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Galaxian(FC)",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 2,
    Size: "7.8M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "November 13, 2015",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "FC Red Bull Salzburg App",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 1526,
    Size: "89M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 7, 2018",
    "Current Ver": "4.0.4-R",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "FC Zenit official Android app",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 5675,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "April 18, 2018",
    "Current Ver": "3.0.10",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Fan App for Portsmouth FC",
    Category: "SPORTS",
    Rating: 4.5,
    Reviews: 53,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Sports",
    "Last Updated": "August 6, 2016",
    "Current Ver": 60816,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Latest Barcelona News 24h",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 104,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "January 6, 2018",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Mobile FC",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 5015,
    Size: "57M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 25, 2018",
    "Current Ver": 125,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "FirstCry Baby & Kids Shopping, Fashion & Parenting",
    Category: "SHOPPING",
    Rating: 4.1,
    Reviews: 41074,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "June 27, 2018",
    "Current Ver": 68,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Fan App for Reading FC",
    Category: "SPORTS",
    Rating: 3.6,
    Reviews: 9,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Sports",
    "Last Updated": "August 6, 2016",
    "Current Ver": 60816,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Deportivo Toluca FC",
    Category: "SPORTS",
    Rating: 4.7,
    Reviews: 2317,
    Size: "5.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.0.20",
    numInstall: 50000,
    numAndroid: 5,
  },
  {
    App: "Underdog FC",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 216,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 2, 2018",
    "Current Ver": 23.17,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Las Vegas Lights FC",
    Category: "SPORTS",
    Rating: 4.9,
    Reviews: 10,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 9, 2018",
    "Current Ver": "2.0.833.18",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "APOEL FC",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 688,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "January 7, 2015",
    "Current Ver": "Varies with device",
    numInstall: 10000,
    numAndroid: null,
  },
  {
    App: "FD Shift Calendar Widget",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 981,
    Size: "73k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 16, 2011",
    "Current Ver": "1.2.4",
    numInstall: 100000,
    numAndroid: 1,
  },
  {
    App: "Bank FD Interest Calculator",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 166,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "January 7, 2018",
    "Current Ver": 2.5,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FD VR Video Player - (Stored)",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 751,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 30, 2016",
    "Current Ver": "3.6.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "FD Mobile",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 53,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "September 20, 2017",
    "Current Ver": "2.1.2",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Formula DRIFT",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 169,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 27, 2018",
    "Current Ver": "2.0.855.33",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FD VR - Virtual 3D Web Browser",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 729,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 9, 2018",
    "Current Ver": "4.6.12c",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "FD Community FCU Mobile",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 175,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 12, 2018",
    "Current Ver": "5.9.1.0",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Female Daily",
    Category: "BEAUTY",
    Rating: 3.9,
    Reviews: 4354,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Beauty",
    "Last Updated": "August 6, 2018",
    "Current Ver": "2.5.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "FD VR - Virtual App Launcher",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.1,
    Reviews: 1463,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "November 30, 2016",
    "Current Ver": "3.6.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "FD VR Player - for 360 Youtube",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 100,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 30, 2016",
    "Current Ver": "3.6.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FD VR Store -VR Games and Apps",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 105,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "November 30, 2016",
    "Current Ver": "3.6.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Policy And FD Manager",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 20,
    Size: "4.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 9, 2018",
    "Current Ver": 14,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "FD VR - Virtual Reality Camera",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 1007,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 30, 2016",
    "Current Ver": "3.6.1",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Sports Lite",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 16,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 31, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FD VR Theater - for Youtube VR",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 4585,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 30, 2016",
    "Current Ver": "3.6.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Story Time FD",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 2,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Simulation",
    "Last Updated": "March 25, 2016",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 1,
  },
  {
    App: "FD Calculator | Term Deposit | Fixed Deposit",
    Category: "FINANCE",
    Rating: 4.8,
    Reviews: 12,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 13, 2018",
    "Current Ver": 2.1,
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "FD CANNECT",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "75M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 31, 2018",
    "Current Ver": 3,
    numInstall: 1,
    numAndroid: 8,
  },
  {
    App: "Financial Calculator India",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 13819,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 4, 2018",
    "Current Ver": 3.3,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "FD Calculator (EMI, SIP, RD & Loan Eligilibility)",
    Category: "FINANCE",
    Rating: 5,
    Reviews: 104,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 7, 2018",
    "Current Ver": "2.1.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FD VR Cardboard Featured 360 Videos",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 76,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 19, 2017",
    "Current Ver": "4.5.1c",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "EMI, FD, RD - Bank Calculator",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 42,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 2, 2017",
    "Current Ver": 2.3,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "FD VR Player - for Youtube 3D",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 2378,
    Size: "9.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 30, 2016",
    "Current Ver": "3.6.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "RD/FD Calculator",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 92,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "January 31, 2017",
    "Current Ver": "1.2.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FD VR Music Videos - MTV Pop and Rap in 360",
    Category: "FAMILY",
    Rating: 4.9,
    Reviews: 15,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "December 19, 2017",
    "Current Ver": "4.5.3c",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FD VR - Virtual Photo Gallery",
    Category: "FAMILY",
    Rating: 3.5,
    Reviews: 179,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 30, 2016",
    "Current Ver": "3.6.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Fix Deposit Calculator (FD)",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 7,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "February 6, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FD Interest Calculator",
    Category: "FINANCE",
    Rating: 4.2,
    Reviews: 17,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "January 18, 2015",
    "Current Ver": 2.7,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "Deposit Calculator FD & RD",
    Category: "FINANCE",
    Rating: 4.4,
    Reviews: 18,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "January 21, 2017",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "FD Fotografia",
    Category: "PHOTOGRAPHY",
    Rating: "NaN",
    Reviews: 2,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "January 17, 2018",
    "Current Ver": "0.0.9",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Banking Calculator",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 3704,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 20, 2018",
    "Current Ver": 34,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "FD e-paper",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.1,
    Reviews: 183,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 4, 2018",
    "Current Ver": "2.2.9",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FD Fitness",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 3,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 4, 2018",
    "Current Ver": "6.3.1",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "EMI/FD/RD/PV/IRR/BEP/EOQ Calc",
    Category: "FINANCE",
    Rating: 4.5,
    Reviews: 58,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "December 9, 2015",
    "Current Ver": "1.6.3",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "EMI Calculator | FD Calculator | RD calculator",
    Category: "FINANCE",
    Rating: 4.6,
    Reviews: 106,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 19, 2018",
    "Current Ver": 5.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "LineStar for FanDuel",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 1539,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Sports",
    "Last Updated": "June 6, 2018",
    "Current Ver": "3.0.3",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "HD Video Download for Facebook",
    Category: "VIDEO_PLAYERS",
    Rating: 4.4,
    Reviews: 20755,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "March 16, 2018",
    "Current Ver": "4.0.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fire Emblem Heroes",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 407694,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "July 19, 2018",
    "Current Ver": "2.7.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Santa Fe FCU Mobile Banking",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 12,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "January 22, 2018",
    "Current Ver": "1.18.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FE Connect",
    Category: "TOOLS",
    Rating: 4.8,
    Reviews: 24,
    Size: "4.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 14, 2017",
    "Current Ver": "2.3.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "FE Civil Engineering Exam Prep",
    Category: "FAMILY",
    Rating: 2.8,
    Reviews: 9,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "5.33.3669",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "FE CREDIT - TET VUI",
    Category: "FINANCE",
    Rating: 4.1,
    Reviews: 125,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 6, 2018",
    "Current Ver": "1.2.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "FE Mechanical Engineering Prep",
    Category: "FAMILY",
    Rating: 1,
    Reviews: 2,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "5.33.3669",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "FE Mobile",
    Category: "BUSINESS",
    Rating: 3,
    Reviews: 2,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 10, 2018",
    "Current Ver": "1.4.5",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Comunidad De Fe Minitries",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 19,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 1, 2018",
    "Current Ver": 1.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Garena Free Fire",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 5534114,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.21.0",
    numInstall: 100000000,
    numAndroid: 4,
  },
  {
    App: "FE Other Disciplines Engineering Exam Prep",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "5.33.3669",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "FE EN ACCIÓN RADIO",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 5, 2018",
    "Current Ver": 1.4,
    numInstall: 10,
    numAndroid: 5,
  },
  {
    App: "FE Electric & Comp Engineering",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "5.33.3669",
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "Caprock Santa Fe Credit Union",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "March 23, 2018",
    "Current Ver": "3.0.6",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FE Chemical Engineering Exam Prep",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 27, 2018",
    "Current Ver": "5.33.3669",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "Santa Fe Map and Walks",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 2,
    Size: "47M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "April 20, 2018",
    "Current Ver": 32,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FE IP",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 3,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 27, 2017",
    "Current Ver": 1.51,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Safe Santa Fe",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 2,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 4, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Santa Fe New Mexican e-Edition",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 25,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "June 21, 2018",
    "Current Ver": "4.7.4.18.0621",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "L!FE Premium Training",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "4.2.2",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Theme for Galaxy Note FE Launcher | Live Wallpaper",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 2,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 22, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Theme for Galaxy Note FE",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 3,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 29, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Note FE Theme And Launcher For Samsung Galaxy",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 7,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 28, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FE CPS",
    Category: "FINANCE",
    Rating: 3,
    Reviews: 62,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 26, 2017",
    "Current Ver": "0.1.8",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "La Fe de Jesus",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 8,
    Size: "658k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "January 31, 2017",
    "Current Ver": "NaN",
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Santa Fe Indian Market",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 4,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 23, 2018",
    "Current Ver": 5.11,
    numInstall: 500,
    numAndroid: 5,
  },
  {
    App: "FE Connect Fhoton",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 28, 2017",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Repair Hyundai Santa Fe",
    Category: "AUTO_AND_VEHICLES",
    Rating: 3.9,
    Reviews: 22,
    Size: "97M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "January 31, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "La Fe de Jesús",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 10,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 23, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Santa Fe Espresso & News",
    Category: "FOOD_AND_DRINK",
    Rating: "NaN",
    Reviews: 0,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Food & Drink",
    "Last Updated": "October 12, 2017",
    "Current Ver": "1.2.2",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Santa Fe Sentry",
    Category: "HOUSE_AND_HOME",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "House & Home",
    "Last Updated": "August 7, 2017",
    "Current Ver": "1.6.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Santa Fe Thrive",
    Category: "HEALTH_AND_FITNESS",
    Rating: 5,
    Reviews: 2,
    Size: "8.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 9, 2018",
    "Current Ver": "4.2.2",
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "FE Connect Drive-Tech",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 12, 2018",
    "Current Ver": "1.2.1.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FE Mix - Jokes - Status - Wallpaper",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 2, 2018",
    "Current Ver": 2.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Frases Cristianas de Esperanza y Fe",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 2,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "October 18, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Theme for Samsung Galaxy Note FE",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 52,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 4, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Santa Fe VIP Tours",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "August 19, 2017",
    "Current Ver": 2.8,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Santa Fe App",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 196,
    Size: "5.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 9, 2017",
    "Current Ver": "2.1.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Curso Básico y Avanzado la Fe de Jesús Audio-Texto",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Education",
    "Last Updated": "July 12, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Ríos de Fe",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 141,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 24, 2018",
    "Current Ver": 1.8,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Theme For Galaxy Note FE",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 19, 2018",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Le Fe de Jesus",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 3,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "December 17, 2015",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "FG Mobile",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 130,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "December 21, 2017",
    "Current Ver": "2.0.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "FG Wallet",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 9,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 6, 2018",
    "Current Ver": 2.1,
    numInstall: 1000,
    numAndroid: 6,
  },
  {
    App: "Burn Your Fat With Me! FG",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.5,
    Reviews: 38487,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Health & Fitness",
    "Last Updated": "July 3, 2018",
    "Current Ver": "5.1.0",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "FG On-The-Go",
    Category: "TOOLS",
    Rating: 4.9,
    Reviews: 55,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 29, 2018",
    "Current Ver": "2.01.0.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FG Autumn Photo Puzzle",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "4.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "August 23, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Radio FG Paris Underground",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 26, 2015",
    "Current Ver": 2,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "FG Radio - Radios de France",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 10, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FG SPINNER",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 2,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Board",
    "Last Updated": "April 6, 2018",
    "Current Ver": 0.9,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FG Finder",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 154,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 16, 2018",
    "Current Ver": "2.1.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FG. Chic - House Lounge Musique - Radios de France",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "6.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "June 9, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "BROTHER IN WARS: GUNNER CITY WARLORDS",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 8649,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.0.3",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Angry Birds Space HD",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 43645,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "May 25, 2018",
    "Current Ver": "2.2.13",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Survival Prison Escape v2: Free Action Game",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 44027,
    Size: "52M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Strategy",
    "Last Updated": "February 21, 2018",
    "Current Ver": "1.0.9",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "FG VOC",
    Category: "BUSINESS",
    Rating: 4.8,
    Reviews: 6,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 7, 2018",
    "Current Ver": "2.1.5",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Police Car Driver",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 83671,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Racing",
    "Last Updated": "May 4, 2018",
    "Current Ver": 9,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Modern Sniper Strike: Best Commando Action 2k18",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 164,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "August 23, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Moto Fighter 3D",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 85410,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Racing",
    "Last Updated": "September 20, 2017",
    "Current Ver": 20170920,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "FG Rockstar",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.1.5",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "BMX Boy",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 839206,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "September 20, 2017",
    "Current Ver": "1.16.33",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Crazy Bike attack Racing New: motorcycle racing",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 20364,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "July 12, 2018",
    "Current Ver": "1.2.1",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "POLARIS 2MFG",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 1228,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 28, 2018",
    "Current Ver": 1.7,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Gun Disassembly 2",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 26347,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Entertainment",
    "Last Updated": "September 15, 2017",
    "Current Ver": "14.0.1",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Fields of Battle",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 71476,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "April 21, 2018",
    "Current Ver": 2.14,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Family Guy The Quest for Stuff",
    Category: "GAME",
    Rating: 4,
    Reviews: 995002,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Adventure",
    "Last Updated": "July 25, 2018",
    "Current Ver": "1.73.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Ambulance Simulator 3D",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 29415,
    Size: "66M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Simulation",
    "Last Updated": "December 11, 2016",
    "Current Ver": "2.0.1",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Leghe Fantagazzetta",
    Category: "SPORTS",
    Rating: 4.1,
    Reviews: 79464,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 6, 2018",
    "Current Ver": "5.0.8",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Police Car Driving Sim",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 72522,
    Size: "51M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "April 10, 2018",
    "Current Ver": 1.54,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Toy Attack",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 3878,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "April 4, 2018",
    "Current Ver": 1.9,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Field Goal Tournament",
    Category: "SPORTS",
    Rating: 3.7,
    Reviews: 2980,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "September 1, 2015",
    "Current Ver": "1.2.8",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Ghost In Photo",
    Category: "PHOTOGRAPHY",
    Rating: 3.9,
    Reviews: 28429,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Photography",
    "Last Updated": "March 16, 2018",
    "Current Ver": 2,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Disney Princess Palace Pets",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 60097,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment;Pretend Play",
    "Last Updated": "February 10, 2018",
    "Current Ver": 5.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Police VAZ LADA Simulator",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 3502,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "September 11, 2016",
    "Current Ver": 1.3,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Scary Video Maker",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 9296,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 24, 2018",
    "Current Ver": 1.14,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "SnowMobile Parking Adventure",
    Category: "GAME",
    Rating: 3.6,
    Reviews: 12257,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "September 9, 2016",
    "Current Ver": 1.4,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "PBS KIDS Games",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 12919,
    Size: "94M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Educational;Education",
    "Last Updated": "June 6, 2018",
    "Current Ver": "1.15.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Zombie Sniper 3D III",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 8122,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "February 28, 2017",
    "Current Ver": 1.8,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "Family Guy- Another Freakin' Mobile Game",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 221691,
    Size: "94M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Puzzle",
    "Last Updated": "August 6, 2018",
    "Current Ver": "1.20.22",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "FH WiFiCam",
    Category: "PHOTOGRAPHY",
    Rating: 2.6,
    Reviews: 201,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 2, 2017",
    "Current Ver": 2.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "HD Themes Volvo FH Trucks",
    Category: "PERSONALIZATION",
    Rating: 4.4,
    Reviews: 40,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "June 21, 2016",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Familial Hypercholesterolaemia",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 0,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 5, 2018",
    "Current Ver": "2.0.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Familial Hypercholesterolaemia Handbook",
    Category: "MEDICAL",
    Rating: 1,
    Reviews: 2,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 2, 2018",
    "Current Ver": "2.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Themes Volvo FH 16 Trucks",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 38,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "June 17, 2016",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "FH Calculator",
    Category: "HEALTH_AND_FITNESS",
    Rating: "NaN",
    Reviews: 9,
    Size: "992k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 4, 2015",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Top Themes Volvo FH Trucks",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 9,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "June 19, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Top Puzzles Volvo FH Trucks",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 4,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Puzzle",
    "Last Updated": "November 20, 2016",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Wallpapers Volvo FH 16 Trucks",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 13,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "June 18, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Puzzles Volvo FH 16 Trucks",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 10,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Puzzle",
    "Last Updated": "December 2, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Jigsaw Volvo FH 16 Trucks",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 5,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Puzzle",
    "Last Updated": "December 1, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Shoot Hunter-Gun Killer",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 320334,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 8, 2018",
    "Current Ver": "1.1.2",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "studentsLife by FH Kärnten",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 108,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "March 30, 2018",
    "Current Ver": "4.0.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "FH® Cost Lookup / FH® CCSalud",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 30,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 21, 2017",
    "Current Ver": "4.1.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FH Kufstein App",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 9,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 20, 2017",
    "Current Ver": "2.3.1",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "FH App",
    Category: "BUSINESS",
    Rating: 4.9,
    Reviews: 27,
    Size: "6.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.0.90",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "HD Wallpapers Volvo FH Trucks",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 4,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "June 21, 2016",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Jigsaw Puzzles Volvo FH Truck Game",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 4,
    Size: "4.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Puzzle",
    "Last Updated": "July 24, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Themes Volvo FH Trucks",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 14,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "June 17, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "FH School",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 4,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "April 11, 2018",
    "Current Ver": "1.0.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FH Wallet",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.0.0",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "FH Dortmund FB4",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 40,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 22, 2018",
    "Current Ver": "1.2.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Fast Motorcycle Driver 2016",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 28151,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Racing",
    "Last Updated": "December 25, 2016",
    "Current Ver": 1.2,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Wallpapers Volvo FH Truck",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 4,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "July 31, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "HD Jigsaw Volvo FH Trucks",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 2,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Puzzle",
    "Last Updated": "November 29, 2016",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Jigsaw Puzzles Volvo FH Trucks",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 3,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Puzzle",
    "Last Updated": "December 1, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Angry Shark 2016",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 73185,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "November 1, 2017",
    "Current Ver": 1.6,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "First Hawaiian Bank Mobile",
    Category: "FINANCE",
    Rating: 2.1,
    Reviews: 232,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 9, 2018",
    "Current Ver": "18.1.79",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "FH CODE",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 13,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 26, 2018",
    "Current Ver": "FH CODE 1.0",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Strike! Ten Pin Bowling",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 18584,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 27, 2018",
    "Current Ver": "1.7.0",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "IKORO FH App Rosenheim",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 22,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 6, 2018",
    "Current Ver": "1.10.0.0",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "My Truck",
    Category: "TOOLS",
    Rating: 2.5,
    Reviews: 247,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "March 15, 2017",
    "Current Ver": "1.0.6",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Talking Tom Bubble Shooter",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 687136,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "May 25, 2018",
    "Current Ver": "1.5.3.20",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "Forgotten Hill: Fall",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 1063,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "October 30, 2017",
    "Current Ver": 1.7,
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "Forgotten Hill Mementoes",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 2027,
    Size: "56M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "March 19, 2018",
    "Current Ver": 1.5,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "EHiN-FH conferenceapp",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 5,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "November 15, 2016",
    "Current Ver": 1.17,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "BTK-FH Online Campus",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "November 7, 2016",
    "Current Ver": "1.7.2",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Talking Husky Dog",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 26545,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "July 20, 2018",
    "Current Ver": 2.08,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Bubble Bird Rescue",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 70753,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "August 7, 2018",
    "Current Ver": "1.8.6",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Forgotten Hill: Surgery",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 2431,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "November 3, 2017",
    "Current Ver": 1.4,
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Real Airplane Flight Simulator: Pilot Games",
    Category: "FAMILY",
    Rating: 3.3,
    Reviews: 21735,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 11, 2018",
    "Current Ver": "1.0.03",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Dolphin and fish coloring book",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 2249,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Art & Design;Creativity",
    "Last Updated": "May 15, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Carpooling FH Hagenberg",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 18, 2017",
    "Current Ver": "Varies with device",
    numInstall: 100,
    numAndroid: null,
  },
  {
    App: "Forgotten Hill: Puppeteer",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 2917,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "October 30, 2017",
    "Current Ver": 2.6,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Airplane Fly Hawaii",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 83427,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "January 30, 2015",
    "Current Ver": 2.6,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "FiSwitch",
    Category: "TOOLS",
    Rating: 4.8,
    Reviews: 615,
    Size: "2.0M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 24, 2018",
    "Current Ver": 5.2,
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Signal Info",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 424,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 19, 2017",
    "Current Ver": 0.11,
    numInstall: 10000,
    numAndroid: 6,
  },
  {
    App: "Signal Spy - Monitor Signal Strength & Data Usage",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 875,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 31, 2017",
    "Current Ver": "1.9.9.5",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Wi-Fi Auto-connect",
    Category: "COMMUNICATION",
    Rating: 3.8,
    Reviews: 15036,
    Size: "253k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 1, 2015",
    "Current Ver": "1.2.0",
    numInstall: 1000000,
    numAndroid: 1,
  },
  {
    App: "Smart Wi-Fi Hotspot PRO",
    Category: "COMMUNICATION",
    Rating: 3.7,
    Reviews: 197,
    Size: "957k",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "February 10, 2016",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Talkie - Wi-Fi Calling, Chats, File Sharing",
    Category: "COMMUNICATION",
    Rating: 4.2,
    Reviews: 4838,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "Portable Wi-Fi hotspot Premium",
    Category: "COMMUNICATION",
    Rating: 3.7,
    Reviews: 481,
    Size: "420k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "December 16, 2015",
    "Current Ver": "1.4.0.2",
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Avast Wi-Fi Finder",
    Category: "PRODUCTIVITY",
    Rating: 4.3,
    Reviews: 37277,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "February 26, 2018",
    "Current Ver": "2.3.1",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Police Field Interview FI Card",
    Category: "PRODUCTIVITY",
    Rating: 4.5,
    Reviews: 112,
    Size: "2.4M",
    Type: "Paid",
    Price: "$7.99",
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "March 16, 2017",
    "Current Ver": 3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "LG Hi-Fi Plus Manager",
    Category: "TOOLS",
    Rating: 3.5,
    Reviews: 154,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "September 6, 2016",
    "Current Ver": "5.0.6",
    numInstall: 10000,
    numAndroid: 6,
  },
  {
    App: "WeFi - Free Fast WiFi Connect & Find Wi-Fi Map",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 13469,
    Size: "5.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "June 5, 2018",
    "Current Ver": "4.7.0.2200000",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Talkie Pro - Wi-Fi Calling, Chats, File Sharing",
    Category: "COMMUNICATION",
    Rating: 4.5,
    Reviews: 201,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 6, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "Safe Wi-Fi",
    Category: "PRODUCTIVITY",
    Rating: 2.9,
    Reviews: 32,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 3, 2018",
    "Current Ver": "1.3.22",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "[root] Pry-Fi",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 6736,
    Size: "72k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 2, 2014",
    "Current Ver": 1.2,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Sat-Fi",
    Category: "COMMUNICATION",
    Rating: 3.6,
    Reviews: 97,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 31, 2017",
    "Current Ver": "Varies with device",
    numInstall: 5000,
    numAndroid: null,
  },
  {
    App: "WiFi Monitor Pro - analyzer of Wi-Fi networks",
    Category: "TOOLS",
    Rating: 4.6,
    Reviews: 85,
    Size: "2.4M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 5, 2018",
    "Current Ver": 1.9,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Candy simply-Fi",
    Category: "LIFESTYLE",
    Rating: 2.1,
    Reviews: 2390,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 17, 2018",
    "Current Ver": "1.8.4.7",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "SCI-FI UI",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 15,
    Size: "3.9M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "April 16, 2018",
    "Current Ver": "0.0.53",
    numInstall: 100,
    numAndroid: 1,
  },
  {
    App: "Wi-Fi Rabbit Unlock Key",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 142,
    Size: "26k",
    Type: "Paid",
    Price: "$1.00",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "June 26, 2011",
    "Current Ver": "1.0.0",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Wi-Fi settings shortcut",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 479,
    Size: "29k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 13, 2013",
    "Current Ver": 1.4,
    numInstall: 50000,
    numAndroid: 1,
  },
  {
    App: "Wi-Fi Master",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 3673,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.2.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Micro Fi",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 39,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 12, 2014",
    "Current Ver": 2.4,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "fi",
    Category: "FAMILY",
    Rating: 2.9,
    Reviews: 691,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "June 8, 2016",
    "Current Ver": "1.0.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Portable Wi-Fi hotspot Free",
    Category: "COMMUNICATION",
    Rating: 4,
    Reviews: 1711,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 11, 2018",
    "Current Ver": "1.2.5.4-11",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Wi-Fi Networks",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 115,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "October 5, 2015",
    "Current Ver": 1.4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FI CFL",
    Category: "FINANCE",
    Rating: 3.7,
    Reviews: 112,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 5, 2018",
    "Current Ver": "1.1.1",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Tassa.fi Finland",
    Category: "LIFESTYLE",
    Rating: 3.6,
    Reviews: 346,
    Size: "7.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 22, 2018",
    "Current Ver": 5.5,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "TownWiFi | Wi-Fi Everywhere",
    Category: "COMMUNICATION",
    Rating: 3.9,
    Reviews: 2372,
    Size: "58M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 2, 2018",
    "Current Ver": "4.2.1",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Jazz Wi-Fi",
    Category: "COMMUNICATION",
    Rating: 3.4,
    Reviews: 49,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "February 10, 2017",
    "Current Ver": 0.1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Xposed Wi-Fi-Pwd",
    Category: "PERSONALIZATION",
    Rating: 3.5,
    Reviews: 1042,
    Size: "404k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 5, 2014",
    "Current Ver": "3.0.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Life Made WI-Fi Touchscreen Photo Frame",
    Category: "PERSONALIZATION",
    Rating: 1.9,
    Reviews: 19,
    Size: "3.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "February 11, 2018",
    "Current Ver": "1.0.19",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "osmino Wi-Fi: free WiFi",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 134203,
    Size: "4.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 7, 2018",
    "Current Ver": "6.06.14",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Sat-Fi Voice",
    Category: "COMMUNICATION",
    Rating: 3.4,
    Reviews: 37,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "November 21, 2014",
    "Current Ver": "2.2.1.5",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Wi-Fi Visualizer",
    Category: "TOOLS",
    Rating: 3.9,
    Reviews: 132,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 17, 2017",
    "Current Ver": "0.0.9",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Lennox iComfort Wi-Fi",
    Category: "LIFESTYLE",
    Rating: 3,
    Reviews: 552,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 22, 2017",
    "Current Ver": "2.0.15",
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Sci-Fi Sounds and Ringtones",
    Category: "PERSONALIZATION",
    Rating: 3.6,
    Reviews: 128,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "September 27, 2017",
    "Current Ver": 4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Sci Fi Sounds",
    Category: "FAMILY",
    Rating: 3.2,
    Reviews: 4,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 2, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Free Wi-fi HotspoT",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 382,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 20, 2018",
    "Current Ver": 2.5,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "FJ 4x4 Cruiser Offroad Driving",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 3543,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "January 4, 2017",
    "Current Ver": 1.1,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "FJ 4x4 Cruiser Snow Driving",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1619,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "June 4, 2018",
    "Current Ver": 1.3,
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "Wallpapers Toyota FJ Cruiser",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 78,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "June 20, 2016",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "New Wallpapers Toyota FJ Cruiser Theme",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "February 23, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FJ Final Join , Circles Game",
    Category: "GAME",
    Rating: 4.7,
    Reviews: 32,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Arcade",
    "Last Updated": "July 11, 2018",
    "Current Ver": 0.24,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "HD Wallpaper - Toyota FJ Cruiser",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 2,
    Size: "6.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 10, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FJ Drive: Mercedes-Benz Lease",
    Category: "AUTO_AND_VEHICLES",
    Rating: 4.6,
    Reviews: 107,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "November 6, 2017",
    "Current Ver": "2.0.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Driving n Parking School 2017",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 15,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "May 31, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "FJ WiFi HDD",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 40,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 31, 2017",
    "Current Ver": "1.0.5",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Offroad Cruiser",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 42432,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "July 13, 2016",
    "Current Ver": 1.3,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "HD Themes Toyota Cruiser 70",
    Category: "PERSONALIZATION",
    Rating: 4.5,
    Reviews: 86,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "October 2, 2016",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Toyota Cruisers & Trucks Mag",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.5,
    Reviews: 10,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "March 14, 2018",
    "Current Ver": "3.0.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "4 x4 Offroad SUV 3D Truck Simulator Driving 2017",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 32,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "December 6, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Cake Shop - Kids Cooking",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 30668,
    Size: "33M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "July 16, 2018",
    "Current Ver": "2.1.3181",
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "HD Themes Toyota Cruiser 60",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "October 2, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "HD Themes Toyota Cruiser70",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "October 3, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "HD Themes Toyota Cruiser 80",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 2,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "October 3, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "HD Themes Toyota Cruiser 50",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "October 2, 2016",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "OFF-ROAD SIMULATOR 4x4 : REAL",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 109,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "April 15, 2017",
    "Current Ver": 1.4,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "HD Themes Toyota Cruiser 100VX",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 2,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "September 30, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "HD Themes Toyota Cruiser 200",
    Category: "PERSONALIZATION",
    Rating: 3.7,
    Reviews: 3,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "October 1, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "HD Themes Toyota Cruiser 40",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 2,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "October 2, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "Fun Kid Racing - Motocross",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 59768,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing;Action & Adventure",
    "Last Updated": "August 7, 2018",
    "Current Ver": 3.53,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Offroad 4x4 Car Driving",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 26224,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "April 29, 2017",
    "Current Ver": "1.0.4",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Motocross Beach Jumping 3D",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 105954,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Simulation",
    "Last Updated": "June 5, 2018",
    "Current Ver": "1.7.3",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Offroad drive : 4x4 driving game",
    Category: "GAME",
    Rating: 3.5,
    Reviews: 2071,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "June 29, 2018",
    "Current Ver": "1.0.3",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Hair saloon - Spa salon",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 38473,
    Size: "23M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual;Pretend Play",
    "Last Updated": "April 11, 2018",
    "Current Ver": "1.0.5",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Rope Hero: Vice Town",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 452589,
    Size: "99M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "July 1, 2018",
    "Current Ver": 2.2,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Drive 4x4 Luxury SUV Jeep",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 2183,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "July 10, 2018",
    "Current Ver": 1.12,
    numInstall: 500000,
    numAndroid: 2,
  },
  {
    App: "PIP Selfie Camera Photo Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 156322,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
  {
    App: "FJ-link",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 3, 2018",
    "Current Ver": "1.1.2",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Motocross Mayhem",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 35171,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "February 11, 2014",
    "Current Ver": 1.2,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Funny Jokes",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 2505,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "June 18, 2018",
    "Current Ver": 1.2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Flight Simulator: Fly Plane 3D",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 660613,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "March 1, 2017",
    "Current Ver": 1.32,
    numInstall: 50000000,
    numAndroid: 2,
  },
  {
    App: "Motocross Fun Simulator",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 22570,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "January 9, 2017",
    "Current Ver": 1.2,
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Dino Defends king 3 – Dinosaur T rex Hunter Games",
    Category: "GAME",
    Rating: 3.6,
    Reviews: 182,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Adventure",
    "Last Updated": "March 1, 2018",
    "Current Ver": 2.1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Fast Notes FJ",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 12,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "August 12, 2014",
    "Current Ver": "8.0.0",
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "FJ Toolkit",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.5M",
    Type: "Paid",
    Price: "$1.49",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 21, 2015",
    "Current Ver": 14,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Block Gun 3D: Haunted Hollow",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 16282,
    Size: "35M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "October 9, 2017",
    "Current Ver": "1.1.4",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Art of F J Taylor",
    Category: "VIDEO_PLAYERS",
    Rating: "NaN",
    Reviews: 2,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "June 23, 2015",
    "Current Ver": "1.0.2",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Driving Suv Toyota Car Simulator",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 187,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Simulation",
    "Last Updated": "November 12, 2017",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Navy Gunner Shoot War 3D",
    Category: "GAME",
    Rating: 4,
    Reviews: 103199,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.0.7.8",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Drift Legends",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 33788,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "March 29, 2018",
    "Current Ver": "1.8.5",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "FK",
    Category: "MEDICAL",
    Rating: 4.4,
    Reviews: 1517,
    Size: "8.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 13, 2018",
    "Current Ver": "2.5.9",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "FK (FlightKid)",
    Category: "GAME",
    Rating: "NaN",
    Reviews: 2,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Action",
    "Last Updated": "March 3, 2016",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FK Sūduva Marijampolė",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 2,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 21, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Fairy Kingdom: World of Magic and Farming",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 129542,
    Size: "63M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy;Creativity",
    "Last Updated": "July 23, 2018",
    "Current Ver": "2.4.9",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "FK Željezničar",
    Category: "SPORTS",
    Rating: 4.9,
    Reviews: 1420,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 12, 2018",
    "Current Ver": "2.5.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FK Oleksandria",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 14, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FK CLASSIC FOR YOU",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 1,
    Size: "3.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 20, 2018",
    "Current Ver": "1.1.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FK Sileks",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 18, 2018",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Kernel Manager for Franco Kernel ✨",
    Category: "TOOLS",
    Rating: 4.8,
    Reviews: 12700,
    Size: "10M",
    Type: "Paid",
    Price: "$3.49",
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 3, 2018",
    "Current Ver": "3.2.5",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Qarabağ FK",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 9,
    Size: "5.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 1, 2018",
    "Current Ver": 1.14,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FK Sloboda Tuzla",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 20, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FK Jelgava",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 22, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "FK Vojvodina",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 5,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 19, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "FK Liepaja",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 4,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 17, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FK Teplice",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 2,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 1, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "FK Sarajevo",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 6,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 2, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FK Vardar",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 2,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 20, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Ray Financial Calculator Pro",
    Category: "FINANCE",
    Rating: 4,
    Reviews: 67,
    Size: "2.4M",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 3, 2017",
    "Current Ver": 4,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "FK Bregalnica Štip",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 24, 2018",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "FK Mladost Lucani",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 19, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "FK Radnicki Nis",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 1,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 19, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "FK Dukla Prague",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 28, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FK Rad",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 1,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 19, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FK Jablonec",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 2,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 27, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "FK Senica",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "August 24, 2017",
    "Current Ver": 14,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FK Vozdovac",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 1,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 19, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Toy Truck Rally 3D",
    Category: "GAME",
    Rating: 4,
    Reviews: 301895,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "May 23, 2018",
    "Current Ver": "1.4.4",
    numInstall: 50000000,
    numAndroid: 4,
  },
  {
    App: "FK Mladá Boleslav",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 18, 2018",
    "Current Ver": 2,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FK Macva Sabac",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 3,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 19, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FK Crvena zvezda",
    Category: "SPORTS",
    Rating: 4.9,
    Reviews: 1211,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "January 22, 2018",
    "Current Ver": "1.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FK Events",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Productivity",
    "Last Updated": "June 27, 2018",
    "Current Ver": "7.17.2.1",
    numInstall: 5,
    numAndroid: 5,
  },
  {
    App: "PRO MX MOTOCROSS 2",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 25275,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "August 11, 2017",
    "Current Ver": 1.1,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "FK Jonava",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 1,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 21, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "FK Željezničar Izzy",
    Category: "FAMILY",
    Rating: 4.9,
    Reviews: 119,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "November 18, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FK Čukarički",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 19, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Austria Wien FK - Fussball - Inoffizielle App",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 2,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.0.4",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FK Železiarne Podbrezová",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "April 23, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "FK Viktoria Žižkov",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 27, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FK Zemun",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 3,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 19, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FK Atlantas",
    Category: "SPORTS",
    Rating: 1.5,
    Reviews: 2,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 21, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "FK Spartak Subotica",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 19, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FK Dedinje BGD",
    Category: "SPORTS",
    Rating: 5,
    Reviews: 36,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 11, 2017",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FK Fotbal Třinec",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "27M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 18, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FK Crvena Zvezda Izzy",
    Category: "TOOLS",
    Rating: 4.8,
    Reviews: 1456,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 14, 2016",
    "Current Ver": 1.2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "FK Utenis Utena",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 21, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Crazy Freekick",
    Category: "SPORTS",
    Rating: 3.9,
    Reviews: 47688,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 18, 2016",
    "Current Ver": "1.0.15",
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "FL State Parks Guide",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.7,
    Reviews: 871,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "October 27, 2017",
    "Current Ver": "5.29.23 Domain 253",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "FL SW Fishing Regulations",
    Category: "SPORTS",
    Rating: 4.6,
    Reviews: 60,
    Size: "24M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 7, 2014",
    "Current Ver": 1.03,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Permit Test FL Florida DHSMV",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 246,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 12, 2017",
    "Current Ver": "2.9.0",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FL Lottery Results",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 1481,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "March 31, 2018",
    "Current Ver": 3.7,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Florida DMV Permit Test -Fl",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 87,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "February 15, 2018",
    "Current Ver": "6.0.3",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Lottery Results: Florida",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 582,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "January 22, 2018",
    "Current Ver": 4,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Scratch-Off Guide for FL Lotto",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 25,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "July 4, 2018",
    "Current Ver": 1.11,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Charlotte County, FL",
    Category: "PRODUCTIVITY",
    Rating: 4.7,
    Reviews: 10,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "February 23, 2017",
    "Current Ver": "3.9.4",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Results for FL Lottery",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.6,
    Reviews: 146,
    Size: "7.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "February 28, 2017",
    "Current Ver": 3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Check Lottery Tickets - Florida",
    Category: "FAMILY",
    Rating: 2,
    Reviews: 27,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "October 17, 2017",
    "Current Ver": 2.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Fish|Hunt FL",
    Category: "LIFESTYLE",
    Rating: 3.6,
    Reviews: 853,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "March 22, 2018",
    "Current Ver": "3.2.0",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Florida 511",
    Category: "TOOLS",
    Rating: 3.2,
    Reviews: 148,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 14, 2017",
    "Current Ver": "1.0.18",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Florida Storms",
    Category: "WEATHER",
    Rating: 3.8,
    Reviews: 116,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "December 26, 2017",
    "Current Ver": "2.0.11",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FL Racing Manager 2018 Lite",
    Category: "SPORTS",
    Rating: 4,
    Reviews: 1338,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 17, 2018",
    "Current Ver": 1.18,
    numInstall: 100000,
    numAndroid: 3,
  },
  {
    App: "Florida Tides & Weather",
    Category: "WEATHER",
    Rating: 3.8,
    Reviews: 30,
    Size: "2.0M",
    Type: "Paid",
    Price: "$6.99",
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "May 6, 2015",
    "Current Ver": "2.0.0",
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "FL Tax-Verify",
    Category: "BUSINESS",
    Rating: 3.8,
    Reviews: 17,
    Size: "6.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "November 9, 2016",
    "Current Ver": "1.1.3",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "FL House",
    Category: "PRODUCTIVITY",
    Rating: 4.4,
    Reviews: 29,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "November 22, 2016",
    "Current Ver": "1.6.7",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "FL Racing Manager 2015 Pro",
    Category: "SPORTS",
    Rating: 4.4,
    Reviews: 656,
    Size: "22M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 12, 2016",
    "Current Ver": 0.858,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "Lottery Driver- Florida Result",
    Category: "FAMILY",
    Rating: 4.4,
    Reviews: 70,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "April 16, 2017",
    "Current Ver": 2.5,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Florida Travel Guide",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.8,
    Reviews: 11,
    Size: "86M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 11, 2018",
    "Current Ver": "6.8.2",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "The Florida Trail Guide",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.3,
    Reviews: 100,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "April 1, 2017",
    "Current Ver": "6.0.18",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Florida - Pocket Brainbook",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 7,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "March 19, 2018",
    "Current Ver": "1.0.9",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Lottery Ticket Checker - Florida Results & Lotto",
    Category: "TOOLS",
    Rating: 1,
    Reviews: 3,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 12, 2017",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Florida Statutes (FL Code)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.2,
    Reviews: 5,
    Size: "8.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "October 21, 2017",
    "Current Ver": 1.5,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Discovery Church Florida",
    Category: "LIFESTYLE",
    Rating: 4.7,
    Reviews: 40,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Lifestyle",
    "Last Updated": "June 25, 2018",
    "Current Ver": "3.8.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FL Racing Manager 2018 Pro",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 340,
    Size: "15M",
    Type: "Paid",
    Price: "$1.99",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "March 17, 2018",
    "Current Ver": 1.18,
    numInstall: 5000,
    numAndroid: 3,
  },
  {
    App: "Florida Driver License Test",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 65,
    Size: "470k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 30, 2016",
    "Current Ver": 2,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Free Florida DMV Test 2018",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 665,
    Size: "5.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "May 24, 2018",
    "Current Ver": 8.1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Canvas FL",
    Category: "FAMILY",
    Rating: 4.9,
    Reviews: 36,
    Size: "9.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Education",
    "Last Updated": "June 25, 2018",
    "Current Ver": "3.8.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Florida Lottery Results",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.1,
    Reviews: 763,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "December 18, 2015",
    "Current Ver": 2,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Florida Cooling Supply HVAC",
    Category: "PRODUCTIVITY",
    Rating: 4.2,
    Reviews: 6,
    Size: "43M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "July 27, 2018",
    "Current Ver": "8.1.10.41",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Restaurant Inspections - FL",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.5,
    Reviews: 143,
    Size: "226k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "June 12, 2013",
    "Current Ver": 1.1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Florida Keys",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.2,
    Reviews: 92,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "April 6, 2017",
    "Current Ver": 4.1,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "South Florida AA Meetings",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 10,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 24, 2018",
    "Current Ver": 2.18,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Florida Travel Guide - TOURIAS",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.8,
    Reviews: 80,
    Size: "37M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "July 30, 2018",
    "Current Ver": 3.21,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Florida State Gameday",
    Category: "SPORTS",
    Rating: 4.7,
    Reviews: 1566,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "July 13, 2018",
    "Current Ver": "9.19.2",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "FL Bankers",
    Category: "EVENTS",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "June 5, 2018",
    "Current Ver": "1.0.1",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Fort Myers FL",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "September 17, 2015",
    "Current Ver": "2.4.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "News-Journal-Daytona Beach, FL",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 76,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 3, 2018",
    "Current Ver": 5,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Florida map",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 11,
    Size: "3.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "May 15, 2016",
    "Current Ver": "0.0.7",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Trinity Church Deltona, FL",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 33,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 7, 2018",
    "Current Ver": "1.9.0.0",
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "FL Drone 2",
    Category: "PHOTOGRAPHY",
    Rating: 3.3,
    Reviews: 41,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 17, 2017",
    "Current Ver": "1.0.7",
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "Beacon Baptist Jupiter, FL",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 14,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "October 13, 2017",
    "Current Ver": 2.4,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Clearwater, FL - weather and more",
    Category: "WEATHER",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "April 12, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 5,
  },
  {
    App: "University of Florida",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 168,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "October 2, 2017",
    "Current Ver": 2,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Ocala Star Banner, FL",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 75,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 25, 2018",
    "Current Ver": 5.1,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Alachua County Sheriff FL",
    Category: "LIFESTYLE",
    Rating: 3.2,
    Reviews: 5,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "May 13, 2015",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Lotto Results - Mega Millions Powerball Lottery US",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 14221,
    Size: "1.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "December 11, 2015",
    "Current Ver": "2.0.3",
    numInstall: 1000000,
    numAndroid: 2,
  },
  {
    App: "Jax Sheriff (FL)",
    Category: "LIFESTYLE",
    Rating: 4.2,
    Reviews: 53,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 25, 2018",
    "Current Ver": "2.0.1",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Results for FL Lottery (Florida)",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 1,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "November 2, 2017",
    "Current Ver": 2.27,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Hidden Object Florida Vacation Adventure Fun Game",
    Category: "FAMILY",
    Rating: 3.7,
    Reviews: 126,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "June 18, 2018",
    "Current Ver": 1.4,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "WFLA News Channel 8 - Tampa FL",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.8,
    Reviews: 133,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 18, 2018",
    "Current Ver": "v4.30.0.8",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Florida Beach Wallpapers HD",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 5,
    Reviews: 3,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "December 30, 2015",
    "Current Ver": "1.8.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "MY GULFPORT FL",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "May 18, 2018",
    "Current Ver": 17.4,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "My MLS App",
    Category: "LIFESTYLE",
    Rating: 4.1,
    Reviews: 1213,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 4, 2018",
    "Current Ver": "2.8.4",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Employ Florida Mobile",
    Category: "BUSINESS",
    Rating: 2.9,
    Reviews: 97,
    Size: "9.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 13, 2018",
    "Current Ver": "4.5.9",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "St. Petersburg, FL - weather and more",
    Category: "WEATHER",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "April 13, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 5,
  },
  {
    App: "LifePoint Church - FL",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 1,
    Size: "7.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 9, 2015",
    "Current Ver": 1.1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "WSVN • South Florida's Source for Weather",
    Category: "WEATHER",
    Rating: "NaN",
    Reviews: 7,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "June 21, 2018",
    "Current Ver": "4.6.1404",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "PriorityONE Credit Union of Fl",
    Category: "FINANCE",
    Rating: 4.7,
    Reviews: 178,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 12, 2018",
    "Current Ver": "5.9.1.0",
    numInstall: 1000,
    numAndroid: 5,
  },
  {
    App: "Florida Wildflowers",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 5,
    Size: "69M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 10, 2017",
    "Current Ver": 1.5,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Florida Blue",
    Category: "HEALTH_AND_FITNESS",
    Rating: 3.2,
    Reviews: 499,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "July 10, 2018",
    "Current Ver": "4.2.1",
    numInstall: 100000,
    numAndroid: 7,
  },
  {
    App: "ORLANDO FLORIDA MAP",
    Category: "TRAVEL_AND_LOCAL",
    Rating: "NaN",
    Reviews: 3,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "January 24, 2017",
    "Current Ver": "1.3.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Florida Tech Mobile",
    Category: "FAMILY",
    Rating: 3.8,
    Reviews: 87,
    Size: "5.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "September 13, 2016",
    "Current Ver": 5.2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Florida Offline Road Map",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 3.8,
    Reviews: 144,
    Size: "8.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "October 2, 2014",
    "Current Ver": 5,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Florida Map offline",
    Category: "TRAVEL_AND_LOCAL",
    Rating: 4.6,
    Reviews: 8,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Travel & Local",
    "Last Updated": "June 22, 2018",
    "Current Ver": 1.73,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "The Ledger - Lakeland, Florida",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.6,
    Reviews: 89,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "February 17, 2018",
    "Current Ver": 5,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "FRONTLINE COMMANDO",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 1351833,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "October 28, 2013",
    "Current Ver": "3.0.3",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Gainesville Florida Police Department",
    Category: "LIFESTYLE",
    Rating: 4.8,
    Reviews: 4,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "November 22, 2017",
    "Current Ver": 1.1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Gainesville Bus Tracker",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.2,
    Reviews: 63,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 25, 2015",
    "Current Ver": "1.0.6",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Florida Today",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.3,
    Reviews: 202,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "News & Magazines",
    "Last Updated": "June 20, 2018",
    "Current Ver": "5.9.5",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Florida HSMV Driver License",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 14,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 13, 2015",
    "Current Ver": 1.3,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "WSVN - 7 News Miami",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.5,
    Reviews: 3320,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "August 3, 2018",
    "Current Ver": "v4.30.0.9",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "WICShopper",
    Category: "SHOPPING",
    Rating: 3.9,
    Reviews: 3023,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 26, 2018",
    "Current Ver": "Varies with device",
    numInstall: 500000,
    numAndroid: null,
  },
  {
    App: "First Federal Bank of Florida",
    Category: "FINANCE",
    Rating: 4.3,
    Reviews: 133,
    Size: "30M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 23, 2018",
    "Current Ver": "18.1.79",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "South Florida MLS",
    Category: "LIFESTYLE",
    Rating: 4.4,
    Reviews: 133,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 2, 2018",
    "Current Ver": "2.8.4",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Football Manager Mobile 2018",
    Category: "SPORTS",
    Rating: 3.9,
    Reviews: 11460,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$8.99",
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "June 27, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Podcast App: Free & Offline Podcasts by Player FM",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.6,
    Reviews: 66407,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "News & Magazines",
    "Last Updated": "July 25, 2018",
    "Current Ver": "4.1.0.72",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Motorola FM Radio",
    Category: "VIDEO_PLAYERS",
    Rating: 3.9,
    Reviews: 54815,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "May 2, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "FN Cam",
    Category: "PHOTOGRAPHY",
    Rating: 3.4,
    Reviews: 181,
    Size: "10M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "January 13, 2016",
    "Current Ver": "1.1.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "How it Works: FN SCAR assault rifle",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 44,
    Size: "45M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "January 9, 2018",
    "Current Ver": "2.1.9f7",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FN pistol Model 1906 explained",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "5.3M",
    Type: "Paid",
    Price: "$5.49",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "March 9, 2017",
    "Current Ver": "Android 3.0 - 2017",
    numInstall: 10,
    numAndroid: 1,
  },
  {
    App: "FN pistol model 1903 explained",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "19M",
    Type: "Paid",
    Price: "$6.49",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "September 5, 2015",
    "Current Ver": "Android 3.0 - 2015",
    numInstall: 10,
    numAndroid: 1,
  },
  {
    App: "FutureNet your social app",
    Category: "SOCIAL",
    Rating: 4.2,
    Reviews: 2093,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "March 8, 2018",
    "Current Ver": 3.36,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Jigsaw Puzzles FN FAL Light Automatic Rifle",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Puzzle",
    "Last Updated": "May 7, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Wallpapers FN Herstal FNP 9",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "April 12, 2018",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Ninja FN Button",
    Category: "FAMILY",
    Rating: 4.8,
    Reviews: 12,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "July 4, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Wallpapers FN SCAR H",
    Category: "PERSONALIZATION",
    Rating: 5,
    Reviews: 4,
    Size: "9.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "April 12, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Wallpapers FN F2000",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "April 16, 2018",
    "Current Ver": 1,
    numInstall: 5,
    numAndroid: 4,
  },
  {
    App: "Wallpapers FN Five seven",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "April 18, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FN",
    Category: "BUSINESS",
    Rating: 5,
    Reviews: 14,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 1, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "Wallpapers FN FAL Light Automatic Rifle",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Personalization",
    "Last Updated": "April 17, 2018",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: 'The FN "Baby" pistol explained',
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "8.8M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "September 6, 2015",
    "Current Ver": "Android 3.0 - 2015",
    numInstall: 10,
    numAndroid: 1,
  },
  {
    App: "FN FAL rifle explained",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "7.3M",
    Type: "Paid",
    Price: "$6.49",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "September 6, 2015",
    "Current Ver": "Android 3.0 - 2015",
    numInstall: 10,
    numAndroid: 1,
  },
  {
    App: "F N Bail Bonds",
    Category: "LIFESTYLE",
    Rating: 3.8,
    Reviews: 4,
    Size: "14M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "January 6, 2017",
    "Current Ver": 1.4,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "The FN HP pistol explained",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "8.5M",
    Type: "Paid",
    Price: "$6.49",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "September 6, 2015",
    "Current Ver": "Android 3.0 - 2015",
    numInstall: 10,
    numAndroid: 1,
  },
  {
    App: "SB · FN 1870 Mobile Banking",
    Category: "FINANCE",
    Rating: 2.9,
    Reviews: 139,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "June 19, 2017",
    "Current Ver": "3.0.5",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "PIP-Camera FN Photo Effect",
    Category: "PHOTOGRAPHY",
    Rating: 4.6,
    Reviews: 8,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "December 4, 2016",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "Bullet - FN Theme",
    Category: "PERSONALIZATION",
    Rating: 3.8,
    Reviews: 143,
    Size: "240k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "July 31, 2013",
    "Current Ver": 1,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "FN model 1900 pistol explained",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.2M",
    Type: "Paid",
    Price: "$6.49",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "September 5, 2015",
    "Current Ver": "Android 3.0 - 2015",
    numInstall: 10,
    numAndroid: 1,
  },
  {
    App: "Pistolet FN GP35 expliqué",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 2,
    Size: "7.9M",
    Type: "Paid",
    Price: "$5.99",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 19, 2014",
    "Current Ver": "Android 2.0 - 2014",
    numInstall: 5,
    numAndroid: 1,
  },
  {
    App: "FN Web Radio",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "May 18, 2018",
    "Current Ver": 1.1,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "Gun Builder ELITE",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 88941,
    Size: "34M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 26, 2016",
    "Current Ver": "3.1.7",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "FNH Payment Info",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "March 17, 2018",
    "Current Ver": 1.3,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Magnum 3.0 Gun Custom SImulator",
    Category: "GAME",
    Rating: 4.5,
    Reviews: 16815,
    Size: "59M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 4, 2018",
    "Current Ver": 1.0404,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Pistolet FN 1906 expliqué",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 0,
    Size: "5.2M",
    Type: "Paid",
    Price: "$5.49",
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 17, 2014",
    "Current Ver": "Android 2.0 - 2014",
    numInstall: 10,
    numAndroid: 1,
  },
  {
    App: "Circle Colors Pack-FN Theme",
    Category: "PERSONALIZATION",
    Rating: 4.2,
    Reviews: 6,
    Size: "89k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 9, 2013",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "Calculator Fn",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 9,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "November 12, 2015",
    "Current Ver": 1.4,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Pint - FN Theme",
    Category: "PERSONALIZATION",
    Rating: 2.5,
    Reviews: 6,
    Size: "234k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 10, 2013",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "HAL-9000 - FN Theme",
    Category: "PERSONALIZATION",
    Rating: 3.5,
    Reviews: 159,
    Size: "257k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 16, 2013",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Solitaire+",
    Category: "GAME",
    Rating: 4.6,
    Reviews: 11235,
    Size: "Varies with device",
    Type: "Paid",
    Price: "$2.99",
    "Content Rating": "Everyone",
    Genres: "Card",
    "Last Updated": "July 30, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "Fresh News",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 4.4,
    Reviews: 2207,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "July 26, 2018",
    "Current Ver": 41,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Future Cloud",
    Category: "PRODUCTIVITY",
    Rating: 4.6,
    Reviews: 1075,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "January 22, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Fruit Ninja Classic",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 85468,
    Size: "36M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "June 8, 2018",
    "Current Ver": "2.4.1.485300",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Hunting Safari 3D",
    Category: "SPORTS",
    Rating: 4.2,
    Reviews: 36183,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Sports",
    "Last Updated": "January 20, 2018",
    "Current Ver": 1.4,
    numInstall: 5000000,
    numAndroid: 2,
  },
  {
    App: "Gun Club Armory",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 55014,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "December 4, 2017",
    "Current Ver": "1.2.6",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Ethical Hacking",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 128,
    Size: "3.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 9, 2018",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Armed Cam Gun Pack",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 1012,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "January 18, 2015",
    "Current Ver": "1.0.2",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "Zombie Defense",
    Category: "FAMILY",
    Rating: 4.3,
    Reviews: 275048,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Strategy",
    "Last Updated": "June 22, 2018",
    "Current Ver": 12.2,
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Fo File Manager",
    Category: "TOOLS",
    Rating: 4.5,
    Reviews: 1916,
    Size: "364k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 31, 2015",
    "Current Ver": "1.8.8",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Alarm.fo – choose your info",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 19,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "May 29, 2018",
    "Current Ver": "1.4.8",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FO Bixby",
    Category: "PERSONALIZATION",
    Rating: 5,
    Reviews: 5,
    Size: "861k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 25, 2018",
    "Current Ver": 0.2,
    numInstall: 100,
    numAndroid: 7,
  },
  {
    App: "Pin-fo",
    Category: "FAMILY",
    Rating: 4.6,
    Reviews: 19,
    Size: "1.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "August 15, 2016",
    "Current Ver": "3rd Release Aug 2016",
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "MARKET FO",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "November 30, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FO OP St-Nazaire",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "December 19, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FO SODEXO",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "March 13, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FO RCBT",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 5,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "November 15, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FO Interim",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "March 14, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Mu.F.O.",
    Category: "GAME",
    Rating: 5,
    Reviews: 2,
    Size: "16M",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "March 3, 2017",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 2,
  },
  {
    App: "FO PSA Sept-Fons",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 2,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "March 22, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FO BOULANGER",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 10,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 15, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "FO AIRBUS TLSE",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 4,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "January 25, 2018",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "F-O-Meter",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.0.1",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Theme fo Oppo A30 Wallpaper & Icon",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 7,
    Size: "1.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 18, 2017",
    "Current Ver": "1.0.0",
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Fo Fo Fish",
    Category: "GAME",
    Rating: 3.4,
    Reviews: 5,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "August 25, 2015",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 2,
  },
  {
    App: "FO STELIA Méaulte",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 2,
    Size: "18M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "December 19, 2017",
    "Current Ver": 1.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "RRIMS FO",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "5.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 27, 2018",
    "Current Ver": 4.2,
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "Neon Blue Gaming Wallpaper&Theme fo Lenovo K8 Note",
    Category: "BUSINESS",
    Rating: 4.6,
    Reviews: 7,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 24, 2017",
    "Current Ver": "1.0.0",
    numInstall: 500,
    numAndroid: 2,
  },
  {
    App: "Photo Editor Collage Maker Pro",
    Category: "PHOTOGRAPHY",
    Rating: 4.5,
    Reviews: 1519671,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "February 1, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000000,
    numAndroid: null,
  },
  {
    App: "Custos F.O.",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "9.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 20, 2018",
    "Current Ver": "4.1.0",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "FO AIRBUS Nantes",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "December 14, 2017",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Stylish Fonts",
    Category: "PERSONALIZATION",
    Rating: 3.8,
    Reviews: 153176,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "August 7, 2018",
    "Current Ver": 1.17,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "4x4 Jeep Racer",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 7279,
    Size: "54M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "March 9, 2018",
    "Current Ver": 1.5,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Lalafo Pulsuz Elanlar",
    Category: "SHOPPING",
    Rating: 4.4,
    Reviews: 61392,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "August 8, 2018",
    "Current Ver": "Varies with device",
    numInstall: 1000000,
    numAndroid: null,
  },
  {
    App: "My Earthquake Alerts - US & Worldwide Earthquakes",
    Category: "WEATHER",
    Rating: 4.4,
    Reviews: 3471,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "July 24, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "FunForMobile Ringtones & Chat",
    Category: "SOCIAL",
    Rating: 4.4,
    Reviews: 68358,
    Size: "7.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "May 7, 2016",
    "Current Ver": 3.22,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "FarmersOnly Dating",
    Category: "DATING",
    Rating: 3,
    Reviews: 1145,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Dating",
    "Last Updated": "February 25, 2016",
    "Current Ver": 2.2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Free Slideshow Maker & Video Editor",
    Category: "PHOTOGRAPHY",
    Rating: 4.2,
    Reviews: 162564,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "August 5, 2018",
    "Current Ver": 5.2,
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Frontline Terrorist Battle Shoot: Free FPS Shooter",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 9183,
    Size: "49M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "June 22, 2018",
    "Current Ver": 1.1,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "BankNordik",
    Category: "FINANCE",
    Rating: 3.9,
    Reviews: 28,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "August 8, 2018",
    "Current Ver": "7.3.2",
    numInstall: 5000,
    numAndroid: 5,
  },
  {
    App: "Sona - Nær við allastaðni",
    Category: "LIFESTYLE",
    Rating: 4.2,
    Reviews: 31,
    Size: "25M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 2, 2018",
    "Current Ver": "1.6.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Firefox Focus: The privacy browser",
    Category: "COMMUNICATION",
    Rating: 4.4,
    Reviews: 36981,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 6, 2018",
    "Current Ver": 5.2,
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Mad Dash Fo' Cash",
    Category: "GAME",
    Rating: 5,
    Reviews: 14,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "June 19, 2017",
    "Current Ver": "2.5a",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Launcher Theme for LG K10 2018",
    Category: "PERSONALIZATION",
    Rating: 4,
    Reviews: 649,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "March 30, 2017",
    "Current Ver": 1,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Mobile Kick",
    Category: "SPORTS",
    Rating: 4.3,
    Reviews: 111809,
    Size: "40M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "February 7, 2018",
    "Current Ver": "1.0.21",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "English To Shona Dictionary",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 60,
    Size: "3.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 10, 2016",
    "Current Ver": 1.4,
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "Posta App",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 3.6,
    Reviews: 8,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "September 27, 2017",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Thumbnail Maker",
    Category: "PHOTOGRAPHY",
    Rating: 4.4,
    Reviews: 26252,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "May 26, 2018",
    "Current Ver": 1.7,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fon WiFi App – WiFi Connect",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 222,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 26, 2018",
    "Current Ver": "2.2.4",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "MOD-MASTER for Minecraft PE (Pocket Edition) Free",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 271908,
    Size: "8.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "August 2, 2018",
    "Current Ver": "3.3.0",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "MX Player Codec (ARMv7)",
    Category: "LIBRARIES_AND_DEMO",
    Rating: 4.3,
    Reviews: 332083,
    Size: "6.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Libraries & Demo",
    "Last Updated": "April 23, 2018",
    "Current Ver": "1.9.19",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "FP Notebook",
    Category: "MEDICAL",
    Rating: 4.5,
    Reviews: 410,
    Size: "60M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "March 24, 2018",
    "Current Ver": "2.1.0.372",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "FeaturePoints: Free Gift Cards",
    Category: "FAMILY",
    Rating: 3.9,
    Reviews: 121321,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "October 22, 2016",
    "Current Ver": 8.7,
    numInstall: 5000000,
    numAndroid: 4,
  },
  {
    App: "Draw with FP sDraw",
    Category: "TOOLS",
    Rating: 4.3,
    Reviews: 3268,
    Size: "467k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 16, 2017",
    "Current Ver": 6.6,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "FP Click sound changer",
    Category: "PERSONALIZATION",
    Rating: 3.5,
    Reviews: 178,
    Size: "1.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "December 26, 2015",
    "Current Ver": 1,
    numInstall: 10000,
    numAndroid: 1,
  },
  {
    App: "FP Connect",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "22M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "December 15, 2017",
    "Current Ver": "3.15.1",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FP VoiceBot",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 17,
    Size: "157k",
    Type: "Paid",
    Price: "$0.99",
    "Content Rating": "Mature 17+",
    Genres: "Entertainment",
    "Last Updated": "November 25, 2015",
    "Current Ver": 1.2,
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "FP-safe",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "May 8, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FP Legacy",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4,
    Reviews: 3,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "July 2, 2018",
    "Current Ver": "3.4.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Race Manager FP",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 196,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "November 3, 2014",
    "Current Ver": 2.1,
    numInstall: 5000,
    numAndroid: 2,
  },
  {
    App: "FreedomPop Messaging Phone/SIM",
    Category: "COMMUNICATION",
    Rating: 3.6,
    Reviews: 9894,
    Size: "39M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "July 26, 2018",
    "Current Ver": "23.01.1265.0712",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "PhotoFunia",
    Category: "PHOTOGRAPHY",
    Rating: 4.3,
    Reviews: 316378,
    Size: "4.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Photography",
    "Last Updated": "June 3, 2017",
    "Current Ver": "4.0.7.0",
    numInstall: 10000000,
    numAndroid: 2,
  },
  {
    App: "Fingerprint Quick Action",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 8484,
    Size: "1.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 22, 2018",
    "Current Ver": "0.15.2",
    numInstall: 1000000,
    numAndroid: 6,
  },
  {
    App: "GKPB FP Online Church",
    Category: "LIFESTYLE",
    Rating: 5,
    Reviews: 32,
    Size: "7.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 31, 2017",
    "Current Ver": "0.7.1",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FP BW LCD View",
    Category: "FAMILY",
    Rating: 3.4,
    Reviews: 16,
    Size: "1.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "March 31, 2016",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "FP Markets",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "January 30, 2018",
    "Current Ver": "1.0.0.0",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FP Boss",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 1,
    Size: "5.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "July 27, 2018",
    "Current Ver": "1.0.2",
    numInstall: 1,
    numAndroid: 5,
  },
  {
    App: "FP Opgaver",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 9,
    Size: "61M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 31, 2018",
    "Current Ver": 1.9,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FP Charging Daydream",
    Category: "PERSONALIZATION",
    Rating: 3.5,
    Reviews: 96,
    Size: "3.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "November 23, 2015",
    "Current Ver": 2,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "FP Live",
    Category: "COMMUNICATION",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Communication",
    "Last Updated": "November 3, 2017",
    "Current Ver": "1.2.4",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FP Runner",
    Category: "GAME",
    Rating: 3.7,
    Reviews: 38,
    Size: "29M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "June 29, 2016",
    "Current Ver": 1.12,
    numInstall: 1000,
    numAndroid: 3,
  },
  {
    App: "Finger Scanner Gestures",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 2531,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2017",
    "Current Ver": "1.2.4",
    numInstall: 100000,
    numAndroid: 6,
  },
  {
    App: "FP Market",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 24,
    Size: "44k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 17, 2012",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 1,
  },
  {
    App: "FP FCU",
    Category: "FINANCE",
    Rating: 3.6,
    Reviews: 48,
    Size: "26M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "April 5, 2018",
    "Current Ver": "4.6.71",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Slickdeals: Coupons & Shopping",
    Category: "SHOPPING",
    Rating: 4.5,
    Reviews: 33599,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Shopping",
    "Last Updated": "July 30, 2018",
    "Current Ver": 3.9,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "SCM FPS Status",
    Category: "BUSINESS",
    Rating: 4.2,
    Reviews: 123,
    Size: "3.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "April 28, 2018",
    "Current Ver": 3.5,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Hondata Mobile",
    Category: "MAPS_AND_NAVIGATION",
    Rating: 4.3,
    Reviews: 334,
    Size: "676k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "August 23, 2016",
    "Current Ver": 1.3,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "FreedomPop Friends for Free Data",
    Category: "TOOLS",
    Rating: 4.4,
    Reviews: 58,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 24, 2018",
    "Current Ver": "2017.07.24",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Fisher-Price® Smart Connect™",
    Category: "TOOLS",
    Rating: 2.7,
    Reviews: 422,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 23, 2018",
    "Current Ver": "2.4.1",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Fingerprint Lock Screen Prank",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 10786,
    Size: "4.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "December 9, 2017",
    "Current Ver": 5,
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "FP NFC Rewrite",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 17,
    Size: "67k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "January 29, 2016",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Fast Tract Diet",
    Category: "HEALTH_AND_FITNESS",
    Rating: 4.4,
    Reviews: 35,
    Size: "2.4M",
    Type: "Paid",
    Price: "$7.99",
    "Content Rating": "Everyone",
    Genres: "Health & Fitness",
    "Last Updated": "August 8, 2018",
    "Current Ver": "1.9.3",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Greek Bible FP (Audio)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: "NaN",
    Reviews: 5,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "August 29, 2016",
    "Current Ver": "1.0.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "The FP Shield",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 0,
    Size: "11M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "February 1, 2018",
    "Current Ver": "1.1.0",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FP Разбитый дисплей",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 922,
    Size: "552k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "September 20, 2014",
    "Current Ver": 1.1,
    numInstall: 50000,
    numAndroid: 1,
  },
  {
    App: "FP Transportation",
    Category: "AUTO_AND_VEHICLES",
    Rating: "NaN",
    Reviews: 1,
    Size: "885k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "March 9, 2018",
    "Current Ver": "10.0.0",
    numInstall: 1,
    numAndroid: 4,
  },
  {
    App: "Chat For Strangers - Video Chat",
    Category: "SOCIAL",
    Rating: 3.4,
    Reviews: 622,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "May 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 100000,
    numAndroid: null,
  },
  {
    App: "FreedomPop Diagnostics",
    Category: "TOOLS",
    Rating: 2.9,
    Reviews: 452,
    Size: "7.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 17, 2017",
    "Current Ver": "1.03.123.0713",
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "NFP 2018",
    Category: "EVENTS",
    Rating: 4.8,
    Reviews: 8,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Events",
    "Last Updated": "January 9, 2018",
    "Current Ver": "1.0.3",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "AAFP",
    Category: "MEDICAL",
    Rating: 3.8,
    Reviews: 63,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "June 22, 2018",
    "Current Ver": "2.3.1",
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "FQ Magazine",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 1,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "December 12, 2016",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Modern Counter Terrorist FPS Shoot",
    Category: "GAME",
    Rating: 4,
    Reviews: 795,
    Size: "41M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 29, 2017",
    "Current Ver": 1.2,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "FQ METER",
    Category: "PRODUCTIVITY",
    Rating: 3.9,
    Reviews: 17,
    Size: "2.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "April 23, 2017",
    "Current Ver": 1.1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FQ Load Board for Transporters",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "February 16, 2018",
    "Current Ver": "1.1.3",
    numInstall: 100,
    numAndroid: 5,
  },
  {
    App: "FQ India",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 0,
    Size: "8.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 31, 2018",
    "Current Ver": "7.2.2",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Miss FQ",
    Category: "NEWS_AND_MAGAZINES",
    Rating: "NaN",
    Reviews: 0,
    Size: "36M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "April 5, 2018",
    "Current Ver": 3.8,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "FQ - Football Quiz",
    Category: "SPORTS",
    Rating: "NaN",
    Reviews: 1,
    Size: "9.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Sports",
    "Last Updated": "May 29, 2018",
    "Current Ver": 1,
    numInstall: 1,
    numAndroid: 5,
  },
  {
    App: "Monster Ride Pro",
    Category: "GAME",
    Rating: 5,
    Reviews: 1,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Racing",
    "Last Updated": "March 5, 2018",
    "Current Ver": 2,
    numInstall: 10,
    numAndroid: 2,
  },
  {
    App: "BEBONCOOL GAMEPAD V1.0",
    Category: "GAME",
    Rating: 3.9,
    Reviews: 404,
    Size: "2.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Arcade",
    "Last Updated": "August 30, 2017",
    "Current Ver": 1.2,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Union League",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 939,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Role Playing",
    "Last Updated": "June 8, 2018",
    "Current Ver": "1.0.0.96",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Fortune Quest: Savior",
    Category: "FAMILY",
    Rating: 3.6,
    Reviews: 135,
    Size: "75M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Role Playing",
    "Last Updated": "June 1, 2018",
    "Current Ver": 1.022,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Modern Counter 3: FPS Multiplayers battlegro 3",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 17,
    Size: "50M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "March 16, 2018",
    "Current Ver": 15,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Modern Strike Online",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 834117,
    Size: "44M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "July 30, 2018",
    "Current Ver": "1.25.4",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "Trine 2: Complete Story",
    Category: "GAME",
    Rating: 3.8,
    Reviews: 252,
    Size: "11M",
    Type: "Paid",
    Price: "$16.99",
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "February 27, 2015",
    "Current Ver": 2.22,
    numInstall: 10000,
    numAndroid: 5,
  },
  {
    App: "Modern Counter Terror Attack – Shooting Game",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 340,
    Size: "72M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Action",
    "Last Updated": "October 27, 2017",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Big Hunter",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 245455,
    Size: "84M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "May 31, 2018",
    "Current Ver": "2.8.6",
    numInstall: 10000000,
    numAndroid: 4,
  },
  {
    App: "sugar, sugar",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 1405,
    Size: "9.5M",
    Type: "Paid",
    Price: "$1.20",
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "June 5, 2018",
    "Current Ver": 2.7,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "ChopAssistant",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 455,
    Size: "2.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "February 28, 2017",
    "Current Ver": 1.6,
    numInstall: 50000,
    numAndroid: 6,
  },
  {
    App: "Modern Counter Global Strike 3D",
    Category: "GAME",
    Rating: 4.1,
    Reviews: 297,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "March 28, 2018",
    "Current Ver": 1.2,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Fountain Live Wallpaper HD – Dubai Wallpaper 3D",
    Category: "PERSONALIZATION",
    Rating: "NaN",
    Reviews: 1,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Personalization",
    "Last Updated": "April 13, 2018",
    "Current Ver": 1,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "Modern Counter Global Strike 3D V2",
    Category: "GAME",
    Rating: 4,
    Reviews: 368,
    Size: "48M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone 10+",
    Genres: "Action",
    "Last Updated": "March 28, 2018",
    "Current Ver": 1.7,
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "HipChat - beta version",
    Category: "COMMUNICATION",
    Rating: 4.1,
    Reviews: 1035,
    Size: "20M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Communication",
    "Last Updated": "August 7, 2018",
    "Current Ver": "3.20.001",
    numInstall: 50000,
    numAndroid: 4,
  },
  {
    App: "Winter Wonderland",
    Category: "GAME",
    Rating: 4,
    Reviews: 1287,
    Size: "38M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Word",
    "Last Updated": "December 18, 2013",
    "Current Ver": 1,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Soccer Clubs Logo Quiz",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 21661,
    Size: "16M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Trivia",
    "Last Updated": "May 24, 2018",
    "Current Ver": "1.3.81",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Sid Story",
    Category: "GAME",
    Rating: 4.4,
    Reviews: 28510,
    Size: "78M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "August 1, 2018",
    "Current Ver": "2.6.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "PopStar",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 13,
    Size: "5.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Casual",
    "Last Updated": "January 3, 2018",
    "Current Ver": 1.6,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Reindeer VPN - Proxy VPN",
    Category: "TOOLS",
    Rating: 4.2,
    Reviews: 7339,
    Size: "4.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "May 10, 2018",
    "Current Ver": 1.74,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "Inf VPN - Global Proxy & Unlimited Free WIFI VPN",
    Category: "TOOLS",
    Rating: 4.7,
    Reviews: 61445,
    Size: "7.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 26, 2018",
    "Current Ver": "1.9.734",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fuel Rewards® program",
    Category: "LIFESTYLE",
    Rating: 4.6,
    Reviews: 32433,
    Size: "46M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "June 26, 2018",
    "Current Ver": "2.9.1",
    numInstall: 1000000,
    numAndroid: 5,
  },
  {
    App: "Word Search Tab 1 FR",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 0,
    Size: "1020k",
    Type: "Paid",
    Price: "$1.04",
    "Content Rating": "Everyone",
    Genres: "Puzzle",
    "Last Updated": "February 6, 2012",
    "Current Ver": 1.1,
    numInstall: 50,
    numAndroid: 3,
  },
  {
    App: "Fr Daoud Lamei",
    Category: "SOCIAL",
    Rating: 4.7,
    Reviews: 2036,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Social",
    "Last Updated": "May 20, 2018",
    "Current Ver": 1.72,
    numInstall: 100000,
    numAndroid: 4,
  },
  {
    App: "FR Roster",
    Category: "TOOLS",
    Rating: 4.1,
    Reviews: 174,
    Size: "12M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "July 30, 2018",
    "Current Ver": 6.04,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Fr Ignacio Outreach",
    Category: "FAMILY",
    Rating: 4.9,
    Reviews: 52,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "January 19, 2018",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "FR: My Famous Lover",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 185,
    Size: "28M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "August 6, 2015",
    "Current Ver": "1.3.0",
    numInstall: 10000,
    numAndroid: 3,
  },
  {
    App: "Fatal Raid - No.1 Mobile FPS",
    Category: "GAME",
    Rating: 4.3,
    Reviews: 56496,
    Size: "81M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Action",
    "Last Updated": "August 7, 2018",
    "Current Ver": "1.5.447",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Poker Pro.Fr",
    Category: "GAME",
    Rating: 4.2,
    Reviews: 5442,
    Size: "17M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Card",
    "Last Updated": "May 22, 2018",
    "Current Ver": "4.1.3",
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Scoreboard FR",
    Category: "LIFESTYLE",
    Rating: 4.3,
    Reviews: 3,
    Size: "15M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "August 7, 2018",
    "Current Ver": 2.1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "SnakeBite911 FR",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 1,
    Size: "42M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "October 9, 2017",
    "Current Ver": 1.2,
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "My FR App",
    Category: "TOOLS",
    Rating: "NaN",
    Reviews: 2,
    Size: "4.2M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "April 9, 2018",
    "Current Ver": "1.283.0037",
    numInstall: 100,
    numAndroid: 2,
  },
  {
    App: "lesparticuliers.fr",
    Category: "LIFESTYLE",
    Rating: "NaN",
    Reviews: 96,
    Size: "1.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "November 25, 2014",
    "Current Ver": 1.5,
    numInstall: 50000,
    numAndroid: 2,
  },
  {
    App: "Castle Clash: RPG War and Strategy FR",
    Category: "FAMILY",
    Rating: 4.7,
    Reviews: 376223,
    Size: "24M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Strategy",
    "Last Updated": "July 18, 2018",
    "Current Ver": "1.4.2",
    numInstall: 1000000,
    numAndroid: 4,
  },
  {
    App: "Fr Lupupa Sermons",
    Category: "BUSINESS",
    Rating: 4.8,
    Reviews: 19,
    Size: "21M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "June 12, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "FR Plus 1.6",
    Category: "AUTO_AND_VEHICLES",
    Rating: "NaN",
    Reviews: 4,
    Size: "3.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Auto & Vehicles",
    "Last Updated": "July 24, 2018",
    "Current Ver": "1.3.6",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Fr Agnel Pune",
    Category: "FAMILY",
    Rating: 4.1,
    Reviews: 80,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 13, 2018",
    "Current Ver": "2.0.20",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "DICT.fr Mobile",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 20,
    Size: "2.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "July 17, 2018",
    "Current Ver": "2.1.10",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "FR: My Secret Pets!",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 785,
    Size: "31M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Entertainment",
    "Last Updated": "June 3, 2015",
    "Current Ver": "1.3.1",
    numInstall: 50000,
    numAndroid: 3,
  },
  {
    App: "Golden Dictionary (FR-AR)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.2,
    Reviews: 5775,
    Size: "4.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "July 19, 2018",
    "Current Ver": "7.0.4.6",
    numInstall: 500000,
    numAndroid: 4,
  },
  {
    App: "FieldBi FR Offline",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 2,
    Size: "6.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "August 6, 2018",
    "Current Ver": "2.1.8",
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "HTC Sense Input - FR",
    Category: "TOOLS",
    Rating: 4,
    Reviews: 885,
    Size: "8.0M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Tools",
    "Last Updated": "October 30, 2015",
    "Current Ver": "1.0.612928",
    numInstall: 100000,
    numAndroid: 5,
  },
  {
    App: "Gold Quote - Gold.fr",
    Category: "FINANCE",
    Rating: "NaN",
    Reviews: 96,
    Size: "1.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Finance",
    "Last Updated": "May 19, 2016",
    "Current Ver": 2.3,
    numInstall: 10000,
    numAndroid: 2,
  },
  {
    App: "Fanfic-FR",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 3.3,
    Reviews: 52,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Books & Reference",
    "Last Updated": "August 5, 2017",
    "Current Ver": "0.3.4",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Fr. Daoud Lamei",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 22,
    Size: "8.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Education",
    "Last Updated": "June 27, 2018",
    "Current Ver": "3.8.0",
    numInstall: 1000,
    numAndroid: 4,
  },
  {
    App: "Poop FR",
    Category: "FAMILY",
    Rating: "NaN",
    Reviews: 6,
    Size: "2.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Entertainment",
    "Last Updated": "May 29, 2018",
    "Current Ver": 1,
    numInstall: 50,
    numAndroid: 4,
  },
  {
    App: "PLMGSS FR",
    Category: "PRODUCTIVITY",
    Rating: "NaN",
    Reviews: 0,
    Size: "3.1M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Productivity",
    "Last Updated": "December 1, 2017",
    "Current Ver": 1,
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "List iptv FR",
    Category: "VIDEO_PLAYERS",
    Rating: "NaN",
    Reviews: 1,
    Size: "2.9M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Video Players & Editors",
    "Last Updated": "April 22, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Cardio-FR",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 67,
    Size: "82M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "July 31, 2018",
    "Current Ver": "2.2.2",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Naruto & Boruto FR",
    Category: "SOCIAL",
    Rating: "NaN",
    Reviews: 7,
    Size: "7.7M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Teen",
    Genres: "Social",
    "Last Updated": "February 2, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Frim: get new friends on local chat rooms",
    Category: "SOCIAL",
    Rating: 4,
    Reviews: 88486,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Social",
    "Last Updated": "March 23, 2018",
    "Current Ver": "Varies with device",
    numInstall: 5000000,
    numAndroid: null,
  },
  {
    App: "Fr Agnel Ambarnath",
    Category: "FAMILY",
    Rating: 4.2,
    Reviews: 117,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 13, 2018",
    "Current Ver": "2.0.20",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Manga-FR - Anime Vostfr",
    Category: "COMICS",
    Rating: 3.4,
    Reviews: 291,
    Size: "13M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Comics",
    "Last Updated": "May 15, 2017",
    "Current Ver": "2.0.1",
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "Bulgarian French Dictionary Fr",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.6,
    Reviews: 603,
    Size: "7.4M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "June 19, 2016",
    "Current Ver": 2.96,
    numInstall: 10000,
    numAndroid: 4,
  },
  {
    App: "News Minecraft.fr",
    Category: "NEWS_AND_MAGAZINES",
    Rating: 3.8,
    Reviews: 881,
    Size: "2.3M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "News & Magazines",
    "Last Updated": "January 20, 2014",
    "Current Ver": 1.5,
    numInstall: 100000,
    numAndroid: 1,
  },
  {
    App: "payermonstationnement.fr",
    Category: "MAPS_AND_NAVIGATION",
    Rating: "NaN",
    Reviews: 38,
    Size: "9.8M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Maps & Navigation",
    "Last Updated": "June 13, 2018",
    "Current Ver": "2.0.148.0",
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "FR Tides",
    Category: "WEATHER",
    Rating: 3.8,
    Reviews: 1195,
    Size: "582k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Weather",
    "Last Updated": "February 16, 2014",
    "Current Ver": 6,
    numInstall: 100000,
    numAndroid: 2,
  },
  {
    App: "Chemin (fr)",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.8,
    Reviews: 44,
    Size: "619k",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Books & Reference",
    "Last Updated": "March 23, 2014",
    "Current Ver": 0.8,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "FR Calculator",
    Category: "FAMILY",
    Rating: 4,
    Reviews: 7,
    Size: "2.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "June 18, 2017",
    "Current Ver": "1.0.0",
    numInstall: 500,
    numAndroid: 4,
  },
  {
    App: "FR Forms",
    Category: "BUSINESS",
    Rating: "NaN",
    Reviews: 0,
    Size: "9.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Business",
    "Last Updated": "September 29, 2016",
    "Current Ver": "1.1.5",
    numInstall: 10,
    numAndroid: 4,
  },
  {
    App: "Sya9a Maroc - FR",
    Category: "FAMILY",
    Rating: 4.5,
    Reviews: 38,
    Size: "53M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 25, 2017",
    "Current Ver": 1.48,
    numInstall: 5000,
    numAndroid: 4,
  },
  {
    App: "Fr. Mike Schmitz Audio Teachings",
    Category: "FAMILY",
    Rating: 5,
    Reviews: 4,
    Size: "3.6M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Education",
    "Last Updated": "July 6, 2018",
    "Current Ver": 1,
    numInstall: 100,
    numAndroid: 4,
  },
  {
    App: "Parkinson Exercices FR",
    Category: "MEDICAL",
    Rating: "NaN",
    Reviews: 3,
    Size: "9.5M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Medical",
    "Last Updated": "January 20, 2017",
    "Current Ver": 1,
    numInstall: 1000,
    numAndroid: 2,
  },
  {
    App: "The SCP Foundation DB fr nn5n",
    Category: "BOOKS_AND_REFERENCE",
    Rating: 4.5,
    Reviews: 114,
    Size: "Varies with device",
    Type: "Free",
    Price: 0,
    "Content Rating": "Mature 17+",
    Genres: "Books & Reference",
    "Last Updated": "January 19, 2015",
    "Current Ver": "Varies with device",
    numInstall: 1000,
    numAndroid: null,
  },
  {
    App: "iHoroscope - 2018 Daily Horoscope & Astrology",
    Category: "LIFESTYLE",
    Rating: 4.5,
    Reviews: 398307,
    Size: "19M",
    Type: "Free",
    Price: 0,
    "Content Rating": "Everyone",
    Genres: "Lifestyle",
    "Last Updated": "July 25, 2018",
    "Current Ver": "Varies with device",
    numInstall: 10000000,
    numAndroid: null,
  },
];
